
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4HWKL", function(module, exports) {
/*! UIkit 3.21.13 | https://www.getuikit.com | (c) 2014 - 2024 YOOtheme | MIT License */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    const { hasOwnProperty: hasOwnProperty, toString: toString } = Object.prototype;
    function hasOwn(obj, key) {
        return hasOwnProperty.call(obj, key);
    }
    const hyphenateRe = /\B([A-Z])/g;
    const hyphenate = memoize((str)=>str.replace(hyphenateRe, "-$1").toLowerCase());
    const camelizeRe = /-(\w)/g;
    const camelize = memoize((str)=>(str.charAt(0).toLowerCase() + str.slice(1)).replace(camelizeRe, (_, c)=>c.toUpperCase()));
    const ucfirst = memoize((str)=>str.charAt(0).toUpperCase() + str.slice(1));
    function startsWith(str, search) {
        var _a;
        return (_a = str == null ? void 0 : str.startsWith) == null ? void 0 : _a.call(str, search);
    }
    function endsWith(str, search) {
        var _a;
        return (_a = str == null ? void 0 : str.endsWith) == null ? void 0 : _a.call(str, search);
    }
    function includes(obj, search) {
        var _a;
        return (_a = obj == null ? void 0 : obj.includes) == null ? void 0 : _a.call(obj, search);
    }
    function findIndex(array, predicate) {
        var _a;
        return (_a = array == null ? void 0 : array.findIndex) == null ? void 0 : _a.call(array, predicate);
    }
    const { isArray: isArray, from: toArray } = Array;
    const { assign: assign } = Object;
    function isFunction(obj) {
        return typeof obj === "function";
    }
    function isObject(obj) {
        return obj !== null && typeof obj === "object";
    }
    function isPlainObject(obj) {
        return toString.call(obj) === "[object Object]";
    }
    function isWindow(obj) {
        return isObject(obj) && obj === obj.window;
    }
    function isDocument(obj) {
        return nodeType(obj) === 9;
    }
    function isNode(obj) {
        return nodeType(obj) >= 1;
    }
    function isElement(obj) {
        return nodeType(obj) === 1;
    }
    function nodeType(obj) {
        return !isWindow(obj) && isObject(obj) && obj.nodeType;
    }
    function isBoolean(value) {
        return typeof value === "boolean";
    }
    function isString(value) {
        return typeof value === "string";
    }
    function isNumber(value) {
        return typeof value === "number";
    }
    function isNumeric(value) {
        return isNumber(value) || isString(value) && !isNaN(value - parseFloat(value));
    }
    function isEmpty(obj) {
        return !(isArray(obj) ? obj.length : isObject(obj) ? Object.keys(obj).length : false);
    }
    function isUndefined(value) {
        return value === void 0;
    }
    function toBoolean(value) {
        return isBoolean(value) ? value : value === "true" || value === "1" || value === "" ? true : value === "false" || value === "0" ? false : value;
    }
    function toNumber(value) {
        const number = Number(value);
        return isNaN(number) ? false : number;
    }
    function toFloat(value) {
        return parseFloat(value) || 0;
    }
    function toNode(element) {
        return element && toNodes(element)[0];
    }
    function toNodes(element) {
        return isNode(element) ? [
            element
        ] : Array.from(element || []).filter(isNode);
    }
    function toWindow(element) {
        if (isWindow(element)) return element;
        element = toNode(element);
        const document1 = isDocument(element) ? element : element == null ? void 0 : element.ownerDocument;
        return (document1 == null ? void 0 : document1.defaultView) || window;
    }
    function isEqual(value, other) {
        return value === other || isObject(value) && isObject(other) && Object.keys(value).length === Object.keys(other).length && each(value, (val, key)=>val === other[key]);
    }
    function swap(value, a, b) {
        return value.replace(new RegExp(`${a}|${b}`, "g"), (match)=>match === a ? b : a);
    }
    function last(array) {
        return array[array.length - 1];
    }
    function each(obj, cb) {
        for(const key in obj){
            if (false === cb(obj[key], key)) return false;
        }
        return true;
    }
    function sortBy(array, prop) {
        return array.slice().sort(({ [prop]: propA = 0 }, { [prop]: propB = 0 })=>propA > propB ? 1 : propB > propA ? -1 : 0);
    }
    function sumBy(array, iteratee) {
        return array.reduce((sum, item)=>sum + toFloat(isFunction(iteratee) ? iteratee(item) : item[iteratee]), 0);
    }
    function uniqueBy(array, prop) {
        const seen = /* @__PURE__ */ new Set();
        return array.filter(({ [prop]: check })=>seen.has(check) ? false : seen.add(check));
    }
    function pick(obj, props) {
        return props.reduce((res, prop)=>({
                ...res,
                [prop]: obj[prop]
            }), {});
    }
    function clamp(number, min = 0, max = 1) {
        return Math.min(Math.max(toNumber(number) || 0, min), max);
    }
    function noop() {}
    function intersectRect(...rects) {
        return [
            [
                "bottom",
                "top"
            ],
            [
                "right",
                "left"
            ]
        ].every(([minProp, maxProp])=>Math.min(...rects.map(({ [minProp]: min })=>min)) - Math.max(...rects.map(({ [maxProp]: max })=>max)) > 0);
    }
    function pointInRect(point, rect) {
        return point.x <= rect.right && point.x >= rect.left && point.y <= rect.bottom && point.y >= rect.top;
    }
    function ratio(dimensions, prop, value) {
        const aProp = prop === "width" ? "height" : "width";
        return {
            [aProp]: dimensions[prop] ? Math.round(value * dimensions[aProp] / dimensions[prop]) : dimensions[aProp],
            [prop]: value
        };
    }
    function contain(dimensions, maxDimensions) {
        dimensions = {
            ...dimensions
        };
        for(const prop in dimensions)dimensions = dimensions[prop] > maxDimensions[prop] ? ratio(dimensions, prop, maxDimensions[prop]) : dimensions;
        return dimensions;
    }
    function cover$1(dimensions, maxDimensions) {
        dimensions = contain(dimensions, maxDimensions);
        for(const prop in dimensions)dimensions = dimensions[prop] < maxDimensions[prop] ? ratio(dimensions, prop, maxDimensions[prop]) : dimensions;
        return dimensions;
    }
    const Dimensions = {
        ratio: ratio,
        contain: contain,
        cover: cover$1
    };
    function getIndex(i, elements, current = 0, finite = false) {
        elements = toNodes(elements);
        const { length: length } = elements;
        if (!length) return -1;
        i = isNumeric(i) ? toNumber(i) : i === "next" ? current + 1 : i === "previous" ? current - 1 : i === "last" ? length - 1 : elements.indexOf(toNode(i));
        if (finite) return clamp(i, 0, length - 1);
        i %= length;
        return i < 0 ? i + length : i;
    }
    function memoize(fn) {
        const cache = /* @__PURE__ */ Object.create(null);
        return (key, ...args)=>cache[key] || (cache[key] = fn(key, ...args));
    }
    function addClass(element, ...classes) {
        for (const node of toNodes(element)){
            const add = toClasses(classes).filter((cls)=>!hasClass(node, cls));
            if (add.length) node.classList.add(...add);
        }
    }
    function removeClass(element, ...classes) {
        for (const node of toNodes(element)){
            const remove = toClasses(classes).filter((cls)=>hasClass(node, cls));
            if (remove.length) node.classList.remove(...remove);
        }
    }
    function replaceClass(element, oldClass, newClass) {
        newClass = toClasses(newClass);
        oldClass = toClasses(oldClass).filter((cls)=>!includes(newClass, cls));
        removeClass(element, oldClass);
        addClass(element, newClass);
    }
    function hasClass(element, cls) {
        [cls] = toClasses(cls);
        return toNodes(element).some((node)=>node.classList.contains(cls));
    }
    function toggleClass(element, cls, force) {
        const classes = toClasses(cls);
        if (!isUndefined(force)) force = !!force;
        for (const node of toNodes(element))for (const cls2 of classes)node.classList.toggle(cls2, force);
    }
    function toClasses(str) {
        return str ? isArray(str) ? str.map(toClasses).flat() : String(str).split(" ").filter(Boolean) : [];
    }
    function attr(element, name, value) {
        var _a;
        if (isObject(name)) {
            for(const key in name)attr(element, key, name[key]);
            return;
        }
        if (isUndefined(value)) return (_a = toNode(element)) == null ? void 0 : _a.getAttribute(name);
        else for (const el of toNodes(element)){
            if (isFunction(value)) value = value.call(el, attr(el, name));
            if (value === null) removeAttr(el, name);
            else el.setAttribute(name, value);
        }
    }
    function hasAttr(element, name) {
        return toNodes(element).some((element2)=>element2.hasAttribute(name));
    }
    function removeAttr(element, name) {
        toNodes(element).forEach((element2)=>element2.removeAttribute(name));
    }
    function data(element, attribute) {
        for (const name of [
            attribute,
            `data-${attribute}`
        ]){
            if (hasAttr(element, name)) return attr(element, name);
        }
    }
    const inBrowser = typeof window !== "undefined";
    const isRtl = inBrowser && document.dir === "rtl";
    const hasTouch = inBrowser && "ontouchstart" in window;
    const hasPointerEvents = inBrowser && window.PointerEvent;
    const pointerDown$1 = hasPointerEvents ? "pointerdown" : hasTouch ? "touchstart" : "mousedown";
    const pointerMove$1 = hasPointerEvents ? "pointermove" : hasTouch ? "touchmove" : "mousemove";
    const pointerUp$1 = hasPointerEvents ? "pointerup" : hasTouch ? "touchend" : "mouseup";
    const pointerEnter = hasPointerEvents ? "pointerenter" : hasTouch ? "" : "mouseenter";
    const pointerLeave = hasPointerEvents ? "pointerleave" : hasTouch ? "" : "mouseleave";
    const pointerCancel = hasPointerEvents ? "pointercancel" : "touchcancel";
    const voidElements = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true
    };
    function isVoidElement(element) {
        return toNodes(element).some((element2)=>voidElements[element2.tagName.toLowerCase()]);
    }
    const isVisibleFn = inBrowser && Element.prototype.checkVisibility || function() {
        return this.offsetWidth || this.offsetHeight || this.getClientRects().length;
    };
    function isVisible(element) {
        return toNodes(element).some((element2)=>isVisibleFn.call(element2));
    }
    const selInput = "input,select,textarea,button";
    function isInput(element) {
        return toNodes(element).some((element2)=>matches(element2, selInput));
    }
    const selFocusable = `${selInput},a[href],[tabindex]`;
    function isFocusable(element) {
        return matches(element, selFocusable);
    }
    function parent(element) {
        var _a;
        return (_a = toNode(element)) == null ? void 0 : _a.parentElement;
    }
    function filter$1(element, selector) {
        return toNodes(element).filter((element2)=>matches(element2, selector));
    }
    function matches(element, selector) {
        return toNodes(element).some((element2)=>element2.matches(selector));
    }
    function parents(element, selector) {
        const elements = [];
        while(element = parent(element))if (!selector || matches(element, selector)) elements.push(element);
        return elements;
    }
    function children(element, selector) {
        element = toNode(element);
        const children2 = element ? toArray(element.children) : [];
        return selector ? filter$1(children2, selector) : children2;
    }
    function index(element, ref) {
        return ref ? toNodes(element).indexOf(toNode(ref)) : children(parent(element)).indexOf(element);
    }
    function isSameSiteAnchor(el) {
        el = toNode(el);
        return el && [
            "origin",
            "pathname",
            "search"
        ].every((part)=>el[part] === location[part]);
    }
    function getTargetedElement(el) {
        if (isSameSiteAnchor(el)) {
            const { hash: hash, ownerDocument: ownerDocument } = toNode(el);
            const id = decodeURIComponent(hash).slice(1);
            return ownerDocument.getElementById(id) || ownerDocument.getElementsByName(id)[0];
        }
    }
    function query(selector, context) {
        return find(selector, getContext(selector, context));
    }
    function queryAll(selector, context) {
        return findAll(selector, getContext(selector, context));
    }
    function find(selector, context) {
        return toNode(_query(selector, toNode(context), "querySelector"));
    }
    function findAll(selector, context) {
        return toNodes(_query(selector, toNode(context), "querySelectorAll"));
    }
    function getContext(selector, context = document) {
        return isDocument(context) || parseSelector(selector).isContextSelector ? context : context.ownerDocument;
    }
    const addStarRe = /([!>+~-])(?=\s+[!>+~-]|\s*$)/g;
    const splitSelectorRe = /(\([^)]*\)|[^,])+/g;
    const parseSelector = memoize((selector)=>{
        let isContextSelector = false;
        if (!selector || !isString(selector)) return {};
        const selectors = [];
        for (let sel of selector.match(splitSelectorRe)){
            sel = sel.trim().replace(addStarRe, "$1 *");
            isContextSelector || (isContextSelector = [
                "!",
                "+",
                "~",
                "-",
                ">"
            ].includes(sel[0]));
            selectors.push(sel);
        }
        return {
            selector: selectors.join(","),
            selectors: selectors,
            isContextSelector: isContextSelector
        };
    });
    const positionRe = /(\([^)]*\)|\S)*/;
    const parsePositionSelector = memoize((selector)=>{
        selector = selector.slice(1).trim();
        const [position] = selector.match(positionRe);
        return [
            position,
            selector.slice(position.length + 1)
        ];
    });
    function _query(selector, context = document, queryFn) {
        const parsed = parseSelector(selector);
        if (!parsed.isContextSelector) return parsed.selector ? _doQuery(context, queryFn, parsed.selector) : selector;
        selector = "";
        const isSingle = parsed.selectors.length === 1;
        for (let sel of parsed.selectors){
            let positionSel;
            let ctx = context;
            if (sel[0] === "!") {
                [positionSel, sel] = parsePositionSelector(sel);
                ctx = context.parentElement.closest(positionSel);
                if (!sel && isSingle) return ctx;
            }
            if (ctx && sel[0] === "-") {
                [positionSel, sel] = parsePositionSelector(sel);
                ctx = ctx.previousElementSibling;
                ctx = matches(ctx, positionSel) ? ctx : null;
                if (!sel && isSingle) return ctx;
            }
            if (!ctx) continue;
            if (isSingle) {
                if (sel[0] === "~" || sel[0] === "+") {
                    sel = `:scope > :nth-child(${index(ctx) + 1}) ${sel}`;
                    ctx = ctx.parentElement;
                } else if (sel[0] === ">") sel = `:scope ${sel}`;
                return _doQuery(ctx, queryFn, sel);
            }
            selector += `${selector ? "," : ""}${domPath(ctx)} ${sel}`;
        }
        if (!isDocument(context)) context = context.ownerDocument;
        return _doQuery(context, queryFn, selector);
    }
    function _doQuery(context, queryFn, selector) {
        try {
            return context[queryFn](selector);
        } catch (e) {
            return null;
        }
    }
    function domPath(element) {
        const names = [];
        while(element.parentNode){
            const id = attr(element, "id");
            if (id) {
                names.unshift(`#${escape(id)}`);
                break;
            } else {
                let { tagName: tagName } = element;
                if (tagName !== "HTML") tagName += `:nth-child(${index(element) + 1})`;
                names.unshift(tagName);
                element = element.parentNode;
            }
        }
        return names.join(" > ");
    }
    function escape(css) {
        return isString(css) ? CSS.escape(css) : "";
    }
    function on(...args) {
        let [targets, types, selector, listener, useCapture = false] = getArgs(args);
        if (listener.length > 1) listener = detail(listener);
        if (useCapture == null ? void 0 : useCapture.self) listener = selfFilter(listener);
        if (selector) listener = delegate(selector, listener);
        for (const type of types)for (const target of targets)target.addEventListener(type, listener, useCapture);
        return ()=>off(targets, types, listener, useCapture);
    }
    function off(...args) {
        let [targets, types, , listener, useCapture = false] = getArgs(args);
        for (const type of types)for (const target of targets)target.removeEventListener(type, listener, useCapture);
    }
    function once(...args) {
        const [element, types, selector, listener, useCapture = false, condition] = getArgs(args);
        const off2 = on(element, types, selector, (e)=>{
            const result = !condition || condition(e);
            if (result) {
                off2();
                listener(e, result);
            }
        }, useCapture);
        return off2;
    }
    function trigger(targets, event, detail2) {
        return toEventTargets(targets).every((target)=>target.dispatchEvent(createEvent(event, true, true, detail2)));
    }
    function createEvent(e, bubbles = true, cancelable = false, detail2) {
        if (isString(e)) e = new CustomEvent(e, {
            bubbles: bubbles,
            cancelable: cancelable,
            detail: detail2
        });
        return e;
    }
    function getArgs(args) {
        args[0] = toEventTargets(args[0]);
        if (isString(args[1])) args[1] = args[1].split(" ");
        if (isFunction(args[2])) args.splice(2, 0, false);
        return args;
    }
    function delegate(selector, listener) {
        return (e)=>{
            const current = selector[0] === ">" ? findAll(selector, e.currentTarget).reverse().find((element)=>element.contains(e.target)) : e.target.closest(selector);
            if (current) {
                e.current = current;
                listener.call(this, e);
                delete e.current;
            }
        };
    }
    function detail(listener) {
        return (e)=>isArray(e.detail) ? listener(e, ...e.detail) : listener(e);
    }
    function selfFilter(listener) {
        return function(e) {
            if (e.target === e.currentTarget || e.target === e.current) return listener.call(null, e);
        };
    }
    function isEventTarget(target) {
        return target && "addEventListener" in target;
    }
    function toEventTarget(target) {
        return isEventTarget(target) ? target : toNode(target);
    }
    function toEventTargets(target) {
        return isArray(target) ? target.map(toEventTarget).filter(Boolean) : isString(target) ? findAll(target) : isEventTarget(target) ? [
            target
        ] : toNodes(target);
    }
    function isTouch(e) {
        return e.pointerType === "touch" || !!e.touches;
    }
    function getEventPos(e) {
        var _a, _b;
        const { clientX: x, clientY: y } = ((_a = e.touches) == null ? void 0 : _a[0]) || ((_b = e.changedTouches) == null ? void 0 : _b[0]) || e;
        return {
            x: x,
            y: y
        };
    }
    const cssNumber = {
        "animation-iteration-count": true,
        "column-count": true,
        "fill-opacity": true,
        "flex-grow": true,
        "flex-shrink": true,
        "font-weight": true,
        "line-height": true,
        opacity: true,
        order: true,
        orphans: true,
        "stroke-dasharray": true,
        "stroke-dashoffset": true,
        widows: true,
        "z-index": true,
        zoom: true
    };
    function css(element, property, value, priority) {
        const elements = toNodes(element);
        for (const element2 of elements){
            if (isString(property)) {
                property = propName(property);
                if (isUndefined(value)) return getComputedStyle(element2).getPropertyValue(property);
                else element2.style.setProperty(property, isNumeric(value) && !cssNumber[property] ? `${value}px` : value || isNumber(value) ? value : "", priority);
            } else if (isArray(property)) {
                const props = {};
                for (const prop of property)props[prop] = css(element2, prop);
                return props;
            } else if (isObject(property)) for(const prop in property)css(element2, prop, property[prop], value);
        }
        return elements[0];
    }
    const propName = memoize((name)=>{
        if (startsWith(name, "--")) return name;
        name = hyphenate(name);
        const { style: style } = document.documentElement;
        if (name in style) return name;
        for (const prefix of [
            "webkit",
            "moz"
        ]){
            const prefixedName = `-${prefix}-${name}`;
            if (prefixedName in style) return prefixedName;
        }
    });
    const clsTransition = "uk-transition";
    const transitionEnd = "transitionend";
    const transitionCanceled = "transitioncanceled";
    function transition$1(element, props, duration = 400, timing = "linear") {
        duration = Math.round(duration);
        return Promise.all(toNodes(element).map((element2)=>new Promise((resolve, reject)=>{
                for(const name in props)css(element2, name);
                const timer = setTimeout(()=>trigger(element2, transitionEnd), duration);
                once(element2, [
                    transitionEnd,
                    transitionCanceled
                ], ({ type: type })=>{
                    clearTimeout(timer);
                    removeClass(element2, clsTransition);
                    css(element2, {
                        transitionProperty: "",
                        transitionDuration: "",
                        transitionTimingFunction: ""
                    });
                    type === transitionCanceled ? reject() : resolve(element2);
                }, {
                    self: true
                });
                addClass(element2, clsTransition);
                css(element2, {
                    transitionProperty: Object.keys(props).map(propName).join(","),
                    transitionDuration: `${duration}ms`,
                    transitionTimingFunction: timing,
                    ...props
                });
            })));
    }
    const Transition = {
        start: transition$1,
        async stop (element) {
            trigger(element, transitionEnd);
            await Promise.resolve();
        },
        async cancel (element) {
            trigger(element, transitionCanceled);
            await Promise.resolve();
        },
        inProgress (element) {
            return hasClass(element, clsTransition);
        }
    };
    const clsAnimation = "uk-animation";
    const animationEnd = "animationend";
    const animationCanceled = "animationcanceled";
    function animate$2(element, animation, duration = 200, origin, out) {
        return Promise.all(toNodes(element).map((element2)=>new Promise((resolve, reject)=>{
                if (hasClass(element2, clsAnimation)) trigger(element2, animationCanceled);
                const classes = [
                    animation,
                    clsAnimation,
                    `${clsAnimation}-${out ? "leave" : "enter"}`,
                    origin && `uk-transform-origin-${origin}`,
                    out && `${clsAnimation}-reverse`
                ];
                const timer = setTimeout(()=>trigger(element2, animationEnd), duration);
                once(element2, [
                    animationEnd,
                    animationCanceled
                ], ({ type: type })=>{
                    clearTimeout(timer);
                    type === animationCanceled ? reject() : resolve(element2);
                    css(element2, "animationDuration", "");
                    removeClass(element2, classes);
                }, {
                    self: true
                });
                css(element2, "animationDuration", `${duration}ms`);
                addClass(element2, classes);
            })));
    }
    const Animation = {
        in: animate$2,
        out (element, animation, duration, origin) {
            return animate$2(element, animation, duration, origin, true);
        },
        inProgress (element) {
            return hasClass(element, clsAnimation);
        },
        cancel (element) {
            trigger(element, animationCanceled);
        }
    };
    function ready(fn) {
        if (document.readyState !== "loading") {
            fn();
            return;
        }
        once(document, "DOMContentLoaded", fn);
    }
    function isTag(element, ...tagNames) {
        return tagNames.some((tagName)=>{
            var _a;
            return ((_a = element == null ? void 0 : element.tagName) == null ? void 0 : _a.toLowerCase()) === tagName.toLowerCase();
        });
    }
    function empty(element) {
        element = $(element);
        element.innerHTML = "";
        return element;
    }
    function html(parent2, html2) {
        return isUndefined(html2) ? $(parent2).innerHTML : append(empty(parent2), html2);
    }
    const prepend = applyFn("prepend");
    const append = applyFn("append");
    const before = applyFn("before");
    const after = applyFn("after");
    function applyFn(fn) {
        return function(ref, element) {
            var _a;
            const nodes = toNodes(isString(element) ? fragment(element) : element);
            (_a = $(ref)) == null || _a[fn](...nodes);
            return unwrapSingle(nodes);
        };
    }
    function remove$1(element) {
        toNodes(element).forEach((element2)=>element2.remove());
    }
    function wrapAll(element, structure) {
        structure = toNode(before(element, structure));
        while(structure.firstElementChild)structure = structure.firstElementChild;
        append(structure, element);
        return structure;
    }
    function wrapInner(element, structure) {
        return toNodes(toNodes(element).map((element2)=>element2.hasChildNodes() ? wrapAll(toArray(element2.childNodes), structure) : append(element2, structure)));
    }
    function unwrap(element) {
        toNodes(element).map(parent).filter((value, index, self)=>self.indexOf(value) === index).forEach((parent2)=>parent2.replaceWith(...parent2.childNodes));
    }
    const singleTagRe = /^<(\w+)\s*\/?>(?:<\/\1>)?$/;
    function fragment(html2) {
        const matches = singleTagRe.exec(html2);
        if (matches) return document.createElement(matches[1]);
        const container = document.createElement("template");
        container.innerHTML = html2.trim();
        return unwrapSingle(container.content.childNodes);
    }
    function unwrapSingle(nodes) {
        return nodes.length > 1 ? nodes : nodes[0];
    }
    function apply(node, fn) {
        if (!isElement(node)) return;
        fn(node);
        node = node.firstElementChild;
        while(node){
            apply(node, fn);
            node = node.nextElementSibling;
        }
    }
    function $(selector, context) {
        return isHtml(selector) ? toNode(fragment(selector)) : find(selector, context);
    }
    function $$(selector, context) {
        return isHtml(selector) ? toNodes(fragment(selector)) : findAll(selector, context);
    }
    function isHtml(str) {
        return isString(str) && startsWith(str.trim(), "<");
    }
    const dirs$1 = {
        width: [
            "left",
            "right"
        ],
        height: [
            "top",
            "bottom"
        ]
    };
    function dimensions$1(element) {
        const rect = isElement(element) ? toNode(element).getBoundingClientRect() : {
            height: height(element),
            width: width(element),
            top: 0,
            left: 0
        };
        return {
            height: rect.height,
            width: rect.width,
            top: rect.top,
            left: rect.left,
            bottom: rect.top + rect.height,
            right: rect.left + rect.width
        };
    }
    function offset(element, coordinates) {
        if (coordinates) css(element, {
            left: 0,
            top: 0
        });
        const currentOffset = dimensions$1(element);
        if (element) {
            const { scrollY: scrollY, scrollX: scrollX } = toWindow(element);
            const offsetBy = {
                height: scrollY,
                width: scrollX
            };
            for(const dir in dirs$1)for (const prop of dirs$1[dir])currentOffset[prop] += offsetBy[dir];
        }
        if (!coordinates) return currentOffset;
        for (const prop of [
            "left",
            "top"
        ])css(element, prop, coordinates[prop] - currentOffset[prop]);
    }
    function position(element) {
        let { top: top, left: left } = offset(element);
        const { ownerDocument: { body: body, documentElement: documentElement }, offsetParent: offsetParent } = toNode(element);
        let parent = offsetParent || documentElement;
        while(parent && (parent === body || parent === documentElement) && css(parent, "position") === "static")parent = parent.parentNode;
        if (isElement(parent)) {
            const parentOffset = offset(parent);
            top -= parentOffset.top + toFloat(css(parent, "borderTopWidth"));
            left -= parentOffset.left + toFloat(css(parent, "borderLeftWidth"));
        }
        return {
            top: top - toFloat(css(element, "marginTop")),
            left: left - toFloat(css(element, "marginLeft"))
        };
    }
    function offsetPosition(element) {
        element = toNode(element);
        const offset2 = [
            element.offsetTop,
            element.offsetLeft
        ];
        while(element = element.offsetParent){
            offset2[0] += element.offsetTop + toFloat(css(element, `borderTopWidth`));
            offset2[1] += element.offsetLeft + toFloat(css(element, `borderLeftWidth`));
            if (css(element, "position") === "fixed") {
                const win = toWindow(element);
                offset2[0] += win.scrollY;
                offset2[1] += win.scrollX;
                return offset2;
            }
        }
        return offset2;
    }
    const height = dimension("height");
    const width = dimension("width");
    function dimension(prop) {
        const propName = ucfirst(prop);
        return (element, value)=>{
            if (isUndefined(value)) {
                if (isWindow(element)) return element[`inner${propName}`];
                if (isDocument(element)) {
                    const doc = element.documentElement;
                    return Math.max(doc[`offset${propName}`], doc[`scroll${propName}`]);
                }
                element = toNode(element);
                value = css(element, prop);
                value = value === "auto" ? element[`offset${propName}`] : toFloat(value) || 0;
                return value - boxModelAdjust(element, prop);
            } else return css(element, prop, !value && value !== 0 ? "" : +value + boxModelAdjust(element, prop) + "px");
        };
    }
    function boxModelAdjust(element, prop, sizing = "border-box") {
        return css(element, "boxSizing") === sizing ? sumBy(dirs$1[prop], (prop2)=>toFloat(css(element, `padding-${prop2}`)) + toFloat(css(element, `border-${prop2}-width`))) : 0;
    }
    function flipPosition(pos) {
        for(const dir in dirs$1)for(const i in dirs$1[dir]){
            if (dirs$1[dir][i] === pos) return dirs$1[dir][1 - i];
        }
        return pos;
    }
    function toPx(value, property = "width", element = window, offsetDim = false) {
        if (!isString(value)) return toFloat(value);
        return sumBy(parseCalc(value), (value2)=>{
            const unit = parseUnit(value2);
            return unit ? percent(unit === "vh" ? getViewportHeight() : unit === "vw" ? width(toWindow(element)) : offsetDim ? element[`offset${ucfirst(property)}`] : dimensions$1(element)[property], value2) : value2;
        });
    }
    const calcRe = /-?\d+(?:\.\d+)?(?:v[wh]|%|px)?/g;
    const parseCalc = memoize((calc)=>calc.toString().replace(/\s/g, "").match(calcRe) || []);
    const unitRe$1 = /(?:v[hw]|%)$/;
    const parseUnit = memoize((str)=>(str.match(unitRe$1) || [])[0]);
    function percent(base, value) {
        return base * toFloat(value) / 100;
    }
    let vh;
    let vhEl;
    function getViewportHeight() {
        if (vh) return vh;
        if (!vhEl) {
            vhEl = $("<div>");
            css(vhEl, {
                height: "100vh",
                position: "fixed"
            });
            on(window, "resize", ()=>vh = null);
        }
        append(document.body, vhEl);
        vh = vhEl.clientHeight;
        remove$1(vhEl);
        return vh;
    }
    const fastdom = {
        read: read,
        write: write,
        clear: clear,
        flush: flush
    };
    const reads = [];
    const writes = [];
    function read(task) {
        reads.push(task);
        scheduleFlush();
        return task;
    }
    function write(task) {
        writes.push(task);
        scheduleFlush();
        return task;
    }
    function clear(task) {
        remove(reads, task);
        remove(writes, task);
    }
    let scheduled = false;
    function flush() {
        runTasks(reads);
        runTasks(writes.splice(0));
        scheduled = false;
        if (reads.length || writes.length) scheduleFlush();
    }
    function scheduleFlush() {
        if (!scheduled) {
            scheduled = true;
            queueMicrotask(flush);
        }
    }
    function runTasks(tasks) {
        let task;
        while(task = tasks.shift())try {
            task();
        } catch (e) {
            console.error(e);
        }
    }
    function remove(array, item) {
        const index = array.indexOf(item);
        return ~index && array.splice(index, 1);
    }
    class MouseTracker {
        init() {
            this.positions = [];
            let position;
            this.unbind = on(document, "mousemove", (e)=>position = getEventPos(e));
            this.interval = setInterval(()=>{
                if (!position) return;
                this.positions.push(position);
                if (this.positions.length > 5) this.positions.shift();
            }, 50);
        }
        cancel() {
            var _a;
            (_a = this.unbind) == null || _a.call(this);
            clearInterval(this.interval);
        }
        movesTo(target) {
            if (!this.positions || this.positions.length < 2) return false;
            const p = dimensions$1(target);
            const { left: left, right: right, top: top, bottom: bottom } = p;
            const [prevPosition] = this.positions;
            const position = last(this.positions);
            const path = [
                prevPosition,
                position
            ];
            if (pointInRect(position, p)) return false;
            const diagonals = [
                [
                    {
                        x: left,
                        y: top
                    },
                    {
                        x: right,
                        y: bottom
                    }
                ],
                [
                    {
                        x: left,
                        y: bottom
                    },
                    {
                        x: right,
                        y: top
                    }
                ]
            ];
            return diagonals.some((diagonal)=>{
                const intersection = intersect(path, diagonal);
                return intersection && pointInRect(intersection, p);
            });
        }
    }
    function intersect([{ x: x1, y: y1 }, { x: x2, y: y2 }], [{ x: x3, y: y3 }, { x: x4, y: y4 }]) {
        const denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
        if (denominator === 0) return false;
        const ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;
        if (ua < 0) return false;
        return {
            x: x1 + ua * (x2 - x1),
            y: y1 + ua * (y2 - y1)
        };
    }
    function observeIntersection(targets, cb, options = {}, { intersecting: intersecting = true } = {}) {
        const observer = new IntersectionObserver(intersecting ? (entries, observer2)=>{
            if (entries.some((entry)=>entry.isIntersecting)) cb(entries, observer2);
        } : cb, options);
        for (const el of toNodes(targets))observer.observe(el);
        return observer;
    }
    const hasResizeObserver = inBrowser && window.ResizeObserver;
    function observeResize(targets, cb, options = {
        box: "border-box"
    }) {
        if (hasResizeObserver) return observe$1(ResizeObserver, targets, cb, options);
        const off = [
            on(window, "load resize", cb),
            on(document, "loadedmetadata load", cb, true)
        ];
        return {
            disconnect: ()=>off.map((cb2)=>cb2())
        };
    }
    function observeViewportResize(cb) {
        return {
            disconnect: on([
                window,
                window.visualViewport
            ], "resize", cb)
        };
    }
    function observeMutation(targets, cb, options) {
        return observe$1(MutationObserver, targets, cb, options);
    }
    function observe$1(Observer, targets, cb, options) {
        const observer = new Observer(cb);
        for (const el of toNodes(targets))observer.observe(el, options);
        return observer;
    }
    function play(el) {
        if (isIFrame(el)) call(el, {
            func: "playVideo",
            method: "play"
        });
        if (isHTML5(el)) el.play().catch(noop);
    }
    function pause(el) {
        if (isIFrame(el)) call(el, {
            func: "pauseVideo",
            method: "pause"
        });
        if (isHTML5(el)) el.pause();
    }
    function mute(el) {
        if (isIFrame(el)) call(el, {
            func: "mute",
            method: "setVolume",
            value: 0
        });
        if (isHTML5(el)) el.muted = true;
    }
    function isVideo(el) {
        return isHTML5(el) || isIFrame(el);
    }
    function isHTML5(el) {
        return isTag(el, "video");
    }
    function isIFrame(el) {
        return isTag(el, "iframe") && (isYoutube(el) || isVimeo(el));
    }
    function isYoutube(el) {
        return !!el.src.match(/\/\/.*?youtube(-nocookie)?\.[a-z]+\/(watch\?v=[^&\s]+|embed)|youtu\.be\/.*/);
    }
    function isVimeo(el) {
        return !!el.src.match(/vimeo\.com\/video\/.*/);
    }
    async function call(el, cmd) {
        await enableApi(el);
        post(el, cmd);
    }
    function post(el, cmd) {
        el.contentWindow.postMessage(JSON.stringify({
            event: "command",
            ...cmd
        }), "*");
    }
    const stateKey = "_ukPlayer";
    let counter = 0;
    function enableApi(el) {
        if (el[stateKey]) return el[stateKey];
        const youtube = isYoutube(el);
        const vimeo = isVimeo(el);
        const id = ++counter;
        let poller;
        return el[stateKey] = new Promise((resolve)=>{
            youtube && once(el, "load", ()=>{
                const listener = ()=>post(el, {
                        event: "listening",
                        id: id
                    });
                poller = setInterval(listener, 100);
                listener();
            });
            once(window, "message", resolve, false, ({ data: data })=>{
                try {
                    data = JSON.parse(data);
                    return youtube && (data == null ? void 0 : data.id) === id && data.event === "onReady" || vimeo && Number(data == null ? void 0 : data.player_id) === id;
                } catch (e) {}
            });
            el.src = `${el.src}${includes(el.src, "?") ? "&" : "?"}${youtube ? "enablejsapi=1" : `api=1&player_id=${id}`}`;
        }).then(()=>clearInterval(poller));
    }
    function isInView(element, offsetTop = 0, offsetLeft = 0) {
        if (!isVisible(element)) return false;
        return intersectRect(...overflowParents(element).map((parent2)=>{
            const { top: top, left: left, bottom: bottom, right: right } = offsetViewport(parent2);
            return {
                top: top - offsetTop,
                left: left - offsetLeft,
                bottom: bottom + offsetTop,
                right: right + offsetLeft
            };
        }).concat(offset(element)));
    }
    function scrollIntoView(element, { offset: offsetBy = 0 } = {}) {
        const parents2 = isVisible(element) ? scrollParents(element, false, [
            "hidden"
        ]) : [];
        return parents2.reduce((fn, scrollElement, i)=>{
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, offsetHeight: offsetHeight } = scrollElement;
            const viewport = offsetViewport(scrollElement);
            const maxScroll = scrollHeight - viewport.height;
            const { height: elHeight, top: elTop } = parents2[i - 1] ? offsetViewport(parents2[i - 1]) : offset(element);
            let top = Math.ceil(elTop - viewport.top - offsetBy + scrollTop);
            if (offsetBy > 0 && offsetHeight < elHeight + offsetBy) top += offsetBy;
            else offsetBy = 0;
            if (top > maxScroll) {
                offsetBy -= top - maxScroll;
                top = maxScroll;
            } else if (top < 0) {
                offsetBy -= top;
                top = 0;
            }
            return ()=>scrollTo(scrollElement, top - scrollTop, element, maxScroll).then(fn);
        }, ()=>Promise.resolve())();
        function scrollTo(element2, top, targetEl, maxScroll) {
            return new Promise((resolve)=>{
                const scroll = element2.scrollTop;
                const duration = getDuration(Math.abs(top));
                const start = Date.now();
                const isScrollingElement = scrollingElement(element2) === element2;
                const targetTop = offset(targetEl).top + (isScrollingElement ? 0 : scroll);
                let prev = 0;
                let frames = 15;
                (function step() {
                    const percent = ease(clamp((Date.now() - start) / duration));
                    let diff = 0;
                    if (parents2[0] === element2 && scroll + top < maxScroll) diff = offset(targetEl).top + (isScrollingElement ? 0 : element2.scrollTop) - targetTop - dimensions$1(getCoveringElement(targetEl)).height;
                    if (css(element2, "scrollBehavior") !== "auto") css(element2, "scrollBehavior", "auto");
                    element2.scrollTop = scroll + (top + diff) * percent;
                    css(element2, "scrollBehavior", "");
                    if (percent === 1 && (prev === diff || !frames--)) resolve();
                    else {
                        prev = diff;
                        requestAnimationFrame(step);
                    }
                })();
            });
        }
        function getDuration(dist) {
            return 40 * Math.pow(dist, 0.375);
        }
        function ease(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
        }
    }
    function scrolledOver(element, startOffset = 0, endOffset = 0) {
        if (!isVisible(element)) return 0;
        const scrollElement = scrollParent(element, true);
        const { scrollHeight: scrollHeight, scrollTop: scrollTop } = scrollElement;
        const { height: viewportHeight } = offsetViewport(scrollElement);
        const maxScroll = scrollHeight - viewportHeight;
        const elementOffsetTop = offsetPosition(element)[0] - offsetPosition(scrollElement)[0];
        const start = Math.max(0, elementOffsetTop - viewportHeight + startOffset);
        const end = Math.min(maxScroll, elementOffsetTop + element.offsetHeight - endOffset);
        return start < end ? clamp((scrollTop - start) / (end - start)) : 1;
    }
    function scrollParents(element, scrollable = false, props = []) {
        const scrollEl = scrollingElement(element);
        let ancestors = parents(element).reverse();
        ancestors = ancestors.slice(ancestors.indexOf(scrollEl) + 1);
        const fixedIndex = findIndex(ancestors, (el)=>css(el, "position") === "fixed");
        if (~fixedIndex) ancestors = ancestors.slice(fixedIndex);
        return [
            scrollEl
        ].concat(ancestors.filter((parent2)=>css(parent2, "overflow").split(" ").some((prop)=>includes([
                    "auto",
                    "scroll",
                    ...props
                ], prop)) && (!scrollable || parent2.scrollHeight > offsetViewport(parent2).height))).reverse();
    }
    function scrollParent(...args) {
        return scrollParents(...args)[0];
    }
    function overflowParents(element) {
        return scrollParents(element, false, [
            "hidden",
            "clip"
        ]);
    }
    function offsetViewport(scrollElement) {
        const window1 = toWindow(scrollElement);
        const documentScrollingElement = scrollingElement(scrollElement);
        const useWindow = !isNode(scrollElement) || scrollElement.contains(documentScrollingElement);
        if (useWindow && window1.visualViewport) {
            let { height: height, width: width, scale: scale, pageTop: top, pageLeft: left } = window1.visualViewport;
            height = Math.round(height * scale);
            width = Math.round(width * scale);
            return {
                height: height,
                width: width,
                top: top,
                left: left,
                bottom: top + height,
                right: left + width
            };
        }
        let rect = offset(useWindow ? window1 : scrollElement);
        if (css(scrollElement, "display") === "inline") return rect;
        const { body: body, documentElement: documentElement } = window1.document;
        const viewportElement = useWindow ? documentScrollingElement === documentElement || // In quirks mode the scrolling element is body, even though the viewport is html
        documentScrollingElement.clientHeight < body.clientHeight ? documentScrollingElement : body : scrollElement;
        for (let [prop, dir, start, end] of [
            [
                "width",
                "x",
                "left",
                "right"
            ],
            [
                "height",
                "y",
                "top",
                "bottom"
            ]
        ]){
            const subpixel = rect[prop] % 1;
            rect[start] += toFloat(css(viewportElement, `border-${start}-width`));
            rect[prop] = rect[dir] = viewportElement[`client${ucfirst(prop)}`] - (subpixel ? subpixel < 0.5 ? -subpixel : 1 - subpixel : 0);
            rect[end] = rect[prop] + rect[start];
        }
        return rect;
    }
    function getCoveringElement(target) {
        const { left: left, width: width, top: top } = dimensions$1(target);
        for (const position of top ? [
            0,
            top
        ] : [
            0
        ]){
            let coverEl;
            for (const el of toWindow(target).document.elementsFromPoint(left + width / 2, position))if (!el.contains(target) && // If e.g. Offcanvas is not yet closed
            !hasClass(el, "uk-togglable-leave") && (hasPosition(el, "fixed") && zIndex(parents(target).reverse().find((parent2)=>!parent2.contains(el) && !hasPosition(parent2, "static"))) < zIndex(el) || hasPosition(el, "sticky") && parent(el).contains(target)) && (!coverEl || dimensions$1(coverEl).height < dimensions$1(el).height)) coverEl = el;
            if (coverEl) return coverEl;
        }
    }
    function zIndex(element) {
        return toFloat(css(element, "zIndex"));
    }
    function hasPosition(element, position) {
        return css(element, "position") === position;
    }
    function scrollingElement(element) {
        return toWindow(element).document.scrollingElement;
    }
    const dirs = [
        [
            "width",
            "x",
            "left",
            "right"
        ],
        [
            "height",
            "y",
            "top",
            "bottom"
        ]
    ];
    function positionAt(element, target, options) {
        options = {
            attach: {
                element: [
                    "left",
                    "top"
                ],
                target: [
                    "left",
                    "top"
                ],
                ...options.attach
            },
            offset: [
                0,
                0
            ],
            placement: [],
            ...options
        };
        if (!isArray(target)) target = [
            target,
            target
        ];
        offset(element, getPosition(element, target, options));
    }
    function getPosition(element, target, options) {
        const position = attachTo(element, target, options);
        const { boundary: boundary, viewportOffset: viewportOffset = 0, placement: placement } = options;
        let offsetPosition = position;
        for (const [i, [prop, , start, end]] of Object.entries(dirs)){
            const viewport = getViewport$2(element, target[i], viewportOffset, boundary, i);
            if (isWithin(position, viewport, i)) continue;
            let offsetBy = 0;
            if (placement[i] === "flip") {
                const attach = options.attach.target[i];
                if (attach === end && position[end] <= viewport[end] || attach === start && position[start] >= viewport[start]) continue;
                offsetBy = flip(element, target, options, i)[start] - position[start];
                const scrollArea = getScrollArea(element, target[i], viewportOffset, i);
                if (!isWithin(applyOffset(position, offsetBy, i), scrollArea, i)) {
                    if (isWithin(position, scrollArea, i)) continue;
                    if (options.recursion) return false;
                    const newPos = flipAxis(element, target, options);
                    if (newPos && isWithin(newPos, scrollArea, 1 - i)) return newPos;
                    continue;
                }
            } else if (placement[i] === "shift") {
                const targetDim = offset(target[i]);
                const { offset: elOffset } = options;
                offsetBy = clamp(clamp(position[start], viewport[start], viewport[end] - position[prop]), targetDim[start] - position[prop] + elOffset[i], targetDim[end] - elOffset[i]) - position[start];
            }
            offsetPosition = applyOffset(offsetPosition, offsetBy, i);
        }
        return offsetPosition;
    }
    function attachTo(element, target, options) {
        let { attach: attach, offset: offsetBy } = {
            attach: {
                element: [
                    "left",
                    "top"
                ],
                target: [
                    "left",
                    "top"
                ],
                ...options.attach
            },
            offset: [
                0,
                0
            ],
            ...options
        };
        let elOffset = offset(element);
        for (const [i, [prop, , start, end]] of Object.entries(dirs)){
            const targetOffset = attach.target[i] === attach.element[i] ? offsetViewport(target[i]) : offset(target[i]);
            elOffset = applyOffset(elOffset, targetOffset[start] - elOffset[start] + moveBy(attach.target[i], end, targetOffset[prop]) - moveBy(attach.element[i], end, elOffset[prop]) + +offsetBy[i], i);
        }
        return elOffset;
    }
    function applyOffset(position, offset2, i) {
        const [, dir, start, end] = dirs[i];
        const newPos = {
            ...position
        };
        newPos[start] = position[dir] = position[start] + offset2;
        newPos[end] += offset2;
        return newPos;
    }
    function moveBy(attach, end, dim) {
        return attach === "center" ? dim / 2 : attach === end ? dim : 0;
    }
    function getViewport$2(element, target, viewportOffset, boundary, i) {
        let viewport = getIntersectionArea(...commonScrollParents(element, target).map(offsetViewport));
        if (viewportOffset) {
            viewport[dirs[i][2]] += viewportOffset;
            viewport[dirs[i][3]] -= viewportOffset;
        }
        if (boundary) viewport = getIntersectionArea(viewport, offset(isArray(boundary) ? boundary[i] : boundary));
        return viewport;
    }
    function getScrollArea(element, target, viewportOffset, i) {
        const [prop, axis, start, end] = dirs[i];
        const [scrollElement] = commonScrollParents(element, target);
        const viewport = offsetViewport(scrollElement);
        if ([
            "auto",
            "scroll"
        ].includes(css(scrollElement, `overflow-${axis}`))) {
            viewport[start] -= scrollElement[`scroll${ucfirst(start)}`];
            viewport[end] = viewport[start] + scrollElement[`scroll${ucfirst(prop)}`];
        }
        viewport[start] += viewportOffset;
        viewport[end] -= viewportOffset;
        return viewport;
    }
    function commonScrollParents(element, target) {
        return overflowParents(target).filter((parent)=>parent.contains(element));
    }
    function getIntersectionArea(...rects) {
        let area = {};
        for (const rect of rects)for (const [, , start, end] of dirs){
            area[start] = Math.max(area[start] || 0, rect[start]);
            area[end] = Math.min(...[
                area[end],
                rect[end]
            ].filter(Boolean));
        }
        return area;
    }
    function isWithin(positionA, positionB, i) {
        const [, , start, end] = dirs[i];
        return positionA[start] >= positionB[start] && positionA[end] <= positionB[end];
    }
    function flip(element, target, { offset: offset2, attach: attach }, i) {
        return attachTo(element, target, {
            attach: {
                element: flipAttach(attach.element, i),
                target: flipAttach(attach.target, i)
            },
            offset: flipOffset(offset2, i)
        });
    }
    function flipAxis(element, target, options) {
        return getPosition(element, target, {
            ...options,
            attach: {
                element: options.attach.element.map(flipAttachAxis).reverse(),
                target: options.attach.target.map(flipAttachAxis).reverse()
            },
            offset: options.offset.reverse(),
            placement: options.placement.reverse(),
            recursion: true
        });
    }
    function flipAttach(attach, i) {
        const newAttach = [
            ...attach
        ];
        const index = dirs[i].indexOf(attach[i]);
        if (~index) newAttach[i] = dirs[i][1 - index % 2 + 2];
        return newAttach;
    }
    function flipAttachAxis(prop) {
        for(let i = 0; i < dirs.length; i++){
            const index = dirs[i].indexOf(prop);
            if (~index) return dirs[1 - i][index % 2 + 2];
        }
    }
    function flipOffset(offset2, i) {
        offset2 = [
            ...offset2
        ];
        offset2[i] *= -1;
        return offset2;
    }
    var util = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        $: $,
        $$: $$,
        Animation: Animation,
        Dimensions: Dimensions,
        MouseTracker: MouseTracker,
        Transition: Transition,
        addClass: addClass,
        after: after,
        append: append,
        apply: apply,
        assign: assign,
        attr: attr,
        before: before,
        boxModelAdjust: boxModelAdjust,
        camelize: camelize,
        children: children,
        clamp: clamp,
        createEvent: createEvent,
        css: css,
        data: data,
        dimensions: dimensions$1,
        each: each,
        empty: empty,
        endsWith: endsWith,
        escape: escape,
        fastdom: fastdom,
        filter: filter$1,
        find: find,
        findAll: findAll,
        findIndex: findIndex,
        flipPosition: flipPosition,
        fragment: fragment,
        getCoveringElement: getCoveringElement,
        getEventPos: getEventPos,
        getIndex: getIndex,
        getTargetedElement: getTargetedElement,
        hasAttr: hasAttr,
        hasClass: hasClass,
        hasOwn: hasOwn,
        hasTouch: hasTouch,
        height: height,
        html: html,
        hyphenate: hyphenate,
        inBrowser: inBrowser,
        includes: includes,
        index: index,
        intersectRect: intersectRect,
        isArray: isArray,
        isBoolean: isBoolean,
        isDocument: isDocument,
        isElement: isElement,
        isEmpty: isEmpty,
        isEqual: isEqual,
        isFocusable: isFocusable,
        isFunction: isFunction,
        isInView: isInView,
        isInput: isInput,
        isNode: isNode,
        isNumber: isNumber,
        isNumeric: isNumeric,
        isObject: isObject,
        isPlainObject: isPlainObject,
        isRtl: isRtl,
        isSameSiteAnchor: isSameSiteAnchor,
        isString: isString,
        isTag: isTag,
        isTouch: isTouch,
        isUndefined: isUndefined,
        isVideo: isVideo,
        isVisible: isVisible,
        isVoidElement: isVoidElement,
        isWindow: isWindow,
        last: last,
        matches: matches,
        memoize: memoize,
        mute: mute,
        noop: noop,
        observeIntersection: observeIntersection,
        observeMutation: observeMutation,
        observeResize: observeResize,
        observeViewportResize: observeViewportResize,
        off: off,
        offset: offset,
        offsetPosition: offsetPosition,
        offsetViewport: offsetViewport,
        on: on,
        once: once,
        overflowParents: overflowParents,
        parent: parent,
        parents: parents,
        pause: pause,
        pick: pick,
        play: play,
        pointInRect: pointInRect,
        pointerCancel: pointerCancel,
        pointerDown: pointerDown$1,
        pointerEnter: pointerEnter,
        pointerLeave: pointerLeave,
        pointerMove: pointerMove$1,
        pointerUp: pointerUp$1,
        position: position,
        positionAt: positionAt,
        prepend: prepend,
        propName: propName,
        query: query,
        queryAll: queryAll,
        ready: ready,
        remove: remove$1,
        removeAttr: removeAttr,
        removeClass: removeClass,
        replaceClass: replaceClass,
        scrollIntoView: scrollIntoView,
        scrollParent: scrollParent,
        scrollParents: scrollParents,
        scrolledOver: scrolledOver,
        selFocusable: selFocusable,
        selInput: selInput,
        sortBy: sortBy,
        startsWith: startsWith,
        sumBy: sumBy,
        swap: swap,
        toArray: toArray,
        toBoolean: toBoolean,
        toEventTargets: toEventTargets,
        toFloat: toFloat,
        toNode: toNode,
        toNodes: toNodes,
        toNumber: toNumber,
        toPx: toPx,
        toWindow: toWindow,
        toggleClass: toggleClass,
        trigger: trigger,
        ucfirst: ucfirst,
        uniqueBy: uniqueBy,
        unwrap: unwrap,
        width: width,
        wrapAll: wrapAll,
        wrapInner: wrapInner
    });
    var Class = {
        connected () {
            addClass(this.$el, this.$options.id);
        }
    };
    const units = [
        "days",
        "hours",
        "minutes",
        "seconds"
    ];
    var countdown = {
        mixins: [
            Class
        ],
        props: {
            date: String,
            clsWrapper: String,
            role: String
        },
        data: {
            date: "",
            clsWrapper: ".uk-countdown-%unit%",
            role: "timer"
        },
        connected () {
            attr(this.$el, "role", this.role);
            this.date = toFloat(Date.parse(this.$props.date));
            this.end = false;
            this.start();
        },
        disconnected () {
            this.stop();
        },
        events: {
            name: "visibilitychange",
            el: ()=>document,
            handler () {
                if (document.hidden) this.stop();
                else this.start();
            }
        },
        methods: {
            start () {
                this.stop();
                this.update();
                if (!this.timer) {
                    trigger(this.$el, "countdownstart");
                    this.timer = setInterval(this.update, 1e3);
                }
            },
            stop () {
                if (this.timer) {
                    clearInterval(this.timer);
                    trigger(this.$el, "countdownstop");
                    this.timer = null;
                }
            },
            update () {
                const timespan = getTimeSpan(this.date);
                if (!timespan.total) {
                    this.stop();
                    if (!this.end) {
                        trigger(this.$el, "countdownend");
                        this.end = true;
                    }
                }
                for (const unit of units){
                    const el = $(this.clsWrapper.replace("%unit%", unit), this.$el);
                    if (!el) continue;
                    let digits = Math.trunc(timespan[unit]).toString().padStart(2, "0");
                    if (el.textContent !== digits) {
                        digits = digits.split("");
                        if (digits.length !== el.children.length) html(el, digits.map(()=>"<span></span>").join(""));
                        digits.forEach((digit, i)=>el.children[i].textContent = digit);
                    }
                }
            }
        }
    };
    function getTimeSpan(date) {
        const total = Math.max(0, date - Date.now()) / 1e3;
        return {
            total: total,
            seconds: total % 60,
            minutes: total / 60 % 60,
            hours: total / 60 / 60 % 24,
            days: total / 60 / 60 / 24
        };
    }
    const strats = {};
    strats.events = strats.watch = strats.observe = strats.created = strats.beforeConnect = strats.connected = strats.beforeDisconnect = strats.disconnected = strats.destroy = concatStrat;
    strats.args = function(parentVal, childVal) {
        return childVal !== false && concatStrat(childVal || parentVal);
    };
    strats.update = function(parentVal, childVal) {
        return sortBy(concatStrat(parentVal, isFunction(childVal) ? {
            read: childVal
        } : childVal), "order");
    };
    strats.props = function(parentVal, childVal) {
        if (isArray(childVal)) {
            const value = {};
            for (const key of childVal)value[key] = String;
            childVal = value;
        }
        return strats.methods(parentVal, childVal);
    };
    strats.computed = strats.methods = function(parentVal, childVal) {
        return childVal ? parentVal ? {
            ...parentVal,
            ...childVal
        } : childVal : parentVal;
    };
    strats.i18n = strats.data = function(parentVal, childVal, vm) {
        if (!vm) {
            if (!childVal) return parentVal;
            if (!parentVal) return childVal;
            return function(vm2) {
                return mergeFnData(parentVal, childVal, vm2);
            };
        }
        return mergeFnData(parentVal, childVal, vm);
    };
    function mergeFnData(parentVal, childVal, vm) {
        return strats.computed(isFunction(parentVal) ? parentVal.call(vm, vm) : parentVal, isFunction(childVal) ? childVal.call(vm, vm) : childVal);
    }
    function concatStrat(parentVal, childVal) {
        parentVal = parentVal && !isArray(parentVal) ? [
            parentVal
        ] : parentVal;
        return childVal ? parentVal ? parentVal.concat(childVal) : isArray(childVal) ? childVal : [
            childVal
        ] : parentVal;
    }
    function defaultStrat(parentVal, childVal) {
        return isUndefined(childVal) ? parentVal : childVal;
    }
    function mergeOptions(parent, child, vm) {
        const options = {};
        if (isFunction(child)) child = child.options;
        if (child.extends) parent = mergeOptions(parent, child.extends, vm);
        if (child.mixins) for (const mixin of child.mixins)parent = mergeOptions(parent, mixin, vm);
        for(const key in parent)mergeKey(key);
        for(const key in child)if (!hasOwn(parent, key)) mergeKey(key);
        function mergeKey(key) {
            options[key] = (strats[key] || defaultStrat)(parent[key], child[key], vm);
        }
        return options;
    }
    function parseOptions(options, args = []) {
        try {
            return options ? startsWith(options, "{") ? JSON.parse(options) : args.length && !includes(options, ":") ? {
                [args[0]]: options
            } : options.split(";").reduce((options2, option)=>{
                const [key, value] = option.split(/:(.*)/);
                if (key && !isUndefined(value)) options2[key.trim()] = value.trim();
                return options2;
            }, {}) : {};
        } catch (e) {
            return {};
        }
    }
    function coerce$1(type, value) {
        if (type === Boolean) return toBoolean(value);
        else if (type === Number) return toNumber(value);
        else if (type === "list") return toList(value);
        else if (type === Object && isString(value)) return parseOptions(value);
        return type ? type(value) : value;
    }
    const listRe = /,(?![^(]*\))/;
    function toList(value) {
        return isArray(value) ? value : isString(value) ? value.split(listRe).map((value2)=>isNumeric(value2) ? toNumber(value2) : toBoolean(value2.trim())) : [
            value
        ];
    }
    function initUpdates(instance) {
        instance._data = {};
        instance._updates = [
            ...instance.$options.update || []
        ];
        instance._disconnect.push(()=>instance._updates = instance._data = null);
    }
    function prependUpdate(instance, update) {
        instance._updates.unshift(update);
    }
    function callUpdate(instance, e = "update") {
        if (!instance._connected) return;
        if (!instance._updates.length) return;
        if (!instance._queued) {
            instance._queued = /* @__PURE__ */ new Set();
            fastdom.read(()=>{
                if (instance._connected) runUpdates(instance, instance._queued);
                instance._queued = null;
            });
        }
        instance._queued.add(e.type || e);
    }
    function runUpdates(instance, types) {
        for (const { read: read, write: write, events: events = [] } of instance._updates){
            if (!types.has("update") && !events.some((type)=>types.has(type))) continue;
            let result;
            if (read) {
                result = read.call(instance, instance._data, types);
                if (result && isPlainObject(result)) assign(instance._data, result);
            }
            if (write && result !== false) fastdom.write(()=>{
                if (instance._connected) write.call(instance, instance._data, types);
            });
        }
    }
    function resize(options) {
        return observe(observeResize, options, "resize");
    }
    function intersection(options) {
        return observe(observeIntersection, options);
    }
    function mutation(options) {
        return observe(observeMutation, options);
    }
    function lazyload(options = {}) {
        return intersection({
            handler: function(entries, observer) {
                const { targets: targets = this.$el, preload: preload = 5 } = options;
                for (const el of toNodes(isFunction(targets) ? targets(this) : targets))$$('[loading="lazy"]', el).slice(0, preload - 1).forEach((el2)=>removeAttr(el2, "loading"));
                for (const el of entries.filter(({ isIntersecting: isIntersecting })=>isIntersecting).map(({ target: target })=>target))observer.unobserve(el);
            },
            ...options
        });
    }
    function viewport(options) {
        return observe((target, handler)=>observeViewportResize(handler), options, "resize");
    }
    function scroll$1(options) {
        return observe((target, handler)=>({
                disconnect: on(toScrollTargets(target), "scroll", handler, {
                    passive: true
                })
            }), options, "scroll");
    }
    function swipe(options) {
        return {
            observe (target, handler) {
                return {
                    observe: noop,
                    unobserve: noop,
                    disconnect: on(target, pointerDown$1, handler, {
                        passive: true
                    })
                };
            },
            handler (e) {
                if (!isTouch(e)) return;
                const pos = getEventPos(e);
                const target = "tagName" in e.target ? e.target : parent(e.target);
                once(document, `${pointerUp$1} ${pointerCancel} scroll`, (e2)=>{
                    const { x: x, y: y } = getEventPos(e2);
                    if (e2.type !== "scroll" && target && x && Math.abs(pos.x - x) > 100 || y && Math.abs(pos.y - y) > 100) setTimeout(()=>{
                        trigger(target, "swipe");
                        trigger(target, `swipe${swipeDirection(pos.x, pos.y, x, y)}`);
                    });
                });
            },
            ...options
        };
    }
    function observe(observe2, options, emit) {
        return {
            observe: observe2,
            handler () {
                callUpdate(this, emit);
            },
            ...options
        };
    }
    function swipeDirection(x1, y1, x2, y2) {
        return Math.abs(x1 - x2) >= Math.abs(y1 - y2) ? x1 - x2 > 0 ? "Left" : "Right" : y1 - y2 > 0 ? "Up" : "Down";
    }
    function toScrollTargets(elements) {
        return toNodes(elements).map((node)=>{
            const { ownerDocument: ownerDocument } = node;
            const parent2 = scrollParent(node, true);
            return parent2 === ownerDocument.scrollingElement ? ownerDocument : parent2;
        });
    }
    var Margin = {
        props: {
            margin: String,
            firstColumn: Boolean
        },
        data: {
            margin: "uk-margin-small-top",
            firstColumn: "uk-first-column"
        },
        observe: [
            mutation({
                options: {
                    childList: true
                }
            }),
            mutation({
                options: {
                    attributes: true,
                    attributeFilter: [
                        "style"
                    ]
                },
                target: ({ $el: $el })=>[
                        $el,
                        ...children($el)
                    ]
            }),
            resize({
                target: ({ $el: $el })=>[
                        $el,
                        ...children($el)
                    ]
            })
        ],
        update: {
            read () {
                return {
                    rows: getRows(children(this.$el))
                };
            },
            write ({ rows: rows }) {
                for (const row of rows)for (const el of row){
                    toggleClass(el, this.margin, rows[0] !== row);
                    toggleClass(el, this.firstColumn, row[isRtl ? row.length - 1 : 0] === el);
                }
            },
            events: [
                "resize"
            ]
        }
    };
    function getRows(elements) {
        const sorted = [
            []
        ];
        const withOffset = elements.some((el, i)=>i && elements[i - 1].offsetParent !== el.offsetParent);
        for (const el of elements){
            if (!isVisible(el)) continue;
            const offset = getOffset(el, withOffset);
            for(let i = sorted.length - 1; i >= 0; i--){
                const current = sorted[i];
                if (!current[0]) {
                    current.push(el);
                    break;
                }
                const offsetCurrent = getOffset(current[0], withOffset);
                if (offset.top >= offsetCurrent.bottom - 1 && offset.top !== offsetCurrent.top) {
                    sorted.push([
                        el
                    ]);
                    break;
                }
                if (offset.bottom - 1 > offsetCurrent.top || offset.top === offsetCurrent.top) {
                    let j = current.length - 1;
                    for(; j >= 0; j--){
                        const offsetCurrent2 = getOffset(current[j], withOffset);
                        if (offset.left >= offsetCurrent2.left) break;
                    }
                    current.splice(j + 1, 0, el);
                    break;
                }
                if (i === 0) {
                    sorted.unshift([
                        el
                    ]);
                    break;
                }
            }
        }
        return sorted;
    }
    function getOffset(element, offset = false) {
        let { offsetTop: offsetTop, offsetLeft: offsetLeft, offsetHeight: offsetHeight, offsetWidth: offsetWidth } = element;
        if (offset) [offsetTop, offsetLeft] = offsetPosition(element);
        return {
            top: offsetTop,
            left: offsetLeft,
            bottom: offsetTop + offsetHeight,
            right: offsetLeft + offsetWidth
        };
    }
    async function slide(action, target, duration) {
        await awaitFrame();
        let nodes = children(target);
        const currentProps = nodes.map((el)=>getProps$1(el, true));
        const targetProps = {
            ...css(target, [
                "height",
                "padding"
            ]),
            display: "block"
        };
        const targets = nodes.concat(target);
        await Promise.all(targets.map(Transition.cancel));
        css(targets, "transitionProperty", "none");
        await action();
        nodes = nodes.concat(children(target).filter((el)=>!includes(nodes, el)));
        await Promise.resolve();
        css(targets, "transitionProperty", "");
        const targetStyle = attr(target, "style");
        const targetPropsTo = css(target, [
            "height",
            "padding"
        ]);
        const [propsTo, propsFrom] = getTransitionProps(target, nodes, currentProps);
        const attrsTo = nodes.map((el)=>({
                style: attr(el, "style")
            }));
        nodes.forEach((el, i)=>propsFrom[i] && css(el, propsFrom[i]));
        css(target, targetProps);
        trigger(target, "scroll");
        await awaitFrame();
        const transitions = nodes.map((el, i)=>parent(el) === target && Transition.start(el, propsTo[i], duration, "ease")).concat(Transition.start(target, targetPropsTo, duration, "ease"));
        try {
            await Promise.all(transitions);
            nodes.forEach((el, i)=>{
                attr(el, attrsTo[i]);
                if (parent(el) === target) css(el, "display", propsTo[i].opacity === 0 ? "none" : "");
            });
            attr(target, "style", targetStyle);
        } catch (e) {
            attr(nodes, "style", "");
            resetProps(target, targetProps);
        }
    }
    function getProps$1(el, opacity) {
        const zIndex = css(el, "zIndex");
        return isVisible(el) ? {
            display: "",
            opacity: opacity ? css(el, "opacity") : "0",
            pointerEvents: "none",
            position: "absolute",
            zIndex: zIndex === "auto" ? index(el) : zIndex,
            ...getPositionWithMargin(el)
        } : false;
    }
    function getTransitionProps(target, nodes, currentProps) {
        const propsTo = nodes.map((el, i)=>parent(el) && i in currentProps ? currentProps[i] ? isVisible(el) ? getPositionWithMargin(el) : {
                opacity: 0
            } : {
                opacity: isVisible(el) ? 1 : 0
            } : false);
        const propsFrom = propsTo.map((props, i)=>{
            const from = parent(nodes[i]) === target && (currentProps[i] || getProps$1(nodes[i]));
            if (!from) return false;
            if (!props) delete from.opacity;
            else if (!("opacity" in props)) {
                const { opacity: opacity } = from;
                if (opacity % 1) props.opacity = 1;
                else delete from.opacity;
            }
            return from;
        });
        return [
            propsTo,
            propsFrom
        ];
    }
    function resetProps(el, props) {
        for(const prop in props)css(el, prop, "");
    }
    function getPositionWithMargin(el) {
        const { height: height, width: width } = dimensions$1(el);
        return {
            height: height,
            width: width,
            transform: "",
            ...position(el),
            ...css(el, [
                "marginTop",
                "marginLeft"
            ])
        };
    }
    function awaitFrame() {
        return new Promise((resolve)=>requestAnimationFrame(resolve));
    }
    const clsLeave = "uk-transition-leave";
    const clsEnter = "uk-transition-enter";
    function fade(action, target, duration, stagger = 0) {
        const index = transitionIndex(target, true);
        const propsIn = {
            opacity: 1
        };
        const propsOut = {
            opacity: 0
        };
        const wrapIndexFn = (fn)=>()=>index === transitionIndex(target) ? fn() : Promise.reject();
        const leaveFn = wrapIndexFn(async ()=>{
            addClass(target, clsLeave);
            await Promise.all(getTransitionNodes(target).map((child, i)=>new Promise((resolve)=>setTimeout(()=>Transition.start(child, propsOut, duration / 2, "ease").then(resolve), i * stagger))));
            removeClass(target, clsLeave);
        });
        const enterFn = wrapIndexFn(async ()=>{
            const oldHeight = height(target);
            addClass(target, clsEnter);
            action();
            css(children(target), {
                opacity: 0
            });
            await awaitFrame();
            const nodes = children(target);
            const newHeight = height(target);
            css(target, "alignContent", "flex-start");
            height(target, oldHeight);
            const transitionNodes = getTransitionNodes(target);
            css(nodes, propsOut);
            const transitions = transitionNodes.map(async (child, i)=>{
                await awaitTimeout(i * stagger);
                await Transition.start(child, propsIn, duration / 2, "ease");
            });
            if (oldHeight !== newHeight) transitions.push(Transition.start(target, {
                height: newHeight
            }, duration / 2 + transitionNodes.length * stagger, "ease"));
            await Promise.all(transitions).then(()=>{
                removeClass(target, clsEnter);
                if (index === transitionIndex(target)) {
                    css(target, {
                        height: "",
                        alignContent: ""
                    });
                    css(nodes, {
                        opacity: ""
                    });
                    delete target.dataset.transition;
                }
            });
        });
        return hasClass(target, clsLeave) ? waitTransitionend(target).then(enterFn) : hasClass(target, clsEnter) ? waitTransitionend(target).then(leaveFn).then(enterFn) : leaveFn().then(enterFn);
    }
    function transitionIndex(target, next) {
        if (next) target.dataset.transition = 1 + transitionIndex(target);
        return toNumber(target.dataset.transition) || 0;
    }
    function waitTransitionend(target) {
        return Promise.all(children(target).filter(Transition.inProgress).map((el)=>new Promise((resolve)=>once(el, "transitionend transitioncanceled", resolve))));
    }
    function getTransitionNodes(target) {
        return getRows(children(target)).flat().filter(isVisible);
    }
    function awaitTimeout(timeout) {
        return new Promise((resolve)=>setTimeout(resolve, timeout));
    }
    var Animate = {
        props: {
            duration: Number,
            animation: Boolean
        },
        data: {
            duration: 150,
            animation: "slide"
        },
        methods: {
            animate (action, target = this.$el) {
                const name = this.animation;
                const animationFn = name === "fade" ? fade : name === "delayed-fade" ? (...args)=>fade(...args, 40) : name ? slide : ()=>{
                    action();
                    return Promise.resolve();
                };
                return animationFn(action, target, this.duration).catch(noop);
            }
        }
    };
    const keyMap = {
        TAB: 9,
        ESC: 27,
        SPACE: 32,
        END: 35,
        HOME: 36,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40
    };
    var filter = {
        mixins: [
            Animate
        ],
        args: "target",
        props: {
            target: String,
            selActive: Boolean
        },
        data: {
            target: "",
            selActive: false,
            attrItem: "uk-filter-control",
            cls: "uk-active",
            duration: 250
        },
        computed: {
            children: ({ target: target }, $el)=>$$(`${target} > *`, $el),
            toggles: ({ attrItem: attrItem }, $el)=>$$(`[${attrItem}],[data-${attrItem}]`, $el)
        },
        watch: {
            toggles (toggles) {
                this.updateState();
                const actives = $$(this.selActive, this.$el);
                for (const toggle of toggles){
                    if (this.selActive !== false) toggleClass(toggle, this.cls, includes(actives, toggle));
                    const button = findButton(toggle);
                    if (isTag(button, "a")) attr(button, "role", "button");
                }
            },
            children (list, prev) {
                if (prev) this.updateState();
            }
        },
        events: {
            name: "click keydown",
            delegate: ({ attrItem: attrItem })=>`[${attrItem}],[data-${attrItem}]`,
            handler (e) {
                if (e.type === "keydown" && e.keyCode !== keyMap.SPACE) return;
                if (e.target.closest("a,button")) {
                    e.preventDefault();
                    this.apply(e.current);
                }
            }
        },
        methods: {
            apply (el) {
                const prevState = this.getState();
                const newState = mergeState(el, this.attrItem, this.getState());
                if (!isEqualState(prevState, newState)) this.setState(newState);
            },
            getState () {
                return this.toggles.filter((item)=>hasClass(item, this.cls)).reduce((state, el)=>mergeState(el, this.attrItem, state), {
                    filter: {
                        "": ""
                    },
                    sort: []
                });
            },
            async setState (state, animate = true) {
                state = {
                    filter: {
                        "": ""
                    },
                    sort: [],
                    ...state
                };
                trigger(this.$el, "beforeFilter", [
                    this,
                    state
                ]);
                for (const toggle of this.toggles)toggleClass(toggle, this.cls, matchFilter(toggle, this.attrItem, state));
                await Promise.all($$(this.target, this.$el).map((target)=>{
                    const filterFn = ()=>applyState(state, target, children(target));
                    return animate ? this.animate(filterFn, target) : filterFn();
                }));
                trigger(this.$el, "afterFilter", [
                    this
                ]);
            },
            updateState () {
                fastdom.write(()=>this.setState(this.getState(), false));
            }
        }
    };
    function getFilter(el, attr2) {
        return parseOptions(data(el, attr2), [
            "filter"
        ]);
    }
    function isEqualState(stateA, stateB) {
        return [
            "filter",
            "sort"
        ].every((prop)=>isEqual(stateA[prop], stateB[prop]));
    }
    function applyState(state, target, children) {
        for (const el of children)css(el, "display", Object.values(state.filter).every((selector)=>!selector || matches(el, selector)) ? "" : "none");
        const [sort, order] = state.sort;
        if (sort) {
            const sorted = sortItems(children, sort, order);
            if (!isEqual(sorted, children)) append(target, sorted);
        }
    }
    function mergeState(el, attr2, state) {
        const { filter: filter, group: group, sort: sort, order: order = "asc" } = getFilter(el, attr2);
        if (filter || isUndefined(sort)) {
            if (group) {
                if (filter) {
                    delete state.filter[""];
                    state.filter[group] = filter;
                } else {
                    delete state.filter[group];
                    if (isEmpty(state.filter) || "" in state.filter) state.filter = {
                        "": filter || ""
                    };
                }
            } else state.filter = {
                "": filter || ""
            };
        }
        if (!isUndefined(sort)) state.sort = [
            sort,
            order
        ];
        return state;
    }
    function matchFilter(el, attr2, { filter: stateFilter = {
        "": ""
    }, sort: [stateSort, stateOrder] }) {
        const { filter: filter = "", group: group = "", sort: sort, order: order = "asc" } = getFilter(el, attr2);
        return isUndefined(sort) ? group in stateFilter && filter === stateFilter[group] || !filter && group && !(group in stateFilter) && !stateFilter[""] : stateSort === sort && stateOrder === order;
    }
    function sortItems(nodes, sort, order) {
        return [
            ...nodes
        ].sort((a, b)=>data(a, sort).localeCompare(data(b, sort), void 0, {
                numeric: true
            }) * (order === "asc" || -1));
    }
    function findButton(el) {
        return $("a,button", el) || el;
    }
    let prevented;
    function preventBackgroundScroll(el) {
        const off = on(el, "touchstart", (e)=>{
            if (e.targetTouches.length !== 1 || matches(e.target, 'input[type="range"')) return;
            let prev = getEventPos(e).y;
            const offMove = on(el, "touchmove", (e2)=>{
                const pos = getEventPos(e2).y;
                if (pos === prev) return;
                prev = pos;
                if (!scrollParents(e2.target).some((scrollParent)=>{
                    if (!el.contains(scrollParent)) return false;
                    let { scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollParent;
                    return clientHeight < scrollHeight;
                })) e2.preventDefault();
            }, {
                passive: false
            });
            once(el, "scroll touchend touchcanel", offMove, {
                capture: true
            });
        }, {
            passive: true
        });
        if (prevented) return off;
        prevented = true;
        const { scrollingElement: scrollingElement } = document;
        css(scrollingElement, {
            overflowY: CSS.supports("overflow", "clip") ? "clip" : "hidden",
            touchAction: "none",
            paddingRight: width(window) - scrollingElement.clientWidth || ""
        });
        return ()=>{
            prevented = false;
            off();
            css(scrollingElement, {
                overflowY: "",
                touchAction: "",
                paddingRight: ""
            });
        };
    }
    var Container = {
        props: {
            container: Boolean
        },
        data: {
            container: true
        },
        computed: {
            container ({ container: container }) {
                return container === true && this.$container || container && $(container);
            }
        }
    };
    var Togglable = {
        props: {
            cls: Boolean,
            animation: "list",
            duration: Number,
            velocity: Number,
            origin: String,
            transition: String
        },
        data: {
            cls: false,
            animation: [
                false
            ],
            duration: 200,
            velocity: 0.2,
            origin: false,
            transition: "ease",
            clsEnter: "uk-togglable-enter",
            clsLeave: "uk-togglable-leave"
        },
        computed: {
            hasAnimation: ({ animation: animation })=>!!animation[0],
            hasTransition: ({ animation: animation })=>[
                    "slide",
                    "reveal"
                ].some((transition)=>startsWith(animation[0], transition))
        },
        methods: {
            async toggleElement (targets, toggle, animate) {
                try {
                    await Promise.all(toNodes(targets).map((el)=>{
                        const show = isBoolean(toggle) ? toggle : !this.isToggled(el);
                        if (!trigger(el, `before${show ? "show" : "hide"}`, [
                            this
                        ])) return Promise.reject();
                        const promise = (isFunction(animate) ? animate : animate === false || !this.hasAnimation ? toggleInstant : this.hasTransition ? toggleTransition : toggleAnimation)(el, show, this);
                        const cls = show ? this.clsEnter : this.clsLeave;
                        addClass(el, cls);
                        trigger(el, show ? "show" : "hide", [
                            this
                        ]);
                        const done = ()=>{
                            removeClass(el, cls);
                            trigger(el, show ? "shown" : "hidden", [
                                this
                            ]);
                        };
                        return promise ? promise.then(done, ()=>{
                            removeClass(el, cls);
                            return Promise.reject();
                        }) : done();
                    }));
                    return true;
                } catch (e) {
                    return false;
                }
            },
            isToggled (el = this.$el) {
                el = toNode(el);
                return hasClass(el, this.clsEnter) ? true : hasClass(el, this.clsLeave) ? false : this.cls ? hasClass(el, this.cls.split(" ")[0]) : isVisible(el);
            },
            _toggle (el, toggled) {
                if (!el) return;
                toggled = Boolean(toggled);
                let changed;
                if (this.cls) {
                    changed = includes(this.cls, " ") || toggled !== hasClass(el, this.cls);
                    changed && toggleClass(el, this.cls, includes(this.cls, " ") ? void 0 : toggled);
                } else {
                    changed = toggled === el.hidden;
                    changed && (el.hidden = !toggled);
                }
                if (changed) trigger(el, "toggled", [
                    toggled,
                    this
                ]);
                $$("[autofocus]", el).some((el2)=>isVisible(el2) ? el2.focus() || true : el2.blur());
            }
        }
    };
    function toggleInstant(el, show, { _toggle: _toggle }) {
        Animation.cancel(el);
        Transition.cancel(el);
        return _toggle(el, show);
    }
    async function toggleTransition(el, show, { animation: animation, duration: duration, velocity: velocity, transition: transition, _toggle: _toggle }) {
        var _a;
        const [mode = "reveal", startProp = "top"] = ((_a = animation[0]) == null ? void 0 : _a.split("-")) || [];
        const dirs = [
            [
                "left",
                "right"
            ],
            [
                "top",
                "bottom"
            ]
        ];
        const dir = dirs[includes(dirs[0], startProp) ? 0 : 1];
        const end = dir[1] === startProp;
        const props = [
            "width",
            "height"
        ];
        const dimProp = props[dirs.indexOf(dir)];
        const marginProp = `margin-${dir[0]}`;
        const marginStartProp = `margin-${startProp}`;
        let currentDim = dimensions$1(el)[dimProp];
        const inProgress = Transition.inProgress(el);
        await Transition.cancel(el);
        if (show) _toggle(el, true);
        const prevProps = Object.fromEntries([
            "padding",
            "border",
            "width",
            "height",
            "minWidth",
            "minHeight",
            "overflowY",
            "overflowX",
            marginProp,
            marginStartProp
        ].map((key)=>[
                key,
                el.style[key]
            ]));
        const dim = dimensions$1(el);
        const currentMargin = toFloat(css(el, marginProp));
        const marginStart = toFloat(css(el, marginStartProp));
        const endDim = dim[dimProp] + marginStart;
        if (!inProgress && !show) currentDim += marginStart;
        const [wrapper] = wrapInner(el, "<div>");
        css(wrapper, {
            boxSizing: "border-box",
            height: dim.height,
            width: dim.width,
            ...css(el, [
                "overflow",
                "padding",
                "borderTop",
                "borderRight",
                "borderBottom",
                "borderLeft",
                "borderImage",
                marginStartProp
            ])
        });
        css(el, {
            padding: 0,
            border: 0,
            minWidth: 0,
            minHeight: 0,
            [marginStartProp]: 0,
            width: dim.width,
            height: dim.height,
            overflow: "hidden",
            [dimProp]: currentDim
        });
        const percent = currentDim / endDim;
        duration = (velocity * endDim + duration) * (show ? 1 - percent : percent);
        const endProps = {
            [dimProp]: show ? endDim : 0
        };
        if (end) {
            css(el, marginProp, endDim - currentDim + currentMargin);
            endProps[marginProp] = show ? currentMargin : endDim + currentMargin;
        }
        if (!end ^ mode === "reveal") {
            css(wrapper, marginProp, -endDim + currentDim);
            Transition.start(wrapper, {
                [marginProp]: show ? 0 : -endDim
            }, duration, transition);
        }
        try {
            await Transition.start(el, endProps, duration, transition);
        } finally{
            css(el, prevProps);
            unwrap(wrapper.firstChild);
            if (!show) _toggle(el, false);
        }
    }
    function toggleAnimation(el, show, cmp) {
        const { animation: animation, duration: duration, _toggle: _toggle } = cmp;
        if (show) {
            _toggle(el, true);
            return Animation.in(el, animation[0], duration, cmp.origin);
        }
        return Animation.out(el, animation[1] || animation[0], duration, cmp.origin).then(()=>_toggle(el, false));
    }
    const active$1 = [];
    var Modal = {
        mixins: [
            Class,
            Container,
            Togglable
        ],
        props: {
            selPanel: String,
            selClose: String,
            escClose: Boolean,
            bgClose: Boolean,
            stack: Boolean,
            role: String
        },
        data: {
            cls: "uk-open",
            escClose: true,
            bgClose: true,
            overlay: true,
            stack: false,
            role: "dialog"
        },
        computed: {
            panel: ({ selPanel: selPanel }, $el)=>$(selPanel, $el),
            transitionElement () {
                return this.panel;
            },
            bgClose ({ bgClose: bgClose }) {
                return bgClose && this.panel;
            }
        },
        connected () {
            attr(this.panel || this.$el, "role", this.role);
            if (this.overlay) attr(this.panel || this.$el, "aria-modal", true);
        },
        beforeDisconnect () {
            if (includes(active$1, this)) this.toggleElement(this.$el, false, false);
        },
        events: [
            {
                name: "click",
                delegate: ({ selClose: selClose })=>`${selClose},a[href*="#"]`,
                handler (e) {
                    const { current: current, defaultPrevented: defaultPrevented } = e;
                    const { hash: hash } = current;
                    if (!defaultPrevented && hash && isSameSiteAnchor(current) && !this.$el.contains($(hash))) this.hide();
                    else if (matches(current, this.selClose)) {
                        e.preventDefault();
                        this.hide();
                    }
                }
            },
            {
                name: "toggle",
                self: true,
                handler (e) {
                    if (e.defaultPrevented) return;
                    e.preventDefault();
                    if (this.isToggled() === includes(active$1, this)) this.toggle();
                }
            },
            {
                name: "beforeshow",
                self: true,
                handler (e) {
                    if (includes(active$1, this)) return false;
                    if (!this.stack && active$1.length) {
                        Promise.all(active$1.map((modal)=>modal.hide())).then(this.show);
                        e.preventDefault();
                    } else active$1.push(this);
                }
            },
            {
                name: "show",
                self: true,
                handler () {
                    if (this.stack) css(this.$el, "zIndex", toFloat(css(this.$el, "zIndex")) + active$1.length);
                    const handlers = [
                        this.overlay && preventBackgroundFocus(this),
                        this.overlay && preventBackgroundScroll(this.$el),
                        this.bgClose && listenForBackgroundClose$1(this),
                        this.escClose && listenForEscClose$1(this)
                    ];
                    once(this.$el, "hidden", ()=>handlers.forEach((handler)=>handler && handler()), {
                        self: true
                    });
                    addClass(document.documentElement, this.clsPage);
                }
            },
            {
                name: "shown",
                self: true,
                handler () {
                    if (!isFocusable(this.$el)) attr(this.$el, "tabindex", "-1");
                    if (!matches(this.$el, ":focus-within")) this.$el.focus();
                }
            },
            {
                name: "hidden",
                self: true,
                handler () {
                    if (includes(active$1, this)) active$1.splice(active$1.indexOf(this), 1);
                    css(this.$el, "zIndex", "");
                    if (!active$1.some((modal)=>modal.clsPage === this.clsPage)) removeClass(document.documentElement, this.clsPage);
                }
            }
        ],
        methods: {
            toggle () {
                return this.isToggled() ? this.hide() : this.show();
            },
            show () {
                if (this.container && parent(this.$el) !== this.container) {
                    append(this.container, this.$el);
                    return new Promise((resolve)=>requestAnimationFrame(()=>this.show().then(resolve)));
                }
                return this.toggleElement(this.$el, true, animate$1);
            },
            hide () {
                return this.toggleElement(this.$el, false, animate$1);
            }
        }
    };
    function animate$1(el, show, { transitionElement: transitionElement, _toggle: _toggle }) {
        return new Promise((resolve, reject)=>once(el, "show hide", ()=>{
                var _a;
                (_a = el._reject) == null || _a.call(el);
                el._reject = reject;
                _toggle(el, show);
                const off = once(transitionElement, "transitionstart", ()=>{
                    once(transitionElement, "transitionend transitioncancel", resolve, {
                        self: true
                    });
                    clearTimeout(timer);
                }, {
                    self: true
                });
                const timer = setTimeout(()=>{
                    off();
                    resolve();
                }, toMs(css(transitionElement, "transitionDuration")));
            })).then(()=>delete el._reject);
    }
    function toMs(time) {
        return time ? endsWith(time, "ms") ? toFloat(time) : toFloat(time) * 1e3 : 0;
    }
    function preventBackgroundFocus(modal) {
        return on(document, "focusin", (e)=>{
            if (last(active$1) === modal && !modal.$el.contains(e.target)) modal.$el.focus();
        });
    }
    function listenForBackgroundClose$1(modal) {
        return on(document, pointerDown$1, ({ target: target })=>{
            if (last(active$1) !== modal || modal.overlay && !modal.$el.contains(target) || modal.panel.contains(target)) return;
            once(document, `${pointerUp$1} ${pointerCancel} scroll`, ({ defaultPrevented: defaultPrevented, type: type, target: newTarget })=>{
                if (!defaultPrevented && type === pointerUp$1 && target === newTarget) modal.hide();
            }, true);
        });
    }
    function listenForEscClose$1(modal) {
        return on(document, "keydown", (e)=>{
            if (e.keyCode === 27 && last(active$1) === modal) modal.hide();
        });
    }
    var Animations$2 = {
        slide: {
            show (dir) {
                return [
                    {
                        transform: translate(dir * -100)
                    },
                    {
                        transform: translate()
                    }
                ];
            },
            percent (current) {
                return translated(current);
            },
            translate (percent, dir) {
                return [
                    {
                        transform: translate(dir * -100 * percent)
                    },
                    {
                        transform: translate(dir * 100 * (1 - percent))
                    }
                ];
            }
        }
    };
    function translated(el) {
        return Math.abs(new DOMMatrix(css(el, "transform")).m41 / el.offsetWidth);
    }
    function translate(value = 0, unit = "%") {
        value += value ? unit : "";
        return `translate3d(${value}, 0, 0)`;
    }
    function scale3d(value) {
        return `scale3d(${value}, ${value}, 1)`;
    }
    function Transitioner$1(prev, next, dir, { animation: animation, easing: easing }) {
        const { percent: percent, translate: translate, show: show = noop } = animation;
        const props = show(dir);
        const { promise: promise, resolve: resolve } = withResolvers();
        return {
            dir: dir,
            show (duration, percent2 = 0, linear) {
                const timing = linear ? "linear" : easing;
                duration -= Math.round(duration * clamp(percent2, -1, 1));
                this.translate(percent2);
                triggerUpdate(next, "itemin", {
                    percent: percent2,
                    duration: duration,
                    timing: timing,
                    dir: dir
                });
                triggerUpdate(prev, "itemout", {
                    percent: 1 - percent2,
                    duration: duration,
                    timing: timing,
                    dir: dir
                });
                Promise.all([
                    Transition.start(next, props[1], duration, timing),
                    Transition.start(prev, props[0], duration, timing)
                ]).then(()=>{
                    this.reset();
                    resolve();
                }, noop);
                return promise;
            },
            cancel () {
                return Transition.cancel([
                    next,
                    prev
                ]);
            },
            reset () {
                for(const prop in props[0])css([
                    next,
                    prev
                ], prop, "");
            },
            async forward (duration, percent2 = this.percent()) {
                await this.cancel();
                return this.show(duration, percent2, true);
            },
            translate (percent2) {
                this.reset();
                const props2 = translate(percent2, dir);
                css(next, props2[1]);
                css(prev, props2[0]);
                triggerUpdate(next, "itemtranslatein", {
                    percent: percent2,
                    dir: dir
                });
                triggerUpdate(prev, "itemtranslateout", {
                    percent: 1 - percent2,
                    dir: dir
                });
            },
            percent () {
                return percent(prev || next, next, dir);
            },
            getDistance () {
                return prev == null ? void 0 : prev.offsetWidth;
            }
        };
    }
    function triggerUpdate(el, type, data) {
        trigger(el, createEvent(type, false, false, data));
    }
    function withResolvers() {
        let resolve;
        return {
            promise: new Promise((res)=>resolve = res),
            resolve: resolve
        };
    }
    var I18n = {
        props: {
            i18n: Object
        },
        data: {
            i18n: null
        },
        methods: {
            t (key, ...params) {
                var _a, _b, _c;
                let i = 0;
                return ((_c = ((_a = this.i18n) == null ? void 0 : _a[key]) || ((_b = this.$options.i18n) == null ? void 0 : _b[key])) == null ? void 0 : _c.replace(/%s/g, ()=>params[i++] || "")) || "";
            }
        }
    };
    var SliderAutoplay = {
        props: {
            autoplay: Boolean,
            autoplayInterval: Number,
            pauseOnHover: Boolean
        },
        data: {
            autoplay: false,
            autoplayInterval: 7e3,
            pauseOnHover: true
        },
        connected () {
            attr(this.list, "aria-live", this.autoplay ? "off" : "polite");
            this.autoplay && this.startAutoplay();
        },
        disconnected () {
            this.stopAutoplay();
        },
        update () {
            attr(this.slides, "tabindex", "-1");
        },
        events: [
            {
                name: "visibilitychange",
                el: ()=>document,
                filter: ({ autoplay: autoplay })=>autoplay,
                handler () {
                    if (document.hidden) this.stopAutoplay();
                    else this.startAutoplay();
                }
            }
        ],
        methods: {
            startAutoplay () {
                this.stopAutoplay();
                this.interval = setInterval(()=>{
                    if (!(this.stack.length || this.draggable && matches(this.$el, ":focus-within") && !matches(this.$el, ":focus") || this.pauseOnHover && matches(this.$el, ":hover"))) this.show("next");
                }, this.autoplayInterval);
            },
            stopAutoplay () {
                clearInterval(this.interval);
            }
        }
    };
    const pointerOptions = {
        passive: false,
        capture: true
    };
    const pointerUpOptions = {
        passive: true,
        capture: true
    };
    const pointerDown = "touchstart mousedown";
    const pointerMove = "touchmove mousemove";
    const pointerUp = "touchend touchcancel mouseup click input scroll";
    const preventClick = (e)=>e.preventDefault();
    var SliderDrag = {
        props: {
            draggable: Boolean
        },
        data: {
            draggable: true,
            threshold: 10
        },
        created () {
            for (const key of [
                "start",
                "move",
                "end"
            ]){
                const fn = this[key];
                this[key] = (e)=>{
                    const pos = getEventPos(e).x * (isRtl ? -1 : 1);
                    this.prevPos = pos === this.pos ? this.prevPos : this.pos;
                    this.pos = pos;
                    fn(e);
                };
            }
        },
        events: [
            {
                name: pointerDown,
                passive: true,
                delegate: ({ selList: selList })=>`${selList} > *`,
                handler (e) {
                    if (!this.draggable || this.parallax || !isTouch(e) && hasSelectableText(e.target) || e.target.closest(selInput) || e.button > 0 || this.length < 2) return;
                    this.start(e);
                }
            },
            {
                name: "dragstart",
                handler (e) {
                    e.preventDefault();
                }
            },
            {
                // iOS workaround for slider stopping if swiping fast
                name: pointerMove,
                el: ({ list: list })=>list,
                handler: noop,
                ...pointerOptions
            }
        ],
        methods: {
            start () {
                this.drag = this.pos;
                if (this._transitioner) {
                    this.percent = this._transitioner.percent();
                    this.drag += this._transitioner.getDistance() * this.percent * this.dir;
                    this._transitioner.cancel();
                    this._transitioner.translate(this.percent);
                    this.dragging = true;
                    this.stack = [];
                } else this.prevIndex = this.index;
                on(document, pointerMove, this.move, pointerOptions);
                on(document, pointerUp, this.end, pointerUpOptions);
                css(this.list, "userSelect", "none");
            },
            move (e) {
                const distance = this.pos - this.drag;
                if (distance === 0 || this.prevPos === this.pos || !this.dragging && Math.abs(distance) < this.threshold) return;
                if (!this.dragging) on(this.list, "click", preventClick, pointerOptions);
                e.cancelable && e.preventDefault();
                this.dragging = true;
                this.dir = distance < 0 ? 1 : -1;
                let { slides: slides, prevIndex: prevIndex } = this;
                let dis = Math.abs(distance);
                let nextIndex = this.getIndex(prevIndex + this.dir);
                let width = getDistance.call(this, prevIndex, nextIndex);
                while(nextIndex !== prevIndex && dis > width){
                    this.drag -= width * this.dir;
                    prevIndex = nextIndex;
                    dis -= width;
                    nextIndex = this.getIndex(prevIndex + this.dir);
                    width = getDistance.call(this, prevIndex, nextIndex);
                }
                this.percent = dis / width;
                const prev = slides[prevIndex];
                const next = slides[nextIndex];
                const changed = this.index !== nextIndex;
                const edge = prevIndex === nextIndex;
                let itemShown;
                for (const i of [
                    this.index,
                    this.prevIndex
                ])if (!includes([
                    nextIndex,
                    prevIndex
                ], i)) {
                    trigger(slides[i], "itemhidden", [
                        this
                    ]);
                    if (edge) {
                        itemShown = true;
                        this.prevIndex = prevIndex;
                    }
                }
                if (this.index === prevIndex && this.prevIndex !== prevIndex || itemShown) trigger(slides[this.index], "itemshown", [
                    this
                ]);
                if (changed) {
                    this.prevIndex = prevIndex;
                    this.index = nextIndex;
                    if (!edge) {
                        trigger(prev, "beforeitemhide", [
                            this
                        ]);
                        trigger(prev, "itemhide", [
                            this
                        ]);
                    }
                    trigger(next, "beforeitemshow", [
                        this
                    ]);
                    trigger(next, "itemshow", [
                        this
                    ]);
                }
                this._transitioner = this._translate(Math.abs(this.percent), prev, !edge && next);
            },
            end () {
                off(document, pointerMove, this.move, pointerOptions);
                off(document, pointerUp, this.end, pointerUpOptions);
                if (this.dragging) {
                    this.dragging = null;
                    if (this.index === this.prevIndex) {
                        this.percent = 1 - this.percent;
                        this.dir *= -1;
                        this._show(false, this.index, true);
                        this._transitioner = null;
                    } else {
                        const dirChange = (isRtl ? this.dir * (isRtl ? 1 : -1) : this.dir) < 0 === this.prevPos > this.pos;
                        this.index = dirChange ? this.index : this.prevIndex;
                        if (dirChange) this.percent = 1 - this.percent;
                        this.show(this.dir > 0 && !dirChange || this.dir < 0 && dirChange ? "next" : "previous", true);
                    }
                }
                setTimeout(()=>off(this.list, "click", preventClick, pointerOptions));
                css(this.list, {
                    userSelect: ""
                });
                this.drag = this.percent = null;
            }
        }
    };
    function getDistance(prev, next) {
        return this._getTransitioner(prev, prev !== next && next).getDistance() || this.slides[prev].offsetWidth;
    }
    function hasSelectableText(el) {
        return css(el, "userSelect") !== "none" && toArray(el.childNodes).some((el2)=>el2.nodeType === 3 && el2.textContent.trim());
    }
    function initWatches(instance) {
        instance._watches = [];
        for (const watches of instance.$options.watch || [])for (const [name, watch] of Object.entries(watches))registerWatch(instance, watch, name);
        instance._initial = true;
    }
    function registerWatch(instance, watch, name) {
        instance._watches.push({
            name: name,
            ...isPlainObject(watch) ? watch : {
                handler: watch
            }
        });
    }
    function runWatches(instance, values) {
        for (const { name: name, handler: handler, immediate: immediate = true } of instance._watches)if (instance._initial && immediate || hasOwn(values, name) && !isEqual(values[name], instance[name])) handler.call(instance, instance[name], values[name]);
        instance._initial = false;
    }
    function initComputed(instance) {
        const { computed: computed } = instance.$options;
        instance._computed = {};
        if (computed) for(const key in computed)registerComputed(instance, key, computed[key]);
    }
    const mutationOptions = {
        subtree: true,
        childList: true
    };
    function registerComputed(instance, key, cb) {
        instance._hasComputed = true;
        Object.defineProperty(instance, key, {
            enumerable: true,
            get () {
                const { _computed: _computed, $props: $props, $el: $el } = instance;
                if (!hasOwn(_computed, key)) {
                    _computed[key] = (cb.get || cb).call(instance, $props, $el);
                    if (cb.observe && instance._computedObserver) {
                        const selector = cb.observe.call(instance, $props);
                        instance._computedObserver.observe([
                            "~",
                            "+",
                            "-"
                        ].includes(selector[0]) ? $el.parentElement : $el.getRootNode(), mutationOptions);
                    }
                }
                return _computed[key];
            },
            set (value) {
                const { _computed: _computed } = instance;
                _computed[key] = cb.set ? cb.set.call(instance, value) : value;
                if (isUndefined(_computed[key])) delete _computed[key];
            }
        });
    }
    function initComputedUpdates(instance) {
        if (!instance._hasComputed) return;
        prependUpdate(instance, {
            read: ()=>runWatches(instance, resetComputed(instance)),
            events: [
                "resize",
                "computed"
            ]
        });
        instance._computedObserver = observeMutation(instance.$el, ()=>callUpdate(instance, "computed"), mutationOptions);
        instance._disconnect.push(()=>{
            instance._computedObserver.disconnect();
            instance._computedObserver = null;
            resetComputed(instance);
        });
    }
    function resetComputed(instance) {
        const values = {
            ...instance._computed
        };
        instance._computed = {};
        return values;
    }
    function initEvents(instance) {
        for (const event of instance.$options.events || []){
            if (hasOwn(event, "handler")) registerEvent(instance, event);
            else for(const key in event)registerEvent(instance, event[key], key);
        }
    }
    function registerEvent(instance, event, key) {
        let { name: name, el: el, handler: handler, capture: capture, passive: passive, delegate: delegate, filter: filter, self: self } = isPlainObject(event) ? event : {
            name: key,
            handler: event
        };
        el = isFunction(el) ? el.call(instance, instance) : el || instance.$el;
        if (!el || isArray(el) && !el.length || filter && !filter.call(instance, instance)) return;
        instance._disconnect.push(on(el, name, delegate ? isString(delegate) ? delegate : delegate.call(instance, instance) : null, isString(handler) ? instance[handler] : handler.bind(instance), {
            passive: passive,
            capture: capture,
            self: self
        }));
    }
    function initObservers(instance) {
        for (const observer of instance.$options.observe || [])registerObservable(instance, observer);
    }
    function registerObservable(instance, observable) {
        let { observe: observe, target: target = instance.$el, handler: handler, options: options, filter: filter, args: args } = observable;
        if (filter && !filter.call(instance, instance)) return;
        const key = `_observe${instance._disconnect.length}`;
        if (isFunction(target) && !hasOwn(instance, key)) registerComputed(instance, key, ()=>{
            const targets2 = target.call(instance, instance);
            return isArray(targets2) ? toNodes(targets2) : targets2;
        });
        handler = isString(handler) ? instance[handler] : handler.bind(instance);
        if (isFunction(options)) options = options.call(instance, instance);
        const targets = hasOwn(instance, key) ? instance[key] : target;
        const observer = observe(targets, handler, options, args);
        if (isFunction(target) && isArray(instance[key])) registerWatch(instance, {
            handler: updateTargets(observer, options),
            immediate: false
        }, key);
        instance._disconnect.push(()=>observer.disconnect());
    }
    function updateTargets(observer, options) {
        return (targets, prev)=>{
            for (const target of prev)if (!includes(targets, target)) {
                if (observer.unobserve) observer.unobserve(target);
                else if (observer.observe) observer.disconnect();
            }
            for (const target of targets)if (!includes(prev, target) || !observer.unobserve) observer.observe(target, options);
        };
    }
    function initProps(instance) {
        const { $options: $options, $props: $props } = instance;
        const props = getProps($options);
        assign($props, props);
        const { computed: computed, methods: methods } = $options;
        for(let key in $props)if (key in props && (!computed || !hasOwn(computed, key)) && (!methods || !hasOwn(methods, key))) instance[key] = $props[key];
    }
    function getProps(opts) {
        const data$1 = {};
        const { args: args = [], props: props = {}, el: el, id: id } = opts;
        if (!props) return data$1;
        for(const key in props){
            const prop = hyphenate(key);
            let value = data(el, prop);
            if (isUndefined(value)) continue;
            value = props[key] === Boolean && value === "" ? true : coerce$1(props[key], value);
            if (prop === "target" && startsWith(value, "_")) continue;
            data$1[key] = value;
        }
        const options = parseOptions(data(el, id), args);
        for(const key in options){
            const prop = camelize(key);
            if (!isUndefined(props[prop])) data$1[prop] = coerce$1(props[prop], options[key]);
        }
        return data$1;
    }
    const getAttributes = memoize((id, props)=>{
        const attributes = Object.keys(props);
        const filter = attributes.concat(id).map((key)=>[
                hyphenate(key),
                `data-${hyphenate(key)}`
            ]).flat();
        return {
            attributes: attributes,
            filter: filter
        };
    });
    function initPropsObserver(instance) {
        const { $options: $options, $props: $props } = instance;
        const { id: id, props: props, el: el } = $options;
        if (!props) return;
        const { attributes: attributes, filter: filter } = getAttributes(id, props);
        const observer = new MutationObserver((records)=>{
            const data = getProps($options);
            if (records.some(({ attributeName: attributeName })=>{
                const prop = attributeName.replace("data-", "");
                return (prop === id ? attributes : [
                    camelize(prop),
                    camelize(attributeName)
                ]).some((prop2)=>!isUndefined(data[prop2]) && data[prop2] !== $props[prop2]);
            })) instance.$reset();
        });
        observer.observe(el, {
            attributes: true,
            attributeFilter: filter
        });
        instance._disconnect.push(()=>observer.disconnect());
    }
    function callHook(instance, hook) {
        var _a;
        (_a = instance.$options[hook]) == null || _a.forEach((handler)=>handler.call(instance));
    }
    function callConnected(instance) {
        if (instance._connected) return;
        initProps(instance);
        callHook(instance, "beforeConnect");
        instance._connected = true;
        instance._disconnect = [];
        initEvents(instance);
        initUpdates(instance);
        initWatches(instance);
        initObservers(instance);
        initPropsObserver(instance);
        initComputedUpdates(instance);
        callHook(instance, "connected");
        callUpdate(instance);
    }
    function callDisconnected(instance) {
        if (!instance._connected) return;
        callHook(instance, "beforeDisconnect");
        instance._disconnect.forEach((off)=>off());
        instance._disconnect = null;
        callHook(instance, "disconnected");
        instance._connected = false;
    }
    let uid = 0;
    function init$1(instance, options = {}) {
        options.data = normalizeData(options, instance.constructor.options);
        instance.$options = mergeOptions(instance.constructor.options, options, instance);
        instance.$props = {};
        instance._uid = uid++;
        initData(instance);
        initMethods(instance);
        initComputed(instance);
        callHook(instance, "created");
        if (options.el) instance.$mount(options.el);
    }
    function initData(instance) {
        const { data: data = {} } = instance.$options;
        for(const key in data)instance.$props[key] = instance[key] = data[key];
    }
    function initMethods(instance) {
        const { methods: methods } = instance.$options;
        if (methods) for(const key in methods)instance[key] = methods[key].bind(instance);
    }
    function normalizeData({ data: data = {} }, { args: args = [], props: props = {} }) {
        if (isArray(data)) data = data.slice(0, args.length).reduce((data2, value, index)=>{
            if (isPlainObject(value)) assign(data2, value);
            else data2[args[index]] = value;
            return data2;
        }, {});
        for(const key in data){
            if (isUndefined(data[key])) delete data[key];
            else if (props[key]) data[key] = coerce$1(props[key], data[key]);
        }
        return data;
    }
    const App = function(options) {
        init$1(this, options);
    };
    App.util = util;
    App.options = {};
    App.version = "3.21.13";
    const PREFIX = "uk-";
    const DATA = "__uikit__";
    const components$2 = {};
    function component(name, options) {
        var _a, _b;
        const id = PREFIX + hyphenate(name);
        if (!options) {
            if (!components$2[id].options) components$2[id] = App.extend(components$2[id]);
            return components$2[id];
        }
        name = camelize(name);
        App[name] = (element, data)=>createComponent(name, element, data);
        const opt = (_a = options.options) != null ? _a : {
            ...options
        };
        opt.id = id;
        opt.name = name;
        (_b = opt.install) == null || _b.call(opt, App, opt, name);
        if (App._initialized && !opt.functional) requestAnimationFrame(()=>createComponent(name, `[${id}],[data-${id}]`));
        return components$2[id] = opt;
    }
    function createComponent(name, element, data, ...args) {
        const Component = component(name);
        return Component.options.functional ? new Component({
            data: isPlainObject(element) ? element : [
                element,
                data,
                ...args
            ]
        }) : element ? $$(element).map(init)[0] : init();
        function init(element2) {
            const instance = getComponent(element2, name);
            if (instance) {
                if (data) instance.$destroy();
                else return instance;
            }
            return new Component({
                el: element2,
                data: data
            });
        }
    }
    function getComponents(element) {
        return (element == null ? void 0 : element[DATA]) || {};
    }
    function getComponent(element, name) {
        return getComponents(element)[name];
    }
    function attachToElement(element, instance) {
        if (!element[DATA]) element[DATA] = {};
        element[DATA][instance.$options.name] = instance;
    }
    function detachFromElement(element, instance) {
        var _a;
        (_a = element[DATA]) == null || delete _a[instance.$options.name];
        if (isEmpty(element[DATA])) delete element[DATA];
    }
    function globalApi(App) {
        App.component = component;
        App.getComponents = getComponents;
        App.getComponent = getComponent;
        App.update = update;
        App.use = function(plugin) {
            if (plugin.installed) return;
            plugin.call(null, this);
            plugin.installed = true;
            return this;
        };
        App.mixin = function(mixin, component2) {
            component2 = (isString(component2) ? this.component(component2) : component2) || this;
            component2.options = mergeOptions(component2.options, mixin);
        };
        App.extend = function(options) {
            options || (options = {});
            const Super = this;
            const Sub = function UIkitComponent(options2) {
                init$1(this, options2);
            };
            Sub.prototype = Object.create(Super.prototype);
            Sub.prototype.constructor = Sub;
            Sub.options = mergeOptions(Super.options, options);
            Sub.super = Super;
            Sub.extend = Super.extend;
            return Sub;
        };
        let container;
        Object.defineProperty(App, "container", {
            get () {
                return container || document.body;
            },
            set (element) {
                container = $(element);
            }
        });
    }
    function update(element, e) {
        element = element ? toNode(element) : document.body;
        for (const parentEl of parents(element).reverse())updateElement(parentEl, e);
        apply(element, (element2)=>updateElement(element2, e));
    }
    function updateElement(element, e) {
        const components = getComponents(element);
        for(const name in components)callUpdate(components[name], e);
    }
    function instanceApi(App) {
        App.prototype.$mount = function(el) {
            const instance = this;
            attachToElement(el, instance);
            instance.$options.el = el;
            if (document.contains(el)) callConnected(instance);
        };
        App.prototype.$destroy = function(removeEl = false) {
            const instance = this;
            const { el: el } = instance.$options;
            if (el) callDisconnected(instance);
            callHook(instance, "destroy");
            detachFromElement(el, instance);
            if (removeEl) remove$1(instance.$el);
        };
        App.prototype.$create = createComponent;
        App.prototype.$emit = function(e) {
            callUpdate(this, e);
        };
        App.prototype.$update = function(element = this.$el, e) {
            update(element, e);
        };
        App.prototype.$reset = function() {
            callDisconnected(this);
            callConnected(this);
        };
        App.prototype.$getComponent = getComponent;
        Object.defineProperties(App.prototype, {
            $el: {
                get () {
                    return this.$options.el;
                }
            },
            $container: Object.getOwnPropertyDescriptor(App, "container")
        });
    }
    let id = 1;
    function generateId(instance, el = null) {
        return (el == null ? void 0 : el.id) || `${instance.$options.id}-${id++}`;
    }
    var SliderNav = {
        i18n: {
            next: "Next slide",
            previous: "Previous slide",
            slideX: "Slide %s",
            slideLabel: "%s of %s",
            role: "String"
        },
        data: {
            selNav: false,
            role: "region"
        },
        computed: {
            nav: ({ selNav: selNav }, $el)=>$(selNav, $el),
            navChildren () {
                return children(this.nav);
            },
            selNavItem: ({ attrItem: attrItem })=>`[${attrItem}],[data-${attrItem}]`,
            navItems (_, $el) {
                return $$(this.selNavItem, $el);
            }
        },
        watch: {
            nav (nav, prev) {
                attr(nav, "role", "tablist");
                this.padNavitems();
                if (prev) this.$emit();
            },
            list (list) {
                if (isTag(list, "ul")) attr(list, "role", "presentation");
            },
            navChildren (children2) {
                attr(children2, "role", "presentation");
                this.padNavitems();
                this.updateNav();
            },
            navItems (items) {
                for (const el of items){
                    const cmd = data(el, this.attrItem);
                    const button = $("a,button", el) || el;
                    let ariaLabel;
                    let ariaControls = null;
                    if (isNumeric(cmd)) {
                        const item = toNumber(cmd);
                        const slide = this.slides[item];
                        if (slide) {
                            if (!slide.id) slide.id = generateId(this, slide);
                            ariaControls = slide.id;
                        }
                        ariaLabel = this.t("slideX", toFloat(cmd) + 1);
                        attr(button, "role", "tab");
                    } else {
                        if (this.list) {
                            if (!this.list.id) this.list.id = generateId(this, this.list);
                            ariaControls = this.list.id;
                        }
                        ariaLabel = this.t(cmd);
                    }
                    attr(button, {
                        "aria-controls": ariaControls,
                        "aria-label": attr(button, "aria-label") || ariaLabel
                    });
                }
            },
            slides (slides) {
                slides.forEach((slide, i)=>attr(slide, {
                        role: this.nav ? "tabpanel" : "group",
                        "aria-label": this.t("slideLabel", i + 1, this.length),
                        "aria-roledescription": this.nav ? null : "slide"
                    }));
                this.padNavitems();
            }
        },
        connected () {
            attr(this.$el, {
                role: this.role,
                "aria-roledescription": "carousel"
            });
        },
        update: [
            {
                write () {
                    this.navItems.concat(this.nav).forEach((el)=>el && (el.hidden = !this.maxIndex));
                    this.updateNav();
                },
                events: [
                    "resize"
                ]
            }
        ],
        events: [
            {
                name: "click keydown",
                delegate: ({ selNavItem: selNavItem })=>selNavItem,
                filter: ({ parallax: parallax })=>!parallax,
                handler (e) {
                    if (e.target.closest("a,button") && (e.type === "click" || e.keyCode === keyMap.SPACE)) {
                        e.preventDefault();
                        this.show(data(e.current, this.attrItem));
                    }
                }
            },
            {
                name: "itemshow",
                handler: "updateNav"
            },
            {
                name: "keydown",
                delegate: ({ selNavItem: selNavItem })=>selNavItem,
                filter: ({ parallax: parallax })=>!parallax,
                handler (e) {
                    const { current: current, keyCode: keyCode } = e;
                    const cmd = data(current, this.attrItem);
                    if (!isNumeric(cmd)) return;
                    let i = keyCode === keyMap.HOME ? 0 : keyCode === keyMap.END ? "last" : keyCode === keyMap.LEFT ? "previous" : keyCode === keyMap.RIGHT ? "next" : -1;
                    if (~i) {
                        e.preventDefault();
                        this.show(i);
                    }
                }
            }
        ],
        methods: {
            updateNav () {
                const index = this.getValidIndex();
                for (const el of this.navItems){
                    const cmd = data(el, this.attrItem);
                    const button = $("a,button", el) || el;
                    if (isNumeric(cmd)) {
                        const item = toNumber(cmd);
                        const active = item === index;
                        toggleClass(el, this.clsActive, active);
                        toggleClass(button, "uk-disabled", this.parallax);
                        attr(button, {
                            "aria-selected": active,
                            tabindex: active && !this.parallax ? null : -1
                        });
                        if (active && button && matches(parent(el), ":focus-within")) button.focus();
                    } else toggleClass(el, "uk-invisible", this.finite && (cmd === "previous" && index === 0 || cmd === "next" && index >= this.maxIndex));
                }
            },
            padNavitems () {
                if (!this.nav) return;
                const children2 = [];
                for(let i = 0; i < this.length; i++){
                    const attr2 = `${this.attrItem}="${i}"`;
                    children2[i] = this.navChildren.findLast((el)=>el.matches(`[${attr2}]`)) || $(`<li ${attr2}><a href></a></li>`);
                }
                if (!isEqual(children2, this.navChildren)) html(this.nav, children2);
            }
        }
    };
    const easeOutQuad = "cubic-bezier(0.25, 0.46, 0.45, 0.94)";
    const easeOutQuart = "cubic-bezier(0.165, 0.84, 0.44, 1)";
    var Slider = {
        mixins: [
            SliderAutoplay,
            SliderDrag,
            SliderNav,
            I18n
        ],
        props: {
            clsActivated: String,
            easing: String,
            index: Number,
            finite: Boolean,
            velocity: Number
        },
        data: ()=>({
                easing: "ease",
                finite: false,
                velocity: 1,
                index: 0,
                prevIndex: -1,
                stack: [],
                percent: 0,
                clsActive: "uk-active",
                clsActivated: "",
                clsEnter: "uk-slide-enter",
                clsLeave: "uk-slide-leave",
                clsSlideActive: "uk-slide-active",
                Transitioner: false,
                transitionOptions: {}
            }),
        connected () {
            this.prevIndex = -1;
            this.index = this.getValidIndex(this.$props.index);
            this.stack = [];
        },
        disconnected () {
            removeClass(this.slides, this.clsActive);
        },
        computed: {
            duration: ({ velocity: velocity }, $el)=>speedUp($el.offsetWidth / velocity),
            list: ({ selList: selList }, $el)=>$(selList, $el),
            maxIndex () {
                return this.length - 1;
            },
            slides () {
                return children(this.list);
            },
            length () {
                return this.slides.length;
            }
        },
        watch: {
            slides (slides, prev) {
                if (prev) this.$emit();
            }
        },
        events: {
            itemshow ({ target: target }) {
                addClass(target, this.clsEnter, this.clsSlideActive);
            },
            itemshown ({ target: target }) {
                removeClass(target, this.clsEnter);
            },
            itemhide ({ target: target }) {
                addClass(target, this.clsLeave);
            },
            itemhidden ({ target: target }) {
                removeClass(target, this.clsLeave, this.clsSlideActive);
            }
        },
        methods: {
            show (index, force = false) {
                var _a;
                if (this.dragging || !this.length || this.parallax) return;
                const { stack: stack } = this;
                const queueIndex = force ? 0 : stack.length;
                const reset = ()=>{
                    stack.splice(queueIndex, 1);
                    if (stack.length) this.show(stack.shift(), true);
                };
                stack[force ? "unshift" : "push"](index);
                if (!force && stack.length > 1) {
                    if (stack.length === 2) (_a = this._transitioner) == null || _a.forward(Math.min(this.duration, 200));
                    return;
                }
                const prevIndex = this.getIndex(this.index);
                const prev = hasClass(this.slides, this.clsActive) && this.slides[prevIndex];
                const nextIndex = this.getIndex(index, this.index);
                const next = this.slides[nextIndex];
                if (prev === next) {
                    reset();
                    return;
                }
                this.dir = getDirection(index, prevIndex);
                this.prevIndex = prevIndex;
                this.index = nextIndex;
                if (prev && !trigger(prev, "beforeitemhide", [
                    this
                ]) || !trigger(next, "beforeitemshow", [
                    this,
                    prev
                ])) {
                    this.index = this.prevIndex;
                    reset();
                    return;
                }
                const promise = this._show(prev, next, force).then(()=>{
                    prev && trigger(prev, "itemhidden", [
                        this
                    ]);
                    trigger(next, "itemshown", [
                        this
                    ]);
                    stack.shift();
                    this._transitioner = null;
                    if (stack.length) requestAnimationFrame(()=>stack.length && this.show(stack.shift(), true));
                });
                prev && trigger(prev, "itemhide", [
                    this
                ]);
                trigger(next, "itemshow", [
                    this
                ]);
                return promise;
            },
            getIndex (index = this.index, prev = this.index) {
                return clamp(getIndex(index, this.slides, prev, this.finite), 0, Math.max(0, this.maxIndex));
            },
            getValidIndex (index = this.index, prevIndex = this.prevIndex) {
                return this.getIndex(index, prevIndex);
            },
            async _show (prev, next, force) {
                this._transitioner = this._getTransitioner(prev, next, this.dir, {
                    easing: force ? next.offsetWidth < 600 ? easeOutQuad : easeOutQuart : this.easing,
                    ...this.transitionOptions
                });
                if (!force && !prev) {
                    this._translate(1);
                    return;
                }
                const { length: length } = this.stack;
                return this._transitioner[length > 1 ? "forward" : "show"](length > 1 ? Math.min(this.duration, 75 + 75 / (length - 1)) : this.duration, this.percent);
            },
            _translate (percent, prev = this.prevIndex, next = this.index) {
                const transitioner = this._getTransitioner(prev === next ? false : prev, next);
                transitioner.translate(percent);
                return transitioner;
            },
            _getTransitioner (prev = this.prevIndex, next = this.index, dir = this.dir || 1, options = this.transitionOptions) {
                return new this.Transitioner(isNumber(prev) ? this.slides[prev] : prev, isNumber(next) ? this.slides[next] : next, dir * (isRtl ? -1 : 1), options);
            }
        }
    };
    function getDirection(index, prevIndex) {
        return index === "next" ? 1 : index === "previous" ? -1 : index < prevIndex ? -1 : 1;
    }
    function speedUp(x) {
        return 0.5 * x + 300;
    }
    var Slideshow = {
        mixins: [
            Slider
        ],
        props: {
            animation: String
        },
        data: {
            animation: "slide",
            clsActivated: "uk-transition-active",
            Animations: Animations$2,
            Transitioner: Transitioner$1
        },
        computed: {
            animation ({ animation: animation, Animations: Animations2 }) {
                return {
                    ...Animations2[animation] || Animations2.slide,
                    name: animation
                };
            },
            transitionOptions () {
                return {
                    animation: this.animation
                };
            }
        },
        observe: resize(),
        events: {
            beforeitemshow ({ target: target }) {
                addClass(target, this.clsActive);
            },
            itemshown ({ target: target }) {
                addClass(target, this.clsActivated);
            },
            itemhidden ({ target: target }) {
                removeClass(target, this.clsActive, this.clsActivated);
            }
        }
    };
    var Animations$1 = {
        ...Animations$2,
        fade: {
            show () {
                return [
                    {
                        opacity: 0
                    },
                    {
                        opacity: 1
                    }
                ];
            },
            percent (current) {
                return 1 - css(current, "opacity");
            },
            translate (percent) {
                return [
                    {
                        opacity: 1 - percent
                    },
                    {
                        opacity: percent
                    }
                ];
            }
        },
        scale: {
            show () {
                return [
                    {
                        opacity: 0,
                        transform: scale3d(0.8)
                    },
                    {
                        opacity: 1,
                        transform: scale3d(1)
                    }
                ];
            },
            percent (current) {
                return 1 - css(current, "opacity");
            },
            translate (percent) {
                return [
                    {
                        opacity: 1 - percent,
                        transform: scale3d(1 - 0.2 * percent)
                    },
                    {
                        opacity: percent,
                        transform: scale3d(0.8 + 0.2 * percent)
                    }
                ];
            }
        }
    };
    var LightboxPanel = {
        mixins: [
            Modal,
            Slideshow
        ],
        functional: true,
        props: {
            delayControls: Number,
            preload: Number,
            videoAutoplay: Boolean,
            template: String
        },
        data: ()=>({
                preload: 1,
                videoAutoplay: false,
                delayControls: 3e3,
                items: [],
                cls: "uk-open",
                clsPage: "uk-lightbox-page",
                selList: ".uk-lightbox-items",
                attrItem: "uk-lightbox-item",
                selClose: ".uk-close-large",
                selCaption: ".uk-lightbox-caption",
                pauseOnHover: false,
                velocity: 2,
                Animations: Animations$1,
                template: `<div class="uk-lightbox uk-overflow-hidden"> <div class="uk-lightbox-items"></div> <div class="uk-lightbox-toolbar uk-position-top uk-text-right uk-transition-slide-top uk-transition-opaque"> <button class="uk-lightbox-toolbar-icon uk-close-large" type="button" uk-close></button> </div> <a class="uk-lightbox-button uk-position-center-left uk-position-medium uk-transition-fade" href uk-slidenav-previous uk-lightbox-item="previous"></a> <a class="uk-lightbox-button uk-position-center-right uk-position-medium uk-transition-fade" href uk-slidenav-next uk-lightbox-item="next"></a> <div class="uk-lightbox-toolbar uk-lightbox-caption uk-position-bottom uk-text-center uk-transition-slide-bottom uk-transition-opaque"></div> </div>`
            }),
        created () {
            const $el = $(this.template);
            const list = $(this.selList, $el);
            this.items.forEach(()=>append(list, "<div>"));
            const close = $("[uk-close]", $el);
            const closeLabel = this.t("close");
            if (close && closeLabel) close.dataset.i18n = JSON.stringify({
                label: closeLabel
            });
            this.$mount(append(this.container, $el));
        },
        events: [
            {
                name: `${pointerMove$1} ${pointerDown$1} keydown`,
                handler: "showControls"
            },
            {
                name: "click",
                self: true,
                delegate: ({ selList: selList })=>`${selList} > *`,
                handler (e) {
                    if (!e.defaultPrevented) this.hide();
                }
            },
            {
                name: "shown",
                self: true,
                handler: "showControls"
            },
            {
                name: "hide",
                self: true,
                handler () {
                    this.hideControls();
                    removeClass(this.slides, this.clsActive);
                    Transition.stop(this.slides);
                }
            },
            {
                name: "hidden",
                self: true,
                handler () {
                    this.$destroy(true);
                }
            },
            {
                name: "keyup",
                el: ()=>document,
                handler ({ keyCode: keyCode }) {
                    if (!this.isToggled(this.$el) || !this.draggable) return;
                    let i = -1;
                    if (keyCode === keyMap.LEFT) i = "previous";
                    else if (keyCode === keyMap.RIGHT) i = "next";
                    else if (keyCode === keyMap.HOME) i = 0;
                    else if (keyCode === keyMap.END) i = "last";
                    if (~i) this.show(i);
                }
            },
            {
                name: "beforeitemshow",
                handler (e) {
                    if (this.isToggled()) return;
                    this.draggable = false;
                    e.preventDefault();
                    this.toggleElement(this.$el, true, false);
                    this.animation = Animations$1["scale"];
                    removeClass(e.target, this.clsActive);
                    this.stack.splice(1, 0, this.index);
                }
            },
            {
                name: "itemshow",
                handler () {
                    html($(this.selCaption, this.$el), this.getItem().caption || "");
                    for(let j = -this.preload; j <= this.preload; j++)this.loadItem(this.index + j);
                }
            },
            {
                name: "itemshown",
                handler () {
                    this.draggable = this.$props.draggable;
                }
            },
            {
                name: "itemload",
                async handler (_, item) {
                    const { source: src, type: type, alt: alt = "", poster: poster, attrs: attrs = {} } = item;
                    this.setItem(item, "<span uk-spinner></span>");
                    if (!src) return;
                    let matches;
                    const iframeAttrs = {
                        allowfullscreen: "",
                        style: "max-width: 100%; box-sizing: border-box;",
                        "uk-responsive": "",
                        "uk-video": `${this.videoAutoplay}`
                    };
                    if (type === "image" || src.match(/\.(avif|jpe?g|jfif|a?png|gif|svg|webp)($|\?)/i)) {
                        const img = createEl("img", {
                            src: src,
                            alt: alt,
                            ...attrs
                        });
                        on(img, "load", ()=>this.setItem(item, img));
                        on(img, "error", ()=>this.setError(item));
                    } else if (type === "video" || src.match(/\.(mp4|webm|ogv)($|\?)/i)) {
                        const video = createEl("video", {
                            src: src,
                            poster: poster,
                            controls: "",
                            playsinline: "",
                            "uk-video": `${this.videoAutoplay}`,
                            ...attrs
                        });
                        on(video, "loadedmetadata", ()=>this.setItem(item, video));
                        on(video, "error", ()=>this.setError(item));
                    } else if (type === "iframe" || src.match(/\.(html|php)($|\?)/i)) this.setItem(item, createEl("iframe", {
                        src: src,
                        allowfullscreen: "",
                        class: "uk-lightbox-iframe",
                        ...attrs
                    }));
                    else if (matches = src.match(/\/\/(?:.*?youtube(-nocookie)?\..*?(?:[?&]v=|\/shorts\/)|youtu\.be\/)([\w-]{11})[&?]?(.*)?/)) this.setItem(item, createEl("iframe", {
                        src: `https://www.youtube${matches[1] || ""}.com/embed/${matches[2]}${matches[3] ? `?${matches[3]}` : ""}`,
                        width: 1920,
                        height: 1080,
                        ...iframeAttrs,
                        ...attrs
                    }));
                    else if (matches = src.match(/\/\/.*?vimeo\.[a-z]+\/(\d+)[&?]?(.*)?/)) try {
                        const { height: height, width: width } = await (await fetch(`https://vimeo.com/api/oembed.json?maxwidth=1920&url=${encodeURI(src)}`, {
                            credentials: "omit"
                        })).json();
                        this.setItem(item, createEl("iframe", {
                            src: `https://player.vimeo.com/video/${matches[1]}${matches[2] ? `?${matches[2]}` : ""}`,
                            width: width,
                            height: height,
                            ...iframeAttrs,
                            ...attrs
                        }));
                    } catch (e) {
                        this.setError(item);
                    }
                }
            }
        ],
        methods: {
            loadItem (index = this.index) {
                const item = this.getItem(index);
                if (!this.getSlide(item).childElementCount) trigger(this.$el, "itemload", [
                    item
                ]);
            },
            getItem (index = this.index) {
                return this.items[getIndex(index, this.slides)];
            },
            setItem (item, content) {
                trigger(this.$el, "itemloaded", [
                    this,
                    html(this.getSlide(item), content)
                ]);
            },
            getSlide (item) {
                return this.slides[this.items.indexOf(item)];
            },
            setError (item) {
                this.setItem(item, '<span uk-icon="icon: bolt; ratio: 2"></span>');
            },
            showControls () {
                clearTimeout(this.controlsTimer);
                this.controlsTimer = setTimeout(this.hideControls, this.delayControls);
                addClass(this.$el, "uk-active", "uk-transition-active");
            },
            hideControls () {
                removeClass(this.$el, "uk-active", "uk-transition-active");
            }
        }
    };
    function createEl(tag, attrs) {
        const el = fragment(`<${tag}>`);
        attr(el, attrs);
        return el;
    }
    var lightbox = {
        install: install$3,
        props: {
            toggle: String
        },
        data: {
            toggle: "a"
        },
        computed: {
            toggles: ({ toggle: toggle }, $el)=>$$(toggle, $el)
        },
        watch: {
            toggles (toggles) {
                this.hide();
                for (const toggle of toggles)if (isTag(toggle, "a")) attr(toggle, "role", "button");
            }
        },
        disconnected () {
            this.hide();
        },
        events: {
            name: "click",
            delegate: ({ toggle: toggle })=>`${toggle}:not(.uk-disabled)`,
            handler (e) {
                if (!e.defaultPrevented) {
                    e.preventDefault();
                    this.show(e.current);
                }
            }
        },
        methods: {
            show (index) {
                const items = uniqueBy(this.toggles.map(toItem), "source");
                if (isElement(index)) {
                    const { source: source } = toItem(index);
                    index = findIndex(items, ({ source: src })=>source === src);
                }
                this.panel = this.panel || this.$create("lightboxPanel", {
                    ...this.$props,
                    items: items
                });
                on(this.panel.$el, "hidden", ()=>this.panel = null);
                return this.panel.show(index);
            },
            hide () {
                var _a;
                return (_a = this.panel) == null ? void 0 : _a.hide();
            }
        }
    };
    function install$3(UIkit, Lightbox) {
        if (!UIkit.lightboxPanel) UIkit.component("lightboxPanel", LightboxPanel);
        assign(Lightbox.props, UIkit.component("lightboxPanel").options.props);
    }
    function toItem(el) {
        const item = {};
        for (const attr2 of [
            "href",
            "caption",
            "type",
            "poster",
            "alt",
            "attrs"
        ])item[attr2 === "href" ? "source" : attr2] = data(el, attr2);
        item.attrs = parseOptions(item.attrs);
        return item;
    }
    var notification = {
        mixins: [
            Container
        ],
        functional: true,
        args: [
            "message",
            "status"
        ],
        data: {
            message: "",
            status: "",
            timeout: 5e3,
            group: "",
            pos: "top-center",
            clsContainer: "uk-notification",
            clsClose: "uk-notification-close",
            clsMsg: "uk-notification-message"
        },
        install: install$2,
        computed: {
            marginProp: ({ pos: pos })=>`margin-${pos.match(/[a-z]+(?=-)/)[0]}`,
            startProps () {
                return {
                    opacity: 0,
                    [this.marginProp]: -this.$el.offsetHeight
                };
            }
        },
        created () {
            const posClass = `${this.clsContainer}-${this.pos}`;
            const containerAttr = `data-${this.clsContainer}-container`;
            const container = $(`.${posClass}[${containerAttr}]`, this.container) || append(this.container, `<div class="${this.clsContainer} ${posClass}" ${containerAttr}></div>`);
            this.$mount(append(container, `<div class="${this.clsMsg}${this.status ? ` ${this.clsMsg}-${this.status}` : ""}" role="alert"> <a href class="${this.clsClose}" data-uk-close></a> <div>${this.message}</div> </div>`));
        },
        async connected () {
            const margin = toFloat(css(this.$el, this.marginProp));
            await Transition.start(css(this.$el, this.startProps), {
                opacity: 1,
                [this.marginProp]: margin
            });
            if (this.timeout) this.timer = setTimeout(this.close, this.timeout);
        },
        events: {
            click (e) {
                if (e.target.closest('a[href="#"],a[href=""]')) e.preventDefault();
                this.close();
            },
            [pointerEnter] () {
                if (this.timer) clearTimeout(this.timer);
            },
            [pointerLeave] () {
                if (this.timeout) this.timer = setTimeout(this.close, this.timeout);
            }
        },
        methods: {
            async close (immediate) {
                const removeFn = (el)=>{
                    const container = parent(el);
                    trigger(el, "close", [
                        this
                    ]);
                    remove$1(el);
                    if (!(container == null ? void 0 : container.hasChildNodes())) remove$1(container);
                };
                if (this.timer) clearTimeout(this.timer);
                if (!immediate) await Transition.start(this.$el, this.startProps);
                removeFn(this.$el);
            }
        }
    };
    function install$2(UIkit) {
        UIkit.notification.closeAll = function(group, immediate) {
            apply(document.body, (el)=>{
                const notification = UIkit.getComponent(el, "notification");
                if (notification && (!group || group === notification.group)) notification.close(immediate);
            });
        };
    }
    var Media = {
        props: {
            media: Boolean
        },
        data: {
            media: false
        },
        connected () {
            const media = toMedia(this.media, this.$el);
            this.matchMedia = true;
            if (media) {
                this.mediaObj = window.matchMedia(media);
                const handler = ()=>{
                    this.matchMedia = this.mediaObj.matches;
                    trigger(this.$el, createEvent("mediachange", false, true, [
                        this.mediaObj
                    ]));
                };
                this.offMediaObj = on(this.mediaObj, "change", ()=>{
                    handler();
                    this.$emit("resize");
                });
                handler();
            }
        },
        disconnected () {
            var _a;
            (_a = this.offMediaObj) == null || _a.call(this);
        }
    };
    function toMedia(value, element) {
        if (isString(value)) {
            if (startsWith(value, "@")) value = toFloat(css(element, `--uk-breakpoint-${value.slice(1)}`));
            else if (isNaN(value)) return value;
        }
        return value && isNumeric(value) ? `(min-width: ${value}px)` : "";
    }
    function getMaxPathLength(el) {
        return isVisible(el) ? Math.ceil(Math.max(0, ...$$("[stroke]", el).map((stroke)=>{
            var _a;
            return ((_a = stroke.getTotalLength) == null ? void 0 : _a.call(stroke)) || 0;
        }))) : 0;
    }
    const props = {
        x: transformFn,
        y: transformFn,
        rotate: transformFn,
        scale: transformFn,
        color: colorFn,
        backgroundColor: colorFn,
        borderColor: colorFn,
        blur: filterFn,
        hue: filterFn,
        fopacity: filterFn,
        grayscale: filterFn,
        invert: filterFn,
        saturate: filterFn,
        sepia: filterFn,
        opacity: cssPropFn,
        stroke: strokeFn,
        bgx: backgroundFn,
        bgy: backgroundFn
    };
    const { keys: keys } = Object;
    var Parallax = {
        mixins: [
            Media
        ],
        props: fillObject(keys(props), "list"),
        data: fillObject(keys(props), void 0),
        computed: {
            props (properties, $el) {
                const stops = {};
                for(const prop in properties)if (prop in props && !isUndefined(properties[prop])) stops[prop] = properties[prop].slice();
                const result = {};
                for(const prop in stops)result[prop] = props[prop](prop, $el, stops[prop], stops);
                return result;
            }
        },
        events: {
            load () {
                this.$emit();
            }
        },
        methods: {
            reset () {
                for(const prop in this.getCss(0))css(this.$el, prop, "");
            },
            getCss (percent) {
                const css2 = {};
                for(const prop in this.props)this.props[prop](css2, clamp(percent));
                css2.willChange = Object.keys(css2).map(propName).join(",");
                return css2;
            }
        }
    };
    function transformFn(prop, el, stops) {
        let unit = getUnit(stops) || ({
            x: "px",
            y: "px",
            rotate: "deg"
        })[prop] || "";
        let transformFn2;
        if (prop === "x" || prop === "y") {
            prop = `translate${ucfirst(prop)}`;
            transformFn2 = (stop)=>toFloat(toFloat(stop).toFixed(unit === "px" ? 0 : 6));
        } else if (prop === "scale") {
            unit = "";
            transformFn2 = (stop)=>{
                var _a;
                return getUnit([
                    stop
                ]) ? toPx(stop, "width", el, true) / el[`offset${((_a = stop.endsWith) == null ? void 0 : _a.call(stop, "vh")) ? "Height" : "Width"}`] : toFloat(stop);
            };
        }
        if (stops.length === 1) stops.unshift(prop === "scale" ? 1 : 0);
        stops = parseStops(stops, transformFn2);
        return (css2, percent)=>{
            css2.transform = `${css2.transform || ""} ${prop}(${getValue(stops, percent)}${unit})`;
        };
    }
    function colorFn(prop, el, stops) {
        if (stops.length === 1) stops.unshift(getCssValue(el, prop, ""));
        stops = parseStops(stops, (stop)=>parseColor(el, stop));
        return (css2, percent)=>{
            const [start, end, p] = getStop(stops, percent);
            const value = start.map((value2, i)=>{
                value2 += p * (end[i] - value2);
                return i === 3 ? toFloat(value2) : parseInt(value2, 10);
            }).join(",");
            css2[prop] = `rgba(${value})`;
        };
    }
    function parseColor(el, color) {
        return getCssValue(el, "color", color).split(/[(),]/g).slice(1, -1).concat(1).slice(0, 4).map(toFloat);
    }
    function filterFn(prop, el, stops) {
        if (stops.length === 1) stops.unshift(0);
        const unit = getUnit(stops) || ({
            blur: "px",
            hue: "deg"
        })[prop] || "%";
        prop = ({
            fopacity: "opacity",
            hue: "hue-rotate"
        })[prop] || prop;
        stops = parseStops(stops);
        return (css2, percent)=>{
            const value = getValue(stops, percent);
            css2.filter = `${css2.filter || ""} ${prop}(${value + unit})`;
        };
    }
    function cssPropFn(prop, el, stops) {
        if (stops.length === 1) stops.unshift(getCssValue(el, prop, ""));
        stops = parseStops(stops);
        return (css2, percent)=>{
            css2[prop] = getValue(stops, percent);
        };
    }
    function strokeFn(prop, el, stops) {
        if (stops.length === 1) stops.unshift(0);
        const unit = getUnit(stops);
        const length = getMaxPathLength(el);
        stops = parseStops(stops.reverse(), (stop)=>{
            stop = toFloat(stop);
            return unit === "%" ? stop * length / 100 : stop;
        });
        if (!stops.some(([value])=>value)) return noop;
        css(el, "strokeDasharray", length);
        return (css2, percent)=>{
            css2.strokeDashoffset = getValue(stops, percent);
        };
    }
    function backgroundFn(prop, el, stops, props2) {
        if (stops.length === 1) stops.unshift(0);
        const attr = prop === "bgy" ? "height" : "width";
        props2[prop] = parseStops(stops, (stop)=>toPx(stop, attr, el));
        const bgProps = [
            "bgx",
            "bgy"
        ].filter((prop2)=>prop2 in props2);
        if (bgProps.length === 2 && prop === "bgx") return noop;
        if (getCssValue(el, "backgroundSize", "") === "cover") return backgroundCoverFn(prop, el, stops, props2);
        const positions = {};
        for (const prop2 of bgProps)positions[prop2] = getBackgroundPos(el, prop2);
        return setBackgroundPosFn(bgProps, positions, props2);
    }
    function backgroundCoverFn(prop, el, stops, props2) {
        const dimImage = getBackgroundImageDimensions(el);
        if (!dimImage.width) return noop;
        const dimEl = {
            width: el.offsetWidth,
            height: el.offsetHeight
        };
        const bgProps = [
            "bgx",
            "bgy"
        ].filter((prop2)=>prop2 in props2);
        const positions = {};
        for (const prop2 of bgProps){
            const values = props2[prop2].map(([value])=>value);
            const min = Math.min(...values);
            const max = Math.max(...values);
            const down = values.indexOf(min) < values.indexOf(max);
            const diff = max - min;
            positions[prop2] = `${(down ? -diff : 0) - (down ? min : max)}px`;
            dimEl[prop2 === "bgy" ? "height" : "width"] += diff;
        }
        const dim = Dimensions.cover(dimImage, dimEl);
        for (const prop2 of bgProps){
            const attr = prop2 === "bgy" ? "height" : "width";
            const overflow = dim[attr] - dimEl[attr];
            positions[prop2] = `max(${getBackgroundPos(el, prop2)},-${overflow}px) + ${positions[prop2]}`;
        }
        const fn = setBackgroundPosFn(bgProps, positions, props2);
        return (css2, percent)=>{
            fn(css2, percent);
            css2.backgroundSize = `${dim.width}px ${dim.height}px`;
            css2.backgroundRepeat = "no-repeat";
        };
    }
    function getBackgroundPos(el, prop) {
        return getCssValue(el, `background-position-${prop.slice(-1)}`, "");
    }
    function setBackgroundPosFn(bgProps, positions, props2) {
        return function(css2, percent) {
            for (const prop of bgProps){
                const value = getValue(props2[prop], percent);
                css2[`background-position-${prop.slice(-1)}`] = `calc(${positions[prop]} + ${value}px)`;
            }
        };
    }
    const loading = {};
    const dimensions = {};
    function getBackgroundImageDimensions(el) {
        const src = css(el, "backgroundImage").replace(/^none|url\(["']?(.+?)["']?\)$/, "$1");
        if (dimensions[src]) return dimensions[src];
        const image = new Image();
        if (src) {
            image.src = src;
            if (!image.naturalWidth && !loading[src]) {
                once(image, "error load", ()=>{
                    dimensions[src] = toDimensions(image);
                    trigger(el, createEvent("load", false));
                });
                loading[src] = true;
                return toDimensions(image);
            }
        }
        return dimensions[src] = toDimensions(image);
    }
    function toDimensions(image) {
        return {
            width: image.naturalWidth,
            height: image.naturalHeight
        };
    }
    function parseStops(stops, fn = toFloat) {
        const result = [];
        const { length: length } = stops;
        let nullIndex = 0;
        for(let i = 0; i < length; i++){
            let [value, percent] = isString(stops[i]) ? stops[i].trim().split(/ (?![^(]*\))/) : [
                stops[i]
            ];
            value = fn(value);
            percent = percent ? toFloat(percent) / 100 : null;
            if (i === 0) {
                if (percent === null) percent = 0;
                else if (percent) result.push([
                    value,
                    0
                ]);
            } else if (i === length - 1) {
                if (percent === null) percent = 1;
                else if (percent !== 1) {
                    result.push([
                        value,
                        percent
                    ]);
                    percent = 1;
                }
            }
            result.push([
                value,
                percent
            ]);
            if (percent === null) nullIndex++;
            else if (nullIndex) {
                const leftPercent = result[i - nullIndex - 1][1];
                const p = (percent - leftPercent) / (nullIndex + 1);
                for(let j = nullIndex; j > 0; j--)result[i - j][1] = leftPercent + p * (nullIndex - j + 1);
                nullIndex = 0;
            }
        }
        return result;
    }
    function getStop(stops, percent) {
        const index = findIndex(stops.slice(1), ([, targetPercent])=>percent <= targetPercent) + 1;
        return [
            stops[index - 1][0],
            stops[index][0],
            (percent - stops[index - 1][1]) / (stops[index][1] - stops[index - 1][1])
        ];
    }
    function getValue(stops, percent) {
        const [start, end, p] = getStop(stops, percent);
        return start + Math.abs(start - end) * p * (start < end ? 1 : -1);
    }
    const unitRe = /^-?\d+(?:\.\d+)?(\S+)?/;
    function getUnit(stops, defaultUnit) {
        var _a;
        for (const stop of stops){
            const match = (_a = stop.match) == null ? void 0 : _a.call(stop, unitRe);
            if (match) return match[1];
        }
        return defaultUnit;
    }
    function getCssValue(el, prop, value) {
        const prev = el.style[prop];
        const val = css(css(el, prop, value), prop);
        el.style[prop] = prev;
        return val;
    }
    function fillObject(keys2, value) {
        return keys2.reduce((data, prop)=>{
            data[prop] = value;
            return data;
        }, {});
    }
    function ease(percent, easing) {
        return easing >= 0 ? Math.pow(percent, easing + 1) : 1 - Math.pow(1 - percent, 1 - easing);
    }
    var parallax = {
        mixins: [
            Parallax
        ],
        props: {
            target: String,
            viewport: Number,
            // Deprecated
            easing: Number,
            start: String,
            end: String
        },
        data: {
            target: false,
            viewport: 1,
            easing: 1,
            start: 0,
            end: 0
        },
        computed: {
            target: ({ target: target }, $el)=>getOffsetElement(target && query(target, $el) || $el),
            start ({ start: start }) {
                return toPx(start, "height", this.target, true);
            },
            end ({ end: end, viewport: viewport2 }) {
                return toPx(end || (viewport2 = (1 - viewport2) * 100) && `${viewport2}vh+${viewport2}%`, "height", this.target, true);
            }
        },
        observe: [
            viewport(),
            scroll$1({
                target: ({ target: target })=>target
            }),
            resize({
                target: ({ $el: $el, target: target })=>[
                        $el,
                        target,
                        scrollParent(target, true)
                    ]
            })
        ],
        update: {
            read ({ percent: percent }, types) {
                if (!types.has("scroll")) percent = false;
                if (!isVisible(this.$el)) return false;
                if (!this.matchMedia) return;
                const prev = percent;
                percent = ease(scrolledOver(this.target, this.start, this.end), this.easing);
                return {
                    percent: percent,
                    style: prev === percent ? false : this.getCss(percent)
                };
            },
            write ({ style: style }) {
                if (!this.matchMedia) {
                    this.reset();
                    return;
                }
                style && css(this.$el, style);
            },
            events: [
                "scroll",
                "resize"
            ]
        }
    };
    function getOffsetElement(el) {
        return el ? "offsetTop" in el ? el : getOffsetElement(parent(el)) : document.documentElement;
    }
    var SliderParallax = {
        props: {
            parallax: Boolean,
            parallaxTarget: Boolean,
            parallaxStart: String,
            parallaxEnd: String,
            parallaxEasing: Number
        },
        data: {
            parallax: false,
            parallaxTarget: false,
            parallaxStart: 0,
            parallaxEnd: 0,
            parallaxEasing: 0
        },
        observe: [
            resize({
                target: ({ $el: $el, parallaxTarget: parallaxTarget })=>[
                        $el,
                        parallaxTarget
                    ],
                filter: ({ parallax: parallax })=>parallax
            }),
            scroll$1({
                filter: ({ parallax: parallax })=>parallax
            })
        ],
        computed: {
            parallaxTarget ({ parallaxTarget: parallaxTarget }, $el) {
                return parallaxTarget && query(parallaxTarget, $el) || this.list;
            }
        },
        update: {
            read () {
                if (!this.parallax) return false;
                const target = this.parallaxTarget;
                if (!target) return false;
                const start = toPx(this.parallaxStart, "height", target, true);
                const end = toPx(this.parallaxEnd, "height", target, true);
                const percent = ease(scrolledOver(target, start, end), this.parallaxEasing);
                return {
                    parallax: this.getIndexAt(percent)
                };
            },
            write ({ parallax: parallax }) {
                const [prevIndex, slidePercent] = parallax;
                const nextIndex = this.getValidIndex(prevIndex + Math.ceil(slidePercent));
                const prev = this.slides[prevIndex];
                const next = this.slides[nextIndex];
                const { triggerShow: triggerShow, triggerShown: triggerShown, triggerHide: triggerHide, triggerHidden: triggerHidden } = useTriggers(this);
                if (~this.prevIndex) {
                    for (const i of new Set([
                        this.index,
                        this.prevIndex
                    ]))if (!includes([
                        nextIndex,
                        prevIndex
                    ], i)) {
                        triggerHide(this.slides[i]);
                        triggerHidden(this.slides[i]);
                    }
                }
                const changed = this.prevIndex !== prevIndex || this.index !== nextIndex;
                this.dir = 1;
                this.prevIndex = prevIndex;
                this.index = nextIndex;
                if (prev !== next) triggerHide(prev);
                triggerShow(next);
                if (changed) triggerShown(prev);
                this._translate(prev === next ? 1 : slidePercent, prev, next);
            },
            events: [
                "scroll",
                "resize"
            ]
        },
        methods: {
            getIndexAt (percent) {
                const index = percent * (this.length - 1);
                return [
                    Math.floor(index),
                    index % 1
                ];
            }
        }
    };
    function useTriggers(cmp) {
        const { clsSlideActive: clsSlideActive, clsEnter: clsEnter, clsLeave: clsLeave } = cmp;
        return {
            triggerShow: triggerShow,
            triggerShown: triggerShown,
            triggerHide: triggerHide,
            triggerHidden: triggerHidden
        };
        function triggerShow(el) {
            if (hasClass(el, clsLeave)) {
                triggerHide(el);
                triggerHidden(el);
            }
            if (!hasClass(el, clsSlideActive)) {
                trigger(el, "beforeitemshow", [
                    cmp
                ]);
                trigger(el, "itemshow", [
                    cmp
                ]);
            }
        }
        function triggerShown(el) {
            if (hasClass(el, clsEnter)) trigger(el, "itemshown", [
                cmp
            ]);
        }
        function triggerHide(el) {
            if (!hasClass(el, clsSlideActive)) triggerShow(el);
            if (hasClass(el, clsEnter)) triggerShown(el);
            if (!hasClass(el, clsLeave)) {
                trigger(el, "beforeitemhide", [
                    cmp
                ]);
                trigger(el, "itemhide", [
                    cmp
                ]);
            }
        }
        function triggerHidden(el) {
            if (hasClass(el, clsLeave)) trigger(el, "itemhidden", [
                cmp
            ]);
        }
    }
    var SliderReactive = {
        update: {
            write () {
                if (this.stack.length || this.dragging || this.parallax) return;
                const index = this.getValidIndex();
                if (!~this.prevIndex || this.index !== index) this.show(index);
                else this._translate(1);
            },
            events: [
                "resize"
            ]
        }
    };
    var SliderPreload = {
        observe: lazyload({
            target: ({ slides: slides })=>slides,
            targets: (instance)=>instance.getAdjacentSlides()
        }),
        methods: {
            getAdjacentSlides () {
                return [
                    1,
                    -1
                ].map((i)=>this.slides[this.getIndex(this.index + i)]);
            }
        }
    };
    function Transitioner(prev, next, dir, { center: center, easing: easing, list: list }) {
        const from = prev ? getLeft(prev, list, center) : getLeft(next, list, center) + dimensions$1(next).width * dir;
        const to = next ? getLeft(next, list, center) : from + dimensions$1(prev).width * dir * (isRtl ? -1 : 1);
        const { promise: promise, resolve: resolve } = withResolvers();
        return {
            dir: dir,
            show (duration, percent = 0, linear) {
                const timing = linear ? "linear" : easing;
                duration -= Math.round(duration * clamp(percent, -1, 1));
                css(list, "transitionProperty", "none");
                this.translate(percent);
                css(list, "transitionProperty", "");
                percent = prev ? percent : clamp(percent, 0, 1);
                triggerUpdate(this.getItemIn(), "itemin", {
                    percent: percent,
                    duration: duration,
                    timing: timing,
                    dir: dir
                });
                prev && triggerUpdate(this.getItemIn(true), "itemout", {
                    percent: 1 - percent,
                    duration: duration,
                    timing: timing,
                    dir: dir
                });
                Transition.start(list, {
                    transform: translate(-to * (isRtl ? -1 : 1), "px")
                }, duration, timing).then(resolve, noop);
                return promise;
            },
            cancel () {
                return Transition.cancel(list);
            },
            reset () {
                css(list, "transform", "");
            },
            async forward (duration, percent = this.percent()) {
                await this.cancel();
                return this.show(duration, percent, true);
            },
            translate (percent) {
                if (percent === this.percent()) return;
                const distance = this.getDistance() * dir * (isRtl ? -1 : 1);
                css(list, "transform", translate(clamp(-to + (distance - distance * percent), -getWidth(list), dimensions$1(list).width) * (isRtl ? -1 : 1), "px"));
                const actives = this.getActives();
                const itemIn = this.getItemIn();
                const itemOut = this.getItemIn(true);
                percent = prev ? clamp(percent, -1, 1) : 0;
                for (const slide of children(list)){
                    const isActive = includes(actives, slide);
                    const isIn = slide === itemIn;
                    const isOut = slide === itemOut;
                    const translateIn = isIn || !isOut && (isActive || dir * (isRtl ? -1 : 1) === -1 ^ getElLeft(slide, list) > getElLeft(prev || next));
                    triggerUpdate(slide, `itemtranslate${translateIn ? "in" : "out"}`, {
                        dir: dir,
                        percent: isOut ? 1 - percent : isIn ? percent : isActive ? 1 : 0
                    });
                }
            },
            percent () {
                return Math.abs((new DOMMatrix(css(list, "transform")).m41 * (isRtl ? -1 : 1) + from) / (to - from));
            },
            getDistance () {
                return Math.abs(to - from);
            },
            getItemIn (out = false) {
                let actives = this.getActives();
                let nextActives = inView(list, getLeft(next || prev, list, center));
                if (out) {
                    const temp = actives;
                    actives = nextActives;
                    nextActives = temp;
                }
                return nextActives[findIndex(nextActives, (el)=>!includes(actives, el))];
            },
            getActives () {
                return inView(list, getLeft(prev || next, list, center));
            }
        };
    }
    function getLeft(el, list, center) {
        const left = getElLeft(el, list);
        return center ? left - centerEl(el, list) : Math.min(left, getMax(list));
    }
    function getMax(list) {
        return Math.max(0, getWidth(list) - dimensions$1(list).width);
    }
    function getWidth(list, index) {
        return sumBy(children(list).slice(0, index), (el)=>dimensions$1(el).width);
    }
    function centerEl(el, list) {
        return dimensions$1(list).width / 2 - dimensions$1(el).width / 2;
    }
    function getElLeft(el, list) {
        return el && (position(el).left + (isRtl ? dimensions$1(el).width - dimensions$1(list).width : 0)) * (isRtl ? -1 : 1) || 0;
    }
    function inView(list, listLeft) {
        listLeft -= 1;
        const listWidth = dimensions$1(list).width;
        const listRight = listLeft + listWidth + 2;
        return children(list).filter((slide)=>{
            const slideLeft = getElLeft(slide, list);
            const slideRight = slideLeft + Math.min(dimensions$1(slide).width, listWidth);
            return slideLeft >= listLeft && slideRight <= listRight;
        });
    }
    var slider = {
        mixins: [
            Class,
            Slider,
            SliderReactive,
            SliderParallax,
            SliderPreload
        ],
        props: {
            center: Boolean,
            sets: Boolean,
            active: String
        },
        data: {
            center: false,
            sets: false,
            attrItem: "uk-slider-item",
            selList: ".uk-slider-items",
            selNav: ".uk-slider-nav",
            clsContainer: "uk-slider-container",
            active: "all",
            Transitioner: Transitioner
        },
        computed: {
            finite ({ finite: finite }) {
                return finite || isFinite(this.list, this.center);
            },
            maxIndex () {
                if (!this.finite || this.center && !this.sets) return this.length - 1;
                if (this.center) return last(this.sets);
                let lft = 0;
                const max = getMax(this.list);
                const index = findIndex(this.slides, (el)=>{
                    if (lft >= max - 5e-3) return true;
                    lft += dimensions$1(el).width;
                });
                return ~index ? index : this.length - 1;
            },
            sets ({ sets: enabled }) {
                if (!enabled || this.parallax) return;
                let left = 0;
                const sets = [];
                const width = dimensions$1(this.list).width;
                for(let i = 0; i < this.length; i++){
                    const slideWidth = dimensions$1(this.slides[i]).width;
                    if (left + slideWidth > width) left = 0;
                    if (this.center) {
                        if (left < width / 2 && left + slideWidth + dimensions$1(this.slides[getIndex(i + 1, this.slides)]).width / 2 > width / 2) {
                            sets.push(i);
                            left = width / 2 - slideWidth / 2;
                        }
                    } else if (left === 0) sets.push(Math.min(i, this.maxIndex));
                    left += slideWidth;
                }
                if (sets.length) return sets;
            },
            transitionOptions () {
                return {
                    center: this.center,
                    list: this.list
                };
            },
            slides () {
                return children(this.list).filter(isVisible);
            }
        },
        connected () {
            toggleClass(this.$el, this.clsContainer, !$(`.${this.clsContainer}`, this.$el));
        },
        observe: resize({
            target: ({ slides: slides, $el: $el })=>[
                    $el,
                    ...slides
                ]
        }),
        update: {
            write () {
                for (const el of this.navItems){
                    const index = toNumber(data(el, this.attrItem));
                    if (index !== false) el.hidden = !this.maxIndex || index > this.maxIndex || this.sets && !includes(this.sets, index);
                }
                this.reorder();
                if (!this.parallax) this._translate(1);
                this.updateActiveClasses();
            },
            events: [
                "resize"
            ]
        },
        events: {
            beforeitemshow (e) {
                if (!this.dragging && this.sets && this.stack.length < 2 && !includes(this.sets, this.index)) this.index = this.getValidIndex();
                const diff = Math.abs(this.index - this.prevIndex + (this.dir > 0 && this.index < this.prevIndex || this.dir < 0 && this.index > this.prevIndex ? (this.maxIndex + 1) * this.dir : 0));
                if (!this.dragging && diff > 1) {
                    for(let i = 0; i < diff; i++)this.stack.splice(1, 0, this.dir > 0 ? "next" : "previous");
                    e.preventDefault();
                    return;
                }
                const index = this.dir < 0 || !this.slides[this.prevIndex] ? this.index : this.prevIndex;
                const avgWidth = getWidth(this.list) / this.length;
                this.duration = speedUp(avgWidth / this.velocity) * (dimensions$1(this.slides[index]).width / avgWidth);
                this.reorder();
            },
            itemshow () {
                if (~this.prevIndex) addClass(this._getTransitioner().getItemIn(), this.clsActive);
                this.updateActiveClasses(this.prevIndex);
            },
            itemshown () {
                this.updateActiveClasses();
            }
        },
        methods: {
            reorder () {
                if (this.finite) {
                    css(this.slides, "order", "");
                    return;
                }
                const index = this.dir > 0 && this.slides[this.prevIndex] ? this.prevIndex : this.index;
                this.slides.forEach((slide, i)=>css(slide, "order", this.dir > 0 && i < index ? 1 : this.dir < 0 && i >= this.index ? -1 : ""));
                if (!this.center || !this.length) return;
                const next = this.slides[index];
                let width = dimensions$1(this.list).width / 2 - dimensions$1(next).width / 2;
                let j = 0;
                while(width > 0){
                    const slideIndex = this.getIndex(--j + index, index);
                    const slide = this.slides[slideIndex];
                    css(slide, "order", slideIndex > index ? -2 : -1);
                    width -= dimensions$1(slide).width;
                }
            },
            updateActiveClasses (currentIndex = this.index) {
                let actives = this._getTransitioner(currentIndex).getActives();
                if (this.active !== "all") actives = [
                    this.slides[this.getValidIndex(currentIndex)]
                ];
                const activeClasses = [
                    this.clsActive,
                    !this.sets || includes(this.sets, toFloat(this.index)) ? this.clsActivated : ""
                ];
                for (const slide of this.slides){
                    const active = includes(actives, slide);
                    toggleClass(slide, activeClasses, active);
                    attr(slide, "aria-hidden", !active);
                    for (const focusable of $$(selFocusable, slide)){
                        if (!hasOwn(focusable, "_tabindex")) focusable._tabindex = attr(focusable, "tabindex");
                        attr(focusable, "tabindex", active ? focusable._tabindex : -1);
                    }
                }
            },
            getValidIndex (index = this.index, prevIndex = this.prevIndex) {
                index = this.getIndex(index, prevIndex);
                if (!this.sets) return index;
                let prev;
                do {
                    if (includes(this.sets, index)) return index;
                    prev = index;
                    index = this.getIndex(index + this.dir, prevIndex);
                }while (index !== prev);
                return index;
            },
            getAdjacentSlides () {
                const { width: width } = dimensions$1(this.list);
                const left = -width;
                const right = width * 2;
                const slideWidth = dimensions$1(this.slides[this.index]).width;
                const slideLeft = this.center ? width / 2 - slideWidth / 2 : 0;
                const slides = /* @__PURE__ */ new Set();
                for (const i of [
                    -1,
                    1
                ]){
                    let currentLeft = slideLeft + (i > 0 ? slideWidth : 0);
                    let j = 0;
                    do {
                        const slide = this.slides[this.getIndex(this.index + i + j++ * i)];
                        currentLeft += dimensions$1(slide).width * i;
                        slides.add(slide);
                    }while (this.length > j && currentLeft > left && currentLeft < right);
                }
                return Array.from(slides);
            },
            getIndexAt (percent) {
                let index = -1;
                const scrollDist = this.center ? getWidth(this.list) - (dimensions$1(this.slides[0]).width / 2 + dimensions$1(last(this.slides)).width / 2) : getWidth(this.list, this.maxIndex);
                let dist = percent * scrollDist;
                let slidePercent = 0;
                do {
                    const slideWidth = dimensions$1(this.slides[++index]).width;
                    const slideDist = this.center ? slideWidth / 2 + dimensions$1(this.slides[index + 1]).width / 2 : slideWidth;
                    slidePercent = dist / slideDist % 1;
                    dist -= slideDist;
                }while (dist >= 0 && index < this.maxIndex);
                return [
                    index,
                    slidePercent
                ];
            }
        }
    };
    function isFinite(list, center) {
        if (!list || list.length < 2) return true;
        const { width: listWidth } = dimensions$1(list);
        if (!center) return Math.ceil(getWidth(list)) < Math.trunc(listWidth + getMaxElWidth(list));
        const slides = children(list);
        const listHalf = Math.trunc(listWidth / 2);
        for(const index in slides){
            const slide = slides[index];
            const slideWidth = dimensions$1(slide).width;
            const slidesInView = /* @__PURE__ */ new Set([
                slide
            ]);
            let diff = 0;
            for (const i of [
                -1,
                1
            ]){
                let left = slideWidth / 2;
                let j = 0;
                while(left < listHalf){
                    const nextSlide = slides[getIndex(+index + i + j++ * i, slides)];
                    if (slidesInView.has(nextSlide)) return true;
                    left += dimensions$1(nextSlide).width;
                    slidesInView.add(nextSlide);
                }
                diff = Math.max(diff, slideWidth / 2 + dimensions$1(slides[getIndex(+index + i, slides)]).width / 2 - (left - listHalf));
            }
            if (Math.trunc(diff) > sumBy(slides.filter((slide2)=>!slidesInView.has(slide2)), (slide2)=>dimensions$1(slide2).width)) return true;
        }
        return false;
    }
    function getMaxElWidth(list) {
        return Math.max(0, ...children(list).map((el)=>dimensions$1(el).width));
    }
    var sliderParallax = {
        mixins: [
            Parallax
        ],
        beforeConnect () {
            this.item = this.$el.closest(`.${this.$options.id.replace("parallax", "items")} > *`);
        },
        disconnected () {
            this.item = null;
        },
        events: [
            {
                name: "itemin itemout",
                self: true,
                el: ({ item: item })=>item,
                handler ({ type: type, detail: { percent: percent, duration: duration, timing: timing, dir: dir } }) {
                    fastdom.read(()=>{
                        if (!this.matchMedia) return;
                        const propsFrom = this.getCss(getCurrentPercent(type, dir, percent));
                        const propsTo = this.getCss(isIn(type) ? 0.5 : dir > 0 ? 1 : 0);
                        fastdom.write(()=>{
                            css(this.$el, propsFrom);
                            Transition.start(this.$el, propsTo, duration, timing).catch(noop);
                        });
                    });
                }
            },
            {
                name: "transitioncanceled transitionend",
                self: true,
                el: ({ item: item })=>item,
                handler () {
                    Transition.cancel(this.$el);
                }
            },
            {
                name: "itemtranslatein itemtranslateout",
                self: true,
                el: ({ item: item })=>item,
                handler ({ type: type, detail: { percent: percent, dir: dir } }) {
                    fastdom.read(()=>{
                        if (!this.matchMedia) {
                            this.reset();
                            return;
                        }
                        const props = this.getCss(getCurrentPercent(type, dir, percent));
                        fastdom.write(()=>css(this.$el, props));
                    });
                }
            }
        ]
    };
    function isIn(type) {
        return endsWith(type, "in");
    }
    function getCurrentPercent(type, dir, percent) {
        percent /= 2;
        return isIn(type) ^ dir < 0 ? percent : 1 - percent;
    }
    var Animations = {
        ...Animations$2,
        fade: {
            show () {
                return [
                    {
                        opacity: 0,
                        zIndex: 0
                    },
                    {
                        zIndex: -1
                    }
                ];
            },
            percent (current) {
                return 1 - css(current, "opacity");
            },
            translate (percent) {
                return [
                    {
                        opacity: 1 - percent,
                        zIndex: 0
                    },
                    {
                        zIndex: -1
                    }
                ];
            }
        },
        scale: {
            show () {
                return [
                    {
                        opacity: 0,
                        transform: scale3d(1.5),
                        zIndex: 0
                    },
                    {
                        zIndex: -1
                    }
                ];
            },
            percent (current) {
                return 1 - css(current, "opacity");
            },
            translate (percent) {
                return [
                    {
                        opacity: 1 - percent,
                        transform: scale3d(1 + 0.5 * percent),
                        zIndex: 0
                    },
                    {
                        zIndex: -1
                    }
                ];
            }
        },
        pull: {
            show (dir) {
                return dir < 0 ? [
                    {
                        transform: translate(30),
                        zIndex: -1
                    },
                    {
                        transform: translate(),
                        zIndex: 0
                    }
                ] : [
                    {
                        transform: translate(-100),
                        zIndex: 0
                    },
                    {
                        transform: translate(),
                        zIndex: -1
                    }
                ];
            },
            percent (current, next, dir) {
                return dir < 0 ? 1 - translated(next) : translated(current);
            },
            translate (percent, dir) {
                return dir < 0 ? [
                    {
                        transform: translate(30 * percent),
                        zIndex: -1
                    },
                    {
                        transform: translate(-100 * (1 - percent)),
                        zIndex: 0
                    }
                ] : [
                    {
                        transform: translate(-percent * 100),
                        zIndex: 0
                    },
                    {
                        transform: translate(30 * (1 - percent)),
                        zIndex: -1
                    }
                ];
            }
        },
        push: {
            show (dir) {
                return dir < 0 ? [
                    {
                        transform: translate(100),
                        zIndex: 0
                    },
                    {
                        transform: translate(),
                        zIndex: -1
                    }
                ] : [
                    {
                        transform: translate(-30),
                        zIndex: -1
                    },
                    {
                        transform: translate(),
                        zIndex: 0
                    }
                ];
            },
            percent (current, next, dir) {
                return dir > 0 ? 1 - translated(next) : translated(current);
            },
            translate (percent, dir) {
                return dir < 0 ? [
                    {
                        transform: translate(percent * 100),
                        zIndex: 0
                    },
                    {
                        transform: translate(-30 * (1 - percent)),
                        zIndex: -1
                    }
                ] : [
                    {
                        transform: translate(-30 * percent),
                        zIndex: -1
                    },
                    {
                        transform: translate(100 * (1 - percent)),
                        zIndex: 0
                    }
                ];
            }
        }
    };
    var slideshow = {
        mixins: [
            Class,
            Slideshow,
            SliderReactive,
            SliderParallax,
            SliderPreload
        ],
        props: {
            ratio: String,
            minHeight: String,
            maxHeight: String
        },
        data: {
            ratio: "16:9",
            minHeight: void 0,
            maxHeight: void 0,
            selList: ".uk-slideshow-items",
            attrItem: "uk-slideshow-item",
            selNav: ".uk-slideshow-nav",
            Animations: Animations
        },
        watch: {
            list (list) {
                css(list, {
                    aspectRatio: this.ratio ? this.ratio.replace(":", "/") : void 0,
                    minHeight: this.minHeight,
                    maxHeight: this.maxHeight,
                    minWidth: "100%",
                    maxWidth: "100%"
                });
            }
        },
        methods: {
            getAdjacentSlides () {
                return [
                    1,
                    -1
                ].map((i)=>this.slides[this.getIndex(this.index + i)]);
            }
        }
    };
    var sortable = {
        mixins: [
            Class,
            Animate
        ],
        props: {
            group: String,
            threshold: Number,
            clsItem: String,
            clsPlaceholder: String,
            clsDrag: String,
            clsDragState: String,
            clsBase: String,
            clsNoDrag: String,
            clsEmpty: String,
            clsCustom: String,
            handle: String
        },
        data: {
            group: false,
            threshold: 5,
            clsItem: "uk-sortable-item",
            clsPlaceholder: "uk-sortable-placeholder",
            clsDrag: "uk-sortable-drag",
            clsDragState: "uk-drag",
            clsBase: "uk-sortable",
            clsNoDrag: "uk-sortable-nodrag",
            clsEmpty: "uk-sortable-empty",
            clsCustom: "",
            handle: false,
            pos: {}
        },
        events: {
            name: pointerDown$1,
            passive: false,
            handler: "init"
        },
        computed: {
            target: (_, $el)=>($el.tBodies || [
                    $el
                ])[0],
            items () {
                return children(this.target);
            },
            isEmpty () {
                return !this.items.length;
            },
            handles ({ handle: handle }, $el) {
                return handle ? $$(handle, $el) : this.items;
            }
        },
        watch: {
            isEmpty (empty) {
                toggleClass(this.target, this.clsEmpty, empty);
            },
            handles (handles, prev) {
                css(prev, {
                    touchAction: "",
                    userSelect: ""
                });
                css(handles, {
                    touchAction: "none",
                    userSelect: "none"
                });
            }
        },
        update: {
            write (data) {
                if (!this.drag || !parent(this.placeholder)) return;
                const { pos: { x: x, y: y }, origin: { offsetTop: offsetTop, offsetLeft: offsetLeft }, placeholder: placeholder } = this;
                css(this.drag, {
                    top: y - offsetTop,
                    left: x - offsetLeft
                });
                const sortable = this.getSortable(document.elementFromPoint(x, y));
                if (!sortable) return;
                const { items: items } = sortable;
                if (items.some(Transition.inProgress)) return;
                const target = findTarget(items, {
                    x: x,
                    y: y
                });
                if (items.length && (!target || target === placeholder)) return;
                const previous = this.getSortable(placeholder);
                const insertTarget = findInsertTarget(sortable.target, target, placeholder, x, y, sortable === previous && data.moved !== target);
                if (insertTarget === false) return;
                if (insertTarget && placeholder === insertTarget) return;
                if (sortable !== previous) {
                    previous.remove(placeholder);
                    data.moved = target;
                } else delete data.moved;
                sortable.insert(placeholder, insertTarget);
                this.touched.add(sortable);
            },
            events: [
                "move"
            ]
        },
        methods: {
            init (e) {
                const { target: target, button: button, defaultPrevented: defaultPrevented } = e;
                const [placeholder] = this.items.filter((el)=>el.contains(target));
                if (!placeholder || defaultPrevented || button > 0 || isInput(target) || target.closest(`.${this.clsNoDrag}`) || this.handle && !target.closest(this.handle)) return;
                e.preventDefault();
                this.pos = getEventPos(e);
                this.touched = /* @__PURE__ */ new Set([
                    this
                ]);
                this.placeholder = placeholder;
                this.origin = {
                    target: target,
                    index: index(placeholder),
                    ...this.pos
                };
                on(document, pointerMove$1, this.move);
                on(document, pointerUp$1, this.end);
                if (!this.threshold) this.start(e);
            },
            start (e) {
                this.drag = appendDrag(this.$container, this.placeholder);
                const { left: left, top: top } = dimensions$1(this.placeholder);
                assign(this.origin, {
                    offsetLeft: this.pos.x - left,
                    offsetTop: this.pos.y - top
                });
                addClass(this.drag, this.clsDrag, this.clsCustom);
                addClass(this.placeholder, this.clsPlaceholder);
                addClass(this.items, this.clsItem);
                addClass(document.documentElement, this.clsDragState);
                trigger(this.$el, "start", [
                    this,
                    this.placeholder
                ]);
                trackScroll(this.pos);
                this.move(e);
            },
            move: throttle(function(e) {
                assign(this.pos, getEventPos(e));
                if (!this.drag && (Math.abs(this.pos.x - this.origin.x) > this.threshold || Math.abs(this.pos.y - this.origin.y) > this.threshold)) this.start(e);
                this.$emit("move");
            }),
            end () {
                off(document, pointerMove$1, this.move);
                off(document, pointerUp$1, this.end);
                if (!this.drag) return;
                untrackScroll();
                const sortable = this.getSortable(this.placeholder);
                if (this === sortable) {
                    if (this.origin.index !== index(this.placeholder)) trigger(this.$el, "moved", [
                        this,
                        this.placeholder
                    ]);
                } else {
                    trigger(sortable.$el, "added", [
                        sortable,
                        this.placeholder
                    ]);
                    trigger(this.$el, "removed", [
                        this,
                        this.placeholder
                    ]);
                }
                trigger(this.$el, "stop", [
                    this,
                    this.placeholder
                ]);
                remove$1(this.drag);
                this.drag = null;
                for (const { clsPlaceholder: clsPlaceholder, clsItem: clsItem } of this.touched)for (const sortable2 of this.touched)removeClass(sortable2.items, clsPlaceholder, clsItem);
                this.touched = null;
                removeClass(document.documentElement, this.clsDragState);
            },
            insert (element, target) {
                addClass(this.items, this.clsItem);
                if (target && target.previousElementSibling !== element) this.animate(()=>before(target, element));
                else if (!target && this.target.lastElementChild !== element) this.animate(()=>append(this.target, element));
            },
            remove (element) {
                if (this.target.contains(element)) this.animate(()=>remove$1(element));
            },
            getSortable (element) {
                do {
                    const sortable = this.$getComponent(element, "sortable");
                    if (sortable && (sortable === this || this.group !== false && sortable.group === this.group)) return sortable;
                }while (element = parent(element));
            }
        }
    };
    let trackTimer;
    function trackScroll(pos) {
        let last = Date.now();
        trackTimer = setInterval(()=>{
            let { x: x, y: y } = pos;
            y += document.scrollingElement.scrollTop;
            const dist = (Date.now() - last) * 0.3;
            last = Date.now();
            scrollParents(document.elementFromPoint(x, pos.y)).reverse().some((scrollEl)=>{
                let { scrollTop: scroll, scrollHeight: scrollHeight } = scrollEl;
                const { top: top, bottom: bottom, height: height2 } = offsetViewport(scrollEl);
                if (top < y && top + 35 > y) scroll -= dist;
                else if (bottom > y && bottom - 35 < y) scroll += dist;
                else return;
                if (scroll > 0 && scroll < scrollHeight - height2) {
                    scrollEl.scrollTop = scroll;
                    return true;
                }
            });
        }, 15);
    }
    function untrackScroll() {
        clearInterval(trackTimer);
    }
    function appendDrag(container, element) {
        let clone;
        if (isTag(element, "li", "tr")) {
            clone = $("<div>");
            append(clone, element.cloneNode(true).children);
            for (const attribute of element.getAttributeNames())attr(clone, attribute, element.getAttribute(attribute));
        } else clone = element.cloneNode(true);
        append(container, clone);
        css(clone, "margin", "0", "important");
        css(clone, {
            boxSizing: "border-box",
            width: element.offsetWidth,
            height: element.offsetHeight,
            padding: css(element, "padding")
        });
        height(clone.firstElementChild, height(element.firstElementChild));
        return clone;
    }
    function findTarget(items, point) {
        return items[findIndex(items, (item)=>pointInRect(point, dimensions$1(item)))];
    }
    function findInsertTarget(list, target, placeholder, x, y, sameList) {
        if (!children(list).length) return;
        const rect = dimensions$1(target);
        if (!sameList) {
            if (!isHorizontal(list, placeholder)) return y < rect.top + rect.height / 2 ? target : target.nextElementSibling;
            return target;
        }
        const placeholderRect = dimensions$1(placeholder);
        const sameRow = linesIntersect([
            rect.top,
            rect.bottom
        ], [
            placeholderRect.top,
            placeholderRect.bottom
        ]);
        const [pointerPos, lengthProp, startProp, endProp] = sameRow ? [
            x,
            "width",
            "left",
            "right"
        ] : [
            y,
            "height",
            "top",
            "bottom"
        ];
        const diff = placeholderRect[lengthProp] < rect[lengthProp] ? rect[lengthProp] - placeholderRect[lengthProp] : 0;
        if (placeholderRect[startProp] < rect[startProp]) {
            if (diff && pointerPos < rect[startProp] + diff) return false;
            return target.nextElementSibling;
        }
        if (diff && pointerPos > rect[endProp] - diff) return false;
        return target;
    }
    function isHorizontal(list, placeholder) {
        const single = children(list).length === 1;
        if (single) append(list, placeholder);
        const items = children(list);
        const isHorizontal2 = items.some((el, i)=>{
            const rectA = dimensions$1(el);
            return items.slice(i + 1).some((el2)=>{
                const rectB = dimensions$1(el2);
                return !linesIntersect([
                    rectA.left,
                    rectA.right
                ], [
                    rectB.left,
                    rectB.right
                ]);
            });
        });
        if (single) remove$1(placeholder);
        return isHorizontal2;
    }
    function linesIntersect(lineA, lineB) {
        return lineA[1] > lineB[0] && lineB[1] > lineA[0];
    }
    function throttle(fn) {
        let throttled;
        return function(...args) {
            if (!throttled) {
                throttled = true;
                fn.call(this, ...args);
                requestAnimationFrame(()=>throttled = false);
            }
        };
    }
    var Position = {
        props: {
            pos: String,
            offset: Boolean,
            flip: Boolean,
            shift: Boolean,
            inset: Boolean
        },
        data: {
            pos: `bottom-${isRtl ? "right" : "left"}`,
            offset: false,
            flip: true,
            shift: true,
            inset: false
        },
        connected () {
            this.pos = this.$props.pos.split("-").concat("center").slice(0, 2);
            [this.dir, this.align] = this.pos;
            this.axis = includes([
                "top",
                "bottom"
            ], this.dir) ? "y" : "x";
        },
        methods: {
            positionAt (element, target, boundary) {
                let offset = [
                    this.getPositionOffset(element),
                    this.getShiftOffset(element)
                ];
                const placement = [
                    this.flip && "flip",
                    this.shift && "shift"
                ];
                const attach = {
                    element: [
                        this.inset ? this.dir : flipPosition(this.dir),
                        this.align
                    ],
                    target: [
                        this.dir,
                        this.align
                    ]
                };
                if (this.axis === "y") {
                    for(const prop in attach)attach[prop].reverse();
                    offset.reverse();
                    placement.reverse();
                }
                const restoreScrollPosition = storeScrollPosition(element);
                const elDim = dimensions$1(element);
                css(element, {
                    top: -elDim.height,
                    left: -elDim.width
                });
                positionAt(element, target, {
                    attach: attach,
                    offset: offset,
                    boundary: boundary,
                    placement: placement,
                    viewportOffset: this.getViewportOffset(element)
                });
                restoreScrollPosition();
            },
            getPositionOffset (element = this.$el) {
                return toPx(this.offset === false ? css(element, "--uk-position-offset") : this.offset, this.axis === "x" ? "width" : "height", element) * (includes([
                    "left",
                    "top"
                ], this.dir) ? -1 : 1) * (this.inset ? -1 : 1);
            },
            getShiftOffset (element = this.$el) {
                return this.align === "center" ? 0 : toPx(css(element, "--uk-position-shift-offset"), this.axis === "y" ? "width" : "height", element) * (includes([
                    "left",
                    "top"
                ], this.align) ? 1 : -1);
            },
            getViewportOffset (element) {
                return toPx(css(element, "--uk-position-viewport-offset"));
            }
        }
    };
    function storeScrollPosition(element) {
        const scrollElement = scrollParent(element);
        const { scrollTop: scrollTop } = scrollElement;
        return ()=>{
            if (scrollTop !== scrollElement.scrollTop) scrollElement.scrollTop = scrollTop;
        };
    }
    var tooltip = {
        mixins: [
            Container,
            Togglable,
            Position
        ],
        data: {
            pos: "top",
            animation: [
                "uk-animation-scale-up"
            ],
            duration: 100,
            cls: "uk-active"
        },
        connected () {
            makeFocusable(this.$el);
        },
        disconnected () {
            this.hide();
        },
        methods: {
            show () {
                if (this.isToggled(this.tooltip || null)) return;
                const { delay: delay = 0, title: title } = parseProps(this.$options);
                if (!title) return;
                const titleAttr = attr(this.$el, "title");
                const off = on(this.$el, [
                    "blur",
                    pointerLeave
                ], (e)=>!isTouch(e) && this.hide());
                this.reset = ()=>{
                    attr(this.$el, {
                        title: titleAttr,
                        "aria-describedby": null
                    });
                    off();
                };
                const id = generateId(this);
                attr(this.$el, {
                    title: null,
                    "aria-describedby": id
                });
                clearTimeout(this.showTimer);
                this.showTimer = setTimeout(()=>this._show(title, id), delay);
            },
            async hide () {
                var _a;
                if (matches(this.$el, "input:focus")) return;
                clearTimeout(this.showTimer);
                if (this.isToggled(this.tooltip || null)) await this.toggleElement(this.tooltip, false, false);
                (_a = this.reset) == null || _a.call(this);
                remove$1(this.tooltip);
                this.tooltip = null;
            },
            async _show (title, id) {
                this.tooltip = append(this.container, `<div id="${id}" class="uk-${this.$options.name}" role="tooltip"> <div class="uk-${this.$options.name}-inner">${title}</div> </div>`);
                on(this.tooltip, "toggled", (e, toggled)=>{
                    if (!toggled) return;
                    const update = ()=>this.positionAt(this.tooltip, this.$el);
                    update();
                    const [dir, align] = getAlignment(this.tooltip, this.$el, this.pos);
                    this.origin = this.axis === "y" ? `${flipPosition(dir)}-${align}` : `${align}-${flipPosition(dir)}`;
                    const handlers = [
                        once(document, `keydown ${pointerDown$1}`, this.hide, false, (e2)=>e2.type === pointerDown$1 && !this.$el.contains(e2.target) || e2.type === "keydown" && e2.keyCode === keyMap.ESC),
                        on([
                            document,
                            ...overflowParents(this.$el)
                        ], "scroll", update, {
                            passive: true
                        })
                    ];
                    once(this.tooltip, "hide", ()=>handlers.forEach((handler)=>handler()), {
                        self: true
                    });
                });
                if (!await this.toggleElement(this.tooltip, true)) this.hide();
            }
        },
        events: {
            // Clicking a button does not give it focus on all browsers and platforms
            // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#clicking_and_focus
            [`focus ${pointerEnter} ${pointerDown$1}`] (e) {
                if (!isTouch(e) || e.type === pointerDown$1) this.show();
            }
        }
    };
    function makeFocusable(el) {
        if (!isFocusable(el)) attr(el, "tabindex", "0");
    }
    function getAlignment(el, target, [dir, align]) {
        const elOffset = offset(el);
        const targetOffset = offset(target);
        const properties = [
            [
                "left",
                "right"
            ],
            [
                "top",
                "bottom"
            ]
        ];
        for (const props2 of properties){
            if (elOffset[props2[0]] >= targetOffset[props2[1]]) {
                dir = props2[1];
                break;
            }
            if (elOffset[props2[1]] <= targetOffset[props2[0]]) {
                dir = props2[0];
                break;
            }
        }
        const props = includes(properties[0], dir) ? properties[1] : properties[0];
        align = props.find((prop)=>elOffset[prop] === targetOffset[prop]) || "center";
        return [
            dir,
            align
        ];
    }
    function parseProps(options) {
        const { el: el, id: id, data: data$1 } = options;
        return [
            "delay",
            "title"
        ].reduce((obj, key)=>({
                [key]: data(el, key),
                ...obj
            }), {
            ...parseOptions(data(el, id), [
                "title"
            ]),
            ...data$1
        });
    }
    var upload = {
        mixins: [
            I18n
        ],
        i18n: {
            invalidMime: "Invalid File Type: %s",
            invalidName: "Invalid File Name: %s",
            invalidSize: "Invalid File Size: %s Kilobytes Max"
        },
        props: {
            allow: String,
            clsDragover: String,
            concurrent: Number,
            maxSize: Number,
            method: String,
            mime: String,
            multiple: Boolean,
            name: String,
            params: Object,
            type: String,
            url: String
        },
        data: {
            allow: false,
            clsDragover: "uk-dragover",
            concurrent: 1,
            maxSize: 0,
            method: "POST",
            mime: false,
            multiple: false,
            name: "files[]",
            params: {},
            type: "",
            url: "",
            abort: noop,
            beforeAll: noop,
            beforeSend: noop,
            complete: noop,
            completeAll: noop,
            error: noop,
            fail: noop,
            load: noop,
            loadEnd: noop,
            loadStart: noop,
            progress: noop
        },
        events: {
            change (e) {
                if (!matches(e.target, 'input[type="file"]')) return;
                e.preventDefault();
                if (e.target.files) this.upload(e.target.files);
                e.target.value = "";
            },
            drop (e) {
                stop(e);
                const transfer = e.dataTransfer;
                if (!(transfer == null ? void 0 : transfer.files)) return;
                removeClass(this.$el, this.clsDragover);
                this.upload(transfer.files);
            },
            dragenter (e) {
                stop(e);
            },
            dragover (e) {
                stop(e);
                addClass(this.$el, this.clsDragover);
            },
            dragleave (e) {
                stop(e);
                removeClass(this.$el, this.clsDragover);
            }
        },
        methods: {
            async upload (files) {
                files = toArray(files);
                if (!files.length) return;
                trigger(this.$el, "upload", [
                    files
                ]);
                for (const file of files){
                    if (this.maxSize && this.maxSize * 1e3 < file.size) {
                        this.fail(this.t("invalidSize", this.maxSize));
                        return;
                    }
                    if (this.allow && !match$1(this.allow, file.name)) {
                        this.fail(this.t("invalidName", this.allow));
                        return;
                    }
                    if (this.mime && !match$1(this.mime, file.type)) {
                        this.fail(this.t("invalidMime", this.mime));
                        return;
                    }
                }
                if (!this.multiple) files = files.slice(0, 1);
                this.beforeAll(this, files);
                const chunks = chunk(files, this.concurrent);
                const upload = async (files2)=>{
                    const data = new FormData();
                    files2.forEach((file)=>data.append(this.name, file));
                    for(const key in this.params)data.append(key, this.params[key]);
                    try {
                        const xhr = await ajax(this.url, {
                            data: data,
                            method: this.method,
                            responseType: this.type,
                            beforeSend: (env)=>{
                                const { xhr: xhr2 } = env;
                                on(xhr2.upload, "progress", this.progress);
                                for (const type of [
                                    "loadStart",
                                    "load",
                                    "loadEnd",
                                    "abort"
                                ])on(xhr2, type.toLowerCase(), this[type]);
                                return this.beforeSend(env);
                            }
                        });
                        this.complete(xhr);
                        if (chunks.length) await upload(chunks.shift());
                        else this.completeAll(xhr);
                    } catch (e) {
                        this.error(e);
                    }
                };
                await upload(chunks.shift());
            }
        }
    };
    function match$1(pattern, path) {
        return path.match(new RegExp(`^${pattern.replace(/\//g, "\\/").replace(/\*\*/g, "(\\/[^\\/]+)*").replace(/\*/g, "[^\\/]+").replace(/((?!\\))\?/g, "$1.")}$`, "i"));
    }
    function chunk(files, size) {
        const chunks = [];
        for(let i = 0; i < files.length; i += size)chunks.push(files.slice(i, i + size));
        return chunks;
    }
    function stop(e) {
        e.preventDefault();
        e.stopPropagation();
    }
    async function ajax(url, options) {
        const env = {
            data: null,
            method: "GET",
            headers: {},
            xhr: new XMLHttpRequest(),
            beforeSend: noop,
            responseType: "",
            ...options
        };
        await env.beforeSend(env);
        return send(url, env);
    }
    function send(url, env) {
        return new Promise((resolve, reject)=>{
            const { xhr: xhr } = env;
            for(const prop in env){
                if (prop in xhr) try {
                    xhr[prop] = env[prop];
                } catch (e) {}
            }
            xhr.open(env.method.toUpperCase(), url);
            for(const header in env.headers)xhr.setRequestHeader(header, env.headers[header]);
            on(xhr, "load", ()=>{
                if (xhr.status === 0 || xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) resolve(xhr);
                else reject(assign(Error(xhr.statusText), {
                    xhr: xhr,
                    status: xhr.status
                }));
            });
            on(xhr, "error", ()=>reject(assign(Error("Network Error"), {
                    xhr: xhr
                })));
            on(xhr, "timeout", ()=>reject(assign(Error("Network Timeout"), {
                    xhr: xhr
                })));
            xhr.send(env.data);
        });
    }
    var components$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        Countdown: countdown,
        Filter: filter,
        Lightbox: lightbox,
        LightboxPanel: LightboxPanel,
        Notification: notification,
        Parallax: parallax,
        Slider: slider,
        SliderParallax: sliderParallax,
        Slideshow: slideshow,
        SlideshowParallax: sliderParallax,
        Sortable: sortable,
        Tooltip: tooltip,
        Upload: upload
    });
    function boot(App) {
        if (inBrowser && window.MutationObserver) {
            if (document.body) requestAnimationFrame(()=>init(App));
            else new MutationObserver((records, observer)=>{
                if (document.body) {
                    init(App);
                    observer.disconnect();
                }
            }).observe(document.documentElement, {
                childList: true
            });
        }
    }
    function init(App) {
        trigger(document, "uikit:init", App);
        if (document.body) apply(document.body, connect);
        new MutationObserver((records)=>records.forEach(applyChildListMutation)).observe(document, {
            subtree: true,
            childList: true
        });
        new MutationObserver((records)=>records.forEach(applyAttributeMutation)).observe(document, {
            subtree: true,
            attributes: true
        });
        App._initialized = true;
    }
    function applyChildListMutation({ addedNodes: addedNodes, removedNodes: removedNodes }) {
        for (const node of addedNodes)apply(node, connect);
        for (const node of removedNodes)apply(node, disconnect);
    }
    function applyAttributeMutation({ target: target, attributeName: attributeName }) {
        var _a;
        const name = getComponentName(attributeName);
        if (name) {
            if (hasAttr(target, attributeName)) createComponent(name, target);
            else (_a = getComponent(target, name)) == null || _a.$destroy();
        }
    }
    function connect(node) {
        const components2 = getComponents(node);
        for(const name in components2)callConnected(components2[name]);
        for (const attributeName of node.getAttributeNames()){
            const name = getComponentName(attributeName);
            name && createComponent(name, node);
        }
    }
    function disconnect(node) {
        const components2 = getComponents(node);
        for(const name in components2)callDisconnected(components2[name]);
    }
    function getComponentName(attribute) {
        if (startsWith(attribute, "data-")) attribute = attribute.slice(5);
        const cmp = components$2[attribute];
        return cmp && (cmp.options || cmp).name;
    }
    globalApi(App);
    instanceApi(App);
    var Accordion = {
        mixins: [
            Class,
            Togglable
        ],
        props: {
            animation: Boolean,
            targets: String,
            active: null,
            collapsible: Boolean,
            multiple: Boolean,
            toggle: String,
            content: String,
            offset: Number
        },
        data: {
            targets: "> *",
            active: false,
            animation: true,
            collapsible: true,
            multiple: false,
            clsOpen: "uk-open",
            toggle: "> .uk-accordion-title",
            content: "> .uk-accordion-content",
            offset: 0
        },
        computed: {
            items: ({ targets: targets }, $el)=>$$(targets, $el),
            toggles ({ toggle: toggle }) {
                return this.items.map((item)=>$(toggle, item));
            },
            contents ({ content: content }) {
                return this.items.map((item)=>{
                    var _a;
                    return ((_a = item._wrapper) == null ? void 0 : _a.firstElementChild) || $(content, item);
                });
            }
        },
        watch: {
            items (items, prev) {
                if (prev || hasClass(items, this.clsOpen)) return;
                const active = this.active !== false && items[Number(this.active)] || !this.collapsible && items[0];
                if (active) this.toggle(active, false);
            },
            toggles () {
                this.$emit();
            },
            contents (items) {
                for (const el of items){
                    const isOpen = hasClass(this.items.find((item)=>item.contains(el)), this.clsOpen);
                    hide(el, !isOpen);
                }
                this.$emit();
            }
        },
        observe: lazyload(),
        events: [
            {
                name: "click keydown",
                delegate: ({ targets: targets, $props: $props })=>`${targets} ${$props.toggle}`,
                async handler (e) {
                    var _a;
                    if (e.type === "keydown" && e.keyCode !== keyMap.SPACE) return;
                    e.preventDefault();
                    (_a = this._off) == null || _a.call(this);
                    this._off = keepScrollPosition(e.target);
                    await this.toggle(index(this.toggles, e.current));
                    this._off();
                }
            },
            {
                name: "shown hidden",
                self: true,
                delegate: ({ targets: targets })=>targets,
                handler () {
                    this.$emit();
                }
            }
        ],
        update () {
            const activeItems = filter$1(this.items, `.${this.clsOpen}`);
            for(const index2 in this.items){
                const toggle = this.toggles[index2];
                const content = this.contents[index2];
                if (!toggle || !content) continue;
                toggle.id = generateId(this, toggle);
                content.id = generateId(this, content);
                const active = includes(activeItems, this.items[index2]);
                attr(toggle, {
                    role: isTag(toggle, "a") ? "button" : null,
                    "aria-controls": content.id,
                    "aria-expanded": active,
                    "aria-disabled": !this.collapsible && activeItems.length < 2 && active
                });
                attr(content, {
                    role: "region",
                    "aria-labelledby": toggle.id
                });
                if (isTag(content, "ul")) attr(children(content), "role", "presentation");
            }
        },
        methods: {
            toggle (item, animate) {
                item = this.items[getIndex(item, this.items)];
                let items = [
                    item
                ];
                const activeItems = filter$1(this.items, `.${this.clsOpen}`);
                if (!this.multiple && !includes(activeItems, items[0])) items = items.concat(activeItems);
                if (!this.collapsible && activeItems.length < 2 && includes(activeItems, item)) return;
                return Promise.all(items.map((el)=>this.toggleElement(el, !includes(activeItems, el), (el2, show)=>{
                        toggleClass(el2, this.clsOpen, show);
                        if (animate === false || !this.animation) {
                            hide($(this.content, el2), !show);
                            return;
                        }
                        return transition(el2, show, this);
                    })));
            }
        }
    };
    function hide(el, hide2) {
        el && (el.hidden = hide2);
    }
    async function transition(el, show, { content: content, duration: duration, velocity: velocity, transition: transition2 }) {
        var _a;
        content = ((_a = el._wrapper) == null ? void 0 : _a.firstElementChild) || $(content, el);
        if (!el._wrapper) el._wrapper = wrapAll(content, "<div>");
        const wrapper = el._wrapper;
        css(wrapper, "overflow", "hidden");
        const currentHeight = toFloat(css(wrapper, "height"));
        await Transition.cancel(wrapper);
        hide(content, false);
        const endHeight = sumBy([
            "marginTop",
            "marginBottom"
        ], (prop)=>css(content, prop)) + dimensions$1(content).height;
        const percent = currentHeight / endHeight;
        duration = (velocity * endHeight + duration) * (show ? 1 - percent : percent);
        css(wrapper, "height", currentHeight);
        await Transition.start(wrapper, {
            height: show ? endHeight : 0
        }, duration, transition2);
        unwrap(content);
        delete el._wrapper;
        if (!show) hide(content, true);
    }
    function keepScrollPosition(el) {
        const scrollElement = scrollParent(el, true);
        let frame;
        (function scroll() {
            frame = requestAnimationFrame(()=>{
                const { top: top } = dimensions$1(el);
                if (top < 0) scrollElement.scrollTop += top;
                scroll();
            });
        })();
        return ()=>requestAnimationFrame(()=>cancelAnimationFrame(frame));
    }
    var alert = {
        mixins: [
            Class,
            Togglable
        ],
        args: "animation",
        props: {
            animation: Boolean,
            close: String
        },
        data: {
            animation: true,
            selClose: ".uk-alert-close",
            duration: 150
        },
        events: {
            name: "click",
            delegate: ({ selClose: selClose })=>selClose,
            handler (e) {
                e.preventDefault();
                this.close();
            }
        },
        methods: {
            async close () {
                await this.toggleElement(this.$el, false, animate);
                this.$destroy(true);
            }
        }
    };
    function animate(el, show, { duration: duration, transition: transition, velocity: velocity }) {
        const height = toFloat(css(el, "height"));
        css(el, "height", height);
        return Transition.start(el, {
            height: 0,
            marginTop: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingBottom: 0,
            borderTop: 0,
            borderBottom: 0,
            opacity: 0
        }, velocity * height + duration, transition);
    }
    var Video = {
        args: "autoplay",
        props: {
            automute: Boolean,
            autoplay: Boolean
        },
        data: {
            automute: false,
            autoplay: true
        },
        beforeConnect () {
            if (this.autoplay === "inview" && !hasAttr(this.$el, "preload")) this.$el.preload = "none";
            if (isTag(this.$el, "iframe") && !hasAttr(this.$el, "allow")) this.$el.allow = "autoplay";
            if (this.autoplay === "hover") {
                if (isTag(this.$el, "video")) this.$el.tabindex = 0;
                else this.autoplay = true;
            }
            if (this.automute) mute(this.$el);
        },
        events: [
            {
                name: `${pointerEnter} focusin`,
                filter: ({ autoplay: autoplay })=>includes(autoplay, "hover"),
                handler (e) {
                    if (!isTouch(e) || !isPlaying(this.$el)) play(this.$el);
                    else pause(this.$el);
                }
            },
            {
                name: `${pointerLeave} focusout`,
                filter: ({ autoplay: autoplay })=>includes(autoplay, "hover"),
                handler (e) {
                    if (!isTouch(e)) pause(this.$el);
                }
            }
        ],
        observe: [
            intersection({
                filter: ({ $el: $el, autoplay: autoplay })=>autoplay !== "hover" && isVideo($el),
                handler ([{ isIntersecting: isIntersecting }]) {
                    if (!document.fullscreenElement) {
                        if (isIntersecting) {
                            if (this.autoplay) play(this.$el);
                        } else pause(this.$el);
                    }
                },
                args: {
                    intersecting: false
                },
                options: ({ $el: $el, autoplay: autoplay })=>({
                        root: autoplay === "inview" ? null : parent($el)
                    })
            })
        ]
    };
    function isPlaying(videoEl) {
        return !videoEl.paused && !videoEl.ended;
    }
    var cover = {
        mixins: [
            Video
        ],
        props: {
            width: Number,
            height: Number
        },
        data: {
            automute: true
        },
        created () {
            this.useObjectFit = isTag(this.$el, "img", "video");
        },
        observe: resize({
            target: ({ $el: $el })=>getPositionedParent($el) || parent($el),
            filter: ({ useObjectFit: useObjectFit })=>!useObjectFit
        }),
        update: {
            read () {
                if (this.useObjectFit) return false;
                const { ratio: ratio, cover: cover } = Dimensions;
                const { $el: $el, width: width, height: height } = this;
                let dim = {
                    width: width,
                    height: height
                };
                if (!width || !height) {
                    const intrinsic = {
                        width: $el.naturalWidth || $el.videoWidth || $el.clientWidth,
                        height: $el.naturalHeight || $el.videoHeight || $el.clientHeight
                    };
                    if (width) dim = ratio(intrinsic, "width", width);
                    else if (height) dim = ratio(intrinsic, "height", height);
                    else dim = intrinsic;
                }
                const { offsetHeight: coverHeight, offsetWidth: coverWidth } = getPositionedParent($el) || parent($el);
                const coverDim = cover(dim, {
                    width: coverWidth,
                    height: coverHeight
                });
                if (!coverDim.width || !coverDim.height) return false;
                return coverDim;
            },
            write ({ height: height, width: width }) {
                css(this.$el, {
                    height: height,
                    width: width
                });
            },
            events: [
                "resize"
            ]
        }
    };
    function getPositionedParent(el) {
        while(el = parent(el)){
            if (css(el, "position") !== "static") return el;
        }
    }
    let active;
    var drop = {
        mixins: [
            Container,
            Position,
            Togglable
        ],
        args: "pos",
        props: {
            mode: "list",
            toggle: Boolean,
            boundary: Boolean,
            boundaryX: Boolean,
            boundaryY: Boolean,
            target: Boolean,
            targetX: Boolean,
            targetY: Boolean,
            stretch: Boolean,
            delayShow: Number,
            delayHide: Number,
            autoUpdate: Boolean,
            clsDrop: String,
            animateOut: Boolean,
            bgScroll: Boolean,
            closeOnScroll: Boolean
        },
        data: {
            mode: [
                "click",
                "hover"
            ],
            toggle: "- *",
            boundary: false,
            boundaryX: false,
            boundaryY: false,
            target: false,
            targetX: false,
            targetY: false,
            stretch: false,
            delayShow: 0,
            delayHide: 800,
            autoUpdate: true,
            clsDrop: false,
            animateOut: false,
            bgScroll: true,
            animation: [
                "uk-animation-fade"
            ],
            cls: "uk-open",
            container: false,
            closeOnScroll: false
        },
        computed: {
            boundary ({ boundary: boundary, boundaryX: boundaryX, boundaryY: boundaryY }, $el) {
                return [
                    query(boundaryX || boundary, $el) || window,
                    query(boundaryY || boundary, $el) || window
                ];
            },
            target ({ target: target, targetX: targetX, targetY: targetY }, $el) {
                targetX || (targetX = target || this.targetEl);
                targetY || (targetY = target || this.targetEl);
                return [
                    targetX === true ? window : query(targetX, $el),
                    targetY === true ? window : query(targetY, $el)
                ];
            }
        },
        created () {
            this.tracker = new MouseTracker();
        },
        beforeConnect () {
            this.clsDrop = this.$props.clsDrop || this.$options.id;
        },
        connected () {
            addClass(this.$el, "uk-drop", this.clsDrop);
            if (this.toggle && !this.targetEl) this.targetEl = createToggleComponent(this);
            this._style = pick(this.$el.style, [
                "width",
                "height"
            ]);
        },
        disconnected () {
            if (this.isActive()) {
                this.hide(false);
                active = null;
            }
            css(this.$el, this._style);
        },
        events: [
            {
                name: "click",
                delegate: ()=>".uk-drop-close",
                handler (e) {
                    e.preventDefault();
                    this.hide(false);
                }
            },
            {
                name: "click",
                delegate: ()=>'a[href*="#"]',
                handler ({ defaultPrevented: defaultPrevented, current: current }) {
                    const { hash: hash } = current;
                    if (!defaultPrevented && hash && isSameSiteAnchor(current) && !this.$el.contains($(hash))) this.hide(false);
                }
            },
            {
                name: "beforescroll",
                handler () {
                    this.hide(false);
                }
            },
            {
                name: "toggle",
                self: true,
                handler (e, toggle) {
                    e.preventDefault();
                    if (this.isToggled()) this.hide(false);
                    else this.show(toggle == null ? void 0 : toggle.$el, false);
                }
            },
            {
                name: "toggleshow",
                self: true,
                handler (e, toggle) {
                    e.preventDefault();
                    this.show(toggle == null ? void 0 : toggle.$el);
                }
            },
            {
                name: "togglehide",
                self: true,
                handler (e) {
                    e.preventDefault();
                    if (!matches(this.$el, ":focus,:hover")) this.hide();
                }
            },
            {
                name: `${pointerEnter} focusin`,
                filter: ({ mode: mode })=>includes(mode, "hover"),
                handler (e) {
                    if (!isTouch(e)) this.clearTimers();
                }
            },
            {
                name: `${pointerLeave} focusout`,
                filter: ({ mode: mode })=>includes(mode, "hover"),
                handler (e) {
                    if (!isTouch(e) && e.relatedTarget) this.hide();
                }
            },
            {
                name: "toggled",
                self: true,
                handler (e, toggled) {
                    if (toggled) {
                        this.clearTimers();
                        this.position();
                    }
                }
            },
            {
                name: "show",
                self: true,
                handler () {
                    active = this;
                    this.tracker.init();
                    attr(this.targetEl, "aria-expanded", true);
                    const handlers = [
                        listenForResize(this),
                        listenForEscClose(this),
                        listenForBackgroundClose(this),
                        this.autoUpdate && listenForScroll(this),
                        this.closeOnScroll && listenForScrollClose(this)
                    ];
                    once(this.$el, "hide", ()=>handlers.forEach((handler)=>handler && handler()), {
                        self: true
                    });
                    if (!this.bgScroll) once(this.$el, "hidden", preventBackgroundScroll(this.$el), {
                        self: true
                    });
                }
            },
            {
                name: "beforehide",
                self: true,
                handler: "clearTimers"
            },
            {
                name: "hide",
                handler ({ target: target }) {
                    if (this.$el !== target) {
                        active = active === null && this.$el.contains(target) && this.isToggled() ? this : active;
                        return;
                    }
                    active = this.isActive() ? null : active;
                    this.tracker.cancel();
                    attr(this.targetEl, "aria-expanded", null);
                }
            }
        ],
        update: {
            write () {
                if (this.isToggled() && !hasClass(this.$el, this.clsEnter)) this.position();
            }
        },
        methods: {
            show (target = this.targetEl, delay = true) {
                if (this.isToggled() && target && this.targetEl && target !== this.targetEl) this.hide(false, false);
                this.targetEl = target;
                this.clearTimers();
                if (this.isActive()) return;
                if (active) {
                    if (delay && active.isDelaying()) {
                        this.showTimer = setTimeout(()=>matches(target, ":hover") && this.show(), 10);
                        return;
                    }
                    let prev;
                    while(active && prev !== active && !active.$el.contains(this.$el)){
                        prev = active;
                        active.hide(false, false);
                    }
                }
                if (this.container && parent(this.$el) !== this.container) append(this.container, this.$el);
                this.showTimer = setTimeout(()=>this.toggleElement(this.$el, true), delay && this.delayShow || 0);
            },
            hide (delay = true, animate = true) {
                const hide = ()=>this.toggleElement(this.$el, false, this.animateOut && animate);
                this.clearTimers();
                this.isDelayedHide = delay;
                if (delay && this.isDelaying()) this.hideTimer = setTimeout(this.hide, 50);
                else if (delay && this.delayHide) this.hideTimer = setTimeout(hide, this.delayHide);
                else hide();
            },
            clearTimers () {
                clearTimeout(this.showTimer);
                clearTimeout(this.hideTimer);
                this.showTimer = null;
                this.hideTimer = null;
            },
            isActive () {
                return active === this;
            },
            isDelaying () {
                return [
                    this.$el,
                    ...$$(".uk-drop", this.$el)
                ].some((el)=>this.tracker.movesTo(el));
            },
            position () {
                const restoreScrollPosition = storeScrollPosition(this.$el);
                removeClass(this.$el, "uk-drop-stack");
                css(this.$el, this._style);
                this.$el.hidden = true;
                const viewports = this.target.map((target)=>getViewport$1(this.$el, target));
                const viewportOffset = this.getViewportOffset(this.$el);
                const dirs = [
                    [
                        0,
                        [
                            "x",
                            "width",
                            "left",
                            "right"
                        ]
                    ],
                    [
                        1,
                        [
                            "y",
                            "height",
                            "top",
                            "bottom"
                        ]
                    ]
                ];
                for (const [i, [axis, prop]] of dirs)if (this.axis !== axis && includes([
                    axis,
                    true
                ], this.stretch)) css(this.$el, {
                    [prop]: Math.min(offset(this.boundary[i])[prop], viewports[i][prop] - 2 * viewportOffset),
                    [`overflow-${axis}`]: "auto"
                });
                const maxWidth = viewports[0].width - 2 * viewportOffset;
                this.$el.hidden = false;
                css(this.$el, "maxWidth", "");
                if (this.$el.offsetWidth > maxWidth) addClass(this.$el, "uk-drop-stack");
                css(this.$el, "maxWidth", maxWidth);
                this.positionAt(this.$el, this.target, this.boundary);
                for (const [i, [axis, prop, start, end]] of dirs)if (this.axis === axis && includes([
                    axis,
                    true
                ], this.stretch)) {
                    const positionOffset = Math.abs(this.getPositionOffset());
                    const targetOffset = offset(this.target[i]);
                    const elOffset = offset(this.$el);
                    css(this.$el, {
                        [prop]: (targetOffset[start] > elOffset[start] ? targetOffset[this.inset ? end : start] - Math.max(offset(this.boundary[i])[start], viewports[i][start] + viewportOffset) : Math.min(offset(this.boundary[i])[end], viewports[i][end] - viewportOffset) - targetOffset[this.inset ? start : end]) - positionOffset,
                        [`overflow-${axis}`]: "auto"
                    });
                    this.positionAt(this.$el, this.target, this.boundary);
                }
                restoreScrollPosition();
            }
        }
    };
    function getViewport$1(el, target) {
        return offsetViewport(overflowParents(target).find((parent2)=>parent2.contains(el)));
    }
    function createToggleComponent(drop) {
        const { $el: $el } = drop.$create("toggle", query(drop.toggle, drop.$el), {
            target: drop.$el,
            mode: drop.mode
        });
        attr($el, "aria-haspopup", true);
        return $el;
    }
    function listenForResize(drop) {
        const update = ()=>drop.$emit();
        const off = [
            observeViewportResize(update),
            observeResize(overflowParents(drop.$el).concat(drop.target), update)
        ];
        return ()=>off.map((observer)=>observer.disconnect());
    }
    function listenForScroll(drop, fn = ()=>drop.$emit()) {
        return on([
            document,
            ...overflowParents(drop.$el)
        ], "scroll", fn, {
            passive: true
        });
    }
    function listenForEscClose(drop) {
        return on(document, "keydown", (e)=>{
            if (e.keyCode === keyMap.ESC) drop.hide(false);
        });
    }
    function listenForScrollClose(drop) {
        return listenForScroll(drop, ()=>drop.hide(false));
    }
    function listenForBackgroundClose(drop) {
        return on(document, pointerDown$1, ({ target: target })=>{
            if (drop.$el.contains(target)) return;
            once(document, `${pointerUp$1} ${pointerCancel} scroll`, ({ defaultPrevented: defaultPrevented, type: type, target: newTarget })=>{
                var _a;
                if (!defaultPrevented && type === pointerUp$1 && target === newTarget && !((_a = drop.targetEl) == null ? void 0 : _a.contains(target))) drop.hide(false);
            }, true);
        });
    }
    var Dropnav = {
        mixins: [
            Class,
            Container
        ],
        props: {
            align: String,
            clsDrop: String,
            boundary: Boolean,
            dropbar: Boolean,
            dropbarAnchor: Boolean,
            duration: Number,
            mode: Boolean,
            offset: Boolean,
            stretch: Boolean,
            delayShow: Boolean,
            delayHide: Boolean,
            target: Boolean,
            targetX: Boolean,
            targetY: Boolean,
            animation: Boolean,
            animateOut: Boolean,
            closeOnScroll: Boolean
        },
        data: {
            align: isRtl ? "right" : "left",
            clsDrop: "uk-dropdown",
            clsDropbar: "uk-dropnav-dropbar",
            boundary: true,
            dropbar: false,
            dropbarAnchor: false,
            duration: 200,
            container: false,
            selNavItem: "> li > a, > ul > li > a"
        },
        computed: {
            dropbarAnchor: ({ dropbarAnchor: dropbarAnchor }, $el)=>query(dropbarAnchor, $el) || $el,
            dropbar ({ dropbar: dropbar }) {
                if (!dropbar) return null;
                dropbar = this._dropbar || query(dropbar, this.$el) || $(`+ .${this.clsDropbar}`, this.$el);
                return dropbar ? dropbar : this._dropbar = $("<div></div>");
            },
            dropContainer (_, $el) {
                return this.container || $el;
            },
            dropdowns ({ clsDrop: clsDrop }, $el) {
                var _a;
                const dropdowns = $$(`.${clsDrop}`, $el);
                if (this.dropContainer !== $el) for (const el of $$(`.${clsDrop}`, this.dropContainer)){
                    const target = (_a = this.getDropdown(el)) == null ? void 0 : _a.targetEl;
                    if (!includes(dropdowns, el) && target && this.$el.contains(target)) dropdowns.push(el);
                }
                return dropdowns;
            },
            items ({ selNavItem: selNavItem }, $el) {
                return $$(selNavItem, $el);
            }
        },
        watch: {
            dropbar (dropbar) {
                addClass(dropbar, "uk-dropbar", "uk-dropbar-top", this.clsDropbar, `uk-${this.$options.name}-dropbar`);
            },
            dropdowns () {
                this.initializeDropdowns();
            }
        },
        connected () {
            this.initializeDropdowns();
        },
        disconnected () {
            remove$1(this._dropbar);
            delete this._dropbar;
        },
        events: [
            {
                name: "mouseover focusin",
                delegate: ({ selNavItem: selNavItem })=>selNavItem,
                handler ({ current: current }) {
                    const active2 = this.getActive();
                    if (active2 && includes(active2.mode, "hover") && active2.targetEl && !current.contains(active2.targetEl) && !active2.isDelaying()) active2.hide(false);
                }
            },
            {
                name: "keydown",
                self: true,
                delegate: ({ selNavItem: selNavItem })=>selNavItem,
                handler (e) {
                    var _a;
                    const { current: current, keyCode: keyCode } = e;
                    const active2 = this.getActive();
                    if (keyCode === keyMap.DOWN && (active2 == null ? void 0 : active2.targetEl) === current) {
                        e.preventDefault();
                        (_a = $(selFocusable, active2.$el)) == null || _a.focus();
                    }
                    handleNavItemNavigation(e, this.items, active2);
                }
            },
            {
                name: "keydown",
                el: ({ dropContainer: dropContainer })=>dropContainer,
                delegate: ({ clsDrop: clsDrop })=>`.${clsDrop}`,
                handler (e) {
                    var _a;
                    const { current: current, keyCode: keyCode, target: target } = e;
                    if (isInput(target) || !includes(this.dropdowns, current)) return;
                    const active2 = this.getActive();
                    let next = -1;
                    if (keyCode === keyMap.HOME) next = 0;
                    else if (keyCode === keyMap.END) next = "last";
                    else if (keyCode === keyMap.UP) next = "previous";
                    else if (keyCode === keyMap.DOWN) next = "next";
                    else if (keyCode === keyMap.ESC) (_a = active2.targetEl) == null || _a.focus();
                    if (~next) {
                        e.preventDefault();
                        const elements = $$(selFocusable, current);
                        elements[getIndex(next, elements, findIndex(elements, (el)=>matches(el, ":focus")))].focus();
                    }
                    handleNavItemNavigation(e, this.items, active2);
                }
            },
            {
                name: "mouseleave",
                el: ({ dropbar: dropbar })=>dropbar,
                filter: ({ dropbar: dropbar })=>dropbar,
                handler () {
                    const active2 = this.getActive();
                    if (active2 && includes(active2.mode, "hover") && !this.dropdowns.some((el)=>matches(el, ":hover"))) active2.hide();
                }
            },
            {
                name: "beforeshow",
                el: ({ dropContainer: dropContainer })=>dropContainer,
                filter: ({ dropbar: dropbar })=>dropbar,
                handler ({ target: target }) {
                    if (!this.isDropbarDrop(target)) return;
                    if (this.dropbar.previousElementSibling !== this.dropbarAnchor) after(this.dropbarAnchor, this.dropbar);
                    addClass(target, `${this.clsDrop}-dropbar`);
                }
            },
            {
                name: "show",
                el: ({ dropContainer: dropContainer })=>dropContainer,
                filter: ({ dropbar: dropbar })=>dropbar,
                handler ({ target: target }) {
                    if (!this.isDropbarDrop(target)) return;
                    const drop = this.getDropdown(target);
                    const adjustHeight = ()=>{
                        const maxBottom = Math.max(...parents(target, `.${this.clsDrop}`).concat(target).map((el)=>offset(el).bottom));
                        offset(this.dropbar, {
                            left: offset(this.dropbar).left,
                            top: this.getDropbarOffset(drop.getPositionOffset())
                        });
                        this.transitionTo(maxBottom - offset(this.dropbar).top + toFloat(css(target, "marginBottom")), target);
                    };
                    this._observer = observeResize([
                        drop.$el,
                        ...drop.target
                    ], adjustHeight);
                    adjustHeight();
                }
            },
            {
                name: "beforehide",
                el: ({ dropContainer: dropContainer })=>dropContainer,
                filter: ({ dropbar: dropbar })=>dropbar,
                handler (e) {
                    const active2 = this.getActive();
                    if (matches(this.dropbar, ":hover") && active2.$el === e.target && this.isDropbarDrop(active2.$el) && includes(active2.mode, "hover") && active2.isDelayedHide && !this.items.some((el)=>active2.targetEl !== el && matches(el, ":focus"))) e.preventDefault();
                }
            },
            {
                name: "hide",
                el: ({ dropContainer: dropContainer })=>dropContainer,
                filter: ({ dropbar: dropbar })=>dropbar,
                handler ({ target: target }) {
                    var _a;
                    if (!this.isDropbarDrop(target)) return;
                    (_a = this._observer) == null || _a.disconnect();
                    const active2 = this.getActive();
                    if (!active2 || active2.$el === target) this.transitionTo(0);
                }
            }
        ],
        methods: {
            getActive () {
                var _a;
                return includes(this.dropdowns, (_a = active) == null ? void 0 : _a.$el) && active;
            },
            async transitionTo (newHeight, el) {
                const { dropbar: dropbar } = this;
                const oldHeight = height(dropbar);
                el = oldHeight < newHeight && el;
                await Transition.cancel([
                    el,
                    dropbar
                ]);
                if (el) {
                    const diff = offset(el).top - offset(dropbar).top - oldHeight;
                    if (diff > 0) css(el, "transitionDelay", `${diff / newHeight * this.duration}ms`);
                }
                css(el, "clipPath", `polygon(0 0,100% 0,100% ${oldHeight}px,0 ${oldHeight}px)`);
                height(dropbar, oldHeight);
                await Promise.all([
                    Transition.start(dropbar, {
                        height: newHeight
                    }, this.duration),
                    Transition.start(el, {
                        clipPath: `polygon(0 0,100% 0,100% ${newHeight}px,0 ${newHeight}px)`
                    }, this.duration).finally(()=>css(el, {
                            clipPath: "",
                            transitionDelay: ""
                        }))
                ]).catch(noop);
            },
            getDropdown (el) {
                return this.$getComponent(el, "drop") || this.$getComponent(el, "dropdown");
            },
            isDropbarDrop (el) {
                return includes(this.dropdowns, el) && hasClass(el, this.clsDrop);
            },
            getDropbarOffset (offsetTop) {
                const { $el: $el, target: target, targetY: targetY } = this;
                const { top: top, height: height2 } = offset(query(targetY || target || $el, $el));
                return top + height2 + offsetTop;
            },
            initializeDropdowns () {
                this.$create("drop", this.dropdowns.filter((el)=>!this.getDropdown(el)), {
                    ...this.$props,
                    flip: false,
                    shift: true,
                    pos: `bottom-${this.align}`,
                    boundary: this.boundary === true ? this.$el : this.boundary
                });
            }
        }
    };
    function handleNavItemNavigation(e, toggles, active2) {
        var _a, _b, _c;
        const { current: current, keyCode: keyCode } = e;
        let next = -1;
        if (keyCode === keyMap.HOME) next = 0;
        else if (keyCode === keyMap.END) next = "last";
        else if (keyCode === keyMap.LEFT) next = "previous";
        else if (keyCode === keyMap.RIGHT) next = "next";
        else if (keyCode === keyMap.TAB) {
            (_a = active2.targetEl) == null || _a.focus();
            (_b = active2.hide) == null || _b.call(active2, false);
        }
        if (~next) {
            e.preventDefault();
            (_c = active2.hide) == null || _c.call(active2, false);
            toggles[getIndex(next, toggles, toggles.indexOf(active2.targetEl || current))].focus();
        }
    }
    var formCustom = {
        mixins: [
            Class
        ],
        args: "target",
        props: {
            target: Boolean
        },
        data: {
            target: false
        },
        computed: {
            input: (_, $el)=>$(selInput, $el),
            state () {
                return this.input.nextElementSibling;
            },
            target ({ target: target }, $el) {
                return target && (target === true && parent(this.input) === $el && this.input.nextElementSibling || $(target, $el));
            }
        },
        update () {
            var _a;
            const { target: target, input: input } = this;
            if (!target) return;
            let option;
            const prop = isInput(target) ? "value" : "textContent";
            const prev = target[prop];
            const value = ((_a = input.files) == null ? void 0 : _a[0]) ? input.files[0].name : matches(input, "select") && (option = $$("option", input).filter((el)=>el.selected)[0]) ? option.textContent : input.value;
            if (prev !== value) target[prop] = value;
        },
        events: [
            {
                name: "change",
                handler () {
                    this.$emit();
                }
            },
            {
                name: "reset",
                el: ({ $el: $el })=>$el.closest("form"),
                handler () {
                    this.$emit();
                }
            }
        ]
    };
    var grid = {
        extends: Margin,
        mixins: [
            Class
        ],
        name: "grid",
        props: {
            masonry: Boolean,
            parallax: String,
            parallaxStart: String,
            parallaxEnd: String,
            parallaxJustify: Boolean
        },
        data: {
            margin: "uk-grid-margin",
            clsStack: "uk-grid-stack",
            masonry: false,
            parallax: 0,
            parallaxStart: 0,
            parallaxEnd: 0,
            parallaxJustify: false
        },
        connected () {
            this.masonry && addClass(this.$el, "uk-flex-top", "uk-flex-wrap-top");
        },
        observe: scroll$1({
            filter: ({ parallax: parallax, parallaxJustify: parallaxJustify })=>parallax || parallaxJustify
        }),
        update: [
            {
                write ({ rows: rows }) {
                    toggleClass(this.$el, this.clsStack, !rows.some((row)=>row.length > 1));
                },
                events: [
                    "resize"
                ]
            },
            {
                read (data) {
                    const { rows: rows } = data;
                    let { masonry: masonry, parallax: parallax, parallaxJustify: parallaxJustify, margin: margin } = this;
                    parallax = Math.max(0, toPx(parallax));
                    if (!(masonry || parallax || parallaxJustify) || positionedAbsolute(rows) || rows[0].some((el, i)=>rows.some((row)=>row[i] && row[i].offsetWidth !== el.offsetWidth))) return data.translates = data.scrollColumns = false;
                    let gutter = getGutter(rows, margin);
                    let columns;
                    let translates;
                    if (masonry) [columns, translates] = applyMasonry(rows, gutter, masonry === "next");
                    else columns = transpose(rows);
                    const columnHeights = columns.map((column)=>sumBy(column, "offsetHeight") + gutter * (column.length - 1));
                    const height = Math.max(0, ...columnHeights);
                    let scrollColumns;
                    let parallaxStart;
                    let parallaxEnd;
                    if (parallax || parallaxJustify) {
                        scrollColumns = columnHeights.map((hgt, i)=>parallaxJustify ? height - hgt + parallax : parallax / (i % 2 || 8));
                        if (!parallaxJustify) parallax = Math.max(...columnHeights.map((hgt, i)=>hgt + scrollColumns[i] - height));
                        parallaxStart = toPx(this.parallaxStart, "height", this.$el, true);
                        parallaxEnd = toPx(this.parallaxEnd, "height", this.$el, true);
                    }
                    return {
                        columns: columns,
                        translates: translates,
                        scrollColumns: scrollColumns,
                        parallaxStart: parallaxStart,
                        parallaxEnd: parallaxEnd,
                        padding: parallax,
                        height: translates ? height : ""
                    };
                },
                write ({ height: height, padding: padding }) {
                    css(this.$el, "paddingBottom", padding || "");
                    height !== false && css(this.$el, "height", height);
                },
                events: [
                    "resize"
                ]
            },
            {
                read ({ rows: rows, scrollColumns: scrollColumns, parallaxStart: parallaxStart, parallaxEnd: parallaxEnd }) {
                    return {
                        scrolled: scrollColumns && !positionedAbsolute(rows) ? scrolledOver(this.$el, parallaxStart, parallaxEnd) : false
                    };
                },
                write ({ columns: columns, scrolled: scrolled, scrollColumns: scrollColumns, translates: translates }) {
                    if (!scrolled && !translates) return;
                    columns.forEach((column, i)=>column.forEach((el, j)=>{
                            let [x, y] = translates && translates[i][j] || [
                                0,
                                0
                            ];
                            if (scrolled) y += scrolled * scrollColumns[i];
                            css(el, "transform", `translate(${x}px, ${y}px)`);
                        }));
                },
                events: [
                    "scroll",
                    "resize"
                ]
            }
        ]
    };
    function positionedAbsolute(rows) {
        return rows.flat().some((el)=>css(el, "position") === "absolute");
    }
    function applyMasonry(rows, gutter, next) {
        const columns = [];
        const translates = [];
        const columnHeights = Array(rows[0].length).fill(0);
        let rowHeights = 0;
        for (let row of rows){
            if (isRtl) row = row.reverse();
            let height = 0;
            for(const j in row){
                const { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = row[j];
                const index = next ? j : columnHeights.indexOf(Math.min(...columnHeights));
                push(columns, index, row[j]);
                push(translates, index, [
                    (index - j) * offsetWidth * (isRtl ? -1 : 1),
                    columnHeights[index] - rowHeights
                ]);
                columnHeights[index] += offsetHeight + gutter;
                height = Math.max(height, offsetHeight);
            }
            rowHeights += height + gutter;
        }
        return [
            columns,
            translates
        ];
    }
    function getGutter(rows, cls) {
        const node = rows.flat().find((el)=>hasClass(el, cls));
        return toFloat(node ? css(node, "marginTop") : css(rows[0][0], "paddingLeft"));
    }
    function transpose(rows) {
        const columns = [];
        for (const row of rows)for(const i in row)push(columns, i, row[i]);
        return columns;
    }
    function push(array, index, value) {
        if (!array[index]) array[index] = [];
        array[index].push(value);
    }
    var heightMatch = {
        args: "target",
        props: {
            target: String,
            row: Boolean
        },
        data: {
            target: "> *",
            row: true
        },
        computed: {
            elements: ({ target: target }, $el)=>$$(target, $el)
        },
        observe: resize({
            target: ({ $el: $el, elements: elements })=>elements.reduce((elements2, el)=>elements2.concat(el, ...el.children), [
                    $el
                ])
        }),
        events: {
            // Hidden elements may change height when fonts load
            name: "loadingdone",
            el: ()=>document.fonts,
            handler () {
                this.$emit("resize");
            }
        },
        update: {
            read () {
                return {
                    rows: (this.row ? getRows(this.elements) : [
                        this.elements
                    ]).map(match)
                };
            },
            write ({ rows: rows }) {
                for (const { heights: heights, elements: elements } of rows)elements.forEach((el, i)=>css(el, "minHeight", heights[i]));
            },
            events: [
                "resize"
            ]
        }
    };
    function match(elements) {
        if (elements.length < 2) return {
            heights: [
                ""
            ],
            elements: elements
        };
        let heights = elements.map(getHeight);
        const max = Math.max(...heights);
        return {
            heights: elements.map((el, i)=>heights[i].toFixed(2) === max.toFixed(2) ? "" : max),
            elements: elements
        };
    }
    function getHeight(element) {
        const style = pick(element.style, [
            "display",
            "minHeight"
        ]);
        if (!isVisible(element)) css(element, "display", "block", "important");
        css(element, "minHeight", "");
        const height = dimensions$1(element).height - boxModelAdjust(element, "height", "content-box");
        css(element, style);
        return height;
    }
    var heightPlaceholder = {
        args: "target",
        props: {
            target: String
        },
        data: {
            target: ""
        },
        computed: {
            target: {
                get: ({ target: target }, $el)=>query(target, $el),
                observe: ({ target: target })=>target
            }
        },
        observe: resize({
            target: ({ target: target })=>target
        }),
        update: {
            read () {
                return this.target ? {
                    height: this.target.offsetHeight
                } : false;
            },
            write ({ height: height }) {
                css(this.$el, {
                    minHeight: height
                });
            },
            events: [
                "resize"
            ]
        }
    };
    var heightViewport = {
        props: {
            expand: Boolean,
            offsetTop: Boolean,
            offsetBottom: Boolean,
            minHeight: Number
        },
        data: {
            expand: false,
            offsetTop: false,
            offsetBottom: false,
            minHeight: 0
        },
        // check for offsetTop change
        observe: [
            viewport({
                filter: ({ expand: expand })=>expand
            }),
            resize({
                target: ({ $el: $el })=>scrollParents($el)
            })
        ],
        update: {
            read () {
                if (!isVisible(this.$el)) return false;
                let minHeight = "";
                const box = boxModelAdjust(this.$el, "height", "content-box");
                const { body: body, scrollingElement: scrollingElement } = document;
                const scrollElement = scrollParent(this.$el);
                const { height: viewportHeight } = offsetViewport(scrollElement === body ? scrollingElement : scrollElement);
                const isScrollingElement = scrollingElement === scrollElement || body === scrollElement;
                minHeight = `calc(${isScrollingElement ? "100vh" : `${viewportHeight}px`}`;
                if (this.expand) {
                    const diff = dimensions$1(scrollElement).height - dimensions$1(this.$el).height;
                    minHeight += ` - ${diff}px`;
                } else {
                    if (this.offsetTop) {
                        if (isScrollingElement) {
                            const offsetTopEl = this.offsetTop === true ? this.$el : query(this.offsetTop, this.$el);
                            const { top: top } = offset(offsetTopEl);
                            minHeight += top > 0 && top < viewportHeight / 2 ? ` - ${top}px` : "";
                        } else minHeight += ` - ${boxModelAdjust(scrollElement, "height", css(scrollElement, "boxSizing"))}px`;
                    }
                    if (this.offsetBottom === true) minHeight += ` - ${dimensions$1(this.$el.nextElementSibling).height}px`;
                    else if (isNumeric(this.offsetBottom)) minHeight += ` - ${this.offsetBottom}vh`;
                    else if (this.offsetBottom && endsWith(this.offsetBottom, "px")) minHeight += ` - ${toFloat(this.offsetBottom)}px`;
                    else if (isString(this.offsetBottom)) minHeight += ` - ${dimensions$1(query(this.offsetBottom, this.$el)).height}px`;
                }
                minHeight += `${box ? ` - ${box}px` : ""})`;
                return {
                    minHeight: minHeight
                };
            },
            write ({ minHeight: minHeight }) {
                css(this.$el, "minHeight", `max(${this.minHeight || 0}px, ${minHeight})`);
            },
            events: [
                "resize"
            ]
        }
    };
    var closeIcon = '<svg width="14" height="14" viewBox="0 0 14 14"><line fill="none" stroke="#000" stroke-width="1.1" x1="1" y1="1" x2="13" y2="13"/><line fill="none" stroke="#000" stroke-width="1.1" x1="13" y1="1" x2="1" y2="13"/></svg>';
    var closeLarge = '<svg width="20" height="20" viewBox="0 0 20 20"><line fill="none" stroke="#000" stroke-width="1.4" x1="1" y1="1" x2="19" y2="19"/><line fill="none" stroke="#000" stroke-width="1.4" x1="19" y1="1" x2="1" y2="19"/></svg>';
    var dropParentIcon = '<svg width="12" height="12" viewBox="0 0 12 12"><polyline fill="none" stroke="#000" stroke-width="1.1" points="1 3.5 6 8.5 11 3.5"/></svg>';
    var marker = '<svg width="20" height="20" viewBox="0 0 20 20"><rect width="1" height="11" x="9" y="4"/><rect width="11" height="1" x="4" y="9"/></svg>';
    var navParentIconLarge = '<svg width="14" height="14" viewBox="0 0 14 14"><polyline fill="none" stroke="#000" stroke-width="1.1" points="1 4 7 10 13 4"/></svg>';
    var navParentIcon = '<svg width="12" height="12" viewBox="0 0 12 12"><polyline fill="none" stroke="#000" stroke-width="1.1" points="1 3.5 6 8.5 11 3.5"/></svg>';
    var navbarParentIcon = '<svg width="12" height="12" viewBox="0 0 12 12"><polyline fill="none" stroke="#000" stroke-width="1.1" points="1 3.5 6 8.5 11 3.5"/></svg>';
    var navbarToggleIcon = '<svg width="20" height="20" viewBox="0 0 20 20"><style>.uk-navbar-toggle-icon svg&gt;[class*=&quot;line-&quot;]{transition:0.2s ease-in-out;transition-property:transform, opacity;transform-origin:center;opacity:1}.uk-navbar-toggle-icon svg&gt;.line-3{opacity:0}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-3{opacity:1}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-2{transform:rotate(45deg)}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-3{transform:rotate(-45deg)}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-1,.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-4{opacity:0}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-1{transform:translateY(6px) scaleX(0)}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-4{transform:translateY(-6px) scaleX(0)}</style><rect width="20" height="2" y="3" class="line-1"/><rect width="20" height="2" y="9" class="line-2"/><rect width="20" height="2" y="9" class="line-3"/><rect width="20" height="2" y="15" class="line-4"/></svg>';
    var overlayIcon = '<svg width="40" height="40" viewBox="0 0 40 40"><rect width="1" height="40" x="19" y="0"/><rect width="40" height="1" x="0" y="19"/></svg>';
    var paginationNext = '<svg width="7" height="12" viewBox="0 0 7 12"><polyline fill="none" stroke="#000" stroke-width="1.2" points="1 1 6 6 1 11"/></svg>';
    var paginationPrevious = '<svg width="7" height="12" viewBox="0 0 7 12"><polyline fill="none" stroke="#000" stroke-width="1.2" points="6 1 1 6 6 11"/></svg>';
    var searchIcon = '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.1" cx="9" cy="9" r="7"/><path fill="none" stroke="#000" stroke-width="1.1" d="M14,14 L18,18 L14,14 Z"/></svg>';
    var searchLarge = '<svg width="40" height="40" viewBox="0 0 40 40"><circle fill="none" stroke="#000" stroke-width="1.8" cx="17.5" cy="17.5" r="16.5"/><line fill="none" stroke="#000" stroke-width="1.8" x1="38" y1="39" x2="29" y2="30"/></svg>';
    var searchMedium = '<svg width="24" height="24" viewBox="0 0 24 24"><circle fill="none" stroke="#000" stroke-width="1.1" cx="10.5" cy="10.5" r="9.5"/><line fill="none" stroke="#000" stroke-width="1.1" x1="23" y1="23" x2="17" y2="17"/></svg>';
    var slidenavNextLarge = '<svg width="25" height="40" viewBox="0 0 25 40"><polyline fill="none" stroke="#000" stroke-width="2" points="4.002,38.547 22.527,20.024 4,1.5"/></svg>';
    var slidenavNext = '<svg width="14" height="24" viewBox="0 0 14 24"><polyline fill="none" stroke="#000" stroke-width="1.4" points="1.225,23 12.775,12 1.225,1"/></svg>';
    var slidenavPreviousLarge = '<svg width="25" height="40" viewBox="0 0 25 40"><polyline fill="none" stroke="#000" stroke-width="2" points="20.527,1.5 2,20.024 20.525,38.547"/></svg>';
    var slidenavPrevious = '<svg width="14" height="24" viewBox="0 0 14 24"><polyline fill="none" stroke="#000" stroke-width="1.4" points="12.775,1 1.225,12 12.775,23"/></svg>';
    var spinner = '<svg width="30" height="30" viewBox="0 0 30 30"><circle fill="none" stroke="#000" cx="15" cy="15" r="14"/></svg>';
    var totop = '<svg width="18" height="10" viewBox="0 0 18 10"><polyline fill="none" stroke="#000" stroke-width="1.2" points="1 9 9 1 17 9"/></svg>';
    var Svg = {
        args: "src",
        props: {
            width: Number,
            height: Number,
            ratio: Number
        },
        data: {
            ratio: 1
        },
        connected () {
            this.svg = this.getSvg().then((el)=>{
                if (!this._connected) return;
                const svg = insertSVG(el, this.$el);
                if (this.svgEl && svg !== this.svgEl) remove$1(this.svgEl);
                applyWidthAndHeight.call(this, svg, el);
                return this.svgEl = svg;
            }, noop);
        },
        disconnected () {
            this.svg.then((svg)=>{
                if (this._connected) return;
                if (isVoidElement(this.$el)) this.$el.hidden = false;
                remove$1(svg);
                this.svgEl = null;
            });
            this.svg = null;
        },
        methods: {
            async getSvg () {}
        }
    };
    function insertSVG(el, root) {
        if (isVoidElement(root) || isTag(root, "canvas")) {
            root.hidden = true;
            const next = root.nextElementSibling;
            return equals(el, next) ? next : after(root, el);
        }
        const last = root.lastElementChild;
        return equals(el, last) ? last : append(root, el);
    }
    function equals(el, other) {
        return isTag(el, "svg") && isTag(other, "svg") && el.innerHTML === other.innerHTML;
    }
    function applyWidthAndHeight(el, ref) {
        const props = [
            "width",
            "height"
        ];
        let dimensions = props.map((prop)=>this[prop]);
        if (!dimensions.some((val)=>val)) dimensions = props.map((prop)=>attr(ref, prop));
        const viewBox = attr(ref, "viewBox");
        if (viewBox && !dimensions.some((val)=>val)) dimensions = viewBox.split(" ").slice(2);
        dimensions.forEach((val, i)=>attr(el, props[i], toFloat(val) * this.ratio || null));
    }
    var svg = {
        mixins: [
            Svg
        ],
        args: "src",
        props: {
            src: String,
            icon: String,
            attributes: "list",
            strokeAnimation: Boolean
        },
        data: {
            strokeAnimation: false
        },
        observe: [
            mutation({
                async handler () {
                    const svg = await this.svg;
                    if (svg) applyAttributes.call(this, svg);
                },
                options: {
                    attributes: true,
                    attributeFilter: [
                        "id",
                        "class",
                        "style"
                    ]
                }
            })
        ],
        async connected () {
            if (includes(this.src, "#")) [this.src, this.icon] = this.src.split("#");
            const svg = await this.svg;
            if (svg) {
                applyAttributes.call(this, svg);
                if (this.strokeAnimation) applyAnimation(svg);
            }
        },
        methods: {
            async getSvg () {
                if (isTag(this.$el, "img") && !this.$el.complete && this.$el.loading === "lazy") await new Promise((resolve)=>once(this.$el, "load", resolve));
                return parseSVG(await loadSVG(this.src), this.icon) || Promise.reject("SVG not found.");
            }
        }
    };
    function applyAttributes(el) {
        const { $el: $el } = this;
        addClass(el, attr($el, "class"), "uk-svg");
        for(let i = 0; i < $el.style.length; i++){
            const prop = $el.style[i];
            css(el, prop, css($el, prop));
        }
        for(const attribute in this.attributes){
            const [prop, value] = this.attributes[attribute].split(":", 2);
            attr(el, prop, value);
        }
        if (!this.$el.id) removeAttr(el, "id");
    }
    const loadSVG = memoize(async (src)=>{
        if (src) {
            if (startsWith(src, "data:")) return decodeURIComponent(src.split(",")[1]);
            else return (await fetch(src)).text();
        } else return Promise.reject();
    });
    function parseSVG(svg, icon) {
        if (icon && includes(svg, "<symbol")) svg = parseSymbols(svg)[icon] || svg;
        return stringToSvg(svg);
    }
    const symbolRe = /<symbol([^]*?id=(['"])(.+?)\2[^]*?<\/)symbol>/g;
    const parseSymbols = memoize(function(svg) {
        const symbols = {};
        symbolRe.lastIndex = 0;
        let match;
        while(match = symbolRe.exec(svg))symbols[match[3]] = `<svg ${match[1]}svg>`;
        return symbols;
    });
    function applyAnimation(el) {
        const length = getMaxPathLength(el);
        if (length) css(el, "--uk-animation-stroke", length);
    }
    function stringToSvg(string) {
        const container = document.createElement("template");
        container.innerHTML = string;
        return container.content.firstElementChild;
    }
    const icons = {
        spinner: spinner,
        totop: totop,
        marker: marker,
        "close-icon": closeIcon,
        "close-large": closeLarge,
        "drop-parent-icon": dropParentIcon,
        "nav-parent-icon": navParentIcon,
        "nav-parent-icon-large": navParentIconLarge,
        "navbar-parent-icon": navbarParentIcon,
        "navbar-toggle-icon": navbarToggleIcon,
        "overlay-icon": overlayIcon,
        "pagination-next": paginationNext,
        "pagination-previous": paginationPrevious,
        "search-icon": searchIcon,
        "search-medium": searchMedium,
        "search-large": searchLarge,
        "search-toggle-icon": searchIcon,
        "slidenav-next": slidenavNext,
        "slidenav-next-large": slidenavNextLarge,
        "slidenav-previous": slidenavPrevious,
        "slidenav-previous-large": slidenavPreviousLarge
    };
    const Icon = {
        install: install$1,
        mixins: [
            Svg
        ],
        args: "icon",
        props: {
            icon: String
        },
        isIcon: true,
        beforeConnect () {
            addClass(this.$el, "uk-icon");
        },
        methods: {
            async getSvg () {
                const icon = getIcon(this.icon);
                if (!icon) throw "Icon not found.";
                return icon;
            }
        }
    };
    const IconComponent = {
        args: false,
        extends: Icon,
        data: (vm)=>({
                icon: hyphenate(vm.constructor.options.name)
            }),
        beforeConnect () {
            addClass(this.$el, this.$options.id);
        }
    };
    const NavParentIcon = {
        extends: IconComponent,
        beforeConnect () {
            const icon = this.$props.icon;
            this.icon = this.$el.closest(".uk-nav-primary") ? `${icon}-large` : icon;
        }
    };
    const Search = {
        extends: IconComponent,
        mixins: [
            I18n
        ],
        i18n: {
            toggle: "Open Search",
            submit: "Submit Search"
        },
        beforeConnect () {
            const isToggle = hasClass(this.$el, "uk-search-toggle") || hasClass(this.$el, "uk-navbar-toggle");
            this.icon = isToggle ? "search-toggle-icon" : hasClass(this.$el, "uk-search-icon") && this.$el.closest(".uk-search-large") ? "search-large" : this.$el.closest(".uk-search-medium") ? "search-medium" : this.$props.icon;
            if (hasAttr(this.$el, "aria-label")) return;
            if (isToggle) {
                const label = this.t("toggle");
                attr(this.$el, "aria-label", label);
            } else {
                const button = this.$el.closest("a,button");
                if (button) {
                    const label = this.t("submit");
                    attr(button, "aria-label", label);
                }
            }
        }
    };
    const Spinner = {
        extends: IconComponent,
        beforeConnect () {
            attr(this.$el, "role", "status");
        },
        methods: {
            async getSvg () {
                const icon = await Icon.methods.getSvg.call(this);
                if (this.ratio !== 1) css($("circle", icon), "strokeWidth", 1 / this.ratio);
                return icon;
            }
        }
    };
    const ButtonComponent = {
        extends: IconComponent,
        mixins: [
            I18n
        ],
        beforeConnect () {
            const button = this.$el.closest("a,button");
            attr(button, "role", this.role !== null && isTag(button, "a") ? "button" : this.role);
            const label = this.t("label");
            if (label && !hasAttr(button, "aria-label")) attr(button, "aria-label", label);
        }
    };
    const Slidenav = {
        extends: ButtonComponent,
        beforeConnect () {
            addClass(this.$el, "uk-slidenav");
            const icon = this.$props.icon;
            this.icon = hasClass(this.$el, "uk-slidenav-large") ? `${icon}-large` : icon;
        }
    };
    const NavbarToggleIcon = {
        extends: ButtonComponent,
        i18n: {
            label: "Open menu"
        }
    };
    const Close = {
        extends: ButtonComponent,
        i18n: {
            label: "Close"
        },
        beforeConnect () {
            this.icon = `close-${hasClass(this.$el, "uk-close-large") ? "large" : "icon"}`;
        }
    };
    const Marker = {
        extends: ButtonComponent,
        i18n: {
            label: "Open"
        }
    };
    const Totop = {
        extends: ButtonComponent,
        i18n: {
            label: "Back to top"
        }
    };
    const PaginationNext = {
        extends: ButtonComponent,
        i18n: {
            label: "Next page"
        },
        data: {
            role: null
        }
    };
    const PaginationPrevious = {
        extends: ButtonComponent,
        i18n: {
            label: "Previous page"
        },
        data: {
            role: null
        }
    };
    const parsed = {};
    function install$1(UIkit) {
        UIkit.icon.add = (name, svg)=>{
            const added = isString(name) ? {
                [name]: svg
            } : name;
            each(added, (svg2, name2)=>{
                icons[name2] = svg2;
                delete parsed[name2];
            });
            if (UIkit._initialized) apply(document.body, (el)=>each(UIkit.getComponents(el), (cmp)=>{
                    cmp.$options.isIcon && cmp.icon in added && cmp.$reset();
                }));
        };
    }
    const aliases = {
        twitter: "x"
    };
    function getIcon(icon) {
        icon = aliases[icon] || icon;
        if (!icons[icon]) return null;
        if (!parsed[icon]) parsed[icon] = stringToSvg(icons[applyRtl(icon)] || icons[icon]);
        return parsed[icon].cloneNode(true);
    }
    function applyRtl(icon) {
        return isRtl ? swap(swap(icon, "left", "right"), "previous", "next") : icon;
    }
    var img = {
        args: "dataSrc",
        props: {
            dataSrc: String,
            sources: String,
            margin: String,
            target: String,
            loading: String
        },
        data: {
            dataSrc: "",
            sources: false,
            margin: "50%",
            target: false,
            loading: "lazy"
        },
        connected () {
            if (this.loading !== "lazy") this.load();
            else if (isImg(this.$el)) {
                this.$el.loading = "lazy";
                setSrcAttrs(this.$el);
            }
        },
        disconnected () {
            if (this.img) this.img.onload = "";
            delete this.img;
        },
        observe: intersection({
            handler (entries, observer) {
                this.load();
                observer.disconnect();
            },
            options: ({ margin: margin })=>({
                    rootMargin: margin
                }),
            filter: ({ loading: loading })=>loading === "lazy",
            target: ({ $el: $el, $props: $props })=>$props.target ? [
                    $el,
                    ...queryAll($props.target, $el)
                ] : $el
        }),
        methods: {
            load () {
                if (this.img) return this.img;
                const image = isImg(this.$el) ? this.$el : getImageFromElement(this.$el, this.dataSrc, this.sources);
                removeAttr(image, "loading");
                setSrcAttrs(this.$el, image.currentSrc);
                return this.img = image;
            }
        }
    };
    function setSrcAttrs(el, src) {
        if (isImg(el)) {
            const parentNode = parent(el);
            const elements = isTag(parentNode, "picture") ? children(parentNode) : [
                el
            ];
            elements.forEach((el2)=>setSourceProps(el2, el2));
        } else if (src) {
            const change = !includes(el.style.backgroundImage, src);
            if (change) {
                css(el, "backgroundImage", `url(${escape(src)})`);
                trigger(el, createEvent("load", false));
            }
        }
    }
    const srcProps = [
        "data-src",
        "data-srcset",
        "sizes"
    ];
    function setSourceProps(sourceEl, targetEl) {
        for (const prop of srcProps){
            const value = data(sourceEl, prop);
            if (value) attr(targetEl, prop.replace(/^(data-)+/, ""), value);
        }
    }
    function getImageFromElement(el, src, sources) {
        const img = new Image();
        wrapInPicture(img, sources);
        setSourceProps(el, img);
        img.onload = ()=>{
            setSrcAttrs(el, img.currentSrc);
        };
        attr(img, "src", src);
        return img;
    }
    function wrapInPicture(img, sources) {
        sources = parseSources(sources);
        if (sources.length) {
            const picture = fragment("<picture>");
            for (const attrs of sources){
                const source = fragment("<source>");
                attr(source, attrs);
                append(picture, source);
            }
            append(picture, img);
        }
    }
    function parseSources(sources) {
        if (!sources) return [];
        if (startsWith(sources, "[")) try {
            sources = JSON.parse(sources);
        } catch (e) {
            sources = [];
        }
        else sources = parseOptions(sources);
        if (!isArray(sources)) sources = [
            sources
        ];
        return sources.filter((source)=>!isEmpty(source));
    }
    function isImg(el) {
        return isTag(el, "img");
    }
    var inverse = {
        props: {
            target: String,
            selActive: String
        },
        data: {
            target: false,
            selActive: false
        },
        computed: {
            target: ({ target: target }, $el)=>target ? $$(target, $el) : $el
        },
        observe: [
            intersection({
                handler (entries) {
                    this.isIntersecting = entries.some(({ isIntersecting: isIntersecting })=>isIntersecting);
                    this.$emit();
                },
                target: ({ target: target })=>target,
                args: {
                    intersecting: false
                }
            }),
            mutation({
                target: ({ target: target })=>target,
                options: {
                    attributes: true,
                    attributeFilter: [
                        "class"
                    ],
                    attributeOldValue: true
                }
            }),
            {
                target: ({ target: target })=>target,
                observe: (target, handler)=>{
                    const observer = observeResize([
                        ...toNodes(target),
                        document.documentElement
                    ], handler);
                    const listener = [
                        on(document, "scroll itemshown itemhidden", handler, {
                            passive: true,
                            capture: true
                        }),
                        on(document, "show hide transitionstart", (e)=>{
                            handler();
                            return observer.observe(e.target);
                        }),
                        on(document, "shown hidden transitionend transitioncancel", (e)=>{
                            handler();
                            return observer.unobserve(e.target);
                        })
                    ];
                    return {
                        observe: observer.observe.bind(observer),
                        unobserve: observer.unobserve.bind(observer),
                        disconnect () {
                            observer.disconnect();
                            listener.map((off)=>off());
                        }
                    };
                },
                handler () {
                    this.$emit();
                }
            }
        ],
        update: {
            read () {
                if (!this.isIntersecting) return false;
                for (const target of toNodes(this.target)){
                    let color = !this.selActive || matches(target, this.selActive) ? findTargetColor(target) : "";
                    if (color !== false) replaceClass(target, "uk-light uk-dark", color);
                }
            }
        }
    };
    function findTargetColor(target) {
        const dim = dimensions$1(target);
        const viewport = dimensions$1(window);
        if (!intersectRect(dim, viewport)) return false;
        const { left: left, top: top, height: height, width: width } = dim;
        let last;
        for (const percent of [
            0.25,
            0.5,
            0.75
        ]){
            const elements = target.ownerDocument.elementsFromPoint(Math.max(0, Math.min(left + width * percent, viewport.width - 1)), Math.max(0, Math.min(top + height / 2, viewport.height - 1)));
            for (const element of elements){
                if (target.contains(element) || !checkVisibility(element) || element.closest('[class*="-leave"]') && elements.some((el)=>element !== el && matches(el, '[class*="-enter"]'))) continue;
                const color = css(element, "--uk-inverse");
                if (color) {
                    if (color === last) return `uk-${color}`;
                    last = color;
                    break;
                }
            }
        }
        return last ? `uk-${last}` : "";
    }
    function checkVisibility(element) {
        if (css(element, "visibility") !== "visible") return false;
        while(element){
            if (css(element, "opacity") === "0") return false;
            element = parent(element);
        }
        return true;
    }
    var leader = {
        mixins: [
            Class,
            Media
        ],
        props: {
            fill: String
        },
        data: {
            fill: "",
            clsWrapper: "uk-leader-fill",
            clsHide: "uk-leader-hide",
            attrFill: "data-fill"
        },
        computed: {
            fill: ({ fill: fill }, $el)=>fill || css($el, "--uk-leader-fill-content")
        },
        connected () {
            [this.wrapper] = wrapInner(this.$el, `<span class="${this.clsWrapper}">`);
        },
        disconnected () {
            unwrap(this.wrapper.childNodes);
        },
        observe: resize(),
        update: {
            read () {
                const width = Math.trunc(this.$el.offsetWidth / 2);
                return {
                    width: width,
                    fill: this.fill,
                    hide: !this.matchMedia
                };
            },
            write ({ width: width, fill: fill, hide: hide }) {
                toggleClass(this.wrapper, this.clsHide, hide);
                attr(this.wrapper, this.attrFill, new Array(width).join(fill));
            },
            events: [
                "resize"
            ]
        }
    };
    var modal = {
        install: install,
        mixins: [
            Modal
        ],
        data: {
            clsPage: "uk-modal-page",
            selPanel: ".uk-modal-dialog",
            selClose: '[class*="uk-modal-close"]'
        },
        events: [
            {
                name: "fullscreenchange webkitendfullscreen",
                capture: true,
                handler (e) {
                    if (isTag(e.target, "video") && this.isToggled() && !document.fullscreenElement) this.hide();
                }
            },
            {
                name: "show",
                self: true,
                handler () {
                    if (hasClass(this.panel, "uk-margin-auto-vertical")) addClass(this.$el, "uk-flex");
                    else css(this.$el, "display", "block");
                    height(this.$el);
                }
            },
            {
                name: "hidden",
                self: true,
                handler () {
                    css(this.$el, "display", "");
                    removeClass(this.$el, "uk-flex");
                }
            }
        ]
    };
    function install({ modal: modal }) {
        modal.dialog = function(content, options) {
            const dialog = modal($(`<div><div class="uk-modal-dialog">${content}</div></div>`), {
                stack: true,
                role: "alertdialog",
                ...options
            });
            dialog.show();
            on(dialog.$el, "hidden", async ()=>{
                await Promise.resolve();
                dialog.$destroy(true);
            }, {
                self: true
            });
            return dialog;
        };
        modal.alert = function(message, options) {
            return openDialog(({ i18n: i18n })=>`<div class="uk-modal-body">${isString(message) ? message : html(message)}</div> <div class="uk-modal-footer uk-text-right"> <button class="uk-button uk-button-primary uk-modal-close" autofocus>${i18n.ok}</button> </div>`, options);
        };
        modal.confirm = function(message, options) {
            return openDialog(({ i18n: i18n })=>`<form> <div class="uk-modal-body">${isString(message) ? message : html(message)}</div> <div class="uk-modal-footer uk-text-right"> <button class="uk-button uk-button-default uk-modal-close" type="button">${i18n.cancel}</button> <button class="uk-button uk-button-primary" autofocus>${i18n.ok}</button> </div> </form>`, options, ()=>Promise.reject());
        };
        modal.prompt = function(message, value, options) {
            const promise = openDialog(({ i18n: i18n })=>`<form class="uk-form-stacked"> <div class="uk-modal-body"> <label>${isString(message) ? message : html(message)}</label> <input class="uk-input" autofocus> </div> <div class="uk-modal-footer uk-text-right"> <button class="uk-button uk-button-default uk-modal-close" type="button">${i18n.cancel}</button> <button class="uk-button uk-button-primary">${i18n.ok}</button> </div> </form>`, options, ()=>null, ()=>input.value);
            const { $el: $el } = promise.dialog;
            const input = $("input", $el);
            input.value = value || "";
            on($el, "show", ()=>input.select());
            return promise;
        };
        modal.i18n = {
            ok: "Ok",
            cancel: "Cancel"
        };
        function openDialog(tmpl, options, hideFn = noop, submitFn = noop) {
            options = {
                bgClose: false,
                escClose: true,
                ...options,
                i18n: {
                    ...modal.i18n,
                    ...options == null ? void 0 : options.i18n
                }
            };
            const dialog = modal.dialog(tmpl(options), options);
            return assign(new Promise((resolve)=>{
                const off = on(dialog.$el, "hide", ()=>resolve(hideFn()));
                on(dialog.$el, "submit", "form", (e)=>{
                    e.preventDefault();
                    resolve(submitFn(dialog));
                    off();
                    dialog.hide();
                });
            }), {
                dialog: dialog
            });
        }
    }
    var nav = {
        extends: Accordion,
        data: {
            targets: "> .uk-parent",
            toggle: "> a",
            content: "> ul"
        }
    };
    const clsNavbarTransparent = "uk-navbar-transparent";
    var navbar = {
        extends: Dropnav,
        props: {
            dropbarTransparentMode: Boolean
        },
        data: {
            clsDrop: "uk-navbar-dropdown",
            selNavItem: ".uk-navbar-nav > li > a,a.uk-navbar-item,button.uk-navbar-item,.uk-navbar-item a,.uk-navbar-item button,.uk-navbar-toggle",
            // Simplify with :where() selector once browser target is Safari 14+
            dropbarTransparentMode: false
        },
        computed: {
            navbarContainer: (_, $el)=>$el.closest(".uk-navbar-container")
        },
        watch: {
            items () {
                const justify = hasClass(this.$el, "uk-navbar-justify");
                const containers = $$(".uk-navbar-nav, .uk-navbar-left, .uk-navbar-right", this.$el);
                for (const container of containers){
                    const items = justify ? $$(".uk-navbar-nav > li > a, .uk-navbar-item, .uk-navbar-toggle", container).length : "";
                    css(container, "flexGrow", items);
                }
            }
        },
        events: [
            {
                name: "show",
                el: ({ dropContainer: dropContainer })=>dropContainer,
                handler ({ target: target }) {
                    if (this.getTransparentMode(target) === "remove" && hasClass(this.navbarContainer, clsNavbarTransparent)) {
                        removeClass(this.navbarContainer, clsNavbarTransparent);
                        this._transparent = true;
                    }
                }
            },
            {
                name: "hide",
                el: ({ dropContainer: dropContainer })=>dropContainer,
                async handler () {
                    await awaitMacroTask();
                    if (!this.getActive() && this._transparent) {
                        addClass(this.navbarContainer, clsNavbarTransparent);
                        this._transparent = null;
                    }
                }
            }
        ],
        methods: {
            getTransparentMode (el) {
                if (!this.navbarContainer) return;
                if (this.dropbar && this.isDropbarDrop(el)) return this.dropbarTransparentMode;
                const drop = this.getDropdown(el);
                if (drop && hasClass(el, "uk-dropbar")) return drop.inset ? "behind" : "remove";
            },
            getDropbarOffset (offsetTop) {
                const { top: top, height: height } = offset(this.navbarContainer);
                return top + (this.dropbarTransparentMode === "behind" ? 0 : height + offsetTop);
            }
        }
    };
    function awaitMacroTask() {
        return new Promise((resolve)=>setTimeout(resolve));
    }
    var offcanvas = {
        mixins: [
            Modal
        ],
        args: "mode",
        props: {
            mode: String,
            flip: Boolean,
            overlay: Boolean,
            swiping: Boolean
        },
        data: {
            mode: "slide",
            flip: false,
            overlay: false,
            clsPage: "uk-offcanvas-page",
            clsContainer: "uk-offcanvas-container",
            selPanel: ".uk-offcanvas-bar",
            clsFlip: "uk-offcanvas-flip",
            clsContainerAnimation: "uk-offcanvas-container-animation",
            clsSidebarAnimation: "uk-offcanvas-bar-animation",
            clsMode: "uk-offcanvas",
            clsOverlay: "uk-offcanvas-overlay",
            selClose: ".uk-offcanvas-close",
            container: false,
            swiping: true
        },
        computed: {
            clsFlip: ({ flip: flip, clsFlip: clsFlip })=>flip ? clsFlip : "",
            clsOverlay: ({ overlay: overlay, clsOverlay: clsOverlay })=>overlay ? clsOverlay : "",
            clsMode: ({ mode: mode, clsMode: clsMode })=>`${clsMode}-${mode}`,
            clsSidebarAnimation: ({ mode: mode, clsSidebarAnimation: clsSidebarAnimation })=>mode === "none" || mode === "reveal" ? "" : clsSidebarAnimation,
            clsContainerAnimation: ({ mode: mode, clsContainerAnimation: clsContainerAnimation })=>mode !== "push" && mode !== "reveal" ? "" : clsContainerAnimation,
            transitionElement ({ mode: mode }) {
                return mode === "reveal" ? parent(this.panel) : this.panel;
            }
        },
        observe: swipe({
            filter: ({ swiping: swiping })=>swiping
        }),
        update: {
            read () {
                if (this.isToggled() && !isVisible(this.$el)) this.hide();
            },
            events: [
                "resize"
            ]
        },
        events: [
            {
                name: "touchmove",
                self: true,
                passive: false,
                filter: ({ overlay: overlay })=>overlay,
                handler (e) {
                    e.cancelable && e.preventDefault();
                }
            },
            {
                name: "show",
                self: true,
                handler () {
                    if (this.mode === "reveal" && !hasClass(parent(this.panel), this.clsMode)) addClass(wrapAll(this.panel, "<div>"), this.clsMode);
                    const { body: body, scrollingElement: scrollingElement } = document;
                    addClass(body, this.clsContainer, this.clsFlip);
                    css(body, "touchAction", "pan-y pinch-zoom");
                    css(this.$el, "display", "block");
                    css(this.panel, "maxWidth", scrollingElement.clientWidth);
                    addClass(this.$el, this.clsOverlay);
                    addClass(this.panel, this.clsSidebarAnimation, this.mode === "reveal" ? "" : this.clsMode);
                    height(body);
                    addClass(body, this.clsContainerAnimation);
                    this.clsContainerAnimation && suppressUserScale();
                }
            },
            {
                name: "hide",
                self: true,
                handler () {
                    removeClass(document.body, this.clsContainerAnimation);
                    css(document.body, "touchAction", "");
                }
            },
            {
                name: "hidden",
                self: true,
                handler () {
                    this.clsContainerAnimation && resumeUserScale();
                    if (this.mode === "reveal" && hasClass(parent(this.panel), this.clsMode)) unwrap(this.panel);
                    removeClass(this.panel, this.clsSidebarAnimation, this.clsMode);
                    removeClass(this.$el, this.clsOverlay);
                    css(this.$el, "display", "");
                    css(this.panel, "maxWidth", "");
                    removeClass(document.body, this.clsContainer, this.clsFlip);
                }
            },
            {
                name: "swipeLeft swipeRight",
                handler (e) {
                    if (this.isToggled() && endsWith(e.type, "Left") ^ this.flip) this.hide();
                }
            }
        ]
    };
    function suppressUserScale() {
        getViewport().content += ",user-scalable=0";
    }
    function resumeUserScale() {
        const viewport = getViewport();
        viewport.content = viewport.content.replace(/,user-scalable=0$/, "");
    }
    function getViewport() {
        return $('meta[name="viewport"]', document.head) || append(document.head, '<meta name="viewport">');
    }
    var overflowAuto = {
        mixins: [
            Class
        ],
        props: {
            selContainer: String,
            selContent: String,
            minHeight: Number
        },
        data: {
            selContainer: ".uk-modal",
            selContent: ".uk-modal-dialog",
            minHeight: 150
        },
        computed: {
            container: ({ selContainer: selContainer }, $el)=>$el.closest(selContainer),
            content: ({ selContent: selContent }, $el)=>$el.closest(selContent)
        },
        observe: resize({
            target: ({ container: container, content: content })=>[
                    container,
                    content
                ]
        }),
        update: {
            read () {
                if (!this.content || !this.container || !isVisible(this.$el)) return false;
                return {
                    max: Math.max(this.minHeight, height(this.container) - (dimensions$1(this.content).height - height(this.$el)))
                };
            },
            write ({ max: max }) {
                css(this.$el, {
                    minHeight: this.minHeight,
                    maxHeight: max
                });
            },
            events: [
                "resize"
            ]
        }
    };
    var responsive = {
        props: [
            "width",
            "height"
        ],
        connected () {
            addClass(this.$el, "uk-responsive-width");
            css(this.$el, "aspectRatio", `${this.width}/${this.height}`);
        }
    };
    var scroll = {
        props: {
            offset: Number
        },
        data: {
            offset: 0
        },
        connected () {
            registerClick(this);
        },
        disconnected () {
            unregisterClick(this);
        },
        methods: {
            async scrollTo (el) {
                el = el && $(el) || document.body;
                if (trigger(this.$el, "beforescroll", [
                    this,
                    el
                ])) {
                    await scrollIntoView(el, {
                        offset: this.offset
                    });
                    trigger(this.$el, "scrolled", [
                        this,
                        el
                    ]);
                }
            }
        }
    };
    const instances = /* @__PURE__ */ new Set();
    function registerClick(cmp) {
        if (!instances.size) on(document, "click", clickHandler);
        instances.add(cmp);
    }
    function unregisterClick(cmp) {
        instances.delete(cmp);
        if (!instances.size) off(document, "click", clickHandler);
    }
    function clickHandler(e) {
        if (e.defaultPrevented) return;
        for (const instance of instances)if (instance.$el.contains(e.target) && isSameSiteAnchor(instance.$el)) {
            e.preventDefault();
            if (window.location.href !== instance.$el.href) window.history.pushState({}, "", instance.$el.href);
            instance.scrollTo(getTargetedElement(instance.$el));
        }
    }
    const clsInView = "uk-scrollspy-inview";
    var scrollspy = {
        args: "cls",
        props: {
            cls: String,
            target: String,
            hidden: Boolean,
            margin: String,
            repeat: Boolean,
            delay: Number
        },
        data: ()=>({
                cls: "",
                target: false,
                hidden: true,
                margin: "-1px",
                repeat: false,
                delay: 0
            }),
        computed: {
            elements: ({ target: target }, $el)=>target ? $$(target, $el) : [
                    $el
                ]
        },
        watch: {
            elements (elements) {
                if (this.hidden) css(filter$1(elements, `:not(.${clsInView})`), "opacity", 0);
            }
        },
        connected () {
            this.elementData = /* @__PURE__ */ new Map();
        },
        disconnected () {
            for (const [el, state] of this.elementData.entries())removeClass(el, clsInView, (state == null ? void 0 : state.cls) || "");
            delete this.elementData;
        },
        observe: intersection({
            target: ({ elements: elements })=>elements,
            handler (records) {
                const elements = this.elementData;
                for (const { target: el, isIntersecting: isIntersecting } of records){
                    if (!elements.has(el)) elements.set(el, {
                        cls: data(el, "uk-scrollspy-class") || this.cls
                    });
                    const state = elements.get(el);
                    if (!this.repeat && state.show) continue;
                    state.show = isIntersecting;
                }
                this.$emit();
            },
            options: ({ margin: margin })=>({
                    rootMargin: margin
                }),
            args: {
                intersecting: false
            }
        }),
        update: [
            {
                write (data) {
                    for (const [el, state] of this.elementData.entries()){
                        if (state.show && !state.inview && !state.queued) {
                            state.queued = true;
                            data.promise = (data.promise || Promise.resolve()).then(()=>new Promise((resolve)=>setTimeout(resolve, this.delay))).then(()=>{
                                this.toggle(el, true);
                                setTimeout(()=>{
                                    state.queued = false;
                                    this.$emit();
                                }, 300);
                            });
                        } else if (!state.show && state.inview && !state.queued && this.repeat) this.toggle(el, false);
                    }
                }
            }
        ],
        methods: {
            toggle (el, inview) {
                var _a, _b;
                const state = (_a = this.elementData) == null ? void 0 : _a.get(el);
                if (!state) return;
                (_b = state.off) == null || _b.call(state);
                css(el, "opacity", !inview && this.hidden ? 0 : "");
                toggleClass(el, clsInView, inview);
                toggleClass(el, state.cls);
                let match;
                if (match = state.cls.match(/\buk-animation-[\w-]+/g)) {
                    const removeAnimationClasses = ()=>removeClass(el, match);
                    if (inview) state.off = once(el, "animationcancel animationend", removeAnimationClasses, {
                        self: true
                    });
                    else removeAnimationClasses();
                }
                trigger(el, inview ? "inview" : "outview");
                state.inview = inview;
            }
        }
    };
    var scrollspyNav = {
        props: {
            cls: String,
            closest: Boolean,
            scroll: Boolean,
            target: String,
            offset: Number
        },
        data: {
            cls: "uk-active",
            closest: false,
            scroll: false,
            target: 'a[href]:not([role="button"])',
            offset: 0
        },
        computed: {
            links: ({ target: target }, $el)=>$$(target, $el).filter((el)=>isSameSiteAnchor(el)),
            elements ({ closest: closest }) {
                return this.links.map((el)=>el.closest(closest || "*"));
            }
        },
        watch: {
            links (links) {
                if (this.scroll) this.$create("scroll", links, {
                    offset: this.offset
                });
            }
        },
        observe: [
            intersection(),
            scroll$1()
        ],
        update: [
            {
                read () {
                    const targets = this.links.map((el)=>getTargetedElement(el) || el.ownerDocument);
                    const { length: length } = targets;
                    if (!length || !isVisible(this.$el)) return false;
                    const scrollElement = scrollParent(targets, true);
                    const { scrollTop: scrollTop, scrollHeight: scrollHeight } = scrollElement;
                    const viewport = offsetViewport(scrollElement);
                    const max = scrollHeight - viewport.height;
                    let active = false;
                    if (scrollTop >= max) active = length - 1;
                    else {
                        const offsetBy = this.offset + dimensions$1(getCoveringElement()).height + viewport.height * 0.1;
                        for(let i = 0; i < targets.length; i++){
                            if (offset(targets[i]).top - viewport.top - offsetBy > 0) break;
                            active = +i;
                        }
                    }
                    return {
                        active: active
                    };
                },
                write ({ active: active }) {
                    const changed = active !== false && !hasClass(this.elements[active], this.cls);
                    this.links.forEach((el)=>el.blur());
                    for(let i = 0; i < this.elements.length; i++)toggleClass(this.elements[i], this.cls, +i === active);
                    if (changed) trigger(this.$el, "active", [
                        active,
                        this.elements[active]
                    ]);
                },
                events: [
                    "scroll",
                    "resize"
                ]
            }
        ]
    };
    var sticky = {
        mixins: [
            Class,
            Media
        ],
        props: {
            position: String,
            top: null,
            bottom: null,
            start: null,
            end: null,
            offset: String,
            overflowFlip: Boolean,
            animation: String,
            clsActive: String,
            clsInactive: String,
            clsFixed: String,
            clsBelow: String,
            selTarget: String,
            showOnUp: Boolean,
            targetOffset: Number
        },
        data: {
            position: "top",
            top: false,
            bottom: false,
            start: false,
            end: false,
            offset: 0,
            overflowFlip: false,
            animation: "",
            clsActive: "uk-active",
            clsInactive: "",
            clsFixed: "uk-sticky-fixed",
            clsBelow: "uk-sticky-below",
            selTarget: "",
            showOnUp: false,
            targetOffset: false
        },
        computed: {
            target: ({ selTarget: selTarget }, $el)=>selTarget && $(selTarget, $el) || $el
        },
        connected () {
            this.start = coerce(this.start || this.top);
            this.end = coerce(this.end || this.bottom);
            this.placeholder = $("+ .uk-sticky-placeholder", this.$el) || $('<div class="uk-sticky-placeholder"></div>');
            this.isFixed = false;
            this.setActive(false);
        },
        beforeDisconnect () {
            if (this.isFixed) {
                this.hide();
                removeClass(this.target, this.clsInactive);
            }
            reset(this.$el);
            remove$1(this.placeholder);
            this.placeholder = null;
        },
        observe: [
            viewport(),
            scroll$1({
                target: ()=>document.scrollingElement
            }),
            resize({
                target: ({ $el: $el })=>[
                        $el,
                        getVisibleParent($el),
                        document.scrollingElement
                    ],
                handler (entries) {
                    this.$emit(this._data.resized && entries.some(({ target: target })=>target === getVisibleParent(this.$el)) ? "update" : "resize");
                    this._data.resized = true;
                }
            })
        ],
        events: [
            {
                name: "load hashchange popstate",
                el: ()=>window,
                filter: ({ targetOffset: targetOffset })=>targetOffset !== false,
                handler () {
                    const { scrollingElement: scrollingElement } = document;
                    if (!location.hash || scrollingElement.scrollTop === 0) return;
                    setTimeout(()=>{
                        const targetOffset = offset($(location.hash));
                        const elOffset = offset(this.$el);
                        if (this.isFixed && intersectRect(targetOffset, elOffset)) scrollingElement.scrollTop = Math.ceil(targetOffset.top - elOffset.height - toPx(this.targetOffset, "height", this.placeholder) - toPx(this.offset, "height", this.placeholder));
                    });
                }
            }
        ],
        update: [
            {
                read ({ height: height$1, width: width, margin: margin, sticky: sticky }, types) {
                    this.inactive = !this.matchMedia || !isVisible(this.$el) || !this.$el.offsetHeight;
                    if (this.inactive) return;
                    const dynamicViewport = height(window);
                    const maxScrollHeight = Math.max(0, document.scrollingElement.scrollHeight - dynamicViewport);
                    if (!maxScrollHeight) {
                        this.inactive = true;
                        return;
                    }
                    const hide = this.isFixed && types.has("update");
                    if (hide) {
                        preventTransition(this.target);
                        this.hide();
                    }
                    if (!this.active) {
                        ({ height: height$1, width: width } = dimensions$1(this.$el));
                        margin = css(this.$el, "margin");
                    }
                    if (hide) this.show();
                    const viewport2 = toPx("100vh", "height");
                    let position = this.position;
                    if (this.overflowFlip && height$1 > viewport2) position = position === "top" ? "bottom" : "top";
                    const referenceElement = this.isFixed ? this.placeholder : this.$el;
                    let offset$1 = toPx(this.offset, "height", sticky ? this.$el : referenceElement);
                    if (position === "bottom" && (height$1 < dynamicViewport || this.overflowFlip)) offset$1 += dynamicViewport - height$1;
                    const overflow = this.overflowFlip ? 0 : Math.max(0, height$1 + offset$1 - viewport2);
                    const topOffset = offset(referenceElement).top - // offset possible `transform: translateY` animation 'uk-animation-slide-top' while hiding
                    new DOMMatrix(css(referenceElement, "transform")).m42;
                    const elHeight = dimensions$1(this.$el).height;
                    const start = (this.start === false ? topOffset : parseProp(this.start, this.$el, topOffset)) - offset$1;
                    const end = this.end === false ? maxScrollHeight : Math.min(maxScrollHeight, parseProp(this.end, this.$el, topOffset + height$1, true) - elHeight - offset$1 + overflow);
                    sticky = !this.showOnUp && start + offset$1 === topOffset && end === Math.min(maxScrollHeight, parseProp(true, this.$el, 0, true) - elHeight - offset$1 + overflow) && css(getVisibleParent(this.$el), "overflowY") !== "hidden";
                    return {
                        start: start,
                        end: end,
                        offset: offset$1,
                        overflow: overflow,
                        height: height$1,
                        elHeight: elHeight,
                        width: width,
                        margin: margin,
                        top: offsetPosition(referenceElement)[0],
                        sticky: sticky,
                        viewport: viewport2,
                        maxScrollHeight: maxScrollHeight
                    };
                },
                write ({ height: height, width: width, margin: margin, offset: offset, sticky: sticky }) {
                    if (this.inactive || sticky || !this.isFixed) reset(this.$el);
                    if (this.inactive) return;
                    if (sticky) {
                        height = width = margin = 0;
                        css(this.$el, {
                            position: "sticky",
                            top: offset
                        });
                    }
                    const { placeholder: placeholder } = this;
                    css(placeholder, {
                        height: height,
                        width: width,
                        margin: margin
                    });
                    if (parent(placeholder) !== parent(this.$el) || sticky ^ index(placeholder) < index(this.$el)) {
                        (sticky ? before : after)(this.$el, placeholder);
                        placeholder.hidden = true;
                    }
                },
                events: [
                    "resize"
                ]
            },
            {
                read ({ scroll: prevScroll = 0, dir: prevDir = "down", overflow: overflow, overflowScroll: overflowScroll = 0, start: start, end: end, elHeight: elHeight, height: height, sticky: sticky, maxScrollHeight: maxScrollHeight }) {
                    const scroll2 = Math.min(document.scrollingElement.scrollTop, maxScrollHeight);
                    const dir = prevScroll <= scroll2 ? "down" : "up";
                    const referenceElement = this.isFixed ? this.placeholder : this.$el;
                    return {
                        dir: dir,
                        prevDir: prevDir,
                        scroll: scroll2,
                        prevScroll: prevScroll,
                        below: scroll2 > offset(referenceElement).top + (sticky ? Math.min(height, elHeight) : height),
                        offsetParentTop: offset(referenceElement.offsetParent).top,
                        overflowScroll: clamp(overflowScroll + clamp(scroll2, start, end) - clamp(prevScroll, start, end), 0, overflow)
                    };
                },
                write (data, types) {
                    const isScrollUpdate = types.has("scroll");
                    const { initTimestamp: initTimestamp = 0, dir: dir, prevDir: prevDir, scroll: scroll2, prevScroll: prevScroll = 0, top: top, start: start, below: below } = data;
                    if (scroll2 < 0 || scroll2 === prevScroll && isScrollUpdate || this.showOnUp && !isScrollUpdate && !this.isFixed) return;
                    const now = Date.now();
                    if (now - initTimestamp > 300 || dir !== prevDir) {
                        data.initScroll = scroll2;
                        data.initTimestamp = now;
                    }
                    if (this.showOnUp && !this.isFixed && Math.abs(data.initScroll - scroll2) <= 30 && Math.abs(prevScroll - scroll2) <= 10) return;
                    if (this.inactive || scroll2 < start || this.showOnUp && (scroll2 <= start || dir === "down" && isScrollUpdate || dir === "up" && !this.isFixed && !below)) {
                        if (!this.isFixed) {
                            if (Animation.inProgress(this.$el) && top > scroll2) {
                                Animation.cancel(this.$el);
                                this.hide();
                            }
                            return;
                        }
                        if (this.animation && below) {
                            if (hasClass(this.$el, "uk-animation-leave")) return;
                            Animation.out(this.$el, this.animation).then(()=>this.hide(), noop);
                        } else this.hide();
                    } else if (this.isFixed) this.update();
                    else if (this.animation && below) {
                        this.show();
                        Animation.in(this.$el, this.animation).catch(noop);
                    } else {
                        preventTransition(this.target);
                        this.show();
                    }
                },
                events: [
                    "resize",
                    "resizeViewport",
                    "scroll"
                ]
            }
        ],
        methods: {
            show () {
                this.isFixed = true;
                this.update();
                this.placeholder.hidden = false;
            },
            hide () {
                const { offset: offset, sticky: sticky } = this._data;
                this.setActive(false);
                removeClass(this.$el, this.clsFixed, this.clsBelow);
                if (sticky) css(this.$el, "top", offset);
                else css(this.$el, {
                    position: "",
                    top: "",
                    width: "",
                    marginTop: ""
                });
                this.placeholder.hidden = true;
                this.isFixed = false;
            },
            update () {
                let { width: width, scroll: scroll2 = 0, overflow: overflow, overflowScroll: overflowScroll = 0, start: start, end: end, offset: offset, offsetParentTop: offsetParentTop, sticky: sticky, below: below } = this._data;
                const active = start !== 0 || scroll2 > start;
                if (!sticky) {
                    let position = "fixed";
                    if (scroll2 > end) {
                        offset += end - offsetParentTop + overflowScroll - overflow;
                        position = "absolute";
                    }
                    css(this.$el, {
                        position: position,
                        width: width,
                        marginTop: 0
                    }, "important");
                }
                css(this.$el, "top", offset - overflowScroll);
                this.setActive(active);
                toggleClass(this.$el, this.clsBelow, below);
                addClass(this.$el, this.clsFixed);
            },
            setActive (active) {
                const prev = this.active;
                this.active = active;
                if (active) {
                    replaceClass(this.target, this.clsInactive, this.clsActive);
                    prev !== active && trigger(this.$el, "active");
                } else {
                    replaceClass(this.target, this.clsActive, this.clsInactive);
                    if (prev !== active) {
                        preventTransition(this.target);
                        trigger(this.$el, "inactive");
                    }
                }
            }
        }
    };
    function parseProp(value, el, propOffset, padding) {
        if (!value) return 0;
        if (isNumeric(value) || isString(value) && value.match(/^-?\d/)) return propOffset + toPx(value, "height", el, true);
        else {
            const refElement = value === true ? getVisibleParent(el) : query(value, el);
            return offset(refElement).bottom - (padding && (refElement == null ? void 0 : refElement.contains(el)) ? toFloat(css(refElement, "paddingBottom")) + toFloat(css(refElement, "borderBottomWidth")) : 0);
        }
    }
    function coerce(value) {
        if (value === "true") return true;
        else if (value === "false") return false;
        return value;
    }
    function reset(el) {
        css(el, {
            position: "",
            top: "",
            marginTop: "",
            width: ""
        });
    }
    const clsTransitionDisable = "uk-transition-disable";
    function preventTransition(element) {
        if (!hasClass(element, clsTransitionDisable)) {
            addClass(element, clsTransitionDisable);
            requestAnimationFrame(()=>removeClass(element, clsTransitionDisable));
        }
    }
    function getVisibleParent(element) {
        while(element = parent(element)){
            if (isVisible(element)) return element;
        }
    }
    const selDisabled = ".uk-disabled *, .uk-disabled, [disabled]";
    var Switcher = {
        mixins: [
            Togglable
        ],
        args: "connect",
        props: {
            connect: String,
            toggle: String,
            itemNav: String,
            active: Number,
            followFocus: Boolean,
            swiping: Boolean
        },
        data: {
            connect: "~.uk-switcher",
            toggle: "> * > :first-child",
            itemNav: false,
            active: 0,
            cls: "uk-active",
            attrItem: "uk-switcher-item",
            selVertical: ".uk-nav",
            followFocus: false,
            swiping: true
        },
        computed: {
            connects: {
                get: ({ connect: connect }, $el)=>queryAll(connect, $el),
                observe: ({ connect: connect })=>connect
            },
            connectChildren () {
                return this.connects.map((el)=>children(el)).flat();
            },
            toggles: ({ toggle: toggle }, $el)=>$$(toggle, $el),
            children (_, $el) {
                return children($el).filter((child)=>this.toggles.some((toggle)=>child.contains(toggle)));
            }
        },
        watch: {
            connects (connects) {
                if (this.swiping) css(connects, "touchAction", "pan-y pinch-zoom");
                this.$emit();
            },
            connectChildren () {
                let index = Math.max(0, this.index());
                for (const el of this.connects)children(el).forEach((child, i)=>toggleClass(child, this.cls, i === index));
                this.$emit();
            },
            toggles (toggles) {
                this.$emit();
                const active = this.index();
                this.show(~active ? active : toggles[this.active] || toggles[0]);
            }
        },
        connected () {
            attr(this.$el, "role", "tablist");
        },
        observe: [
            lazyload({
                targets: ({ connectChildren: connectChildren })=>connectChildren
            }),
            swipe({
                target: ({ connects: connects })=>connects,
                filter: ({ swiping: swiping })=>swiping
            })
        ],
        events: [
            {
                name: "click keydown",
                delegate: ({ toggle: toggle })=>toggle,
                handler (e) {
                    if (!matches(e.current, selDisabled) && (e.type === "click" || e.keyCode === keyMap.SPACE)) {
                        e.preventDefault();
                        this.show(e.current);
                    }
                }
            },
            {
                name: "keydown",
                delegate: ({ toggle: toggle })=>toggle,
                handler (e) {
                    const { current: current, keyCode: keyCode } = e;
                    const isVertical = matches(this.$el, this.selVertical);
                    let i = keyCode === keyMap.HOME ? 0 : keyCode === keyMap.END ? "last" : keyCode === keyMap.LEFT && !isVertical || keyCode === keyMap.UP && isVertical ? "previous" : keyCode === keyMap.RIGHT && !isVertical || keyCode === keyMap.DOWN && isVertical ? "next" : -1;
                    if (~i) {
                        e.preventDefault();
                        const toggles = this.toggles.filter((el)=>!matches(el, selDisabled));
                        const next = toggles[getIndex(i, toggles, toggles.indexOf(current))];
                        next.focus();
                        if (this.followFocus) this.show(next);
                    }
                }
            },
            {
                name: "click",
                el: ({ $el: $el, connects: connects, itemNav: itemNav })=>connects.concat(itemNav ? queryAll(itemNav, $el) : []),
                delegate: ({ attrItem: attrItem })=>`[${attrItem}],[data-${attrItem}]`,
                handler (e) {
                    if (e.target.closest("a,button")) {
                        e.preventDefault();
                        this.show(data(e.current, this.attrItem));
                    }
                }
            },
            {
                name: "swipeRight swipeLeft",
                filter: ({ swiping: swiping })=>swiping,
                el: ({ connects: connects })=>connects,
                handler ({ type: type }) {
                    this.show(endsWith(type, "Left") ? "next" : "previous");
                }
            }
        ],
        update () {
            var _a;
            for (const el of this.connects)if (isTag(el, "ul")) attr(el, "role", "presentation");
            attr(children(this.$el), "role", "presentation");
            for(const index in this.toggles){
                const toggle = this.toggles[index];
                const item = (_a = this.connects[0]) == null ? void 0 : _a.children[index];
                attr(toggle, "role", "tab");
                if (!item) continue;
                toggle.id = generateId(this, toggle);
                item.id = generateId(this, item);
                attr(toggle, "aria-controls", item.id);
                attr(item, {
                    role: "tabpanel",
                    "aria-labelledby": toggle.id
                });
            }
            attr(this.$el, "aria-orientation", matches(this.$el, this.selVertical) ? "vertical" : null);
        },
        methods: {
            index () {
                return findIndex(this.children, (el)=>hasClass(el, this.cls));
            },
            show (item) {
                const toggles = this.toggles.filter((el)=>!matches(el, selDisabled));
                const prev = this.index();
                const next = getIndex(!isNode(item) || includes(toggles, item) ? item : 0, toggles, getIndex(this.toggles[prev], toggles));
                const active = getIndex(toggles[next], this.toggles);
                this.children.forEach((child, i)=>{
                    toggleClass(child, this.cls, active === i);
                    attr(this.toggles[i], {
                        "aria-selected": active === i,
                        tabindex: active === i ? null : -1
                    });
                });
                const animate = prev >= 0 && prev !== next;
                this.connects.forEach(async ({ children: children2 })=>{
                    const actives = toArray(children2).filter((child, i)=>i !== active && hasClass(child, this.cls));
                    if (await this.toggleElement(actives, false, animate)) await this.toggleElement(children2[active], true, animate);
                });
            }
        }
    };
    var tab = {
        mixins: [
            Class
        ],
        extends: Switcher,
        props: {
            media: Boolean
        },
        data: {
            media: 960,
            attrItem: "uk-tab-item",
            selVertical: ".uk-tab-left,.uk-tab-right"
        },
        connected () {
            const cls = hasClass(this.$el, "uk-tab-left") ? "uk-tab-left" : hasClass(this.$el, "uk-tab-right") ? "uk-tab-right" : false;
            if (cls) this.$create("toggle", this.$el, {
                cls: cls,
                mode: "media",
                media: this.media
            });
        }
    };
    const KEY_SPACE = 32;
    var toggle = {
        mixins: [
            Media,
            Togglable
        ],
        args: "target",
        props: {
            href: String,
            target: null,
            mode: "list",
            queued: Boolean
        },
        data: {
            href: false,
            target: false,
            mode: "click",
            queued: true
        },
        computed: {
            target: {
                get: ({ target: target }, $el)=>{
                    target = queryAll(target || $el.hash, $el);
                    return target.length ? target : [
                        $el
                    ];
                },
                observe: ({ target: target })=>target
            }
        },
        connected () {
            if (!includes(this.mode, "media")) {
                if (!isFocusable(this.$el)) attr(this.$el, "tabindex", "0");
                if (!this.cls && isTag(this.$el, "a")) attr(this.$el, "role", "button");
            }
        },
        observe: lazyload({
            targets: ({ target: target })=>target
        }),
        events: [
            {
                name: pointerDown$1,
                filter: ({ mode: mode })=>includes(mode, "hover"),
                handler (e) {
                    this._preventClick = null;
                    if (!isTouch(e) || isBoolean(this._showState) || this.$el.disabled) return;
                    trigger(this.$el, "focus");
                    once(document, pointerDown$1, ()=>trigger(this.$el, "blur"), true, (e2)=>!this.$el.contains(e2.target));
                    if (includes(this.mode, "click")) this._preventClick = true;
                }
            },
            {
                // mouseenter mouseleave are added because of Firefox bug,
                // where pointerleave is triggered immediately after pointerenter on scroll
                name: `mouseenter mouseleave ${pointerEnter} ${pointerLeave} focus blur`,
                filter: ({ mode: mode })=>includes(mode, "hover"),
                handler (e) {
                    if (isTouch(e) || this.$el.disabled) return;
                    const show = includes([
                        "mouseenter",
                        pointerEnter,
                        "focus"
                    ], e.type);
                    const expanded = this.isToggled(this.target);
                    if (!show && (!isBoolean(this._showState) || e.type !== "blur" && matches(this.$el, ":focus") || e.type === "blur" && matches(this.$el, ":hover"))) {
                        if (expanded === this._showState) this._showState = null;
                        return;
                    }
                    if (show && isBoolean(this._showState) && expanded !== this._showState) return;
                    this._showState = show ? expanded : null;
                    this.toggle(`toggle${show ? "show" : "hide"}`);
                }
            },
            {
                name: "keydown",
                filter: ({ $el: $el, mode: mode })=>includes(mode, "click") && !isTag($el, "input"),
                handler (e) {
                    if (e.keyCode === KEY_SPACE) {
                        e.preventDefault();
                        this.$el.click();
                    }
                }
            },
            {
                name: "click",
                filter: ({ mode: mode })=>[
                        "click",
                        "hover"
                    ].some((m)=>includes(mode, m)),
                handler (e) {
                    let link;
                    if (this._preventClick || e.target.closest('a[href="#"], a[href=""]') || (link = e.target.closest("a[href]")) && (!this.isToggled(this.target) || link.hash && matches(this.target, link.hash))) e.preventDefault();
                    if (!this._preventClick && includes(this.mode, "click")) this.toggle();
                }
            },
            {
                name: "mediachange",
                filter: ({ mode: mode })=>includes(mode, "media"),
                el: ({ target: target })=>target,
                handler (e, mediaObj) {
                    if (mediaObj.matches ^ this.isToggled(this.target)) this.toggle();
                }
            }
        ],
        methods: {
            async toggle (type) {
                if (!trigger(this.target, type || "toggle", [
                    this
                ])) return;
                if (hasAttr(this.$el, "aria-expanded")) attr(this.$el, "aria-expanded", !this.isToggled(this.target));
                if (!this.queued) return this.toggleElement(this.target);
                const leaving = this.target.filter((el)=>hasClass(el, this.clsLeave));
                if (leaving.length) {
                    for (const el of this.target){
                        const isLeaving = includes(leaving, el);
                        this.toggleElement(el, isLeaving, isLeaving);
                    }
                    return;
                }
                const toggled = this.target.filter(this.isToggled);
                if (await this.toggleElement(toggled, false)) await this.toggleElement(this.target.filter((el)=>!includes(toggled, el)), true);
            }
        }
    };
    var components = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        Accordion: Accordion,
        Alert: alert,
        Close: Close,
        Cover: cover,
        Drop: drop,
        DropParentIcon: IconComponent,
        Dropdown: drop,
        Dropnav: Dropnav,
        FormCustom: formCustom,
        Grid: grid,
        HeightMatch: heightMatch,
        HeightPlaceholder: heightPlaceholder,
        HeightViewport: heightViewport,
        Icon: Icon,
        Img: img,
        Inverse: inverse,
        Leader: leader,
        Margin: Margin,
        Marker: Marker,
        Modal: modal,
        Nav: nav,
        NavParentIcon: NavParentIcon,
        Navbar: navbar,
        NavbarParentIcon: IconComponent,
        NavbarToggleIcon: NavbarToggleIcon,
        Offcanvas: offcanvas,
        OverflowAuto: overflowAuto,
        OverlayIcon: IconComponent,
        PaginationNext: PaginationNext,
        PaginationPrevious: PaginationPrevious,
        Responsive: responsive,
        Scroll: scroll,
        Scrollspy: scrollspy,
        ScrollspyNav: scrollspyNav,
        SearchIcon: Search,
        SlidenavNext: Slidenav,
        SlidenavPrevious: Slidenav,
        Spinner: Spinner,
        Sticky: sticky,
        Svg: svg,
        Switcher: Switcher,
        Tab: tab,
        Toggle: toggle,
        Totop: Totop,
        Video: Video
    });
    each(components, (component, name)=>App.component(name, component));
    boot(App);
    each(components$1, (component, name)=>App.component(name, component));
    return App;
});

});

parcelRegister("4zpiX", function(module, exports) {

module.exports = (parcelRequire("dO5NA"));

});
parcelRegister("dO5NA", function(module, exports) {
"use strict";

var $1X85b = parcelRequire("1X85b");

var $4i3Tl = parcelRequire("4i3Tl");

var $dzKYE = parcelRequire("dzKYE");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0d4716803010cf7$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $a0d4716803010cf7$var$_decode2 = $iHLHC((parcelRequire("42E6z")));

var $a0d4716803010cf7$var$_encode2 = $iHLHC((parcelRequire("1rsTn")));

var $a0d4716803010cf7$var$_CryptoController = $iHLHC((parcelRequire("hf5sb")));

var $a0d4716803010cf7$var$_EventuallyQueue = $iHLHC((parcelRequire("cJKeG")));

var $a0d4716803010cf7$var$_IndexedDBStorageController = $iHLHC((parcelRequire("b4vvz")));

var $a0d4716803010cf7$var$_InstallationController = $iHLHC((parcelRequire("i5Nxa")));

var $a0d4716803010cf7$var$ParseOp = $a0d4716803010cf7$var$_interopRequireWildcard((parcelRequire("3l0Qd")));

var $a0d4716803010cf7$var$_RESTController = $iHLHC((parcelRequire("dcLeF")));

var $a0d4716803010cf7$var$_ParseACL = $iHLHC((parcelRequire("2xGBa")));

var $a0d4716803010cf7$var$Analytics = $a0d4716803010cf7$var$_interopRequireWildcard((parcelRequire("54Znm")));

var $a0d4716803010cf7$var$_AnonymousUtils = $iHLHC((parcelRequire("ffqks")));

var $a0d4716803010cf7$var$Cloud = $a0d4716803010cf7$var$_interopRequireWildcard((parcelRequire("2YVFi")));

var $a0d4716803010cf7$var$_ParseCLP = $iHLHC((parcelRequire("hnFLk")));

var $a0d4716803010cf7$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $a0d4716803010cf7$var$_EventEmitter = $iHLHC((parcelRequire("2GgHs")));

var $a0d4716803010cf7$var$_ParseConfig = $iHLHC((parcelRequire("5K5Co")));

var $a0d4716803010cf7$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $a0d4716803010cf7$var$_FacebookUtils = $iHLHC((parcelRequire("iRjYO")));

var $a0d4716803010cf7$var$_ParseFile = $iHLHC((parcelRequire("59JWU")));

var $a0d4716803010cf7$var$Hooks = $a0d4716803010cf7$var$_interopRequireWildcard((parcelRequire("9vZqN")));

var $a0d4716803010cf7$var$_ParseGeoPoint = $iHLHC((parcelRequire("jtZTC")));

var $a0d4716803010cf7$var$_ParsePolygon = $iHLHC((parcelRequire("i8AKq")));

var $a0d4716803010cf7$var$_ParseInstallation = $iHLHC((parcelRequire("7nsYD")));

var $a0d4716803010cf7$var$_LocalDatastore = $iHLHC((parcelRequire("xW8Bi")));

var $a0d4716803010cf7$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $a0d4716803010cf7$var$Push = $a0d4716803010cf7$var$_interopRequireWildcard((parcelRequire("3Jcx2")));

var $a0d4716803010cf7$var$_ParseQuery = $iHLHC((parcelRequire("4FVCr")));

var $a0d4716803010cf7$var$_ParseRelation = $iHLHC((parcelRequire("967gW")));

var $a0d4716803010cf7$var$_ParseRole = $iHLHC((parcelRequire("7MXHA")));

var $a0d4716803010cf7$var$_ParseSchema = $iHLHC((parcelRequire("9xpH4")));

var $a0d4716803010cf7$var$_ParseSession = $iHLHC((parcelRequire("b7rpJ")));

var $a0d4716803010cf7$var$_Storage = $iHLHC((parcelRequire("7GXKV")));

var $a0d4716803010cf7$var$_ParseUser = $iHLHC((parcelRequire("iQ4JH")));

var $a0d4716803010cf7$var$_ParseLiveQuery = $iHLHC((parcelRequire("heN8G")));

var $a0d4716803010cf7$var$_LiveQueryClient = $iHLHC((parcelRequire("b2fSd")));

var $a0d4716803010cf7$var$_LocalDatastoreController = $iHLHC((parcelRequire("e3Muo")));

var $a0d4716803010cf7$var$_StorageController = $iHLHC((parcelRequire("7pMC1")));

var $a0d4716803010cf7$var$_WebSocketController = $iHLHC((parcelRequire("5C46p")));
function $a0d4716803010cf7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof $1X85b) return null;
    var r = new $1X85b(), t = new $1X85b();
    return ($a0d4716803010cf7$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $a0d4716803010cf7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $a0d4716803010cf7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    };
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = $4i3Tl && $dzKYE ? $dzKYE(e, u) : null;
        i && (i.get || i.set) ? $4i3Tl(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
/**
 * Contains all Parse API classes and functions.
 *
 * @static
 * @global
 * @class
 * @hideconstructor
 */ const $a0d4716803010cf7$var$Parse = {
    ACL: $a0d4716803010cf7$var$_ParseACL.default,
    Analytics: $a0d4716803010cf7$var$Analytics,
    AnonymousUtils: $a0d4716803010cf7$var$_AnonymousUtils.default,
    Cloud: $a0d4716803010cf7$var$Cloud,
    CLP: $a0d4716803010cf7$var$_ParseCLP.default,
    CoreManager: $a0d4716803010cf7$var$_CoreManager.default,
    Config: $a0d4716803010cf7$var$_ParseConfig.default,
    Error: $a0d4716803010cf7$var$_ParseError.default,
    FacebookUtils: $a0d4716803010cf7$var$_FacebookUtils.default,
    File: $a0d4716803010cf7$var$_ParseFile.default,
    GeoPoint: $a0d4716803010cf7$var$_ParseGeoPoint.default,
    Polygon: $a0d4716803010cf7$var$_ParsePolygon.default,
    Installation: $a0d4716803010cf7$var$_ParseInstallation.default,
    LocalDatastore: $a0d4716803010cf7$var$_LocalDatastore.default,
    Object: $a0d4716803010cf7$var$_ParseObject.default,
    Op: {
        Set: $a0d4716803010cf7$var$ParseOp.SetOp,
        Unset: $a0d4716803010cf7$var$ParseOp.UnsetOp,
        Increment: $a0d4716803010cf7$var$ParseOp.IncrementOp,
        Add: $a0d4716803010cf7$var$ParseOp.AddOp,
        Remove: $a0d4716803010cf7$var$ParseOp.RemoveOp,
        AddUnique: $a0d4716803010cf7$var$ParseOp.AddUniqueOp,
        Relation: $a0d4716803010cf7$var$ParseOp.RelationOp
    },
    Push: $a0d4716803010cf7$var$Push,
    Query: $a0d4716803010cf7$var$_ParseQuery.default,
    Relation: $a0d4716803010cf7$var$_ParseRelation.default,
    Role: $a0d4716803010cf7$var$_ParseRole.default,
    Schema: $a0d4716803010cf7$var$_ParseSchema.default,
    Session: $a0d4716803010cf7$var$_ParseSession.default,
    Storage: $a0d4716803010cf7$var$_Storage.default,
    User: $a0d4716803010cf7$var$_ParseUser.default,
    LiveQueryClient: $a0d4716803010cf7$var$_LiveQueryClient.default,
    IndexedDB: undefined,
    Hooks: undefined,
    Parse: undefined,
    /**
   * @member {EventuallyQueue} Parse.EventuallyQueue
   * @static
   */ set EventuallyQueue (queue){
        $a0d4716803010cf7$var$_CoreManager.default.setEventuallyQueue(queue);
    },
    get EventuallyQueue () {
        return $a0d4716803010cf7$var$_CoreManager.default.getEventuallyQueue();
    },
    /**
   * Call this method first to set up your authentication tokens for Parse.
   *
   * @param {string} applicationId Your Parse Application ID.
   * @param {string} [javaScriptKey] Your Parse JavaScript Key (Not needed for parse-server)
   * @param {string} [masterKey] Your Parse Master Key. (Node.js only!)
   * @static
   */ initialize (applicationId, javaScriptKey) {
        if ($a0d4716803010cf7$var$_CoreManager.default.get("IS_NODE") && true) /* eslint-disable no-console */ console.log("It looks like you're using the browser version of the SDK in a node.js environment. You should require('parse/node') instead.");
        $a0d4716803010cf7$var$Parse._initialize(applicationId, javaScriptKey);
    },
    _initialize (applicationId, javaScriptKey, masterKey) {
        $a0d4716803010cf7$var$_CoreManager.default.set("APPLICATION_ID", applicationId);
        $a0d4716803010cf7$var$_CoreManager.default.set("JAVASCRIPT_KEY", javaScriptKey);
        $a0d4716803010cf7$var$_CoreManager.default.set("MASTER_KEY", masterKey);
        $a0d4716803010cf7$var$_CoreManager.default.set("USE_MASTER_KEY", false);
        $a0d4716803010cf7$var$_CoreManager.default.setIfNeeded("EventEmitter", $a0d4716803010cf7$var$_EventEmitter.default);
        $a0d4716803010cf7$var$_CoreManager.default.setIfNeeded("LiveQuery", new $a0d4716803010cf7$var$_ParseLiveQuery.default());
        $a0d4716803010cf7$var$_CoreManager.default.setIfNeeded("CryptoController", $a0d4716803010cf7$var$_CryptoController.default);
        $a0d4716803010cf7$var$_CoreManager.default.setIfNeeded("EventuallyQueue", $a0d4716803010cf7$var$_EventuallyQueue.default);
        $a0d4716803010cf7$var$_CoreManager.default.setIfNeeded("InstallationController", $a0d4716803010cf7$var$_InstallationController.default);
        $a0d4716803010cf7$var$_CoreManager.default.setIfNeeded("LocalDatastoreController", $a0d4716803010cf7$var$_LocalDatastoreController.default);
        $a0d4716803010cf7$var$_CoreManager.default.setIfNeeded("StorageController", $a0d4716803010cf7$var$_StorageController.default);
        $a0d4716803010cf7$var$_CoreManager.default.setIfNeeded("WebSocketController", $a0d4716803010cf7$var$_WebSocketController.default);
        $a0d4716803010cf7$var$Parse.IndexedDB = $a0d4716803010cf7$var$_CoreManager.default.setIfNeeded("IndexedDBStorageController", $a0d4716803010cf7$var$_IndexedDBStorageController.default);
    },
    /**
   * Call this method to set your AsyncStorage engine
   * Starting Parse@1.11, the ParseSDK do not provide a React AsyncStorage as the ReactNative module
   * is not provided at a stable path and changes over versions.
   *
   * @param {AsyncStorage} storage a react native async storage.
   * @static
   */ setAsyncStorage (storage) {
        $a0d4716803010cf7$var$_CoreManager.default.setAsyncStorage(storage);
    },
    /**
   * Call this method to set your LocalDatastoreStorage engine
   * If using React-Native use {@link Parse.setAsyncStorage Parse.setAsyncStorage()}
   *
   * @param {LocalDatastoreController} controller a data storage.
   * @static
   */ setLocalDatastoreController (controller) {
        $a0d4716803010cf7$var$_CoreManager.default.setLocalDatastoreController(controller);
    },
    /**
   * Returns information regarding the current server's health
   *
   * @returns {Promise}
   * @static
   */ getServerHealth () {
        return $a0d4716803010cf7$var$_CoreManager.default.getRESTController().request("GET", "health");
    },
    /**
   * @member {string} Parse.applicationId
   * @static
   */ set applicationId (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("APPLICATION_ID", value);
    },
    get applicationId () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("APPLICATION_ID");
    },
    /**
   * @member {string} Parse.javaScriptKey
   * @static
   */ set javaScriptKey (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("JAVASCRIPT_KEY", value);
    },
    get javaScriptKey () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("JAVASCRIPT_KEY");
    },
    /**
   * @member {string} Parse.masterKey
   * @static
   */ set masterKey (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("MASTER_KEY", value);
    },
    get masterKey () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("MASTER_KEY");
    },
    /**
   * @member {string} Parse.serverURL
   * @static
   */ set serverURL (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("SERVER_URL", value);
    },
    get serverURL () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("SERVER_URL");
    },
    /**
   * @member {string} Parse.serverAuthToken
   * @static
   */ set serverAuthToken (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("SERVER_AUTH_TOKEN", value);
    },
    get serverAuthToken () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("SERVER_AUTH_TOKEN");
    },
    /**
   * @member {string} Parse.serverAuthType
   * @static
   */ set serverAuthType (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("SERVER_AUTH_TYPE", value);
    },
    get serverAuthType () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("SERVER_AUTH_TYPE");
    },
    /**
   * @member {ParseLiveQuery} Parse.LiveQuery
   * @static
   */ set LiveQuery (liveQuery){
        $a0d4716803010cf7$var$_CoreManager.default.setLiveQuery(liveQuery);
    },
    get LiveQuery () {
        return $a0d4716803010cf7$var$_CoreManager.default.getLiveQuery();
    },
    /**
   * @member {string} Parse.liveQueryServerURL
   * @static
   */ set liveQueryServerURL (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("LIVEQUERY_SERVER_URL", value);
    },
    get liveQueryServerURL () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("LIVEQUERY_SERVER_URL");
    },
    /**
   * @member {boolean} Parse.encryptedUser
   * @static
   */ set encryptedUser (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("ENCRYPTED_USER", value);
    },
    get encryptedUser () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("ENCRYPTED_USER");
    },
    /**
   * @member {string} Parse.secret
   * @static
   */ set secret (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("ENCRYPTED_KEY", value);
    },
    get secret () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("ENCRYPTED_KEY");
    },
    /**
   * @member {boolean} Parse.idempotency
   * @static
   */ set idempotency (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("IDEMPOTENCY", value);
    },
    get idempotency () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("IDEMPOTENCY");
    },
    /**
   * @member {boolean} Parse.allowCustomObjectId
   * @static
   */ set allowCustomObjectId (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("ALLOW_CUSTOM_OBJECT_ID", value);
    },
    get allowCustomObjectId () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("ALLOW_CUSTOM_OBJECT_ID");
    },
    _request () {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return $a0d4716803010cf7$var$_CoreManager.default.getRESTController().request.apply(null, args);
    },
    _ajax () {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $a0d4716803010cf7$var$_CoreManager.default.getRESTController().ajax.apply(null, args);
    },
    // We attempt to match the signatures of the legacy versions of these methods
    _decode (_, value1) {
        return (0, $a0d4716803010cf7$var$_decode2.default)(value1);
    },
    _encode (value1, _, disallowObjects) {
        return (0, $a0d4716803010cf7$var$_encode2.default)(value1, disallowObjects);
    },
    _getInstallationId () {
        return $a0d4716803010cf7$var$_CoreManager.default.getInstallationController().currentInstallationId();
    },
    /**
   * Enable pinning in your application.
   * This must be called after `Parse.initialize` in your application.
   *
   * @param [polling] Allow pinging the server /health endpoint. Default true
   * @param [ms] Milliseconds to ping the server. Default 2000ms
   * @static
   */ enableLocalDatastore () {
        let polling = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        let ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
        if (!this.applicationId) {
            console.log("'enableLocalDataStore' must be called after 'initialize'");
            return;
        }
        if (!this.LocalDatastore.isEnabled) {
            this.LocalDatastore.isEnabled = true;
            if (polling) $a0d4716803010cf7$var$_CoreManager.default.getEventuallyQueue().poll(ms);
        }
    },
    /**
   * Flag that indicates whether Local Datastore is enabled.
   *
   * @static
   * @returns {boolean}
   */ isLocalDatastoreEnabled () {
        return this.LocalDatastore.isEnabled;
    },
    /**
   * Gets all contents from Local Datastore
   *
   * <pre>
   * await Parse.dumpLocalDatastore();
   * </pre>
   *
   * @static
   * @returns {object}
   */ dumpLocalDatastore () {
        if (!this.LocalDatastore.isEnabled) {
            console.log("Parse.enableLocalDatastore() must be called first"); // eslint-disable-line no-console
            return $a0d4716803010cf7$var$_promise.default.resolve({});
        } else return $a0d4716803010cf7$var$Parse.LocalDatastore._getAllContents();
    },
    /**
   * Enable the current user encryption.
   * This must be called before login any user.
   *
   * @static
   */ enableEncryptedUser () {
        this.encryptedUser = true;
    },
    /**
   * Flag that indicates whether Encrypted User is enabled.
   *
   * @static
   * @returns {boolean}
   */ isEncryptedUserEnabled () {
        return this.encryptedUser;
    }
};
$a0d4716803010cf7$var$_CoreManager.default.setRESTController($a0d4716803010cf7$var$_RESTController.default);
// For legacy requires, of the form `var Parse = require('parse').Parse`
$a0d4716803010cf7$var$Parse.Parse = $a0d4716803010cf7$var$Parse;
module.exports = $a0d4716803010cf7$var$Parse;
var $a0d4716803010cf7$var$_default = module.exports.default = $a0d4716803010cf7$var$Parse;

});
parcelRegister("1X85b", function(module, exports) {

module.exports = (parcelRequire("bZPfD"));

});
parcelRegister("bZPfD", function(module, exports) {
"use strict";

var $9ugx4 = parcelRequire("9ugx4");
parcelRequire("jXhxH");
module.exports = $9ugx4;

});
parcelRegister("9ugx4", function(module, exports) {
"use strict";
parcelRequire("5xrGR");
parcelRequire("iYyco");
parcelRequire("15yqC");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.WeakMap;

});
parcelRegister("5xrGR", function(module, exports) {
"use strict";

var $bYkAs = parcelRequire("bYkAs");

var $ajzxw = parcelRequire("ajzxw");

var $lmV2R = parcelRequire("lmV2R");

var $fmQ29 = parcelRequire("fmQ29");

var $diq7r = parcelRequire("diq7r");
var $408583899c0cb4a1$require$defineProperty = $diq7r.f;

var $5KUYO = parcelRequire("5KUYO");

var $5IrwJ = parcelRequire("5IrwJ");

var $7phdw = parcelRequire("7phdw");

var $jeZ4p = parcelRequire("jeZ4p");
var $408583899c0cb4a1$var$ARRAY_ITERATOR = "Array Iterator";
var $408583899c0cb4a1$var$setInternalState = $fmQ29.set;
var $408583899c0cb4a1$var$getInternalState = $fmQ29.getterFor($408583899c0cb4a1$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = $5KUYO(Array, "Array", function(iterated, kind) {
    $408583899c0cb4a1$var$setInternalState(this, {
        type: $408583899c0cb4a1$var$ARRAY_ITERATOR,
        target: $bYkAs(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $408583899c0cb4a1$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $5IrwJ(undefined, true);
    }
    switch(state.kind){
        case "keys":
            return $5IrwJ(index, false);
        case "values":
            return $5IrwJ(target[index], false);
    }
    return $5IrwJ([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $408583899c0cb4a1$var$values = $lmV2R.Arguments = $lmV2R.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$ajzxw("keys");
$ajzxw("values");
$ajzxw("entries");
// V8 ~ Chrome 45- bug
if (!$7phdw && $jeZ4p && $408583899c0cb4a1$var$values.name !== "values") try {
    $408583899c0cb4a1$require$defineProperty($408583899c0cb4a1$var$values, "name", {
        value: "values"
    });
} catch (error) {}

});
parcelRegister("bYkAs", function(module, exports) {
"use strict";

var $lEtn3 = parcelRequire("lEtn3");

var $cBWnS = parcelRequire("cBWnS");
module.exports = function(it) {
    return $lEtn3($cBWnS(it));
};

});
parcelRegister("lEtn3", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");

var $77TPA = parcelRequire("77TPA");

var $bTsfg = parcelRequire("bTsfg");
var $fc341dd70e1b0620$var$$Object = Object;
var $fc341dd70e1b0620$var$split = $f518o("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = $77TPA(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$fc341dd70e1b0620$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $bTsfg(it) === "String" ? $fc341dd70e1b0620$var$split(it, "") : $fc341dd70e1b0620$var$$Object(it);
} : $fc341dd70e1b0620$var$$Object;

});
parcelRegister("f518o", function(module, exports) {
"use strict";

var $4abbf = parcelRequire("4abbf");
var $afa833e25d010c4e$var$FunctionPrototype = Function.prototype;
var $afa833e25d010c4e$var$call = $afa833e25d010c4e$var$FunctionPrototype.call;
var $afa833e25d010c4e$var$uncurryThisWithBind = $4abbf && $afa833e25d010c4e$var$FunctionPrototype.bind.bind($afa833e25d010c4e$var$call, $afa833e25d010c4e$var$call);
module.exports = $4abbf ? $afa833e25d010c4e$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $afa833e25d010c4e$var$call.apply(fn, arguments);
    };
};

});
parcelRegister("4abbf", function(module, exports) {
"use strict";

var $77TPA = parcelRequire("77TPA");
module.exports = !$77TPA(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});

});
parcelRegister("77TPA", function(module, exports) {
"use strict";
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

});



parcelRegister("bTsfg", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");
var $8a8abdadef2cf5c0$var$toString = $f518o({}.toString);
var $8a8abdadef2cf5c0$var$stringSlice = $f518o("".slice);
module.exports = function(it) {
    return $8a8abdadef2cf5c0$var$stringSlice($8a8abdadef2cf5c0$var$toString(it), 8, -1);
};

});


parcelRegister("cBWnS", function(module, exports) {
"use strict";

var $6exeg = parcelRequire("6exeg");
var $92e63aa0587dfa53$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if ($6exeg(it)) throw new $92e63aa0587dfa53$var$$TypeError("Can't call method on " + it);
    return it;
};

});
parcelRegister("6exeg", function(module, exports) {
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

});



parcelRegister("ajzxw", function(module, exports) {
"use strict";
module.exports = function() {};

});

parcelRegister("lmV2R", function(module, exports) {
"use strict";
module.exports = {};

});

parcelRegister("fmQ29", function(module, exports) {
"use strict";

var $3rZfY = parcelRequire("3rZfY");

var $9l3PP = parcelRequire("9l3PP");

var $1WYwK = parcelRequire("1WYwK");

var $k4kcW = parcelRequire("k4kcW");

var $heVlo = parcelRequire("heVlo");

var $bEwnT = parcelRequire("bEwnT");

var $aUKPz = parcelRequire("aUKPz");

var $lKGD2 = parcelRequire("lKGD2");
var $b30145e9256ae915$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $b30145e9256ae915$var$TypeError = $9l3PP.TypeError;
var $b30145e9256ae915$var$WeakMap = $9l3PP.WeakMap;
var $b30145e9256ae915$var$set, $b30145e9256ae915$var$get, $b30145e9256ae915$var$has;
var $b30145e9256ae915$var$enforce = function(it) {
    return $b30145e9256ae915$var$has(it) ? $b30145e9256ae915$var$get(it) : $b30145e9256ae915$var$set(it, {});
};
var $b30145e9256ae915$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$1WYwK(it) || (state = $b30145e9256ae915$var$get(it)).type !== TYPE) throw new $b30145e9256ae915$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($3rZfY || $bEwnT.state) {
    var $b30145e9256ae915$var$store = $bEwnT.state || ($bEwnT.state = new $b30145e9256ae915$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $b30145e9256ae915$var$store.get = $b30145e9256ae915$var$store.get;
    $b30145e9256ae915$var$store.has = $b30145e9256ae915$var$store.has;
    $b30145e9256ae915$var$store.set = $b30145e9256ae915$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $b30145e9256ae915$var$set = function(it, metadata) {
        if ($b30145e9256ae915$var$store.has(it)) throw new $b30145e9256ae915$var$TypeError($b30145e9256ae915$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $b30145e9256ae915$var$store.set(it, metadata);
        return metadata;
    };
    $b30145e9256ae915$var$get = function(it) {
        return $b30145e9256ae915$var$store.get(it) || {};
    };
    $b30145e9256ae915$var$has = function(it) {
        return $b30145e9256ae915$var$store.has(it);
    };
} else {
    var $b30145e9256ae915$var$STATE = $aUKPz("state");
    $lKGD2[$b30145e9256ae915$var$STATE] = true;
    $b30145e9256ae915$var$set = function(it, metadata) {
        if ($heVlo(it, $b30145e9256ae915$var$STATE)) throw new $b30145e9256ae915$var$TypeError($b30145e9256ae915$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $k4kcW(it, $b30145e9256ae915$var$STATE, metadata);
        return metadata;
    };
    $b30145e9256ae915$var$get = function(it) {
        return $heVlo(it, $b30145e9256ae915$var$STATE) ? it[$b30145e9256ae915$var$STATE] : {};
    };
    $b30145e9256ae915$var$has = function(it) {
        return $heVlo(it, $b30145e9256ae915$var$STATE);
    };
}
module.exports = {
    set: $b30145e9256ae915$var$set,
    get: $b30145e9256ae915$var$get,
    has: $b30145e9256ae915$var$has,
    enforce: $b30145e9256ae915$var$enforce,
    getterFor: $b30145e9256ae915$var$getterFor
};

});
parcelRegister("3rZfY", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");

var $e6Rz5 = parcelRequire("e6Rz5");
var $283368fe873ec799$var$WeakMap = $9l3PP.WeakMap;
module.exports = $e6Rz5($283368fe873ec799$var$WeakMap) && /native code/.test(String($283368fe873ec799$var$WeakMap));

});
parcelRegister("9l3PP", function(module, exports) {
"use strict";
var $6cc90cc61420cf0b$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
$6cc90cc61420cf0b$var$check(typeof globalThis == "object" && globalThis) || $6cc90cc61420cf0b$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$6cc90cc61420cf0b$var$check(typeof self == "object" && self) || $6cc90cc61420cf0b$var$check(typeof $parcel$global == "object" && $parcel$global) || $6cc90cc61420cf0b$var$check(typeof module.exports == "object" && module.exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();

});

parcelRegister("e6Rz5", function(module, exports) {
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $a45b2d1e9ff03254$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof $a45b2d1e9ff03254$var$documentAll == "undefined" && $a45b2d1e9ff03254$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $a45b2d1e9ff03254$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};

});


parcelRegister("1WYwK", function(module, exports) {
"use strict";

var $e6Rz5 = parcelRequire("e6Rz5");
module.exports = function(it) {
    return typeof it == "object" ? it !== null : $e6Rz5(it);
};

});

parcelRegister("k4kcW", function(module, exports) {
"use strict";

var $jeZ4p = parcelRequire("jeZ4p");

var $diq7r = parcelRequire("diq7r");

var $8c6fn = parcelRequire("8c6fn");
module.exports = $jeZ4p ? function(object, key, value) {
    return $diq7r.f(object, key, $8c6fn(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("jeZ4p", function(module, exports) {
"use strict";

var $77TPA = parcelRequire("77TPA");
// Detect IE8's incomplete defineProperty implementation
module.exports = !$77TPA(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});

});

parcelRegister("diq7r", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $9ae1377901c67661$export$2d1720544b23b823; }, function (v) { return $9ae1377901c67661$export$2d1720544b23b823 = v; });
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $9ae1377901c67661$export$2d1720544b23b823;
"use strict";

var $jeZ4p = parcelRequire("jeZ4p");

var $9E0l8 = parcelRequire("9E0l8");

var $5Shx3 = parcelRequire("5Shx3");

var $l3LMJ = parcelRequire("l3LMJ");

var $eBk19 = parcelRequire("eBk19");
var $9ae1377901c67661$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $9ae1377901c67661$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $9ae1377901c67661$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $9ae1377901c67661$var$ENUMERABLE = "enumerable";
var $9ae1377901c67661$var$CONFIGURABLE = "configurable";
var $9ae1377901c67661$var$WRITABLE = "writable";
$9ae1377901c67661$export$2d1720544b23b823 = $jeZ4p ? $5Shx3 ? function defineProperty(O, P, Attributes) {
    $l3LMJ(O);
    P = $eBk19(P);
    $l3LMJ(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $9ae1377901c67661$var$WRITABLE in Attributes && !Attributes[$9ae1377901c67661$var$WRITABLE]) {
        var current = $9ae1377901c67661$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$9ae1377901c67661$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $9ae1377901c67661$var$CONFIGURABLE in Attributes ? Attributes[$9ae1377901c67661$var$CONFIGURABLE] : current[$9ae1377901c67661$var$CONFIGURABLE],
                enumerable: $9ae1377901c67661$var$ENUMERABLE in Attributes ? Attributes[$9ae1377901c67661$var$ENUMERABLE] : current[$9ae1377901c67661$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $9ae1377901c67661$var$$defineProperty(O, P, Attributes);
} : $9ae1377901c67661$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $l3LMJ(O);
    P = $eBk19(P);
    $l3LMJ(Attributes);
    if ($9E0l8) try {
        return $9ae1377901c67661$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $9ae1377901c67661$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("9E0l8", function(module, exports) {
"use strict";

var $jeZ4p = parcelRequire("jeZ4p");

var $77TPA = parcelRequire("77TPA");

var $kHYxY = parcelRequire("kHYxY");
// Thanks to IE8 for its funny defineProperty
module.exports = !$jeZ4p && !$77TPA(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($kHYxY("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});

});
parcelRegister("kHYxY", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");

var $1WYwK = parcelRequire("1WYwK");
var $f136ca29978a4a35$var$document = $9l3PP.document;
// typeof document.createElement is 'object' in old IE
var $f136ca29978a4a35$var$EXISTS = $1WYwK($f136ca29978a4a35$var$document) && $1WYwK($f136ca29978a4a35$var$document.createElement);
module.exports = function(it) {
    return $f136ca29978a4a35$var$EXISTS ? $f136ca29978a4a35$var$document.createElement(it) : {};
};

});


parcelRegister("5Shx3", function(module, exports) {
"use strict";

var $jeZ4p = parcelRequire("jeZ4p");

var $77TPA = parcelRequire("77TPA");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = $jeZ4p && $77TPA(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});

});

parcelRegister("l3LMJ", function(module, exports) {
"use strict";

var $1WYwK = parcelRequire("1WYwK");
var $f54ef1e9b84b33bb$var$$String = String;
var $f54ef1e9b84b33bb$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if ($1WYwK(argument)) return argument;
    throw new $f54ef1e9b84b33bb$var$$TypeError($f54ef1e9b84b33bb$var$$String(argument) + " is not an object");
};

});

parcelRegister("eBk19", function(module, exports) {
"use strict";

var $axnyg = parcelRequire("axnyg");

var $jpeSb = parcelRequire("jpeSb");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = $axnyg(argument, "string");
    return $jpeSb(key) ? key : key + "";
};

});
parcelRegister("axnyg", function(module, exports) {
"use strict";

var $aELZY = parcelRequire("aELZY");

var $1WYwK = parcelRequire("1WYwK");

var $jpeSb = parcelRequire("jpeSb");

var $k0Syp = parcelRequire("k0Syp");

var $abNh0 = parcelRequire("abNh0");

var $fq7H3 = parcelRequire("fq7H3");
var $7abf4150ed03b059$var$$TypeError = TypeError;
var $7abf4150ed03b059$var$TO_PRIMITIVE = $fq7H3("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!$1WYwK(input) || $jpeSb(input)) return input;
    var exoticToPrim = $k0Syp(input, $7abf4150ed03b059$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $aELZY(exoticToPrim, input, pref);
        if (!$1WYwK(result) || $jpeSb(result)) return result;
        throw new $7abf4150ed03b059$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $abNh0(input, pref);
};

});
parcelRegister("aELZY", function(module, exports) {
"use strict";

var $4abbf = parcelRequire("4abbf");
var $7c22df5888774151$var$call = Function.prototype.call;
module.exports = $4abbf ? $7c22df5888774151$var$call.bind($7c22df5888774151$var$call) : function() {
    return $7c22df5888774151$var$call.apply($7c22df5888774151$var$call, arguments);
};

});

parcelRegister("jpeSb", function(module, exports) {
"use strict";

var $5Pobw = parcelRequire("5Pobw");

var $e6Rz5 = parcelRequire("e6Rz5");

var $8hsAO = parcelRequire("8hsAO");

var $73gki = parcelRequire("73gki");
var $e20be38f1a7713cb$var$$Object = Object;
module.exports = $73gki ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $5Pobw("Symbol");
    return $e6Rz5($Symbol) && $8hsAO($Symbol.prototype, $e20be38f1a7713cb$var$$Object(it));
};

});
parcelRegister("5Pobw", function(module, exports) {
"use strict";

var $ly30u = parcelRequire("ly30u");

var $9l3PP = parcelRequire("9l3PP");

var $e6Rz5 = parcelRequire("e6Rz5");
var $43e479c85e4cf48d$var$aFunction = function(variable) {
    return $e6Rz5(variable) ? variable : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? $43e479c85e4cf48d$var$aFunction($ly30u[namespace]) || $43e479c85e4cf48d$var$aFunction($9l3PP[namespace]) : $ly30u[namespace] && $ly30u[namespace][method] || $9l3PP[namespace] && $9l3PP[namespace][method];
};

});
parcelRegister("ly30u", function(module, exports) {
"use strict";
module.exports = {};

});


parcelRegister("8hsAO", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");
module.exports = $f518o({}.isPrototypeOf);

});

parcelRegister("73gki", function(module, exports) {
"use strict";

var $e1lwM = parcelRequire("e1lwM");
module.exports = $e1lwM && !Symbol.sham && typeof Symbol.iterator == "symbol";

});
parcelRegister("e1lwM", function(module, exports) {
"use strict";

var $a9ory = parcelRequire("a9ory");

var $77TPA = parcelRequire("77TPA");

var $9l3PP = parcelRequire("9l3PP");
var $a351dba3dcb94263$var$$String = $9l3PP.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !$77TPA(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$a351dba3dcb94263$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $a9ory && $a9ory < 41;
});

});
parcelRegister("a9ory", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");

var $jVEg8 = parcelRequire("jVEg8");
var $763db49f47cf0571$var$process = $9l3PP.process;
var $763db49f47cf0571$var$Deno = $9l3PP.Deno;
var $763db49f47cf0571$var$versions = $763db49f47cf0571$var$process && $763db49f47cf0571$var$process.versions || $763db49f47cf0571$var$Deno && $763db49f47cf0571$var$Deno.version;
var $763db49f47cf0571$var$v8 = $763db49f47cf0571$var$versions && $763db49f47cf0571$var$versions.v8;
var $763db49f47cf0571$var$match, $763db49f47cf0571$var$version;
if ($763db49f47cf0571$var$v8) {
    $763db49f47cf0571$var$match = $763db49f47cf0571$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $763db49f47cf0571$var$version = $763db49f47cf0571$var$match[0] > 0 && $763db49f47cf0571$var$match[0] < 4 ? 1 : +($763db49f47cf0571$var$match[0] + $763db49f47cf0571$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$763db49f47cf0571$var$version && $jVEg8) {
    $763db49f47cf0571$var$match = $jVEg8.match(/Edge\/(\d+)/);
    if (!$763db49f47cf0571$var$match || $763db49f47cf0571$var$match[1] >= 74) {
        $763db49f47cf0571$var$match = $jVEg8.match(/Chrome\/(\d+)/);
        if ($763db49f47cf0571$var$match) $763db49f47cf0571$var$version = +$763db49f47cf0571$var$match[1];
    }
}
module.exports = $763db49f47cf0571$var$version;

});
parcelRegister("jVEg8", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");
var $e82291d7fea48b60$var$navigator = $9l3PP.navigator;
var $e82291d7fea48b60$var$userAgent = $e82291d7fea48b60$var$navigator && $e82291d7fea48b60$var$navigator.userAgent;
module.exports = $e82291d7fea48b60$var$userAgent ? String($e82291d7fea48b60$var$userAgent) : "";

});





parcelRegister("k0Syp", function(module, exports) {
"use strict";

var $8GsPx = parcelRequire("8GsPx");

var $6exeg = parcelRequire("6exeg");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return $6exeg(func) ? undefined : $8GsPx(func);
};

});
parcelRegister("8GsPx", function(module, exports) {
"use strict";

var $e6Rz5 = parcelRequire("e6Rz5");

var $k9gzN = parcelRequire("k9gzN");
var $65289c1234f4e46d$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if ($e6Rz5(argument)) return argument;
    throw new $65289c1234f4e46d$var$$TypeError($k9gzN(argument) + " is not a function");
};

});
parcelRegister("k9gzN", function(module, exports) {
"use strict";
var $eab181a387a9eaa1$var$$String = String;
module.exports = function(argument) {
    try {
        return $eab181a387a9eaa1$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};

});



parcelRegister("abNh0", function(module, exports) {
"use strict";

var $aELZY = parcelRequire("aELZY");

var $e6Rz5 = parcelRequire("e6Rz5");

var $1WYwK = parcelRequire("1WYwK");
var $76b127166c30fd75$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $e6Rz5(fn = input.toString) && !$1WYwK(val = $aELZY(fn, input))) return val;
    if ($e6Rz5(fn = input.valueOf) && !$1WYwK(val = $aELZY(fn, input))) return val;
    if (pref !== "string" && $e6Rz5(fn = input.toString) && !$1WYwK(val = $aELZY(fn, input))) return val;
    throw new $76b127166c30fd75$var$$TypeError("Can't convert object to primitive value");
};

});

parcelRegister("fq7H3", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");

var $3hwUC = parcelRequire("3hwUC");

var $heVlo = parcelRequire("heVlo");

var $kuKGb = parcelRequire("kuKGb");

var $e1lwM = parcelRequire("e1lwM");

var $73gki = parcelRequire("73gki");
var $b39f40790c8b3bef$var$Symbol = $9l3PP.Symbol;
var $b39f40790c8b3bef$var$WellKnownSymbolsStore = $3hwUC("wks");
var $b39f40790c8b3bef$var$createWellKnownSymbol = $73gki ? $b39f40790c8b3bef$var$Symbol["for"] || $b39f40790c8b3bef$var$Symbol : $b39f40790c8b3bef$var$Symbol && $b39f40790c8b3bef$var$Symbol.withoutSetter || $kuKGb;
module.exports = function(name) {
    if (!$heVlo($b39f40790c8b3bef$var$WellKnownSymbolsStore, name)) $b39f40790c8b3bef$var$WellKnownSymbolsStore[name] = $e1lwM && $heVlo($b39f40790c8b3bef$var$Symbol, name) ? $b39f40790c8b3bef$var$Symbol[name] : $b39f40790c8b3bef$var$createWellKnownSymbol("Symbol." + name);
    return $b39f40790c8b3bef$var$WellKnownSymbolsStore[name];
};

});
parcelRegister("3hwUC", function(module, exports) {
"use strict";

var $bEwnT = parcelRequire("bEwnT");
module.exports = function(key, value) {
    return $bEwnT[key] || ($bEwnT[key] = value || {});
};

});
parcelRegister("bEwnT", function(module, exports) {
"use strict";

var $7phdw = parcelRequire("7phdw");

var $9l3PP = parcelRequire("9l3PP");

var $hvWkx = parcelRequire("hvWkx");
var $87bc8d05060220af$var$SHARED = "__core-js_shared__";
var $87bc8d05060220af$var$store = module.exports = $9l3PP[$87bc8d05060220af$var$SHARED] || $hvWkx($87bc8d05060220af$var$SHARED, {});
($87bc8d05060220af$var$store.versions || ($87bc8d05060220af$var$store.versions = [])).push({
    version: "3.38.1",
    mode: $7phdw ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.38.1/LICENSE",
    source: "https://github.com/zloirock/core-js"
});

});
parcelRegister("7phdw", function(module, exports) {
"use strict";
module.exports = true;

});

parcelRegister("hvWkx", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $cc029411f908d311$var$defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        $cc029411f908d311$var$defineProperty($9l3PP, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $9l3PP[key] = value;
    }
    return value;
};

});



parcelRegister("heVlo", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");

var $iJNxK = parcelRequire("iJNxK");
var $c8d039cb715f1306$var$hasOwnProperty = $f518o({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return $c8d039cb715f1306$var$hasOwnProperty($iJNxK(it), key);
};

});
parcelRegister("iJNxK", function(module, exports) {
"use strict";

var $cBWnS = parcelRequire("cBWnS");
var $da42dc3c0500dd4c$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $da42dc3c0500dd4c$var$$Object($cBWnS(argument));
};

});


parcelRegister("kuKGb", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");
var $eebad18d7b7b98cf$var$id = 0;
var $eebad18d7b7b98cf$var$postfix = Math.random();
var $eebad18d7b7b98cf$var$toString = $f518o(1.0.toString);
module.exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $eebad18d7b7b98cf$var$toString(++$eebad18d7b7b98cf$var$id + $eebad18d7b7b98cf$var$postfix, 36);
};

});





parcelRegister("8c6fn", function(module, exports) {
"use strict";
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("aUKPz", function(module, exports) {
"use strict";

var $3hwUC = parcelRequire("3hwUC");

var $kuKGb = parcelRequire("kuKGb");
var $7f2375f10522f278$var$keys = $3hwUC("keys");
module.exports = function(key) {
    return $7f2375f10522f278$var$keys[key] || ($7f2375f10522f278$var$keys[key] = $kuKGb(key));
};

});

parcelRegister("lKGD2", function(module, exports) {
"use strict";
module.exports = {};

});


parcelRegister("5KUYO", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $aELZY = parcelRequire("aELZY");

var $7phdw = parcelRequire("7phdw");

var $3mtHt = parcelRequire("3mtHt");

var $e6Rz5 = parcelRequire("e6Rz5");

var $c713e = parcelRequire("c713e");

var $2pQL6 = parcelRequire("2pQL6");

var $6e7Qv = parcelRequire("6e7Qv");

var $dheYH = parcelRequire("dheYH");

var $k4kcW = parcelRequire("k4kcW");

var $kY5Tb = parcelRequire("kY5Tb");

var $fq7H3 = parcelRequire("fq7H3");

var $lmV2R = parcelRequire("lmV2R");

var $5cZ5h = parcelRequire("5cZ5h");
var $430d72a5b73e012e$var$PROPER_FUNCTION_NAME = $3mtHt.PROPER;
var $430d72a5b73e012e$var$CONFIGURABLE_FUNCTION_NAME = $3mtHt.CONFIGURABLE;
var $430d72a5b73e012e$var$IteratorPrototype = $5cZ5h.IteratorPrototype;
var $430d72a5b73e012e$var$BUGGY_SAFARI_ITERATORS = $5cZ5h.BUGGY_SAFARI_ITERATORS;
var $430d72a5b73e012e$var$ITERATOR = $fq7H3("iterator");
var $430d72a5b73e012e$var$KEYS = "keys";
var $430d72a5b73e012e$var$VALUES = "values";
var $430d72a5b73e012e$var$ENTRIES = "entries";
var $430d72a5b73e012e$var$returnThis = function() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $c713e(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$430d72a5b73e012e$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $430d72a5b73e012e$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $430d72a5b73e012e$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $430d72a5b73e012e$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$430d72a5b73e012e$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$430d72a5b73e012e$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $2pQL6(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$7phdw && $2pQL6(CurrentIteratorPrototype) !== $430d72a5b73e012e$var$IteratorPrototype) {
                if ($6e7Qv) $6e7Qv(CurrentIteratorPrototype, $430d72a5b73e012e$var$IteratorPrototype);
                else if (!$e6Rz5(CurrentIteratorPrototype[$430d72a5b73e012e$var$ITERATOR])) $kY5Tb(CurrentIteratorPrototype, $430d72a5b73e012e$var$ITERATOR, $430d72a5b73e012e$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $dheYH(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($7phdw) $lmV2R[TO_STRING_TAG] = $430d72a5b73e012e$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($430d72a5b73e012e$var$PROPER_FUNCTION_NAME && DEFAULT === $430d72a5b73e012e$var$VALUES && nativeIterator && nativeIterator.name !== $430d72a5b73e012e$var$VALUES) {
        if (!$7phdw && $430d72a5b73e012e$var$CONFIGURABLE_FUNCTION_NAME) $k4kcW(IterablePrototype, "name", $430d72a5b73e012e$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $aELZY(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($430d72a5b73e012e$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($430d72a5b73e012e$var$KEYS),
            entries: getIterationMethod($430d72a5b73e012e$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($430d72a5b73e012e$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $kY5Tb(IterablePrototype, KEY, methods[KEY]);
        } else $ggcsv({
            target: NAME,
            proto: true,
            forced: $430d72a5b73e012e$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$7phdw || FORCED) && IterablePrototype[$430d72a5b73e012e$var$ITERATOR] !== defaultIterator) $kY5Tb(IterablePrototype, $430d72a5b73e012e$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $lmV2R[NAME] = defaultIterator;
    return methods;
};

});
parcelRegister("ggcsv", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");

var $2JOsI = parcelRequire("2JOsI");

var $5FNR6 = parcelRequire("5FNR6");

var $e6Rz5 = parcelRequire("e6Rz5");

var $fTFId = parcelRequire("fTFId");
var $bd67cdff1139f731$require$getOwnPropertyDescriptor = $fTFId.f;

var $iaZZ9 = parcelRequire("iaZZ9");

var $ly30u = parcelRequire("ly30u");

var $b5UsH = parcelRequire("b5UsH");

var $k4kcW = parcelRequire("k4kcW");

var $heVlo = parcelRequire("heVlo");

var $bd67cdff1139f731$var$wrapConstructor = function(NativeConstructor) {
    var Wrapper = function(a, b, c) {
        if (this instanceof Wrapper) {
            switch(arguments.length){
                case 0:
                    return new NativeConstructor();
                case 1:
                    return new NativeConstructor(a);
                case 2:
                    return new NativeConstructor(a, b);
            }
            return new NativeConstructor(a, b, c);
        }
        return $2JOsI(NativeConstructor, this, arguments);
    };
    Wrapper.prototype = NativeConstructor.prototype;
    return Wrapper;
};
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var PROTO = options.proto;
    var nativeSource = GLOBAL ? $9l3PP : STATIC ? $9l3PP[TARGET] : $9l3PP[TARGET] && $9l3PP[TARGET].prototype;
    var target = GLOBAL ? $ly30u : $ly30u[TARGET] || $k4kcW($ly30u, TARGET, {})[TARGET];
    var targetPrototype = target.prototype;
    var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
    var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
    for(key in source){
        FORCED = $iaZZ9(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contains in native
        USE_NATIVE = !FORCED && nativeSource && $heVlo(nativeSource, key);
        targetProperty = target[key];
        if (USE_NATIVE) {
            if (options.dontCallGetSet) {
                descriptor = $bd67cdff1139f731$require$getOwnPropertyDescriptor(nativeSource, key);
                nativeProperty = descriptor && descriptor.value;
            } else nativeProperty = nativeSource[key];
        }
        // export native or implementation
        sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
        if (!FORCED && !PROTO && typeof targetProperty == typeof sourceProperty) continue;
        // bind methods to global for calling from export context
        if (options.bind && USE_NATIVE) resultProperty = $b5UsH(sourceProperty, $9l3PP);
        else if (options.wrap && USE_NATIVE) resultProperty = $bd67cdff1139f731$var$wrapConstructor(sourceProperty);
        else if (PROTO && $e6Rz5(sourceProperty)) resultProperty = $5FNR6(sourceProperty);
        else resultProperty = sourceProperty;
        // add a flag to not completely full polyfills
        if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) $k4kcW(resultProperty, "sham", true);
        $k4kcW(target, key, resultProperty);
        if (PROTO) {
            VIRTUAL_PROTOTYPE = TARGET + "Prototype";
            if (!$heVlo($ly30u, VIRTUAL_PROTOTYPE)) $k4kcW($ly30u, VIRTUAL_PROTOTYPE, {});
            // export virtual prototype methods
            $k4kcW($ly30u[VIRTUAL_PROTOTYPE], key, sourceProperty);
            // export real prototype methods
            if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) $k4kcW(targetPrototype, key, sourceProperty);
        }
    }
};

});
parcelRegister("2JOsI", function(module, exports) {
"use strict";

var $4abbf = parcelRequire("4abbf");
var $1fe6ed77f53bfcf9$var$FunctionPrototype = Function.prototype;
var $1fe6ed77f53bfcf9$var$apply = $1fe6ed77f53bfcf9$var$FunctionPrototype.apply;
var $1fe6ed77f53bfcf9$var$call = $1fe6ed77f53bfcf9$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == "object" && Reflect.apply || ($4abbf ? $1fe6ed77f53bfcf9$var$call.bind($1fe6ed77f53bfcf9$var$apply) : function() {
    return $1fe6ed77f53bfcf9$var$call.apply($1fe6ed77f53bfcf9$var$apply, arguments);
});

});

parcelRegister("5FNR6", function(module, exports) {
"use strict";

var $bTsfg = parcelRequire("bTsfg");

var $f518o = parcelRequire("f518o");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($bTsfg(fn) === "Function") return $f518o(fn);
};

});

parcelRegister("fTFId", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $b92c593844a00ebc$export$2d1720544b23b823; }, function (v) { return $b92c593844a00ebc$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $b92c593844a00ebc$export$2d1720544b23b823;
"use strict";

var $jeZ4p = parcelRequire("jeZ4p");

var $aELZY = parcelRequire("aELZY");

var $d5uYy = parcelRequire("d5uYy");

var $8c6fn = parcelRequire("8c6fn");

var $bYkAs = parcelRequire("bYkAs");

var $eBk19 = parcelRequire("eBk19");

var $heVlo = parcelRequire("heVlo");

var $9E0l8 = parcelRequire("9E0l8");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $b92c593844a00ebc$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$b92c593844a00ebc$export$2d1720544b23b823 = $jeZ4p ? $b92c593844a00ebc$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $bYkAs(O);
    P = $eBk19(P);
    if ($9E0l8) try {
        return $b92c593844a00ebc$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($heVlo(O, P)) return $8c6fn(!$aELZY($d5uYy.f, O, P), O[P]);
};

});
parcelRegister("d5uYy", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $9873c51cd09bc8e8$export$2d1720544b23b823; }, function (v) { return $9873c51cd09bc8e8$export$2d1720544b23b823 = v; });
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $9873c51cd09bc8e8$export$2d1720544b23b823;
"use strict";
var $9873c51cd09bc8e8$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $9873c51cd09bc8e8$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $9873c51cd09bc8e8$var$NASHORN_BUG = $9873c51cd09bc8e8$var$getOwnPropertyDescriptor && !$9873c51cd09bc8e8$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$9873c51cd09bc8e8$export$2d1720544b23b823 = $9873c51cd09bc8e8$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $9873c51cd09bc8e8$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $9873c51cd09bc8e8$var$$propertyIsEnumerable;

});


parcelRegister("iaZZ9", function(module, exports) {
"use strict";

var $77TPA = parcelRequire("77TPA");

var $e6Rz5 = parcelRequire("e6Rz5");
var $d3b93e2220965ba3$var$replacement = /#|\.prototype\./;
var $d3b93e2220965ba3$var$isForced = function(feature, detection) {
    var value = $d3b93e2220965ba3$var$data[$d3b93e2220965ba3$var$normalize(feature)];
    return value === $d3b93e2220965ba3$var$POLYFILL ? true : value === $d3b93e2220965ba3$var$NATIVE ? false : $e6Rz5(detection) ? $77TPA(detection) : !!detection;
};
var $d3b93e2220965ba3$var$normalize = $d3b93e2220965ba3$var$isForced.normalize = function(string) {
    return String(string).replace($d3b93e2220965ba3$var$replacement, ".").toLowerCase();
};
var $d3b93e2220965ba3$var$data = $d3b93e2220965ba3$var$isForced.data = {};
var $d3b93e2220965ba3$var$NATIVE = $d3b93e2220965ba3$var$isForced.NATIVE = "N";
var $d3b93e2220965ba3$var$POLYFILL = $d3b93e2220965ba3$var$isForced.POLYFILL = "P";
module.exports = $d3b93e2220965ba3$var$isForced;

});

parcelRegister("b5UsH", function(module, exports) {
"use strict";

var $5FNR6 = parcelRequire("5FNR6");

var $8GsPx = parcelRequire("8GsPx");

var $4abbf = parcelRequire("4abbf");
var $813bf57ad4cb3874$var$bind = $5FNR6($5FNR6.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    $8GsPx(fn);
    return that === undefined ? fn : $4abbf ? $813bf57ad4cb3874$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

});


parcelRegister("3mtHt", function(module, exports) {
"use strict";

var $jeZ4p = parcelRequire("jeZ4p");

var $heVlo = parcelRequire("heVlo");
var $272a77017ce23a3f$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $272a77017ce23a3f$var$getDescriptor = $jeZ4p && Object.getOwnPropertyDescriptor;
var $272a77017ce23a3f$var$EXISTS = $heVlo($272a77017ce23a3f$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $272a77017ce23a3f$var$PROPER = $272a77017ce23a3f$var$EXISTS && (function something() {}).name === "something";
var $272a77017ce23a3f$var$CONFIGURABLE = $272a77017ce23a3f$var$EXISTS && (!$jeZ4p || $jeZ4p && $272a77017ce23a3f$var$getDescriptor($272a77017ce23a3f$var$FunctionPrototype, "name").configurable);
module.exports = {
    EXISTS: $272a77017ce23a3f$var$EXISTS,
    PROPER: $272a77017ce23a3f$var$PROPER,
    CONFIGURABLE: $272a77017ce23a3f$var$CONFIGURABLE
};

});

parcelRegister("c713e", function(module, exports) {
"use strict";

var $5cZ5h = parcelRequire("5cZ5h");
var $8d16f43a61fa9285$require$IteratorPrototype = $5cZ5h.IteratorPrototype;

var $fhVPP = parcelRequire("fhVPP");

var $8c6fn = parcelRequire("8c6fn");

var $dheYH = parcelRequire("dheYH");

var $lmV2R = parcelRequire("lmV2R");
var $8d16f43a61fa9285$var$returnThis = function() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $fhVPP($8d16f43a61fa9285$require$IteratorPrototype, {
        next: $8c6fn(+!ENUMERABLE_NEXT, next)
    });
    $dheYH(IteratorConstructor, TO_STRING_TAG, false, true);
    $lmV2R[TO_STRING_TAG] = $8d16f43a61fa9285$var$returnThis;
    return IteratorConstructor;
};

});
parcelRegister("5cZ5h", function(module, exports) {
"use strict";

var $77TPA = parcelRequire("77TPA");

var $e6Rz5 = parcelRequire("e6Rz5");

var $1WYwK = parcelRequire("1WYwK");

var $fhVPP = parcelRequire("fhVPP");

var $2pQL6 = parcelRequire("2pQL6");

var $kY5Tb = parcelRequire("kY5Tb");

var $fq7H3 = parcelRequire("fq7H3");

var $7phdw = parcelRequire("7phdw");
var $3cad74ce71fd0eea$var$ITERATOR = $fq7H3("iterator");
var $3cad74ce71fd0eea$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $3cad74ce71fd0eea$var$IteratorPrototype, $3cad74ce71fd0eea$var$PrototypeOfArrayIteratorPrototype, $3cad74ce71fd0eea$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $3cad74ce71fd0eea$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $3cad74ce71fd0eea$var$arrayIterator)) $3cad74ce71fd0eea$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $3cad74ce71fd0eea$var$PrototypeOfArrayIteratorPrototype = $2pQL6($2pQL6($3cad74ce71fd0eea$var$arrayIterator));
        if ($3cad74ce71fd0eea$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $3cad74ce71fd0eea$var$IteratorPrototype = $3cad74ce71fd0eea$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $3cad74ce71fd0eea$var$NEW_ITERATOR_PROTOTYPE = !$1WYwK($3cad74ce71fd0eea$var$IteratorPrototype) || $77TPA(function() {
    var test = {};
    // FF44- legacy iterators case
    return $3cad74ce71fd0eea$var$IteratorPrototype[$3cad74ce71fd0eea$var$ITERATOR].call(test) !== test;
});
if ($3cad74ce71fd0eea$var$NEW_ITERATOR_PROTOTYPE) $3cad74ce71fd0eea$var$IteratorPrototype = {};
else if ($7phdw) $3cad74ce71fd0eea$var$IteratorPrototype = $fhVPP($3cad74ce71fd0eea$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$e6Rz5($3cad74ce71fd0eea$var$IteratorPrototype[$3cad74ce71fd0eea$var$ITERATOR])) $kY5Tb($3cad74ce71fd0eea$var$IteratorPrototype, $3cad74ce71fd0eea$var$ITERATOR, function() {
    return this;
});
module.exports = {
    IteratorPrototype: $3cad74ce71fd0eea$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $3cad74ce71fd0eea$var$BUGGY_SAFARI_ITERATORS
};

});
parcelRegister("fhVPP", function(module, exports) {
"use strict";

var $l3LMJ = parcelRequire("l3LMJ");

var $a965u = parcelRequire("a965u");

var $4mKOn = parcelRequire("4mKOn");

var $lKGD2 = parcelRequire("lKGD2");

var $f0Cl9 = parcelRequire("f0Cl9");

var $kHYxY = parcelRequire("kHYxY");

var $aUKPz = parcelRequire("aUKPz");
var $b2154e617ce55b74$var$GT = ">";
var $b2154e617ce55b74$var$LT = "<";
var $b2154e617ce55b74$var$PROTOTYPE = "prototype";
var $b2154e617ce55b74$var$SCRIPT = "script";
var $b2154e617ce55b74$var$IE_PROTO = $aUKPz("IE_PROTO");
var $b2154e617ce55b74$var$EmptyConstructor = function() {};
var $b2154e617ce55b74$var$scriptTag = function(content) {
    return $b2154e617ce55b74$var$LT + $b2154e617ce55b74$var$SCRIPT + $b2154e617ce55b74$var$GT + content + $b2154e617ce55b74$var$LT + "/" + $b2154e617ce55b74$var$SCRIPT + $b2154e617ce55b74$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $b2154e617ce55b74$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($b2154e617ce55b74$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $b2154e617ce55b74$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $kHYxY("iframe");
    var JS = "java" + $b2154e617ce55b74$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $f0Cl9.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($b2154e617ce55b74$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $b2154e617ce55b74$var$activeXDocument;
var $b2154e617ce55b74$var$NullProtoObject = function() {
    try {
        $b2154e617ce55b74$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $b2154e617ce55b74$var$NullProtoObject = typeof document != "undefined" ? document.domain && $b2154e617ce55b74$var$activeXDocument ? $b2154e617ce55b74$var$NullProtoObjectViaActiveX($b2154e617ce55b74$var$activeXDocument) // old IE
     : $b2154e617ce55b74$var$NullProtoObjectViaIFrame() : $b2154e617ce55b74$var$NullProtoObjectViaActiveX($b2154e617ce55b74$var$activeXDocument); // WSH
    var length = $4mKOn.length;
    while(length--)delete $b2154e617ce55b74$var$NullProtoObject[$b2154e617ce55b74$var$PROTOTYPE][$4mKOn[length]];
    return $b2154e617ce55b74$var$NullProtoObject();
};
$lKGD2[$b2154e617ce55b74$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $b2154e617ce55b74$var$EmptyConstructor[$b2154e617ce55b74$var$PROTOTYPE] = $l3LMJ(O);
        result = new $b2154e617ce55b74$var$EmptyConstructor();
        $b2154e617ce55b74$var$EmptyConstructor[$b2154e617ce55b74$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$b2154e617ce55b74$var$IE_PROTO] = O;
    } else result = $b2154e617ce55b74$var$NullProtoObject();
    return Properties === undefined ? result : $a965u.f(result, Properties);
};

});
parcelRegister("a965u", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $762f7781ac324761$export$2d1720544b23b823; }, function (v) { return $762f7781ac324761$export$2d1720544b23b823 = v; });
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $762f7781ac324761$export$2d1720544b23b823;
"use strict";

var $jeZ4p = parcelRequire("jeZ4p");

var $5Shx3 = parcelRequire("5Shx3");

var $diq7r = parcelRequire("diq7r");

var $l3LMJ = parcelRequire("l3LMJ");

var $bYkAs = parcelRequire("bYkAs");

var $3Ut0t = parcelRequire("3Ut0t");
$762f7781ac324761$export$2d1720544b23b823 = $jeZ4p && !$5Shx3 ? Object.defineProperties : function defineProperties(O, Properties) {
    $l3LMJ(O);
    var props = $bYkAs(Properties);
    var keys = $3Ut0t(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$diq7r.f(O, key = keys[index++], props[key]);
    return O;
};

});
parcelRegister("3Ut0t", function(module, exports) {
"use strict";

var $4aJsK = parcelRequire("4aJsK");

var $4mKOn = parcelRequire("4mKOn");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return $4aJsK(O, $4mKOn);
};

});
parcelRegister("4aJsK", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");

var $heVlo = parcelRequire("heVlo");

var $bYkAs = parcelRequire("bYkAs");

var $3NUiQ = parcelRequire("3NUiQ");
var $309b5c8313a5777b$require$indexOf = $3NUiQ.indexOf;

var $lKGD2 = parcelRequire("lKGD2");
var $309b5c8313a5777b$var$push = $f518o([].push);
module.exports = function(object, names) {
    var O = $bYkAs(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$heVlo($lKGD2, key) && $heVlo(O, key) && $309b5c8313a5777b$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($heVlo(O, key = names[i++])) ~$309b5c8313a5777b$require$indexOf(result, key) || $309b5c8313a5777b$var$push(result, key);
    return result;
};

});
parcelRegister("3NUiQ", function(module, exports) {
"use strict";

var $bYkAs = parcelRequire("bYkAs");

var $2s0YW = parcelRequire("2s0YW");

var $6ocdr = parcelRequire("6ocdr");
// `Array.prototype.{ indexOf, includes }` methods implementation
var $2c519f5086e10272$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $bYkAs($this);
        var length = $6ocdr(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $2s0YW(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $2c519f5086e10272$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $2c519f5086e10272$var$createMethod(false)
};

});
parcelRegister("2s0YW", function(module, exports) {
"use strict";

var $3ZmxQ = parcelRequire("3ZmxQ");
var $1c8ef54373f1e5b2$var$max = Math.max;
var $1c8ef54373f1e5b2$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = $3ZmxQ(index);
    return integer < 0 ? $1c8ef54373f1e5b2$var$max(integer + length, 0) : $1c8ef54373f1e5b2$var$min(integer, length);
};

});
parcelRegister("3ZmxQ", function(module, exports) {
"use strict";

var $61khJ = parcelRequire("61khJ");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $61khJ(number);
};

});
parcelRegister("61khJ", function(module, exports) {
"use strict";
var $4622923b6f763fec$var$ceil = Math.ceil;
var $4622923b6f763fec$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $4622923b6f763fec$var$floor : $4622923b6f763fec$var$ceil)(n);
};

});



parcelRegister("6ocdr", function(module, exports) {
"use strict";

var $8xt01 = parcelRequire("8xt01");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return $8xt01(obj.length);
};

});
parcelRegister("8xt01", function(module, exports) {
"use strict";

var $3ZmxQ = parcelRequire("3ZmxQ");
var $019ab543e8c37611$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    var len = $3ZmxQ(argument);
    return len > 0 ? $019ab543e8c37611$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});




parcelRegister("4mKOn", function(module, exports) {
"use strict";
// IE8- don't enum bug keys
module.exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];

});



parcelRegister("f0Cl9", function(module, exports) {
"use strict";

var $5Pobw = parcelRequire("5Pobw");
module.exports = $5Pobw("document", "documentElement");

});


parcelRegister("2pQL6", function(module, exports) {
"use strict";

var $heVlo = parcelRequire("heVlo");

var $e6Rz5 = parcelRequire("e6Rz5");

var $iJNxK = parcelRequire("iJNxK");

var $aUKPz = parcelRequire("aUKPz");

var $lss67 = parcelRequire("lss67");
var $1c26d7549f99106c$var$IE_PROTO = $aUKPz("IE_PROTO");
var $1c26d7549f99106c$var$$Object = Object;
var $1c26d7549f99106c$var$ObjectPrototype = $1c26d7549f99106c$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = $lss67 ? $1c26d7549f99106c$var$$Object.getPrototypeOf : function(O) {
    var object = $iJNxK(O);
    if ($heVlo(object, $1c26d7549f99106c$var$IE_PROTO)) return object[$1c26d7549f99106c$var$IE_PROTO];
    var constructor = object.constructor;
    if ($e6Rz5(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $1c26d7549f99106c$var$$Object ? $1c26d7549f99106c$var$ObjectPrototype : null;
};

});
parcelRegister("lss67", function(module, exports) {
"use strict";

var $77TPA = parcelRequire("77TPA");
module.exports = !$77TPA(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

});


parcelRegister("kY5Tb", function(module, exports) {
"use strict";

var $k4kcW = parcelRequire("k4kcW");
module.exports = function(target, key, value, options) {
    if (options && options.enumerable) target[key] = value;
    else $k4kcW(target, key, value);
    return target;
};

});


parcelRegister("dheYH", function(module, exports) {
"use strict";

var $6WE3a = parcelRequire("6WE3a");

var $diq7r = parcelRequire("diq7r");
var $9aa87b38f09a974a$require$defineProperty = $diq7r.f;

var $k4kcW = parcelRequire("k4kcW");

var $heVlo = parcelRequire("heVlo");

var $akp1c = parcelRequire("akp1c");

var $fq7H3 = parcelRequire("fq7H3");
var $9aa87b38f09a974a$var$TO_STRING_TAG = $fq7H3("toStringTag");
module.exports = function(it, TAG, STATIC, SET_METHOD) {
    var target = STATIC ? it : it && it.prototype;
    if (target) {
        if (!$heVlo(target, $9aa87b38f09a974a$var$TO_STRING_TAG)) $9aa87b38f09a974a$require$defineProperty(target, $9aa87b38f09a974a$var$TO_STRING_TAG, {
            configurable: true,
            value: TAG
        });
        if (SET_METHOD && !$6WE3a) $k4kcW(target, "toString", $akp1c);
    }
};

});
parcelRegister("6WE3a", function(module, exports) {
"use strict";

var $fq7H3 = parcelRequire("fq7H3");
var $50e739fb2ec827de$var$TO_STRING_TAG = $fq7H3("toStringTag");
var $50e739fb2ec827de$var$test = {};
$50e739fb2ec827de$var$test[$50e739fb2ec827de$var$TO_STRING_TAG] = "z";
module.exports = String($50e739fb2ec827de$var$test) === "[object z]";

});

parcelRegister("akp1c", function(module, exports) {
"use strict";

var $6WE3a = parcelRequire("6WE3a");

var $aHxiP = parcelRequire("aHxiP");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = $6WE3a ? ({}).toString : function toString() {
    return "[object " + $aHxiP(this) + "]";
};

});
parcelRegister("aHxiP", function(module, exports) {
"use strict";

var $6WE3a = parcelRequire("6WE3a");

var $e6Rz5 = parcelRequire("e6Rz5");

var $bTsfg = parcelRequire("bTsfg");

var $fq7H3 = parcelRequire("fq7H3");
var $7ca7c0c7b62cb973$var$TO_STRING_TAG = $fq7H3("toStringTag");
var $7ca7c0c7b62cb973$var$$Object = Object;
// ES3 wrong here
var $7ca7c0c7b62cb973$var$CORRECT_ARGUMENTS = $bTsfg(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $7ca7c0c7b62cb973$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = $6WE3a ? $bTsfg : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $7ca7c0c7b62cb973$var$tryGet(O = $7ca7c0c7b62cb973$var$$Object(it), $7ca7c0c7b62cb973$var$TO_STRING_TAG)) == "string" ? tag : $7ca7c0c7b62cb973$var$CORRECT_ARGUMENTS ? $bTsfg(O) : (result = $bTsfg(O)) === "Object" && $e6Rz5(O.callee) ? "Arguments" : result;
};

});




parcelRegister("6e7Qv", function(module, exports) {
"use strict";

var $bDN0F = parcelRequire("bDN0F");

var $1WYwK = parcelRequire("1WYwK");

var $cBWnS = parcelRequire("cBWnS");

var $9Vbk9 = parcelRequire("9Vbk9");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $bDN0F(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $cBWnS(O);
        $9Vbk9(proto);
        if (!$1WYwK(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

});
parcelRegister("bDN0F", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");

var $8GsPx = parcelRequire("8GsPx");
module.exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $f518o($8GsPx(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};

});

parcelRegister("9Vbk9", function(module, exports) {
"use strict";

var $hPrFs = parcelRequire("hPrFs");
var $739238a3929f6003$var$$String = String;
var $739238a3929f6003$var$$TypeError = TypeError;
module.exports = function(argument) {
    if ($hPrFs(argument)) return argument;
    throw new $739238a3929f6003$var$$TypeError("Can't set " + $739238a3929f6003$var$$String(argument) + " as a prototype");
};

});
parcelRegister("hPrFs", function(module, exports) {
"use strict";

var $1WYwK = parcelRequire("1WYwK");
module.exports = function(argument) {
    return $1WYwK(argument) || argument === null;
};

});




parcelRegister("5IrwJ", function(module, exports) {
"use strict";
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};

});


parcelRegister("iYyco", function(module, exports) {
// empty

});

parcelRegister("15yqC", function(module, exports) {
"use strict";
parcelRequire("8jHfZ");

});
parcelRegister("8jHfZ", function(module, exports) {
"use strict";

var $7DccQ = parcelRequire("7DccQ");

var $9l3PP = parcelRequire("9l3PP");

var $f518o = parcelRequire("f518o");

var $gklY2 = parcelRequire("gklY2");

var $iZE4H = parcelRequire("iZE4H");

var $30YqS = parcelRequire("30YqS");

var $f9bwY = parcelRequire("f9bwY");

var $1WYwK = parcelRequire("1WYwK");

var $fmQ29 = parcelRequire("fmQ29");
var $60e1a7058f7ed582$require$enforceInternalState = $fmQ29.enforce;

var $77TPA = parcelRequire("77TPA");

var $3rZfY = parcelRequire("3rZfY");
var $60e1a7058f7ed582$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $60e1a7058f7ed582$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $60e1a7058f7ed582$var$isExtensible = $60e1a7058f7ed582$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $60e1a7058f7ed582$var$isFrozen = $60e1a7058f7ed582$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $60e1a7058f7ed582$var$isSealed = $60e1a7058f7ed582$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $60e1a7058f7ed582$var$freeze = $60e1a7058f7ed582$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $60e1a7058f7ed582$var$seal = $60e1a7058f7ed582$var$$Object.seal;
var $60e1a7058f7ed582$var$IS_IE11 = !$9l3PP.ActiveXObject && "ActiveXObject" in $9l3PP;
var $60e1a7058f7ed582$var$InternalWeakMap;
var $60e1a7058f7ed582$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $60e1a7058f7ed582$var$$WeakMap = $30YqS("WeakMap", $60e1a7058f7ed582$var$wrapper, $f9bwY);
var $60e1a7058f7ed582$var$WeakMapPrototype = $60e1a7058f7ed582$var$$WeakMap.prototype;
var $60e1a7058f7ed582$var$nativeSet = $f518o($60e1a7058f7ed582$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $60e1a7058f7ed582$var$hasMSEdgeFreezingBug = function() {
    return $7DccQ && $77TPA(function() {
        var frozenArray = $60e1a7058f7ed582$var$freeze([]);
        $60e1a7058f7ed582$var$nativeSet(new $60e1a7058f7ed582$var$$WeakMap(), frozenArray, 1);
        return !$60e1a7058f7ed582$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($3rZfY) {
    if ($60e1a7058f7ed582$var$IS_IE11) {
        $60e1a7058f7ed582$var$InternalWeakMap = $f9bwY.getConstructor($60e1a7058f7ed582$var$wrapper, "WeakMap", true);
        $iZE4H.enable();
        var $60e1a7058f7ed582$var$nativeDelete = $f518o($60e1a7058f7ed582$var$WeakMapPrototype["delete"]);
        var $60e1a7058f7ed582$var$nativeHas = $f518o($60e1a7058f7ed582$var$WeakMapPrototype.has);
        var $60e1a7058f7ed582$var$nativeGet = $f518o($60e1a7058f7ed582$var$WeakMapPrototype.get);
        $gklY2($60e1a7058f7ed582$var$WeakMapPrototype, {
            "delete": function(key) {
                if ($1WYwK(key) && !$60e1a7058f7ed582$var$isExtensible(key)) {
                    var state = $60e1a7058f7ed582$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $60e1a7058f7ed582$var$InternalWeakMap();
                    return $60e1a7058f7ed582$var$nativeDelete(this, key) || state.frozen["delete"](key);
                }
                return $60e1a7058f7ed582$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($1WYwK(key) && !$60e1a7058f7ed582$var$isExtensible(key)) {
                    var state = $60e1a7058f7ed582$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $60e1a7058f7ed582$var$InternalWeakMap();
                    return $60e1a7058f7ed582$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $60e1a7058f7ed582$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($1WYwK(key) && !$60e1a7058f7ed582$var$isExtensible(key)) {
                    var state = $60e1a7058f7ed582$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $60e1a7058f7ed582$var$InternalWeakMap();
                    return $60e1a7058f7ed582$var$nativeHas(this, key) ? $60e1a7058f7ed582$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $60e1a7058f7ed582$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($1WYwK(key) && !$60e1a7058f7ed582$var$isExtensible(key)) {
                    var state = $60e1a7058f7ed582$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $60e1a7058f7ed582$var$InternalWeakMap();
                    $60e1a7058f7ed582$var$nativeHas(this, key) ? $60e1a7058f7ed582$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $60e1a7058f7ed582$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($60e1a7058f7ed582$var$hasMSEdgeFreezingBug()) $gklY2($60e1a7058f7ed582$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($60e1a7058f7ed582$var$isArray(key)) {
                if ($60e1a7058f7ed582$var$isFrozen(key)) arrayIntegrityLevel = $60e1a7058f7ed582$var$freeze;
                else if ($60e1a7058f7ed582$var$isSealed(key)) arrayIntegrityLevel = $60e1a7058f7ed582$var$seal;
            }
            $60e1a7058f7ed582$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel) arrayIntegrityLevel(key);
            return this;
        }
    });
}

});
parcelRegister("7DccQ", function(module, exports) {
"use strict";

var $77TPA = parcelRequire("77TPA");
module.exports = !$77TPA(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});

});

parcelRegister("gklY2", function(module, exports) {
"use strict";

var $kY5Tb = parcelRequire("kY5Tb");
module.exports = function(target, src, options) {
    for(var key in src)if (options && options.unsafe && target[key]) target[key] = src[key];
    else $kY5Tb(target, key, src[key], options);
    return target;
};

});

parcelRegister("iZE4H", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $f518o = parcelRequire("f518o");

var $lKGD2 = parcelRequire("lKGD2");

var $1WYwK = parcelRequire("1WYwK");

var $heVlo = parcelRequire("heVlo");

var $diq7r = parcelRequire("diq7r");
var $dd3d02812fbc62e5$require$defineProperty = $diq7r.f;

var $9hUhV = parcelRequire("9hUhV");

var $cMezS = parcelRequire("cMezS");

var $CMtyq = parcelRequire("CMtyq");

var $kuKGb = parcelRequire("kuKGb");

var $7DccQ = parcelRequire("7DccQ");
var $dd3d02812fbc62e5$var$REQUIRED = false;
var $dd3d02812fbc62e5$var$METADATA = $kuKGb("meta");
var $dd3d02812fbc62e5$var$id = 0;
var $dd3d02812fbc62e5$var$setMetadata = function(it) {
    $dd3d02812fbc62e5$require$defineProperty(it, $dd3d02812fbc62e5$var$METADATA, {
        value: {
            objectID: "O" + $dd3d02812fbc62e5$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $dd3d02812fbc62e5$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$1WYwK(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$heVlo(it, $dd3d02812fbc62e5$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$CMtyq(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $dd3d02812fbc62e5$var$setMetadata(it);
    // return object ID
    }
    return it[$dd3d02812fbc62e5$var$METADATA].objectID;
};
var $dd3d02812fbc62e5$var$getWeakData = function(it, create) {
    if (!$heVlo(it, $dd3d02812fbc62e5$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$CMtyq(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $dd3d02812fbc62e5$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$dd3d02812fbc62e5$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $dd3d02812fbc62e5$var$onFreeze = function(it) {
    if ($7DccQ && $dd3d02812fbc62e5$var$REQUIRED && $CMtyq(it) && !$heVlo(it, $dd3d02812fbc62e5$var$METADATA)) $dd3d02812fbc62e5$var$setMetadata(it);
    return it;
};
var $dd3d02812fbc62e5$var$enable = function() {
    $dd3d02812fbc62e5$var$meta.enable = function() {};
    $dd3d02812fbc62e5$var$REQUIRED = true;
    var getOwnPropertyNames = $9hUhV.f;
    var splice = $f518o([].splice);
    var test = {};
    test[$dd3d02812fbc62e5$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $9hUhV.f = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $dd3d02812fbc62e5$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $ggcsv({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $cMezS.f
        });
    }
};
var $dd3d02812fbc62e5$var$meta = module.exports = {
    enable: $dd3d02812fbc62e5$var$enable,
    fastKey: $dd3d02812fbc62e5$var$fastKey,
    getWeakData: $dd3d02812fbc62e5$var$getWeakData,
    onFreeze: $dd3d02812fbc62e5$var$onFreeze
};
$lKGD2[$dd3d02812fbc62e5$var$METADATA] = true;

});
parcelRegister("9hUhV", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $6c315d3c53f090a4$export$2d1720544b23b823; }, function (v) { return $6c315d3c53f090a4$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $6c315d3c53f090a4$export$2d1720544b23b823;
"use strict";

var $4aJsK = parcelRequire("4aJsK");

var $4mKOn = parcelRequire("4mKOn");
var $6c315d3c53f090a4$var$hiddenKeys = $4mKOn.concat("length", "prototype");
$6c315d3c53f090a4$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $4aJsK(O, $6c315d3c53f090a4$var$hiddenKeys);
};

});

parcelRegister("cMezS", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $94d5468708b48bdd$export$2d1720544b23b823; }, function (v) { return $94d5468708b48bdd$export$2d1720544b23b823 = v; });
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $94d5468708b48bdd$export$2d1720544b23b823;
"use strict";

var $bTsfg = parcelRequire("bTsfg");

var $bYkAs = parcelRequire("bYkAs");

var $9hUhV = parcelRequire("9hUhV");
var $94d5468708b48bdd$require$$getOwnPropertyNames = $9hUhV.f;

var $hF40G = parcelRequire("hF40G");
var $94d5468708b48bdd$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $94d5468708b48bdd$var$getWindowNames = function(it) {
    try {
        return $94d5468708b48bdd$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $hF40G($94d5468708b48bdd$var$windowNames);
    }
};
$94d5468708b48bdd$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $94d5468708b48bdd$var$windowNames && $bTsfg(it) === "Window" ? $94d5468708b48bdd$var$getWindowNames(it) : $94d5468708b48bdd$require$$getOwnPropertyNames($bYkAs(it));
};

});
parcelRegister("hF40G", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");
module.exports = $f518o([].slice);

});


parcelRegister("CMtyq", function(module, exports) {
"use strict";

var $77TPA = parcelRequire("77TPA");

var $1WYwK = parcelRequire("1WYwK");

var $bTsfg = parcelRequire("bTsfg");

var $4DiPJ = parcelRequire("4DiPJ");
// eslint-disable-next-line es/no-object-isextensible -- safe
var $074926fc34266401$var$$isExtensible = Object.isExtensible;
var $074926fc34266401$var$FAILS_ON_PRIMITIVES = $77TPA(function() {
    $074926fc34266401$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = $074926fc34266401$var$FAILS_ON_PRIMITIVES || $4DiPJ ? function isExtensible(it) {
    if (!$1WYwK(it)) return false;
    if ($4DiPJ && $bTsfg(it) === "ArrayBuffer") return false;
    return $074926fc34266401$var$$isExtensible ? $074926fc34266401$var$$isExtensible(it) : true;
} : $074926fc34266401$var$$isExtensible;

});
parcelRegister("4DiPJ", function(module, exports) {
"use strict";

var $77TPA = parcelRequire("77TPA");
module.exports = $77TPA(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});

});



parcelRegister("30YqS", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $9l3PP = parcelRequire("9l3PP");

var $iZE4H = parcelRequire("iZE4H");

var $77TPA = parcelRequire("77TPA");

var $k4kcW = parcelRequire("k4kcW");

var $jUk8Y = parcelRequire("jUk8Y");

var $a95no = parcelRequire("a95no");

var $e6Rz5 = parcelRequire("e6Rz5");

var $1WYwK = parcelRequire("1WYwK");

var $6exeg = parcelRequire("6exeg");

var $dheYH = parcelRequire("dheYH");

var $diq7r = parcelRequire("diq7r");
var $23203fd0f826b34f$require$defineProperty = $diq7r.f;

var $igsV9 = parcelRequire("igsV9");
var $23203fd0f826b34f$require$forEach = $igsV9.forEach;

var $jeZ4p = parcelRequire("jeZ4p");

var $fmQ29 = parcelRequire("fmQ29");
var $23203fd0f826b34f$var$setInternalState = $fmQ29.set;
var $23203fd0f826b34f$var$internalStateGetterFor = $fmQ29.getterFor;
module.exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = $9l3PP[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var exported = {};
    var Constructor;
    if (!$jeZ4p || !$e6Rz5(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$77TPA(function() {
        new NativeConstructor().entries().next();
    }))) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $iZE4H.enable();
    } else {
        Constructor = wrapper(function(target, iterable) {
            $23203fd0f826b34f$var$setInternalState($a95no(target, Prototype), {
                type: CONSTRUCTOR_NAME,
                collection: new NativeConstructor()
            });
            if (!$6exeg(iterable)) $jUk8Y(iterable, target[ADDER], {
                that: target,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $23203fd0f826b34f$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        $23203fd0f826b34f$require$forEach([
            "add",
            "clear",
            "delete",
            "forEach",
            "get",
            "has",
            "set",
            "keys",
            "values",
            "entries"
        ], function(KEY) {
            var IS_ADDER = KEY === "add" || KEY === "set";
            if (KEY in NativePrototype && !(IS_WEAK && KEY === "clear")) $k4kcW(Prototype, KEY, function(a, b) {
                var collection = getInternalState(this).collection;
                if (!IS_ADDER && IS_WEAK && !$1WYwK(a)) return KEY === "get" ? undefined : false;
                var result = collection[KEY](a === 0 ? 0 : a, b);
                return IS_ADDER ? this : result;
            });
        });
        IS_WEAK || $23203fd0f826b34f$require$defineProperty(Prototype, "size", {
            configurable: true,
            get: function() {
                return getInternalState(this).collection.size;
            }
        });
    }
    $dheYH(Constructor, CONSTRUCTOR_NAME, false, true);
    exported[CONSTRUCTOR_NAME] = Constructor;
    $ggcsv({
        global: true,
        forced: true
    }, exported);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};

});
parcelRegister("jUk8Y", function(module, exports) {
"use strict";

var $b5UsH = parcelRequire("b5UsH");

var $aELZY = parcelRequire("aELZY");

var $l3LMJ = parcelRequire("l3LMJ");

var $k9gzN = parcelRequire("k9gzN");

var $b4lk6 = parcelRequire("b4lk6");

var $6ocdr = parcelRequire("6ocdr");

var $8hsAO = parcelRequire("8hsAO");

var $3Tvts = parcelRequire("3Tvts");

var $7qrIj = parcelRequire("7qrIj");

var $2l0vW = parcelRequire("2l0vW");
var $e7e2df65bcc557ea$var$$TypeError = TypeError;
var $e7e2df65bcc557ea$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $e7e2df65bcc557ea$var$ResultPrototype = $e7e2df65bcc557ea$var$Result.prototype;
module.exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $b5UsH(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $2l0vW(iterator, "normal", condition);
        return new $e7e2df65bcc557ea$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $l3LMJ(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $7qrIj(iterable);
        if (!iterFn) throw new $e7e2df65bcc557ea$var$$TypeError($k9gzN(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($b4lk6(iterFn)) {
            for(index = 0, length = $6ocdr(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $8hsAO($e7e2df65bcc557ea$var$ResultPrototype, result)) return result;
            }
            return new $e7e2df65bcc557ea$var$Result(false);
        }
        iterator = $3Tvts(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $aELZY(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $2l0vW(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $8hsAO($e7e2df65bcc557ea$var$ResultPrototype, result)) return result;
    }
    return new $e7e2df65bcc557ea$var$Result(false);
};

});
parcelRegister("b4lk6", function(module, exports) {
"use strict";

var $fq7H3 = parcelRequire("fq7H3");

var $lmV2R = parcelRequire("lmV2R");
var $80f09bc4b6f9a218$var$ITERATOR = $fq7H3("iterator");
var $80f09bc4b6f9a218$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && ($lmV2R.Array === it || $80f09bc4b6f9a218$var$ArrayPrototype[$80f09bc4b6f9a218$var$ITERATOR] === it);
};

});

parcelRegister("3Tvts", function(module, exports) {
"use strict";

var $aELZY = parcelRequire("aELZY");

var $8GsPx = parcelRequire("8GsPx");

var $l3LMJ = parcelRequire("l3LMJ");

var $k9gzN = parcelRequire("k9gzN");

var $7qrIj = parcelRequire("7qrIj");
var $2d5eec4516fc0054$var$$TypeError = TypeError;
module.exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $7qrIj(argument) : usingIterator;
    if ($8GsPx(iteratorMethod)) return $l3LMJ($aELZY(iteratorMethod, argument));
    throw new $2d5eec4516fc0054$var$$TypeError($k9gzN(argument) + " is not iterable");
};

});
parcelRegister("7qrIj", function(module, exports) {
"use strict";

var $aHxiP = parcelRequire("aHxiP");

var $k0Syp = parcelRequire("k0Syp");

var $6exeg = parcelRequire("6exeg");

var $lmV2R = parcelRequire("lmV2R");

var $fq7H3 = parcelRequire("fq7H3");
var $5680757ad4007747$var$ITERATOR = $fq7H3("iterator");
module.exports = function(it) {
    if (!$6exeg(it)) return $k0Syp(it, $5680757ad4007747$var$ITERATOR) || $k0Syp(it, "@@iterator") || $lmV2R[$aHxiP(it)];
};

});


parcelRegister("2l0vW", function(module, exports) {
"use strict";

var $aELZY = parcelRequire("aELZY");

var $l3LMJ = parcelRequire("l3LMJ");

var $k0Syp = parcelRequire("k0Syp");
module.exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $l3LMJ(iterator);
    try {
        innerResult = $k0Syp(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $aELZY(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $l3LMJ(innerResult);
    return value;
};

});


parcelRegister("a95no", function(module, exports) {
"use strict";

var $8hsAO = parcelRequire("8hsAO");
var $762eea4538129b77$var$$TypeError = TypeError;
module.exports = function(it, Prototype) {
    if ($8hsAO(Prototype, it)) return it;
    throw new $762eea4538129b77$var$$TypeError("Incorrect invocation");
};

});

parcelRegister("igsV9", function(module, exports) {
"use strict";

var $b5UsH = parcelRequire("b5UsH");

var $f518o = parcelRequire("f518o");

var $lEtn3 = parcelRequire("lEtn3");

var $iJNxK = parcelRequire("iJNxK");

var $6ocdr = parcelRequire("6ocdr");

var $cU9IX = parcelRequire("cU9IX");
var $d4c027b2f08881b7$var$push = $f518o([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $d4c027b2f08881b7$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $iJNxK($this);
        var self = $lEtn3(O);
        var length = $6ocdr(self);
        var boundFunction = $b5UsH(callbackfn, that);
        var index = 0;
        var create = specificCreate || $cU9IX;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $d4c027b2f08881b7$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $d4c027b2f08881b7$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
module.exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $d4c027b2f08881b7$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $d4c027b2f08881b7$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $d4c027b2f08881b7$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $d4c027b2f08881b7$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $d4c027b2f08881b7$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $d4c027b2f08881b7$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $d4c027b2f08881b7$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $d4c027b2f08881b7$var$createMethod(7)
};

});
parcelRegister("cU9IX", function(module, exports) {
"use strict";

var $9pV7u = parcelRequire("9pV7u");
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray, length) {
    return new ($9pV7u(originalArray))(length === 0 ? 0 : length);
};

});
parcelRegister("9pV7u", function(module, exports) {
"use strict";

var $5zZFa = parcelRequire("5zZFa");

var $iQLrm = parcelRequire("iQLrm");

var $1WYwK = parcelRequire("1WYwK");

var $fq7H3 = parcelRequire("fq7H3");
var $6db2c1a99ea8d015$var$SPECIES = $fq7H3("species");
var $6db2c1a99ea8d015$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray) {
    var C;
    if ($5zZFa(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($iQLrm(C) && (C === $6db2c1a99ea8d015$var$$Array || $5zZFa(C.prototype))) C = undefined;
        else if ($1WYwK(C)) {
            C = C[$6db2c1a99ea8d015$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $6db2c1a99ea8d015$var$$Array : C;
};

});
parcelRegister("5zZFa", function(module, exports) {
"use strict";

var $bTsfg = parcelRequire("bTsfg");
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
    return $bTsfg(argument) === "Array";
};

});

parcelRegister("iQLrm", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");

var $77TPA = parcelRequire("77TPA");

var $e6Rz5 = parcelRequire("e6Rz5");

var $aHxiP = parcelRequire("aHxiP");

var $5Pobw = parcelRequire("5Pobw");

var $fgsf9 = parcelRequire("fgsf9");
var $db91e1f52262defb$var$noop = function() {};
var $db91e1f52262defb$var$construct = $5Pobw("Reflect", "construct");
var $db91e1f52262defb$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $db91e1f52262defb$var$exec = $f518o($db91e1f52262defb$var$constructorRegExp.exec);
var $db91e1f52262defb$var$INCORRECT_TO_STRING = !$db91e1f52262defb$var$constructorRegExp.test($db91e1f52262defb$var$noop);
var $db91e1f52262defb$var$isConstructorModern = function isConstructor(argument) {
    if (!$e6Rz5(argument)) return false;
    try {
        $db91e1f52262defb$var$construct($db91e1f52262defb$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $db91e1f52262defb$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$e6Rz5(argument)) return false;
    switch($aHxiP(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $db91e1f52262defb$var$INCORRECT_TO_STRING || !!$db91e1f52262defb$var$exec($db91e1f52262defb$var$constructorRegExp, $fgsf9(argument));
    } catch (error) {
        return true;
    }
};
$db91e1f52262defb$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !$db91e1f52262defb$var$construct || $77TPA(function() {
    var called;
    return $db91e1f52262defb$var$isConstructorModern($db91e1f52262defb$var$isConstructorModern.call) || !$db91e1f52262defb$var$isConstructorModern(Object) || !$db91e1f52262defb$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $db91e1f52262defb$var$isConstructorLegacy : $db91e1f52262defb$var$isConstructorModern;

});
parcelRegister("fgsf9", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");

var $e6Rz5 = parcelRequire("e6Rz5");

var $bEwnT = parcelRequire("bEwnT");
var $b1ce423370fb74c6$var$functionToString = $f518o(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$e6Rz5($bEwnT.inspectSource)) $bEwnT.inspectSource = function(it) {
    return $b1ce423370fb74c6$var$functionToString(it);
};
module.exports = $bEwnT.inspectSource;

});






parcelRegister("f9bwY", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");

var $gklY2 = parcelRequire("gklY2");

var $iZE4H = parcelRequire("iZE4H");
var $b070a40e5a3e5284$require$getWeakData = $iZE4H.getWeakData;

var $a95no = parcelRequire("a95no");

var $l3LMJ = parcelRequire("l3LMJ");

var $6exeg = parcelRequire("6exeg");

var $1WYwK = parcelRequire("1WYwK");

var $jUk8Y = parcelRequire("jUk8Y");

var $igsV9 = parcelRequire("igsV9");

var $heVlo = parcelRequire("heVlo");

var $fmQ29 = parcelRequire("fmQ29");
var $b070a40e5a3e5284$var$setInternalState = $fmQ29.set;
var $b070a40e5a3e5284$var$internalStateGetterFor = $fmQ29.getterFor;
var $b070a40e5a3e5284$var$find = $igsV9.find;
var $b070a40e5a3e5284$var$findIndex = $igsV9.findIndex;
var $b070a40e5a3e5284$var$splice = $f518o([].splice);
var $b070a40e5a3e5284$var$id = 0;
// fallback for uncaught frozen keys
var $b070a40e5a3e5284$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $b070a40e5a3e5284$var$UncaughtFrozenStore());
};
var $b070a40e5a3e5284$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $b070a40e5a3e5284$var$findUncaughtFrozen = function(store, key) {
    return $b070a40e5a3e5284$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$b070a40e5a3e5284$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $b070a40e5a3e5284$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$b070a40e5a3e5284$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $b070a40e5a3e5284$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = $b070a40e5a3e5284$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $b070a40e5a3e5284$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
module.exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $a95no(that, Prototype);
            $b070a40e5a3e5284$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $b070a40e5a3e5284$var$id++,
                frozen: null
            });
            if (!$6exeg(iterable)) $jUk8Y(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $b070a40e5a3e5284$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $b070a40e5a3e5284$require$getWeakData($l3LMJ(key), true);
            if (data === true) $b070a40e5a3e5284$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $gklY2(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            "delete": function(key) {
                var state = getInternalState(this);
                if (!$1WYwK(key)) return false;
                var data = $b070a40e5a3e5284$require$getWeakData(key);
                if (data === true) return $b070a40e5a3e5284$var$uncaughtFrozenStore(state)["delete"](key);
                return data && $heVlo(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$1WYwK(key)) return false;
                var data = $b070a40e5a3e5284$require$getWeakData(key);
                if (data === true) return $b070a40e5a3e5284$var$uncaughtFrozenStore(state).has(key);
                return data && $heVlo(data, state.id);
            }
        });
        $gklY2(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($1WYwK(key)) {
                    var data = $b070a40e5a3e5284$require$getWeakData(key);
                    if (data === true) return $b070a40e5a3e5284$var$uncaughtFrozenStore(state).get(key);
                    if (data) return data[state.id];
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};

});




parcelRegister("jXhxH", function(module, exports) {
"use strict";
parcelRequire("5xrGR");

var $gmmG5 = parcelRequire("gmmG5");

var $9l3PP = parcelRequire("9l3PP");

var $dheYH = parcelRequire("dheYH");

var $lmV2R = parcelRequire("lmV2R");
for(var $e871229cc66a3590$var$COLLECTION_NAME in $gmmG5){
    $dheYH($9l3PP[$e871229cc66a3590$var$COLLECTION_NAME], $e871229cc66a3590$var$COLLECTION_NAME);
    $lmV2R[$e871229cc66a3590$var$COLLECTION_NAME] = $lmV2R.Array;
}

});
parcelRegister("gmmG5", function(module, exports) {
"use strict";
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

});




parcelRegister("4i3Tl", function(module, exports) {

module.exports = (parcelRequire("iizpp"));

});
parcelRegister("iizpp", function(module, exports) {
"use strict";

var $gwRSD = parcelRequire("gwRSD");
module.exports = $gwRSD;

});
parcelRegister("gwRSD", function(module, exports) {
"use strict";
parcelRequire("dbXU8");

var $ly30u = parcelRequire("ly30u");
var $c0896dfc3ce18d01$var$Object = $ly30u.Object;
var $c0896dfc3ce18d01$var$defineProperty = module.exports = function defineProperty(it, key, desc) {
    return $c0896dfc3ce18d01$var$Object.defineProperty(it, key, desc);
};
if ($c0896dfc3ce18d01$var$Object.defineProperty.sham) $c0896dfc3ce18d01$var$defineProperty.sham = true;

});
parcelRegister("dbXU8", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $jeZ4p = parcelRequire("jeZ4p");

var $diq7r = parcelRequire("diq7r");
var $99aac538dbdc1bf0$require$defineProperty = $diq7r.f;
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe
$ggcsv({
    target: "Object",
    stat: true,
    forced: Object.defineProperty !== $99aac538dbdc1bf0$require$defineProperty,
    sham: !$jeZ4p
}, {
    defineProperty: $99aac538dbdc1bf0$require$defineProperty
});

});




parcelRegister("dzKYE", function(module, exports) {

module.exports = (parcelRequire("jDHFu"));

});
parcelRegister("jDHFu", function(module, exports) {
"use strict";

var $ji3LA = parcelRequire("ji3LA");
module.exports = $ji3LA;

});
parcelRegister("ji3LA", function(module, exports) {
"use strict";
parcelRequire("hFHob");

var $ly30u = parcelRequire("ly30u");
var $e0b29eb8ac6b80f9$var$Object = $ly30u.Object;
var $e0b29eb8ac6b80f9$var$getOwnPropertyDescriptor = module.exports = function getOwnPropertyDescriptor(it, key) {
    return $e0b29eb8ac6b80f9$var$Object.getOwnPropertyDescriptor(it, key);
};
if ($e0b29eb8ac6b80f9$var$Object.getOwnPropertyDescriptor.sham) $e0b29eb8ac6b80f9$var$getOwnPropertyDescriptor.sham = true;

});
parcelRegister("hFHob", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $77TPA = parcelRequire("77TPA");

var $bYkAs = parcelRequire("bYkAs");

var $fTFId = parcelRequire("fTFId");
var $cdd7ec27ab46eac9$require$nativeGetOwnPropertyDescriptor = $fTFId.f;

var $jeZ4p = parcelRequire("jeZ4p");
var $cdd7ec27ab46eac9$var$FORCED = !$jeZ4p || $77TPA(function() {
    $cdd7ec27ab46eac9$require$nativeGetOwnPropertyDescriptor(1);
});
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$ggcsv({
    target: "Object",
    stat: true,
    forced: $cdd7ec27ab46eac9$var$FORCED,
    sham: !$jeZ4p
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
        return $cdd7ec27ab46eac9$require$nativeGetOwnPropertyDescriptor($bYkAs(it), key);
    }
});

});




parcelRegister("iHLHC", function(module, exports) {
function $d9e13eddec1cce9d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $d9e13eddec1cce9d$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iH0WI", function(module, exports) {

module.exports = (parcelRequire("5XWAD"));

});
parcelRegister("5XWAD", function(module, exports) {
"use strict";

var $iplN3 = parcelRequire("iplN3");
parcelRequire("jXhxH");
module.exports = $iplN3;

});
parcelRegister("iplN3", function(module, exports) {
"use strict";
parcelRequire("l3Lsr");
parcelRequire("5xrGR");
parcelRequire("iYyco");
parcelRequire("hwEmk");
parcelRequire("ettPZ");
parcelRequire("hakp0");
parcelRequire("d5cWg");
parcelRequire("wzhSp");
parcelRequire("ja2zQ");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Promise;

});
parcelRegister("l3Lsr", function(module, exports) {
"use strict";
parcelRequire("6wipU");

});
parcelRegister("6wipU", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $8hsAO = parcelRequire("8hsAO");

var $2pQL6 = parcelRequire("2pQL6");

var $6e7Qv = parcelRequire("6e7Qv");

var $fNJMH = parcelRequire("fNJMH");

var $fhVPP = parcelRequire("fhVPP");

var $k4kcW = parcelRequire("k4kcW");

var $8c6fn = parcelRequire("8c6fn");

var $2UmSX = parcelRequire("2UmSX");

var $hqQHV = parcelRequire("hqQHV");

var $jUk8Y = parcelRequire("jUk8Y");

var $d1QGz = parcelRequire("d1QGz");

var $fq7H3 = parcelRequire("fq7H3");
var $4bf40474de7b2e05$var$TO_STRING_TAG = $fq7H3("toStringTag");
var $4bf40474de7b2e05$var$$Error = Error;
var $4bf40474de7b2e05$var$push = [].push;
var $4bf40474de7b2e05$var$$AggregateError = function AggregateError(errors, message /* , options */ ) {
    var isInstance = $8hsAO($4bf40474de7b2e05$var$AggregateErrorPrototype, this);
    var that;
    if ($6e7Qv) that = $6e7Qv(new $4bf40474de7b2e05$var$$Error(), isInstance ? $2pQL6(this) : $4bf40474de7b2e05$var$AggregateErrorPrototype);
    else {
        that = isInstance ? this : $fhVPP($4bf40474de7b2e05$var$AggregateErrorPrototype);
        $k4kcW(that, $4bf40474de7b2e05$var$TO_STRING_TAG, "Error");
    }
    if (message !== undefined) $k4kcW(that, "message", $d1QGz(message));
    $hqQHV(that, $4bf40474de7b2e05$var$$AggregateError, that.stack, 1);
    if (arguments.length > 2) $2UmSX(that, arguments[2]);
    var errorsArray = [];
    $jUk8Y(errors, $4bf40474de7b2e05$var$push, {
        that: errorsArray
    });
    $k4kcW(that, "errors", errorsArray);
    return that;
};
if ($6e7Qv) $6e7Qv($4bf40474de7b2e05$var$$AggregateError, $4bf40474de7b2e05$var$$Error);
else $fNJMH($4bf40474de7b2e05$var$$AggregateError, $4bf40474de7b2e05$var$$Error, {
    name: true
});
var $4bf40474de7b2e05$var$AggregateErrorPrototype = $4bf40474de7b2e05$var$$AggregateError.prototype = $fhVPP($4bf40474de7b2e05$var$$Error.prototype, {
    constructor: $8c6fn(1, $4bf40474de7b2e05$var$$AggregateError),
    message: $8c6fn(1, ""),
    name: $8c6fn(1, "AggregateError")
});
// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$ggcsv({
    global: true,
    constructor: true,
    arity: 2
}, {
    AggregateError: $4bf40474de7b2e05$var$$AggregateError
});

});
parcelRegister("fNJMH", function(module, exports) {
"use strict";

var $heVlo = parcelRequire("heVlo");

var $eNGig = parcelRequire("eNGig");

var $fTFId = parcelRequire("fTFId");

var $diq7r = parcelRequire("diq7r");
module.exports = function(target, source, exceptions) {
    var keys = $eNGig(source);
    var defineProperty = $diq7r.f;
    var getOwnPropertyDescriptor = $fTFId.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$heVlo(target, key) && !(exceptions && $heVlo(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

});
parcelRegister("eNGig", function(module, exports) {
"use strict";

var $5Pobw = parcelRequire("5Pobw");

var $f518o = parcelRequire("f518o");

var $9hUhV = parcelRequire("9hUhV");

var $4BK7o = parcelRequire("4BK7o");

var $l3LMJ = parcelRequire("l3LMJ");
var $ac6672e9a4de8594$var$concat = $f518o([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = $5Pobw("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $9hUhV.f($l3LMJ(it));
    var getOwnPropertySymbols = $4BK7o.f;
    return getOwnPropertySymbols ? $ac6672e9a4de8594$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};

});
parcelRegister("4BK7o", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $35ae643adc7aa6b6$export$2d1720544b23b823; }, function (v) { return $35ae643adc7aa6b6$export$2d1720544b23b823 = v; });
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $35ae643adc7aa6b6$export$2d1720544b23b823;
"use strict";
$35ae643adc7aa6b6$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});



parcelRegister("2UmSX", function(module, exports) {
"use strict";

var $1WYwK = parcelRequire("1WYwK");

var $k4kcW = parcelRequire("k4kcW");
// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function(O, options) {
    if ($1WYwK(options) && "cause" in options) $k4kcW(O, "cause", options.cause);
};

});

parcelRegister("hqQHV", function(module, exports) {
"use strict";

var $k4kcW = parcelRequire("k4kcW");

var $6Gy1W = parcelRequire("6Gy1W");

var $8Dt96 = parcelRequire("8Dt96");
// non-standard V8
var $cb0dbff8b0356666$var$captureStackTrace = Error.captureStackTrace;
module.exports = function(error, C, stack, dropEntries) {
    if ($8Dt96) {
        if ($cb0dbff8b0356666$var$captureStackTrace) $cb0dbff8b0356666$var$captureStackTrace(error, C);
        else $k4kcW(error, "stack", $6Gy1W(stack, dropEntries));
    }
};

});
parcelRegister("6Gy1W", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");
var $4de1100d8939e62c$var$$Error = Error;
var $4de1100d8939e62c$var$replace = $f518o("".replace);
var $4de1100d8939e62c$var$TEST = function(arg) {
    return String(new $4de1100d8939e62c$var$$Error(arg).stack);
}("zxcasd");
// eslint-disable-next-line redos/no-vulnerable -- safe
var $4de1100d8939e62c$var$V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var $4de1100d8939e62c$var$IS_V8_OR_CHAKRA_STACK = $4de1100d8939e62c$var$V8_OR_CHAKRA_STACK_ENTRY.test($4de1100d8939e62c$var$TEST);
module.exports = function(stack, dropEntries) {
    if ($4de1100d8939e62c$var$IS_V8_OR_CHAKRA_STACK && typeof stack == "string" && !$4de1100d8939e62c$var$$Error.prepareStackTrace) while(dropEntries--)stack = $4de1100d8939e62c$var$replace(stack, $4de1100d8939e62c$var$V8_OR_CHAKRA_STACK_ENTRY, "");
    return stack;
};

});

parcelRegister("8Dt96", function(module, exports) {
"use strict";

var $77TPA = parcelRequire("77TPA");

var $8c6fn = parcelRequire("8c6fn");
module.exports = !$77TPA(function() {
    var error = new Error("a");
    if (!("stack" in error)) return true;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(error, "stack", $8c6fn(1, 7));
    return error.stack !== 7;
});

});


parcelRegister("d1QGz", function(module, exports) {
"use strict";

var $l2Ut5 = parcelRequire("l2Ut5");
module.exports = function(argument, $default) {
    return argument === undefined ? arguments.length < 2 ? "" : $default : $l2Ut5(argument);
};

});
parcelRegister("l2Ut5", function(module, exports) {
"use strict";

var $aHxiP = parcelRequire("aHxiP");
var $f52596499fa10f8b$var$$String = String;
module.exports = function(argument) {
    if ($aHxiP(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return $f52596499fa10f8b$var$$String(argument);
};

});




parcelRegister("hwEmk", function(module, exports) {
"use strict";
parcelRequire("cDoup");
parcelRequire("fRDGg");
parcelRequire("bhLYs");
parcelRequire("fm27z");
parcelRequire("iGB6b");
parcelRequire("doKxr");

});
parcelRegister("cDoup", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $7phdw = parcelRequire("7phdw");

var $1V6sC = parcelRequire("1V6sC");

var $9l3PP = parcelRequire("9l3PP");

var $aELZY = parcelRequire("aELZY");

var $kY5Tb = parcelRequire("kY5Tb");

var $6e7Qv = parcelRequire("6e7Qv");

var $dheYH = parcelRequire("dheYH");

var $13iqA = parcelRequire("13iqA");

var $8GsPx = parcelRequire("8GsPx");

var $e6Rz5 = parcelRequire("e6Rz5");

var $1WYwK = parcelRequire("1WYwK");

var $a95no = parcelRequire("a95no");

var $2FOd2 = parcelRequire("2FOd2");

var $htH5s = parcelRequire("htH5s");
var $932c1fa8a18a7d3b$require$task = $htH5s.set;

var $e02YY = parcelRequire("e02YY");

var $eCofm = parcelRequire("eCofm");

var $7aQOM = parcelRequire("7aQOM");

var $dn6WB = parcelRequire("dn6WB");

var $fmQ29 = parcelRequire("fmQ29");

var $lBL1o = parcelRequire("lBL1o");

var $3kjIC = parcelRequire("3kjIC");

var $1HEKk = parcelRequire("1HEKk");
var $932c1fa8a18a7d3b$var$PROMISE = "Promise";
var $932c1fa8a18a7d3b$var$FORCED_PROMISE_CONSTRUCTOR = $3kjIC.CONSTRUCTOR;
var $932c1fa8a18a7d3b$var$NATIVE_PROMISE_REJECTION_EVENT = $3kjIC.REJECTION_EVENT;
var $932c1fa8a18a7d3b$var$NATIVE_PROMISE_SUBCLASSING = $3kjIC.SUBCLASSING;
var $932c1fa8a18a7d3b$var$getInternalPromiseState = $fmQ29.getterFor($932c1fa8a18a7d3b$var$PROMISE);
var $932c1fa8a18a7d3b$var$setInternalState = $fmQ29.set;
var $932c1fa8a18a7d3b$var$NativePromisePrototype = $lBL1o && $lBL1o.prototype;
var $932c1fa8a18a7d3b$var$PromiseConstructor = $lBL1o;
var $932c1fa8a18a7d3b$var$PromisePrototype = $932c1fa8a18a7d3b$var$NativePromisePrototype;
var $932c1fa8a18a7d3b$var$TypeError = $9l3PP.TypeError;
var $932c1fa8a18a7d3b$var$document = $9l3PP.document;
var $932c1fa8a18a7d3b$var$process = $9l3PP.process;
var $932c1fa8a18a7d3b$var$newPromiseCapability = $1HEKk.f;
var $932c1fa8a18a7d3b$var$newGenericPromiseCapability = $932c1fa8a18a7d3b$var$newPromiseCapability;
var $932c1fa8a18a7d3b$var$DISPATCH_EVENT = !!($932c1fa8a18a7d3b$var$document && $932c1fa8a18a7d3b$var$document.createEvent && $9l3PP.dispatchEvent);
var $932c1fa8a18a7d3b$var$UNHANDLED_REJECTION = "unhandledrejection";
var $932c1fa8a18a7d3b$var$REJECTION_HANDLED = "rejectionhandled";
var $932c1fa8a18a7d3b$var$PENDING = 0;
var $932c1fa8a18a7d3b$var$FULFILLED = 1;
var $932c1fa8a18a7d3b$var$REJECTED = 2;
var $932c1fa8a18a7d3b$var$HANDLED = 1;
var $932c1fa8a18a7d3b$var$UNHANDLED = 2;
var $932c1fa8a18a7d3b$var$Internal, $932c1fa8a18a7d3b$var$OwnPromiseCapability, $932c1fa8a18a7d3b$var$PromiseWrapper, $932c1fa8a18a7d3b$var$nativeThen;
// helpers
var $932c1fa8a18a7d3b$var$isThenable = function(it) {
    var then;
    return $1WYwK(it) && $e6Rz5(then = it.then) ? then : false;
};
var $932c1fa8a18a7d3b$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state === $932c1fa8a18a7d3b$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $932c1fa8a18a7d3b$var$UNHANDLED) $932c1fa8a18a7d3b$var$onHandleUnhandled(state);
                state.rejection = $932c1fa8a18a7d3b$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject(new $932c1fa8a18a7d3b$var$TypeError("Promise-chain cycle"));
            else if (then = $932c1fa8a18a7d3b$var$isThenable(result)) $aELZY(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $932c1fa8a18a7d3b$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $e02YY(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$932c1fa8a18a7d3b$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $932c1fa8a18a7d3b$var$onUnhandled(state);
    });
};
var $932c1fa8a18a7d3b$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($932c1fa8a18a7d3b$var$DISPATCH_EVENT) {
        event = $932c1fa8a18a7d3b$var$document.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $9l3PP.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$932c1fa8a18a7d3b$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $9l3PP["on" + name])) handler(event);
    else if (name === $932c1fa8a18a7d3b$var$UNHANDLED_REJECTION) $eCofm("Unhandled promise rejection", reason);
};
var $932c1fa8a18a7d3b$var$onUnhandled = function(state) {
    $aELZY($932c1fa8a18a7d3b$require$task, $9l3PP, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $932c1fa8a18a7d3b$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $7aQOM(function() {
                if ($1V6sC) $932c1fa8a18a7d3b$var$process.emit("unhandledRejection", value, promise);
                else $932c1fa8a18a7d3b$var$dispatchEvent($932c1fa8a18a7d3b$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $1V6sC || $932c1fa8a18a7d3b$var$isUnhandled(state) ? $932c1fa8a18a7d3b$var$UNHANDLED : $932c1fa8a18a7d3b$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $932c1fa8a18a7d3b$var$isUnhandled = function(state) {
    return state.rejection !== $932c1fa8a18a7d3b$var$HANDLED && !state.parent;
};
var $932c1fa8a18a7d3b$var$onHandleUnhandled = function(state) {
    $aELZY($932c1fa8a18a7d3b$require$task, $9l3PP, function() {
        var promise = state.facade;
        if ($1V6sC) $932c1fa8a18a7d3b$var$process.emit("rejectionHandled", promise);
        else $932c1fa8a18a7d3b$var$dispatchEvent($932c1fa8a18a7d3b$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $932c1fa8a18a7d3b$var$bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $932c1fa8a18a7d3b$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $932c1fa8a18a7d3b$var$REJECTED;
    $932c1fa8a18a7d3b$var$notify(state, true);
};
var $932c1fa8a18a7d3b$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw new $932c1fa8a18a7d3b$var$TypeError("Promise can't be resolved itself");
        var then = $932c1fa8a18a7d3b$var$isThenable(value);
        if (then) $e02YY(function() {
            var wrapper = {
                done: false
            };
            try {
                $aELZY(then, value, $932c1fa8a18a7d3b$var$bind($932c1fa8a18a7d3b$var$internalResolve, wrapper, state), $932c1fa8a18a7d3b$var$bind($932c1fa8a18a7d3b$var$internalReject, wrapper, state));
            } catch (error) {
                $932c1fa8a18a7d3b$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $932c1fa8a18a7d3b$var$FULFILLED;
            $932c1fa8a18a7d3b$var$notify(state, false);
        }
    } catch (error) {
        $932c1fa8a18a7d3b$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($932c1fa8a18a7d3b$var$FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    $932c1fa8a18a7d3b$var$PromiseConstructor = function Promise(executor) {
        $a95no(this, $932c1fa8a18a7d3b$var$PromisePrototype);
        $8GsPx(executor);
        $aELZY($932c1fa8a18a7d3b$var$Internal, this);
        var state = $932c1fa8a18a7d3b$var$getInternalPromiseState(this);
        try {
            executor($932c1fa8a18a7d3b$var$bind($932c1fa8a18a7d3b$var$internalResolve, state), $932c1fa8a18a7d3b$var$bind($932c1fa8a18a7d3b$var$internalReject, state));
        } catch (error) {
            $932c1fa8a18a7d3b$var$internalReject(state, error);
        }
    };
    $932c1fa8a18a7d3b$var$PromisePrototype = $932c1fa8a18a7d3b$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $932c1fa8a18a7d3b$var$Internal = function Promise(executor) {
        $932c1fa8a18a7d3b$var$setInternalState(this, {
            type: $932c1fa8a18a7d3b$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $dn6WB(),
            rejection: false,
            state: $932c1fa8a18a7d3b$var$PENDING,
            value: null
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $932c1fa8a18a7d3b$var$Internal.prototype = $kY5Tb($932c1fa8a18a7d3b$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $932c1fa8a18a7d3b$var$getInternalPromiseState(this);
        var reaction = $932c1fa8a18a7d3b$var$newPromiseCapability($2FOd2(this, $932c1fa8a18a7d3b$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $e6Rz5(onFulfilled) ? onFulfilled : true;
        reaction.fail = $e6Rz5(onRejected) && onRejected;
        reaction.domain = $1V6sC ? $932c1fa8a18a7d3b$var$process.domain : undefined;
        if (state.state === $932c1fa8a18a7d3b$var$PENDING) state.reactions.add(reaction);
        else $e02YY(function() {
            $932c1fa8a18a7d3b$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $932c1fa8a18a7d3b$var$OwnPromiseCapability = function() {
        var promise = new $932c1fa8a18a7d3b$var$Internal();
        var state = $932c1fa8a18a7d3b$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $932c1fa8a18a7d3b$var$bind($932c1fa8a18a7d3b$var$internalResolve, state);
        this.reject = $932c1fa8a18a7d3b$var$bind($932c1fa8a18a7d3b$var$internalReject, state);
    };
    $1HEKk.f = $932c1fa8a18a7d3b$var$newPromiseCapability = function(C) {
        return C === $932c1fa8a18a7d3b$var$PromiseConstructor || C === $932c1fa8a18a7d3b$var$PromiseWrapper ? new $932c1fa8a18a7d3b$var$OwnPromiseCapability(C) : $932c1fa8a18a7d3b$var$newGenericPromiseCapability(C);
    };
    if (!$7phdw && $e6Rz5($lBL1o) && $932c1fa8a18a7d3b$var$NativePromisePrototype !== Object.prototype) {
        $932c1fa8a18a7d3b$var$nativeThen = $932c1fa8a18a7d3b$var$NativePromisePrototype.then;
        if (!$932c1fa8a18a7d3b$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $kY5Tb($932c1fa8a18a7d3b$var$NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $932c1fa8a18a7d3b$var$PromiseConstructor(function(resolve, reject) {
                $aELZY($932c1fa8a18a7d3b$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $932c1fa8a18a7d3b$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($6e7Qv) $6e7Qv($932c1fa8a18a7d3b$var$NativePromisePrototype, $932c1fa8a18a7d3b$var$PromisePrototype);
    }
}
$ggcsv({
    global: true,
    constructor: true,
    wrap: true,
    forced: $932c1fa8a18a7d3b$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: $932c1fa8a18a7d3b$var$PromiseConstructor
});
$dheYH($932c1fa8a18a7d3b$var$PromiseConstructor, $932c1fa8a18a7d3b$var$PROMISE, false, true);
$13iqA($932c1fa8a18a7d3b$var$PROMISE);

});
parcelRegister("1V6sC", function(module, exports) {
"use strict";

var $glx3T = parcelRequire("glx3T");
module.exports = $glx3T === "NODE";

});
parcelRegister("glx3T", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");

var $jVEg8 = parcelRequire("jVEg8");

var $bTsfg = parcelRequire("bTsfg");
var $be6840dfc257ddfd$var$userAgentStartsWith = function(string) {
    return $jVEg8.slice(0, string.length) === string;
};
module.exports = function() {
    if ($be6840dfc257ddfd$var$userAgentStartsWith("Bun/")) return "BUN";
    if ($be6840dfc257ddfd$var$userAgentStartsWith("Cloudflare-Workers")) return "CLOUDFLARE";
    if ($be6840dfc257ddfd$var$userAgentStartsWith("Deno/")) return "DENO";
    if ($be6840dfc257ddfd$var$userAgentStartsWith("Node.js/")) return "NODE";
    if ($9l3PP.Bun && typeof Bun.version == "string") return "BUN";
    if ($9l3PP.Deno && typeof Deno.version == "object") return "DENO";
    if ($bTsfg($9l3PP.process) === "process") return "NODE";
    if ($9l3PP.window && $9l3PP.document) return "BROWSER";
    return "REST";
}();

});


parcelRegister("13iqA", function(module, exports) {
"use strict";

var $5Pobw = parcelRequire("5Pobw");

var $7kUwJ = parcelRequire("7kUwJ");

var $fq7H3 = parcelRequire("fq7H3");

var $jeZ4p = parcelRequire("jeZ4p");
var $0c445d9d3ba4becb$var$SPECIES = $fq7H3("species");
module.exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $5Pobw(CONSTRUCTOR_NAME);
    if ($jeZ4p && Constructor && !Constructor[$0c445d9d3ba4becb$var$SPECIES]) $7kUwJ(Constructor, $0c445d9d3ba4becb$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});
parcelRegister("7kUwJ", function(module, exports) {
"use strict";

var $diq7r = parcelRequire("diq7r");
module.exports = function(target, name, descriptor) {
    return $diq7r.f(target, name, descriptor);
};

});


parcelRegister("2FOd2", function(module, exports) {
"use strict";

var $l3LMJ = parcelRequire("l3LMJ");

var $dGyrk = parcelRequire("dGyrk");

var $6exeg = parcelRequire("6exeg");

var $fq7H3 = parcelRequire("fq7H3");
var $1f265ba52a34b575$var$SPECIES = $fq7H3("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function(O, defaultConstructor) {
    var C = $l3LMJ(O).constructor;
    var S;
    return C === undefined || $6exeg(S = $l3LMJ(C)[$1f265ba52a34b575$var$SPECIES]) ? defaultConstructor : $dGyrk(S);
};

});
parcelRegister("dGyrk", function(module, exports) {
"use strict";

var $iQLrm = parcelRequire("iQLrm");

var $k9gzN = parcelRequire("k9gzN");
var $9f69e99df50e84bd$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
module.exports = function(argument) {
    if ($iQLrm(argument)) return argument;
    throw new $9f69e99df50e84bd$var$$TypeError($k9gzN(argument) + " is not a constructor");
};

});


parcelRegister("htH5s", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");

var $2JOsI = parcelRequire("2JOsI");

var $b5UsH = parcelRequire("b5UsH");

var $e6Rz5 = parcelRequire("e6Rz5");

var $heVlo = parcelRequire("heVlo");

var $77TPA = parcelRequire("77TPA");

var $f0Cl9 = parcelRequire("f0Cl9");

var $hF40G = parcelRequire("hF40G");

var $kHYxY = parcelRequire("kHYxY");

var $10H6z = parcelRequire("10H6z");

var $2rR7B = parcelRequire("2rR7B");

var $1V6sC = parcelRequire("1V6sC");
var $cb969145f2946e64$var$set = $9l3PP.setImmediate;
var $cb969145f2946e64$var$clear = $9l3PP.clearImmediate;
var $cb969145f2946e64$var$process = $9l3PP.process;
var $cb969145f2946e64$var$Dispatch = $9l3PP.Dispatch;
var $cb969145f2946e64$var$Function = $9l3PP.Function;
var $cb969145f2946e64$var$MessageChannel = $9l3PP.MessageChannel;
var $cb969145f2946e64$var$String = $9l3PP.String;
var $cb969145f2946e64$var$counter = 0;
var $cb969145f2946e64$var$queue = {};
var $cb969145f2946e64$var$ONREADYSTATECHANGE = "onreadystatechange";
var $cb969145f2946e64$var$$location, $cb969145f2946e64$var$defer, $cb969145f2946e64$var$channel, $cb969145f2946e64$var$port;
$77TPA(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $cb969145f2946e64$var$$location = $9l3PP.location;
});
var $cb969145f2946e64$var$run = function(id) {
    if ($heVlo($cb969145f2946e64$var$queue, id)) {
        var fn = $cb969145f2946e64$var$queue[id];
        delete $cb969145f2946e64$var$queue[id];
        fn();
    }
};
var $cb969145f2946e64$var$runner = function(id) {
    return function() {
        $cb969145f2946e64$var$run(id);
    };
};
var $cb969145f2946e64$var$eventListener = function(event) {
    $cb969145f2946e64$var$run(event.data);
};
var $cb969145f2946e64$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $9l3PP.postMessage($cb969145f2946e64$var$String(id), $cb969145f2946e64$var$$location.protocol + "//" + $cb969145f2946e64$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$cb969145f2946e64$var$set || !$cb969145f2946e64$var$clear) {
    $cb969145f2946e64$var$set = function setImmediate(handler) {
        $10H6z(arguments.length, 1);
        var fn = $e6Rz5(handler) ? handler : $cb969145f2946e64$var$Function(handler);
        var args = $hF40G(arguments, 1);
        $cb969145f2946e64$var$queue[++$cb969145f2946e64$var$counter] = function() {
            $2JOsI(fn, undefined, args);
        };
        $cb969145f2946e64$var$defer($cb969145f2946e64$var$counter);
        return $cb969145f2946e64$var$counter;
    };
    $cb969145f2946e64$var$clear = function clearImmediate(id) {
        delete $cb969145f2946e64$var$queue[id];
    };
    // Node.js 0.8-
    if ($1V6sC) $cb969145f2946e64$var$defer = function(id) {
        $cb969145f2946e64$var$process.nextTick($cb969145f2946e64$var$runner(id));
    };
    else if ($cb969145f2946e64$var$Dispatch && $cb969145f2946e64$var$Dispatch.now) $cb969145f2946e64$var$defer = function(id) {
        $cb969145f2946e64$var$Dispatch.now($cb969145f2946e64$var$runner(id));
    };
    else if ($cb969145f2946e64$var$MessageChannel && !$2rR7B) {
        $cb969145f2946e64$var$channel = new $cb969145f2946e64$var$MessageChannel();
        $cb969145f2946e64$var$port = $cb969145f2946e64$var$channel.port2;
        $cb969145f2946e64$var$channel.port1.onmessage = $cb969145f2946e64$var$eventListener;
        $cb969145f2946e64$var$defer = $b5UsH($cb969145f2946e64$var$port.postMessage, $cb969145f2946e64$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($9l3PP.addEventListener && $e6Rz5($9l3PP.postMessage) && !$9l3PP.importScripts && $cb969145f2946e64$var$$location && $cb969145f2946e64$var$$location.protocol !== "file:" && !$77TPA($cb969145f2946e64$var$globalPostMessageDefer)) {
        $cb969145f2946e64$var$defer = $cb969145f2946e64$var$globalPostMessageDefer;
        $9l3PP.addEventListener("message", $cb969145f2946e64$var$eventListener, false);
    // IE8-
    } else if ($cb969145f2946e64$var$ONREADYSTATECHANGE in $kHYxY("script")) $cb969145f2946e64$var$defer = function(id) {
        $f0Cl9.appendChild($kHYxY("script"))[$cb969145f2946e64$var$ONREADYSTATECHANGE] = function() {
            $f0Cl9.removeChild(this);
            $cb969145f2946e64$var$run(id);
        };
    };
    else $cb969145f2946e64$var$defer = function(id) {
        setTimeout($cb969145f2946e64$var$runner(id), 0);
    };
}
module.exports = {
    set: $cb969145f2946e64$var$set,
    clear: $cb969145f2946e64$var$clear
};

});
parcelRegister("10H6z", function(module, exports) {
"use strict";
var $0bc73a46a382b3b0$var$$TypeError = TypeError;
module.exports = function(passed, required) {
    if (passed < required) throw new $0bc73a46a382b3b0$var$$TypeError("Not enough arguments");
    return passed;
};

});

parcelRegister("2rR7B", function(module, exports) {
"use strict";

var $jVEg8 = parcelRequire("jVEg8");
// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($jVEg8);

});


parcelRegister("e02YY", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");

var $d92Pc = parcelRequire("d92Pc");

var $b5UsH = parcelRequire("b5UsH");

var $htH5s = parcelRequire("htH5s");
var $a31361095d52e233$require$macrotask = $htH5s.set;

var $dn6WB = parcelRequire("dn6WB");

var $2rR7B = parcelRequire("2rR7B");

var $j6fgo = parcelRequire("j6fgo");

var $lVxFm = parcelRequire("lVxFm");

var $1V6sC = parcelRequire("1V6sC");
var $a31361095d52e233$var$MutationObserver = $9l3PP.MutationObserver || $9l3PP.WebKitMutationObserver;
var $a31361095d52e233$var$document = $9l3PP.document;
var $a31361095d52e233$var$process = $9l3PP.process;
var $a31361095d52e233$var$Promise = $9l3PP.Promise;
var $a31361095d52e233$var$microtask = $d92Pc("queueMicrotask");
var $a31361095d52e233$var$notify, $a31361095d52e233$var$toggle, $a31361095d52e233$var$node, $a31361095d52e233$var$promise, $a31361095d52e233$var$then;
// modern engines have queueMicrotask method
if (!$a31361095d52e233$var$microtask) {
    var $a31361095d52e233$var$queue = new $dn6WB();
    var $a31361095d52e233$var$flush = function() {
        var parent, fn;
        if ($1V6sC && (parent = $a31361095d52e233$var$process.domain)) parent.exit();
        while(fn = $a31361095d52e233$var$queue.get())try {
            fn();
        } catch (error) {
            if ($a31361095d52e233$var$queue.head) $a31361095d52e233$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$2rR7B && !$1V6sC && !$lVxFm && $a31361095d52e233$var$MutationObserver && $a31361095d52e233$var$document) {
        $a31361095d52e233$var$toggle = true;
        $a31361095d52e233$var$node = $a31361095d52e233$var$document.createTextNode("");
        new $a31361095d52e233$var$MutationObserver($a31361095d52e233$var$flush).observe($a31361095d52e233$var$node, {
            characterData: true
        });
        $a31361095d52e233$var$notify = function() {
            $a31361095d52e233$var$node.data = $a31361095d52e233$var$toggle = !$a31361095d52e233$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$j6fgo && $a31361095d52e233$var$Promise && $a31361095d52e233$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $a31361095d52e233$var$promise = $a31361095d52e233$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $a31361095d52e233$var$promise.constructor = $a31361095d52e233$var$Promise;
        $a31361095d52e233$var$then = $b5UsH($a31361095d52e233$var$promise.then, $a31361095d52e233$var$promise);
        $a31361095d52e233$var$notify = function() {
            $a31361095d52e233$var$then($a31361095d52e233$var$flush);
        };
    // Node.js without promises
    } else if ($1V6sC) $a31361095d52e233$var$notify = function() {
        $a31361095d52e233$var$process.nextTick($a31361095d52e233$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $a31361095d52e233$require$macrotask = $b5UsH($a31361095d52e233$require$macrotask, $9l3PP);
        $a31361095d52e233$var$notify = function() {
            $a31361095d52e233$require$macrotask($a31361095d52e233$var$flush);
        };
    }
    $a31361095d52e233$var$microtask = function(fn) {
        if (!$a31361095d52e233$var$queue.head) $a31361095d52e233$var$notify();
        $a31361095d52e233$var$queue.add(fn);
    };
}
module.exports = $a31361095d52e233$var$microtask;

});
parcelRegister("d92Pc", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");

var $jeZ4p = parcelRequire("jeZ4p");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $991e4e97a0da8ac3$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
module.exports = function(name) {
    if (!$jeZ4p) return $9l3PP[name];
    var descriptor = $991e4e97a0da8ac3$var$getOwnPropertyDescriptor($9l3PP, name);
    return descriptor && descriptor.value;
};

});

parcelRegister("dn6WB", function(module, exports) {
"use strict";
var $9bc2cf5012c3f636$var$Queue = function() {
    this.head = null;
    this.tail = null;
};
$9bc2cf5012c3f636$var$Queue.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
module.exports = $9bc2cf5012c3f636$var$Queue;

});

parcelRegister("j6fgo", function(module, exports) {
"use strict";

var $jVEg8 = parcelRequire("jVEg8");
module.exports = /ipad|iphone|ipod/i.test($jVEg8) && typeof Pebble != "undefined";

});

parcelRegister("lVxFm", function(module, exports) {
"use strict";

var $jVEg8 = parcelRequire("jVEg8");
module.exports = /web0s(?!.*chrome)/i.test($jVEg8);

});


parcelRegister("eCofm", function(module, exports) {
"use strict";
module.exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};

});

parcelRegister("7aQOM", function(module, exports) {
"use strict";
module.exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};

});

parcelRegister("lBL1o", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");
module.exports = $9l3PP.Promise;

});

parcelRegister("3kjIC", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");

var $lBL1o = parcelRequire("lBL1o");

var $e6Rz5 = parcelRequire("e6Rz5");

var $iaZZ9 = parcelRequire("iaZZ9");

var $fgsf9 = parcelRequire("fgsf9");

var $fq7H3 = parcelRequire("fq7H3");

var $glx3T = parcelRequire("glx3T");

var $7phdw = parcelRequire("7phdw");

var $a9ory = parcelRequire("a9ory");
var $26c28911b0a6f2f3$var$NativePromisePrototype = $lBL1o && $lBL1o.prototype;
var $26c28911b0a6f2f3$var$SPECIES = $fq7H3("species");
var $26c28911b0a6f2f3$var$SUBCLASSING = false;
var $26c28911b0a6f2f3$var$NATIVE_PROMISE_REJECTION_EVENT = $e6Rz5($9l3PP.PromiseRejectionEvent);
var $26c28911b0a6f2f3$var$FORCED_PROMISE_CONSTRUCTOR = $iaZZ9("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $fgsf9($lBL1o);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($lBL1o);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $a9ory === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($7phdw && !($26c28911b0a6f2f3$var$NativePromisePrototype["catch"] && $26c28911b0a6f2f3$var$NativePromisePrototype["finally"])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$a9ory || $a9ory < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $lBL1o(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$26c28911b0a6f2f3$var$SPECIES] = FakePromise;
        $26c28911b0a6f2f3$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$26c28911b0a6f2f3$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($glx3T === "BROWSER" || $glx3T === "DENO") && !$26c28911b0a6f2f3$var$NATIVE_PROMISE_REJECTION_EVENT;
});
module.exports = {
    CONSTRUCTOR: $26c28911b0a6f2f3$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $26c28911b0a6f2f3$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $26c28911b0a6f2f3$var$SUBCLASSING
};

});

parcelRegister("1HEKk", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $13d969f6bdce5a90$export$2d1720544b23b823; }, function (v) { return $13d969f6bdce5a90$export$2d1720544b23b823 = v; });
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $13d969f6bdce5a90$export$2d1720544b23b823;
"use strict";

var $8GsPx = parcelRequire("8GsPx");
var $13d969f6bdce5a90$var$$TypeError = TypeError;
var $13d969f6bdce5a90$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $13d969f6bdce5a90$var$$TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $8GsPx(resolve);
    this.reject = $8GsPx(reject);
};
$13d969f6bdce5a90$export$2d1720544b23b823 = function(C) {
    return new $13d969f6bdce5a90$var$PromiseCapability(C);
};

});


parcelRegister("fRDGg", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $aELZY = parcelRequire("aELZY");

var $8GsPx = parcelRequire("8GsPx");

var $1HEKk = parcelRequire("1HEKk");

var $7aQOM = parcelRequire("7aQOM");

var $jUk8Y = parcelRequire("jUk8Y");

var $67553 = parcelRequire("67553");
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$ggcsv({
    target: "Promise",
    stat: true,
    forced: $67553
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $1HEKk.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $7aQOM(function() {
            var $promiseResolve = $8GsPx(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $jUk8Y(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $aELZY($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});
parcelRegister("67553", function(module, exports) {
"use strict";

var $lBL1o = parcelRequire("lBL1o");

var $39DPZ = parcelRequire("39DPZ");

var $3kjIC = parcelRequire("3kjIC");
var $4737566c7a07b7bd$require$FORCED_PROMISE_CONSTRUCTOR = $3kjIC.CONSTRUCTOR;
module.exports = $4737566c7a07b7bd$require$FORCED_PROMISE_CONSTRUCTOR || !$39DPZ(function(iterable) {
    $lBL1o.all(iterable).then(undefined, function() {});
});

});
parcelRegister("39DPZ", function(module, exports) {
"use strict";

var $fq7H3 = parcelRequire("fq7H3");
var $24c11d3f184eaea3$var$ITERATOR = $fq7H3("iterator");
var $24c11d3f184eaea3$var$SAFE_CLOSING = false;
try {
    var $24c11d3f184eaea3$var$called = 0;
    var $24c11d3f184eaea3$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$24c11d3f184eaea3$var$called++
            };
        },
        "return": function() {
            $24c11d3f184eaea3$var$SAFE_CLOSING = true;
        }
    };
    $24c11d3f184eaea3$var$iteratorWithReturn[$24c11d3f184eaea3$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($24c11d3f184eaea3$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
module.exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$24c11d3f184eaea3$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$24c11d3f184eaea3$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};

});



parcelRegister("bhLYs", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $7phdw = parcelRequire("7phdw");

var $3kjIC = parcelRequire("3kjIC");
var $83767ee5defd3650$require$FORCED_PROMISE_CONSTRUCTOR = $3kjIC.CONSTRUCTOR;

var $lBL1o = parcelRequire("lBL1o");

var $5Pobw = parcelRequire("5Pobw");

var $e6Rz5 = parcelRequire("e6Rz5");

var $kY5Tb = parcelRequire("kY5Tb");
var $83767ee5defd3650$var$NativePromisePrototype = $lBL1o && $lBL1o.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$ggcsv({
    target: "Promise",
    proto: true,
    forced: $83767ee5defd3650$require$FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!$7phdw && $e6Rz5($lBL1o)) {
    var $83767ee5defd3650$var$method = $5Pobw("Promise").prototype["catch"];
    if ($83767ee5defd3650$var$NativePromisePrototype["catch"] !== $83767ee5defd3650$var$method) $kY5Tb($83767ee5defd3650$var$NativePromisePrototype, "catch", $83767ee5defd3650$var$method, {
        unsafe: true
    });
}

});

parcelRegister("fm27z", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $aELZY = parcelRequire("aELZY");

var $8GsPx = parcelRequire("8GsPx");

var $1HEKk = parcelRequire("1HEKk");

var $7aQOM = parcelRequire("7aQOM");

var $jUk8Y = parcelRequire("jUk8Y");

var $67553 = parcelRequire("67553");
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$ggcsv({
    target: "Promise",
    stat: true,
    forced: $67553
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $1HEKk.f(C);
        var reject = capability.reject;
        var result = $7aQOM(function() {
            var $promiseResolve = $8GsPx(C.resolve);
            $jUk8Y(iterable, function(promise) {
                $aELZY($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRegister("iGB6b", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $1HEKk = parcelRequire("1HEKk");

var $3kjIC = parcelRequire("3kjIC");
var $d9a8ed3f94958e72$require$FORCED_PROMISE_CONSTRUCTOR = $3kjIC.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$ggcsv({
    target: "Promise",
    stat: true,
    forced: $d9a8ed3f94958e72$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = $1HEKk.f(this);
        var capabilityReject = capability.reject;
        capabilityReject(r);
        return capability.promise;
    }
});

});

parcelRegister("doKxr", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $5Pobw = parcelRequire("5Pobw");

var $7phdw = parcelRequire("7phdw");

var $lBL1o = parcelRequire("lBL1o");

var $3kjIC = parcelRequire("3kjIC");
var $9c119dc8f2c5f0ff$require$FORCED_PROMISE_CONSTRUCTOR = $3kjIC.CONSTRUCTOR;

var $gStD1 = parcelRequire("gStD1");
var $9c119dc8f2c5f0ff$var$PromiseConstructorWrapper = $5Pobw("Promise");
var $9c119dc8f2c5f0ff$var$CHECK_WRAPPER = $7phdw && !$9c119dc8f2c5f0ff$require$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$ggcsv({
    target: "Promise",
    stat: true,
    forced: $7phdw || $9c119dc8f2c5f0ff$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $gStD1($9c119dc8f2c5f0ff$var$CHECK_WRAPPER && this === $9c119dc8f2c5f0ff$var$PromiseConstructorWrapper ? $lBL1o : this, x);
    }
});

});
parcelRegister("gStD1", function(module, exports) {
"use strict";

var $l3LMJ = parcelRequire("l3LMJ");

var $1WYwK = parcelRequire("1WYwK");

var $1HEKk = parcelRequire("1HEKk");
module.exports = function(C, x) {
    $l3LMJ(C);
    if ($1WYwK(x) && x.constructor === C) return x;
    var promiseCapability = $1HEKk.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

});



parcelRegister("ettPZ", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $aELZY = parcelRequire("aELZY");

var $8GsPx = parcelRequire("8GsPx");

var $1HEKk = parcelRequire("1HEKk");

var $7aQOM = parcelRequire("7aQOM");

var $jUk8Y = parcelRequire("jUk8Y");

var $67553 = parcelRequire("67553");
// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$ggcsv({
    target: "Promise",
    stat: true,
    forced: $67553
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $1HEKk.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $7aQOM(function() {
            var promiseResolve = $8GsPx(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $jUk8Y(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $aELZY(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "fulfilled",
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "rejected",
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRegister("hakp0", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $aELZY = parcelRequire("aELZY");

var $8GsPx = parcelRequire("8GsPx");

var $5Pobw = parcelRequire("5Pobw");

var $1HEKk = parcelRequire("1HEKk");

var $7aQOM = parcelRequire("7aQOM");

var $jUk8Y = parcelRequire("jUk8Y");

var $67553 = parcelRequire("67553");
var $c7f3324d588fc2f3$var$PROMISE_ANY_ERROR = "No one promise resolved";
// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$ggcsv({
    target: "Promise",
    stat: true,
    forced: $67553
}, {
    any: function any(iterable) {
        var C = this;
        var AggregateError = $5Pobw("AggregateError");
        var capability = $1HEKk.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $7aQOM(function() {
            var promiseResolve = $8GsPx(C.resolve);
            var errors = [];
            var counter = 0;
            var remaining = 1;
            var alreadyResolved = false;
            $jUk8Y(iterable, function(promise) {
                var index = counter++;
                var alreadyRejected = false;
                remaining++;
                $aELZY(promiseResolve, C, promise).then(function(value) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyResolved = true;
                    resolve(value);
                }, function(error) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyRejected = true;
                    errors[index] = error;
                    --remaining || reject(new AggregateError(errors, $c7f3324d588fc2f3$var$PROMISE_ANY_ERROR));
                });
            });
            --remaining || reject(new AggregateError(errors, $c7f3324d588fc2f3$var$PROMISE_ANY_ERROR));
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRegister("d5cWg", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $1HEKk = parcelRequire("1HEKk");
// `Promise.withResolvers` method
// https://github.com/tc39/proposal-promise-with-resolvers
$ggcsv({
    target: "Promise",
    stat: true
}, {
    withResolvers: function withResolvers() {
        var promiseCapability = $1HEKk.f(this);
        return {
            promise: promiseCapability.promise,
            resolve: promiseCapability.resolve,
            reject: promiseCapability.reject
        };
    }
});

});

parcelRegister("wzhSp", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $7phdw = parcelRequire("7phdw");

var $lBL1o = parcelRequire("lBL1o");

var $77TPA = parcelRequire("77TPA");

var $5Pobw = parcelRequire("5Pobw");

var $e6Rz5 = parcelRequire("e6Rz5");

var $2FOd2 = parcelRequire("2FOd2");

var $gStD1 = parcelRequire("gStD1");

var $kY5Tb = parcelRequire("kY5Tb");
var $061e5c9a4575699d$var$NativePromisePrototype = $lBL1o && $lBL1o.prototype;
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $061e5c9a4575699d$var$NON_GENERIC = !!$lBL1o && $77TPA(function() {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    $061e5c9a4575699d$var$NativePromisePrototype["finally"].call({
        then: function() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$ggcsv({
    target: "Promise",
    proto: true,
    real: true,
    forced: $061e5c9a4575699d$var$NON_GENERIC
}, {
    "finally": function(onFinally) {
        var C = $2FOd2(this, $5Pobw("Promise"));
        var isFunction = $e6Rz5(onFinally);
        return this.then(isFunction ? function(x) {
            return $gStD1(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $gStD1(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!$7phdw && $e6Rz5($lBL1o)) {
    var $061e5c9a4575699d$var$method = $5Pobw("Promise").prototype["finally"];
    if ($061e5c9a4575699d$var$NativePromisePrototype["finally"] !== $061e5c9a4575699d$var$method) $kY5Tb($061e5c9a4575699d$var$NativePromisePrototype, "finally", $061e5c9a4575699d$var$method, {
        unsafe: true
    });
}

});

parcelRegister("ja2zQ", function(module, exports) {
"use strict";

var $4TFls = parcelRequire("4TFls");
var $df30f33d6e780b35$require$charAt = $4TFls.charAt;

var $l2Ut5 = parcelRequire("l2Ut5");

var $fmQ29 = parcelRequire("fmQ29");

var $5KUYO = parcelRequire("5KUYO");

var $5IrwJ = parcelRequire("5IrwJ");
var $df30f33d6e780b35$var$STRING_ITERATOR = "String Iterator";
var $df30f33d6e780b35$var$setInternalState = $fmQ29.set;
var $df30f33d6e780b35$var$getInternalState = $fmQ29.getterFor($df30f33d6e780b35$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$5KUYO(String, "String", function(iterated) {
    $df30f33d6e780b35$var$setInternalState(this, {
        type: $df30f33d6e780b35$var$STRING_ITERATOR,
        string: $l2Ut5(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $df30f33d6e780b35$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $5IrwJ(undefined, true);
    point = $df30f33d6e780b35$require$charAt(string, index);
    state.index += point.length;
    return $5IrwJ(point, false);
});

});
parcelRegister("4TFls", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");

var $3ZmxQ = parcelRequire("3ZmxQ");

var $l2Ut5 = parcelRequire("l2Ut5");

var $cBWnS = parcelRequire("cBWnS");
var $390c5ec511d9538f$var$charAt = $f518o("".charAt);
var $390c5ec511d9538f$var$charCodeAt = $f518o("".charCodeAt);
var $390c5ec511d9538f$var$stringSlice = $f518o("".slice);
var $390c5ec511d9538f$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $l2Ut5($cBWnS($this));
        var position = $3ZmxQ(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $390c5ec511d9538f$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $390c5ec511d9538f$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $390c5ec511d9538f$var$charAt(S, position) : first : CONVERT_TO_STRING ? $390c5ec511d9538f$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $390c5ec511d9538f$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $390c5ec511d9538f$var$createMethod(true)
};

});





parcelRegister("42E6z", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2f167552ee152234$var$decode;

var $2f167552ee152234$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $2f167552ee152234$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $2f167552ee152234$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $2f167552ee152234$var$_ParseFile = $iHLHC((parcelRequire("59JWU")));

var $2f167552ee152234$var$_ParseGeoPoint = $iHLHC((parcelRequire("jtZTC")));

var $2f167552ee152234$var$_ParsePolygon = $iHLHC((parcelRequire("i8AKq")));

var $2f167552ee152234$var$_ParseRelation = $iHLHC((parcelRequire("967gW")));
function $2f167552ee152234$var$decode(value) {
    if (value === null || typeof value !== "object" || value instanceof Date) return value;
    if ((0, $2f167552ee152234$var$_isArray.default)(value)) {
        const dup = [];
        (0, $2f167552ee152234$var$_forEach.default)(value).call(value, (v, i)=>{
            dup[i] = $2f167552ee152234$var$decode(v);
        });
        return dup;
    }
    if (typeof value.__op === "string") {
        const { opFromJSON: opFromJSON } = $2f167552ee152234$var$_CoreManager.default.getParseOp();
        return opFromJSON(value);
    }
    const ParseObject = $2f167552ee152234$var$_CoreManager.default.getParseObject();
    if (value.__type === "Pointer" && value.className) return ParseObject.fromJSON(value);
    if (value.__type === "Object" && value.className) return ParseObject.fromJSON(value);
    if (value.__type === "Relation") {
        // The parent and key fields will be populated by the parent
        const relation = new $2f167552ee152234$var$_ParseRelation.default(null, null);
        relation.targetClassName = value.className;
        return relation;
    }
    if (value.__type === "Date") return new Date(value.iso);
    if (value.__type === "File") return $2f167552ee152234$var$_ParseFile.default.fromJSON(value);
    if (value.__type === "GeoPoint") return new $2f167552ee152234$var$_ParseGeoPoint.default({
        latitude: value.latitude,
        longitude: value.longitude
    });
    if (value.__type === "Polygon") return new $2f167552ee152234$var$_ParsePolygon.default(value.coordinates);
    const copy = {};
    for(const k in value)copy[k] = $2f167552ee152234$var$decode(value[k]);
    return copy;
}

});
parcelRegister("euZIZ", function(module, exports) {

module.exports = (parcelRequire("4hHz8"));

});
parcelRegister("4hHz8", function(module, exports) {
"use strict";

var $7wq4z = parcelRequire("7wq4z");
module.exports = $7wq4z;

});
parcelRegister("7wq4z", function(module, exports) {
"use strict";
parcelRequire("eZTVb");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Array.isArray;

});
parcelRegister("eZTVb", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $5zZFa = parcelRequire("5zZFa");
// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$ggcsv({
    target: "Array",
    stat: true
}, {
    isArray: $5zZFa
});

});




parcelRegister("gW71a", function(module, exports) {

module.exports = (parcelRequire("7pUJQ"));

});
parcelRegister("7pUJQ", function(module, exports) {
"use strict";

var $aHxiP = parcelRequire("aHxiP");

var $heVlo = parcelRequire("heVlo");

var $8hsAO = parcelRequire("8hsAO");

var $6px0W = parcelRequire("6px0W");
parcelRequire("8RcmS");
var $5666e1445fcead3a$var$ArrayPrototype = Array.prototype;
var $5666e1445fcead3a$var$DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
module.exports = function(it) {
    var own = it.forEach;
    return it === $5666e1445fcead3a$var$ArrayPrototype || $8hsAO($5666e1445fcead3a$var$ArrayPrototype, it) && own === $5666e1445fcead3a$var$ArrayPrototype.forEach || $heVlo($5666e1445fcead3a$var$DOMIterables, $aHxiP(it)) ? $6px0W : own;
};

});
parcelRegister("6px0W", function(module, exports) {
"use strict";

var $cGPC8 = parcelRequire("cGPC8");
module.exports = $cGPC8;

});
parcelRegister("cGPC8", function(module, exports) {
"use strict";
parcelRequire("aNlay");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Array", "forEach");

});
parcelRegister("aNlay", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $6uImx = parcelRequire("6uImx");
// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$ggcsv({
    target: "Array",
    proto: true,
    forced: [].forEach !== $6uImx
}, {
    forEach: $6uImx
});

});
parcelRegister("6uImx", function(module, exports) {
"use strict";

var $igsV9 = parcelRequire("igsV9");
var $4ba7f4e1b90b0672$require$$forEach = $igsV9.forEach;

var $kQPJO = parcelRequire("kQPJO");
var $4ba7f4e1b90b0672$var$STRICT_METHOD = $kQPJO("forEach");
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !$4ba7f4e1b90b0672$var$STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
    return $4ba7f4e1b90b0672$require$$forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

});
parcelRegister("kQPJO", function(module, exports) {
"use strict";

var $77TPA = parcelRequire("77TPA");
module.exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $77TPA(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};

});



parcelRegister("1F553", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");

var $ly30u = parcelRequire("ly30u");
module.exports = function(CONSTRUCTOR, METHOD) {
    var Namespace = $ly30u[CONSTRUCTOR + "Prototype"];
    var pureMethod = Namespace && Namespace[METHOD];
    if (pureMethod) return pureMethod;
    var NativeConstructor = $9l3PP[CONSTRUCTOR];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    return NativePrototype && NativePrototype[METHOD];
};

});



parcelRegister("8RcmS", function(module, exports) {
// empty

});



parcelRegister("73D0B", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $523712883a269370$var$_forEach = $iHLHC((parcelRequire("gW71a")));
/** Based on https://github.com/react-native-async-storage/async-storage/blob/main/packages/default-storage-backend/src/types.ts */ const $523712883a269370$var$config = {
    IS_NODE: typeof $4TNnu !== "undefined" && !!$4TNnu.versions && !!$4TNnu.versions.node && !$4TNnu.versions.electron,
    REQUEST_ATTEMPT_LIMIT: 5,
    REQUEST_BATCH_SIZE: 20,
    REQUEST_HEADERS: {},
    SERVER_URL: "https://api.parse.com/1",
    SERVER_AUTH_TYPE: null,
    SERVER_AUTH_TOKEN: null,
    LIVEQUERY_SERVER_URL: null,
    ENCRYPTED_KEY: null,
    VERSION: "js5.3.0",
    APPLICATION_ID: null,
    JAVASCRIPT_KEY: null,
    MASTER_KEY: null,
    USE_MASTER_KEY: false,
    PERFORM_USER_REWRITE: true,
    FORCE_REVOCABLE_SESSION: false,
    ENCRYPTED_USER: false,
    IDEMPOTENCY: false,
    ALLOW_CUSTOM_OBJECT_ID: false,
    PARSE_ERRORS: []
};
function $523712883a269370$var$requireMethods(name, methods, controller) {
    (0, $523712883a269370$var$_forEach.default)(methods).call(methods, (func)=>{
        if (typeof controller[func] !== "function") throw new Error(`${name} must implement ${func}()`);
    });
}
const $523712883a269370$var$CoreManager = {
    get: function(key) {
        if ($523712883a269370$var$config.hasOwnProperty(key)) return $523712883a269370$var$config[key];
        throw new Error("Configuration key not found: " + key);
    },
    set: function(key, value) {
        $523712883a269370$var$config[key] = value;
    },
    setIfNeeded: function(key, value) {
        if (!$523712883a269370$var$config.hasOwnProperty(key)) $523712883a269370$var$config[key] = value;
        return $523712883a269370$var$config[key];
    },
    /* Specialized Controller Setters/Getters */ setAnalyticsController (controller) {
        $523712883a269370$var$requireMethods("AnalyticsController", [
            "track"
        ], controller);
        $523712883a269370$var$config["AnalyticsController"] = controller;
    },
    getAnalyticsController () {
        return $523712883a269370$var$config["AnalyticsController"];
    },
    setCloudController (controller) {
        $523712883a269370$var$requireMethods("CloudController", [
            "run",
            "getJobsData",
            "startJob"
        ], controller);
        $523712883a269370$var$config["CloudController"] = controller;
    },
    getCloudController () {
        return $523712883a269370$var$config["CloudController"];
    },
    setConfigController (controller) {
        $523712883a269370$var$requireMethods("ConfigController", [
            "current",
            "get",
            "save"
        ], controller);
        $523712883a269370$var$config["ConfigController"] = controller;
    },
    getConfigController () {
        return $523712883a269370$var$config["ConfigController"];
    },
    setCryptoController (controller) {
        $523712883a269370$var$requireMethods("CryptoController", [
            "encrypt",
            "decrypt"
        ], controller);
        $523712883a269370$var$config["CryptoController"] = controller;
    },
    getCryptoController () {
        return $523712883a269370$var$config["CryptoController"];
    },
    setEventEmitter (eventEmitter) {
        $523712883a269370$var$config["EventEmitter"] = eventEmitter;
    },
    getEventEmitter () {
        return $523712883a269370$var$config["EventEmitter"];
    },
    setFileController (controller) {
        $523712883a269370$var$requireMethods("FileController", [
            "saveFile",
            "saveBase64"
        ], controller);
        $523712883a269370$var$config["FileController"] = controller;
    },
    setEventuallyQueue (controller) {
        $523712883a269370$var$requireMethods("EventuallyQueue", [
            "poll",
            "save",
            "destroy"
        ], controller);
        $523712883a269370$var$config["EventuallyQueue"] = controller;
    },
    getEventuallyQueue () {
        return $523712883a269370$var$config["EventuallyQueue"];
    },
    getFileController () {
        return $523712883a269370$var$config["FileController"];
    },
    setInstallationController (controller) {
        $523712883a269370$var$requireMethods("InstallationController", [
            "currentInstallationId",
            "currentInstallation",
            "updateInstallationOnDisk"
        ], controller);
        $523712883a269370$var$config["InstallationController"] = controller;
    },
    getInstallationController () {
        return $523712883a269370$var$config["InstallationController"];
    },
    setLiveQuery (liveQuery) {
        $523712883a269370$var$config["LiveQuery"] = liveQuery;
    },
    getLiveQuery () {
        return $523712883a269370$var$config["LiveQuery"];
    },
    setObjectController (controller) {
        $523712883a269370$var$requireMethods("ObjectController", [
            "save",
            "fetch",
            "destroy"
        ], controller);
        $523712883a269370$var$config["ObjectController"] = controller;
    },
    getObjectController () {
        return $523712883a269370$var$config["ObjectController"];
    },
    setObjectStateController (controller) {
        $523712883a269370$var$requireMethods("ObjectStateController", [
            "getState",
            "initializeState",
            "removeState",
            "getServerData",
            "setServerData",
            "getPendingOps",
            "setPendingOp",
            "pushPendingState",
            "popPendingState",
            "mergeFirstPendingState",
            "getObjectCache",
            "estimateAttribute",
            "estimateAttributes",
            "commitServerChanges",
            "enqueueTask",
            "clearAllState"
        ], controller);
        $523712883a269370$var$config["ObjectStateController"] = controller;
    },
    getObjectStateController () {
        return $523712883a269370$var$config["ObjectStateController"];
    },
    setPushController (controller) {
        $523712883a269370$var$requireMethods("PushController", [
            "send"
        ], controller);
        $523712883a269370$var$config["PushController"] = controller;
    },
    getPushController () {
        return $523712883a269370$var$config["PushController"];
    },
    setQueryController (controller) {
        $523712883a269370$var$requireMethods("QueryController", [
            "find",
            "aggregate"
        ], controller);
        $523712883a269370$var$config["QueryController"] = controller;
    },
    getQueryController () {
        return $523712883a269370$var$config["QueryController"];
    },
    setRESTController (controller) {
        $523712883a269370$var$requireMethods("RESTController", [
            "request",
            "ajax"
        ], controller);
        $523712883a269370$var$config["RESTController"] = controller;
    },
    getRESTController () {
        return $523712883a269370$var$config["RESTController"];
    },
    setSchemaController (controller) {
        $523712883a269370$var$requireMethods("SchemaController", [
            "get",
            "create",
            "update",
            "delete",
            "send",
            "purge"
        ], controller);
        $523712883a269370$var$config["SchemaController"] = controller;
    },
    getSchemaController () {
        return $523712883a269370$var$config["SchemaController"];
    },
    setSessionController (controller) {
        $523712883a269370$var$requireMethods("SessionController", [
            "getSession"
        ], controller);
        $523712883a269370$var$config["SessionController"] = controller;
    },
    getSessionController () {
        return $523712883a269370$var$config["SessionController"];
    },
    setStorageController (controller) {
        if (controller.async) $523712883a269370$var$requireMethods("An async StorageController", [
            "getItemAsync",
            "setItemAsync",
            "removeItemAsync",
            "getAllKeysAsync"
        ], controller);
        else $523712883a269370$var$requireMethods("A synchronous StorageController", [
            "getItem",
            "setItem",
            "removeItem",
            "getAllKeys"
        ], controller);
        $523712883a269370$var$config["StorageController"] = controller;
    },
    setLocalDatastoreController (controller) {
        $523712883a269370$var$requireMethods("LocalDatastoreController", [
            "pinWithName",
            "fromPinWithName",
            "unPinWithName",
            "getAllContents",
            "clear"
        ], controller);
        $523712883a269370$var$config["LocalDatastoreController"] = controller;
    },
    getLocalDatastoreController () {
        return $523712883a269370$var$config["LocalDatastoreController"];
    },
    setLocalDatastore (store) {
        $523712883a269370$var$config["LocalDatastore"] = store;
    },
    getLocalDatastore () {
        return $523712883a269370$var$config["LocalDatastore"];
    },
    getStorageController () {
        return $523712883a269370$var$config["StorageController"];
    },
    setAsyncStorage (storage) {
        $523712883a269370$var$config["AsyncStorage"] = storage;
    },
    getAsyncStorage () {
        return $523712883a269370$var$config["AsyncStorage"];
    },
    setWebSocketController (controller) {
        $523712883a269370$var$config["WebSocketController"] = controller;
    },
    getWebSocketController () {
        return $523712883a269370$var$config["WebSocketController"];
    },
    setUserController (controller) {
        $523712883a269370$var$requireMethods("UserController", [
            "setCurrentUser",
            "currentUser",
            "currentUserAsync",
            "signUp",
            "logIn",
            "become",
            "logOut",
            "me",
            "requestPasswordReset",
            "upgradeToRevocableSession",
            "requestEmailVerification",
            "verifyPassword",
            "linkWith"
        ], controller);
        $523712883a269370$var$config["UserController"] = controller;
    },
    getUserController () {
        return $523712883a269370$var$config["UserController"];
    },
    setLiveQueryController (controller) {
        $523712883a269370$var$requireMethods("LiveQueryController", [
            "setDefaultLiveQueryClient",
            "getDefaultLiveQueryClient",
            "_clearCachedDefaultClient"
        ], controller);
        $523712883a269370$var$config["LiveQueryController"] = controller;
    },
    getLiveQueryController () {
        return $523712883a269370$var$config["LiveQueryController"];
    },
    setHooksController (controller) {
        $523712883a269370$var$requireMethods("HooksController", [
            "create",
            "get",
            "update",
            "remove"
        ], controller);
        $523712883a269370$var$config["HooksController"] = controller;
    },
    getHooksController () {
        return $523712883a269370$var$config["HooksController"];
    },
    setParseOp (op) {
        $523712883a269370$var$config["ParseOp"] = op;
    },
    getParseOp () {
        return $523712883a269370$var$config["ParseOp"];
    },
    setParseObject (object) {
        $523712883a269370$var$config["ParseObject"] = object;
    },
    getParseObject () {
        return $523712883a269370$var$config["ParseObject"];
    },
    setParseQuery (query) {
        $523712883a269370$var$config["ParseQuery"] = query;
    },
    getParseQuery () {
        return $523712883a269370$var$config["ParseQuery"];
    },
    setParseRole (role) {
        $523712883a269370$var$config["ParseRole"] = role;
    },
    getParseRole () {
        return $523712883a269370$var$config["ParseRole"];
    },
    setParseUser (user) {
        $523712883a269370$var$config["ParseUser"] = user;
    },
    getParseUser () {
        return $523712883a269370$var$config["ParseUser"];
    }
};
module.exports = $523712883a269370$var$CoreManager;
var $523712883a269370$var$_default = module.exports.default = $523712883a269370$var$CoreManager;

});
parcelRegister("4TNnu", function(module, exports) {
// shim for using process in browser
var $391299e0893a3dfa$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};

});


parcelRegister("59JWU", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c116f8917d53f2a$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $3c116f8917d53f2a$var$_slice = $iHLHC((parcelRequire("a1TrC")));

var $3c116f8917d53f2a$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $3c116f8917d53f2a$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $3c116f8917d53f2a$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $3c116f8917d53f2a$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $3c116f8917d53f2a$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $3c116f8917d53f2a$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $3c116f8917d53f2a$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $3c116f8917d53f2a$var$_Xhr = $iHLHC((parcelRequire("fbHpb")));
/* global XMLHttpRequest, Blob */ let $3c116f8917d53f2a$var$XHR = null;
if (typeof XMLHttpRequest !== "undefined") $3c116f8917d53f2a$var$XHR = XMLHttpRequest;
function $3c116f8917d53f2a$var$b64Digit(number) {
    if (number < 26) return String.fromCharCode(65 + number);
    if (number < 52) return String.fromCharCode(97 + (number - 26));
    if (number < 62) return String.fromCharCode(48 + (number - 52));
    if (number === 62) return "+";
    if (number === 63) return "/";
    throw new TypeError("Tried to encode large digit " + number + " in base64.");
}
/**
 * A Parse.File is a local representation of a file that is saved to the Parse
 * cloud.
 *
 * @alias Parse.File
 */ class $3c116f8917d53f2a$var$ParseFile {
    /**
   * @param name {String} The file's name. This will be prefixed by a unique
   *     value once the file has finished saving. The file name must begin with
   *     an alphanumeric character, and consist of alphanumeric characters,
   *     periods, spaces, underscores, or dashes.
   * @param data {Array} The data for the file, as either:
   *     1. an Array of byte value Numbers, or
   *     2. an Object like { base64: "..." } with a base64-encoded String.
   *     3. an Object like { uri: "..." } with a uri String.
   *     4. a File object selected with a file upload control. (3) only works
   *        in Firefox 3.6+, Safari 6.0.2+, Chrome 7+, and IE 10+.
   *        For example:
   * <pre>
   * var fileUploadControl = $("#profilePhotoFileUpload")[0];
   * if (fileUploadControl.files.length > 0) {
   *   var file = fileUploadControl.files[0];
   *   var name = "photo.jpg";
   *   var parseFile = new Parse.File(name, file);
   *   parseFile.save().then(function() {
   *     // The file has been saved to Parse.
   *   }, function(error) {
   *     // The file either could not be read, or could not be saved to Parse.
   *   });
   * }</pre>
   * @param type {String} Optional Content-Type header to use for the file. If
   *     this is omitted, the content type will be inferred from the name's
   *     extension.
   * @param metadata {object} Optional key value pairs to be stored with file object
   * @param tags {object} Optional key value pairs to be stored with file object
   */ constructor(name, data, type, metadata, tags){
        (0, $3c116f8917d53f2a$var$_defineProperty2.default)(this, "_name", void 0);
        (0, $3c116f8917d53f2a$var$_defineProperty2.default)(this, "_url", void 0);
        (0, $3c116f8917d53f2a$var$_defineProperty2.default)(this, "_source", void 0);
        (0, $3c116f8917d53f2a$var$_defineProperty2.default)(this, "_previousSave", void 0);
        (0, $3c116f8917d53f2a$var$_defineProperty2.default)(this, "_data", void 0);
        (0, $3c116f8917d53f2a$var$_defineProperty2.default)(this, "_requestTask", void 0);
        (0, $3c116f8917d53f2a$var$_defineProperty2.default)(this, "_metadata", void 0);
        (0, $3c116f8917d53f2a$var$_defineProperty2.default)(this, "_tags", void 0);
        const specifiedType = type || "";
        this._name = name;
        this._metadata = metadata || {};
        this._tags = tags || {};
        if (data !== undefined) {
            if ((0, $3c116f8917d53f2a$var$_isArray.default)(data)) {
                this._data = $3c116f8917d53f2a$var$ParseFile.encodeBase64(data);
                this._source = {
                    format: "base64",
                    base64: this._data,
                    type: specifiedType
                };
            } else if (typeof Blob !== "undefined" && data instanceof Blob) this._source = {
                format: "file",
                file: data,
                type: specifiedType
            };
            else if (data && typeof data.uri === "string" && data.uri !== undefined) this._source = {
                format: "uri",
                uri: data.uri,
                type: specifiedType
            };
            else if (data && typeof data.base64 === "string") {
                var _context, _context2, _context3;
                const base64 = (0, $3c116f8917d53f2a$var$_slice.default)(_context = data.base64.split(",")).call(_context, -1)[0];
                const dataType = specifiedType || (0, $3c116f8917d53f2a$var$_slice.default)(_context2 = (0, $3c116f8917d53f2a$var$_slice.default)(_context3 = data.base64.split(";")).call(_context3, 0, 1)[0].split(":")).call(_context2, 1, 2)[0] || "text/plain";
                this._data = base64;
                this._source = {
                    format: "base64",
                    base64: base64,
                    type: dataType
                };
            } else throw new TypeError("Cannot create a Parse.File with that data.");
        }
    }
    /**
   * Return the data for the file, downloading it if not already present.
   * Data is present if initialized with Byte Array, Base64 or Saved with Uri.
   * Data is cleared if saved with File object selected with a file upload control
   *
   * @returns {Promise} Promise that is resolve with base64 data
   */ async getData() {
        if (this._data) return this._data;
        if (!this._url) throw new Error("Cannot retrieve data for unsaved ParseFile.");
        const controller = $3c116f8917d53f2a$var$_CoreManager.default.getFileController();
        const result = await controller.download(this._url, {
            requestTask: (task)=>this._requestTask = task
        });
        this._data = result.base64;
        return this._data;
    }
    /**
   * Gets the name of the file. Before save is called, this is the filename
   * given by the user. After save is called, that name gets prefixed with a
   * unique identifier.
   *
   * @returns {string}
   */ name() {
        return this._name;
    }
    /**
   * Gets the url of the file. It is only available after you save the file or
   * after you get the file from a Parse.Object.
   *
   * @param {object} options An object to specify url options
   * @param {boolean} [options.forceSecure] force the url to be secure
   * @returns {string | undefined}
   */ url(options) {
        options = options || {};
        if (!this._url) return;
        if (options.forceSecure) return this._url.replace(/^http:\/\//i, "https://");
        else return this._url;
    }
    /**
   * Gets the metadata of the file.
   *
   * @returns {object}
   */ metadata() {
        return this._metadata;
    }
    /**
   * Gets the tags of the file.
   *
   * @returns {object}
   */ tags() {
        return this._tags;
    }
    /**
   * Saves the file to the Parse cloud.
   *
   * @param {object} options
   * Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *     behalf of a specific user.
   *   <li>progress: In Browser only, callback for upload progress. For example:
   * <pre>
   * let parseFile = new Parse.File(name, file);
   * parseFile.save({
   *   progress: (progressValue, loaded, total, { type }) => {
   *     if (type === "upload" && progressValue !== null) {
   *       // Update the UI using progressValue
   *     }
   *   }
   * });
   * </pre>
   * </ul>
   * @returns {Promise | undefined} Promise that is resolved when the save finishes.
   */ save(options) {
        options = options || {};
        options.requestTask = (task)=>this._requestTask = task;
        options.metadata = this._metadata;
        options.tags = this._tags;
        const controller = $3c116f8917d53f2a$var$_CoreManager.default.getFileController();
        if (!this._previousSave) {
            if (this._source.format === "file") this._previousSave = controller.saveFile(this._name, this._source, options).then((res)=>{
                this._name = res.name;
                this._url = res.url;
                this._data = null;
                this._requestTask = null;
                return this;
            });
            else if (this._source.format === "uri") this._previousSave = controller.download(this._source.uri, options).then((result)=>{
                if (!(result && result.base64)) return {};
                const newSource = {
                    format: "base64",
                    base64: result.base64,
                    type: result.contentType
                };
                this._data = result.base64;
                this._requestTask = null;
                return controller.saveBase64(this._name, newSource, options);
            }).then((res)=>{
                this._name = res.name;
                this._url = res.url;
                this._requestTask = null;
                return this;
            });
            else this._previousSave = controller.saveBase64(this._name, this._source, options).then((res)=>{
                this._name = res.name;
                this._url = res.url;
                this._requestTask = null;
                return this;
            });
        }
        if (this._previousSave) return this._previousSave;
    }
    /**
   * Aborts the request if it has already been sent.
   */ cancel() {
        if (this._requestTask && typeof this._requestTask.abort === "function") {
            this._requestTask._aborted = true;
            this._requestTask.abort();
        }
        this._requestTask = null;
    }
    /**
   * Deletes the file from the Parse cloud.
   * In Cloud Code and Node only with Master Key.
   *
   * @param {object} options
   * Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   * <pre>
   * @returns {Promise} Promise that is resolved when the delete finishes.
   */ destroy() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!this._name) throw new $3c116f8917d53f2a$var$_ParseError.default($3c116f8917d53f2a$var$_ParseError.default.FILE_DELETE_UNNAMED_ERROR, "Cannot delete an unnamed file.");
        const destroyOptions = {
            useMasterKey: true
        };
        if (options.hasOwnProperty("useMasterKey")) destroyOptions.useMasterKey = !!options.useMasterKey;
        const controller = $3c116f8917d53f2a$var$_CoreManager.default.getFileController();
        return controller.deleteFile(this._name, destroyOptions).then(()=>{
            this._data = undefined;
            this._requestTask = null;
            return this;
        });
    }
    toJSON() {
        return {
            __type: "File",
            name: this._name,
            url: this._url
        };
    }
    equals(other) {
        if (this === other) return true;
        // Unsaved Files are never equal, since they will be saved to different URLs
        return other instanceof $3c116f8917d53f2a$var$ParseFile && this.name() === other.name() && this.url() === other.url() && typeof this.url() !== "undefined";
    }
    /**
   * Sets metadata to be saved with file object. Overwrites existing metadata
   *
   * @param {object} metadata Key value pairs to be stored with file object
   */ setMetadata(metadata) {
        if (metadata && typeof metadata === "object") {
            var _context4;
            (0, $3c116f8917d53f2a$var$_forEach.default)(_context4 = (0, $3c116f8917d53f2a$var$_keys.default)(metadata)).call(_context4, (key)=>{
                this.addMetadata(key, metadata[key]);
            });
        }
    }
    /**
   * Sets metadata to be saved with file object. Adds to existing metadata.
   *
   * @param {string} key key to store the metadata
   * @param {*} value metadata
   */ addMetadata(key, value) {
        if (typeof key === "string") this._metadata[key] = value;
    }
    /**
   * Sets tags to be saved with file object. Overwrites existing tags
   *
   * @param {object} tags Key value pairs to be stored with file object
   */ setTags(tags) {
        if (tags && typeof tags === "object") {
            var _context5;
            (0, $3c116f8917d53f2a$var$_forEach.default)(_context5 = (0, $3c116f8917d53f2a$var$_keys.default)(tags)).call(_context5, (key)=>{
                this.addTag(key, tags[key]);
            });
        }
    }
    /**
   * Sets tags to be saved with file object. Adds to existing tags.
   *
   * @param {string} key key to store tags
   * @param {*} value tag
   */ addTag(key, value) {
        if (typeof key === "string") this._tags[key] = value;
    }
    static fromJSON(obj) {
        if (obj.__type !== "File") throw new TypeError("JSON object does not represent a ParseFile");
        const file = new $3c116f8917d53f2a$var$ParseFile(obj.name);
        file._url = obj.url;
        return file;
    }
    static encodeBase64(bytes) {
        const chunks = [];
        chunks.length = Math.ceil(bytes.length / 3);
        for(let i = 0; i < chunks.length; i++){
            const b1 = bytes[i * 3];
            const b2 = bytes[i * 3 + 1] || 0;
            const b3 = bytes[i * 3 + 2] || 0;
            const has2 = i * 3 + 1 < bytes.length;
            const has3 = i * 3 + 2 < bytes.length;
            chunks[i] = [
                $3c116f8917d53f2a$var$b64Digit(b1 >> 2 & 0x3f),
                $3c116f8917d53f2a$var$b64Digit(b1 << 4 & 0x30 | b2 >> 4 & 0x0f),
                has2 ? $3c116f8917d53f2a$var$b64Digit(b2 << 2 & 0x3c | b3 >> 6 & 0x03) : "=",
                has3 ? $3c116f8917d53f2a$var$b64Digit(b3 & 0x3f) : "="
            ].join("");
        }
        return chunks.join("");
    }
}
const $3c116f8917d53f2a$var$DefaultController = {
    saveFile: async function(name, source, options) {
        if (source.format !== "file") throw new Error("saveFile can only be used with File-type sources.");
        const base64Data = await new $3c116f8917d53f2a$var$_promise.default((res, rej)=>{
            // eslint-disable-next-line no-undef
            const reader = new FileReader();
            reader.onload = ()=>res(reader.result);
            reader.onerror = (error)=>rej(error);
            reader.readAsDataURL(source.file);
        });
        // we only want the data after the comma
        // For example: "data:application/pdf;base64,JVBERi0xLjQKJ..." we would only want "JVBERi0xLjQKJ..."
        const [first, second] = base64Data.split(",");
        // in the event there is no 'data:application/pdf;base64,' at the beginning of the base64 string
        // use the entire string instead
        const data = second ? second : first;
        const newSource = {
            format: "base64",
            base64: data,
            type: source.type || (source.file ? source.file.type : undefined)
        };
        return await $3c116f8917d53f2a$var$DefaultController.saveBase64(name, newSource, options);
    },
    saveBase64: function(name, source) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (source.format !== "base64") throw new Error("saveBase64 can only be used with Base64-type sources.");
        const data = {
            base64: source.base64,
            fileData: {
                metadata: {
                    ...options.metadata
                },
                tags: {
                    ...options.tags
                }
            }
        };
        delete options.metadata;
        delete options.tags;
        if (source.type) data._ContentType = source.type;
        return $3c116f8917d53f2a$var$_CoreManager.default.getRESTController().request("POST", "files/" + name, data, options);
    },
    download: function(uri, options) {
        if ($3c116f8917d53f2a$var$XHR) return this.downloadAjax(uri, options);
        else return $3c116f8917d53f2a$var$_promise.default.reject("Cannot make a request: No definition of XMLHttpRequest was found.");
    },
    downloadAjax: function(uri, options) {
        return new $3c116f8917d53f2a$var$_promise.default((resolve, reject)=>{
            const xhr = new $3c116f8917d53f2a$var$XHR();
            xhr.open("GET", uri, true);
            xhr.responseType = "arraybuffer";
            xhr.onerror = function(e) {
                reject(e);
            };
            xhr.onreadystatechange = function() {
                if (xhr.readyState !== xhr.DONE) return;
                if (!this.response) return resolve({});
                const bytes = new Uint8Array(this.response);
                resolve({
                    base64: $3c116f8917d53f2a$var$ParseFile.encodeBase64(bytes),
                    contentType: xhr.getResponseHeader("content-type")
                });
            };
            options.requestTask(xhr);
            xhr.send();
        });
    },
    deleteFile: function(name, options) {
        const headers = {
            "X-Parse-Application-ID": $3c116f8917d53f2a$var$_CoreManager.default.get("APPLICATION_ID")
        };
        if (options.useMasterKey) headers["X-Parse-Master-Key"] = $3c116f8917d53f2a$var$_CoreManager.default.get("MASTER_KEY");
        let url = $3c116f8917d53f2a$var$_CoreManager.default.get("SERVER_URL");
        if (url[url.length - 1] !== "/") url += "/";
        url += "files/" + name;
        return $3c116f8917d53f2a$var$_CoreManager.default.getRESTController().ajax("DELETE", url, "", headers).catch((response)=>{
            // TODO: return JSON object in server
            if (!response || response === "SyntaxError: Unexpected end of JSON input") return $3c116f8917d53f2a$var$_promise.default.resolve();
            else return $3c116f8917d53f2a$var$_CoreManager.default.getRESTController().handleError(response);
        });
    },
    _setXHR (xhr) {
        $3c116f8917d53f2a$var$XHR = xhr;
    },
    _getXHR () {
        return $3c116f8917d53f2a$var$XHR;
    }
};
$3c116f8917d53f2a$var$_CoreManager.default.setFileController($3c116f8917d53f2a$var$DefaultController);
var $3c116f8917d53f2a$var$_default = module.exports.default = $3c116f8917d53f2a$var$ParseFile;
module.exports.b64Digit = $3c116f8917d53f2a$var$b64Digit;

});
parcelRegister("a1TrC", function(module, exports) {

module.exports = (parcelRequire("loUO6"));

});
parcelRegister("loUO6", function(module, exports) {
"use strict";

var $17yB6 = parcelRequire("17yB6");
module.exports = $17yB6;

});
parcelRegister("17yB6", function(module, exports) {
"use strict";

var $8hsAO = parcelRequire("8hsAO");

var $fa9j5 = parcelRequire("fa9j5");
var $0d11483398c26308$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.slice;
    return it === $0d11483398c26308$var$ArrayPrototype || $8hsAO($0d11483398c26308$var$ArrayPrototype, it) && own === $0d11483398c26308$var$ArrayPrototype.slice ? $fa9j5 : own;
};

});
parcelRegister("fa9j5", function(module, exports) {
"use strict";
parcelRequire("hGTMp");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Array", "slice");

});
parcelRegister("hGTMp", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $5zZFa = parcelRequire("5zZFa");

var $iQLrm = parcelRequire("iQLrm");

var $1WYwK = parcelRequire("1WYwK");

var $2s0YW = parcelRequire("2s0YW");

var $6ocdr = parcelRequire("6ocdr");

var $bYkAs = parcelRequire("bYkAs");

var $b1Dzg = parcelRequire("b1Dzg");

var $fq7H3 = parcelRequire("fq7H3");

var $PdD5d = parcelRequire("PdD5d");

var $hF40G = parcelRequire("hF40G");
var $ce11a0a1d0d9691d$var$HAS_SPECIES_SUPPORT = $PdD5d("slice");
var $ce11a0a1d0d9691d$var$SPECIES = $fq7H3("species");
var $ce11a0a1d0d9691d$var$$Array = Array;
var $ce11a0a1d0d9691d$var$max = Math.max;
// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$ggcsv({
    target: "Array",
    proto: true,
    forced: !$ce11a0a1d0d9691d$var$HAS_SPECIES_SUPPORT
}, {
    slice: function slice(start, end) {
        var O = $bYkAs(this);
        var length = $6ocdr(O);
        var k = $2s0YW(start, length);
        var fin = $2s0YW(end === undefined ? length : end, length);
        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
        var Constructor, result, n;
        if ($5zZFa(O)) {
            Constructor = O.constructor;
            // cross-realm fallback
            if ($iQLrm(Constructor) && (Constructor === $ce11a0a1d0d9691d$var$$Array || $5zZFa(Constructor.prototype))) Constructor = undefined;
            else if ($1WYwK(Constructor)) {
                Constructor = Constructor[$ce11a0a1d0d9691d$var$SPECIES];
                if (Constructor === null) Constructor = undefined;
            }
            if (Constructor === $ce11a0a1d0d9691d$var$$Array || Constructor === undefined) return $hF40G(O, k, fin);
        }
        result = new (Constructor === undefined ? $ce11a0a1d0d9691d$var$$Array : Constructor)($ce11a0a1d0d9691d$var$max(fin - k, 0));
        for(n = 0; k < fin; k++, n++)if (k in O) $b1Dzg(result, n, O[k]);
        result.length = n;
        return result;
    }
});

});
parcelRegister("b1Dzg", function(module, exports) {
"use strict";

var $jeZ4p = parcelRequire("jeZ4p");

var $diq7r = parcelRequire("diq7r");

var $8c6fn = parcelRequire("8c6fn");
module.exports = function(object, key, value) {
    if ($jeZ4p) $diq7r.f(object, key, $8c6fn(0, value));
    else object[key] = value;
};

});

parcelRegister("PdD5d", function(module, exports) {
"use strict";

var $77TPA = parcelRequire("77TPA");

var $fq7H3 = parcelRequire("fq7H3");

var $a9ory = parcelRequire("a9ory");
var $099f560b79cb257e$var$SPECIES = $fq7H3("species");
module.exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $a9ory >= 51 || !$77TPA(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$099f560b79cb257e$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};

});






parcelRegister("2QmZN", function(module, exports) {

module.exports = (parcelRequire("5gyKS"));

});
parcelRegister("5gyKS", function(module, exports) {
"use strict";

var $4irDB = parcelRequire("4irDB");
module.exports = $4irDB;

});
parcelRegister("4irDB", function(module, exports) {
"use strict";
parcelRequire("daIoi");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Object.keys;

});
parcelRegister("daIoi", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $iJNxK = parcelRequire("iJNxK");

var $3Ut0t = parcelRequire("3Ut0t");

var $77TPA = parcelRequire("77TPA");
var $996ea4a33c906706$var$FAILS_ON_PRIMITIVES = $77TPA(function() {
    $3Ut0t(1);
});
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$ggcsv({
    target: "Object",
    stat: true,
    forced: $996ea4a33c906706$var$FAILS_ON_PRIMITIVES
}, {
    keys: function keys(it) {
        return $3Ut0t($iJNxK(it));
    }
});

});




parcelRegister("9l1BE", function(module, exports) {

module.exports = (parcelRequire("hCfza"));

});
parcelRegister("hCfza", function(module, exports) {
"use strict";

var $d7pYj = parcelRequire("d7pYj");
module.exports = $d7pYj;

});
parcelRegister("d7pYj", function(module, exports) {
"use strict";

var $8hsAO = parcelRequire("8hsAO");

var $19Owo = parcelRequire("19Owo");
var $98d013491640d7ee$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.indexOf;
    return it === $98d013491640d7ee$var$ArrayPrototype || $8hsAO($98d013491640d7ee$var$ArrayPrototype, it) && own === $98d013491640d7ee$var$ArrayPrototype.indexOf ? $19Owo : own;
};

});
parcelRegister("19Owo", function(module, exports) {
"use strict";
parcelRequire("Qq8LU");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Array", "indexOf");

});
parcelRegister("Qq8LU", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $5FNR6 = parcelRequire("5FNR6");

var $3NUiQ = parcelRequire("3NUiQ");
var $09d92265e7517df8$require$$indexOf = $3NUiQ.indexOf;

var $kQPJO = parcelRequire("kQPJO");
var $09d92265e7517df8$var$nativeIndexOf = $5FNR6([].indexOf);
var $09d92265e7517df8$var$NEGATIVE_ZERO = !!$09d92265e7517df8$var$nativeIndexOf && 1 / $09d92265e7517df8$var$nativeIndexOf([
    1
], 1, -0) < 0;
var $09d92265e7517df8$var$FORCED = $09d92265e7517df8$var$NEGATIVE_ZERO || !$kQPJO("indexOf");
// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$ggcsv({
    target: "Array",
    proto: true,
    forced: $09d92265e7517df8$var$FORCED
}, {
    indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
        var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
        return $09d92265e7517df8$var$NEGATIVE_ZERO ? $09d92265e7517df8$var$nativeIndexOf(this, searchElement, fromIndex) || 0 : $09d92265e7517df8$require$$indexOf(this, searchElement, fromIndex);
    }
});

});





parcelRegister("4cByw", function(module, exports) {

var $hV0qA = parcelRequire("hV0qA");

var $5UiDK = parcelRequire("5UiDK");
function $30f56a30cd5b4ba5$var$_defineProperty(e, r, t) {
    return (r = $5UiDK(r)) in e ? $hV0qA(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $30f56a30cd5b4ba5$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hV0qA", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2S1Lk"));

});
parcelRegister("2S1Lk", function(module, exports) {
"use strict";

var $aAhWo = parcelRequire("aAhWo");
module.exports = $aAhWo;

});
parcelRegister("aAhWo", function(module, exports) {
"use strict";

var $iizpp = parcelRequire("iizpp");
module.exports = $iizpp;

});



parcelRegister("5UiDK", function(module, exports) {

var $6iqUa = parcelRequire("6iqUa");
var $44d0a4459b094cf1$var$_typeof = $6iqUa.default;

var $xKtYn = parcelRequire("xKtYn");
function $44d0a4459b094cf1$var$toPropertyKey(t) {
    var i = $xKtYn(t, "string");
    return "symbol" == $44d0a4459b094cf1$var$_typeof(i) ? i : i + "";
}
module.exports = $44d0a4459b094cf1$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6iqUa", function(module, exports) {

var $4UwFI = parcelRequire("4UwFI");

var $g71bB = parcelRequire("g71bB");
function $49594b40b1cfa2a1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $49594b40b1cfa2a1$var$_typeof = "function" == typeof $4UwFI && "symbol" == typeof $g71bB ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof $4UwFI && o.constructor === $4UwFI && o !== $4UwFI.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $49594b40b1cfa2a1$var$_typeof(o);
}
module.exports = $49594b40b1cfa2a1$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4UwFI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("clgUG"));

});
parcelRegister("clgUG", function(module, exports) {
"use strict";

var $dnFMy = parcelRequire("dnFMy");
parcelRequire("h8IOe");
parcelRequire("5oSUb");
parcelRequire("gy6wN");
parcelRequire("i3G8Z");
parcelRequire("fVjjW");
parcelRequire("6Vj7u");
parcelRequire("1kp86");
parcelRequire("kSb0Q");
parcelRequire("4IO6j");
parcelRequire("9RLNS");
module.exports = $dnFMy;

});
parcelRegister("dnFMy", function(module, exports) {
"use strict";

var $feUJs = parcelRequire("feUJs");
parcelRequire("jgM91");
parcelRequire("8QfZZ");
parcelRequire("il9RF");
parcelRequire("ec6Rp");
module.exports = $feUJs;

});
parcelRegister("feUJs", function(module, exports) {
"use strict";

var $aT1j7 = parcelRequire("aT1j7");
parcelRequire("jXhxH");
module.exports = $aT1j7;

});
parcelRegister("aT1j7", function(module, exports) {
"use strict";
parcelRequire("isTuv");
parcelRequire("iYyco");
parcelRequire("ko4d9");
parcelRequire("8uxl4");
parcelRequire("fqhMK");
parcelRequire("8awQv");
parcelRequire("5w9fi");
parcelRequire("5qCPf");
parcelRequire("9t2TR");
parcelRequire("6x2NK");
parcelRequire("1X7iO");
parcelRequire("bKaho");
parcelRequire("1mNbp");
parcelRequire("dNcSW");
parcelRequire("8m2Pj");
parcelRequire("549n2");
parcelRequire("hvBC6");
parcelRequire("5wzrh");
parcelRequire("diqsM");
parcelRequire("iQ4e6");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Symbol;

});
parcelRegister("isTuv", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $77TPA = parcelRequire("77TPA");

var $5zZFa = parcelRequire("5zZFa");

var $1WYwK = parcelRequire("1WYwK");

var $iJNxK = parcelRequire("iJNxK");

var $6ocdr = parcelRequire("6ocdr");

var $c8xJJ = parcelRequire("c8xJJ");

var $b1Dzg = parcelRequire("b1Dzg");

var $cU9IX = parcelRequire("cU9IX");

var $PdD5d = parcelRequire("PdD5d");

var $fq7H3 = parcelRequire("fq7H3");

var $a9ory = parcelRequire("a9ory");
var $d715e2e4c4a00cf5$var$IS_CONCAT_SPREADABLE = $fq7H3("isConcatSpreadable");
// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var $d715e2e4c4a00cf5$var$IS_CONCAT_SPREADABLE_SUPPORT = $a9ory >= 51 || !$77TPA(function() {
    var array = [];
    array[$d715e2e4c4a00cf5$var$IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
});
var $d715e2e4c4a00cf5$var$isConcatSpreadable = function(O) {
    if (!$1WYwK(O)) return false;
    var spreadable = O[$d715e2e4c4a00cf5$var$IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : $5zZFa(O);
};
var $d715e2e4c4a00cf5$var$FORCED = !$d715e2e4c4a00cf5$var$IS_CONCAT_SPREADABLE_SUPPORT || !$PdD5d("concat");
// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$ggcsv({
    target: "Array",
    proto: true,
    arity: 1,
    forced: $d715e2e4c4a00cf5$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
        var O = $iJNxK(this);
        var A = $cU9IX(O, 0);
        var n = 0;
        var i, k, length, len, E;
        for(i = -1, length = arguments.length; i < length; i++){
            E = i === -1 ? O : arguments[i];
            if ($d715e2e4c4a00cf5$var$isConcatSpreadable(E)) {
                len = $6ocdr(E);
                $c8xJJ(n + len);
                for(k = 0; k < len; k++, n++)if (k in E) $b1Dzg(A, n, E[k]);
            } else {
                $c8xJJ(n + 1);
                $b1Dzg(A, n++, E);
            }
        }
        A.length = n;
        return A;
    }
});

});
parcelRegister("c8xJJ", function(module, exports) {
"use strict";
var $8d6066c31eba0f0a$var$$TypeError = TypeError;
var $8d6066c31eba0f0a$var$MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
module.exports = function(it) {
    if (it > $8d6066c31eba0f0a$var$MAX_SAFE_INTEGER) throw $8d6066c31eba0f0a$var$$TypeError("Maximum allowed index exceeded");
    return it;
};

});


parcelRegister("ko4d9", function(module, exports) {
"use strict";
parcelRequire("fX6Qo");
parcelRequire("6nSVj");
parcelRequire("a7I9i");
parcelRequire("kvPdS");
parcelRequire("jKKLo");

});
parcelRegister("fX6Qo", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $9l3PP = parcelRequire("9l3PP");

var $aELZY = parcelRequire("aELZY");

var $f518o = parcelRequire("f518o");

var $7phdw = parcelRequire("7phdw");

var $jeZ4p = parcelRequire("jeZ4p");

var $e1lwM = parcelRequire("e1lwM");

var $77TPA = parcelRequire("77TPA");

var $heVlo = parcelRequire("heVlo");

var $8hsAO = parcelRequire("8hsAO");

var $l3LMJ = parcelRequire("l3LMJ");

var $bYkAs = parcelRequire("bYkAs");

var $eBk19 = parcelRequire("eBk19");

var $l2Ut5 = parcelRequire("l2Ut5");

var $8c6fn = parcelRequire("8c6fn");

var $fhVPP = parcelRequire("fhVPP");

var $3Ut0t = parcelRequire("3Ut0t");

var $9hUhV = parcelRequire("9hUhV");

var $cMezS = parcelRequire("cMezS");

var $4BK7o = parcelRequire("4BK7o");

var $fTFId = parcelRequire("fTFId");

var $diq7r = parcelRequire("diq7r");

var $a965u = parcelRequire("a965u");

var $d5uYy = parcelRequire("d5uYy");

var $kY5Tb = parcelRequire("kY5Tb");

var $7kUwJ = parcelRequire("7kUwJ");

var $3hwUC = parcelRequire("3hwUC");

var $aUKPz = parcelRequire("aUKPz");

var $lKGD2 = parcelRequire("lKGD2");

var $kuKGb = parcelRequire("kuKGb");

var $fq7H3 = parcelRequire("fq7H3");

var $knUX7 = parcelRequire("knUX7");

var $cHa91 = parcelRequire("cHa91");

var $bPU03 = parcelRequire("bPU03");

var $dheYH = parcelRequire("dheYH");

var $fmQ29 = parcelRequire("fmQ29");

var $igsV9 = parcelRequire("igsV9");
var $b9d1acc5cb3a14b5$require$$forEach = $igsV9.forEach;
var $b9d1acc5cb3a14b5$var$HIDDEN = $aUKPz("hidden");
var $b9d1acc5cb3a14b5$var$SYMBOL = "Symbol";
var $b9d1acc5cb3a14b5$var$PROTOTYPE = "prototype";
var $b9d1acc5cb3a14b5$var$setInternalState = $fmQ29.set;
var $b9d1acc5cb3a14b5$var$getInternalState = $fmQ29.getterFor($b9d1acc5cb3a14b5$var$SYMBOL);
var $b9d1acc5cb3a14b5$var$ObjectPrototype = Object[$b9d1acc5cb3a14b5$var$PROTOTYPE];
var $b9d1acc5cb3a14b5$var$$Symbol = $9l3PP.Symbol;
var $b9d1acc5cb3a14b5$var$SymbolPrototype = $b9d1acc5cb3a14b5$var$$Symbol && $b9d1acc5cb3a14b5$var$$Symbol[$b9d1acc5cb3a14b5$var$PROTOTYPE];
var $b9d1acc5cb3a14b5$var$RangeError = $9l3PP.RangeError;
var $b9d1acc5cb3a14b5$var$TypeError = $9l3PP.TypeError;
var $b9d1acc5cb3a14b5$var$QObject = $9l3PP.QObject;
var $b9d1acc5cb3a14b5$var$nativeGetOwnPropertyDescriptor = $fTFId.f;
var $b9d1acc5cb3a14b5$var$nativeDefineProperty = $diq7r.f;
var $b9d1acc5cb3a14b5$var$nativeGetOwnPropertyNames = $cMezS.f;
var $b9d1acc5cb3a14b5$var$nativePropertyIsEnumerable = $d5uYy.f;
var $b9d1acc5cb3a14b5$var$push = $f518o([].push);
var $b9d1acc5cb3a14b5$var$AllSymbols = $3hwUC("symbols");
var $b9d1acc5cb3a14b5$var$ObjectPrototypeSymbols = $3hwUC("op-symbols");
var $b9d1acc5cb3a14b5$var$WellKnownSymbolsStore = $3hwUC("wks");
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $b9d1acc5cb3a14b5$var$USE_SETTER = !$b9d1acc5cb3a14b5$var$QObject || !$b9d1acc5cb3a14b5$var$QObject[$b9d1acc5cb3a14b5$var$PROTOTYPE] || !$b9d1acc5cb3a14b5$var$QObject[$b9d1acc5cb3a14b5$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $b9d1acc5cb3a14b5$var$fallbackDefineProperty = function(O, P, Attributes) {
    var ObjectPrototypeDescriptor = $b9d1acc5cb3a14b5$var$nativeGetOwnPropertyDescriptor($b9d1acc5cb3a14b5$var$ObjectPrototype, P);
    if (ObjectPrototypeDescriptor) delete $b9d1acc5cb3a14b5$var$ObjectPrototype[P];
    $b9d1acc5cb3a14b5$var$nativeDefineProperty(O, P, Attributes);
    if (ObjectPrototypeDescriptor && O !== $b9d1acc5cb3a14b5$var$ObjectPrototype) $b9d1acc5cb3a14b5$var$nativeDefineProperty($b9d1acc5cb3a14b5$var$ObjectPrototype, P, ObjectPrototypeDescriptor);
};
var $b9d1acc5cb3a14b5$var$setSymbolDescriptor = $jeZ4p && $77TPA(function() {
    return $fhVPP($b9d1acc5cb3a14b5$var$nativeDefineProperty({}, "a", {
        get: function() {
            return $b9d1acc5cb3a14b5$var$nativeDefineProperty(this, "a", {
                value: 7
            }).a;
        }
    })).a !== 7;
}) ? $b9d1acc5cb3a14b5$var$fallbackDefineProperty : $b9d1acc5cb3a14b5$var$nativeDefineProperty;
var $b9d1acc5cb3a14b5$var$wrap = function(tag, description) {
    var symbol = $b9d1acc5cb3a14b5$var$AllSymbols[tag] = $fhVPP($b9d1acc5cb3a14b5$var$SymbolPrototype);
    $b9d1acc5cb3a14b5$var$setInternalState(symbol, {
        type: $b9d1acc5cb3a14b5$var$SYMBOL,
        tag: tag,
        description: description
    });
    if (!$jeZ4p) symbol.description = description;
    return symbol;
};
var $b9d1acc5cb3a14b5$var$$defineProperty = function defineProperty(O, P, Attributes) {
    if (O === $b9d1acc5cb3a14b5$var$ObjectPrototype) $b9d1acc5cb3a14b5$var$$defineProperty($b9d1acc5cb3a14b5$var$ObjectPrototypeSymbols, P, Attributes);
    $l3LMJ(O);
    var key = $eBk19(P);
    $l3LMJ(Attributes);
    if ($heVlo($b9d1acc5cb3a14b5$var$AllSymbols, key)) {
        if (!Attributes.enumerable) {
            if (!$heVlo(O, $b9d1acc5cb3a14b5$var$HIDDEN)) $b9d1acc5cb3a14b5$var$nativeDefineProperty(O, $b9d1acc5cb3a14b5$var$HIDDEN, $8c6fn(1, $fhVPP(null)));
            O[$b9d1acc5cb3a14b5$var$HIDDEN][key] = true;
        } else {
            if ($heVlo(O, $b9d1acc5cb3a14b5$var$HIDDEN) && O[$b9d1acc5cb3a14b5$var$HIDDEN][key]) O[$b9d1acc5cb3a14b5$var$HIDDEN][key] = false;
            Attributes = $fhVPP(Attributes, {
                enumerable: $8c6fn(0, false)
            });
        }
        return $b9d1acc5cb3a14b5$var$setSymbolDescriptor(O, key, Attributes);
    }
    return $b9d1acc5cb3a14b5$var$nativeDefineProperty(O, key, Attributes);
};
var $b9d1acc5cb3a14b5$var$$defineProperties = function defineProperties(O, Properties) {
    $l3LMJ(O);
    var properties = $bYkAs(Properties);
    var keys = $3Ut0t(properties).concat($b9d1acc5cb3a14b5$var$$getOwnPropertySymbols(properties));
    $b9d1acc5cb3a14b5$require$$forEach(keys, function(key) {
        if (!$jeZ4p || $aELZY($b9d1acc5cb3a14b5$var$$propertyIsEnumerable, properties, key)) $b9d1acc5cb3a14b5$var$$defineProperty(O, key, properties[key]);
    });
    return O;
};
var $b9d1acc5cb3a14b5$var$$create = function create(O, Properties) {
    return Properties === undefined ? $fhVPP(O) : $b9d1acc5cb3a14b5$var$$defineProperties($fhVPP(O), Properties);
};
var $b9d1acc5cb3a14b5$var$$propertyIsEnumerable = function propertyIsEnumerable(V) {
    var P = $eBk19(V);
    var enumerable = $aELZY($b9d1acc5cb3a14b5$var$nativePropertyIsEnumerable, this, P);
    if (this === $b9d1acc5cb3a14b5$var$ObjectPrototype && $heVlo($b9d1acc5cb3a14b5$var$AllSymbols, P) && !$heVlo($b9d1acc5cb3a14b5$var$ObjectPrototypeSymbols, P)) return false;
    return enumerable || !$heVlo(this, P) || !$heVlo($b9d1acc5cb3a14b5$var$AllSymbols, P) || $heVlo(this, $b9d1acc5cb3a14b5$var$HIDDEN) && this[$b9d1acc5cb3a14b5$var$HIDDEN][P] ? enumerable : true;
};
var $b9d1acc5cb3a14b5$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = $bYkAs(O);
    var key = $eBk19(P);
    if (it === $b9d1acc5cb3a14b5$var$ObjectPrototype && $heVlo($b9d1acc5cb3a14b5$var$AllSymbols, key) && !$heVlo($b9d1acc5cb3a14b5$var$ObjectPrototypeSymbols, key)) return;
    var descriptor = $b9d1acc5cb3a14b5$var$nativeGetOwnPropertyDescriptor(it, key);
    if (descriptor && $heVlo($b9d1acc5cb3a14b5$var$AllSymbols, key) && !($heVlo(it, $b9d1acc5cb3a14b5$var$HIDDEN) && it[$b9d1acc5cb3a14b5$var$HIDDEN][key])) descriptor.enumerable = true;
    return descriptor;
};
var $b9d1acc5cb3a14b5$var$$getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = $b9d1acc5cb3a14b5$var$nativeGetOwnPropertyNames($bYkAs(O));
    var result = [];
    $b9d1acc5cb3a14b5$require$$forEach(names, function(key) {
        if (!$heVlo($b9d1acc5cb3a14b5$var$AllSymbols, key) && !$heVlo($lKGD2, key)) $b9d1acc5cb3a14b5$var$push(result, key);
    });
    return result;
};
var $b9d1acc5cb3a14b5$var$$getOwnPropertySymbols = function(O) {
    var IS_OBJECT_PROTOTYPE = O === $b9d1acc5cb3a14b5$var$ObjectPrototype;
    var names = $b9d1acc5cb3a14b5$var$nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? $b9d1acc5cb3a14b5$var$ObjectPrototypeSymbols : $bYkAs(O));
    var result = [];
    $b9d1acc5cb3a14b5$require$$forEach(names, function(key) {
        if ($heVlo($b9d1acc5cb3a14b5$var$AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || $heVlo($b9d1acc5cb3a14b5$var$ObjectPrototype, key))) $b9d1acc5cb3a14b5$var$push(result, $b9d1acc5cb3a14b5$var$AllSymbols[key]);
    });
    return result;
};
// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!$e1lwM) {
    $b9d1acc5cb3a14b5$var$$Symbol = function Symbol() {
        if ($8hsAO($b9d1acc5cb3a14b5$var$SymbolPrototype, this)) throw new $b9d1acc5cb3a14b5$var$TypeError("Symbol is not a constructor");
        var description = !arguments.length || arguments[0] === undefined ? undefined : $l2Ut5(arguments[0]);
        var tag = $kuKGb(description);
        var setter = function(value) {
            var $this = this === undefined ? $9l3PP : this;
            if ($this === $b9d1acc5cb3a14b5$var$ObjectPrototype) $aELZY(setter, $b9d1acc5cb3a14b5$var$ObjectPrototypeSymbols, value);
            if ($heVlo($this, $b9d1acc5cb3a14b5$var$HIDDEN) && $heVlo($this[$b9d1acc5cb3a14b5$var$HIDDEN], tag)) $this[$b9d1acc5cb3a14b5$var$HIDDEN][tag] = false;
            var descriptor = $8c6fn(1, value);
            try {
                $b9d1acc5cb3a14b5$var$setSymbolDescriptor($this, tag, descriptor);
            } catch (error) {
                if (!(error instanceof $b9d1acc5cb3a14b5$var$RangeError)) throw error;
                $b9d1acc5cb3a14b5$var$fallbackDefineProperty($this, tag, descriptor);
            }
        };
        if ($jeZ4p && $b9d1acc5cb3a14b5$var$USE_SETTER) $b9d1acc5cb3a14b5$var$setSymbolDescriptor($b9d1acc5cb3a14b5$var$ObjectPrototype, tag, {
            configurable: true,
            set: setter
        });
        return $b9d1acc5cb3a14b5$var$wrap(tag, description);
    };
    $b9d1acc5cb3a14b5$var$SymbolPrototype = $b9d1acc5cb3a14b5$var$$Symbol[$b9d1acc5cb3a14b5$var$PROTOTYPE];
    $kY5Tb($b9d1acc5cb3a14b5$var$SymbolPrototype, "toString", function toString() {
        return $b9d1acc5cb3a14b5$var$getInternalState(this).tag;
    });
    $kY5Tb($b9d1acc5cb3a14b5$var$$Symbol, "withoutSetter", function(description) {
        return $b9d1acc5cb3a14b5$var$wrap($kuKGb(description), description);
    });
    $d5uYy.f = $b9d1acc5cb3a14b5$var$$propertyIsEnumerable;
    $diq7r.f = $b9d1acc5cb3a14b5$var$$defineProperty;
    $a965u.f = $b9d1acc5cb3a14b5$var$$defineProperties;
    $fTFId.f = $b9d1acc5cb3a14b5$var$$getOwnPropertyDescriptor;
    $9hUhV.f = $cMezS.f = $b9d1acc5cb3a14b5$var$$getOwnPropertyNames;
    $4BK7o.f = $b9d1acc5cb3a14b5$var$$getOwnPropertySymbols;
    $knUX7.f = function(name) {
        return $b9d1acc5cb3a14b5$var$wrap($fq7H3(name), name);
    };
    if ($jeZ4p) {
        // https://github.com/tc39/proposal-Symbol-description
        $7kUwJ($b9d1acc5cb3a14b5$var$SymbolPrototype, "description", {
            configurable: true,
            get: function description() {
                return $b9d1acc5cb3a14b5$var$getInternalState(this).description;
            }
        });
        if (!$7phdw) $kY5Tb($b9d1acc5cb3a14b5$var$ObjectPrototype, "propertyIsEnumerable", $b9d1acc5cb3a14b5$var$$propertyIsEnumerable, {
            unsafe: true
        });
    }
}
$ggcsv({
    global: true,
    constructor: true,
    wrap: true,
    forced: !$e1lwM,
    sham: !$e1lwM
}, {
    Symbol: $b9d1acc5cb3a14b5$var$$Symbol
});
$b9d1acc5cb3a14b5$require$$forEach($3Ut0t($b9d1acc5cb3a14b5$var$WellKnownSymbolsStore), function(name) {
    $cHa91(name);
});
$ggcsv({
    target: $b9d1acc5cb3a14b5$var$SYMBOL,
    stat: true,
    forced: !$e1lwM
}, {
    useSetter: function() {
        $b9d1acc5cb3a14b5$var$USE_SETTER = true;
    },
    useSimple: function() {
        $b9d1acc5cb3a14b5$var$USE_SETTER = false;
    }
});
$ggcsv({
    target: "Object",
    stat: true,
    forced: !$e1lwM,
    sham: !$jeZ4p
}, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $b9d1acc5cb3a14b5$var$$create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $b9d1acc5cb3a14b5$var$$defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $b9d1acc5cb3a14b5$var$$defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $b9d1acc5cb3a14b5$var$$getOwnPropertyDescriptor
});
$ggcsv({
    target: "Object",
    stat: true,
    forced: !$e1lwM
}, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $b9d1acc5cb3a14b5$var$$getOwnPropertyNames
});
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$bPU03();
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$dheYH($b9d1acc5cb3a14b5$var$$Symbol, $b9d1acc5cb3a14b5$var$SYMBOL);
$lKGD2[$b9d1acc5cb3a14b5$var$HIDDEN] = true;

});
parcelRegister("knUX7", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $ed72223cb1d16ce4$export$2d1720544b23b823; }, function (v) { return $ed72223cb1d16ce4$export$2d1720544b23b823 = v; });
var $ed72223cb1d16ce4$export$2d1720544b23b823;
"use strict";

var $fq7H3 = parcelRequire("fq7H3");
$ed72223cb1d16ce4$export$2d1720544b23b823 = $fq7H3;

});

parcelRegister("cHa91", function(module, exports) {
"use strict";

var $ly30u = parcelRequire("ly30u");

var $heVlo = parcelRequire("heVlo");

var $knUX7 = parcelRequire("knUX7");

var $diq7r = parcelRequire("diq7r");
var $93e15eaad2755601$require$defineProperty = $diq7r.f;
module.exports = function(NAME) {
    var Symbol = $ly30u.Symbol || ($ly30u.Symbol = {});
    if (!$heVlo(Symbol, NAME)) $93e15eaad2755601$require$defineProperty(Symbol, NAME, {
        value: $knUX7.f(NAME)
    });
};

});

parcelRegister("bPU03", function(module, exports) {
"use strict";

var $aELZY = parcelRequire("aELZY");

var $5Pobw = parcelRequire("5Pobw");

var $fq7H3 = parcelRequire("fq7H3");

var $kY5Tb = parcelRequire("kY5Tb");
module.exports = function() {
    var Symbol = $5Pobw("Symbol");
    var SymbolPrototype = Symbol && Symbol.prototype;
    var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
    var TO_PRIMITIVE = $fq7H3("toPrimitive");
    if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    $kY5Tb(SymbolPrototype, TO_PRIMITIVE, function(hint) {
        return $aELZY(valueOf, this);
    }, {
        arity: 1
    });
};

});


parcelRegister("6nSVj", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $5Pobw = parcelRequire("5Pobw");

var $heVlo = parcelRequire("heVlo");

var $l2Ut5 = parcelRequire("l2Ut5");

var $3hwUC = parcelRequire("3hwUC");

var $lCnHq = parcelRequire("lCnHq");
var $4a5f7eb962eeacc9$var$StringToSymbolRegistry = $3hwUC("string-to-symbol-registry");
var $4a5f7eb962eeacc9$var$SymbolToStringRegistry = $3hwUC("symbol-to-string-registry");
// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$ggcsv({
    target: "Symbol",
    stat: true,
    forced: !$lCnHq
}, {
    "for": function(key) {
        var string = $l2Ut5(key);
        if ($heVlo($4a5f7eb962eeacc9$var$StringToSymbolRegistry, string)) return $4a5f7eb962eeacc9$var$StringToSymbolRegistry[string];
        var symbol = $5Pobw("Symbol")(string);
        $4a5f7eb962eeacc9$var$StringToSymbolRegistry[string] = symbol;
        $4a5f7eb962eeacc9$var$SymbolToStringRegistry[symbol] = string;
        return symbol;
    }
});

});
parcelRegister("lCnHq", function(module, exports) {
"use strict";

var $e1lwM = parcelRequire("e1lwM");
/* eslint-disable es/no-symbol -- safe */ module.exports = $e1lwM && !!Symbol["for"] && !!Symbol.keyFor;

});


parcelRegister("a7I9i", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $heVlo = parcelRequire("heVlo");

var $jpeSb = parcelRequire("jpeSb");

var $k9gzN = parcelRequire("k9gzN");

var $3hwUC = parcelRequire("3hwUC");

var $lCnHq = parcelRequire("lCnHq");
var $75eccde7a410c69b$var$SymbolToStringRegistry = $3hwUC("symbol-to-string-registry");
// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$ggcsv({
    target: "Symbol",
    stat: true,
    forced: !$lCnHq
}, {
    keyFor: function keyFor(sym) {
        if (!$jpeSb(sym)) throw new TypeError($k9gzN(sym) + " is not a symbol");
        if ($heVlo($75eccde7a410c69b$var$SymbolToStringRegistry, sym)) return $75eccde7a410c69b$var$SymbolToStringRegistry[sym];
    }
});

});

parcelRegister("kvPdS", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $5Pobw = parcelRequire("5Pobw");

var $2JOsI = parcelRequire("2JOsI");

var $aELZY = parcelRequire("aELZY");

var $f518o = parcelRequire("f518o");

var $77TPA = parcelRequire("77TPA");

var $e6Rz5 = parcelRequire("e6Rz5");

var $jpeSb = parcelRequire("jpeSb");

var $hF40G = parcelRequire("hF40G");

var $7cIyi = parcelRequire("7cIyi");

var $e1lwM = parcelRequire("e1lwM");
var $eeee6fa84fef6c89$var$$String = String;
var $eeee6fa84fef6c89$var$$stringify = $5Pobw("JSON", "stringify");
var $eeee6fa84fef6c89$var$exec = $f518o(/./.exec);
var $eeee6fa84fef6c89$var$charAt = $f518o("".charAt);
var $eeee6fa84fef6c89$var$charCodeAt = $f518o("".charCodeAt);
var $eeee6fa84fef6c89$var$replace = $f518o("".replace);
var $eeee6fa84fef6c89$var$numberToString = $f518o(1.0.toString);
var $eeee6fa84fef6c89$var$tester = /[\uD800-\uDFFF]/g;
var $eeee6fa84fef6c89$var$low = /^[\uD800-\uDBFF]$/;
var $eeee6fa84fef6c89$var$hi = /^[\uDC00-\uDFFF]$/;
var $eeee6fa84fef6c89$var$WRONG_SYMBOLS_CONVERSION = !$e1lwM || $77TPA(function() {
    var symbol = $5Pobw("Symbol")("stringify detection");
    // MS Edge converts symbol values to JSON as {}
    return $eeee6fa84fef6c89$var$$stringify([
        symbol
    ]) !== "[null]" || $eeee6fa84fef6c89$var$$stringify({
        a: symbol
    }) !== "{}" || $eeee6fa84fef6c89$var$$stringify(Object(symbol)) !== "{}";
});
// https://github.com/tc39/proposal-well-formed-stringify
var $eeee6fa84fef6c89$var$ILL_FORMED_UNICODE = $77TPA(function() {
    return $eeee6fa84fef6c89$var$$stringify("\uDF06\uD834") !== '"\udf06\ud834"' || $eeee6fa84fef6c89$var$$stringify("\uDEAD") !== '"\udead"';
});
var $eeee6fa84fef6c89$var$stringifyWithSymbolsFix = function(it, replacer) {
    var args = $hF40G(arguments);
    var $replacer = $7cIyi(replacer);
    if (!$e6Rz5($replacer) && (it === undefined || $jpeSb(it))) return; // IE8 returns string on undefined
    args[1] = function(key, value) {
        // some old implementations (like WebKit) could pass numbers as keys
        if ($e6Rz5($replacer)) value = $aELZY($replacer, this, $eeee6fa84fef6c89$var$$String(key), value);
        if (!$jpeSb(value)) return value;
    };
    return $2JOsI($eeee6fa84fef6c89$var$$stringify, null, args);
};
var $eeee6fa84fef6c89$var$fixIllFormed = function(match, offset, string) {
    var prev = $eeee6fa84fef6c89$var$charAt(string, offset - 1);
    var next = $eeee6fa84fef6c89$var$charAt(string, offset + 1);
    if ($eeee6fa84fef6c89$var$exec($eeee6fa84fef6c89$var$low, match) && !$eeee6fa84fef6c89$var$exec($eeee6fa84fef6c89$var$hi, next) || $eeee6fa84fef6c89$var$exec($eeee6fa84fef6c89$var$hi, match) && !$eeee6fa84fef6c89$var$exec($eeee6fa84fef6c89$var$low, prev)) return "\\u" + $eeee6fa84fef6c89$var$numberToString($eeee6fa84fef6c89$var$charCodeAt(match, 0), 16);
    return match;
};
if ($eeee6fa84fef6c89$var$$stringify) // `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
$ggcsv({
    target: "JSON",
    stat: true,
    arity: 3,
    forced: $eeee6fa84fef6c89$var$WRONG_SYMBOLS_CONVERSION || $eeee6fa84fef6c89$var$ILL_FORMED_UNICODE
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
        var args = $hF40G(arguments);
        var result = $2JOsI($eeee6fa84fef6c89$var$WRONG_SYMBOLS_CONVERSION ? $eeee6fa84fef6c89$var$stringifyWithSymbolsFix : $eeee6fa84fef6c89$var$$stringify, null, args);
        return $eeee6fa84fef6c89$var$ILL_FORMED_UNICODE && typeof result == "string" ? $eeee6fa84fef6c89$var$replace(result, $eeee6fa84fef6c89$var$tester, $eeee6fa84fef6c89$var$fixIllFormed) : result;
    }
});

});
parcelRegister("7cIyi", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");

var $5zZFa = parcelRequire("5zZFa");

var $e6Rz5 = parcelRequire("e6Rz5");

var $bTsfg = parcelRequire("bTsfg");

var $l2Ut5 = parcelRequire("l2Ut5");
var $53ec368500e5db3b$var$push = $f518o([].push);
module.exports = function(replacer) {
    if ($e6Rz5(replacer)) return replacer;
    if (!$5zZFa(replacer)) return;
    var rawLength = replacer.length;
    var keys = [];
    for(var i = 0; i < rawLength; i++){
        var element = replacer[i];
        if (typeof element == "string") $53ec368500e5db3b$var$push(keys, element);
        else if (typeof element == "number" || $bTsfg(element) === "Number" || $bTsfg(element) === "String") $53ec368500e5db3b$var$push(keys, $l2Ut5(element));
    }
    var keysLength = keys.length;
    var root = true;
    return function(key, value) {
        if (root) {
            root = false;
            return value;
        }
        if ($5zZFa(this)) return value;
        for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
    };
};

});


parcelRegister("jKKLo", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $e1lwM = parcelRequire("e1lwM");

var $77TPA = parcelRequire("77TPA");

var $4BK7o = parcelRequire("4BK7o");

var $iJNxK = parcelRequire("iJNxK");
// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $e616966c6146c7ae$var$FORCED = !$e1lwM || $77TPA(function() {
    $4BK7o.f(1);
});
// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$ggcsv({
    target: "Object",
    stat: true,
    forced: $e616966c6146c7ae$var$FORCED
}, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        var $getOwnPropertySymbols = $4BK7o.f;
        return $getOwnPropertySymbols ? $getOwnPropertySymbols($iJNxK(it)) : [];
    }
});

});


parcelRegister("8uxl4", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
$cHa91("asyncIterator");

});

parcelRegister("fqhMK", function(module, exports) {
// empty

});

parcelRegister("8awQv", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
$cHa91("hasInstance");

});

parcelRegister("5w9fi", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
$cHa91("isConcatSpreadable");

});

parcelRegister("5qCPf", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
$cHa91("iterator");

});

parcelRegister("9t2TR", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
$cHa91("match");

});

parcelRegister("6x2NK", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
$cHa91("matchAll");

});

parcelRegister("1X7iO", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
$cHa91("replace");

});

parcelRegister("bKaho", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
$cHa91("search");

});

parcelRegister("1mNbp", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
$cHa91("species");

});

parcelRegister("dNcSW", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
$cHa91("split");

});

parcelRegister("8m2Pj", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");

var $bPU03 = parcelRequire("bPU03");
// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
$cHa91("toPrimitive");
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$bPU03();

});

parcelRegister("549n2", function(module, exports) {
"use strict";

var $5Pobw = parcelRequire("5Pobw");

var $cHa91 = parcelRequire("cHa91");

var $dheYH = parcelRequire("dheYH");
// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
$cHa91("toStringTag");
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$dheYH($5Pobw("Symbol"), "Symbol");

});

parcelRegister("hvBC6", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
$cHa91("unscopables");

});

parcelRegister("5wzrh", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");

var $dheYH = parcelRequire("dheYH");
// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
$dheYH($9l3PP.JSON, "JSON", true);

});

parcelRegister("diqsM", function(module, exports) {
// empty

});

parcelRegister("iQ4e6", function(module, exports) {
// empty

});



parcelRegister("jgM91", function(module, exports) {
"use strict";

var $fq7H3 = parcelRequire("fq7H3");

var $diq7r = parcelRequire("diq7r");
var $e074db730ad1cf64$require$defineProperty = $diq7r.f;
var $e074db730ad1cf64$var$METADATA = $fq7H3("metadata");
var $e074db730ad1cf64$var$FunctionPrototype = Function.prototype;
// Function.prototype[@@metadata]
// https://github.com/tc39/proposal-decorator-metadata
if ($e074db730ad1cf64$var$FunctionPrototype[$e074db730ad1cf64$var$METADATA] === undefined) $e074db730ad1cf64$require$defineProperty($e074db730ad1cf64$var$FunctionPrototype, $e074db730ad1cf64$var$METADATA, {
    value: null
});

});

parcelRegister("8QfZZ", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-async-explicit-resource-management
$cHa91("asyncDispose");

});

parcelRegister("il9RF", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$cHa91("dispose");

});

parcelRegister("ec6Rp", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
$cHa91("metadata");

});


parcelRegister("h8IOe", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $aI91n = parcelRequire("aI91n");
// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$ggcsv({
    target: "Symbol",
    stat: true
}, {
    isRegisteredSymbol: $aI91n
});

});
parcelRegister("aI91n", function(module, exports) {
"use strict";

var $5Pobw = parcelRequire("5Pobw");

var $f518o = parcelRequire("f518o");
var $7cc502dc9bbe7b43$var$Symbol = $5Pobw("Symbol");
var $7cc502dc9bbe7b43$var$keyFor = $7cc502dc9bbe7b43$var$Symbol.keyFor;
var $7cc502dc9bbe7b43$var$thisSymbolValue = $f518o($7cc502dc9bbe7b43$var$Symbol.prototype.valueOf);
// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
module.exports = $7cc502dc9bbe7b43$var$Symbol.isRegisteredSymbol || function isRegisteredSymbol(value) {
    try {
        return $7cc502dc9bbe7b43$var$keyFor($7cc502dc9bbe7b43$var$thisSymbolValue(value)) !== undefined;
    } catch (error) {
        return false;
    }
};

});


parcelRegister("5oSUb", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $f31wA = parcelRequire("f31wA");
// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$ggcsv({
    target: "Symbol",
    stat: true,
    forced: true
}, {
    isWellKnownSymbol: $f31wA
});

});
parcelRegister("f31wA", function(module, exports) {
"use strict";

var $3hwUC = parcelRequire("3hwUC");

var $5Pobw = parcelRequire("5Pobw");

var $f518o = parcelRequire("f518o");

var $jpeSb = parcelRequire("jpeSb");

var $fq7H3 = parcelRequire("fq7H3");
var $af485198f762da41$var$Symbol = $5Pobw("Symbol");
var $af485198f762da41$var$$isWellKnownSymbol = $af485198f762da41$var$Symbol.isWellKnownSymbol;
var $af485198f762da41$var$getOwnPropertyNames = $5Pobw("Object", "getOwnPropertyNames");
var $af485198f762da41$var$thisSymbolValue = $f518o($af485198f762da41$var$Symbol.prototype.valueOf);
var $af485198f762da41$var$WellKnownSymbolsStore = $3hwUC("wks");
for(var $af485198f762da41$var$i = 0, $af485198f762da41$var$symbolKeys = $af485198f762da41$var$getOwnPropertyNames($af485198f762da41$var$Symbol), $af485198f762da41$var$symbolKeysLength = $af485198f762da41$var$symbolKeys.length; $af485198f762da41$var$i < $af485198f762da41$var$symbolKeysLength; $af485198f762da41$var$i++)// some old engines throws on access to some keys like `arguments` or `caller`
try {
    var $af485198f762da41$var$symbolKey = $af485198f762da41$var$symbolKeys[$af485198f762da41$var$i];
    if ($jpeSb($af485198f762da41$var$Symbol[$af485198f762da41$var$symbolKey])) $fq7H3($af485198f762da41$var$symbolKey);
} catch (error) {}
// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
module.exports = function isWellKnownSymbol(value) {
    if ($af485198f762da41$var$$isWellKnownSymbol && $af485198f762da41$var$$isWellKnownSymbol(value)) return true;
    try {
        var symbol = $af485198f762da41$var$thisSymbolValue(value);
        for(var j = 0, keys = $af485198f762da41$var$getOwnPropertyNames($af485198f762da41$var$WellKnownSymbolsStore), keysLength = keys.length; j < keysLength; j++){
            // eslint-disable-next-line eqeqeq -- polyfilled symbols case
            if ($af485198f762da41$var$WellKnownSymbolsStore[keys[j]] == symbol) return true;
        }
    } catch (error) {}
    return false;
};

});


parcelRegister("gy6wN", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.customMatcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$cHa91("customMatcher");

});

parcelRegister("i3G8Z", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
$cHa91("observable");

});

parcelRegister("fVjjW", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $aI91n = parcelRequire("aI91n");
// `Symbol.isRegistered` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$ggcsv({
    target: "Symbol",
    stat: true,
    name: "isRegisteredSymbol"
}, {
    isRegistered: $aI91n
});

});

parcelRegister("6Vj7u", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $f31wA = parcelRequire("f31wA");
// `Symbol.isWellKnown` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$ggcsv({
    target: "Symbol",
    stat: true,
    name: "isWellKnownSymbol",
    forced: true
}, {
    isWellKnown: $f31wA
});

});

parcelRegister("1kp86", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$cHa91("matcher");

});

parcelRegister("kSb0Q", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.metadataKey` well-known symbol
// https://github.com/tc39/proposal-decorator-metadata
$cHa91("metadataKey");

});

parcelRegister("4IO6j", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$cHa91("patternMatch");

});

parcelRegister("9RLNS", function(module, exports) {
"use strict";

var $cHa91 = parcelRequire("cHa91");
$cHa91("replaceAll");

});



parcelRegister("g71bB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4zyOz"));

});
parcelRegister("4zyOz", function(module, exports) {
"use strict";

var $hk00C = parcelRequire("hk00C");
module.exports = $hk00C;

});
parcelRegister("hk00C", function(module, exports) {
"use strict";

var $gjewt = parcelRequire("gjewt");
module.exports = $gjewt;

});
parcelRegister("gjewt", function(module, exports) {
"use strict";

var $leuHo = parcelRequire("leuHo");
parcelRequire("jXhxH");
module.exports = $leuHo;

});
parcelRegister("leuHo", function(module, exports) {
"use strict";
parcelRequire("5xrGR");
parcelRequire("iYyco");
parcelRequire("ja2zQ");
parcelRequire("5qCPf");

var $knUX7 = parcelRequire("knUX7");
module.exports = $knUX7.f("iterator");

});






parcelRegister("xKtYn", function(module, exports) {

var $ahuoO = parcelRequire("ahuoO");

var $6iqUa = parcelRequire("6iqUa");
var $0657239ffd4e8d29$var$_typeof = $6iqUa.default;
function $0657239ffd4e8d29$var$toPrimitive(t, r) {
    if ("object" != $0657239ffd4e8d29$var$_typeof(t) || !t) return t;
    var e = t[$ahuoO];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0657239ffd4e8d29$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $0657239ffd4e8d29$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ahuoO", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4dAHt"));

});
parcelRegister("4dAHt", function(module, exports) {
"use strict";

var $cNi4z = parcelRequire("cNi4z");
module.exports = $cNi4z;

});
parcelRegister("cNi4z", function(module, exports) {
"use strict";

var $hlFio = parcelRequire("hlFio");
module.exports = $hlFio;

});
parcelRegister("hlFio", function(module, exports) {
"use strict";

var $biyW3 = parcelRequire("biyW3");
module.exports = $biyW3;

});
parcelRegister("biyW3", function(module, exports) {
"use strict";
parcelRequire("b6S9o");
parcelRequire("8m2Pj");

var $knUX7 = parcelRequire("knUX7");
module.exports = $knUX7.f("toPrimitive");

});
parcelRegister("b6S9o", function(module, exports) {
// empty

});









parcelRegister("6ilM0", function(module, exports) {
"use strict";


var $iHLHC = parcelRequire("iHLHC");
(parcelRequire("4i3Tl"))(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4955503c9c2a41c0$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $4955503c9c2a41c0$var$_defineProperty2 = $iHLHC((parcelRequire("4i3Tl")));

var $4955503c9c2a41c0$var$_defineProperty3 = $iHLHC((parcelRequire("4cByw")));

var $4955503c9c2a41c0$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));
/**
 * Constructs a new Parse.Error object with the given code and message.
 *
 * Parse.CoreManager.set('PARSE_ERRORS', [{ code, message }]) can be use to override error messages.
 *
 * @alias Parse.Error
 */ class $4955503c9c2a41c0$var$ParseError extends Error {
    /**
   * @param {number} code An error code constant from <code>Parse.Error</code>.
   * @param {string} message A detailed description of the error.
   */ constructor(code, message){
        var _context;
        super(message);
        (0, $4955503c9c2a41c0$var$_defineProperty3.default)(this, "code", void 0);
        (0, $4955503c9c2a41c0$var$_defineProperty3.default)(this, "message", void 0);
        (0, $4955503c9c2a41c0$var$_defineProperty3.default)(this, "object", void 0);
        (0, $4955503c9c2a41c0$var$_defineProperty3.default)(this, "errors", void 0);
        this.code = code;
        let customMessage = message;
        (0, $4955503c9c2a41c0$var$_forEach.default)(_context = $4955503c9c2a41c0$var$_CoreManager.default.get("PARSE_ERRORS")).call(_context, (error)=>{
            if (error.code === code && error.code) customMessage = error.message;
        });
        (0, $4955503c9c2a41c0$var$_defineProperty2.default)(this, "message", {
            enumerable: true,
            value: customMessage
        });
    }
    toString() {
        return "ParseError: " + this.code + " " + this.message;
    }
}
(0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "OTHER_CAUSE", -1);
/**
 * Error code indicating that something has gone wrong with the server.
 *
 * @property {number} INTERNAL_SERVER_ERROR
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INTERNAL_SERVER_ERROR", 1);
/**
 * Error code indicating the connection to the Parse servers failed.
 *
 * @property {number} CONNECTION_FAILED
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "CONNECTION_FAILED", 100);
/**
 * Error code indicating the specified object doesn't exist.
 *
 * @property {number} OBJECT_NOT_FOUND
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "OBJECT_NOT_FOUND", 101);
/**
 * Error code indicating you tried to query with a datatype that doesn't
 * support it, like exact matching an array or object.
 *
 * @property {number} INVALID_QUERY
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_QUERY", 102);
/**
 * Error code indicating a missing or invalid classname. Classnames are
 * case-sensitive. They must start with a letter, and a-zA-Z0-9_ are the
 * only valid characters.
 *
 * @property {number} INVALID_CLASS_NAME
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_CLASS_NAME", 103);
/**
 * Error code indicating an unspecified object id.
 *
 * @property {number} MISSING_OBJECT_ID
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "MISSING_OBJECT_ID", 104);
/**
 * Error code indicating an invalid key name. Keys are case-sensitive. They
 * must start with a letter, and a-zA-Z0-9_ are the only valid characters.
 *
 * @property {number} INVALID_KEY_NAME
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_KEY_NAME", 105);
/**
 * Error code indicating a malformed pointer. You should not see this unless
 * you have been mucking about changing internal Parse code.
 *
 * @property {number} INVALID_POINTER
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_POINTER", 106);
/**
 * Error code indicating that badly formed JSON was received upstream. This
 * either indicates you have done something unusual with modifying how
 * things encode to JSON, or the network is failing badly.
 *
 * @property {number} INVALID_JSON
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_JSON", 107);
/**
 * Error code indicating that the feature you tried to access is only
 * available internally for testing purposes.
 *
 * @property {number} COMMAND_UNAVAILABLE
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "COMMAND_UNAVAILABLE", 108);
/**
 * You must call Parse.initialize before using the Parse library.
 *
 * @property {number} NOT_INITIALIZED
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "NOT_INITIALIZED", 109);
/**
 * Error code indicating that a field was set to an inconsistent type.
 *
 * @property {number} INCORRECT_TYPE
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INCORRECT_TYPE", 111);
/**
 * Error code indicating an invalid channel name. A channel name is either
 * an empty string (the broadcast channel) or contains only a-zA-Z0-9_
 * characters and starts with a letter.
 *
 * @property {number} INVALID_CHANNEL_NAME
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_CHANNEL_NAME", 112);
/**
 * Error code indicating that push is misconfigured.
 *
 * @property {number} PUSH_MISCONFIGURED
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "PUSH_MISCONFIGURED", 115);
/**
 * Error code indicating that the object is too large.
 *
 * @property {number} OBJECT_TOO_LARGE
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "OBJECT_TOO_LARGE", 116);
/**
 * Error code indicating that the operation isn't allowed for clients.
 *
 * @property {number} OPERATION_FORBIDDEN
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "OPERATION_FORBIDDEN", 119);
/**
 * Error code indicating the result was not found in the cache.
 *
 * @property {number} CACHE_MISS
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "CACHE_MISS", 120);
/**
 * Error code indicating that an invalid key was used in a nested
 * JSONObject.
 *
 * @property {number} INVALID_NESTED_KEY
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_NESTED_KEY", 121);
/**
 * Error code indicating that an invalid filename was used for ParseFile.
 * A valid file name contains only a-zA-Z0-9_. characters and is between 1
 * and 128 characters.
 *
 * @property {number} INVALID_FILE_NAME
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_FILE_NAME", 122);
/**
 * Error code indicating an invalid ACL was provided.
 *
 * @property {number} INVALID_ACL
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_ACL", 123);
/**
 * Error code indicating that the request timed out on the server. Typically
 * this indicates that the request is too expensive to run.
 *
 * @property {number} TIMEOUT
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "TIMEOUT", 124);
/**
 * Error code indicating that the email address was invalid.
 *
 * @property {number} INVALID_EMAIL_ADDRESS
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_EMAIL_ADDRESS", 125);
/**
 * Error code indicating a missing content type.
 *
 * @property {number} MISSING_CONTENT_TYPE
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "MISSING_CONTENT_TYPE", 126);
/**
 * Error code indicating a missing content length.
 *
 * @property {number} MISSING_CONTENT_LENGTH
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "MISSING_CONTENT_LENGTH", 127);
/**
 * Error code indicating an invalid content length.
 *
 * @property {number} INVALID_CONTENT_LENGTH
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_CONTENT_LENGTH", 128);
/**
 * Error code indicating a file that was too large.
 *
 * @property {number} FILE_TOO_LARGE
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "FILE_TOO_LARGE", 129);
/**
 * Error code indicating an error saving a file.
 *
 * @property {number} FILE_SAVE_ERROR
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "FILE_SAVE_ERROR", 130);
/**
 * Error code indicating that a unique field was given a value that is
 * already taken.
 *
 * @property {number} DUPLICATE_VALUE
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "DUPLICATE_VALUE", 137);
/**
 * Error code indicating that a role's name is invalid.
 *
 * @property {number} INVALID_ROLE_NAME
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_ROLE_NAME", 139);
/**
 * Error code indicating that an application quota was exceeded.  Upgrade to
 * resolve.
 *
 * @property {number} EXCEEDED_QUOTA
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "EXCEEDED_QUOTA", 140);
/**
 * Error code indicating that a Cloud Code script failed.
 *
 * @property {number} SCRIPT_FAILED
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "SCRIPT_FAILED", 141);
/**
 * Error code indicating that a Cloud Code validation failed.
 *
 * @property {number} VALIDATION_ERROR
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "VALIDATION_ERROR", 142);
/**
 * Error code indicating that invalid image data was provided.
 *
 * @property {number} INVALID_IMAGE_DATA
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_IMAGE_DATA", 143);
/**
 * Error code indicating an unsaved file.
 *
 * @property {number} UNSAVED_FILE_ERROR
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "UNSAVED_FILE_ERROR", 151);
/**
 * Error code indicating an invalid push time.
 *
 * @property {number} INVALID_PUSH_TIME_ERROR
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_PUSH_TIME_ERROR", 152);
/**
 * Error code indicating an error deleting a file.
 *
 * @property {number} FILE_DELETE_ERROR
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "FILE_DELETE_ERROR", 153);
/**
 * Error code indicating an error deleting an unnamed file.
 *
 * @property {number} FILE_DELETE_UNNAMED_ERROR
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "FILE_DELETE_UNNAMED_ERROR", 161);
/**
 * Error code indicating that the application has exceeded its request
 * limit.
 *
 * @property {number} REQUEST_LIMIT_EXCEEDED
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "REQUEST_LIMIT_EXCEEDED", 155);
/**
 * Error code indicating that the request was a duplicate and has been discarded due to
 * idempotency rules.
 *
 * @property {number} DUPLICATE_REQUEST
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "DUPLICATE_REQUEST", 159);
/**
 * Error code indicating an invalid event name.
 *
 * @property {number} INVALID_EVENT_NAME
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_EVENT_NAME", 160);
/**
 * Error code indicating that a field had an invalid value.
 *
 * @property {number} INVALID_VALUE
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_VALUE", 162);
/**
 * Error code indicating that the username is missing or empty.
 *
 * @property {number} USERNAME_MISSING
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "USERNAME_MISSING", 200);
/**
 * Error code indicating that the password is missing or empty.
 *
 * @property {number} PASSWORD_MISSING
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "PASSWORD_MISSING", 201);
/**
 * Error code indicating that the username has already been taken.
 *
 * @property {number} USERNAME_TAKEN
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "USERNAME_TAKEN", 202);
/**
 * Error code indicating that the email has already been taken.
 *
 * @property {number} EMAIL_TAKEN
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "EMAIL_TAKEN", 203);
/**
 * Error code indicating that the email is missing, but must be specified.
 *
 * @property {number} EMAIL_MISSING
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "EMAIL_MISSING", 204);
/**
 * Error code indicating that a user with the specified email was not found.
 *
 * @property {number} EMAIL_NOT_FOUND
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "EMAIL_NOT_FOUND", 205);
/**
 * Error code indicating that a user object without a valid session could
 * not be altered.
 *
 * @property {number} SESSION_MISSING
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "SESSION_MISSING", 206);
/**
 * Error code indicating that a user can only be created through signup.
 *
 * @property {number} MUST_CREATE_USER_THROUGH_SIGNUP
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "MUST_CREATE_USER_THROUGH_SIGNUP", 207);
/**
 * Error code indicating that an an account being linked is already linked
 * to another user.
 *
 * @property {number} ACCOUNT_ALREADY_LINKED
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "ACCOUNT_ALREADY_LINKED", 208);
/**
 * Error code indicating that the current session token is invalid.
 *
 * @property {number} INVALID_SESSION_TOKEN
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_SESSION_TOKEN", 209);
/**
 * Error code indicating an error enabling or verifying MFA
 *
 * @property {number} MFA_ERROR
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "MFA_ERROR", 210);
/**
 * Error code indicating that a valid MFA token must be provided
 *
 * @property {number} MFA_TOKEN_REQUIRED
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "MFA_TOKEN_REQUIRED", 211);
/**
 * Error code indicating that a user cannot be linked to an account because
 * that account's id could not be found.
 *
 * @property {number} LINKED_ID_MISSING
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "LINKED_ID_MISSING", 250);
/**
 * Error code indicating that a user with a linked (e.g. Facebook) account
 * has an invalid session.
 *
 * @property {number} INVALID_LINKED_SESSION
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_LINKED_SESSION", 251);
/**
 * Error code indicating that a service being linked (e.g. Facebook or
 * Twitter) is unsupported.
 *
 * @property {number} UNSUPPORTED_SERVICE
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "UNSUPPORTED_SERVICE", 252);
/**
 * Error code indicating an invalid operation occured on schema
 *
 * @property {number} INVALID_SCHEMA_OPERATION
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "INVALID_SCHEMA_OPERATION", 255);
/**
 * Error code indicating that there were multiple errors. Aggregate errors
 * have an "errors" property, which is an array of error objects with more
 * detail about each error that occurred.
 *
 * @property {number} AGGREGATE_ERROR
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "AGGREGATE_ERROR", 600);
/**
 * Error code indicating the client was unable to read an input file.
 *
 * @property {number} FILE_READ_ERROR
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "FILE_READ_ERROR", 601);
/**
 * Error code indicating a real error code is unavailable because
 * we had to use an XDomainRequest object to allow CORS requests in
 * Internet Explorer, which strips the body from HTTP responses that have
 * a non-2XX status code.
 *
 * @property {number} X_DOMAIN_REQUEST
 * @static
 */ (0, $4955503c9c2a41c0$var$_defineProperty3.default)($4955503c9c2a41c0$var$ParseError, "X_DOMAIN_REQUEST", 602);
var $4955503c9c2a41c0$var$_default = module.exports.default = $4955503c9c2a41c0$var$ParseError;

});

parcelRegister("fbHpb", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0e98d730c7d0205$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $b0e98d730c7d0205$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));
class $b0e98d730c7d0205$var$XhrWeapp {
    constructor(){
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "UNSENT", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "OPENED", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "HEADERS_RECEIVED", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "LOADING", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "DONE", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "header", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "readyState", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "status", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "response", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "responseType", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "responseText", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "responseHeader", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "method", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "url", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "onabort", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "onprogress", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "onerror", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "onreadystatechange", void 0);
        (0, $b0e98d730c7d0205$var$_defineProperty2.default)(this, "requestTask", void 0);
        this.UNSENT = 0;
        this.OPENED = 1;
        this.HEADERS_RECEIVED = 2;
        this.LOADING = 3;
        this.DONE = 4;
        this.header = {};
        this.readyState = this.DONE;
        this.status = 0;
        this.response = "";
        this.responseType = "";
        this.responseText = "";
        this.responseHeader = {};
        this.method = "";
        this.url = "";
        this.onabort = ()=>{};
        this.onprogress = ()=>{};
        this.onerror = ()=>{};
        this.onreadystatechange = ()=>{};
        this.requestTask = null;
    }
    getAllResponseHeaders() {
        let header = "";
        for(const key in this.responseHeader)header += key + ":" + this.getResponseHeader(key) + "\r\n";
        return header;
    }
    getResponseHeader(key) {
        return this.responseHeader[key];
    }
    setRequestHeader(key, value) {
        this.header[key] = value;
    }
    open(method, url) {
        this.method = method;
        this.url = url;
    }
    abort() {
        if (!this.requestTask) return;
        this.requestTask.abort();
        this.status = 0;
        this.response = undefined;
        this.onabort();
        this.onreadystatechange();
    }
    send(data) {
        // @ts-ignore
        this.requestTask = wx.request({
            url: this.url,
            method: this.method,
            data: data,
            header: this.header,
            responseType: this.responseType,
            success: (res)=>{
                this.status = res.statusCode;
                this.response = res.data;
                this.responseHeader = res.header;
                this.responseText = (0, $b0e98d730c7d0205$var$_stringify.default)(res.data);
                this.requestTask = null;
                this.onreadystatechange();
            },
            fail: (err)=>{
                this.requestTask = null;
                // @ts-ignore
                this.onerror(err);
            }
        });
        this.requestTask.onProgressUpdate((res)=>{
            const event = {
                lengthComputable: res.totalBytesExpectedToWrite !== 0,
                loaded: res.totalBytesWritten,
                total: res.totalBytesExpectedToWrite
            };
            // @ts-ignore
            this.onprogress(event);
        });
    }
}
module.exports = $b0e98d730c7d0205$var$XhrWeapp;
var $b0e98d730c7d0205$var$_default = module.exports.default = $b0e98d730c7d0205$var$XhrWeapp;

});
parcelRegister("4qY0x", function(module, exports) {

module.exports = (parcelRequire("jHJ1q"));

});
parcelRegister("jHJ1q", function(module, exports) {
"use strict";

var $6DDjT = parcelRequire("6DDjT");
module.exports = $6DDjT;

});
parcelRegister("6DDjT", function(module, exports) {
"use strict";
parcelRequire("bXbh0");
parcelRequire("kvPdS");

var $ly30u = parcelRequire("ly30u");

var $2JOsI = parcelRequire("2JOsI");
// eslint-disable-next-line es/no-json -- safe
if (!$ly30u.JSON) $ly30u.JSON = {
    stringify: JSON.stringify
};
// eslint-disable-next-line no-unused-vars -- required for `.length`
module.exports = function stringify(it, replacer, space) {
    return $2JOsI($ly30u.JSON.stringify, null, arguments);
};

});
parcelRegister("bXbh0", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $aELZY = parcelRequire("aELZY");

var $iJNxK = parcelRequire("iJNxK");

var $axnyg = parcelRequire("axnyg");

var $geEDG = parcelRequire("geEDG");

var $bTsfg = parcelRequire("bTsfg");

var $77TPA = parcelRequire("77TPA");
var $8b3df3061db8f1fc$var$FORCED = $77TPA(function() {
    return new Date(NaN).toJSON() !== null || $aELZY(Date.prototype.toJSON, {
        toISOString: function() {
            return 1;
        }
    }) !== 1;
});
// `Date.prototype.toJSON` method
// https://tc39.es/ecma262/#sec-date.prototype.tojson
$ggcsv({
    target: "Date",
    proto: true,
    forced: $8b3df3061db8f1fc$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    toJSON: function toJSON(key) {
        var O = $iJNxK(this);
        var pv = $axnyg(O, "number");
        return typeof pv == "number" && !isFinite(pv) ? null : !("toISOString" in O) && $bTsfg(O) === "Date" ? $aELZY($geEDG, O) : O.toISOString();
    }
});

});
parcelRegister("geEDG", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");

var $77TPA = parcelRequire("77TPA");

var $kTagz = parcelRequire("kTagz");
var $bd1d7a35d36f062c$require$padStart = $kTagz.start;
var $bd1d7a35d36f062c$var$$RangeError = RangeError;
var $bd1d7a35d36f062c$var$$isFinite = isFinite;
var $bd1d7a35d36f062c$var$abs = Math.abs;
var $bd1d7a35d36f062c$var$DatePrototype = Date.prototype;
var $bd1d7a35d36f062c$var$nativeDateToISOString = $bd1d7a35d36f062c$var$DatePrototype.toISOString;
var $bd1d7a35d36f062c$var$thisTimeValue = $f518o($bd1d7a35d36f062c$var$DatePrototype.getTime);
var $bd1d7a35d36f062c$var$getUTCDate = $f518o($bd1d7a35d36f062c$var$DatePrototype.getUTCDate);
var $bd1d7a35d36f062c$var$getUTCFullYear = $f518o($bd1d7a35d36f062c$var$DatePrototype.getUTCFullYear);
var $bd1d7a35d36f062c$var$getUTCHours = $f518o($bd1d7a35d36f062c$var$DatePrototype.getUTCHours);
var $bd1d7a35d36f062c$var$getUTCMilliseconds = $f518o($bd1d7a35d36f062c$var$DatePrototype.getUTCMilliseconds);
var $bd1d7a35d36f062c$var$getUTCMinutes = $f518o($bd1d7a35d36f062c$var$DatePrototype.getUTCMinutes);
var $bd1d7a35d36f062c$var$getUTCMonth = $f518o($bd1d7a35d36f062c$var$DatePrototype.getUTCMonth);
var $bd1d7a35d36f062c$var$getUTCSeconds = $f518o($bd1d7a35d36f062c$var$DatePrototype.getUTCSeconds);
// `Date.prototype.toISOString` method implementation
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit fails here:
module.exports = $77TPA(function() {
    return $bd1d7a35d36f062c$var$nativeDateToISOString.call(new Date(-50000000000000 - 1)) !== "0385-07-25T07:06:39.999Z";
}) || !$77TPA(function() {
    $bd1d7a35d36f062c$var$nativeDateToISOString.call(new Date(NaN));
}) ? function toISOString() {
    if (!$bd1d7a35d36f062c$var$$isFinite($bd1d7a35d36f062c$var$thisTimeValue(this))) throw new $bd1d7a35d36f062c$var$$RangeError("Invalid time value");
    var date = this;
    var year = $bd1d7a35d36f062c$var$getUTCFullYear(date);
    var milliseconds = $bd1d7a35d36f062c$var$getUTCMilliseconds(date);
    var sign = year < 0 ? "-" : year > 9999 ? "+" : "";
    return sign + $bd1d7a35d36f062c$require$padStart($bd1d7a35d36f062c$var$abs(year), sign ? 6 : 4, 0) + "-" + $bd1d7a35d36f062c$require$padStart($bd1d7a35d36f062c$var$getUTCMonth(date) + 1, 2, 0) + "-" + $bd1d7a35d36f062c$require$padStart($bd1d7a35d36f062c$var$getUTCDate(date), 2, 0) + "T" + $bd1d7a35d36f062c$require$padStart($bd1d7a35d36f062c$var$getUTCHours(date), 2, 0) + ":" + $bd1d7a35d36f062c$require$padStart($bd1d7a35d36f062c$var$getUTCMinutes(date), 2, 0) + ":" + $bd1d7a35d36f062c$require$padStart($bd1d7a35d36f062c$var$getUTCSeconds(date), 2, 0) + "." + $bd1d7a35d36f062c$require$padStart(milliseconds, 3, 0) + "Z";
} : $bd1d7a35d36f062c$var$nativeDateToISOString;

});
parcelRegister("kTagz", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");

var $8xt01 = parcelRequire("8xt01");

var $l2Ut5 = parcelRequire("l2Ut5");

var $7H731 = parcelRequire("7H731");

var $cBWnS = parcelRequire("cBWnS");
var $f350e85c62547b49$var$repeat = $f518o($7H731);
var $f350e85c62547b49$var$stringSlice = $f518o("".slice);
var $f350e85c62547b49$var$ceil = Math.ceil;
// `String.prototype.{ padStart, padEnd }` methods implementation
var $f350e85c62547b49$var$createMethod = function(IS_END) {
    return function($this, maxLength, fillString) {
        var S = $l2Ut5($cBWnS($this));
        var intMaxLength = $8xt01(maxLength);
        var stringLength = S.length;
        var fillStr = fillString === undefined ? " " : $l2Ut5(fillString);
        var fillLen, stringFiller;
        if (intMaxLength <= stringLength || fillStr === "") return S;
        fillLen = intMaxLength - stringLength;
        stringFiller = $f350e85c62547b49$var$repeat(fillStr, $f350e85c62547b49$var$ceil(fillLen / fillStr.length));
        if (stringFiller.length > fillLen) stringFiller = $f350e85c62547b49$var$stringSlice(stringFiller, 0, fillLen);
        return IS_END ? S + stringFiller : stringFiller + S;
    };
};
module.exports = {
    // `String.prototype.padStart` method
    // https://tc39.es/ecma262/#sec-string.prototype.padstart
    start: $f350e85c62547b49$var$createMethod(false),
    // `String.prototype.padEnd` method
    // https://tc39.es/ecma262/#sec-string.prototype.padend
    end: $f350e85c62547b49$var$createMethod(true)
};

});
parcelRegister("7H731", function(module, exports) {
"use strict";

var $3ZmxQ = parcelRequire("3ZmxQ");

var $l2Ut5 = parcelRequire("l2Ut5");

var $cBWnS = parcelRequire("cBWnS");
var $59a20412be978fce$var$$RangeError = RangeError;
// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
    var str = $l2Ut5($cBWnS(this));
    var result = "";
    var n = $3ZmxQ(count);
    if (n < 0 || n === Infinity) throw new $59a20412be978fce$var$$RangeError("Wrong number of repetitions");
    for(; n > 0; (n >>>= 1) && (str += str))if (n & 1) result += str;
    return result;
};

});









parcelRegister("jtZTC", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2f0bd05739f27ec$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $e2f0bd05739f27ec$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $e2f0bd05739f27ec$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));
/**
 * Creates a new GeoPoint with any of the following forms:<br>
 *   <pre>
 *   new GeoPoint(otherGeoPoint)
 *   new GeoPoint(30, 30)
 *   new GeoPoint([30, 30])
 *   new GeoPoint({latitude: 30, longitude: 30})
 *   new GeoPoint()  // defaults to (0, 0)
 *   </pre>
 * <p>Represents a latitude / longitude point that may be associated
 * with a key in a ParseObject or used as a reference point for geo queries.
 * This allows proximity-based queries on the key.</p>
 *
 * <p>Only one key in a class may contain a GeoPoint.</p>
 *
 * <p>Example:<pre>
 *   var point = new Parse.GeoPoint(30.0, -20.0);
 *   var object = new Parse.Object("PlaceObject");
 *   object.set("location", point);
 *   object.save();</pre></p>
 *
 * @alias Parse.GeoPoint
 */ /* global navigator */ class $e2f0bd05739f27ec$var$ParseGeoPoint {
    /**
   * @param {(number[] | object | number)} arg1 Either a list of coordinate pairs, an object with `latitude`, `longitude`, or the latitude or the point.
   * @param {number} arg2 The longitude of the GeoPoint
   */ constructor(arg1, arg2){
        (0, $e2f0bd05739f27ec$var$_defineProperty2.default)(this, "_latitude", void 0);
        (0, $e2f0bd05739f27ec$var$_defineProperty2.default)(this, "_longitude", void 0);
        if ((0, $e2f0bd05739f27ec$var$_isArray.default)(arg1)) {
            $e2f0bd05739f27ec$var$ParseGeoPoint._validate(arg1[0], arg1[1]);
            this._latitude = arg1[0];
            this._longitude = arg1[1];
        } else if (typeof arg1 === "object") {
            $e2f0bd05739f27ec$var$ParseGeoPoint._validate(arg1.latitude, arg1.longitude);
            this._latitude = arg1.latitude;
            this._longitude = arg1.longitude;
        } else if (arg1 !== undefined && arg2 !== undefined) {
            $e2f0bd05739f27ec$var$ParseGeoPoint._validate(arg1, arg2);
            this._latitude = arg1;
            this._longitude = arg2;
        } else {
            this._latitude = 0;
            this._longitude = 0;
        }
    }
    /**
   * North-south portion of the coordinate, in range [-90, 90].
   * Throws an exception if set out of range in a modern browser.
   *
   * @property {number} latitude
   * @returns {number}
   */ get latitude() {
        return this._latitude;
    }
    set latitude(val) {
        $e2f0bd05739f27ec$var$ParseGeoPoint._validate(val, this.longitude);
        this._latitude = val;
    }
    /**
   * East-west portion of the coordinate, in range [-180, 180].
   * Throws if set out of range in a modern browser.
   *
   * @property {number} longitude
   * @returns {number}
   */ get longitude() {
        return this._longitude;
    }
    set longitude(val) {
        $e2f0bd05739f27ec$var$ParseGeoPoint._validate(this.latitude, val);
        this._longitude = val;
    }
    /**
   * Returns a JSON representation of the GeoPoint, suitable for Parse.
   *
   * @returns {object}
   */ toJSON() {
        $e2f0bd05739f27ec$var$ParseGeoPoint._validate(this._latitude, this._longitude);
        return {
            __type: "GeoPoint",
            latitude: this._latitude,
            longitude: this._longitude
        };
    }
    equals(other) {
        return other instanceof $e2f0bd05739f27ec$var$ParseGeoPoint && this.latitude === other.latitude && this.longitude === other.longitude;
    }
    /**
   * Returns the distance from this GeoPoint to another in radians.
   *
   * @param {Parse.GeoPoint} point the other Parse.GeoPoint.
   * @returns {number}
   */ radiansTo(point) {
        const d2r = Math.PI / 180.0;
        const lat1rad = this.latitude * d2r;
        const long1rad = this.longitude * d2r;
        const lat2rad = point.latitude * d2r;
        const long2rad = point.longitude * d2r;
        const sinDeltaLatDiv2 = Math.sin((lat1rad - lat2rad) / 2);
        const sinDeltaLongDiv2 = Math.sin((long1rad - long2rad) / 2);
        // Square of half the straight line chord distance between both points.
        let a = sinDeltaLatDiv2 * sinDeltaLatDiv2 + Math.cos(lat1rad) * Math.cos(lat2rad) * sinDeltaLongDiv2 * sinDeltaLongDiv2;
        a = Math.min(1.0, a);
        return 2 * Math.asin(Math.sqrt(a));
    }
    /**
   * Returns the distance from this GeoPoint to another in kilometers.
   *
   * @param {Parse.GeoPoint} point the other Parse.GeoPoint.
   * @returns {number}
   */ kilometersTo(point) {
        return this.radiansTo(point) * 6371.0;
    }
    /**
   * Returns the distance from this GeoPoint to another in miles.
   *
   * @param {Parse.GeoPoint} point the other Parse.GeoPoint.
   * @returns {number}
   */ milesTo(point) {
        return this.radiansTo(point) * 3958.8;
    }
    /*
   * Throws an exception if the given lat-long is out of bounds.
   */ static _validate(latitude, longitude) {
        if (isNaN(latitude) || isNaN(longitude) || typeof latitude !== "number" || typeof longitude !== "number") throw new TypeError("GeoPoint latitude and longitude must be valid numbers");
        if (latitude < -90) throw new TypeError("GeoPoint latitude out of bounds: " + latitude + " < -90.0.");
        if (latitude > 90.0) throw new TypeError("GeoPoint latitude out of bounds: " + latitude + " > 90.0.");
        if (longitude < -180) throw new TypeError("GeoPoint longitude out of bounds: " + longitude + " < -180.0.");
        if (longitude > 180.0) throw new TypeError("GeoPoint longitude out of bounds: " + longitude + " > 180.0.");
    }
    /**
   * Creates a GeoPoint with the user's current location, if available.
   *
   * @param {object} options The options.
   * @param {boolean} [options.enableHighAccuracy] A boolean value that indicates the application would like to receive the best possible results.
   *  If true and if the device is able to provide a more accurate position, it will do so.
   *  Note that this can result in slower response times or increased power consumption (with a GPS chip on a mobile device for example).
   *  On the other hand, if false, the device can take the liberty to save resources by responding more quickly and/or using less power. Default: false.
   * @param {number} [options.timeout] A positive long value representing the maximum length of time (in milliseconds) the device is allowed to take in order to return a position.
   *  The default value is Infinity, meaning that getCurrentPosition() won't return until the position is available.
   * @param {number} [options.maximumAge] A positive long value indicating the maximum age in milliseconds of a possible cached position that is acceptable to return.
   *  If set to 0, it means that the device cannot use a cached position and must attempt to retrieve the real current position.
   *  If set to Infinity the device must return a cached position regardless of its age. Default: 0.
   * @static
   * @returns {Promise<Parse.GeoPoint>} User's current location
   */ static current(options) {
        return new $e2f0bd05739f27ec$var$_promise.default((resolve, reject)=>{
            navigator.geolocation.getCurrentPosition((location)=>{
                resolve(new $e2f0bd05739f27ec$var$ParseGeoPoint(location.coords.latitude, location.coords.longitude));
            }, reject, options);
        });
    }
}
var $e2f0bd05739f27ec$var$_default = module.exports.default = $e2f0bd05739f27ec$var$ParseGeoPoint;

});

parcelRegister("i8AKq", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3457aac5b5626dc$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $d3457aac5b5626dc$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $d3457aac5b5626dc$var$_ParseGeoPoint = $iHLHC((parcelRequire("jtZTC")));
/**
 * Creates a new Polygon with any of the following forms:<br>
 *   <pre>
 *   new Polygon([[0,0],[0,1],[1,1],[1,0]])
 *   new Polygon([GeoPoint, GeoPoint, GeoPoint])
 *   </pre>
 *
 * <p>Represents a coordinates that may be associated
 * with a key in a ParseObject or used as a reference point for geo queries.
 * This allows proximity-based queries on the key.</p>
 *
 * <p>Example:<pre>
 *   var polygon = new Parse.Polygon([[0,0],[0,1],[1,1],[1,0]]);
 *   var object = new Parse.Object("PlaceObject");
 *   object.set("area", polygon);
 *   object.save();</pre></p>
 *
 * @alias Parse.Polygon
 */ class $d3457aac5b5626dc$var$ParsePolygon {
    /**
   * @param {(Coordinates | Parse.GeoPoint[])} coordinates An Array of coordinate pairs
   */ constructor(coordinates){
        (0, $d3457aac5b5626dc$var$_defineProperty2.default)(this, "_coordinates", void 0);
        this._coordinates = $d3457aac5b5626dc$var$ParsePolygon._validate(coordinates);
    }
    /**
   * Coordinates value for this Polygon.
   * Throws an exception if not valid type.
   *
   * @property {(Coordinates | Parse.GeoPoint[])} coordinates list of coordinates
   * @returns {Coordinates}
   */ get coordinates() {
        return this._coordinates;
    }
    set coordinates(coords) {
        this._coordinates = $d3457aac5b5626dc$var$ParsePolygon._validate(coords);
    }
    /**
   * Returns a JSON representation of the Polygon, suitable for Parse.
   *
   * @returns {object}
   */ toJSON() {
        $d3457aac5b5626dc$var$ParsePolygon._validate(this._coordinates);
        return {
            __type: "Polygon",
            coordinates: this._coordinates
        };
    }
    /**
   * Checks if two polygons are equal
   *
   * @param {(Parse.Polygon | object)} other
   * @returns {boolean}
   */ equals(other) {
        if (!(other instanceof $d3457aac5b5626dc$var$ParsePolygon) || this.coordinates.length !== other.coordinates.length) return false;
        let isEqual = true;
        for(let i = 1; i < this._coordinates.length; i += 1)if (this._coordinates[i][0] != other.coordinates[i][0] || this._coordinates[i][1] != other.coordinates[i][1]) {
            isEqual = false;
            break;
        }
        return isEqual;
    }
    /**
   *
   * @param {Parse.GeoPoint} point
   * @returns {boolean} Returns if the point is contained in the polygon
   */ containsPoint(point) {
        let minX = this._coordinates[0][0];
        let maxX = this._coordinates[0][0];
        let minY = this._coordinates[0][1];
        let maxY = this._coordinates[0][1];
        for(let i = 1; i < this._coordinates.length; i += 1){
            const p = this._coordinates[i];
            minX = Math.min(p[0], minX);
            maxX = Math.max(p[0], maxX);
            minY = Math.min(p[1], minY);
            maxY = Math.max(p[1], maxY);
        }
        const outside = point.latitude < minX || point.latitude > maxX || point.longitude < minY || point.longitude > maxY;
        if (outside) return false;
        let inside = false;
        for(let i = 0, j = this._coordinates.length - 1; i < this._coordinates.length; j = i++){
            const startX = this._coordinates[i][0];
            const startY = this._coordinates[i][1];
            const endX = this._coordinates[j][0];
            const endY = this._coordinates[j][1];
            const intersect = startY > point.longitude != endY > point.longitude && point.latitude < (endX - startX) * (point.longitude - startY) / (endY - startY) + startX;
            if (intersect) inside = !inside;
        }
        return inside;
    }
    /**
   * Validates that the list of coordinates can form a valid polygon
   *
   * @param {Array} coords the list of coordinates to validate as a polygon
   * @throws {TypeError}
   * @returns {number[][]} Array of coordinates if validated.
   */ static _validate(coords) {
        if (!(0, $d3457aac5b5626dc$var$_isArray.default)(coords)) throw new TypeError("Coordinates must be an Array");
        if (coords.length < 3) throw new TypeError("Polygon must have at least 3 GeoPoints or Points");
        const points = [];
        for(let i = 0; i < coords.length; i += 1){
            const coord = coords[i];
            let geoPoint;
            if (coord instanceof $d3457aac5b5626dc$var$_ParseGeoPoint.default) geoPoint = coord;
            else if ((0, $d3457aac5b5626dc$var$_isArray.default)(coord) && coord.length === 2) geoPoint = new $d3457aac5b5626dc$var$_ParseGeoPoint.default(coord[0], coord[1]);
            else throw new TypeError("Coordinates must be an Array of GeoPoints or Points");
            points.push([
                geoPoint.latitude,
                geoPoint.longitude
            ]);
        }
        return points;
    }
}
var $d3457aac5b5626dc$var$_default = module.exports.default = $d3457aac5b5626dc$var$ParsePolygon;

});

parcelRegister("967gW", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $69fa50bab9964798$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $69fa50bab9964798$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $69fa50bab9964798$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));
/**
 * Creates a new Relation for the given parent object and key. This
 * constructor should rarely be used directly, but rather created by
 * Parse.Object.relation.
 *
 * <p>
 * A class that is used to access all of the children of a many-to-many
 * relationship.  Each instance of Parse.Relation is associated with a
 * particular parent object and key.
 * </p>
 *
 * @alias Parse.Relation
 */ class $69fa50bab9964798$var$ParseRelation {
    /**
   * @param {Parse.Object} parent The parent of this relation.
   * @param {string} key The key for this relation on the parent.
   */ constructor(parent, key){
        (0, $69fa50bab9964798$var$_defineProperty2.default)(this, "parent", void 0);
        (0, $69fa50bab9964798$var$_defineProperty2.default)(this, "key", void 0);
        (0, $69fa50bab9964798$var$_defineProperty2.default)(this, "targetClassName", void 0);
        this.parent = parent;
        this.key = key;
        this.targetClassName = null;
    }
    /*
   * Makes sure that this relation has the right parent and key.
   */ _ensureParentAndKey(parent, key) {
        this.key = this.key || key;
        if (this.key !== key) throw new Error("Internal Error. Relation retrieved from two different keys.");
        if (this.parent) {
            if (this.parent.className !== parent.className) throw new Error("Internal Error. Relation retrieved from two different Objects.");
            if (this.parent.id) {
                if (this.parent.id !== parent.id) throw new Error("Internal Error. Relation retrieved from two different Objects.");
            } else if (parent.id) this.parent = parent;
        } else this.parent = parent;
    }
    /**
   * Adds a Parse.Object or an array of Parse.Objects to the relation.
   *
   * @param {(Parse.Object|Array)} objects The item or items to add.
   * @returns {Parse.Object} The parent of the relation.
   */ add(objects) {
        if (!(0, $69fa50bab9964798$var$_isArray.default)(objects)) objects = [
            objects
        ];
        const { RelationOp: RelationOp } = $69fa50bab9964798$var$_CoreManager.default.getParseOp();
        const change = new RelationOp(objects, []);
        const parent = this.parent;
        if (!parent) throw new Error("Cannot add to a Relation without a parent");
        if (objects.length === 0) return parent;
        parent.set(this.key, change);
        this.targetClassName = change._targetClassName;
        return parent;
    }
    /**
   * Removes a Parse.Object or an array of Parse.Objects from this relation.
   *
   * @param {(Parse.Object|Array)} objects The item or items to remove.
   */ remove(objects) {
        if (!(0, $69fa50bab9964798$var$_isArray.default)(objects)) objects = [
            objects
        ];
        const { RelationOp: RelationOp } = $69fa50bab9964798$var$_CoreManager.default.getParseOp();
        const change = new RelationOp([], objects);
        if (!this.parent) throw new Error("Cannot remove from a Relation without a parent");
        if (objects.length === 0) return;
        this.parent.set(this.key, change);
        this.targetClassName = change._targetClassName;
    }
    /**
   * Returns a JSON version of the object suitable for saving to disk.
   *
   * @returns {object} JSON representation of Relation
   */ toJSON() {
        return {
            __type: "Relation",
            className: this.targetClassName
        };
    }
    /**
   * Returns a Parse.Query that is limited to objects in this
   * relation.
   *
   * @returns {Parse.Query} Relation Query
   */ query() {
        let query;
        const parent = this.parent;
        if (!parent) throw new Error("Cannot construct a query for a Relation without a parent");
        const ParseQuery = $69fa50bab9964798$var$_CoreManager.default.getParseQuery();
        if (!this.targetClassName) {
            query = new ParseQuery(parent.className);
            query._extraOptions.redirectClassNameForKey = this.key;
        } else query = new ParseQuery(this.targetClassName);
        query._addCondition("$relatedTo", "object", {
            __type: "Pointer",
            className: parent.className,
            objectId: parent.id
        });
        query._addCondition("$relatedTo", "key", this.key);
        return query;
    }
}
var $69fa50bab9964798$var$_default = module.exports.default = $69fa50bab9964798$var$ParseRelation;

});


parcelRegister("1rsTn", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $10ceb975b6ee7f2c$var$_default;

var $10ceb975b6ee7f2c$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $10ceb975b6ee7f2c$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $10ceb975b6ee7f2c$var$_startsWith = $iHLHC((parcelRequire("hNmgD")));

var $10ceb975b6ee7f2c$var$_concat = $iHLHC((parcelRequire("oorJA")));

var $10ceb975b6ee7f2c$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $10ceb975b6ee7f2c$var$_map = $iHLHC((parcelRequire("2VoQi")));

var $10ceb975b6ee7f2c$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $10ceb975b6ee7f2c$var$_ParseACL = $iHLHC((parcelRequire("2xGBa")));

var $10ceb975b6ee7f2c$var$_ParseFile = $iHLHC((parcelRequire("59JWU")));

var $10ceb975b6ee7f2c$var$_ParseGeoPoint = $iHLHC((parcelRequire("jtZTC")));

var $10ceb975b6ee7f2c$var$_ParsePolygon = $iHLHC((parcelRequire("i8AKq")));

var $10ceb975b6ee7f2c$var$_ParseRelation = $iHLHC((parcelRequire("967gW")));
function $10ceb975b6ee7f2c$var$encode(value, disallowObjects, forcePointers, seen, offline) {
    const ParseObject = $10ceb975b6ee7f2c$var$_CoreManager.default.getParseObject();
    if (value instanceof ParseObject) {
        if (disallowObjects) throw new Error("Parse Objects not allowed here");
        const seenEntry = value.id ? value.className + ":" + value.id : value;
        if (forcePointers || !seen || (0, $10ceb975b6ee7f2c$var$_indexOf.default)(seen).call(seen, seenEntry) > -1 || value.dirty() || (0, $10ceb975b6ee7f2c$var$_keys.default)(value._getServerData()).length < 1) {
            var _context;
            if (offline && (0, $10ceb975b6ee7f2c$var$_startsWith.default)(_context = value._getId()).call(_context, "local")) return value.toOfflinePointer();
            return value.toPointer();
        }
        seen = (0, $10ceb975b6ee7f2c$var$_concat.default)(seen).call(seen, seenEntry);
        return value._toFullJSON(seen, offline);
    }
    const { Op: Op } = $10ceb975b6ee7f2c$var$_CoreManager.default.getParseOp();
    if (value instanceof Op || value instanceof $10ceb975b6ee7f2c$var$_ParseACL.default || value instanceof $10ceb975b6ee7f2c$var$_ParseGeoPoint.default || value instanceof $10ceb975b6ee7f2c$var$_ParsePolygon.default || value instanceof $10ceb975b6ee7f2c$var$_ParseRelation.default) return value.toJSON();
    if (value instanceof $10ceb975b6ee7f2c$var$_ParseFile.default) {
        if (!value.url()) throw new Error("Tried to encode an unsaved file.");
        return value.toJSON();
    }
    if (Object.prototype.toString.call(value) === "[object Date]") {
        if (isNaN(value)) throw new Error("Tried to encode an invalid date.");
        return {
            __type: "Date",
            iso: value.toJSON()
        };
    }
    if (Object.prototype.toString.call(value) === "[object RegExp]" && typeof value.source === "string") return value.source;
    if ((0, $10ceb975b6ee7f2c$var$_isArray.default)(value)) return (0, $10ceb975b6ee7f2c$var$_map.default)(value).call(value, (v)=>{
        return $10ceb975b6ee7f2c$var$encode(v, disallowObjects, forcePointers, seen, offline);
    });
    if (value && typeof value === "object") {
        const output = {};
        for(const k in value)output[k] = $10ceb975b6ee7f2c$var$encode(value[k], disallowObjects, forcePointers, seen, offline);
        return output;
    }
    return value;
}
function $10ceb975b6ee7f2c$var$_default(value, disallowObjects, forcePointers, seen, offline) {
    return $10ceb975b6ee7f2c$var$encode(value, !!disallowObjects, !!forcePointers, seen || [], offline);
}

});
parcelRegister("hNmgD", function(module, exports) {

module.exports = (parcelRequire("kQxgJ"));

});
parcelRegister("kQxgJ", function(module, exports) {
"use strict";

var $dOs42 = parcelRequire("dOs42");
module.exports = $dOs42;

});
parcelRegister("dOs42", function(module, exports) {
"use strict";

var $8hsAO = parcelRequire("8hsAO");

var $iQF3Q = parcelRequire("iQF3Q");
var $a0e5b6cd70b8df3f$var$StringPrototype = String.prototype;
module.exports = function(it) {
    var own = it.startsWith;
    return typeof it == "string" || it === $a0e5b6cd70b8df3f$var$StringPrototype || $8hsAO($a0e5b6cd70b8df3f$var$StringPrototype, it) && own === $a0e5b6cd70b8df3f$var$StringPrototype.startsWith ? $iQF3Q : own;
};

});
parcelRegister("iQF3Q", function(module, exports) {
"use strict";
parcelRequire("fPtxe");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("String", "startsWith");

});
parcelRegister("fPtxe", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $5FNR6 = parcelRequire("5FNR6");

var $fTFId = parcelRequire("fTFId");
var $b862877cc9dad1a1$require$getOwnPropertyDescriptor = $fTFId.f;

var $8xt01 = parcelRequire("8xt01");

var $l2Ut5 = parcelRequire("l2Ut5");

var $4Te7f = parcelRequire("4Te7f");

var $cBWnS = parcelRequire("cBWnS");

var $bmRml = parcelRequire("bmRml");

var $7phdw = parcelRequire("7phdw");
var $b862877cc9dad1a1$var$stringSlice = $5FNR6("".slice);
var $b862877cc9dad1a1$var$min = Math.min;
var $b862877cc9dad1a1$var$CORRECT_IS_REGEXP_LOGIC = $bmRml("startsWith");
// https://github.com/zloirock/core-js/pull/702
var $b862877cc9dad1a1$var$MDN_POLYFILL_BUG = !$7phdw && !$b862877cc9dad1a1$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $b862877cc9dad1a1$require$getOwnPropertyDescriptor(String.prototype, "startsWith");
    return descriptor && !descriptor.writable;
}();
// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$ggcsv({
    target: "String",
    proto: true,
    forced: !$b862877cc9dad1a1$var$MDN_POLYFILL_BUG && !$b862877cc9dad1a1$var$CORRECT_IS_REGEXP_LOGIC
}, {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = $l2Ut5($cBWnS(this));
        $4Te7f(searchString);
        var index = $8xt01($b862877cc9dad1a1$var$min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = $l2Ut5(searchString);
        return $b862877cc9dad1a1$var$stringSlice(that, index, index + search.length) === search;
    }
});

});
parcelRegister("4Te7f", function(module, exports) {
"use strict";

var $6oZqm = parcelRequire("6oZqm");
var $38f73f974d28d73c$var$$TypeError = TypeError;
module.exports = function(it) {
    if ($6oZqm(it)) throw new $38f73f974d28d73c$var$$TypeError("The method doesn't accept regular expressions");
    return it;
};

});
parcelRegister("6oZqm", function(module, exports) {
"use strict";

var $1WYwK = parcelRequire("1WYwK");

var $bTsfg = parcelRequire("bTsfg");

var $fq7H3 = parcelRequire("fq7H3");
var $4a94a18cd9ae2bc7$var$MATCH = $fq7H3("match");
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function(it) {
    var isRegExp;
    return $1WYwK(it) && ((isRegExp = it[$4a94a18cd9ae2bc7$var$MATCH]) !== undefined ? !!isRegExp : $bTsfg(it) === "RegExp");
};

});


parcelRegister("bmRml", function(module, exports) {
"use strict";

var $fq7H3 = parcelRequire("fq7H3");
var $846b23dc5ef8dd49$var$MATCH = $fq7H3("match");
module.exports = function(METHOD_NAME) {
    var regexp = /./;
    try {
        "/./"[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$846b23dc5ef8dd49$var$MATCH] = false;
            return "/./"[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};

});






parcelRegister("oorJA", function(module, exports) {

module.exports = (parcelRequire("eOq4R"));

});
parcelRegister("eOq4R", function(module, exports) {
"use strict";

var $7SISV = parcelRequire("7SISV");
module.exports = $7SISV;

});
parcelRegister("7SISV", function(module, exports) {
"use strict";

var $8hsAO = parcelRequire("8hsAO");

var $6qdGo = parcelRequire("6qdGo");
var $5bd064c4553bb24a$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.concat;
    return it === $5bd064c4553bb24a$var$ArrayPrototype || $8hsAO($5bd064c4553bb24a$var$ArrayPrototype, it) && own === $5bd064c4553bb24a$var$ArrayPrototype.concat ? $6qdGo : own;
};

});
parcelRegister("6qdGo", function(module, exports) {
"use strict";
parcelRequire("isTuv");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Array", "concat");

});




parcelRegister("2VoQi", function(module, exports) {

module.exports = (parcelRequire("hxV74"));

});
parcelRegister("hxV74", function(module, exports) {
"use strict";

var $c5uyW = parcelRequire("c5uyW");
module.exports = $c5uyW;

});
parcelRegister("c5uyW", function(module, exports) {
"use strict";

var $8hsAO = parcelRequire("8hsAO");

var $3smyF = parcelRequire("3smyF");
var $8ccda8c3e7128aab$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.map;
    return it === $8ccda8c3e7128aab$var$ArrayPrototype || $8hsAO($8ccda8c3e7128aab$var$ArrayPrototype, it) && own === $8ccda8c3e7128aab$var$ArrayPrototype.map ? $3smyF : own;
};

});
parcelRegister("3smyF", function(module, exports) {
"use strict";
parcelRequire("bQEFd");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Array", "map");

});
parcelRegister("bQEFd", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $igsV9 = parcelRequire("igsV9");
var $8a04180965f7f8c1$require$$map = $igsV9.map;

var $PdD5d = parcelRequire("PdD5d");
var $8a04180965f7f8c1$var$HAS_SPECIES_SUPPORT = $PdD5d("map");
// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$ggcsv({
    target: "Array",
    proto: true,
    forced: !$8a04180965f7f8c1$var$HAS_SPECIES_SUPPORT
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        return $8a04180965f7f8c1$require$$map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

});





parcelRegister("2xGBa", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d9fb5067889164c$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $1d9fb5067889164c$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $1d9fb5067889164c$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));
const $1d9fb5067889164c$var$PUBLIC_KEY = "*";
/**
 * Creates a new ACL.
 * If no argument is given, the ACL has no permissions for anyone.
 * If the argument is a Parse.User, the ACL will have read and write
 *   permission for only that user.
 * If the argument is any other JSON object, that object will be interpretted
 *   as a serialized ACL created with toJSON().
 *
 * <p>An ACL, or Access Control List can be added to any
 * <code>Parse.Object</code> to restrict access to only a subset of users
 * of your application.</p>
 *
 * @alias Parse.ACL
 */ class $1d9fb5067889164c$var$ParseACL {
    /**
   * @param {(Parse.User | object)} arg1 The user to initialize the ACL for
   */ constructor(arg1){
        (0, $1d9fb5067889164c$var$_defineProperty2.default)(this, "permissionsById", void 0);
        this.permissionsById = {};
        if (arg1 && typeof arg1 === "object") {
            const ParseUser = $1d9fb5067889164c$var$_CoreManager.default.getParseUser();
            if (arg1 instanceof ParseUser) {
                this.setReadAccess(arg1, true);
                this.setWriteAccess(arg1, true);
            } else for(const userId in arg1){
                const accessList = arg1[userId];
                this.permissionsById[userId] = {};
                for(const permission in accessList){
                    const allowed = accessList[permission];
                    if (permission !== "read" && permission !== "write") throw new TypeError("Tried to create an ACL with an invalid permission type.");
                    if (typeof allowed !== "boolean") throw new TypeError("Tried to create an ACL with an invalid permission value.");
                    this.permissionsById[userId][permission] = allowed;
                }
            }
        } else if (typeof arg1 === "function") throw new TypeError("ParseACL constructed with a function. Did you forget ()?");
    }
    /**
   * Returns a JSON-encoded version of the ACL.
   *
   * @returns {object}
   */ toJSON() {
        const permissions = {};
        for(const p in this.permissionsById)permissions[p] = this.permissionsById[p];
        return permissions;
    }
    /**
   * Returns whether this ACL is equal to another object
   *
   * @param {ParseACL} other The other object's ACL to compare to
   * @returns {boolean}
   */ equals(other) {
        if (!(other instanceof $1d9fb5067889164c$var$ParseACL)) return false;
        const users = (0, $1d9fb5067889164c$var$_keys.default)(this.permissionsById);
        const otherUsers = (0, $1d9fb5067889164c$var$_keys.default)(other.permissionsById);
        if (users.length !== otherUsers.length) return false;
        for(const u in this.permissionsById){
            if (!other.permissionsById[u]) return false;
            if (this.permissionsById[u].read !== other.permissionsById[u].read) return false;
            if (this.permissionsById[u].write !== other.permissionsById[u].write) return false;
        }
        return true;
    }
    _setAccess(accessType, userId, allowed) {
        const ParseRole = $1d9fb5067889164c$var$_CoreManager.default.getParseRole();
        const ParseUser = $1d9fb5067889164c$var$_CoreManager.default.getParseUser();
        if (userId instanceof ParseUser) userId = userId.id;
        else if (userId instanceof ParseRole) {
            const name = userId.getName();
            if (!name) throw new TypeError("Role must have a name");
            userId = "role:" + name;
        }
        if (typeof userId !== "string") throw new TypeError("userId must be a string.");
        if (typeof allowed !== "boolean") throw new TypeError("allowed must be either true or false.");
        let permissions = this.permissionsById[userId];
        if (!permissions) {
            if (!allowed) // The user already doesn't have this permission, so no action is needed
            return;
            else {
                permissions = {};
                this.permissionsById[userId] = permissions;
            }
        }
        if (allowed) this.permissionsById[userId][accessType] = true;
        else {
            delete permissions[accessType];
            if ((0, $1d9fb5067889164c$var$_keys.default)(permissions).length === 0) delete this.permissionsById[userId];
        }
    }
    _getAccess(accessType, userId) {
        const ParseRole = $1d9fb5067889164c$var$_CoreManager.default.getParseRole();
        const ParseUser = $1d9fb5067889164c$var$_CoreManager.default.getParseUser();
        if (userId instanceof ParseUser) {
            userId = userId.id;
            if (!userId) throw new Error("Cannot get access for a ParseUser without an ID");
        } else if (userId instanceof ParseRole) {
            const name = userId.getName();
            if (!name) throw new TypeError("Role must have a name");
            userId = "role:" + name;
        }
        const permissions = this.permissionsById[userId];
        if (!permissions) return false;
        return !!permissions[accessType];
    }
    /**
   * Sets whether the given user is allowed to read this object.
   *
   * @param userId An instance of Parse.User or its objectId.
   * @param {boolean} allowed Whether that user should have read access.
   */ setReadAccess(userId, allowed) {
        this._setAccess("read", userId, allowed);
    }
    /**
   * Get whether the given user id is *explicitly* allowed to read this object.
   * Even if this returns false, the user may still be able to access it if
   * getPublicReadAccess returns true or a role that the user belongs to has
   * write access.
   *
   * @param userId An instance of Parse.User or its objectId, or a Parse.Role.
   * @returns {boolean}
   */ getReadAccess(userId) {
        return this._getAccess("read", userId);
    }
    /**
   * Sets whether the given user id is allowed to write this object.
   *
   * @param userId An instance of Parse.User or its objectId, or a Parse.Role..
   * @param {boolean} allowed Whether that user should have write access.
   */ setWriteAccess(userId, allowed) {
        this._setAccess("write", userId, allowed);
    }
    /**
   * Gets whether the given user id is *explicitly* allowed to write this object.
   * Even if this returns false, the user may still be able to write it if
   * getPublicWriteAccess returns true or a role that the user belongs to has
   * write access.
   *
   * @param userId An instance of Parse.User or its objectId, or a Parse.Role.
   * @returns {boolean}
   */ getWriteAccess(userId) {
        return this._getAccess("write", userId);
    }
    /**
   * Sets whether the public is allowed to read this object.
   *
   * @param {boolean} allowed
   */ setPublicReadAccess(allowed) {
        this.setReadAccess($1d9fb5067889164c$var$PUBLIC_KEY, allowed);
    }
    /**
   * Gets whether the public is allowed to read this object.
   *
   * @returns {boolean}
   */ getPublicReadAccess() {
        return this.getReadAccess($1d9fb5067889164c$var$PUBLIC_KEY);
    }
    /**
   * Sets whether the public is allowed to write this object.
   *
   * @param {boolean} allowed
   */ setPublicWriteAccess(allowed) {
        this.setWriteAccess($1d9fb5067889164c$var$PUBLIC_KEY, allowed);
    }
    /**
   * Gets whether the public is allowed to write this object.
   *
   * @returns {boolean}
   */ getPublicWriteAccess() {
        return this.getWriteAccess($1d9fb5067889164c$var$PUBLIC_KEY);
    }
    /**
   * Gets whether users belonging to the given role are allowed
   * to read this object. Even if this returns false, the role may
   * still be able to write it if a parent role has read access.
   *
   * @param role The name of the role, or a Parse.Role object.
   * @returns {boolean} true if the role has read access. false otherwise.
   * @throws {TypeError} If role is neither a Parse.Role nor a String.
   */ getRoleReadAccess(role) {
        const ParseRole = $1d9fb5067889164c$var$_CoreManager.default.getParseRole();
        if (role instanceof ParseRole) // Normalize to the String name
        role = role.getName();
        if (typeof role !== "string") throw new TypeError("role must be a ParseRole or a String");
        return this.getReadAccess("role:" + role);
    }
    /**
   * Gets whether users belonging to the given role are allowed
   * to write this object. Even if this returns false, the role may
   * still be able to write it if a parent role has write access.
   *
   * @param role The name of the role, or a Parse.Role object.
   * @returns {boolean} true if the role has write access. false otherwise.
   * @throws {TypeError} If role is neither a Parse.Role nor a String.
   */ getRoleWriteAccess(role) {
        const ParseRole = $1d9fb5067889164c$var$_CoreManager.default.getParseRole();
        if (role instanceof ParseRole) // Normalize to the String name
        role = role.getName();
        if (typeof role !== "string") throw new TypeError("role must be a ParseRole or a String");
        return this.getWriteAccess("role:" + role);
    }
    /**
   * Sets whether users belonging to the given role are allowed
   * to read this object.
   *
   * @param role The name of the role, or a Parse.Role object.
   * @param {boolean} allowed Whether the given role can read this object.
   * @throws {TypeError} If role is neither a Parse.Role nor a String.
   */ setRoleReadAccess(role, allowed) {
        const ParseRole = $1d9fb5067889164c$var$_CoreManager.default.getParseRole();
        if (role instanceof ParseRole) // Normalize to the String name
        role = role.getName();
        if (typeof role !== "string") throw new TypeError("role must be a ParseRole or a String");
        this.setReadAccess("role:" + role, allowed);
    }
    /**
   * Sets whether users belonging to the given role are allowed
   * to write this object.
   *
   * @param role The name of the role, or a Parse.Role object.
   * @param {boolean} allowed Whether the given role can write this object.
   * @throws {TypeError} If role is neither a Parse.Role nor a String.
   */ setRoleWriteAccess(role, allowed) {
        const ParseRole = $1d9fb5067889164c$var$_CoreManager.default.getParseRole();
        if (role instanceof ParseRole) // Normalize to the String name
        role = role.getName();
        if (typeof role !== "string") throw new TypeError("role must be a ParseRole or a String");
        this.setWriteAccess("role:" + role, allowed);
    }
}
var $1d9fb5067889164c$var$_default = module.exports.default = $1d9fb5067889164c$var$ParseACL;

});


parcelRegister("hf5sb", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c8d8115ecbe7cbf1$var$_stringify = $iHLHC((parcelRequire("4qY0x")));
let $c8d8115ecbe7cbf1$var$AES;
let $c8d8115ecbe7cbf1$var$ENC;

$c8d8115ecbe7cbf1$var$AES = (parcelRequire("3H9rt"));

$c8d8115ecbe7cbf1$var$ENC = (parcelRequire("1gKAu"));
const $c8d8115ecbe7cbf1$var$CryptoController = {
    encrypt (obj, secretKey) {
        const encrypted = $c8d8115ecbe7cbf1$var$AES.encrypt((0, $c8d8115ecbe7cbf1$var$_stringify.default)(obj), secretKey);
        return encrypted.toString();
    },
    decrypt (encryptedText, secretKey) {
        const decryptedStr = $c8d8115ecbe7cbf1$var$AES.decrypt(encryptedText, secretKey).toString($c8d8115ecbe7cbf1$var$ENC);
        return decryptedStr;
    }
};
module.exports = $c8d8115ecbe7cbf1$var$CryptoController;
var $c8d8115ecbe7cbf1$var$_default = module.exports.default = $c8d8115ecbe7cbf1$var$CryptoController;

});
parcelRegister("3H9rt", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});
parcelRegister("cfaDk", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("5Io6y"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});
parcelRegister("5Io6y", function(module, exports) {
"use strict";

});


parcelRegister("500SS", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("6oXxt", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRegister("ioEPr", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("lqaMD")), (parcelRequire("7ft6W")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});
parcelRegister("lqaMD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRegister("7ft6W", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});


parcelRegister("fctwD", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("ioEPr")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == "string") return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == "string") return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt, hasher) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                if (!hasher) var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                else var key = EvpKDF.create({
                    keySize: keySize + ivSize,
                    hasher: hasher
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});


parcelRegister("1gKAu", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    return CryptoJS.enc.Utf8;
});

});


parcelRegister("cJKeG", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $945d8d7b16514ba0$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $945d8d7b16514ba0$var$_splice = $iHLHC((parcelRequire("aFg1C")));

var $945d8d7b16514ba0$var$_findIndex = $iHLHC((parcelRequire("arN5C")));

var $945d8d7b16514ba0$var$_setInterval2 = $iHLHC((parcelRequire("ds9Aj")));

var $945d8d7b16514ba0$var$_find = $iHLHC((parcelRequire("c61hX")));

var $945d8d7b16514ba0$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $945d8d7b16514ba0$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $945d8d7b16514ba0$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $945d8d7b16514ba0$var$_ParseQuery = $iHLHC((parcelRequire("4FVCr")));

var $945d8d7b16514ba0$var$_Storage = $iHLHC((parcelRequire("7GXKV")));
const $945d8d7b16514ba0$var$QUEUE_KEY = "Parse/Eventually/Queue";
let $945d8d7b16514ba0$var$queueCache = [];
let $945d8d7b16514ba0$var$dirtyCache = true;
let $945d8d7b16514ba0$var$polling = undefined;
/**
 * Provides utility functions to queue objects that will be
 * saved to the server at a later date.
 *
 * @class Parse.EventuallyQueue
 * @static
 */ const $945d8d7b16514ba0$var$EventuallyQueue = {
    /**
   * Add object to queue with save operation.
   *
   * @function save
   * @name Parse.EventuallyQueue.save
   * @param {ParseObject} object Parse.Object to be saved eventually
   * @param {object} [serverOptions] See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Object.html#save Parse.Object.save} options.
   * @returns {Promise} A promise that is fulfilled if object is added to queue.
   * @static
   * @see Parse.Object#saveEventually
   */ save (object) {
        let serverOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.enqueue("save", object, serverOptions);
    },
    /**
   * Add object to queue with save operation.
   *
   * @function destroy
   * @name Parse.EventuallyQueue.destroy
   * @param {ParseObject} object Parse.Object to be destroyed eventually
   * @param {object} [serverOptions] See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Object.html#destroy Parse.Object.destroy} options
   * @returns {Promise} A promise that is fulfilled if object is added to queue.
   * @static
   * @see Parse.Object#destroyEventually
   */ destroy (object) {
        let serverOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.enqueue("destroy", object, serverOptions);
    },
    /**
   * Generate unique identifier to avoid duplicates and maintain previous state.
   *
   * @param {string} action save / destroy
   * @param {object} object Parse.Object to be queued
   * @returns {string}
   * @static
   * @ignore
   */ generateQueueId (action, object) {
        object._getId();
        const { className: className, id: id, _localId: _localId } = object;
        const uniqueId = object.get("hash") || _localId;
        return [
            action,
            className,
            id,
            uniqueId
        ].join("_");
    },
    /**
   * Build queue object and add to queue.
   *
   * @param {string} action save / destroy
   * @param {object} object Parse.Object to be queued
   * @param {object} [serverOptions]
   * @returns {Promise} A promise that is fulfilled if object is added to queue.
   * @static
   * @ignore
   */ async enqueue (action, object, serverOptions) {
        const queueData = await this.getQueue();
        const queueId = this.generateQueueId(action, object);
        let index = this.queueItemExists(queueData, queueId);
        if (index > -1) {
            // Add cached values to new object if they don't exist
            for(const prop in queueData[index].object)if (typeof object.get(prop) === "undefined") object.set(prop, queueData[index].object[prop]);
        } else index = queueData.length;
        queueData[index] = {
            queueId: queueId,
            action: action,
            object: object.toJSON(),
            serverOptions: serverOptions,
            id: object.id,
            className: object.className,
            hash: object.get("hash"),
            createdAt: new Date()
        };
        return this.setQueue(queueData);
    },
    store (data) {
        return $945d8d7b16514ba0$var$_Storage.default.setItemAsync($945d8d7b16514ba0$var$QUEUE_KEY, (0, $945d8d7b16514ba0$var$_stringify.default)(data));
    },
    load () {
        return $945d8d7b16514ba0$var$_Storage.default.getItemAsync($945d8d7b16514ba0$var$QUEUE_KEY);
    },
    /**
   * Sets the in-memory queue from local storage and returns.
   *
   * @function getQueue
   * @name Parse.EventuallyQueue.getQueue
   * @returns {Promise<QueueObject[]>}
   * @static
   */ async getQueue () {
        if ($945d8d7b16514ba0$var$dirtyCache) {
            $945d8d7b16514ba0$var$queueCache = JSON.parse(await this.load() || "[]");
            $945d8d7b16514ba0$var$dirtyCache = false;
        }
        return $945d8d7b16514ba0$var$queueCache;
    },
    /**
   * Saves the queue to local storage
   *
   * @param {Queue} queue Queue containing Parse.Object data.
   * @returns {Promise} A promise that is fulfilled when queue is stored.
   * @static
   * @ignore
   */ setQueue (queue) {
        $945d8d7b16514ba0$var$queueCache = queue;
        return this.store($945d8d7b16514ba0$var$queueCache);
    },
    /**
   * Removes Parse.Object data from queue.
   *
   * @param {string} queueId Unique identifier for Parse.Object data.
   * @returns {Promise} A promise that is fulfilled when queue is stored.
   * @static
   * @ignore
   */ async remove (queueId) {
        const queueData = await this.getQueue();
        const index = this.queueItemExists(queueData, queueId);
        if (index > -1) {
            (0, $945d8d7b16514ba0$var$_splice.default)(queueData).call(queueData, index, 1);
            await this.setQueue(queueData);
        }
    },
    /**
   * Removes all objects from queue.
   *
   * @function clear
   * @name Parse.EventuallyQueue.clear
   * @returns {Promise} A promise that is fulfilled when queue is cleared.
   * @static
   */ clear () {
        $945d8d7b16514ba0$var$queueCache = [];
        return this.store([]);
    },
    /**
   * Return the index of a queueId in the queue. Returns -1 if not found.
   *
   * @param {Queue} queue Queue containing Parse.Object data.
   * @param {string} queueId Unique identifier for Parse.Object data.
   * @returns {number}
   * @static
   * @ignore
   */ queueItemExists (queue, queueId) {
        return (0, $945d8d7b16514ba0$var$_findIndex.default)(queue).call(queue, (data)=>data.queueId === queueId);
    },
    /**
   * Return the number of objects in the queue.
   *
   * @function length
   * @name Parse.EventuallyQueue.length
   * @returns {Promise<number>}
   * @static
   */ async length () {
        const queueData = await this.getQueue();
        return queueData.length;
    },
    /**
   * Sends the queue to the server.
   *
   * @function sendQueue
   * @name Parse.EventuallyQueue.sendQueue
   * @returns {Promise<boolean>} Returns true if queue was sent successfully.
   * @static
   */ async sendQueue () {
        const queue = await this.getQueue();
        const queueData = [
            ...queue
        ];
        if (queueData.length === 0) return false;
        for(let i = 0; i < queueData.length; i += 1){
            const queueObject = queueData[i];
            const { id: id, hash: hash, className: className } = queueObject;
            const ObjectType = $945d8d7b16514ba0$var$_ParseObject.default.extend(className);
            if (id) await this.process.byId(ObjectType, queueObject);
            else if (hash) await this.process.byHash(ObjectType, queueObject);
            else await this.process.create(ObjectType, queueObject);
        }
        return true;
    },
    /**
   * Build queue object and add to queue.
   *
   * @param {ParseObject} object Parse.Object to be processed
   * @param {QueueObject} queueObject Parse.Object data from the queue
   * @returns {Promise} A promise that is fulfilled when operation is performed.
   * @static
   * @ignore
   */ async sendQueueCallback (object, queueObject) {
        if (!object) return this.remove(queueObject.queueId);
        switch(queueObject.action){
            case "save":
                // Queued update was overwritten by other request. Do not save
                if (typeof object.updatedAt !== "undefined" && object.updatedAt > new Date(queueObject.object.createdAt)) return this.remove(queueObject.queueId);
                try {
                    await object.save(queueObject.object, queueObject.serverOptions);
                    await this.remove(queueObject.queueId);
                } catch (e) {
                    if (e.code !== $945d8d7b16514ba0$var$_ParseError.default.CONNECTION_FAILED) await this.remove(queueObject.queueId);
                }
                break;
            case "destroy":
                try {
                    await object.destroy(queueObject.serverOptions);
                    await this.remove(queueObject.queueId);
                } catch (e) {
                    if (e.code !== $945d8d7b16514ba0$var$_ParseError.default.CONNECTION_FAILED) await this.remove(queueObject.queueId);
                }
                break;
        }
    },
    /**
   * Start polling server for network connection.
   * Will send queue if connection is established.
   *
   * @function poll
   * @name Parse.EventuallyQueue.poll
   * @param [ms] Milliseconds to ping the server. Default 2000ms
   * @static
   */ poll () {
        let ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2000;
        if ($945d8d7b16514ba0$var$polling) return;
        $945d8d7b16514ba0$var$polling = (0, $945d8d7b16514ba0$var$_setInterval2.default)(()=>{
            const RESTController = $945d8d7b16514ba0$var$_CoreManager.default.getRESTController();
            RESTController.request("GET", "health").then((_ref)=>{
                let { status: status } = _ref;
                if (status === "ok") {
                    this.stopPoll();
                    return this.sendQueue();
                }
            }).catch((e)=>e);
        }, ms);
    },
    /**
   * Turns off polling.
   *
   * @function stopPoll
   * @name Parse.EventuallyQueue.stopPoll
   * @static
   */ stopPoll () {
        clearInterval($945d8d7b16514ba0$var$polling);
        $945d8d7b16514ba0$var$polling = undefined;
    },
    /**
   * Return true if pinging the server.
   *
   * @function isPolling
   * @name Parse.EventuallyQueue.isPolling
   * @returns {boolean}
   * @static
   */ isPolling () {
        return !!$945d8d7b16514ba0$var$polling;
    },
    _setPolling (flag) {
        $945d8d7b16514ba0$var$polling = flag;
    },
    process: {
        create (ObjectType, queueObject) {
            const object = new ObjectType();
            return $945d8d7b16514ba0$var$EventuallyQueue.sendQueueCallback(object, queueObject);
        },
        async byId (ObjectType, queueObject) {
            const { sessionToken: sessionToken } = queueObject.serverOptions;
            const query = new $945d8d7b16514ba0$var$_ParseQuery.default(ObjectType);
            query.equalTo("objectId", queueObject.id);
            const results = await (0, $945d8d7b16514ba0$var$_find.default)(query).call(query, {
                sessionToken: sessionToken
            });
            return $945d8d7b16514ba0$var$EventuallyQueue.sendQueueCallback(results[0], queueObject);
        },
        async byHash (ObjectType, queueObject) {
            const { sessionToken: sessionToken } = queueObject.serverOptions;
            const query = new $945d8d7b16514ba0$var$_ParseQuery.default(ObjectType);
            query.equalTo("hash", queueObject.hash);
            const results = await (0, $945d8d7b16514ba0$var$_find.default)(query).call(query, {
                sessionToken: sessionToken
            });
            if (results.length > 0) return $945d8d7b16514ba0$var$EventuallyQueue.sendQueueCallback(results[0], queueObject);
            return $945d8d7b16514ba0$var$EventuallyQueue.process.create(ObjectType, queueObject);
        }
    }
};
module.exports = $945d8d7b16514ba0$var$EventuallyQueue;
var $945d8d7b16514ba0$var$_default = module.exports.default = $945d8d7b16514ba0$var$EventuallyQueue;

});
parcelRegister("aFg1C", function(module, exports) {

module.exports = (parcelRequire("1G8gP"));

});
parcelRegister("1G8gP", function(module, exports) {
"use strict";

var $lvdTQ = parcelRequire("lvdTQ");
module.exports = $lvdTQ;

});
parcelRegister("lvdTQ", function(module, exports) {
"use strict";

var $8hsAO = parcelRequire("8hsAO");

var $dG9aM = parcelRequire("dG9aM");
var $fa77466ff259f814$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.splice;
    return it === $fa77466ff259f814$var$ArrayPrototype || $8hsAO($fa77466ff259f814$var$ArrayPrototype, it) && own === $fa77466ff259f814$var$ArrayPrototype.splice ? $dG9aM : own;
};

});
parcelRegister("dG9aM", function(module, exports) {
"use strict";
parcelRequire("6Dlvu");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Array", "splice");

});
parcelRegister("6Dlvu", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $iJNxK = parcelRequire("iJNxK");

var $2s0YW = parcelRequire("2s0YW");

var $3ZmxQ = parcelRequire("3ZmxQ");

var $6ocdr = parcelRequire("6ocdr");

var $6lmzv = parcelRequire("6lmzv");

var $c8xJJ = parcelRequire("c8xJJ");

var $cU9IX = parcelRequire("cU9IX");

var $b1Dzg = parcelRequire("b1Dzg");

var $adIjL = parcelRequire("adIjL");

var $PdD5d = parcelRequire("PdD5d");
var $4d471167f3dade99$var$HAS_SPECIES_SUPPORT = $PdD5d("splice");
var $4d471167f3dade99$var$max = Math.max;
var $4d471167f3dade99$var$min = Math.min;
// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$ggcsv({
    target: "Array",
    proto: true,
    forced: !$4d471167f3dade99$var$HAS_SPECIES_SUPPORT
}, {
    splice: function splice(start, deleteCount /* , ...items */ ) {
        var O = $iJNxK(this);
        var len = $6ocdr(O);
        var actualStart = $2s0YW(start, len);
        var argumentsLength = arguments.length;
        var insertCount, actualDeleteCount, A, k, from, to;
        if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
        else if (argumentsLength === 1) {
            insertCount = 0;
            actualDeleteCount = len - actualStart;
        } else {
            insertCount = argumentsLength - 2;
            actualDeleteCount = $4d471167f3dade99$var$min($4d471167f3dade99$var$max($3ZmxQ(deleteCount), 0), len - actualStart);
        }
        $c8xJJ(len + insertCount - actualDeleteCount);
        A = $cU9IX(O, actualDeleteCount);
        for(k = 0; k < actualDeleteCount; k++){
            from = actualStart + k;
            if (from in O) $b1Dzg(A, k, O[from]);
        }
        A.length = actualDeleteCount;
        if (insertCount < actualDeleteCount) {
            for(k = actualStart; k < len - actualDeleteCount; k++){
                from = k + actualDeleteCount;
                to = k + insertCount;
                if (from in O) O[to] = O[from];
                else $adIjL(O, to);
            }
            for(k = len; k > len - actualDeleteCount + insertCount; k--)$adIjL(O, k - 1);
        } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
            from = k + actualDeleteCount - 1;
            to = k + insertCount - 1;
            if (from in O) O[to] = O[from];
            else $adIjL(O, to);
        }
        for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
        $6lmzv(O, len - actualDeleteCount + insertCount);
        return A;
    }
});

});
parcelRegister("6lmzv", function(module, exports) {
"use strict";

var $jeZ4p = parcelRequire("jeZ4p");

var $5zZFa = parcelRequire("5zZFa");
var $49e6368470390ed9$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $49e6368470390ed9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Safari < 13 does not throw an error in this case
var $49e6368470390ed9$var$SILENT_ON_NON_WRITABLE_LENGTH_SET = $jeZ4p && !function() {
    // makes no sense without proper strict mode support
    if (this !== undefined) return true;
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], "length", {
            writable: false
        }).length = 1;
    } catch (error) {
        return error instanceof TypeError;
    }
}();
module.exports = $49e6368470390ed9$var$SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
    if ($5zZFa(O) && !$49e6368470390ed9$var$getOwnPropertyDescriptor(O, "length").writable) throw new $49e6368470390ed9$var$$TypeError("Cannot set read only .length");
    return O.length = length;
} : function(O, length) {
    return O.length = length;
};

});

parcelRegister("adIjL", function(module, exports) {
"use strict";

var $k9gzN = parcelRequire("k9gzN");
var $770d7ee0fff0d93d$var$$TypeError = TypeError;
module.exports = function(O, P) {
    if (!delete O[P]) throw new $770d7ee0fff0d93d$var$$TypeError("Cannot delete property " + $k9gzN(P) + " of " + $k9gzN(O));
};

});






parcelRegister("arN5C", function(module, exports) {

module.exports = (parcelRequire("lz2LW"));

});
parcelRegister("lz2LW", function(module, exports) {
"use strict";

var $2xWef = parcelRequire("2xWef");
module.exports = $2xWef;

});
parcelRegister("2xWef", function(module, exports) {
"use strict";

var $8hsAO = parcelRequire("8hsAO");

var $2cpI0 = parcelRequire("2cpI0");
var $1dabd4db1b5fbde1$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.findIndex;
    return it === $1dabd4db1b5fbde1$var$ArrayPrototype || $8hsAO($1dabd4db1b5fbde1$var$ArrayPrototype, it) && own === $1dabd4db1b5fbde1$var$ArrayPrototype.findIndex ? $2cpI0 : own;
};

});
parcelRegister("2cpI0", function(module, exports) {
"use strict";
parcelRequire("kY0qH");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Array", "findIndex");

});
parcelRegister("kY0qH", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $igsV9 = parcelRequire("igsV9");
var $f439be9223039380$require$$findIndex = $igsV9.findIndex;

var $ajzxw = parcelRequire("ajzxw");
var $f439be9223039380$var$FIND_INDEX = "findIndex";
var $f439be9223039380$var$SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-findindex -- testing
if ($f439be9223039380$var$FIND_INDEX in []) Array(1)[$f439be9223039380$var$FIND_INDEX](function() {
    $f439be9223039380$var$SKIPS_HOLES = false;
});
// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$ggcsv({
    target: "Array",
    proto: true,
    forced: $f439be9223039380$var$SKIPS_HOLES
}, {
    findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
        return $f439be9223039380$require$$findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$ajzxw($f439be9223039380$var$FIND_INDEX);

});





parcelRegister("ds9Aj", function(module, exports) {

module.exports = (parcelRequire("c97Mc"));

});
parcelRegister("c97Mc", function(module, exports) {
"use strict";
parcelRequire("dGoN0");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.setInterval;

});
parcelRegister("dGoN0", function(module, exports) {
"use strict";
parcelRequire("kEQ2H");
parcelRequire("51F4q");

});
parcelRegister("kEQ2H", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $9l3PP = parcelRequire("9l3PP");

var $cDN8S = parcelRequire("cDN8S");
var $f09fe9a1ef40720b$var$setInterval = $cDN8S($9l3PP.setInterval, true);
// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$ggcsv({
    global: true,
    bind: true,
    forced: $9l3PP.setInterval !== $f09fe9a1ef40720b$var$setInterval
}, {
    setInterval: $f09fe9a1ef40720b$var$setInterval
});

});
parcelRegister("cDN8S", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");

var $2JOsI = parcelRequire("2JOsI");

var $e6Rz5 = parcelRequire("e6Rz5");

var $glx3T = parcelRequire("glx3T");

var $jVEg8 = parcelRequire("jVEg8");

var $hF40G = parcelRequire("hF40G");

var $10H6z = parcelRequire("10H6z");
var $933f3f25a064aad4$var$Function = $9l3PP.Function;
// dirty IE9- and Bun 0.3.0- checks
var $933f3f25a064aad4$var$WRAP = /MSIE .\./.test($jVEg8) || $glx3T === "BUN" && function() {
    var version = $9l3PP.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
module.exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $933f3f25a064aad4$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $10H6z(arguments.length, 1) > firstParamIndex;
        var fn = $e6Rz5(handler) ? handler : $933f3f25a064aad4$var$Function(handler);
        var params = boundArgs ? $hF40G(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $2JOsI(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};

});


parcelRegister("51F4q", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $9l3PP = parcelRequire("9l3PP");

var $cDN8S = parcelRequire("cDN8S");
var $3a8ce77b7590cf0f$var$setTimeout = $cDN8S($9l3PP.setTimeout, true);
// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$ggcsv({
    global: true,
    bind: true,
    forced: $9l3PP.setTimeout !== $3a8ce77b7590cf0f$var$setTimeout
}, {
    setTimeout: $3a8ce77b7590cf0f$var$setTimeout
});

});




parcelRegister("c61hX", function(module, exports) {

module.exports = (parcelRequire("c7TcM"));

});
parcelRegister("c7TcM", function(module, exports) {
"use strict";

var $1gQ9y = parcelRequire("1gQ9y");
module.exports = $1gQ9y;

});
parcelRegister("1gQ9y", function(module, exports) {
"use strict";

var $8hsAO = parcelRequire("8hsAO");

var $6G24z = parcelRequire("6G24z");
var $0ecfbd9b08790f64$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.find;
    return it === $0ecfbd9b08790f64$var$ArrayPrototype || $8hsAO($0ecfbd9b08790f64$var$ArrayPrototype, it) && own === $0ecfbd9b08790f64$var$ArrayPrototype.find ? $6G24z : own;
};

});
parcelRegister("6G24z", function(module, exports) {
"use strict";
parcelRequire("iz28m");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Array", "find");

});
parcelRegister("iz28m", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $igsV9 = parcelRequire("igsV9");
var $d83d269faf2aac2e$require$$find = $igsV9.find;

var $ajzxw = parcelRequire("ajzxw");
var $d83d269faf2aac2e$var$FIND = "find";
var $d83d269faf2aac2e$var$SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if ($d83d269faf2aac2e$var$FIND in []) Array(1)[$d83d269faf2aac2e$var$FIND](function() {
    $d83d269faf2aac2e$var$SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$ggcsv({
    target: "Array",
    proto: true,
    forced: $d83d269faf2aac2e$var$SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $d83d269faf2aac2e$require$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$ajzxw($d83d269faf2aac2e$var$FIND);

});





parcelRegister("fMBjE", function(module, exports) {
"use strict";

var $1X85b = parcelRequire("1X85b");


var $dzKYE = parcelRequire("dzKYE");

var $iHLHC = parcelRequire("iHLHC");
(parcelRequire("4i3Tl"))(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02f719f3389c19af$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $02f719f3389c19af$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $02f719f3389c19af$var$_freeze = $iHLHC((parcelRequire("hNwyw")));

var $02f719f3389c19af$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $02f719f3389c19af$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $02f719f3389c19af$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $02f719f3389c19af$var$_includes = $iHLHC((parcelRequire("dNrmj")));

var $02f719f3389c19af$var$_getPrototypeOf = $iHLHC((parcelRequire("kOp5W")));

var $02f719f3389c19af$var$_concat = $iHLHC((parcelRequire("oorJA")));

var $02f719f3389c19af$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $02f719f3389c19af$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $02f719f3389c19af$var$_create = $iHLHC((parcelRequire("jQ6K5")));

var $02f719f3389c19af$var$_defineProperty3 = $iHLHC((parcelRequire("4i3Tl")));

var $02f719f3389c19af$var$_find = $iHLHC((parcelRequire("c61hX")));

var $02f719f3389c19af$var$_map = $iHLHC((parcelRequire("2VoQi")));

var $02f719f3389c19af$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $02f719f3389c19af$var$_canBeSerialized = $iHLHC((parcelRequire("gloAc")));

var $02f719f3389c19af$var$_decode = $iHLHC((parcelRequire("42E6z")));

var $02f719f3389c19af$var$_encode = $iHLHC((parcelRequire("1rsTn")));

var $02f719f3389c19af$var$_escape = $iHLHC((parcelRequire("1JxNp")));

var $02f719f3389c19af$var$_ParseACL = $iHLHC((parcelRequire("2xGBa")));

var $02f719f3389c19af$var$_parseDate = $iHLHC((parcelRequire("ktbIl")));

var $02f719f3389c19af$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $02f719f3389c19af$var$_ParseFile = $iHLHC((parcelRequire("59JWU")));

var $9FsFR = parcelRequire("9FsFR");

var $klpRA = parcelRequire("klpRA");

var $02f719f3389c19af$var$_uuid = $iHLHC((parcelRequire("4q6en")));

var $3l0Qd = parcelRequire("3l0Qd");

var $02f719f3389c19af$var$_ParseRelation = $iHLHC((parcelRequire("967gW")));

var $02f719f3389c19af$var$SingleInstanceStateController = $02f719f3389c19af$var$_interopRequireWildcard((parcelRequire("8mp0p")));

var $02f719f3389c19af$var$_unique = $iHLHC((parcelRequire("aoRXv")));

var $02f719f3389c19af$var$UniqueInstanceStateController = $02f719f3389c19af$var$_interopRequireWildcard((parcelRequire("eyyNg")));

var $02f719f3389c19af$var$_unsavedChildren = $iHLHC((parcelRequire("zyRRD")));
function $02f719f3389c19af$var$_getRequireWildcardCache(e) {
    if ("function" != typeof $1X85b) return null;
    var r = new $1X85b(), t = new $1X85b();
    return ($02f719f3389c19af$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $02f719f3389c19af$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $02f719f3389c19af$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    };
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = (parcelRequire("4i3Tl")) && $dzKYE ? $dzKYE(e, u) : null;
        i && (i.get || i.set) ? (parcelRequire("4i3Tl"))(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// Mapping of class names to constructors, so we can populate objects from the
// server with appropriate subclasses of ParseObject
const $02f719f3389c19af$var$classMap = {};
// Global counter for generating unique Ids for non-single-instance objects
let $02f719f3389c19af$var$objectCount = 0;
// On web clients, objects are single-instance: any two objects with the same Id
// will have the same attributes. However, this may be dangerous default
// behavior in a server scenario
let $02f719f3389c19af$var$singleInstance = !$02f719f3389c19af$var$_CoreManager.default.get("IS_NODE");
if ($02f719f3389c19af$var$singleInstance) $02f719f3389c19af$var$_CoreManager.default.setObjectStateController($02f719f3389c19af$var$SingleInstanceStateController);
else $02f719f3389c19af$var$_CoreManager.default.setObjectStateController($02f719f3389c19af$var$UniqueInstanceStateController);
function $02f719f3389c19af$var$getServerUrlPath() {
    let serverUrl = $02f719f3389c19af$var$_CoreManager.default.get("SERVER_URL");
    if (serverUrl[serverUrl.length - 1] !== "/") serverUrl += "/";
    const url = serverUrl.replace(/https?:\/\//, "");
    return url.substr((0, $02f719f3389c19af$var$_indexOf.default)(url).call(url, "/"));
}
/**
 * Creates a new model with defined attributes.
 *
 * <p>You won't normally call this method directly.  It is recommended that
 * you use a subclass of <code>Parse.Object</code> instead, created by calling
 * <code>extend</code>.</p>
 *
 * <p>However, if you don't want to use a subclass, or aren't sure which
 * subclass is appropriate, you can use this form:<pre>
 *     var object = new Parse.Object("ClassName");
 * </pre>
 * That is basically equivalent to:<pre>
 *     var MyClass = Parse.Object.extend("ClassName");
 *     var object = new MyClass();
 * </pre></p>
 *
 * @alias Parse.Object
 */ class $02f719f3389c19af$var$ParseObject {
    /**
   * @param {string} className The class name for the object
   * @param {object} attributes The initial set of data to store in the object.
   * @param {object} options The options for this object instance.
   * @param {boolean} [options.ignoreValidation] Set to `true` ignore any attribute validation errors.
   */ constructor(className, attributes, options){
        /**
     * The ID of this object, unique within its class.
     *
     * @property {string} id
     */ (0, $02f719f3389c19af$var$_defineProperty2.default)(this, "id", void 0);
        (0, $02f719f3389c19af$var$_defineProperty2.default)(this, "_localId", void 0);
        (0, $02f719f3389c19af$var$_defineProperty2.default)(this, "_objCount", void 0);
        (0, $02f719f3389c19af$var$_defineProperty2.default)(this, "className", void 0);
        // Enable legacy initializers
        if (typeof this.initialize === "function") this.initialize.apply(this, arguments);
        let toSet = null;
        this._objCount = $02f719f3389c19af$var$objectCount++;
        if (typeof className === "string") {
            this.className = className;
            if (attributes && typeof attributes === "object") toSet = attributes;
        } else if (className && typeof className === "object") {
            this.className = className.className;
            toSet = {};
            for(const attr in className)if (attr !== "className") toSet[attr] = className[attr];
            if (attributes && typeof attributes === "object") options = attributes;
        }
        if (toSet && !this.set(toSet, options)) throw new Error("Can't create an invalid Parse Object");
    }
    /* Prototype getters / setters */ get attributes() {
        const stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
        return (0, $02f719f3389c19af$var$_freeze.default)(stateController.estimateAttributes(this._getStateIdentifier()));
    }
    /**
   * The first time this object was saved on the server.
   *
   * @property {Date} createdAt
   * @returns {Date}
   */ get createdAt() {
        return this._getServerData().createdAt;
    }
    /**
   * The last time this object was updated on the server.
   *
   * @property {Date} updatedAt
   * @returns {Date}
   */ get updatedAt() {
        return this._getServerData().updatedAt;
    }
    /* Private methods */ /**
   * Returns a local or server Id used uniquely identify this object
   *
   * @returns {string}
   */ _getId() {
        if (typeof this.id === "string") return this.id;
        if (typeof this._localId === "string") return this._localId;
        const localId = "local" + (0, $02f719f3389c19af$var$_uuid.default)();
        this._localId = localId;
        return localId;
    }
    /**
   * Returns a unique identifier used to pull data from the State Controller.
   *
   * @returns {Parse.Object|object}
   */ _getStateIdentifier() {
        if ($02f719f3389c19af$var$singleInstance) {
            let id = this.id;
            if (!id) id = this._getId();
            return {
                id: id,
                className: this.className
            };
        } else return this;
    }
    _getServerData() {
        const stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
        return stateController.getServerData(this._getStateIdentifier());
    }
    _clearServerData() {
        const serverData = this._getServerData();
        const unset = {};
        for(const attr in serverData)unset[attr] = undefined;
        const stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
        stateController.setServerData(this._getStateIdentifier(), unset);
    }
    _getPendingOps() {
        const stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
        return stateController.getPendingOps(this._getStateIdentifier());
    }
    /**
   * @param {Array<string>} [keysToClear] - if specified, only ops matching
   * these fields will be cleared
   */ _clearPendingOps(keysToClear) {
        const pending = this._getPendingOps();
        const latest = pending[pending.length - 1];
        const keys = keysToClear || (0, $02f719f3389c19af$var$_keys.default)(latest);
        (0, $02f719f3389c19af$var$_forEach.default)(keys).call(keys, (key)=>{
            delete latest[key];
        });
    }
    _getDirtyObjectAttributes() {
        const attributes = this.attributes;
        const stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
        const objectCache = stateController.getObjectCache(this._getStateIdentifier());
        const dirty = {};
        for(const attr in attributes){
            const val = attributes[attr];
            if (val && typeof val === "object" && !(val instanceof $02f719f3389c19af$var$ParseObject) && !(val instanceof $02f719f3389c19af$var$_ParseFile.default) && !(val instanceof $02f719f3389c19af$var$_ParseRelation.default)) // Due to the way browsers construct maps, the key order will not change
            // unless the object is changed
            try {
                const json = (0, $02f719f3389c19af$var$_encode.default)(val, false, true);
                const stringified = (0, $02f719f3389c19af$var$_stringify.default)(json);
                if (objectCache[attr] !== stringified) dirty[attr] = val;
            } catch (e) {
                // Error occurred, possibly by a nested unsaved pointer in a mutable container
                // No matter how it happened, it indicates a change in the attribute
                dirty[attr] = val;
            }
        }
        return dirty;
    }
    _toFullJSON(seen, offline) {
        const json = this.toJSON(seen, offline);
        json.__type = "Object";
        json.className = this.className;
        return json;
    }
    _getSaveJSON() {
        const pending = this._getPendingOps();
        const dirtyObjects = this._getDirtyObjectAttributes();
        const json = {};
        for(var attr in dirtyObjects){
            let isDotNotation = false;
            for(let i = 0; i < pending.length; i += 1){
                for(const field in pending[i])// Dot notation operations are handled later
                if ((0, $02f719f3389c19af$var$_includes.default)(field).call(field, ".")) {
                    const fieldName = field.split(".")[0];
                    if (fieldName === attr) {
                        isDotNotation = true;
                        break;
                    }
                }
            }
            if (!isDotNotation) json[attr] = new $3l0Qd.SetOp(dirtyObjects[attr]).toJSON();
        }
        for(attr in pending[0])json[attr] = pending[0][attr].toJSON();
        return json;
    }
    _getSaveParams() {
        let method = this.id ? "PUT" : "POST";
        const body = this._getSaveJSON();
        let path = "classes/" + this.className;
        if ($02f719f3389c19af$var$_CoreManager.default.get("ALLOW_CUSTOM_OBJECT_ID")) {
            if (!this.createdAt) {
                method = "POST";
                body.objectId = this.id;
            } else {
                method = "PUT";
                path += "/" + this.id;
            }
        } else if (this.id) path += "/" + this.id;
        else if (this.className === "_User") path = "users";
        return {
            method: method,
            body: body,
            path: path
        };
    }
    _finishFetch(serverData) {
        if (!this.id && serverData.objectId) this.id = serverData.objectId;
        const stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
        stateController.initializeState(this._getStateIdentifier());
        const decoded = {};
        for(const attr in serverData){
            if (attr === "ACL") decoded[attr] = new $02f719f3389c19af$var$_ParseACL.default(serverData[attr]);
            else if (attr !== "objectId") {
                decoded[attr] = (0, $02f719f3389c19af$var$_decode.default)(serverData[attr]);
                if (decoded[attr] instanceof $02f719f3389c19af$var$_ParseRelation.default) decoded[attr]._ensureParentAndKey(this, attr);
            }
        }
        if (decoded.createdAt && typeof decoded.createdAt === "string") decoded.createdAt = (0, $02f719f3389c19af$var$_parseDate.default)(decoded.createdAt);
        if (decoded.updatedAt && typeof decoded.updatedAt === "string") decoded.updatedAt = (0, $02f719f3389c19af$var$_parseDate.default)(decoded.updatedAt);
        if (!decoded.updatedAt && decoded.createdAt) decoded.updatedAt = decoded.createdAt;
        stateController.commitServerChanges(this._getStateIdentifier(), decoded);
    }
    _setExisted(existed) {
        const stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
        const state = stateController.getState(this._getStateIdentifier());
        if (state) state.existed = existed;
    }
    _migrateId(serverId) {
        if (this._localId && serverId) {
            if ($02f719f3389c19af$var$singleInstance) {
                const stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
                const oldState = stateController.removeState(this._getStateIdentifier());
                this.id = serverId;
                delete this._localId;
                if (oldState) stateController.initializeState(this._getStateIdentifier(), oldState);
            } else {
                this.id = serverId;
                delete this._localId;
            }
        }
    }
    _handleSaveResponse(response, status) {
        const changes = {};
        const stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
        const pending = stateController.popPendingState(this._getStateIdentifier());
        for(var attr in pending){
            if (pending[attr] instanceof $3l0Qd.RelationOp) changes[attr] = pending[attr].applyTo(undefined, this, attr);
            else if (!(attr in response)) // Only SetOps and UnsetOps should not come back with results
            changes[attr] = pending[attr].applyTo(undefined);
        }
        for(attr in response){
            if ((attr === "createdAt" || attr === "updatedAt") && typeof response[attr] === "string") changes[attr] = (0, $02f719f3389c19af$var$_parseDate.default)(response[attr]);
            else if (attr === "ACL") changes[attr] = new $02f719f3389c19af$var$_ParseACL.default(response[attr]);
            else if (attr !== "objectId") {
                const val = (0, $02f719f3389c19af$var$_decode.default)(response[attr]);
                if (val && (0, $02f719f3389c19af$var$_getPrototypeOf.default)(val) === Object.prototype) changes[attr] = {
                    ...this.attributes[attr],
                    ...val
                };
                else changes[attr] = val;
                if (changes[attr] instanceof $3l0Qd.UnsetOp) changes[attr] = undefined;
            }
        }
        if (changes.createdAt && !changes.updatedAt) changes.updatedAt = changes.createdAt;
        this._migrateId(response.objectId);
        if (status !== 201) this._setExisted(true);
        stateController.commitServerChanges(this._getStateIdentifier(), changes);
    }
    _handleSaveError() {
        const stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
        stateController.mergeFirstPendingState(this._getStateIdentifier());
    }
    static _getClassMap() {
        return $02f719f3389c19af$var$classMap;
    }
    /* Public methods */ initialize() {
    // NOOP
    }
    /**
   * Returns a JSON version of the object suitable for saving to Parse.
   *
   * @param seen
   * @param offline
   * @returns {object}
   */ toJSON(seen, offline) {
        const seenEntry = this.id ? this.className + ":" + this.id : this;
        seen = seen || [
            seenEntry
        ];
        const json = {};
        const attrs = this.attributes;
        for(const attr in attrs)if ((attr === "createdAt" || attr === "updatedAt") && attrs[attr].toJSON) json[attr] = attrs[attr].toJSON();
        else json[attr] = (0, $02f719f3389c19af$var$_encode.default)(attrs[attr], false, false, seen, offline);
        const pending = this._getPendingOps();
        for(const attr in pending[0])if ((0, $02f719f3389c19af$var$_indexOf.default)(attr).call(attr, ".") < 0) json[attr] = pending[0][attr].toJSON(offline);
        if (this.id) json.objectId = this.id;
        return json;
    }
    /**
   * Determines whether this ParseObject is equal to another ParseObject
   *
   * @param {object} other - An other object ot compare
   * @returns {boolean}
   */ equals(other) {
        if (this === other) return true;
        return other instanceof $02f719f3389c19af$var$ParseObject && this.className === other.className && this.id === other.id && typeof this.id !== "undefined";
    }
    /**
   * Returns true if this object has been modified since its last
   * save/refresh.  If an attribute is specified, it returns true only if that
   * particular attribute has been modified since the last save/refresh.
   *
   * @param {string} attr An attribute name (optional).
   * @returns {boolean}
   */ dirty(attr) {
        if (!this.id) return true;
        const pendingOps = this._getPendingOps();
        const dirtyObjects = this._getDirtyObjectAttributes();
        if (attr) {
            if (dirtyObjects.hasOwnProperty(attr)) return true;
            for(let i = 0; i < pendingOps.length; i++){
                if (pendingOps[i].hasOwnProperty(attr)) return true;
            }
            return false;
        }
        if ((0, $02f719f3389c19af$var$_keys.default)(pendingOps[0]).length !== 0) return true;
        if ((0, $02f719f3389c19af$var$_keys.default)(dirtyObjects).length !== 0) return true;
        return false;
    }
    /**
   * Returns an array of keys that have been modified since last save/refresh
   *
   * @returns {string[]}
   */ dirtyKeys() {
        const pendingOps = this._getPendingOps();
        const keys = {};
        for(let i = 0; i < pendingOps.length; i++)for(const attr in pendingOps[i])keys[attr] = true;
        const dirtyObjects = this._getDirtyObjectAttributes();
        for(const attr in dirtyObjects)keys[attr] = true;
        return (0, $02f719f3389c19af$var$_keys.default)(keys);
    }
    /**
   * Returns true if the object has been fetched.
   *
   * @returns {boolean}
   */ isDataAvailable() {
        const serverData = this._getServerData();
        return !!(0, $02f719f3389c19af$var$_keys.default)(serverData).length;
    }
    /**
   * Gets a Pointer referencing this Object.
   *
   * @returns {Pointer}
   */ toPointer() {
        if (!this.id) throw new Error("Cannot create a pointer to an unsaved ParseObject");
        return {
            __type: "Pointer",
            className: this.className,
            objectId: this.id
        };
    }
    /**
   * Gets a Pointer referencing this Object.
   *
   * @returns {Pointer}
   */ toOfflinePointer() {
        if (!this._localId) throw new Error("Cannot create a offline pointer to a saved ParseObject");
        return {
            __type: "Object",
            className: this.className,
            _localId: this._localId
        };
    }
    /**
   * Gets the value of an attribute.
   *
   * @param {string} attr The string name of an attribute.
   * @returns {*}
   */ get(attr) {
        return this.attributes[attr];
    }
    /**
   * Gets a relation on the given class for the attribute.
   *
   * @param {string} attr The attribute to get the relation for.
   * @returns {Parse.Relation}
   */ relation(attr) {
        const value = this.get(attr);
        if (value) {
            if (!(value instanceof $02f719f3389c19af$var$_ParseRelation.default)) throw new Error("Called relation() on non-relation field " + attr);
            value._ensureParentAndKey(this, attr);
            return value;
        }
        return new $02f719f3389c19af$var$_ParseRelation.default(this, attr);
    }
    /**
   * Gets the HTML-escaped value of an attribute.
   *
   * @param {string} attr The string name of an attribute.
   * @returns {string}
   */ escape(attr) {
        let val = this.attributes[attr];
        if (val == null) return "";
        if (typeof val !== "string") {
            if (typeof val.toString !== "function") return "";
            val = val.toString();
        }
        return (0, $02f719f3389c19af$var$_escape.default)(val);
    }
    /**
   * Returns <code>true</code> if the attribute contains a value that is not
   * null or undefined.
   *
   * @param {string} attr The string name of the attribute.
   * @returns {boolean}
   */ has(attr) {
        const attributes = this.attributes;
        if (attributes.hasOwnProperty(attr)) return attributes[attr] != null;
        return false;
    }
    /**
   * Sets a hash of model attributes on the object.
   *
   * <p>You can call it with an object containing keys and values, with one
   * key and value, or dot notation.  For example:<pre>
   *   gameTurn.set({
   *     player: player1,
   *     diceRoll: 2
   *   }, {
   *     error: function(gameTurnAgain, error) {
   *       // The set failed validation.
   *     }
   *   });
   *
   *   game.set("currentPlayer", player2, {
   *     error: function(gameTurnAgain, error) {
   *       // The set failed validation.
   *     }
   *   });
   *
   *   game.set("finished", true);</pre></p>
   *
   *   game.set("player.score", 10);</pre></p>
   *
   * @param {(string|object)} key The key to set.
   * @param {(string|object)} value The value to give it.
   * @param {object} options A set of options for the set.
   *     The only supported option is <code>error</code>.
   * @returns {(ParseObject|boolean)} true if the set succeeded.
   */ set(key, value, options) {
        let changes = {};
        const newOps = {};
        if (key && typeof key === "object") {
            changes = key;
            options = value;
        } else if (typeof key === "string") changes[key] = value;
        else return this;
        options = options || {};
        let readonly = [];
        if (typeof this.constructor.readOnlyAttributes === "function") readonly = (0, $02f719f3389c19af$var$_concat.default)(readonly).call(readonly, this.constructor.readOnlyAttributes());
        for(const k in changes){
            if (k === "createdAt" || k === "updatedAt") continue;
            if ((0, $02f719f3389c19af$var$_indexOf.default)(readonly).call(readonly, k) > -1) throw new Error("Cannot modify readonly attribute: " + k);
            if (options.unset) newOps[k] = new $3l0Qd.UnsetOp();
            else if (changes[k] instanceof $3l0Qd.Op) newOps[k] = changes[k];
            else if (changes[k] && typeof changes[k] === "object" && typeof changes[k].__op === "string") newOps[k] = (0, $3l0Qd.opFromJSON)(changes[k]);
            else if (k === "objectId" || k === "id") {
                if (typeof changes[k] === "string") this.id = changes[k];
            } else if (k === "ACL" && typeof changes[k] === "object" && !(changes[k] instanceof $02f719f3389c19af$var$_ParseACL.default)) newOps[k] = new $3l0Qd.SetOp(new $02f719f3389c19af$var$_ParseACL.default(changes[k]));
            else if (changes[k] instanceof $02f719f3389c19af$var$_ParseRelation.default) {
                const relation = new $02f719f3389c19af$var$_ParseRelation.default(this, k);
                relation.targetClassName = changes[k].targetClassName;
                newOps[k] = new $3l0Qd.SetOp(relation);
            } else newOps[k] = new $3l0Qd.SetOp(changes[k]);
        }
        const currentAttributes = this.attributes;
        // Calculate new values
        const newValues = {};
        for(const attr in newOps){
            if (newOps[attr] instanceof $3l0Qd.RelationOp) newValues[attr] = newOps[attr].applyTo(currentAttributes[attr], this, attr);
            else if (!(newOps[attr] instanceof $3l0Qd.UnsetOp)) newValues[attr] = newOps[attr].applyTo(currentAttributes[attr]);
        }
        // Validate changes
        if (!options.ignoreValidation) {
            const validation = this.validate(newValues);
            if (validation) {
                if (typeof options.error === "function") options.error(this, validation);
                return false;
            }
        }
        // Consolidate Ops
        const pendingOps = this._getPendingOps();
        const last = pendingOps.length - 1;
        const stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
        for(const attr in newOps){
            const nextOp = newOps[attr].mergeWith(pendingOps[last][attr]);
            stateController.setPendingOp(this._getStateIdentifier(), attr, nextOp);
        }
        return this;
    }
    /**
   * Remove an attribute from the model. This is a noop if the attribute doesn't
   * exist.
   *
   * @param {string} attr The string name of an attribute.
   * @param options
   * @returns {(ParseObject | boolean)}
   */ unset(attr, options) {
        options = options || {};
        options.unset = true;
        return this.set(attr, null, options);
    }
    /**
   * Atomically increments the value of the given attribute the next time the
   * object is saved. If no amount is specified, 1 is used by default.
   *
   * @param attr {String} The key.
   * @param amount {Number} The amount to increment by (optional).
   * @returns {(ParseObject|boolean)}
   */ increment(attr, amount) {
        if (typeof amount === "undefined") amount = 1;
        if (typeof amount !== "number") throw new Error("Cannot increment by a non-numeric amount.");
        return this.set(attr, new $3l0Qd.IncrementOp(amount));
    }
    /**
   * Atomically decrements the value of the given attribute the next time the
   * object is saved. If no amount is specified, 1 is used by default.
   *
   * @param attr {String} The key.
   * @param amount {Number} The amount to decrement by (optional).
   * @returns {(ParseObject | boolean)}
   */ decrement(attr, amount) {
        if (typeof amount === "undefined") amount = 1;
        if (typeof amount !== "number") throw new Error("Cannot decrement by a non-numeric amount.");
        return this.set(attr, new $3l0Qd.IncrementOp(amount * -1));
    }
    /**
   * Atomically add an object to the end of the array associated with a given
   * key.
   *
   * @param attr {String} The key.
   * @param item {} The item to add.
   * @returns {(ParseObject | boolean)}
   */ add(attr, item) {
        return this.set(attr, new $3l0Qd.AddOp([
            item
        ]));
    }
    /**
   * Atomically add the objects to the end of the array associated with a given
   * key.
   *
   * @param attr {String} The key.
   * @param items {Object[]} The items to add.
   * @returns {(ParseObject | boolean)}
   */ addAll(attr, items) {
        return this.set(attr, new $3l0Qd.AddOp(items));
    }
    /**
   * Atomically add an object to the array associated with a given key, only
   * if it is not already present in the array. The position of the insert is
   * not guaranteed.
   *
   * @param attr {String} The key.
   * @param item {} The object to add.
   * @returns {(ParseObject | boolean)}
   */ addUnique(attr, item) {
        return this.set(attr, new $3l0Qd.AddUniqueOp([
            item
        ]));
    }
    /**
   * Atomically add the objects to the array associated with a given key, only
   * if it is not already present in the array. The position of the insert is
   * not guaranteed.
   *
   * @param attr {String} The key.
   * @param items {Object[]} The objects to add.
   * @returns {(ParseObject | boolean)}
   */ addAllUnique(attr, items) {
        return this.set(attr, new $3l0Qd.AddUniqueOp(items));
    }
    /**
   * Atomically remove all instances of an object from the array associated
   * with a given key.
   *
   * @param attr {String} The key.
   * @param item {} The object to remove.
   * @returns {(ParseObject | boolean)}
   */ remove(attr, item) {
        return this.set(attr, new $3l0Qd.RemoveOp([
            item
        ]));
    }
    /**
   * Atomically remove all instances of the objects from the array associated
   * with a given key.
   *
   * @param attr {String} The key.
   * @param items {Object[]} The object to remove.
   * @returns {(ParseObject | boolean)}
   */ removeAll(attr, items) {
        return this.set(attr, new $3l0Qd.RemoveOp(items));
    }
    /**
   * Returns an instance of a subclass of Parse.Op describing what kind of
   * modification has been performed on this field since the last time it was
   * saved. For example, after calling object.increment("x"), calling
   * object.op("x") would return an instance of Parse.Op.Increment.
   *
   * @param attr {String} The key.
   * @returns {Parse.Op | undefined} The operation, or undefined if none.
   */ op(attr) {
        const pending = this._getPendingOps();
        for(let i = pending.length; i--;){
            if (pending[i][attr]) return pending[i][attr];
        }
    }
    /**
   * Creates a new model with identical attributes to this one.
   *
   * @returns {Parse.Object}
   */ clone() {
        const clone = new this.constructor(this.className);
        let attributes = this.attributes;
        if (typeof this.constructor.readOnlyAttributes === "function") {
            const readonly = this.constructor.readOnlyAttributes() || [];
            // Attributes are frozen, so we have to rebuild an object,
            // rather than delete readonly keys
            const copy = {};
            for(const a in attributes)if ((0, $02f719f3389c19af$var$_indexOf.default)(readonly).call(readonly, a) < 0) copy[a] = attributes[a];
            attributes = copy;
        }
        if (clone.set) clone.set(attributes);
        return clone;
    }
    /**
   * Creates a new instance of this object. Not to be confused with clone()
   *
   * @returns {Parse.Object}
   */ newInstance() {
        const clone = new this.constructor(this.className);
        clone.id = this.id;
        if ($02f719f3389c19af$var$singleInstance) // Just return an object with the right id
        return clone;
        const stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
        if (stateController) stateController.duplicateState(this._getStateIdentifier(), clone._getStateIdentifier());
        return clone;
    }
    /**
   * Returns true if this object has never been saved to Parse.
   *
   * @returns {boolean}
   */ isNew() {
        return !this.id;
    }
    /**
   * Returns true if this object was created by the Parse server when the
   * object might have already been there (e.g. in the case of a Facebook
   * login)
   *
   * @returns {boolean}
   */ existed() {
        if (!this.id) return false;
        const stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
        const state = stateController.getState(this._getStateIdentifier());
        if (state) return state.existed;
        return false;
    }
    /**
   * Returns true if this object exists on the Server
   *
   * @param {object} options
   * Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   * </ul>
   * @returns {Promise<boolean>} A boolean promise that is fulfilled if object exists.
   */ async exists(options) {
        if (!this.id) return false;
        try {
            const ParseQuery = $02f719f3389c19af$var$_CoreManager.default.getParseQuery();
            const query = new ParseQuery(this.className);
            await query.get(this.id, options);
            return true;
        } catch (e) {
            if (e.code === $02f719f3389c19af$var$_ParseError.default.OBJECT_NOT_FOUND) return false;
            throw e;
        }
    }
    /**
   * Checks if the model is currently in a valid state.
   *
   * @returns {boolean}
   */ isValid() {
        return !this.validate(this.attributes);
    }
    /**
   * You should not call this function directly unless you subclass
   * <code>Parse.Object</code>, in which case you can override this method
   * to provide additional validation on <code>set</code> and
   * <code>save</code>.  Your implementation should return
   *
   * @param {object} attrs The current data to validate.
   * @returns {Parse.Error|boolean} False if the data is valid.  An error object otherwise.
   * @see Parse.Object#set
   */ validate(attrs) {
        if (attrs.hasOwnProperty("ACL") && !(attrs.ACL instanceof $02f719f3389c19af$var$_ParseACL.default)) return new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.OTHER_CAUSE, "ACL must be a Parse ACL.");
        for(const key in attrs){
            if (!/^[A-Za-z][0-9A-Za-z_.]*$/.test(key)) return new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.INVALID_KEY_NAME);
        }
        return false;
    }
    /**
   * Returns the ACL for this object.
   *
   * @returns {Parse.ACL|null} An instance of Parse.ACL.
   * @see Parse.Object#get
   */ getACL() {
        const acl = this.get("ACL");
        if (acl instanceof $02f719f3389c19af$var$_ParseACL.default) return acl;
        return null;
    }
    /**
   * Sets the ACL to be used for this object.
   *
   * @param {Parse.ACL} acl An instance of Parse.ACL.
   * @param {object} options
   * @returns {(ParseObject | boolean)} Whether the set passed validation.
   * @see Parse.Object#set
   */ setACL(acl, options) {
        return this.set("ACL", acl, options);
    }
    /**
   * Clears any (or specific) changes to this object made since the last call to save()
   *
   * @param {string} [keys] - specify which fields to revert
   */ revert() {
        let keysToRevert;
        for(var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++)keys[_key] = arguments[_key];
        if (keys.length) {
            keysToRevert = [];
            for (const key of keys){
                if (typeof key === "string") keysToRevert.push(key);
                else throw new Error("Parse.Object#revert expects either no, or a list of string, arguments.");
            }
        }
        this._clearPendingOps(keysToRevert);
    }
    /**
   * Clears all attributes on a model
   *
   * @returns {(ParseObject | boolean)}
   */ clear() {
        const attributes = this.attributes;
        const erasable = {};
        let readonly = [
            "createdAt",
            "updatedAt"
        ];
        if (typeof this.constructor.readOnlyAttributes === "function") readonly = (0, $02f719f3389c19af$var$_concat.default)(readonly).call(readonly, this.constructor.readOnlyAttributes());
        for(const attr in attributes)if ((0, $02f719f3389c19af$var$_indexOf.default)(readonly).call(readonly, attr) < 0) erasable[attr] = true;
        return this.set(erasable, {
            unset: true
        });
    }
    /**
   * Fetch the model from the server. If the server's representation of the
   * model differs from its current attributes, they will be overriden.
   *
   * @param {object} options
   * Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   *   <li>include: The name(s) of the key(s) to include. Can be a string, an array of strings,
   *       or an array of array of strings.
   *   <li>context: A dictionary that is accessible in Cloud Code `beforeFind` trigger.
   * </ul>
   * @returns {Promise} A promise that is fulfilled when the fetch
   *     completes.
   */ fetch(options) {
        options = options || {};
        const fetchOptions = {};
        if (options.hasOwnProperty("useMasterKey")) fetchOptions.useMasterKey = options.useMasterKey;
        if (options.hasOwnProperty("sessionToken")) fetchOptions.sessionToken = options.sessionToken;
        if (options.hasOwnProperty("context") && typeof options.context === "object") fetchOptions.context = options.context;
        if (options.hasOwnProperty("include")) {
            fetchOptions.include = [];
            if ((0, $02f719f3389c19af$var$_isArray.default)(options.include)) {
                var _context;
                (0, $02f719f3389c19af$var$_forEach.default)(_context = options.include).call(_context, (key)=>{
                    if ((0, $02f719f3389c19af$var$_isArray.default)(key)) {
                        var _context2;
                        fetchOptions.include = (0, $02f719f3389c19af$var$_concat.default)(_context2 = fetchOptions.include).call(_context2, key);
                    } else fetchOptions.include.push(key);
                });
            } else fetchOptions.include.push(options.include);
        }
        const controller = $02f719f3389c19af$var$_CoreManager.default.getObjectController();
        return controller.fetch(this, true, fetchOptions);
    }
    /**
   * Fetch the model from the server. If the server's representation of the
   * model differs from its current attributes, they will be overriden.
   *
   * Includes nested Parse.Objects for the provided key. You can use dot
   * notation to specify which fields in the included object are also fetched.
   *
   * @param {string | Array<string | Array<string>>} keys The name(s) of the key(s) to include.
   * @param {object} options
   * Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   * </ul>
   * @returns {Promise} A promise that is fulfilled when the fetch
   *     completes.
   */ fetchWithInclude(keys, options) {
        options = options || {};
        options.include = keys;
        return this.fetch(options);
    }
    /**
   * Saves this object to the server at some unspecified time in the future,
   * even if Parse is currently inaccessible.
   *
   * Use this when you may not have a solid network connection, and don't need to know when the save completes.
   * If there is some problem with the object such that it can't be saved, it will be silently discarded.
   *
   * Objects saved with this method will be stored locally in an on-disk cache until they can be delivered to Parse.
   * They will be sent immediately if possible. Otherwise, they will be sent the next time a network connection is
   * available. Objects saved this way will persist even after the app is closed, in which case they will be sent the
   * next time the app is opened.
   *
   * @param {object} [options]
   * Used to pass option parameters to method if arg1 and arg2 were both passed as strings.
   * Valid options are:
   * <ul>
   * <li>sessionToken: A valid session token, used for making a request on
   * behalf of a specific user.
   * <li>cascadeSave: If `false`, nested objects will not be saved (default is `true`).
   * <li>context: A dictionary that is accessible in Cloud Code `beforeSave` and `afterSave` triggers.
   * </ul>
   * @returns {Promise} A promise that is fulfilled when the save
   * completes.
   */ async saveEventually(options) {
        try {
            await this.save(null, options);
        } catch (e) {
            if (e.code === $02f719f3389c19af$var$_ParseError.default.CONNECTION_FAILED) {
                await $02f719f3389c19af$var$_CoreManager.default.getEventuallyQueue().save(this, options);
                $02f719f3389c19af$var$_CoreManager.default.getEventuallyQueue().poll();
            }
        }
        return this;
    }
    /**
   * Set a hash of model attributes, and save the model to the server.
   * updatedAt will be updated when the request returns.
   * You can either call it as:<pre>
   * object.save();</pre>
   * or<pre>
   * object.save(attrs);</pre>
   * or<pre>
   * object.save(null, options);</pre>
   * or<pre>
   * object.save(attrs, options);</pre>
   * or<pre>
   * object.save(key, value);</pre>
   * or<pre>
   * object.save(key, value, options);</pre>
   *
   * Example 1: <pre>
   * gameTurn.save({
   * player: "Jake Cutter",
   * diceRoll: 2
   * }).then(function(gameTurnAgain) {
   * // The save was successful.
   * }, function(error) {
   * // The save failed.  Error is an instance of Parse.Error.
   * });</pre>
   *
   * Example 2: <pre>
   * gameTurn.save("player", "Jake Cutter");</pre>
   *
   * @param {string | object | null} [arg1]
   * Valid options are:<ul>
   * <li>`Object` - Key/value pairs to update on the object.</li>
   * <li>`String` Key - Key of attribute to update (requires arg2 to also be string)</li>
   * <li>`null` - Passing null for arg1 allows you to save the object with options passed in arg2.</li>
   * </ul>
   * @param {string | object} [arg2]
   * <ul>
   * <li>`String` Value - If arg1 was passed as a key, arg2 is the value that should be set on that key.</li>
   * <li>`Object` Options - Valid options are:
   * <ul>
   * <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   * be used for this request.
   * <li>sessionToken: A valid session token, used for making a request on
   * behalf of a specific user.
   * <li>cascadeSave: If `false`, nested objects will not be saved (default is `true`).
   * <li>context: A dictionary that is accessible in Cloud Code `beforeSave` and `afterSave` triggers.
   * </ul>
   * </li>
   * </ul>
   * @param {object} [arg3]
   * Used to pass option parameters to method if arg1 and arg2 were both passed as strings.
   * Valid options are:
   * <ul>
   * <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   * be used for this request.
   * <li>sessionToken: A valid session token, used for making a request on
   * behalf of a specific user.
   * <li>cascadeSave: If `false`, nested objects will not be saved (default is `true`).
   * <li>context: A dictionary that is accessible in Cloud Code `beforeSave` and `afterSave` triggers.
   * </ul>
   * @returns {Promise} A promise that is fulfilled when the save
   * completes.
   */ save(arg1, arg2, arg3) {
        let attrs;
        let options;
        if (typeof arg1 === "object" || typeof arg1 === "undefined") {
            attrs = arg1;
            if (typeof arg2 === "object") options = arg2;
        } else {
            attrs = {};
            attrs[arg1] = arg2;
            options = arg3;
        }
        options = options || {};
        if (attrs) {
            let validationError;
            options.error = (_, validation)=>{
                validationError = validation;
            };
            const success = this.set(attrs, options);
            if (!success) return $02f719f3389c19af$var$_promise.default.reject(validationError);
        }
        const saveOptions = {};
        if (options.hasOwnProperty("useMasterKey")) saveOptions.useMasterKey = !!options.useMasterKey;
        if (options.hasOwnProperty("sessionToken") && typeof options.sessionToken === "string") saveOptions.sessionToken = options.sessionToken;
        if (options.hasOwnProperty("installationId") && typeof options.installationId === "string") saveOptions.installationId = options.installationId;
        if (options.hasOwnProperty("context") && typeof options.context === "object") saveOptions.context = options.context;
        const controller = $02f719f3389c19af$var$_CoreManager.default.getObjectController();
        const unsaved = options.cascadeSave !== false ? (0, $02f719f3389c19af$var$_unsavedChildren.default)(this) : null;
        return controller.save(unsaved, saveOptions).then(()=>{
            return controller.save(this, saveOptions);
        });
    }
    /**
   * Deletes this object from the server at some unspecified time in the future,
   * even if Parse is currently inaccessible.
   *
   * Use this when you may not have a solid network connection,
   * and don't need to know when the delete completes. If there is some problem with the object
   * such that it can't be deleted, the request will be silently discarded.
   *
   * Delete instructions made with this method will be stored locally in an on-disk cache until they can be transmitted
   * to Parse. They will be sent immediately if possible. Otherwise, they will be sent the next time a network connection
   * is available. Delete requests will persist even after the app is closed, in which case they will be sent the
   * next time the app is opened.
   *
   * @param {object} [options]
   * Valid options are:<ul>
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   *   <li>context: A dictionary that is accessible in Cloud Code `beforeDelete` and `afterDelete` triggers.
   * </ul>
   * @returns {Promise} A promise that is fulfilled when the destroy
   *     completes.
   */ async destroyEventually(options) {
        try {
            await this.destroy(options);
        } catch (e) {
            if (e.code === $02f719f3389c19af$var$_ParseError.default.CONNECTION_FAILED) {
                await $02f719f3389c19af$var$_CoreManager.default.getEventuallyQueue().destroy(this, options);
                $02f719f3389c19af$var$_CoreManager.default.getEventuallyQueue().poll();
            }
        }
        return this;
    }
    /**
   * Destroy this model on the server if it was already persisted.
   *
   * @param {object} options
   * Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   *   <li>context: A dictionary that is accessible in Cloud Code `beforeDelete` and `afterDelete` triggers.
   * </ul>
   * @returns {Promise} A promise that is fulfilled when the destroy
   *     completes.
   */ destroy(options) {
        options = options || {};
        const destroyOptions = {};
        if (options.hasOwnProperty("useMasterKey")) destroyOptions.useMasterKey = options.useMasterKey;
        if (options.hasOwnProperty("sessionToken")) destroyOptions.sessionToken = options.sessionToken;
        if (options.hasOwnProperty("context") && typeof options.context === "object") destroyOptions.context = options.context;
        if (!this.id) return $02f719f3389c19af$var$_promise.default.resolve();
        return $02f719f3389c19af$var$_CoreManager.default.getObjectController().destroy(this, destroyOptions);
    }
    /**
   * Asynchronously stores the object and every object it points to in the local datastore,
   * recursively, using a default pin name: _default.
   *
   * If those other objects have not been fetched from Parse, they will not be stored.
   * However, if they have changed data, all the changes will be retained.
   *
   * <pre>
   * await object.pin();
   * </pre>
   *
   * To retrieve object:
   * <code>query.fromLocalDatastore()</code> or <code>query.fromPin()</code>
   *
   * @returns {Promise} A promise that is fulfilled when the pin completes.
   */ pin() {
        return $02f719f3389c19af$var$ParseObject.pinAllWithName($klpRA.DEFAULT_PIN, [
            this
        ]);
    }
    /**
   * Asynchronously removes the object and every object it points to in the local datastore,
   * recursively, using a default pin name: _default.
   *
   * <pre>
   * await object.unPin();
   * </pre>
   *
   * @returns {Promise} A promise that is fulfilled when the unPin completes.
   */ unPin() {
        return $02f719f3389c19af$var$ParseObject.unPinAllWithName($klpRA.DEFAULT_PIN, [
            this
        ]);
    }
    /**
   * Asynchronously returns if the object is pinned
   *
   * <pre>
   * const isPinned = await object.isPinned();
   * </pre>
   *
   * @returns {Promise<boolean>} A boolean promise that is fulfilled if object is pinned.
   */ async isPinned() {
        const localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
        if (!localDatastore.isEnabled) return $02f719f3389c19af$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
        const objectKey = localDatastore.getKeyForObject(this);
        const pin = await localDatastore.fromPinWithName(objectKey);
        return pin.length > 0;
    }
    /**
   * Asynchronously stores the objects and every object they point to in the local datastore, recursively.
   *
   * If those other objects have not been fetched from Parse, they will not be stored.
   * However, if they have changed data, all the changes will be retained.
   *
   * <pre>
   * await object.pinWithName(name);
   * </pre>
   *
   * To retrieve object:
   * <code>query.fromLocalDatastore()</code> or <code>query.fromPinWithName(name)</code>
   *
   * @param {string} name Name of Pin.
   * @returns {Promise} A promise that is fulfilled when the pin completes.
   */ pinWithName(name) {
        return $02f719f3389c19af$var$ParseObject.pinAllWithName(name, [
            this
        ]);
    }
    /**
   * Asynchronously removes the object and every object it points to in the local datastore, recursively.
   *
   * <pre>
   * await object.unPinWithName(name);
   * </pre>
   *
   * @param {string} name Name of Pin.
   * @returns {Promise} A promise that is fulfilled when the unPin completes.
   */ unPinWithName(name) {
        return $02f719f3389c19af$var$ParseObject.unPinAllWithName(name, [
            this
        ]);
    }
    /**
   * Asynchronously loads data from the local datastore into this object.
   *
   * <pre>
   * await object.fetchFromLocalDatastore();
   * </pre>
   *
   * You can create an unfetched pointer with <code>Parse.Object.createWithoutData()</code>
   * and then call <code>fetchFromLocalDatastore()</code> on it.
   *
   * @returns {Promise} A promise that is fulfilled when the fetch completes.
   */ async fetchFromLocalDatastore() {
        const localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
        if (!localDatastore.isEnabled) throw new Error("Parse.enableLocalDatastore() must be called first");
        const objectKey = localDatastore.getKeyForObject(this);
        const pinned = await localDatastore._serializeObject(objectKey);
        if (!pinned) throw new Error("Cannot fetch an unsaved ParseObject");
        const result = $02f719f3389c19af$var$ParseObject.fromJSON(pinned);
        this._finishFetch(result.toJSON());
        return this;
    }
    /* Static methods */ static _clearAllState() {
        const stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
        stateController.clearAllState();
    }
    /**
   * Fetches the given list of Parse.Object.
   * If any error is encountered, stops and calls the error handler.
   *
   * <pre>
   *   Parse.Object.fetchAll([object1, object2, ...])
   *    .then((list) => {
   *      // All the objects were fetched.
   *    }, (error) => {
   *      // An error occurred while fetching one of the objects.
   *    });
   * </pre>
   *
   * @param {Array} list A list of <code>Parse.Object</code>.
   * @param {object} options
   * Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   *   <li>include: The name(s) of the key(s) to include. Can be a string, an array of strings,
   *       or an array of array of strings.
   * </ul>
   * @static
   * @returns {Parse.Object[]}
   */ static fetchAll(list) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const queryOptions = {};
        if (options.hasOwnProperty("useMasterKey")) queryOptions.useMasterKey = options.useMasterKey;
        if (options.hasOwnProperty("sessionToken")) queryOptions.sessionToken = options.sessionToken;
        if (options.hasOwnProperty("include")) queryOptions.include = $02f719f3389c19af$var$ParseObject.handleIncludeOptions(options);
        return $02f719f3389c19af$var$_CoreManager.default.getObjectController().fetch(list, true, queryOptions);
    }
    /**
   * Fetches the given list of Parse.Object.
   *
   * Includes nested Parse.Objects for the provided key. You can use dot
   * notation to specify which fields in the included object are also fetched.
   *
   * If any error is encountered, stops and calls the error handler.
   *
   * <pre>
   *   Parse.Object.fetchAllWithInclude([object1, object2, ...], [pointer1, pointer2, ...])
   *    .then((list) => {
   *      // All the objects were fetched.
   *    }, (error) => {
   *      // An error occurred while fetching one of the objects.
   *    });
   * </pre>
   *
   * @param {Array} list A list of <code>Parse.Object</code>.
   * @param {string | Array<string | Array<string>>} keys The name(s) of the key(s) to include.
   * @param {object} options
   * Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   * </ul>
   * @static
   * @returns {Parse.Object[]}
   */ static fetchAllWithInclude(list, keys, options) {
        options = options || {};
        options.include = keys;
        return $02f719f3389c19af$var$ParseObject.fetchAll(list, options);
    }
    /**
   * Fetches the given list of Parse.Object if needed.
   * If any error is encountered, stops and calls the error handler.
   *
   * Includes nested Parse.Objects for the provided key. You can use dot
   * notation to specify which fields in the included object are also fetched.
   *
   * If any error is encountered, stops and calls the error handler.
   *
   * <pre>
   *   Parse.Object.fetchAllIfNeededWithInclude([object1, object2, ...], [pointer1, pointer2, ...])
   *    .then((list) => {
   *      // All the objects were fetched.
   *    }, (error) => {
   *      // An error occurred while fetching one of the objects.
   *    });
   * </pre>
   *
   * @param {Array} list A list of <code>Parse.Object</code>.
   * @param {string | Array<string | Array<string>>} keys The name(s) of the key(s) to include.
   * @param {object} options
   * Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   * </ul>
   * @static
   * @returns {Parse.Object[]}
   */ static fetchAllIfNeededWithInclude(list, keys, options) {
        options = options || {};
        options.include = keys;
        return $02f719f3389c19af$var$ParseObject.fetchAllIfNeeded(list, options);
    }
    /**
   * Fetches the given list of Parse.Object if needed.
   * If any error is encountered, stops and calls the error handler.
   *
   * <pre>
   *   Parse.Object.fetchAllIfNeeded([object1, ...])
   *    .then((list) => {
   *      // Objects were fetched and updated.
   *    }, (error) => {
   *      // An error occurred while fetching one of the objects.
   *    });
   * </pre>
   *
   * @param {Array} list A list of <code>Parse.Object</code>.
   * @param {object} options
   * @static
   * @returns {Parse.Object[]}
   */ static fetchAllIfNeeded(list, options) {
        options = options || {};
        const queryOptions = {};
        if (options.hasOwnProperty("useMasterKey")) queryOptions.useMasterKey = options.useMasterKey;
        if (options.hasOwnProperty("sessionToken")) queryOptions.sessionToken = options.sessionToken;
        if (options.hasOwnProperty("include")) queryOptions.include = $02f719f3389c19af$var$ParseObject.handleIncludeOptions(options);
        return $02f719f3389c19af$var$_CoreManager.default.getObjectController().fetch(list, false, queryOptions);
    }
    static handleIncludeOptions(options) {
        let include = [];
        if ((0, $02f719f3389c19af$var$_isArray.default)(options.include)) {
            var _context3;
            (0, $02f719f3389c19af$var$_forEach.default)(_context3 = options.include).call(_context3, (key)=>{
                if ((0, $02f719f3389c19af$var$_isArray.default)(key)) include = (0, $02f719f3389c19af$var$_concat.default)(include).call(include, key);
                else include.push(key);
            });
        } else include.push(options.include);
        return include;
    }
    /**
   * Destroy the given list of models on the server if it was already persisted.
   *
   * <p>Unlike saveAll, if an error occurs while deleting an individual model,
   * this method will continue trying to delete the rest of the models if
   * possible, except in the case of a fatal error like a connection error.
   *
   * <p>In particular, the Parse.Error object returned in the case of error may
   * be one of two types:
   *
   * <ul>
   * <li>A Parse.Error.AGGREGATE_ERROR. This object's "errors" property is an
   * array of other Parse.Error objects. Each error object in this array
   * has an "object" property that references the object that could not be
   * deleted (for instance, because that object could not be found).</li>
   * <li>A non-aggregate Parse.Error. This indicates a serious error that
   * caused the delete operation to be aborted partway through (for
   * instance, a connection failure in the middle of the delete).</li>
   * </ul>
   *
   * <pre>
   * Parse.Object.destroyAll([object1, object2, ...])
   * .then((list) => {
   * // All the objects were deleted.
   * }, (error) => {
   * // An error occurred while deleting one or more of the objects.
   * // If this is an aggregate error, then we can inspect each error
   * // object individually to determine the reason why a particular
   * // object was not deleted.
   * if (error.code === Parse.Error.AGGREGATE_ERROR) {
   * for (var i = 0; i < error.errors.length; i++) {
   * console.log("Couldn't delete " + error.errors[i].object.id +
   * "due to " + error.errors[i].message);
   * }
   * } else {
   * console.log("Delete aborted because of " + error.message);
   * }
   * });
   * </pre>
   *
   * @param {Array} list A list of <code>Parse.Object</code>.
   * @param {object} options
   * @static
   * @returns {Promise} A promise that is fulfilled when the destroyAll
   * completes.
   */ static destroyAll(list) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const destroyOptions = {};
        if (options.hasOwnProperty("useMasterKey")) destroyOptions.useMasterKey = options.useMasterKey;
        if (options.hasOwnProperty("sessionToken")) destroyOptions.sessionToken = options.sessionToken;
        if (options.hasOwnProperty("batchSize") && typeof options.batchSize === "number") destroyOptions.batchSize = options.batchSize;
        if (options.hasOwnProperty("context") && typeof options.context === "object") destroyOptions.context = options.context;
        return $02f719f3389c19af$var$_CoreManager.default.getObjectController().destroy(list, destroyOptions);
    }
    /**
   * Saves the given list of Parse.Object.
   * If any error is encountered, stops and calls the error handler.
   *
   * <pre>
   * Parse.Object.saveAll([object1, object2, ...])
   * .then((list) => {
   * // All the objects were saved.
   * }, (error) => {
   * // An error occurred while saving one of the objects.
   * });
   * </pre>
   *
   * @param {Array} list A list of <code>Parse.Object</code>.
   * @param {object} options
   * @static
   * @returns {Parse.Object[]}
   */ static saveAll(list) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const saveOptions = {};
        if (options.hasOwnProperty("useMasterKey")) saveOptions.useMasterKey = options.useMasterKey;
        if (options.hasOwnProperty("sessionToken")) saveOptions.sessionToken = options.sessionToken;
        if (options.hasOwnProperty("batchSize") && typeof options.batchSize === "number") saveOptions.batchSize = options.batchSize;
        if (options.hasOwnProperty("context") && typeof options.context === "object") saveOptions.context = options.context;
        return $02f719f3389c19af$var$_CoreManager.default.getObjectController().save(list, saveOptions);
    }
    /**
   * Creates a reference to a subclass of Parse.Object with the given id. This
   * does not exist on Parse.Object, only on subclasses.
   *
   * <p>A shortcut for: <pre>
   *  var Foo = Parse.Object.extend("Foo");
   *  var pointerToFoo = new Foo();
   *  pointerToFoo.id = "myObjectId";
   * </pre>
   *
   * @param {string} id The ID of the object to create a reference to.
   * @static
   * @returns {Parse.Object} A Parse.Object reference.
   */ static createWithoutData(id) {
        const obj = new this();
        obj.id = id;
        return obj;
    }
    /**
   * Creates a new instance of a Parse Object from a JSON representation.
   *
   * @param {object} json The JSON map of the Object's data
   * @param {boolean} override In single instance mode, all old server data
   *   is overwritten if this is set to true
   * @param {boolean} dirty Whether the Parse.Object should set JSON keys to dirty
   * @static
   * @returns {Parse.Object} A Parse.Object reference
   */ static fromJSON(json, override, dirty) {
        if (!json.className) throw new Error("Cannot create an object without a className");
        const constructor = $02f719f3389c19af$var$classMap[json.className];
        const o = constructor ? new constructor(json.className) : new $02f719f3389c19af$var$ParseObject(json.className);
        const otherAttributes = {};
        for(const attr in json)if (attr !== "className" && attr !== "__type") {
            otherAttributes[attr] = json[attr];
            if (dirty) o.set(attr, json[attr]);
        }
        if (override) {
            // id needs to be set before clearServerData can work
            if (otherAttributes.objectId) o.id = otherAttributes.objectId;
            let preserved = null;
            if (typeof o._preserveFieldsOnFetch === "function") preserved = o._preserveFieldsOnFetch();
            o._clearServerData();
            if (preserved) o._finishFetch(preserved);
        }
        o._finishFetch(otherAttributes);
        if (json.objectId) o._setExisted(true);
        return o;
    }
    /**
   * Registers a subclass of Parse.Object with a specific class name.
   * When objects of that class are retrieved from a query, they will be
   * instantiated with this subclass.
   * This is only necessary when using ES6 subclassing.
   *
   * @param {string} className The class name of the subclass
   * @param {Function} constructor The subclass
   */ static registerSubclass(className, constructor) {
        if (typeof className !== "string") throw new TypeError("The first argument must be a valid class name.");
        if (typeof constructor === "undefined") throw new TypeError("You must supply a subclass constructor.");
        if (typeof constructor !== "function") throw new TypeError("You must register the subclass constructor. Did you attempt to register an instance of the subclass?");
        $02f719f3389c19af$var$classMap[className] = constructor;
        if (!constructor.className) constructor.className = className;
    }
    /**
   * Unegisters a subclass of Parse.Object with a specific class name.
   *
   * @param {string} className The class name of the subclass
   */ static unregisterSubclass(className) {
        if (typeof className !== "string") throw new TypeError("The first argument must be a valid class name.");
        delete $02f719f3389c19af$var$classMap[className];
    }
    /**
   * Creates a new subclass of Parse.Object for the given Parse class name.
   *
   * <p>Every extension of a Parse class will inherit from the most recent
   * previous extension of that class. When a Parse.Object is automatically
   * created by parsing JSON, it will use the most recent extension of that
   * class.</p>
   *
   * <p>You should call either:<pre>
   *     var MyClass = Parse.Object.extend("MyClass", {
   *         <i>Instance methods</i>,
   *         initialize: function(attrs, options) {
   *             this.someInstanceProperty = [],
   *             <i>Other instance properties</i>
   *         }
   *     }, {
   *         <i>Class properties</i>
   *     });</pre>
   * or, for Backbone compatibility:<pre>
   *     var MyClass = Parse.Object.extend({
   *         className: "MyClass",
   *         <i>Instance methods</i>,
   *         initialize: function(attrs, options) {
   *             this.someInstanceProperty = [],
   *             <i>Other instance properties</i>
   *         }
   *     }, {
   *         <i>Class properties</i>
   *     });</pre></p>
   *
   * @param {string} className The name of the Parse class backing this model.
   * @param {object} [protoProps] Instance properties to add to instances of the
   *     class returned from this method.
   * @param {object} [classProps] Class properties to add the class returned from
   *     this method.
   * @returns {Parse.Object} A new subclass of Parse.Object.
   */ static extend(className, protoProps, classProps) {
        if (typeof className !== "string") {
            if (className && typeof className.className === "string") return $02f719f3389c19af$var$ParseObject.extend(className.className, className, protoProps);
            else throw new Error("Parse.Object.extend's first argument should be the className.");
        }
        let adjustedClassName = className;
        if (adjustedClassName === "User" && $02f719f3389c19af$var$_CoreManager.default.get("PERFORM_USER_REWRITE")) adjustedClassName = "_User";
        let parentProto = $02f719f3389c19af$var$ParseObject.prototype;
        if (this.hasOwnProperty("__super__") && this.__super__) parentProto = this.prototype;
        let ParseObjectSubclass = function(attributes, options) {
            this.className = adjustedClassName;
            this._objCount = $02f719f3389c19af$var$objectCount++;
            // Enable legacy initializers
            if (typeof this.initialize === "function") this.initialize.apply(this, arguments);
            if (this._initializers) for (const initializer of this._initializers)initializer.apply(this, arguments);
            if (attributes && typeof attributes === "object") {
                if (!this.set(attributes || {}, options)) throw new Error("Can't create an invalid Parse Object");
            }
        };
        if ($02f719f3389c19af$var$classMap[adjustedClassName]) ParseObjectSubclass = $02f719f3389c19af$var$classMap[adjustedClassName];
        else {
            ParseObjectSubclass.extend = function(name, protoProps, classProps) {
                if (typeof name === "string") return $02f719f3389c19af$var$ParseObject.extend.call(ParseObjectSubclass, name, protoProps, classProps);
                return $02f719f3389c19af$var$ParseObject.extend.call(ParseObjectSubclass, adjustedClassName, name, protoProps);
            };
            ParseObjectSubclass.createWithoutData = $02f719f3389c19af$var$ParseObject.createWithoutData;
            ParseObjectSubclass.className = adjustedClassName;
            ParseObjectSubclass.__super__ = parentProto;
            ParseObjectSubclass.prototype = (0, $02f719f3389c19af$var$_create.default)(parentProto, {
                constructor: {
                    value: ParseObjectSubclass,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
        if (protoProps) for(const prop in protoProps){
            if (prop === "initialize") {
                (0, $02f719f3389c19af$var$_defineProperty3.default)(ParseObjectSubclass.prototype, "_initializers", {
                    value: [
                        ...ParseObjectSubclass.prototype._initializers || [],
                        protoProps[prop]
                    ],
                    enumerable: false,
                    writable: true,
                    configurable: true
                });
                continue;
            }
            if (prop !== "className") (0, $02f719f3389c19af$var$_defineProperty3.default)(ParseObjectSubclass.prototype, prop, {
                value: protoProps[prop],
                enumerable: false,
                writable: true,
                configurable: true
            });
        }
        if (classProps) {
            for(const prop in classProps)if (prop !== "className") (0, $02f719f3389c19af$var$_defineProperty3.default)(ParseObjectSubclass, prop, {
                value: classProps[prop],
                enumerable: false,
                writable: true,
                configurable: true
            });
        }
        $02f719f3389c19af$var$classMap[adjustedClassName] = ParseObjectSubclass;
        return ParseObjectSubclass;
    }
    /**
   * Enable single instance objects, where any local objects with the same Id
   * share the same attributes, and stay synchronized with each other.
   * This is disabled by default in server environments, since it can lead to
   * security issues.
   *
   * @static
   */ static enableSingleInstance() {
        $02f719f3389c19af$var$singleInstance = true;
        $02f719f3389c19af$var$_CoreManager.default.setObjectStateController($02f719f3389c19af$var$SingleInstanceStateController);
    }
    /**
   * Disable single instance objects, where any local objects with the same Id
   * share the same attributes, and stay synchronized with each other.
   * When disabled, you can have two instances of the same object in memory
   * without them sharing attributes.
   *
   * @static
   */ static disableSingleInstance() {
        $02f719f3389c19af$var$singleInstance = false;
        $02f719f3389c19af$var$_CoreManager.default.setObjectStateController($02f719f3389c19af$var$UniqueInstanceStateController);
    }
    /**
   * Asynchronously stores the objects and every object they point to in the local datastore,
   * recursively, using a default pin name: _default.
   *
   * If those other objects have not been fetched from Parse, they will not be stored.
   * However, if they have changed data, all the changes will be retained.
   *
   * <pre>
   * await Parse.Object.pinAll([...]);
   * </pre>
   *
   * To retrieve object:
   * <code>query.fromLocalDatastore()</code> or <code>query.fromPin()</code>
   *
   * @param {Array} objects A list of <code>Parse.Object</code>.
   * @returns {Promise} A promise that is fulfilled when the pin completes.
   * @static
   */ static pinAll(objects) {
        const localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
        if (!localDatastore.isEnabled) return $02f719f3389c19af$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
        return $02f719f3389c19af$var$ParseObject.pinAllWithName($klpRA.DEFAULT_PIN, objects);
    }
    /**
   * Asynchronously stores the objects and every object they point to in the local datastore, recursively.
   *
   * If those other objects have not been fetched from Parse, they will not be stored.
   * However, if they have changed data, all the changes will be retained.
   *
   * <pre>
   * await Parse.Object.pinAllWithName(name, [obj1, obj2, ...]);
   * </pre>
   *
   * To retrieve object:
   * <code>query.fromLocalDatastore()</code> or <code>query.fromPinWithName(name)</code>
   *
   * @param {string} name Name of Pin.
   * @param {Array} objects A list of <code>Parse.Object</code>.
   * @returns {Promise} A promise that is fulfilled when the pin completes.
   * @static
   */ static pinAllWithName(name, objects) {
        const localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
        if (!localDatastore.isEnabled) return $02f719f3389c19af$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
        return localDatastore._handlePinAllWithName(name, objects);
    }
    /**
   * Asynchronously removes the objects and every object they point to in the local datastore,
   * recursively, using a default pin name: _default.
   *
   * <pre>
   * await Parse.Object.unPinAll([...]);
   * </pre>
   *
   * @param {Array} objects A list of <code>Parse.Object</code>.
   * @returns {Promise} A promise that is fulfilled when the unPin completes.
   * @static
   */ static unPinAll(objects) {
        const localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
        if (!localDatastore.isEnabled) return $02f719f3389c19af$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
        return $02f719f3389c19af$var$ParseObject.unPinAllWithName($klpRA.DEFAULT_PIN, objects);
    }
    /**
   * Asynchronously removes the objects and every object they point to in the local datastore, recursively.
   *
   * <pre>
   * await Parse.Object.unPinAllWithName(name, [obj1, obj2, ...]);
   * </pre>
   *
   * @param {string} name Name of Pin.
   * @param {Array} objects A list of <code>Parse.Object</code>.
   * @returns {Promise} A promise that is fulfilled when the unPin completes.
   * @static
   */ static unPinAllWithName(name, objects) {
        const localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
        if (!localDatastore.isEnabled) return $02f719f3389c19af$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
        return localDatastore._handleUnPinAllWithName(name, objects);
    }
    /**
   * Asynchronously removes all objects in the local datastore using a default pin name: _default.
   *
   * <pre>
   * await Parse.Object.unPinAllObjects();
   * </pre>
   *
   * @returns {Promise} A promise that is fulfilled when the unPin completes.
   * @static
   */ static unPinAllObjects() {
        const localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
        if (!localDatastore.isEnabled) return $02f719f3389c19af$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
        return localDatastore.unPinWithName($klpRA.DEFAULT_PIN);
    }
    /**
   * Asynchronously removes all objects with the specified pin name.
   * Deletes the pin name also.
   *
   * <pre>
   * await Parse.Object.unPinAllObjectsWithName(name);
   * </pre>
   *
   * @param {string} name Name of Pin.
   * @returns {Promise} A promise that is fulfilled when the unPin completes.
   * @static
   */ static unPinAllObjectsWithName(name) {
        const localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
        if (!localDatastore.isEnabled) return $02f719f3389c19af$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
        return localDatastore.unPinWithName($klpRA.PIN_PREFIX + name);
    }
}
const $02f719f3389c19af$var$DefaultController = {
    fetch (target, forceFetch, options) {
        const localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
        if ((0, $02f719f3389c19af$var$_isArray.default)(target)) {
            if (target.length < 1) return $02f719f3389c19af$var$_promise.default.resolve([]);
            const objs = [];
            const ids = [];
            let className = null;
            const results = [];
            let error = null;
            (0, $02f719f3389c19af$var$_forEach.default)(target).call(target, (el)=>{
                if (error) return;
                if (!className) className = el.className;
                if (className !== el.className) error = new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.INVALID_CLASS_NAME, "All objects should be of the same class");
                if (!el.id) error = new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.MISSING_OBJECT_ID, "All objects must have an ID");
                if (forceFetch || !el.isDataAvailable()) {
                    ids.push(el.id);
                    objs.push(el);
                }
                results.push(el);
            });
            if (error) return $02f719f3389c19af$var$_promise.default.reject(error);
            const ParseQuery = $02f719f3389c19af$var$_CoreManager.default.getParseQuery();
            const query = new ParseQuery(className);
            query.containedIn("objectId", ids);
            if (options && options.include) query.include(options.include);
            query._limit = ids.length;
            return (0, $02f719f3389c19af$var$_find.default)(query).call(query, options).then(async (objects)=>{
                const idMap = {};
                (0, $02f719f3389c19af$var$_forEach.default)(objects).call(objects, (o)=>{
                    idMap[o.id] = o;
                });
                for(let i = 0; i < objs.length; i++){
                    const obj = objs[i];
                    if (!obj || !obj.id || !idMap[obj.id]) {
                        if (forceFetch) return $02f719f3389c19af$var$_promise.default.reject(new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.OBJECT_NOT_FOUND, "All objects must exist on the server."));
                    }
                }
                if (!$02f719f3389c19af$var$singleInstance) // If single instance objects are disabled, we need to replace the
                for(let i = 0; i < results.length; i++){
                    const obj = results[i];
                    if (obj && obj.id && idMap[obj.id]) {
                        const id = obj.id;
                        obj._finishFetch(idMap[id].toJSON());
                        results[i] = idMap[id];
                    }
                }
                for (const object of results)await localDatastore._updateObjectIfPinned(object);
                return $02f719f3389c19af$var$_promise.default.resolve(results);
            });
        } else if (target instanceof $02f719f3389c19af$var$ParseObject) {
            if (!target.id) return $02f719f3389c19af$var$_promise.default.reject(new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.MISSING_OBJECT_ID, "Object does not have an ID"));
            const RESTController = $02f719f3389c19af$var$_CoreManager.default.getRESTController();
            const params = {};
            if (options && options.include) params.include = options.include.join();
            return RESTController.request("GET", "classes/" + target.className + "/" + target._getId(), params, options).then(async (response)=>{
                target._clearPendingOps();
                target._clearServerData();
                target._finishFetch(response);
                await localDatastore._updateObjectIfPinned(target);
                return target;
            });
        }
        return $02f719f3389c19af$var$_promise.default.resolve(undefined);
    },
    async destroy (target, options) {
        const batchSize = options && options.batchSize ? options.batchSize : $02f719f3389c19af$var$_CoreManager.default.get("REQUEST_BATCH_SIZE");
        const localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
        const RESTController = $02f719f3389c19af$var$_CoreManager.default.getRESTController();
        if ((0, $02f719f3389c19af$var$_isArray.default)(target)) {
            if (target.length < 1) return $02f719f3389c19af$var$_promise.default.resolve([]);
            const batches = [
                []
            ];
            (0, $02f719f3389c19af$var$_forEach.default)(target).call(target, (obj)=>{
                if (!obj.id) return;
                batches[batches.length - 1].push(obj);
                if (batches[batches.length - 1].length >= batchSize) batches.push([]);
            });
            if (batches[batches.length - 1].length === 0) // If the last batch is empty, remove it
            batches.pop();
            let deleteCompleted = $02f719f3389c19af$var$_promise.default.resolve();
            const errors = [];
            (0, $02f719f3389c19af$var$_forEach.default)(batches).call(batches, (batch)=>{
                deleteCompleted = deleteCompleted.then(()=>{
                    return RESTController.request("POST", "batch", {
                        requests: (0, $02f719f3389c19af$var$_map.default)(batch).call(batch, (obj)=>{
                            return {
                                method: "DELETE",
                                path: $02f719f3389c19af$var$getServerUrlPath() + "classes/" + obj.className + "/" + obj._getId(),
                                body: {}
                            };
                        })
                    }, options).then((results)=>{
                        for(let i = 0; i < results.length; i++)if (results[i] && results[i].hasOwnProperty("error")) {
                            const err = new $02f719f3389c19af$var$_ParseError.default(results[i].error.code, results[i].error.error);
                            err.object = batch[i];
                            errors.push(err);
                        }
                    });
                });
            });
            return deleteCompleted.then(async ()=>{
                if (errors.length) {
                    const aggregate = new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.AGGREGATE_ERROR);
                    aggregate.errors = errors;
                    return $02f719f3389c19af$var$_promise.default.reject(aggregate);
                }
                for (const object of target)await localDatastore._destroyObjectIfPinned(object);
                return $02f719f3389c19af$var$_promise.default.resolve(target);
            });
        } else if (target instanceof $02f719f3389c19af$var$ParseObject) return RESTController.request("DELETE", "classes/" + target.className + "/" + target._getId(), {}, options).then(async ()=>{
            await localDatastore._destroyObjectIfPinned(target);
            return $02f719f3389c19af$var$_promise.default.resolve(target);
        });
        return $02f719f3389c19af$var$_promise.default.resolve(target);
    },
    save (target, options) {
        const batchSize = options && options.batchSize ? options.batchSize : $02f719f3389c19af$var$_CoreManager.default.get("REQUEST_BATCH_SIZE");
        const localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
        const mapIdForPin = {};
        const RESTController = $02f719f3389c19af$var$_CoreManager.default.getRESTController();
        const stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
        const allowCustomObjectId = $02f719f3389c19af$var$_CoreManager.default.get("ALLOW_CUSTOM_OBJECT_ID");
        options = options || {};
        options.returnStatus = options.returnStatus || true;
        if ((0, $02f719f3389c19af$var$_isArray.default)(target)) {
            if (target.length < 1) return $02f719f3389c19af$var$_promise.default.resolve([]);
            let unsaved = (0, $02f719f3389c19af$var$_concat.default)(target).call(target);
            for(let i = 0; i < target.length; i++){
                const target_i = target[i];
                if (target_i instanceof $02f719f3389c19af$var$ParseObject) unsaved = (0, $02f719f3389c19af$var$_concat.default)(unsaved).call(unsaved, (0, $02f719f3389c19af$var$_unsavedChildren.default)(target_i, true));
            }
            unsaved = (0, $02f719f3389c19af$var$_unique.default)(unsaved);
            const filesSaved = [];
            let pending = [];
            (0, $02f719f3389c19af$var$_forEach.default)(unsaved).call(unsaved, (el)=>{
                if (el instanceof $02f719f3389c19af$var$_ParseFile.default) filesSaved.push(el.save(options));
                else if (el instanceof $02f719f3389c19af$var$ParseObject) pending.push(el);
            });
            return $02f719f3389c19af$var$_promise.default.all(filesSaved).then(()=>{
                let objectError = null;
                return (0, $9FsFR.continueWhile)(()=>{
                    return pending.length > 0;
                }, ()=>{
                    const batch = [];
                    const nextPending = [];
                    (0, $02f719f3389c19af$var$_forEach.default)(pending).call(pending, (el)=>{
                        if (allowCustomObjectId && Object.prototype.hasOwnProperty.call(el, "id") && !el.id) throw new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.MISSING_OBJECT_ID, "objectId must not be empty or null");
                        if (batch.length < batchSize && (0, $02f719f3389c19af$var$_canBeSerialized.default)(el)) batch.push(el);
                        else nextPending.push(el);
                    });
                    pending = nextPending;
                    if (batch.length < 1) return $02f719f3389c19af$var$_promise.default.reject(new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.OTHER_CAUSE, "Tried to save a batch with a cycle."));
                    // Queue up tasks for each object in the batch.
                    // When every task is ready, the API request will execute
                    const batchReturned = (0, $9FsFR.resolvingPromise)();
                    const batchReady = [];
                    const batchTasks = [];
                    (0, $02f719f3389c19af$var$_forEach.default)(batch).call(batch, (obj, index)=>{
                        const ready = (0, $9FsFR.resolvingPromise)();
                        batchReady.push(ready);
                        stateController.pushPendingState(obj._getStateIdentifier());
                        batchTasks.push(stateController.enqueueTask(obj._getStateIdentifier(), function() {
                            ready.resolve();
                            return batchReturned.then((responses)=>{
                                if (responses[index].hasOwnProperty("success")) {
                                    const objectId = responses[index].success.objectId;
                                    const status = responses[index]._status;
                                    delete responses[index]._status;
                                    delete responses[index]._headers;
                                    delete responses[index]._xhr;
                                    mapIdForPin[objectId] = obj._localId;
                                    obj._handleSaveResponse(responses[index].success, status);
                                } else {
                                    if (!objectError && responses[index].hasOwnProperty("error")) {
                                        const serverError = responses[index].error;
                                        objectError = new $02f719f3389c19af$var$_ParseError.default(serverError.code, serverError.error);
                                        // Cancel the rest of the save
                                        pending = [];
                                    }
                                    obj._handleSaveError();
                                }
                            });
                        }));
                    });
                    (0, $9FsFR.when)(batchReady).then(()=>{
                        // Kick off the batch request
                        return RESTController.request("POST", "batch", {
                            requests: (0, $02f719f3389c19af$var$_map.default)(batch).call(batch, (obj)=>{
                                const params = obj._getSaveParams();
                                params.path = $02f719f3389c19af$var$getServerUrlPath() + params.path;
                                return params;
                            })
                        }, options);
                    }).then(batchReturned.resolve, (error)=>{
                        batchReturned.reject(new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.INCORRECT_TYPE, error.message));
                    });
                    return (0, $9FsFR.when)(batchTasks);
                }).then(async ()=>{
                    if (objectError) return $02f719f3389c19af$var$_promise.default.reject(objectError);
                    for (const object of target)// Make sure that it is a ParseObject before updating it into the localDataStore
                    if (object instanceof $02f719f3389c19af$var$ParseObject) {
                        await localDatastore._updateLocalIdForObject(mapIdForPin[object.id], object);
                        await localDatastore._updateObjectIfPinned(object);
                    }
                    return $02f719f3389c19af$var$_promise.default.resolve(target);
                });
            });
        } else if (target instanceof $02f719f3389c19af$var$ParseObject) {
            if (allowCustomObjectId && Object.prototype.hasOwnProperty.call(target, "id") && !target.id) throw new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.MISSING_OBJECT_ID, "objectId must not be empty or null");
            // generate _localId in case if cascadeSave=false
            target._getId();
            const localId = target._localId;
            // copying target lets guarantee the pointer isn't modified elsewhere
            const targetCopy = target;
            const task = function() {
                const params = targetCopy._getSaveParams();
                return RESTController.request(params.method, params.path, params.body, options).then((response)=>{
                    const status = response._status;
                    delete response._status;
                    delete response._headers;
                    delete response._xhr;
                    targetCopy._handleSaveResponse(response, status);
                }, (error)=>{
                    targetCopy._handleSaveError();
                    return $02f719f3389c19af$var$_promise.default.reject(error);
                });
            };
            stateController.pushPendingState(target._getStateIdentifier());
            return stateController.enqueueTask(target._getStateIdentifier(), task).then(async ()=>{
                await localDatastore._updateLocalIdForObject(localId, target);
                await localDatastore._updateObjectIfPinned(target);
                return target;
            }, (error)=>{
                return $02f719f3389c19af$var$_promise.default.reject(error);
            });
        }
        return $02f719f3389c19af$var$_promise.default.resolve(undefined);
    }
};
$02f719f3389c19af$var$_CoreManager.default.setParseObject($02f719f3389c19af$var$ParseObject);
$02f719f3389c19af$var$_CoreManager.default.setObjectController($02f719f3389c19af$var$DefaultController);
var $02f719f3389c19af$var$_default = module.exports.default = $02f719f3389c19af$var$ParseObject;

});
parcelRegister("hNwyw", function(module, exports) {

module.exports = (parcelRequire("bek8o"));

});
parcelRegister("bek8o", function(module, exports) {
"use strict";

var $dPRNc = parcelRequire("dPRNc");
module.exports = $dPRNc;

});
parcelRegister("dPRNc", function(module, exports) {
"use strict";
parcelRequire("2Nn8K");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Object.freeze;

});
parcelRegister("2Nn8K", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $7DccQ = parcelRequire("7DccQ");

var $77TPA = parcelRequire("77TPA");

var $1WYwK = parcelRequire("1WYwK");

var $iZE4H = parcelRequire("iZE4H");
var $20921b834d47c4a5$require$onFreeze = $iZE4H.onFreeze;
// eslint-disable-next-line es/no-object-freeze -- safe
var $20921b834d47c4a5$var$$freeze = Object.freeze;
var $20921b834d47c4a5$var$FAILS_ON_PRIMITIVES = $77TPA(function() {
    $20921b834d47c4a5$var$$freeze(1);
});
// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$ggcsv({
    target: "Object",
    stat: true,
    forced: $20921b834d47c4a5$var$FAILS_ON_PRIMITIVES,
    sham: !$7DccQ
}, {
    freeze: function freeze(it) {
        return $20921b834d47c4a5$var$$freeze && $1WYwK(it) ? $20921b834d47c4a5$var$$freeze($20921b834d47c4a5$require$onFreeze(it)) : it;
    }
});

});




parcelRegister("dNrmj", function(module, exports) {

module.exports = (parcelRequire("1ArLc"));

});
parcelRegister("1ArLc", function(module, exports) {
"use strict";

var $ysJEj = parcelRequire("ysJEj");
module.exports = $ysJEj;

});
parcelRegister("ysJEj", function(module, exports) {
"use strict";

var $8hsAO = parcelRequire("8hsAO");

var $eDxhp = parcelRequire("eDxhp");

var $dNqHo = parcelRequire("dNqHo");
var $0679775168a8741b$var$ArrayPrototype = Array.prototype;
var $0679775168a8741b$var$StringPrototype = String.prototype;
module.exports = function(it) {
    var own = it.includes;
    if (it === $0679775168a8741b$var$ArrayPrototype || $8hsAO($0679775168a8741b$var$ArrayPrototype, it) && own === $0679775168a8741b$var$ArrayPrototype.includes) return $eDxhp;
    if (typeof it == "string" || it === $0679775168a8741b$var$StringPrototype || $8hsAO($0679775168a8741b$var$StringPrototype, it) && own === $0679775168a8741b$var$StringPrototype.includes) return $dNqHo;
    return own;
};

});
parcelRegister("eDxhp", function(module, exports) {
"use strict";
parcelRequire("aOny7");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Array", "includes");

});
parcelRegister("aOny7", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $3NUiQ = parcelRequire("3NUiQ");
var $7df0d746f7e8703e$require$$includes = $3NUiQ.includes;

var $77TPA = parcelRequire("77TPA");

var $ajzxw = parcelRequire("ajzxw");
// FF99+ bug
var $7df0d746f7e8703e$var$BROKEN_ON_SPARSE = $77TPA(function() {
    // eslint-disable-next-line es/no-array-prototype-includes -- detection
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$ggcsv({
    target: "Array",
    proto: true,
    forced: $7df0d746f7e8703e$var$BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $7df0d746f7e8703e$require$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$ajzxw("includes");

});


parcelRegister("dNqHo", function(module, exports) {
"use strict";
parcelRequire("5KRrY");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("String", "includes");

});
parcelRegister("5KRrY", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $f518o = parcelRequire("f518o");

var $4Te7f = parcelRequire("4Te7f");

var $cBWnS = parcelRequire("cBWnS");

var $l2Ut5 = parcelRequire("l2Ut5");

var $bmRml = parcelRequire("bmRml");
var $0114d161e47b718e$var$stringIndexOf = $f518o("".indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$ggcsv({
    target: "String",
    proto: true,
    forced: !$bmRml("includes")
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$0114d161e47b718e$var$stringIndexOf($l2Ut5($cBWnS(this)), $l2Ut5($4Te7f(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});

});





parcelRegister("kOp5W", function(module, exports) {

module.exports = (parcelRequire("6Llo9"));

});
parcelRegister("6Llo9", function(module, exports) {
"use strict";

var $ffvKw = parcelRequire("ffvKw");
module.exports = $ffvKw;

});
parcelRegister("ffvKw", function(module, exports) {
"use strict";
parcelRequire("6NONQ");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Object.getPrototypeOf;

});
parcelRegister("6NONQ", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $77TPA = parcelRequire("77TPA");

var $iJNxK = parcelRequire("iJNxK");

var $2pQL6 = parcelRequire("2pQL6");

var $lss67 = parcelRequire("lss67");
var $4f3eba1248c55e3d$var$FAILS_ON_PRIMITIVES = $77TPA(function() {
    $2pQL6(1);
});
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$ggcsv({
    target: "Object",
    stat: true,
    forced: $4f3eba1248c55e3d$var$FAILS_ON_PRIMITIVES,
    sham: !$lss67
}, {
    getPrototypeOf: function getPrototypeOf(it) {
        return $2pQL6($iJNxK(it));
    }
});

});




parcelRegister("jQ6K5", function(module, exports) {

module.exports = (parcelRequire("c9ilJ"));

});
parcelRegister("c9ilJ", function(module, exports) {
"use strict";

var $7lNnm = parcelRequire("7lNnm");
module.exports = $7lNnm;

});
parcelRegister("7lNnm", function(module, exports) {
"use strict";
parcelRequire("1UOrt");

var $ly30u = parcelRequire("ly30u");
var $55a0cb8cc2353868$var$Object = $ly30u.Object;
module.exports = function create(P, D) {
    return $55a0cb8cc2353868$var$Object.create(P, D);
};

});
parcelRegister("1UOrt", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $jeZ4p = parcelRequire("jeZ4p");

var $fhVPP = parcelRequire("fhVPP");
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$ggcsv({
    target: "Object",
    stat: true,
    sham: !$jeZ4p
}, {
    create: $fhVPP
});

});




parcelRegister("gloAc", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be61ad28250c80b9$var$canBeSerialized;

var $be61ad28250c80b9$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $be61ad28250c80b9$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $be61ad28250c80b9$var$_ParseFile = $iHLHC((parcelRequire("59JWU")));

var $be61ad28250c80b9$var$_ParseRelation = $iHLHC((parcelRequire("967gW")));
function $be61ad28250c80b9$var$canBeSerialized(obj) {
    const ParseObject = $be61ad28250c80b9$var$_CoreManager.default.getParseObject();
    if (!(obj instanceof ParseObject)) return true;
    const attributes = obj.attributes;
    for(const attr in attributes){
        const val = attributes[attr];
        if (!$be61ad28250c80b9$var$canBeSerializedHelper(val)) return false;
    }
    return true;
}
function $be61ad28250c80b9$var$canBeSerializedHelper(value) {
    if (typeof value !== "object") return true;
    if (value instanceof $be61ad28250c80b9$var$_ParseRelation.default) return true;
    const ParseObject = $be61ad28250c80b9$var$_CoreManager.default.getParseObject();
    if (value instanceof ParseObject) return !!value.id;
    if (value instanceof $be61ad28250c80b9$var$_ParseFile.default) {
        if (value.url()) return true;
        return false;
    }
    if ((0, $be61ad28250c80b9$var$_isArray.default)(value)) {
        for(let i = 0; i < value.length; i++){
            if (!$be61ad28250c80b9$var$canBeSerializedHelper(value[i])) return false;
        }
        return true;
    }
    for(const k in value){
        if (!$be61ad28250c80b9$var$canBeSerializedHelper(value[k])) return false;
    }
    return true;
}

});

parcelRegister("1JxNp", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1434359b124c737a$var$escape;
const $1434359b124c737a$var$encoded = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "/": "&#x2F;",
    "'": "&#x27;",
    '"': "&quot;"
};
function $1434359b124c737a$var$escape(str) {
    return str.replace(/[&<>\/'"]/g, function(char) {
        return $1434359b124c737a$var$encoded[char];
    });
}

});

parcelRegister("ktbIl", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ee6f9a424f393766$var$parseDate;

var $ee6f9a424f393766$var$_parseInt2 = $iHLHC((parcelRequire("dJMBp")));
function $ee6f9a424f393766$var$parseDate(iso8601) {
    const regexp = new RegExp("^([0-9]{1,4})-([0-9]{1,2})-([0-9]{1,2})T([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})(.([0-9]+))?Z$");
    const match = regexp.exec(iso8601);
    if (!match) return null;
    const year = (0, $ee6f9a424f393766$var$_parseInt2.default)(match[1]) || 0;
    const month = ((0, $ee6f9a424f393766$var$_parseInt2.default)(match[2]) || 1) - 1;
    const day = (0, $ee6f9a424f393766$var$_parseInt2.default)(match[3]) || 0;
    const hour = (0, $ee6f9a424f393766$var$_parseInt2.default)(match[4]) || 0;
    const minute = (0, $ee6f9a424f393766$var$_parseInt2.default)(match[5]) || 0;
    const second = (0, $ee6f9a424f393766$var$_parseInt2.default)(match[6]) || 0;
    const milli = (0, $ee6f9a424f393766$var$_parseInt2.default)(match[8]) || 0;
    return new Date(Date.UTC(year, month, day, hour, minute, second, milli));
}

});
parcelRegister("dJMBp", function(module, exports) {

module.exports = (parcelRequire("04sMR"));

});
parcelRegister("04sMR", function(module, exports) {
"use strict";

var $3PfNE = parcelRequire("3PfNE");
module.exports = $3PfNE;

});
parcelRegister("3PfNE", function(module, exports) {
"use strict";
parcelRequire("19lh2");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.parseInt;

});
parcelRegister("19lh2", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $iiMYx = parcelRequire("iiMYx");
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$ggcsv({
    global: true,
    forced: parseInt !== $iiMYx
}, {
    parseInt: $iiMYx
});

});
parcelRegister("iiMYx", function(module, exports) {
"use strict";

var $9l3PP = parcelRequire("9l3PP");

var $77TPA = parcelRequire("77TPA");

var $f518o = parcelRequire("f518o");

var $l2Ut5 = parcelRequire("l2Ut5");

var $eLO92 = parcelRequire("eLO92");
var $d52fe5f5747e292a$require$trim = $eLO92.trim;

var $hxoJH = parcelRequire("hxoJH");
var $d52fe5f5747e292a$var$$parseInt = $9l3PP.parseInt;
var $d52fe5f5747e292a$var$Symbol = $9l3PP.Symbol;
var $d52fe5f5747e292a$var$ITERATOR = $d52fe5f5747e292a$var$Symbol && $d52fe5f5747e292a$var$Symbol.iterator;
var $d52fe5f5747e292a$var$hex = /^[+-]?0x/i;
var $d52fe5f5747e292a$var$exec = $f518o($d52fe5f5747e292a$var$hex.exec);
var $d52fe5f5747e292a$var$FORCED = $d52fe5f5747e292a$var$$parseInt($hxoJH + "08") !== 8 || $d52fe5f5747e292a$var$$parseInt($hxoJH + "0x16") !== 22 || $d52fe5f5747e292a$var$ITERATOR && !$77TPA(function() {
    $d52fe5f5747e292a$var$$parseInt(Object($d52fe5f5747e292a$var$ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = $d52fe5f5747e292a$var$FORCED ? function parseInt(string, radix) {
    var S = $d52fe5f5747e292a$require$trim($l2Ut5(string));
    return $d52fe5f5747e292a$var$$parseInt(S, radix >>> 0 || ($d52fe5f5747e292a$var$exec($d52fe5f5747e292a$var$hex, S) ? 16 : 10));
} : $d52fe5f5747e292a$var$$parseInt;

});
parcelRegister("eLO92", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");

var $cBWnS = parcelRequire("cBWnS");

var $l2Ut5 = parcelRequire("l2Ut5");

var $hxoJH = parcelRequire("hxoJH");
var $ac0c5a32125b222c$var$replace = $f518o("".replace);
var $ac0c5a32125b222c$var$ltrim = RegExp("^[" + $hxoJH + "]+");
var $ac0c5a32125b222c$var$rtrim = RegExp("(^|[^" + $hxoJH + "])[" + $hxoJH + "]+$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $ac0c5a32125b222c$var$createMethod = function(TYPE) {
    return function($this) {
        var string = $l2Ut5($cBWnS($this));
        if (TYPE & 1) string = $ac0c5a32125b222c$var$replace(string, $ac0c5a32125b222c$var$ltrim, "");
        if (TYPE & 2) string = $ac0c5a32125b222c$var$replace(string, $ac0c5a32125b222c$var$rtrim, "$1");
        return string;
    };
};
module.exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $ac0c5a32125b222c$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $ac0c5a32125b222c$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $ac0c5a32125b222c$var$createMethod(3)
};

});
parcelRegister("hxoJH", function(module, exports) {
"use strict";
// a string of all valid unicode whitespaces
module.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";

});








parcelRegister("9FsFR", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.continueWhile = $709e2f78d55925d6$var$continueWhile;
module.exports.resolvingPromise = $709e2f78d55925d6$var$resolvingPromise;
module.exports.when = $709e2f78d55925d6$var$when;

var $709e2f78d55925d6$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $709e2f78d55925d6$var$_isArray = $iHLHC((parcelRequire("euZIZ")));
// Create Deferred Promise
function $709e2f78d55925d6$var$resolvingPromise() {
    let res;
    let rej;
    const promise = new $709e2f78d55925d6$var$_promise.default((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    const defer = promise;
    defer.resolve = res;
    defer.reject = rej;
    return defer;
}
function $709e2f78d55925d6$var$when(promises) {
    let objects;
    const arrayArgument = (0, $709e2f78d55925d6$var$_isArray.default)(promises);
    if (arrayArgument) objects = promises;
    else objects = arguments;
    let total = objects.length;
    let hadError = false;
    const results = [];
    const returnValue = arrayArgument ? [
        results
    ] : results;
    const errors = [];
    results.length = objects.length;
    errors.length = objects.length;
    if (total === 0) return $709e2f78d55925d6$var$_promise.default.resolve(returnValue);
    const promise = $709e2f78d55925d6$var$resolvingPromise();
    const resolveOne = function() {
        total--;
        if (total <= 0) {
            if (hadError) promise.reject(errors);
            else promise.resolve(returnValue);
        }
    };
    const chain = function(object, index) {
        if (object && typeof object.then === "function") object.then(function(result) {
            results[index] = result;
            resolveOne();
        }, function(error) {
            errors[index] = error;
            hadError = true;
            resolveOne();
        });
        else {
            results[index] = object;
            resolveOne();
        }
    };
    for(let i = 0; i < objects.length; i++)chain(objects[i], i);
    return promise;
}
function $709e2f78d55925d6$var$continueWhile(test, emitter) {
    if (test()) return emitter().then(()=>{
        return $709e2f78d55925d6$var$continueWhile(test, emitter);
    });
    return $709e2f78d55925d6$var$_promise.default.resolve();
}

});

parcelRegister("klpRA", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.PIN_PREFIX = module.exports.OBJECT_PREFIX = module.exports.DEFAULT_PIN = void 0;
module.exports.isLocalDatastoreKey = $ecf9d4b8c1b67708$var$isLocalDatastoreKey;

var $ecf9d4b8c1b67708$var$_startsWith = $iHLHC((parcelRequire("hNmgD")));
const $ecf9d4b8c1b67708$var$DEFAULT_PIN = module.exports.DEFAULT_PIN = "_default";
const $ecf9d4b8c1b67708$var$PIN_PREFIX = module.exports.PIN_PREFIX = "parsePin_";
const $ecf9d4b8c1b67708$var$OBJECT_PREFIX = module.exports.OBJECT_PREFIX = "Parse_LDS_";
function $ecf9d4b8c1b67708$var$isLocalDatastoreKey(key) {
    return !!(key && (key === $ecf9d4b8c1b67708$var$DEFAULT_PIN || (0, $ecf9d4b8c1b67708$var$_startsWith.default)(key).call(key, $ecf9d4b8c1b67708$var$PIN_PREFIX) || (0, $ecf9d4b8c1b67708$var$_startsWith.default)(key).call(key, $ecf9d4b8c1b67708$var$OBJECT_PREFIX)));
}

});

parcelRegister("4q6en", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bEzwx = parcelRequire("bEzwx");
let $337e6c754049e2ee$var$uuid = $bEzwx.default;
module.exports = $337e6c754049e2ee$var$uuid;
var $337e6c754049e2ee$var$_default = module.exports.default = $337e6c754049e2ee$var$uuid;

});
parcelRegister("bEzwx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87befc68df50040c$export$2e2bcd8739ae039; });

var $7OiRl = parcelRequire("7OiRl");

var $kknQe = parcelRequire("kknQe");

var $7YxFJ = parcelRequire("7YxFJ");
function $87befc68df50040c$var$v4(options, buf, offset) {
    if ((0, $7OiRl.default).randomUUID && !buf && !options) return (0, $7OiRl.default).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, $kknQe.default))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $7YxFJ.unsafeStringify)(rnds);
}
var $87befc68df50040c$export$2e2bcd8739ae039 = $87befc68df50040c$var$v4;

});
parcelRegister("7OiRl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5afbd4fb4df23c28$export$2e2bcd8739ae039; });
var $5afbd4fb4df23c28$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $5afbd4fb4df23c28$export$2e2bcd8739ae039 = {
    randomUUID: $5afbd4fb4df23c28$var$randomUUID
};

});

parcelRegister("kknQe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecc82b4b4d5334a5$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $ecc82b4b4d5334a5$var$getRandomValues;
var $ecc82b4b4d5334a5$var$rnds8 = new Uint8Array(16);
function $ecc82b4b4d5334a5$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$ecc82b4b4d5334a5$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $ecc82b4b4d5334a5$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$ecc82b4b4d5334a5$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $ecc82b4b4d5334a5$var$getRandomValues($ecc82b4b4d5334a5$var$rnds8);
}

});

parcelRegister("7YxFJ", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", function () { return $5ce84198744ccadf$export$8fb373d660548968; });

var $jPUoq = parcelRequire("jPUoq");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $5ce84198744ccadf$var$byteToHex = [];
for(var $5ce84198744ccadf$var$i = 0; $5ce84198744ccadf$var$i < 256; ++$5ce84198744ccadf$var$i)$5ce84198744ccadf$var$byteToHex.push(($5ce84198744ccadf$var$i + 0x100).toString(16).slice(1));
function $5ce84198744ccadf$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return ($5ce84198744ccadf$var$byteToHex[arr[offset + 0]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 1]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 2]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 3]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 4]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 5]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 6]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 7]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 8]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 9]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 10]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 11]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 12]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 13]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 14]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $5ce84198744ccadf$var$stringify(arr, offset = 0) {
    var uuid = $5ce84198744ccadf$export$8fb373d660548968(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $jPUoq.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $5ce84198744ccadf$export$2e2bcd8739ae039 = $5ce84198744ccadf$var$stringify;

});
parcelRegister("jPUoq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e70e86397c656fa2$export$2e2bcd8739ae039; });

var $bjlDU = parcelRequire("bjlDU");
function $e70e86397c656fa2$var$validate(uuid) {
    return typeof uuid === "string" && (0, $bjlDU.default).test(uuid);
}
var $e70e86397c656fa2$export$2e2bcd8739ae039 = $e70e86397c656fa2$var$validate;

});
parcelRegister("bjlDU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83c241de251331e8$export$2e2bcd8739ae039; });
var $83c241de251331e8$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});





parcelRegister("3l0Qd", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.UnsetOp = module.exports.SetOp = module.exports.RemoveOp = module.exports.RelationOp = module.exports.Op = module.exports.IncrementOp = module.exports.AddUniqueOp = module.exports.AddOp = void 0;
module.exports.opFromJSON = $26e3fc4ccd45c3d4$var$opFromJSON;

var $26e3fc4ccd45c3d4$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $26e3fc4ccd45c3d4$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $26e3fc4ccd45c3d4$var$_concat = $iHLHC((parcelRequire("oorJA")));

var $26e3fc4ccd45c3d4$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $26e3fc4ccd45c3d4$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $26e3fc4ccd45c3d4$var$_splice = $iHLHC((parcelRequire("aFg1C")));

var $26e3fc4ccd45c3d4$var$_map = $iHLHC((parcelRequire("2VoQi")));

var $26e3fc4ccd45c3d4$var$_arrayContainsObject = $iHLHC((parcelRequire("koRMr")));

var $26e3fc4ccd45c3d4$var$_decode = $iHLHC((parcelRequire("42E6z")));

var $26e3fc4ccd45c3d4$var$_encode = $iHLHC((parcelRequire("1rsTn")));

var $26e3fc4ccd45c3d4$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $26e3fc4ccd45c3d4$var$_ParseRelation = $iHLHC((parcelRequire("967gW")));

var $26e3fc4ccd45c3d4$var$_unique = $iHLHC((parcelRequire("aoRXv")));
function $26e3fc4ccd45c3d4$var$opFromJSON(json) {
    if (!json || !json.__op) return null;
    switch(json.__op){
        case "Delete":
            return new $26e3fc4ccd45c3d4$var$UnsetOp();
        case "Increment":
            return new $26e3fc4ccd45c3d4$var$IncrementOp(json.amount);
        case "Add":
            return new $26e3fc4ccd45c3d4$var$AddOp((0, $26e3fc4ccd45c3d4$var$_decode.default)(json.objects));
        case "AddUnique":
            return new $26e3fc4ccd45c3d4$var$AddUniqueOp((0, $26e3fc4ccd45c3d4$var$_decode.default)(json.objects));
        case "Remove":
            return new $26e3fc4ccd45c3d4$var$RemoveOp((0, $26e3fc4ccd45c3d4$var$_decode.default)(json.objects));
        case "AddRelation":
            {
                const toAdd = (0, $26e3fc4ccd45c3d4$var$_decode.default)(json.objects);
                if (!(0, $26e3fc4ccd45c3d4$var$_isArray.default)(toAdd)) return new $26e3fc4ccd45c3d4$var$RelationOp([], []);
                return new $26e3fc4ccd45c3d4$var$RelationOp(toAdd, []);
            }
        case "RemoveRelation":
            {
                const toRemove = (0, $26e3fc4ccd45c3d4$var$_decode.default)(json.objects);
                if (!(0, $26e3fc4ccd45c3d4$var$_isArray.default)(toRemove)) return new $26e3fc4ccd45c3d4$var$RelationOp([], []);
                return new $26e3fc4ccd45c3d4$var$RelationOp([], toRemove);
            }
        case "Batch":
            {
                let toAdd = [];
                let toRemove = [];
                for(let i = 0; i < json.ops.length; i++){
                    if (json.ops[i].__op === "AddRelation") toAdd = (0, $26e3fc4ccd45c3d4$var$_concat.default)(toAdd).call(toAdd, (0, $26e3fc4ccd45c3d4$var$_decode.default)(json.ops[i].objects));
                    else if (json.ops[i].__op === "RemoveRelation") toRemove = (0, $26e3fc4ccd45c3d4$var$_concat.default)(toRemove).call(toRemove, (0, $26e3fc4ccd45c3d4$var$_decode.default)(json.ops[i].objects));
                }
                return new $26e3fc4ccd45c3d4$var$RelationOp(toAdd, toRemove);
            }
    }
    return null;
}
class $26e3fc4ccd45c3d4$var$Op {
    // Empty parent class
    applyTo() {}
    mergeWith() {}
    toJSON() {}
}
module.exports.Op = $26e3fc4ccd45c3d4$var$Op;
class $26e3fc4ccd45c3d4$var$SetOp extends $26e3fc4ccd45c3d4$var$Op {
    constructor(value){
        super();
        (0, $26e3fc4ccd45c3d4$var$_defineProperty2.default)(this, "_value", void 0);
        this._value = value;
    }
    applyTo() {
        return this._value;
    }
    mergeWith() {
        return new $26e3fc4ccd45c3d4$var$SetOp(this._value);
    }
    toJSON(offline) {
        return (0, $26e3fc4ccd45c3d4$var$_encode.default)(this._value, false, true, undefined, offline);
    }
}
module.exports.SetOp = $26e3fc4ccd45c3d4$var$SetOp;
class $26e3fc4ccd45c3d4$var$UnsetOp extends $26e3fc4ccd45c3d4$var$Op {
    applyTo() {
        return undefined;
    }
    mergeWith() {
        return new $26e3fc4ccd45c3d4$var$UnsetOp();
    }
    toJSON() {
        return {
            __op: "Delete"
        };
    }
}
module.exports.UnsetOp = $26e3fc4ccd45c3d4$var$UnsetOp;
class $26e3fc4ccd45c3d4$var$IncrementOp extends $26e3fc4ccd45c3d4$var$Op {
    constructor(amount){
        super();
        (0, $26e3fc4ccd45c3d4$var$_defineProperty2.default)(this, "_amount", void 0);
        if (typeof amount !== "number") throw new TypeError("Increment Op must be initialized with a numeric amount.");
        this._amount = amount;
    }
    applyTo(value) {
        if (typeof value === "undefined") return this._amount;
        if (typeof value !== "number") throw new TypeError("Cannot increment a non-numeric value.");
        return this._amount + value;
    }
    mergeWith(previous) {
        if (!previous) return this;
        if (previous instanceof $26e3fc4ccd45c3d4$var$SetOp) return new $26e3fc4ccd45c3d4$var$SetOp(this.applyTo(previous._value));
        if (previous instanceof $26e3fc4ccd45c3d4$var$UnsetOp) return new $26e3fc4ccd45c3d4$var$SetOp(this._amount);
        if (previous instanceof $26e3fc4ccd45c3d4$var$IncrementOp) return new $26e3fc4ccd45c3d4$var$IncrementOp(this.applyTo(previous._amount));
        throw new Error("Cannot merge Increment Op with the previous Op");
    }
    toJSON() {
        return {
            __op: "Increment",
            amount: this._amount
        };
    }
}
module.exports.IncrementOp = $26e3fc4ccd45c3d4$var$IncrementOp;
class $26e3fc4ccd45c3d4$var$AddOp extends $26e3fc4ccd45c3d4$var$Op {
    constructor(value){
        super();
        (0, $26e3fc4ccd45c3d4$var$_defineProperty2.default)(this, "_value", void 0);
        this._value = (0, $26e3fc4ccd45c3d4$var$_isArray.default)(value) ? value : [
            value
        ];
    }
    applyTo(value) {
        if (value == null) return this._value;
        if ((0, $26e3fc4ccd45c3d4$var$_isArray.default)(value)) return (0, $26e3fc4ccd45c3d4$var$_concat.default)(value).call(value, this._value);
        throw new Error("Cannot add elements to a non-array value");
    }
    mergeWith(previous) {
        if (!previous) return this;
        if (previous instanceof $26e3fc4ccd45c3d4$var$SetOp) return new $26e3fc4ccd45c3d4$var$SetOp(this.applyTo(previous._value));
        if (previous instanceof $26e3fc4ccd45c3d4$var$UnsetOp) return new $26e3fc4ccd45c3d4$var$SetOp(this._value);
        if (previous instanceof $26e3fc4ccd45c3d4$var$AddOp) return new $26e3fc4ccd45c3d4$var$AddOp(this.applyTo(previous._value));
        throw new Error("Cannot merge Add Op with the previous Op");
    }
    toJSON() {
        return {
            __op: "Add",
            objects: (0, $26e3fc4ccd45c3d4$var$_encode.default)(this._value, false, true)
        };
    }
}
module.exports.AddOp = $26e3fc4ccd45c3d4$var$AddOp;
class $26e3fc4ccd45c3d4$var$AddUniqueOp extends $26e3fc4ccd45c3d4$var$Op {
    constructor(value){
        super();
        (0, $26e3fc4ccd45c3d4$var$_defineProperty2.default)(this, "_value", void 0);
        this._value = (0, $26e3fc4ccd45c3d4$var$_unique.default)((0, $26e3fc4ccd45c3d4$var$_isArray.default)(value) ? value : [
            value
        ]);
    }
    applyTo(value) {
        if (value == null) return this._value || [];
        if ((0, $26e3fc4ccd45c3d4$var$_isArray.default)(value)) {
            var _context;
            const ParseObject = $26e3fc4ccd45c3d4$var$_CoreManager.default.getParseObject();
            const toAdd = [];
            (0, $26e3fc4ccd45c3d4$var$_forEach.default)(_context = this._value).call(_context, (v)=>{
                if (v instanceof ParseObject) {
                    if (!(0, $26e3fc4ccd45c3d4$var$_arrayContainsObject.default)(value, v)) toAdd.push(v);
                } else if ((0, $26e3fc4ccd45c3d4$var$_indexOf.default)(value).call(value, v) < 0) toAdd.push(v);
            });
            return (0, $26e3fc4ccd45c3d4$var$_concat.default)(value).call(value, toAdd);
        }
        throw new Error("Cannot add elements to a non-array value");
    }
    mergeWith(previous) {
        if (!previous) return this;
        if (previous instanceof $26e3fc4ccd45c3d4$var$SetOp) return new $26e3fc4ccd45c3d4$var$SetOp(this.applyTo(previous._value));
        if (previous instanceof $26e3fc4ccd45c3d4$var$UnsetOp) return new $26e3fc4ccd45c3d4$var$SetOp(this._value);
        if (previous instanceof $26e3fc4ccd45c3d4$var$AddUniqueOp) return new $26e3fc4ccd45c3d4$var$AddUniqueOp(this.applyTo(previous._value));
        throw new Error("Cannot merge AddUnique Op with the previous Op");
    }
    toJSON() {
        return {
            __op: "AddUnique",
            objects: (0, $26e3fc4ccd45c3d4$var$_encode.default)(this._value, false, true)
        };
    }
}
module.exports.AddUniqueOp = $26e3fc4ccd45c3d4$var$AddUniqueOp;
class $26e3fc4ccd45c3d4$var$RemoveOp extends $26e3fc4ccd45c3d4$var$Op {
    constructor(value){
        super();
        (0, $26e3fc4ccd45c3d4$var$_defineProperty2.default)(this, "_value", void 0);
        this._value = (0, $26e3fc4ccd45c3d4$var$_unique.default)((0, $26e3fc4ccd45c3d4$var$_isArray.default)(value) ? value : [
            value
        ]);
    }
    applyTo(value) {
        if (value == null) return [];
        if ((0, $26e3fc4ccd45c3d4$var$_isArray.default)(value)) {
            const ParseObject = $26e3fc4ccd45c3d4$var$_CoreManager.default.getParseObject();
            // var i = value.indexOf(this._value);
            const removed = (0, $26e3fc4ccd45c3d4$var$_concat.default)(value).call(value, []);
            for(let i = 0; i < this._value.length; i++){
                let index = (0, $26e3fc4ccd45c3d4$var$_indexOf.default)(removed).call(removed, this._value[i]);
                while(index > -1){
                    (0, $26e3fc4ccd45c3d4$var$_splice.default)(removed).call(removed, index, 1);
                    index = (0, $26e3fc4ccd45c3d4$var$_indexOf.default)(removed).call(removed, this._value[i]);
                }
                if (this._value[i] instanceof ParseObject && this._value[i].id) {
                    for(let j = 0; j < removed.length; j++)if (removed[j] instanceof ParseObject && this._value[i].id === removed[j].id) {
                        (0, $26e3fc4ccd45c3d4$var$_splice.default)(removed).call(removed, j, 1);
                        j--;
                    }
                }
            }
            return removed;
        }
        throw new Error("Cannot remove elements from a non-array value");
    }
    mergeWith(previous) {
        if (!previous) return this;
        if (previous instanceof $26e3fc4ccd45c3d4$var$SetOp) return new $26e3fc4ccd45c3d4$var$SetOp(this.applyTo(previous._value));
        if (previous instanceof $26e3fc4ccd45c3d4$var$UnsetOp) return new $26e3fc4ccd45c3d4$var$UnsetOp();
        if (previous instanceof $26e3fc4ccd45c3d4$var$RemoveOp) {
            var _context2;
            const ParseObject = $26e3fc4ccd45c3d4$var$_CoreManager.default.getParseObject();
            const uniques = (0, $26e3fc4ccd45c3d4$var$_concat.default)(_context2 = previous._value).call(_context2, []);
            for(let i = 0; i < this._value.length; i++){
                if (this._value[i] instanceof ParseObject) {
                    if (!(0, $26e3fc4ccd45c3d4$var$_arrayContainsObject.default)(uniques, this._value[i])) uniques.push(this._value[i]);
                } else if ((0, $26e3fc4ccd45c3d4$var$_indexOf.default)(uniques).call(uniques, this._value[i]) < 0) uniques.push(this._value[i]);
            }
            return new $26e3fc4ccd45c3d4$var$RemoveOp(uniques);
        }
        throw new Error("Cannot merge Remove Op with the previous Op");
    }
    toJSON() {
        return {
            __op: "Remove",
            objects: (0, $26e3fc4ccd45c3d4$var$_encode.default)(this._value, false, true)
        };
    }
}
module.exports.RemoveOp = $26e3fc4ccd45c3d4$var$RemoveOp;
class $26e3fc4ccd45c3d4$var$RelationOp extends $26e3fc4ccd45c3d4$var$Op {
    constructor(adds, removes){
        super();
        (0, $26e3fc4ccd45c3d4$var$_defineProperty2.default)(this, "_targetClassName", void 0);
        (0, $26e3fc4ccd45c3d4$var$_defineProperty2.default)(this, "relationsToAdd", void 0);
        (0, $26e3fc4ccd45c3d4$var$_defineProperty2.default)(this, "relationsToRemove", void 0);
        this._targetClassName = null;
        if ((0, $26e3fc4ccd45c3d4$var$_isArray.default)(adds)) this.relationsToAdd = (0, $26e3fc4ccd45c3d4$var$_unique.default)((0, $26e3fc4ccd45c3d4$var$_map.default)(adds).call(adds, this._extractId, this));
        if ((0, $26e3fc4ccd45c3d4$var$_isArray.default)(removes)) this.relationsToRemove = (0, $26e3fc4ccd45c3d4$var$_unique.default)((0, $26e3fc4ccd45c3d4$var$_map.default)(removes).call(removes, this._extractId, this));
    }
    _extractId(obj) {
        if (typeof obj === "string") return obj;
        if (!obj.id) throw new Error("You cannot add or remove an unsaved Parse Object from a relation");
        if (!this._targetClassName) this._targetClassName = obj.className;
        if (this._targetClassName !== obj.className) throw new Error("Tried to create a Relation with 2 different object types: " + this._targetClassName + " and " + obj.className + ".");
        return obj.id;
    }
    applyTo(value, parent, key) {
        if (!value) {
            if (!parent || !key) throw new Error("Cannot apply a RelationOp without either a previous value, or an object and a key");
            const relation = new $26e3fc4ccd45c3d4$var$_ParseRelation.default(parent, key);
            relation.targetClassName = this._targetClassName;
            return relation;
        }
        if (value instanceof $26e3fc4ccd45c3d4$var$_ParseRelation.default) {
            if (this._targetClassName) {
                if (value.targetClassName) {
                    if (this._targetClassName !== value.targetClassName) throw new Error("Related object must be a " + value.targetClassName + ", but a " + this._targetClassName + " was passed in.");
                } else value.targetClassName = this._targetClassName;
            }
            return value;
        } else throw new Error("Relation cannot be applied to a non-relation field");
    }
    mergeWith(previous) {
        if (!previous) return this;
        else if (previous instanceof $26e3fc4ccd45c3d4$var$UnsetOp) throw new Error("You cannot modify a relation after deleting it.");
        else if (previous instanceof $26e3fc4ccd45c3d4$var$SetOp && previous._value instanceof $26e3fc4ccd45c3d4$var$_ParseRelation.default) return this;
        else if (previous instanceof $26e3fc4ccd45c3d4$var$RelationOp) {
            var _context3, _context4, _context5, _context6, _context7, _context8;
            if (previous._targetClassName && previous._targetClassName !== this._targetClassName) throw new Error("Related object must be of class " + previous._targetClassName + ", but " + (this._targetClassName || "null") + " was passed in.");
            const newAdd = (0, $26e3fc4ccd45c3d4$var$_concat.default)(_context3 = previous.relationsToAdd).call(_context3, []);
            (0, $26e3fc4ccd45c3d4$var$_forEach.default)(_context4 = this.relationsToRemove).call(_context4, (r)=>{
                const index = (0, $26e3fc4ccd45c3d4$var$_indexOf.default)(newAdd).call(newAdd, r);
                if (index > -1) (0, $26e3fc4ccd45c3d4$var$_splice.default)(newAdd).call(newAdd, index, 1);
            });
            (0, $26e3fc4ccd45c3d4$var$_forEach.default)(_context5 = this.relationsToAdd).call(_context5, (r)=>{
                const index = (0, $26e3fc4ccd45c3d4$var$_indexOf.default)(newAdd).call(newAdd, r);
                if (index < 0) newAdd.push(r);
            });
            const newRemove = (0, $26e3fc4ccd45c3d4$var$_concat.default)(_context6 = previous.relationsToRemove).call(_context6, []);
            (0, $26e3fc4ccd45c3d4$var$_forEach.default)(_context7 = this.relationsToAdd).call(_context7, (r)=>{
                const index = (0, $26e3fc4ccd45c3d4$var$_indexOf.default)(newRemove).call(newRemove, r);
                if (index > -1) (0, $26e3fc4ccd45c3d4$var$_splice.default)(newRemove).call(newRemove, index, 1);
            });
            (0, $26e3fc4ccd45c3d4$var$_forEach.default)(_context8 = this.relationsToRemove).call(_context8, (r)=>{
                const index = (0, $26e3fc4ccd45c3d4$var$_indexOf.default)(newRemove).call(newRemove, r);
                if (index < 0) newRemove.push(r);
            });
            const newRelation = new $26e3fc4ccd45c3d4$var$RelationOp(newAdd, newRemove);
            newRelation._targetClassName = this._targetClassName;
            return newRelation;
        }
        throw new Error("Cannot merge Relation Op with the previous Op");
    }
    toJSON() {
        const idToPointer = (id)=>{
            return {
                __type: "Pointer",
                className: this._targetClassName,
                objectId: id
            };
        };
        let pointers = null;
        let adds = null;
        let removes = null;
        if (this.relationsToAdd.length > 0) {
            var _context9;
            pointers = (0, $26e3fc4ccd45c3d4$var$_map.default)(_context9 = this.relationsToAdd).call(_context9, idToPointer);
            adds = {
                __op: "AddRelation",
                objects: pointers
            };
        }
        if (this.relationsToRemove.length > 0) {
            var _context10;
            pointers = (0, $26e3fc4ccd45c3d4$var$_map.default)(_context10 = this.relationsToRemove).call(_context10, idToPointer);
            removes = {
                __op: "RemoveRelation",
                objects: pointers
            };
        }
        if (adds && removes) return {
            __op: "Batch",
            ops: [
                adds,
                removes
            ]
        };
        return adds || removes || {};
    }
}
module.exports.RelationOp = $26e3fc4ccd45c3d4$var$RelationOp;
$26e3fc4ccd45c3d4$var$_CoreManager.default.setParseOp({
    Op: $26e3fc4ccd45c3d4$var$Op,
    opFromJSON: $26e3fc4ccd45c3d4$var$opFromJSON,
    SetOp: $26e3fc4ccd45c3d4$var$SetOp,
    UnsetOp: $26e3fc4ccd45c3d4$var$UnsetOp,
    IncrementOp: $26e3fc4ccd45c3d4$var$IncrementOp,
    AddOp: $26e3fc4ccd45c3d4$var$AddOp,
    RelationOp: $26e3fc4ccd45c3d4$var$RelationOp,
    RemoveOp: $26e3fc4ccd45c3d4$var$RemoveOp,
    AddUniqueOp: $26e3fc4ccd45c3d4$var$AddUniqueOp
});

});
parcelRegister("koRMr", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ed9fc43353980608$var$arrayContainsObject;

var $ed9fc43353980608$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $ed9fc43353980608$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));
function $ed9fc43353980608$var$arrayContainsObject(array, object) {
    if ((0, $ed9fc43353980608$var$_indexOf.default)(array).call(array, object) > -1) return true;
    const ParseObject = $ed9fc43353980608$var$_CoreManager.default.getParseObject();
    for(let i = 0; i < array.length; i++){
        if (array[i] instanceof ParseObject && array[i].className === object.className && array[i]._getId() === object._getId()) return true;
    }
    return false;
}

});

parcelRegister("aoRXv", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7926005fcd592cab$var$unique;

var $7926005fcd592cab$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $7926005fcd592cab$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $7926005fcd592cab$var$_arrayContainsObject = $iHLHC((parcelRequire("koRMr")));

var $7926005fcd592cab$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));
function $7926005fcd592cab$var$unique(arr) {
    const uniques = [];
    (0, $7926005fcd592cab$var$_forEach.default)(arr).call(arr, (value)=>{
        const ParseObject = $7926005fcd592cab$var$_CoreManager.default.getParseObject();
        if (value instanceof ParseObject) {
            if (!(0, $7926005fcd592cab$var$_arrayContainsObject.default)(uniques, value)) uniques.push(value);
        } else if ((0, $7926005fcd592cab$var$_indexOf.default)(uniques).call(uniques, value) < 0) uniques.push(value);
    });
    return uniques;
}

});


parcelRegister("8mp0p", function(module, exports) {
"use strict";

var $1X85b = parcelRequire("1X85b");

var $4i3Tl = parcelRequire("4i3Tl");

var $dzKYE = parcelRequire("dzKYE");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllState = $6163c669c0dd0a58$var$clearAllState;
module.exports.commitServerChanges = $6163c669c0dd0a58$var$commitServerChanges;
module.exports.duplicateState = $6163c669c0dd0a58$var$duplicateState;
module.exports.enqueueTask = $6163c669c0dd0a58$var$enqueueTask;
module.exports.estimateAttribute = $6163c669c0dd0a58$var$estimateAttribute;
module.exports.estimateAttributes = $6163c669c0dd0a58$var$estimateAttributes;
module.exports.getObjectCache = $6163c669c0dd0a58$var$getObjectCache;
module.exports.getPendingOps = $6163c669c0dd0a58$var$getPendingOps;
module.exports.getServerData = $6163c669c0dd0a58$var$getServerData;
module.exports.getState = $6163c669c0dd0a58$var$getState;
module.exports.initializeState = $6163c669c0dd0a58$var$initializeState;
module.exports.mergeFirstPendingState = $6163c669c0dd0a58$var$mergeFirstPendingState;
module.exports.popPendingState = $6163c669c0dd0a58$var$popPendingState;
module.exports.pushPendingState = $6163c669c0dd0a58$var$pushPendingState;
module.exports.removeState = $6163c669c0dd0a58$var$removeState;
module.exports.setPendingOp = $6163c669c0dd0a58$var$setPendingOp;
module.exports.setServerData = $6163c669c0dd0a58$var$setServerData;

var $6163c669c0dd0a58$var$ObjectStateMutations = $6163c669c0dd0a58$var$_interopRequireWildcard((parcelRequire("ad1OE")));
function $6163c669c0dd0a58$var$_getRequireWildcardCache(e) {
    if ("function" != typeof $1X85b) return null;
    var r = new $1X85b(), t = new $1X85b();
    return ($6163c669c0dd0a58$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $6163c669c0dd0a58$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $6163c669c0dd0a58$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    };
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = $4i3Tl && $dzKYE ? $dzKYE(e, u) : null;
        i && (i.get || i.set) ? $4i3Tl(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
let $6163c669c0dd0a58$var$objectState = {};
function $6163c669c0dd0a58$var$getState(obj) {
    const classData = $6163c669c0dd0a58$var$objectState[obj.className];
    if (classData) return classData[obj.id] || null;
    return null;
}
function $6163c669c0dd0a58$var$initializeState(obj, initial) {
    let state = $6163c669c0dd0a58$var$getState(obj);
    if (state) return state;
    if (!$6163c669c0dd0a58$var$objectState[obj.className]) $6163c669c0dd0a58$var$objectState[obj.className] = {};
    if (!initial) initial = $6163c669c0dd0a58$var$ObjectStateMutations.defaultState();
    state = $6163c669c0dd0a58$var$objectState[obj.className][obj.id] = initial;
    return state;
}
function $6163c669c0dd0a58$var$removeState(obj) {
    const state = $6163c669c0dd0a58$var$getState(obj);
    if (state === null) return null;
    delete $6163c669c0dd0a58$var$objectState[obj.className][obj.id];
    return state;
}
function $6163c669c0dd0a58$var$getServerData(obj) {
    const state = $6163c669c0dd0a58$var$getState(obj);
    if (state) return state.serverData;
    return {};
}
function $6163c669c0dd0a58$var$setServerData(obj, attributes) {
    const serverData = $6163c669c0dd0a58$var$initializeState(obj).serverData;
    $6163c669c0dd0a58$var$ObjectStateMutations.setServerData(serverData, attributes);
}
function $6163c669c0dd0a58$var$getPendingOps(obj) {
    const state = $6163c669c0dd0a58$var$getState(obj);
    if (state) return state.pendingOps;
    return [
        {}
    ];
}
function $6163c669c0dd0a58$var$setPendingOp(obj, attr, op) {
    const pendingOps = $6163c669c0dd0a58$var$initializeState(obj).pendingOps;
    $6163c669c0dd0a58$var$ObjectStateMutations.setPendingOp(pendingOps, attr, op);
}
function $6163c669c0dd0a58$var$pushPendingState(obj) {
    const pendingOps = $6163c669c0dd0a58$var$initializeState(obj).pendingOps;
    $6163c669c0dd0a58$var$ObjectStateMutations.pushPendingState(pendingOps);
}
function $6163c669c0dd0a58$var$popPendingState(obj) {
    const pendingOps = $6163c669c0dd0a58$var$initializeState(obj).pendingOps;
    return $6163c669c0dd0a58$var$ObjectStateMutations.popPendingState(pendingOps);
}
function $6163c669c0dd0a58$var$mergeFirstPendingState(obj) {
    const pendingOps = $6163c669c0dd0a58$var$getPendingOps(obj);
    $6163c669c0dd0a58$var$ObjectStateMutations.mergeFirstPendingState(pendingOps);
}
function $6163c669c0dd0a58$var$getObjectCache(obj) {
    const state = $6163c669c0dd0a58$var$getState(obj);
    if (state) return state.objectCache;
    return {};
}
function $6163c669c0dd0a58$var$estimateAttribute(obj, attr) {
    const serverData = $6163c669c0dd0a58$var$getServerData(obj);
    const pendingOps = $6163c669c0dd0a58$var$getPendingOps(obj);
    return $6163c669c0dd0a58$var$ObjectStateMutations.estimateAttribute(serverData, pendingOps, obj, attr);
}
function $6163c669c0dd0a58$var$estimateAttributes(obj) {
    const serverData = $6163c669c0dd0a58$var$getServerData(obj);
    const pendingOps = $6163c669c0dd0a58$var$getPendingOps(obj);
    return $6163c669c0dd0a58$var$ObjectStateMutations.estimateAttributes(serverData, pendingOps, obj);
}
function $6163c669c0dd0a58$var$commitServerChanges(obj, changes) {
    const state = $6163c669c0dd0a58$var$initializeState(obj);
    $6163c669c0dd0a58$var$ObjectStateMutations.commitServerChanges(state.serverData, state.objectCache, changes);
}
function $6163c669c0dd0a58$var$enqueueTask(obj, task) {
    const state = $6163c669c0dd0a58$var$initializeState(obj);
    return state.tasks.enqueue(task);
}
function $6163c669c0dd0a58$var$clearAllState() {
    $6163c669c0dd0a58$var$objectState = {};
}
function $6163c669c0dd0a58$var$duplicateState(source, dest) {
    dest.id = source.id;
}

});
parcelRegister("ad1OE", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.commitServerChanges = $76ec86e4064af147$var$commitServerChanges;
module.exports.defaultState = $76ec86e4064af147$var$defaultState;
module.exports.estimateAttribute = $76ec86e4064af147$var$estimateAttribute;
module.exports.estimateAttributes = $76ec86e4064af147$var$estimateAttributes;
module.exports.mergeFirstPendingState = $76ec86e4064af147$var$mergeFirstPendingState;
module.exports.popPendingState = $76ec86e4064af147$var$popPendingState;
module.exports.pushPendingState = $76ec86e4064af147$var$pushPendingState;
module.exports.setPendingOp = $76ec86e4064af147$var$setPendingOp;
module.exports.setServerData = $76ec86e4064af147$var$setServerData;

var $76ec86e4064af147$var$_includes = $iHLHC((parcelRequire("dNrmj")));

var $76ec86e4064af147$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $76ec86e4064af147$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $76ec86e4064af147$var$_encode = $iHLHC((parcelRequire("1rsTn")));

var $76ec86e4064af147$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $76ec86e4064af147$var$_ParseFile = $iHLHC((parcelRequire("59JWU")));

var $76ec86e4064af147$var$_ParseRelation = $iHLHC((parcelRequire("967gW")));

var $76ec86e4064af147$var$_TaskQueue = $iHLHC((parcelRequire("6o8rx")));

var $3l0Qd = parcelRequire("3l0Qd");
function $76ec86e4064af147$var$defaultState() {
    return {
        serverData: {},
        pendingOps: [
            {}
        ],
        objectCache: {},
        tasks: new $76ec86e4064af147$var$_TaskQueue.default(),
        existed: false
    };
}
function $76ec86e4064af147$var$setServerData(serverData, attributes) {
    for(const attr in attributes)if (typeof attributes[attr] !== "undefined") serverData[attr] = attributes[attr];
    else delete serverData[attr];
}
function $76ec86e4064af147$var$setPendingOp(pendingOps, attr, op) {
    const last = pendingOps.length - 1;
    if (op) pendingOps[last][attr] = op;
    else delete pendingOps[last][attr];
}
function $76ec86e4064af147$var$pushPendingState(pendingOps) {
    pendingOps.push({});
}
function $76ec86e4064af147$var$popPendingState(pendingOps) {
    const first = pendingOps.shift();
    if (!pendingOps.length) pendingOps[0] = {};
    return first;
}
function $76ec86e4064af147$var$mergeFirstPendingState(pendingOps) {
    const first = $76ec86e4064af147$var$popPendingState(pendingOps);
    const next = pendingOps[0];
    for(const attr in first)if (next[attr] && first[attr]) {
        const merged = next[attr].mergeWith(first[attr]);
        if (merged) next[attr] = merged;
    } else next[attr] = first[attr];
}
function $76ec86e4064af147$var$estimateAttribute(serverData, pendingOps, object, attr) {
    let value = serverData[attr];
    for(let i = 0; i < pendingOps.length; i++)if (pendingOps[i][attr]) {
        if (pendingOps[i][attr] instanceof $3l0Qd.RelationOp) {
            if (object.id) value = pendingOps[i][attr].applyTo(value, object, attr);
        } else value = pendingOps[i][attr].applyTo(value);
    }
    return value;
}
function $76ec86e4064af147$var$estimateAttributes(serverData, pendingOps, object) {
    const data = {};
    for(var attr in serverData)data[attr] = serverData[attr];
    for(let i = 0; i < pendingOps.length; i++)for(attr in pendingOps[i]){
        if (pendingOps[i][attr] instanceof $3l0Qd.RelationOp) {
            if (object.id) data[attr] = pendingOps[i][attr].applyTo(data[attr], object, attr);
        } else if ((0, $76ec86e4064af147$var$_includes.default)(attr).call(attr, ".")) {
            // similar to nestedSet function
            const fields = attr.split(".");
            const last = fields[fields.length - 1];
            let object = data;
            for(let i = 0; i < fields.length - 1; i++){
                const key = fields[i];
                if (!(key in object)) {
                    const nextKey = fields[i + 1];
                    if (!isNaN(nextKey)) object[key] = [];
                    else object[key] = {};
                } else if ((0, $76ec86e4064af147$var$_isArray.default)(object[key])) object[key] = [
                    ...object[key]
                ];
                else object[key] = {
                    ...object[key]
                };
                object = object[key];
            }
            object[last] = pendingOps[i][attr].applyTo(object[last]);
        } else data[attr] = pendingOps[i][attr].applyTo(data[attr]);
    }
    return data;
}
/**
 * Allows setting properties/variables deep in an object.
 * Converts a.b into { a: { b: value } } for dot notation on Objects
 * Converts a.0.b into { a: [{ b: value }] } for dot notation on Arrays
 *
 * @param obj The object to assign the value to
 * @param key The key to assign. If it's in a deeper path, then use dot notation (`prop1.prop2.prop3`)
 * Note that intermediate object(s) in the nested path are automatically created if they don't exist.
 * @param value The value to assign. If it's an `undefined` then the key is deleted.
 */ function $76ec86e4064af147$var$nestedSet(obj, key, value) {
    const paths = key.split(".");
    for(let i = 0; i < paths.length - 1; i++){
        const path = paths[i];
        if (!(path in obj)) {
            const nextPath = paths[i + 1];
            if (!isNaN(nextPath)) obj[path] = [];
            else obj[path] = {};
        }
        obj = obj[path];
    }
    if (typeof value === "undefined") delete obj[paths[paths.length - 1]];
    else obj[paths[paths.length - 1]] = value;
}
function $76ec86e4064af147$var$commitServerChanges(serverData, objectCache, changes) {
    const ParseObject = $76ec86e4064af147$var$_CoreManager.default.getParseObject();
    for(const attr in changes){
        const val = changes[attr];
        $76ec86e4064af147$var$nestedSet(serverData, attr, val);
        if (val && typeof val === "object" && !(val instanceof ParseObject) && !(val instanceof $76ec86e4064af147$var$_ParseFile.default) && !(val instanceof $76ec86e4064af147$var$_ParseRelation.default)) {
            const json = (0, $76ec86e4064af147$var$_encode.default)(val, false, true);
            objectCache[attr] = (0, $76ec86e4064af147$var$_stringify.default)(json);
        }
    }
}

});
parcelRegister("6o8rx", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a6b889f9dd6a2af$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $9FsFR = parcelRequire("9FsFR");
class $4a6b889f9dd6a2af$var$TaskQueue {
    constructor(){
        (0, $4a6b889f9dd6a2af$var$_defineProperty2.default)(this, "queue", void 0);
        this.queue = [];
    }
    enqueue(task) {
        const taskComplete = (0, $9FsFR.resolvingPromise)();
        this.queue.push({
            task: task,
            _completion: taskComplete
        });
        if (this.queue.length === 1) task().then(()=>{
            this._dequeue();
            taskComplete.resolve();
        }, (error)=>{
            this._dequeue();
            taskComplete.reject(error);
        });
        return taskComplete;
    }
    _dequeue() {
        this.queue.shift();
        if (this.queue.length) {
            const next = this.queue[0];
            next.task().then(()=>{
                this._dequeue();
                next._completion.resolve();
            }, (error)=>{
                this._dequeue();
                next._completion.reject(error);
            });
        }
    }
}
module.exports = $4a6b889f9dd6a2af$var$TaskQueue;
var $4a6b889f9dd6a2af$var$_default = module.exports.default = $4a6b889f9dd6a2af$var$TaskQueue;

});



parcelRegister("eyyNg", function(module, exports) {
"use strict";


var $4i3Tl = parcelRequire("4i3Tl");

var $dzKYE = parcelRequire("dzKYE");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllState = $a98f3af035ff8d06$var$clearAllState;
module.exports.commitServerChanges = $a98f3af035ff8d06$var$commitServerChanges;
module.exports.duplicateState = $a98f3af035ff8d06$var$duplicateState;
module.exports.enqueueTask = $a98f3af035ff8d06$var$enqueueTask;
module.exports.estimateAttribute = $a98f3af035ff8d06$var$estimateAttribute;
module.exports.estimateAttributes = $a98f3af035ff8d06$var$estimateAttributes;
module.exports.getObjectCache = $a98f3af035ff8d06$var$getObjectCache;
module.exports.getPendingOps = $a98f3af035ff8d06$var$getPendingOps;
module.exports.getServerData = $a98f3af035ff8d06$var$getServerData;
module.exports.getState = $a98f3af035ff8d06$var$getState;
module.exports.initializeState = $a98f3af035ff8d06$var$initializeState;
module.exports.mergeFirstPendingState = $a98f3af035ff8d06$var$mergeFirstPendingState;
module.exports.popPendingState = $a98f3af035ff8d06$var$popPendingState;
module.exports.pushPendingState = $a98f3af035ff8d06$var$pushPendingState;
module.exports.removeState = $a98f3af035ff8d06$var$removeState;
module.exports.setPendingOp = $a98f3af035ff8d06$var$setPendingOp;
module.exports.setServerData = $a98f3af035ff8d06$var$setServerData;

var $a98f3af035ff8d06$var$_weakMap = $iHLHC((parcelRequire("1X85b")));

var $a98f3af035ff8d06$var$ObjectStateMutations = $a98f3af035ff8d06$var$_interopRequireWildcard((parcelRequire("ad1OE")));

var $a98f3af035ff8d06$var$_TaskQueue = $iHLHC((parcelRequire("6o8rx")));
function $a98f3af035ff8d06$var$_getRequireWildcardCache(e) {
    if ("function" != typeof (parcelRequire("1X85b"))) return null;
    var r = new (parcelRequire("1X85b"))(), t = new (parcelRequire("1X85b"))();
    return ($a98f3af035ff8d06$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $a98f3af035ff8d06$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $a98f3af035ff8d06$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    };
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = $4i3Tl && $dzKYE ? $dzKYE(e, u) : null;
        i && (i.get || i.set) ? $4i3Tl(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
let $a98f3af035ff8d06$var$objectState = new $a98f3af035ff8d06$var$_weakMap.default();
function $a98f3af035ff8d06$var$getState(obj) {
    const classData = $a98f3af035ff8d06$var$objectState.get(obj);
    return classData || null;
}
function $a98f3af035ff8d06$var$initializeState(obj, initial) {
    let state = $a98f3af035ff8d06$var$getState(obj);
    if (state) return state;
    if (!initial) initial = {
        serverData: {},
        pendingOps: [
            {}
        ],
        objectCache: {},
        tasks: new $a98f3af035ff8d06$var$_TaskQueue.default(),
        existed: false
    };
    state = initial;
    $a98f3af035ff8d06$var$objectState.set(obj, state);
    return state;
}
function $a98f3af035ff8d06$var$removeState(obj) {
    const state = $a98f3af035ff8d06$var$getState(obj);
    if (state === null) return null;
    $a98f3af035ff8d06$var$objectState.delete(obj);
    return state;
}
function $a98f3af035ff8d06$var$getServerData(obj) {
    const state = $a98f3af035ff8d06$var$getState(obj);
    if (state) return state.serverData;
    return {};
}
function $a98f3af035ff8d06$var$setServerData(obj, attributes) {
    const serverData = $a98f3af035ff8d06$var$initializeState(obj).serverData;
    $a98f3af035ff8d06$var$ObjectStateMutations.setServerData(serverData, attributes);
}
function $a98f3af035ff8d06$var$getPendingOps(obj) {
    const state = $a98f3af035ff8d06$var$getState(obj);
    if (state) return state.pendingOps;
    return [
        {}
    ];
}
function $a98f3af035ff8d06$var$setPendingOp(obj, attr, op) {
    const pendingOps = $a98f3af035ff8d06$var$initializeState(obj).pendingOps;
    $a98f3af035ff8d06$var$ObjectStateMutations.setPendingOp(pendingOps, attr, op);
}
function $a98f3af035ff8d06$var$pushPendingState(obj) {
    const pendingOps = $a98f3af035ff8d06$var$initializeState(obj).pendingOps;
    $a98f3af035ff8d06$var$ObjectStateMutations.pushPendingState(pendingOps);
}
function $a98f3af035ff8d06$var$popPendingState(obj) {
    const pendingOps = $a98f3af035ff8d06$var$initializeState(obj).pendingOps;
    return $a98f3af035ff8d06$var$ObjectStateMutations.popPendingState(pendingOps);
}
function $a98f3af035ff8d06$var$mergeFirstPendingState(obj) {
    const pendingOps = $a98f3af035ff8d06$var$getPendingOps(obj);
    $a98f3af035ff8d06$var$ObjectStateMutations.mergeFirstPendingState(pendingOps);
}
function $a98f3af035ff8d06$var$getObjectCache(obj) {
    const state = $a98f3af035ff8d06$var$getState(obj);
    if (state) return state.objectCache;
    return {};
}
function $a98f3af035ff8d06$var$estimateAttribute(obj, attr) {
    const serverData = $a98f3af035ff8d06$var$getServerData(obj);
    const pendingOps = $a98f3af035ff8d06$var$getPendingOps(obj);
    return $a98f3af035ff8d06$var$ObjectStateMutations.estimateAttribute(serverData, pendingOps, obj, attr);
}
function $a98f3af035ff8d06$var$estimateAttributes(obj) {
    const serverData = $a98f3af035ff8d06$var$getServerData(obj);
    const pendingOps = $a98f3af035ff8d06$var$getPendingOps(obj);
    return $a98f3af035ff8d06$var$ObjectStateMutations.estimateAttributes(serverData, pendingOps, obj);
}
function $a98f3af035ff8d06$var$commitServerChanges(obj, changes) {
    const state = $a98f3af035ff8d06$var$initializeState(obj);
    $a98f3af035ff8d06$var$ObjectStateMutations.commitServerChanges(state.serverData, state.objectCache, changes);
}
function $a98f3af035ff8d06$var$enqueueTask(obj, task) {
    const state = $a98f3af035ff8d06$var$initializeState(obj);
    return state.tasks.enqueue(task);
}
function $a98f3af035ff8d06$var$duplicateState(source, dest) {
    const oldState = $a98f3af035ff8d06$var$initializeState(source);
    const newState = $a98f3af035ff8d06$var$initializeState(dest);
    for(const key in oldState.serverData)newState.serverData[key] = oldState.serverData[key];
    for(let index = 0; index < oldState.pendingOps.length; index++)for(const key in oldState.pendingOps[index])newState.pendingOps[index][key] = oldState.pendingOps[index][key];
    for(const key in oldState.objectCache)newState.objectCache[key] = oldState.objectCache[key];
    newState.existed = oldState.existed;
}
function $a98f3af035ff8d06$var$clearAllState() {
    $a98f3af035ff8d06$var$objectState = new $a98f3af035ff8d06$var$_weakMap.default();
}

});

parcelRegister("zyRRD", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $06ae5103554c9256$var$unsavedChildren;

var $06ae5103554c9256$var$_concat = $iHLHC((parcelRequire("oorJA")));

var $06ae5103554c9256$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $06ae5103554c9256$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $06ae5103554c9256$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $06ae5103554c9256$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $06ae5103554c9256$var$_ParseFile = $iHLHC((parcelRequire("59JWU")));

var $06ae5103554c9256$var$_ParseRelation = $iHLHC((parcelRequire("967gW")));
/**
 * Return an array of unsaved children, which are either Parse Objects or Files.
 * If it encounters any dirty Objects without Ids, it will throw an exception.
 *
 * @param {Parse.Object} obj
 * @param {boolean} allowDeepUnsaved
 * @returns {Array}
 */ function $06ae5103554c9256$var$unsavedChildren(obj, allowDeepUnsaved) {
    const encountered = {
        objects: {},
        files: []
    };
    const identifier = obj.className + ":" + obj._getId();
    encountered.objects[identifier] = obj.dirty() ? obj : true;
    const attributes = obj.attributes;
    for(const attr in attributes)if (typeof attributes[attr] === "object") $06ae5103554c9256$var$traverse(attributes[attr], encountered, false, !!allowDeepUnsaved);
    const unsaved = [];
    for(const id in encountered.objects)if (id !== identifier && encountered.objects[id] !== true) unsaved.push(encountered.objects[id]);
    return (0, $06ae5103554c9256$var$_concat.default)(unsaved).call(unsaved, encountered.files);
}
function $06ae5103554c9256$var$traverse(obj, encountered, shouldThrow, allowDeepUnsaved) {
    const ParseObject = $06ae5103554c9256$var$_CoreManager.default.getParseObject();
    if (obj instanceof ParseObject) {
        if (!obj.id && shouldThrow) throw new Error("Cannot create a pointer to an unsaved Object.");
        const identifier = obj.className + ":" + obj._getId();
        if (!encountered.objects[identifier]) {
            encountered.objects[identifier] = obj.dirty() ? obj : true;
            const attributes = obj.attributes;
            for(const attr in attributes)if (typeof attributes[attr] === "object") $06ae5103554c9256$var$traverse(attributes[attr], encountered, !allowDeepUnsaved, allowDeepUnsaved);
        }
        return;
    }
    if (obj instanceof $06ae5103554c9256$var$_ParseFile.default) {
        var _context;
        if (!obj.url() && (0, $06ae5103554c9256$var$_indexOf.default)(_context = encountered.files).call(_context, obj) < 0) encountered.files.push(obj);
        return;
    }
    if (obj instanceof $06ae5103554c9256$var$_ParseRelation.default) return;
    if ((0, $06ae5103554c9256$var$_isArray.default)(obj)) (0, $06ae5103554c9256$var$_forEach.default)(obj).call(obj, (el)=>{
        if (typeof el === "object") $06ae5103554c9256$var$traverse(el, encountered, shouldThrow, allowDeepUnsaved);
    });
    for(const k in obj)if (typeof obj[k] === "object") $06ae5103554c9256$var$traverse(obj[k], encountered, shouldThrow, allowDeepUnsaved);
}

});


parcelRegister("4FVCr", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3677afb657bcb4bc$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $3677afb657bcb4bc$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $3677afb657bcb4bc$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $3677afb657bcb4bc$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $3677afb657bcb4bc$var$_slice = $iHLHC((parcelRequire("a1TrC")));

var $3677afb657bcb4bc$var$_map = $iHLHC((parcelRequire("2VoQi")));

var $3677afb657bcb4bc$var$_filter = $iHLHC((parcelRequire("i3o6i")));

var $3677afb657bcb4bc$var$_keys2 = $iHLHC((parcelRequire("e9nT0")));

var $3677afb657bcb4bc$var$_concat = $iHLHC((parcelRequire("oorJA")));

var $3677afb657bcb4bc$var$_includes = $iHLHC((parcelRequire("dNrmj")));

var $3677afb657bcb4bc$var$_sort = $iHLHC((parcelRequire("8zvHt")));

var $3677afb657bcb4bc$var$_splice = $iHLHC((parcelRequire("aFg1C")));

var $3677afb657bcb4bc$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $3677afb657bcb4bc$var$_find = $iHLHC((parcelRequire("c61hX")));

var $3677afb657bcb4bc$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $3677afb657bcb4bc$var$_entries = $iHLHC((parcelRequire("hOvAP")));

var $3677afb657bcb4bc$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $3677afb657bcb4bc$var$_encode = $iHLHC((parcelRequire("1rsTn")));

var $9FsFR = parcelRequire("9FsFR");

var $3677afb657bcb4bc$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $3677afb657bcb4bc$var$_ParseGeoPoint = $iHLHC((parcelRequire("jtZTC")));

var $3677afb657bcb4bc$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $3677afb657bcb4bc$var$_OfflineQuery = $iHLHC((parcelRequire("fKbuz")));

var $klpRA = parcelRequire("klpRA");
/**
 * Converts a string into a regex that matches it.
 * Surrounding with \Q .. \E does this, we just need to escape any \E's in
 * the text separately.
 *
 * @param s
 * @private
 * @returns {string}
 */ function $3677afb657bcb4bc$var$quote(s) {
    return "\\Q" + s.replace("\\E", "\\E\\\\E\\Q") + "\\E";
}
/**
 * Extracts the class name from queries. If not all queries have the same
 * class name an error will be thrown.
 *
 * @param queries
 * @private
 * @returns {string}
 */ function $3677afb657bcb4bc$var$_getClassNameFromQueries(queries) {
    let className = null;
    (0, $3677afb657bcb4bc$var$_forEach.default)(queries).call(queries, (q)=>{
        if (!className) className = q.className;
        if (className !== q.className) throw new Error("All queries must be for the same class.");
    });
    return className;
}
/*
 * Handles pre-populating the result data of a query with select fields,
 * making sure that the data object contains keys for all objects that have
 * been requested with a select, so that our cached state updates correctly.
 */ function $3677afb657bcb4bc$var$handleSelectResult(data, select) {
    const serverDataMask = {};
    (0, $3677afb657bcb4bc$var$_forEach.default)(select).call(select, (field)=>{
        const hasSubObjectSelect = (0, $3677afb657bcb4bc$var$_indexOf.default)(field).call(field, ".") !== -1;
        if (!hasSubObjectSelect && !data.hasOwnProperty(field)) // this field was selected, but is missing from the retrieved data
        data[field] = undefined;
        else if (hasSubObjectSelect) {
            // this field references a sub-object,
            // so we need to walk down the path components
            const pathComponents = field.split(".");
            let obj = data;
            let serverMask = serverDataMask;
            (0, $3677afb657bcb4bc$var$_forEach.default)(pathComponents).call(pathComponents, (component, index, arr)=>{
                // add keys if the expected data is missing
                if (obj && !obj.hasOwnProperty(component)) obj[component] = undefined;
                if (obj && typeof obj === "object") obj = obj[component];
                //add this path component to the server mask so we can fill it in later if needed
                if (index < arr.length - 1) {
                    if (!serverMask[component]) serverMask[component] = {};
                    serverMask = serverMask[component];
                }
            });
        }
    });
    if ((0, $3677afb657bcb4bc$var$_keys.default)(serverDataMask).length > 0) {
        // When selecting from sub-objects, we don't want to blow away the missing
        // information that we may have retrieved before. We've already added any
        // missing selected keys to sub-objects, but we still need to add in the
        // data for any previously retrieved sub-objects that were not selected.
        const serverData = $3677afb657bcb4bc$var$_CoreManager.default.getObjectStateController().getServerData({
            id: data.objectId,
            className: data.className
        });
        $3677afb657bcb4bc$var$copyMissingDataWithMask(serverData, data, serverDataMask, false);
    }
}
function $3677afb657bcb4bc$var$copyMissingDataWithMask(src, dest, mask, copyThisLevel) {
    //copy missing elements at this level
    if (copyThisLevel) {
        for(const key in src)if (src.hasOwnProperty(key) && !dest.hasOwnProperty(key)) dest[key] = src[key];
    }
    for(const key in mask)if (dest[key] !== undefined && dest[key] !== null && src !== undefined && src !== null) //traverse into objects as needed
    $3677afb657bcb4bc$var$copyMissingDataWithMask(src[key], dest[key], mask[key], true);
}
function $3677afb657bcb4bc$var$handleOfflineSort(a, b, sorts) {
    let order = sorts[0];
    const operator = (0, $3677afb657bcb4bc$var$_slice.default)(order).call(order, 0, 1);
    const isDescending = operator === "-";
    if (isDescending) order = order.substring(1);
    if (order === "_created_at") order = "createdAt";
    if (order === "_updated_at") order = "updatedAt";
    if (!/^[A-Za-z][0-9A-Za-z_]*$/.test(order) || order === "password") throw new $3677afb657bcb4bc$var$_ParseError.default($3677afb657bcb4bc$var$_ParseError.default.INVALID_KEY_NAME, `Invalid Key: ${order}`);
    const field1 = a.get(order);
    const field2 = b.get(order);
    if (field1 < field2) return isDescending ? 1 : -1;
    if (field1 > field2) return isDescending ? -1 : 1;
    if (sorts.length > 1) {
        const remainingSorts = (0, $3677afb657bcb4bc$var$_slice.default)(sorts).call(sorts, 1);
        return $3677afb657bcb4bc$var$handleOfflineSort(a, b, remainingSorts);
    }
    return 0;
}
/**
 * Creates a new parse Parse.Query for the given Parse.Object subclass.
 *
 * <p>Parse.Query defines a query that is used to fetch Parse.Objects. The
 * most common use case is finding all objects that match a query through the
 * <code>find</code> method. for example, this sample code fetches all objects
 * of class <code>myclass</code>. it calls a different function depending on
 * whether the fetch succeeded or not.
 *
 * <pre>
 * var query = new Parse.Query(myclass);
 * query.find().then((results) => {
 *   // results is an array of parse.object.
 * }).catch((error) =>  {
 *  // error is an instance of parse.error.
 * });</pre></p>
 *
 * <p>a Parse.Query can also be used to retrieve a single object whose id is
 * known, through the get method. for example, this sample code fetches an
 * object of class <code>myclass</code> and id <code>myid</code>. it calls a
 * different function depending on whether the fetch succeeded or not.
 *
 * <pre>
 * var query = new Parse.Query(myclass);
 * query.get(myid).then((object) => {
 *     // object is an instance of parse.object.
 * }).catch((error) =>  {
 *  // error is an instance of parse.error.
 * });</pre></p>
 *
 * <p>a Parse.Query can also be used to count the number of objects that match
 * the query without retrieving all of those objects. for example, this
 * sample code counts the number of objects of the class <code>myclass</code>
 * <pre>
 * var query = new Parse.Query(myclass);
 * query.count().then((number) => {
 *     // there are number instances of myclass.
 * }).catch((error) => {
 *     // error is an instance of Parse.Error.
 * });</pre></p>
 *
 * @alias Parse.Query
 */ class $3677afb657bcb4bc$var$ParseQuery {
    /**
   * @param {(string | Parse.Object)} objectClass An instance of a subclass of Parse.Object, or a Parse className string.
   */ constructor(objectClass){
        /**
     * @property {string} className
     */ (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "className", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_where", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_watch", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_include", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_exclude", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_select", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_limit", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_skip", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_count", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_order", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_readPreference", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_includeReadPreference", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_subqueryReadPreference", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_queriesLocalDatastore", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_localDatastorePinName", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_extraOptions", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_hint", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_explain", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_xhrRequest", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_comment", void 0);
        if (typeof objectClass === "string") {
            if (objectClass === "User" && $3677afb657bcb4bc$var$_CoreManager.default.get("PERFORM_USER_REWRITE")) this.className = "_User";
            else this.className = objectClass;
        } else if (objectClass instanceof $3677afb657bcb4bc$var$_ParseObject.default) this.className = objectClass.className;
        else if (typeof objectClass === "function") {
            const objClass = objectClass;
            if (typeof objClass.className === "string") this.className = objClass.className;
            else {
                const obj = new objClass();
                this.className = obj.className;
            }
        } else throw new TypeError("A ParseQuery must be constructed with a ParseObject or class name.");
        this._where = {};
        this._watch = [];
        this._include = [];
        this._exclude = [];
        this._count = false;
        this._limit = -1; // negative limit is not sent in the server request
        this._skip = 0;
        this._readPreference = null;
        this._includeReadPreference = null;
        this._subqueryReadPreference = null;
        this._queriesLocalDatastore = false;
        this._localDatastorePinName = null;
        this._extraOptions = {};
        this._xhrRequest = {
            task: null,
            onchange: ()=>{}
        };
        this._comment = null;
    }
    /**
   * Adds constraint that at least one of the passed in queries matches.
   *
   * @param {Array} queries
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ _orQuery(queries) {
        const queryJSON = (0, $3677afb657bcb4bc$var$_map.default)(queries).call(queries, (q)=>{
            return q.toJSON().where;
        });
        this._where.$or = queryJSON;
        return this;
    }
    /**
   * Adds constraint that all of the passed in queries match.
   *
   * @param {Array} queries
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ _andQuery(queries) {
        const queryJSON = (0, $3677afb657bcb4bc$var$_map.default)(queries).call(queries, (q)=>{
            return q.toJSON().where;
        });
        this._where.$and = queryJSON;
        return this;
    }
    /**
   * Adds constraint that none of the passed in queries match.
   *
   * @param {Array} queries
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ _norQuery(queries) {
        const queryJSON = (0, $3677afb657bcb4bc$var$_map.default)(queries).call(queries, (q)=>{
            return q.toJSON().where;
        });
        this._where.$nor = queryJSON;
        return this;
    }
    /**
   * Helper for condition queries
   *
   * @param key
   * @param condition
   * @param value
   * @returns {Parse.Query}
   */ _addCondition(key, condition, value) {
        if (!this._where[key] || typeof this._where[key] === "string") this._where[key] = {};
        this._where[key][condition] = (0, $3677afb657bcb4bc$var$_encode.default)(value, false, true);
        return this;
    }
    /**
   * Converts string for regular expression at the beginning
   *
   * @param string
   * @returns {string}
   */ _regexStartWith(string) {
        return "^" + $3677afb657bcb4bc$var$quote(string);
    }
    async _handleOfflineQuery(params) {
        var _context;
        $3677afb657bcb4bc$var$_OfflineQuery.default.validateQuery(this);
        const localDatastore = $3677afb657bcb4bc$var$_CoreManager.default.getLocalDatastore();
        const objects = await localDatastore._serializeObjectsFromPinName(this._localDatastorePinName);
        let results = (0, $3677afb657bcb4bc$var$_filter.default)(_context = (0, $3677afb657bcb4bc$var$_map.default)(objects).call(objects, (json, index, arr)=>{
            const object = $3677afb657bcb4bc$var$_ParseObject.default.fromJSON(json, false);
            if (json._localId && !json.objectId) object._localId = json._localId;
            if (!$3677afb657bcb4bc$var$_OfflineQuery.default.matchesQuery(this.className, object, arr, this)) return null;
            return object;
        })).call(_context, (object)=>object !== null);
        if ((0, $3677afb657bcb4bc$var$_keys2.default)(params)) {
            let keys = (0, $3677afb657bcb4bc$var$_keys2.default)(params).split(",");
            keys = (0, $3677afb657bcb4bc$var$_concat.default)(keys).call(keys, [
                "className",
                "objectId",
                "createdAt",
                "updatedAt",
                "ACL"
            ]);
            results = (0, $3677afb657bcb4bc$var$_map.default)(results).call(results, (object)=>{
                var _context2;
                const json = object._toFullJSON();
                (0, $3677afb657bcb4bc$var$_forEach.default)(_context2 = (0, $3677afb657bcb4bc$var$_keys.default)(json)).call(_context2, (key)=>{
                    if (!(0, $3677afb657bcb4bc$var$_includes.default)(keys).call(keys, key)) delete json[key];
                });
                return $3677afb657bcb4bc$var$_ParseObject.default.fromJSON(json, false);
            });
        }
        if (params.order) {
            const sorts = params.order.split(",");
            (0, $3677afb657bcb4bc$var$_sort.default)(results).call(results, (a, b)=>{
                return $3677afb657bcb4bc$var$handleOfflineSort(a, b, sorts);
            });
        }
        let count; // count total before applying limit/skip
        if (params.count) count = results.length; // total count from response
        if (params.skip) {
            if (params.skip >= results.length) results = [];
            else results = (0, $3677afb657bcb4bc$var$_splice.default)(results).call(results, params.skip, results.length);
        }
        let limit = results.length;
        if (params.limit !== 0 && params.limit < results.length) limit = params.limit;
        results = (0, $3677afb657bcb4bc$var$_splice.default)(results).call(results, 0, limit);
        if (typeof count === "number") return {
            results: results,
            count: count
        };
        return results;
    }
    /**
   * Returns a JSON representation of this query.
   *
   * @returns {object} The JSON representation of the query.
   */ toJSON() {
        const params = {
            where: this._where
        };
        if (this._watch.length) params.watch = this._watch.join(",");
        if (this._include.length) params.include = this._include.join(",");
        if (this._exclude.length) params.excludeKeys = this._exclude.join(",");
        if (this._select) params.keys = this._select.join(",");
        if (this._count) params.count = 1;
        if (this._limit >= 0) params.limit = this._limit;
        if (this._skip > 0) params.skip = this._skip;
        if (this._order) params.order = this._order.join(",");
        if (this._readPreference) params.readPreference = this._readPreference;
        if (this._includeReadPreference) params.includeReadPreference = this._includeReadPreference;
        if (this._subqueryReadPreference) params.subqueryReadPreference = this._subqueryReadPreference;
        if (this._hint) params.hint = this._hint;
        if (this._explain) params.explain = true;
        if (this._comment) params.comment = this._comment;
        for(const key in this._extraOptions)params[key] = this._extraOptions[key];
        return params;
    }
    /**
   * Return a query with conditions from json, can be useful to send query from server side to client
   * Not static, all query conditions was set before calling this method will be deleted.
   * For example on the server side we have
   * var query = new Parse.Query("className");
   * query.equalTo(key: value);
   * query.limit(100);
   * ... (others queries)
   * Create JSON representation of Query Object
   * var jsonFromServer = query.fromJSON();
   *
   * On client side getting query:
   * var query = new Parse.Query("className");
   * query.fromJSON(jsonFromServer);
   *
   * and continue to query...
   * query.skip(100).find().then(...);
   *
   * @param {QueryJSON} json from Parse.Query.toJSON() method
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ withJSON(json) {
        if (json.where) this._where = json.where;
        if (json.watch) this._watch = json.watch.split(",");
        if (json.include) this._include = json.include.split(",");
        if ((0, $3677afb657bcb4bc$var$_keys2.default)(json)) this._select = (0, $3677afb657bcb4bc$var$_keys2.default)(json).split(",");
        if (json.excludeKeys) this._exclude = json.excludeKeys.split(",");
        if (json.count) this._count = json.count === 1;
        if (json.limit) this._limit = json.limit;
        if (json.skip) this._skip = json.skip;
        if (json.order) this._order = json.order.split(",");
        if (json.readPreference) this._readPreference = json.readPreference;
        if (json.includeReadPreference) this._includeReadPreference = json.includeReadPreference;
        if (json.subqueryReadPreference) this._subqueryReadPreference = json.subqueryReadPreference;
        if (json.hint) this._hint = json.hint;
        if (json.explain) this._explain = !!json.explain;
        if (json.comment) this._comment = json.comment;
        for(const key in json)if (json.hasOwnProperty(key)) {
            var _context3;
            if ((0, $3677afb657bcb4bc$var$_indexOf.default)(_context3 = [
                "where",
                "include",
                "keys",
                "count",
                "limit",
                "skip",
                "order",
                "readPreference",
                "includeReadPreference",
                "subqueryReadPreference",
                "hint",
                "explain",
                "comment"
            ]).call(_context3, key) === -1) this._extraOptions[key] = json[key];
        }
        return this;
    }
    /**
   * Static method to restore Parse.Query by json representation
   * Internally calling Parse.Query.withJSON
   *
   * @param {string} className
   * @param {QueryJSON} json from Parse.Query.toJSON() method
   * @returns {Parse.Query} new created query
   */ static fromJSON(className, json) {
        const query = new $3677afb657bcb4bc$var$ParseQuery(className);
        return query.withJSON(json);
    }
    /**
   * Constructs a Parse.Object whose id is already known by fetching data from
   * the server. Unlike the <code>first</code> method, it never returns undefined.
   *
   * @param {string} objectId The id of the object to be fetched.
   * @param {object} options
   * Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   *   <li>context: A dictionary that is accessible in Cloud Code `beforeFind` trigger.
   *   <li>json: Return raw json without converting to Parse.Object
   * </ul>
   * @returns {Promise} A promise that is resolved with the result when
   * the query completes.
   */ get(objectId, options) {
        this.equalTo("objectId", objectId);
        const firstOptions = {};
        if (options && options.hasOwnProperty("useMasterKey")) firstOptions.useMasterKey = options.useMasterKey;
        if (options && options.hasOwnProperty("sessionToken")) firstOptions.sessionToken = options.sessionToken;
        if (options && options.hasOwnProperty("context") && typeof options.context === "object") firstOptions.context = options.context;
        if (options && options.hasOwnProperty("json")) firstOptions.json = options.json;
        return this.first(firstOptions).then((response)=>{
            if (response) return response;
            const errorObject = new $3677afb657bcb4bc$var$_ParseError.default($3677afb657bcb4bc$var$_ParseError.default.OBJECT_NOT_FOUND, "Object not found.");
            return $3677afb657bcb4bc$var$_promise.default.reject(errorObject);
        });
    }
    /**
   * Retrieves a list of ParseObjects that satisfy this query.
   *
   * @param {object} options Valid options
   * are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   *   <li>context: A dictionary that is accessible in Cloud Code `beforeFind` trigger.
   *   <li>json: Return raw json without converting to Parse.Object
   * </ul>
   * @returns {Promise} A promise that is resolved with the results when
   * the query completes.
   */ find(options) {
        options = options || {};
        const findOptions = {};
        if (options.hasOwnProperty("useMasterKey")) findOptions.useMasterKey = options.useMasterKey;
        if (options.hasOwnProperty("sessionToken")) findOptions.sessionToken = options.sessionToken;
        if (options.hasOwnProperty("context") && typeof options.context === "object") findOptions.context = options.context;
        this._setRequestTask(findOptions);
        const controller = $3677afb657bcb4bc$var$_CoreManager.default.getQueryController();
        const select = this._select;
        if (this._queriesLocalDatastore) return this._handleOfflineQuery(this.toJSON());
        return (0, $3677afb657bcb4bc$var$_find.default)(controller).call(controller, this.className, this.toJSON(), findOptions).then((response)=>{
            // Return generic object when explain is used
            if (this._explain) return response.results;
            const results = response.results?.map((data)=>{
                // In cases of relations, the server may send back a className
                // on the top level of the payload
                const override = response.className || this.className;
                if (!data.className) data.className = override;
                // Make sure the data object contains keys for all objects that
                // have been requested with a select, so that our cached state
                // updates correctly.
                if (select) $3677afb657bcb4bc$var$handleSelectResult(data, select);
                if (options.json) return data;
                else return $3677afb657bcb4bc$var$_ParseObject.default.fromJSON(data, !select);
            });
            const count = response.count;
            if (typeof count === "number") return {
                results: results,
                count: count
            };
            else return results;
        });
    }
    /**
   * Retrieves a complete list of ParseObjects that satisfy this query.
   * Using `eachBatch` under the hood to fetch all the valid objects.
   *
   * @param {object} options Valid options are:<ul>
   *   <li>batchSize: How many objects to yield in each batch (default: 100)
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   * </ul>
   * @returns {Promise} A promise that is resolved with the results when
   * the query completes.
   */ async findAll(options) {
        let result = [];
        await this.eachBatch((objects)=>{
            result = [
                ...result,
                ...objects
            ];
        }, options);
        return result;
    }
    /**
   * Counts the number of objects that match this query.
   *
   * @param {object} options
   * @param {boolean} [options.useMasterKey]
   * @param {string} [options.sessionToken]
   * Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   * </ul>
   * @returns {Promise} A promise that is resolved with the count when
   * the query completes.
   */ count(options) {
        options = options || {};
        const findOptions = {};
        if (options.hasOwnProperty("useMasterKey")) findOptions.useMasterKey = options.useMasterKey;
        if (options.hasOwnProperty("sessionToken")) findOptions.sessionToken = options.sessionToken;
        this._setRequestTask(findOptions);
        const controller = $3677afb657bcb4bc$var$_CoreManager.default.getQueryController();
        const params = this.toJSON();
        params.limit = 0;
        params.count = 1;
        return (0, $3677afb657bcb4bc$var$_find.default)(controller).call(controller, this.className, params, findOptions).then((result)=>{
            return result.count;
        });
    }
    /**
   * Executes a distinct query and returns unique values
   *
   * @param {string} key A field to find distinct values
   * @param {object} options
   * @param {string} [options.sessionToken] A valid session token, used for making a request on behalf of a specific user.
   * @returns {Promise} A promise that is resolved with the query completes.
   */ distinct(key, options) {
        options = options || {};
        const distinctOptions = {
            useMasterKey: true
        };
        if (options.hasOwnProperty("sessionToken")) distinctOptions.sessionToken = options.sessionToken;
        this._setRequestTask(distinctOptions);
        const controller = $3677afb657bcb4bc$var$_CoreManager.default.getQueryController();
        const params = {
            distinct: key,
            where: this._where,
            hint: this._hint
        };
        return controller.aggregate(this.className, params, distinctOptions).then((results)=>{
            return results.results;
        });
    }
    /**
   * Executes an aggregate query and returns aggregate results
   *
   * @param {(Array|object)} pipeline Array or Object of stages to process query
   * @param {object} options
   * @param {string} [options.sessionToken] A valid session token, used for making a request on behalf of a specific user.
   * @returns {Promise} A promise that is resolved with the query completes.
   */ aggregate(pipeline, options) {
        options = options || {};
        const aggregateOptions = {
            useMasterKey: true
        };
        if (options.hasOwnProperty("sessionToken")) aggregateOptions.sessionToken = options.sessionToken;
        this._setRequestTask(aggregateOptions);
        const controller = $3677afb657bcb4bc$var$_CoreManager.default.getQueryController();
        if (!(0, $3677afb657bcb4bc$var$_isArray.default)(pipeline) && typeof pipeline !== "object") throw new Error("Invalid pipeline must be Array or Object");
        if ((0, $3677afb657bcb4bc$var$_keys.default)(this._where || {}).length) {
            if (!(0, $3677afb657bcb4bc$var$_isArray.default)(pipeline)) pipeline = [
                pipeline
            ];
            pipeline.unshift({
                $match: this._where
            });
        }
        const params = {
            pipeline: pipeline,
            hint: this._hint,
            explain: this._explain,
            readPreference: this._readPreference
        };
        return controller.aggregate(this.className, params, aggregateOptions).then((results)=>{
            return results.results;
        });
    }
    /**
   * Retrieves at most one Parse.Object that satisfies this query.
   *
   * Returns the object if there is one, otherwise undefined.
   *
   * @param {object} options Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   *   <li>context: A dictionary that is accessible in Cloud Code `beforeFind` trigger.
   *   <li>json: Return raw json without converting to Parse.Object
   * </ul>
   * @returns {Promise} A promise that is resolved with the object when
   * the query completes.
   */ first() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const findOptions = {};
        if (options.hasOwnProperty("useMasterKey")) findOptions.useMasterKey = options.useMasterKey;
        if (options.hasOwnProperty("sessionToken")) findOptions.sessionToken = options.sessionToken;
        if (options.hasOwnProperty("context") && typeof options.context === "object") findOptions.context = options.context;
        this._setRequestTask(findOptions);
        const controller = $3677afb657bcb4bc$var$_CoreManager.default.getQueryController();
        const params = this.toJSON();
        params.limit = 1;
        const select = this._select;
        if (this._queriesLocalDatastore) return this._handleOfflineQuery(params).then((objects)=>{
            if (!objects[0]) return undefined;
            return objects[0];
        });
        return (0, $3677afb657bcb4bc$var$_find.default)(controller).call(controller, this.className, params, findOptions).then((response)=>{
            const objects = response.results;
            if (!objects[0]) return undefined;
            if (!objects[0].className) objects[0].className = this.className;
            // Make sure the data object contains keys for all objects that
            // have been requested with a select, so that our cached state
            // updates correctly.
            if (select) $3677afb657bcb4bc$var$handleSelectResult(objects[0], select);
            if (options.json) return objects[0];
            else return $3677afb657bcb4bc$var$_ParseObject.default.fromJSON(objects[0], !select);
        });
    }
    /**
   * Iterates over objects matching a query, calling a callback for each batch.
   * If the callback returns a promise, the iteration will not continue until
   * that promise has been fulfilled. If the callback returns a rejected
   * promise, then iteration will stop with that error. The items are processed
   * in an unspecified order. The query may not have any sort order, and may
   * not use limit or skip.
   *
   * @param {Function} callback Callback that will be called with each result
   *     of the query.
   * @param {object} options Valid options are:<ul>
   *   <li>batchSize: How many objects to yield in each batch (default: 100)
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   *   <li>context: A dictionary that is accessible in Cloud Code `beforeFind` trigger.
   * </ul>
   * @returns {Promise} A promise that will be fulfilled once the
   *     iteration has completed.
   */ eachBatch(callback, options) {
        options = options || {};
        if (this._order || this._skip || this._limit >= 0) return $3677afb657bcb4bc$var$_promise.default.reject("Cannot iterate on a query with sort, skip, or limit.");
        const query = new $3677afb657bcb4bc$var$ParseQuery(this.className);
        query._limit = options.batchSize || 100;
        query._include = [
            ...this._include
        ];
        query._exclude = [
            ...this._exclude
        ];
        if (this._select) query._select = [
            ...this._select
        ];
        query._hint = this._hint;
        query._where = {};
        for(const attr in this._where){
            const val = this._where[attr];
            if ((0, $3677afb657bcb4bc$var$_isArray.default)(val)) query._where[attr] = (0, $3677afb657bcb4bc$var$_map.default)(val).call(val, (v)=>{
                return v;
            });
            else if (val && typeof val === "object") {
                const conditionMap = {};
                query._where[attr] = conditionMap;
                for(const cond in val)conditionMap[cond] = val[cond];
            } else query._where[attr] = val;
        }
        query.ascending("objectId");
        const findOptions = {};
        if (options.hasOwnProperty("useMasterKey")) findOptions.useMasterKey = options.useMasterKey;
        if (options.hasOwnProperty("sessionToken")) findOptions.sessionToken = options.sessionToken;
        if (options.hasOwnProperty("context") && typeof options.context === "object") findOptions.context = options.context;
        if (options.hasOwnProperty("json")) findOptions.json = options.json;
        let finished = false;
        let previousResults = [];
        return (0, $9FsFR.continueWhile)(()=>{
            return !finished;
        }, async ()=>{
            const [results] = await $3677afb657bcb4bc$var$_promise.default.all([
                (0, $3677afb657bcb4bc$var$_find.default)(query).call(query, findOptions),
                $3677afb657bcb4bc$var$_promise.default.resolve(previousResults.length > 0 && callback(previousResults))
            ]);
            if (results.length >= query._limit) {
                query.greaterThan("objectId", results[results.length - 1].id);
                previousResults = results;
            } else if (results.length > 0) {
                await $3677afb657bcb4bc$var$_promise.default.resolve(callback(results));
                finished = true;
            } else finished = true;
        });
    }
    /**
   * Iterates over each result of a query, calling a callback for each one. If
   * the callback returns a promise, the iteration will not continue until
   * that promise has been fulfilled. If the callback returns a rejected
   * promise, then iteration will stop with that error. The items are
   * processed in an unspecified order. The query may not have any sort order,
   * and may not use limit or skip.
   *
   * @param {Function} callback Callback that will be called with each result
   *     of the query.
   * @param {object} options Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   *   <li>json: Return raw json without converting to Parse.Object
   * </ul>
   * @returns {Promise} A promise that will be fulfilled once the
   *     iteration has completed.
   */ each(callback, options) {
        return this.eachBatch((results)=>{
            let callbacksDone = $3677afb657bcb4bc$var$_promise.default.resolve();
            (0, $3677afb657bcb4bc$var$_forEach.default)(results).call(results, (result)=>{
                callbacksDone = callbacksDone.then(()=>{
                    return callback(result);
                });
            });
            return callbacksDone;
        }, options);
    }
    /**
   * Adds a hint to force index selection. (https://docs.mongodb.com/manual/reference/operator/meta/hint/)
   *
   * @param {(string|object)} value String or Object of index that should be used when executing query
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ hint(value) {
        if (typeof value === "undefined") delete this._hint;
        this._hint = value;
        return this;
    }
    /**
   * Investigates the query execution plan. Useful for optimizing queries. (https://docs.mongodb.com/manual/reference/operator/meta/explain/)
   *
   * @param {boolean} explain Used to toggle the information on the query plan.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ explain() {
        let explain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        if (typeof explain !== "boolean") throw new Error("You can only set explain to a boolean value");
        this._explain = explain;
        return this;
    }
    /**
   * Iterates over each result of a query, calling a callback for each one. If
   * the callback returns a promise, the iteration will not continue until
   * that promise has been fulfilled. If the callback returns a rejected
   * promise, then iteration will stop with that error. The items are
   * processed in an unspecified order. The query may not have any sort order,
   * and may not use limit or skip.
   *
   * @param {Function} callback Callback <ul>
   *   <li>currentObject: The current Parse.Object being processed in the array.</li>
   *   <li>index: The index of the current Parse.Object being processed in the array.</li>
   *   <li>query: The query map was called upon.</li>
   * </ul>
   * @param {object} options Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   * </ul>
   * @returns {Promise} A promise that will be fulfilled once the
   *     iteration has completed.
   */ async map(callback, options) {
        const array = [];
        let index = 0;
        await this.each((object)=>{
            return $3677afb657bcb4bc$var$_promise.default.resolve(callback(object, index, this)).then((result)=>{
                array.push(result);
                index += 1;
            });
        }, options);
        return array;
    }
    /**
   * Iterates over each result of a query, calling a callback for each one. If
   * the callback returns a promise, the iteration will not continue until
   * that promise has been fulfilled. If the callback returns a rejected
   * promise, then iteration will stop with that error. The items are
   * processed in an unspecified order. The query may not have any sort order,
   * and may not use limit or skip.
   *
   * @param {Function} callback Callback <ul>
   *   <li>accumulator: The accumulator accumulates the callback's return values. It is the accumulated value previously returned in the last invocation of the callback.</li>
   *   <li>currentObject: The current Parse.Object being processed in the array.</li>
   *   <li>index: The index of the current Parse.Object being processed in the array.</li>
   * </ul>
   * @param {*} initialValue A value to use as the first argument to the first call of the callback. If no initialValue is supplied, the first object in the query will be used and skipped.
   * @param {object} options Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   * </ul>
   * @returns {Promise} A promise that will be fulfilled once the
   *     iteration has completed.
   */ async reduce(callback, initialValue, options) {
        let accumulator = initialValue;
        let index = 0;
        await this.each((object)=>{
            // If no initial value was given, we take the first object from the query
            // as the initial value and don't call the callback with it.
            if (index === 0 && initialValue === undefined) {
                accumulator = object;
                index += 1;
                return;
            }
            return $3677afb657bcb4bc$var$_promise.default.resolve(callback(accumulator, object, index)).then((result)=>{
                accumulator = result;
                index += 1;
            });
        }, options);
        if (index === 0 && initialValue === undefined) // Match Array.reduce behavior: "Calling reduce() on an empty array
        // without an initialValue will throw a TypeError".
        throw new TypeError("Reducing empty query result set with no initial value");
        return accumulator;
    }
    /**
   * Iterates over each result of a query, calling a callback for each one. If
   * the callback returns a promise, the iteration will not continue until
   * that promise has been fulfilled. If the callback returns a rejected
   * promise, then iteration will stop with that error. The items are
   * processed in an unspecified order. The query may not have any sort order,
   * and may not use limit or skip.
   *
   * @param {Function} callback Callback <ul>
   *   <li>currentObject: The current Parse.Object being processed in the array.</li>
   *   <li>index: The index of the current Parse.Object being processed in the array.</li>
   *   <li>query: The query filter was called upon.</li>
   * </ul>
   * @param {object} options Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   *   <li>sessionToken: A valid session token, used for making a request on
   *       behalf of a specific user.
   * </ul>
   * @returns {Promise} A promise that will be fulfilled once the
   *     iteration has completed.
   */ async filter(callback, options) {
        const array = [];
        let index = 0;
        await this.each((object)=>{
            return $3677afb657bcb4bc$var$_promise.default.resolve(callback(object, index, this)).then((flag)=>{
                if (flag) array.push(object);
                index += 1;
            });
        }, options);
        return array;
    }
    /* Query Conditions */ /**
   * Adds a constraint to the query that requires a particular key's value to
   * be equal to the provided value.
   *
   * @param {string} key The key to check.
   * @param value The value that the Parse.Object must contain.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ equalTo(key, value) {
        if (key && typeof key === "object") {
            var _context4;
            (0, $3677afb657bcb4bc$var$_forEach.default)(_context4 = (0, $3677afb657bcb4bc$var$_entries.default)(key)).call(_context4, (_ref)=>{
                let [k, val] = _ref;
                return this.equalTo(k, val);
            });
            return this;
        }
        if (typeof value === "undefined") return this.doesNotExist(key);
        this._where[key] = (0, $3677afb657bcb4bc$var$_encode.default)(value, false, true);
        return this;
    }
    /**
   * Adds a constraint to the query that requires a particular key's value to
   * be not equal to the provided value.
   *
   * @param {string} key The key to check.
   * @param value The value that must not be equalled.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ notEqualTo(key, value) {
        if (key && typeof key === "object") {
            var _context5;
            (0, $3677afb657bcb4bc$var$_forEach.default)(_context5 = (0, $3677afb657bcb4bc$var$_entries.default)(key)).call(_context5, (_ref2)=>{
                let [k, val] = _ref2;
                return this.notEqualTo(k, val);
            });
            return this;
        }
        return this._addCondition(key, "$ne", value);
    }
    /**
   * Adds a constraint to the query that requires a particular key's value to
   * be less than the provided value.
   *
   * @param {string} key The key to check.
   * @param value The value that provides an upper bound.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ lessThan(key, value) {
        return this._addCondition(key, "$lt", value);
    }
    /**
   * Adds a constraint to the query that requires a particular key's value to
   * be greater than the provided value.
   *
   * @param {string} key The key to check.
   * @param value The value that provides an lower bound.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ greaterThan(key, value) {
        return this._addCondition(key, "$gt", value);
    }
    /**
   * Adds a constraint to the query that requires a particular key's value to
   * be less than or equal to the provided value.
   *
   * @param {string} key The key to check.
   * @param value The value that provides an upper bound.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ lessThanOrEqualTo(key, value) {
        return this._addCondition(key, "$lte", value);
    }
    /**
   * Adds a constraint to the query that requires a particular key's value to
   * be greater than or equal to the provided value.
   *
   * @param {string} key The key to check.
   * @param {*} value The value that provides an lower bound.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ greaterThanOrEqualTo(key, value) {
        return this._addCondition(key, "$gte", value);
    }
    /**
   * Adds a constraint to the query that requires a particular key's value to
   * be contained in the provided list of values.
   *
   * @param {string} key The key to check.
   * @param {Array<*>} value The values that will match.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ containedIn(key, value) {
        return this._addCondition(key, "$in", value);
    }
    /**
   * Adds a constraint to the query that requires a particular key's value to
   * not be contained in the provided list of values.
   *
   * @param {string} key The key to check.
   * @param {Array<*>} value The values that will not match.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ notContainedIn(key, value) {
        return this._addCondition(key, "$nin", value);
    }
    /**
   * Adds a constraint to the query that requires a particular key's value to
   * be contained by the provided list of values. Get objects where all array elements match.
   *
   * @param {string} key The key to check.
   * @param {Array} values The values that will match.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ containedBy(key, values) {
        return this._addCondition(key, "$containedBy", values);
    }
    /**
   * Adds a constraint to the query that requires a particular key's value to
   * contain each one of the provided list of values.
   *
   * @param {string} key The key to check.  This key's value must be an array.
   * @param {Array} values The values that will match.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ containsAll(key, values) {
        return this._addCondition(key, "$all", values);
    }
    /**
   * Adds a constraint to the query that requires a particular key's value to
   * contain each one of the provided list of values starting with given strings.
   *
   * @param {string} key The key to check.  This key's value must be an array.
   * @param {Array<string>} values The string values that will match as starting string.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ containsAllStartingWith(key, values) {
        if (!(0, $3677afb657bcb4bc$var$_isArray.default)(values)) values = [
            values
        ];
        const regexObject = (0, $3677afb657bcb4bc$var$_map.default)(values).call(values, (value)=>{
            return {
                $regex: this._regexStartWith(value)
            };
        });
        return this.containsAll(key, regexObject);
    }
    /**
   * Adds a constraint for finding objects that contain the given key.
   *
   * @param {string} key The key that should exist.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ exists(key) {
        return this._addCondition(key, "$exists", true);
    }
    /**
   * Adds a constraint for finding objects that do not contain a given key.
   *
   * @param {string} key The key that should not exist
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ doesNotExist(key) {
        return this._addCondition(key, "$exists", false);
    }
    /**
   * Adds a regular expression constraint for finding string values that match
   * the provided regular expression.
   * This may be slow for large datasets.
   *
   * @param {string} key The key that the string to match is stored in.
   * @param {RegExp | string} regex The regular expression pattern to match.
   * @param {string} modifiers The regular expression mode.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ matches(key, regex, modifiers) {
        this._addCondition(key, "$regex", regex);
        if (!modifiers) modifiers = "";
        if (typeof regex !== "string") {
            if (regex.ignoreCase) modifiers += "i";
            if (regex.multiline) modifiers += "m";
        }
        if (modifiers.length) this._addCondition(key, "$options", modifiers);
        return this;
    }
    /**
   * Adds a constraint that requires that a key's value matches a Parse.Query
   * constraint.
   *
   * @param {string} key The key that the contains the object to match the
   *                     query.
   * @param {Parse.Query} query The query that should match.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ matchesQuery(key, query) {
        const queryJSON = query.toJSON();
        queryJSON.className = query.className;
        return this._addCondition(key, "$inQuery", queryJSON);
    }
    /**
   * Adds a constraint that requires that a key's value not matches a
   * Parse.Query constraint.
   *
   * @param {string} key The key that the contains the object to match the
   *                     query.
   * @param {Parse.Query} query The query that should not match.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ doesNotMatchQuery(key, query) {
        const queryJSON = query.toJSON();
        queryJSON.className = query.className;
        return this._addCondition(key, "$notInQuery", queryJSON);
    }
    /**
   * Adds a constraint that requires that a key's value matches a value in
   * an object returned by a different Parse.Query.
   *
   * @param {string} key The key that contains the value that is being
   *                     matched.
   * @param {string} queryKey The key in the objects returned by the query to
   *                          match against.
   * @param {Parse.Query} query The query to run.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ matchesKeyInQuery(key, queryKey, query) {
        const queryJSON = query.toJSON();
        queryJSON.className = query.className;
        return this._addCondition(key, "$select", {
            key: queryKey,
            query: queryJSON
        });
    }
    /**
   * Adds a constraint that requires that a key's value not match a value in
   * an object returned by a different Parse.Query.
   *
   * @param {string} key The key that contains the value that is being
   *                     excluded.
   * @param {string} queryKey The key in the objects returned by the query to
   *                          match against.
   * @param {Parse.Query} query The query to run.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ doesNotMatchKeyInQuery(key, queryKey, query) {
        const queryJSON = query.toJSON();
        queryJSON.className = query.className;
        return this._addCondition(key, "$dontSelect", {
            key: queryKey,
            query: queryJSON
        });
    }
    /**
   * Adds a constraint for finding string values that contain a provided
   * string.  This may be slow for large datasets.
   *
   * @param {string} key The key that the string to match is stored in.
   * @param {string} substring The substring that the value must contain.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ contains(key, substring) {
        if (typeof substring !== "string") throw new Error("The value being searched for must be a string.");
        return this._addCondition(key, "$regex", $3677afb657bcb4bc$var$quote(substring));
    }
    /**
   * Adds a constraint for finding string values that contain a provided
   * string. This may be slow for large datasets. Requires Parse-Server > 2.5.0
   *
   * In order to sort you must use select and ascending ($score is required)
   *  <pre>
   *   query.fullText('field', 'term');
   *   query.ascending('$score');
   *   query.select('$score');
   *  </pre>
   *
   * To retrieve the weight / rank
   *  <pre>
   *   object->get('score');
   *  </pre>
   *
   * You can define optionals by providing an object as a third parameter
   *  <pre>
   *   query.fullText('field', 'term', { language: 'es', diacriticSensitive: true });
   *  </pre>
   *
   * @param {string} key The key that the string to match is stored in.
   * @param {string} value The string to search
   * @param {object} options (Optional)
   * @param {string} options.language The language that determines the list of stop words for the search and the rules for the stemmer and tokenizer.
   * @param {boolean} options.caseSensitive A boolean flag to enable or disable case sensitive search.
   * @param {boolean} options.diacriticSensitive A boolean flag to enable or disable diacritic sensitive search.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ fullText(key, value) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        options = options || {};
        if (!key) throw new Error("A key is required.");
        if (!value) throw new Error("A search term is required");
        if (typeof value !== "string") throw new Error("The value being searched for must be a string.");
        const fullOptions = {};
        fullOptions.$term = value;
        for(const option in options)switch(option){
            case "language":
                fullOptions.$language = options[option];
                break;
            case "caseSensitive":
                fullOptions.$caseSensitive = options[option];
                break;
            case "diacriticSensitive":
                fullOptions.$diacriticSensitive = options[option];
                break;
            default:
                throw new Error(`Unknown option: ${option}`);
        }
        return this._addCondition(key, "$text", {
            $search: fullOptions
        });
    }
    /**
   * Method to sort the full text search by text score
   *
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ sortByTextScore() {
        this.ascending("$score");
        this.select([
            "$score"
        ]);
        return this;
    }
    /**
   * Adds a constraint for finding string values that start with a provided
   * string.  This query will use the backend index, so it will be fast even
   * for large datasets.
   *
   * @param {string} key The key that the string to match is stored in.
   * @param {string} prefix The substring that the value must start with.
   * @param {string} modifiers The regular expression mode.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ startsWith(key, prefix, modifiers) {
        if (typeof prefix !== "string") throw new Error("The value being searched for must be a string.");
        return this.matches(key, this._regexStartWith(prefix), modifiers);
    }
    /**
   * Adds a constraint for finding string values that end with a provided
   * string.  This will be slow for large datasets.
   *
   * @param {string} key The key that the string to match is stored in.
   * @param {string} suffix The substring that the value must end with.
   * @param {string} modifiers The regular expression mode.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ endsWith(key, suffix, modifiers) {
        if (typeof suffix !== "string") throw new Error("The value being searched for must be a string.");
        return this.matches(key, $3677afb657bcb4bc$var$quote(suffix) + "$", modifiers);
    }
    /**
   * Adds a proximity based constraint for finding objects with key point
   * values near the point given.
   *
   * @param {string} key The key that the Parse.GeoPoint is stored in.
   * @param {Parse.GeoPoint} point The reference Parse.GeoPoint that is used.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ near(key, point) {
        if (!(point instanceof $3677afb657bcb4bc$var$_ParseGeoPoint.default)) // Try to cast it as a GeoPoint
        point = new $3677afb657bcb4bc$var$_ParseGeoPoint.default(point);
        return this._addCondition(key, "$nearSphere", point);
    }
    /**
   * Adds a proximity based constraint for finding objects with key point
   * values near the point given and within the maximum distance given.
   *
   * @param {string} key The key that the Parse.GeoPoint is stored in.
   * @param {Parse.GeoPoint} point The reference Parse.GeoPoint that is used.
   * @param {number} maxDistance Maximum distance (in radians) of results to return.
   * @param {boolean} sorted A Bool value that is true if results should be
   * sorted by distance ascending, false is no sorting is required,
   * defaults to true.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ withinRadians(key, point, maxDistance, sorted) {
        if (sorted || sorted === undefined) {
            this.near(key, point);
            return this._addCondition(key, "$maxDistance", maxDistance);
        } else return this._addCondition(key, "$geoWithin", {
            $centerSphere: [
                [
                    point.longitude,
                    point.latitude
                ],
                maxDistance
            ]
        });
    }
    /**
   * Adds a proximity based constraint for finding objects with key point
   * values near the point given and within the maximum distance given.
   * Radius of earth used is 3958.8 miles.
   *
   * @param {string} key The key that the Parse.GeoPoint is stored in.
   * @param {Parse.GeoPoint} point The reference Parse.GeoPoint that is used.
   * @param {number} maxDistance Maximum distance (in miles) of results to return.
   * @param {boolean} sorted A Bool value that is true if results should be
   * sorted by distance ascending, false is no sorting is required,
   * defaults to true.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ withinMiles(key, point, maxDistance, sorted) {
        return this.withinRadians(key, point, maxDistance / 3958.8, sorted);
    }
    /**
   * Adds a proximity based constraint for finding objects with key point
   * values near the point given and within the maximum distance given.
   * Radius of earth used is 6371.0 kilometers.
   *
   * @param {string} key The key that the Parse.GeoPoint is stored in.
   * @param {Parse.GeoPoint} point The reference Parse.GeoPoint that is used.
   * @param {number} maxDistance Maximum distance (in kilometers) of results to return.
   * @param {boolean} sorted A Bool value that is true if results should be
   * sorted by distance ascending, false is no sorting is required,
   * defaults to true.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ withinKilometers(key, point, maxDistance, sorted) {
        return this.withinRadians(key, point, maxDistance / 6371.0, sorted);
    }
    /**
   * Adds a constraint to the query that requires a particular key's
   * coordinates be contained within a given rectangular geographic bounding
   * box.
   *
   * @param {string} key The key to be constrained.
   * @param {Parse.GeoPoint} southwest
   *     The lower-left inclusive corner of the box.
   * @param {Parse.GeoPoint} northeast
   *     The upper-right inclusive corner of the box.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ withinGeoBox(key, southwest, northeast) {
        if (!(southwest instanceof $3677afb657bcb4bc$var$_ParseGeoPoint.default)) southwest = new $3677afb657bcb4bc$var$_ParseGeoPoint.default(southwest);
        if (!(northeast instanceof $3677afb657bcb4bc$var$_ParseGeoPoint.default)) northeast = new $3677afb657bcb4bc$var$_ParseGeoPoint.default(northeast);
        this._addCondition(key, "$within", {
            $box: [
                southwest,
                northeast
            ]
        });
        return this;
    }
    /**
   * Adds a constraint to the query that requires a particular key's
   * coordinates be contained within and on the bounds of a given polygon.
   * Supports closed and open (last point is connected to first) paths
   *
   * Polygon must have at least 3 points
   *
   * @param {string} key The key to be constrained.
   * @param {Array} points Array of Coordinates / GeoPoints
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ withinPolygon(key, points) {
        return this._addCondition(key, "$geoWithin", {
            $polygon: points
        });
    }
    /**
   * Add a constraint to the query that requires a particular key's
   * coordinates that contains a ParseGeoPoint
   *
   * @param {string} key The key to be constrained.
   * @param {Parse.GeoPoint} point
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ polygonContains(key, point) {
        return this._addCondition(key, "$geoIntersects", {
            $point: point
        });
    }
    /* Query Orderings */ /**
   * Sorts the results in ascending order by the given key.
   *
   * @param {(string|string[])} keys The key to order by, which is a
   * string of comma separated values, or an Array of keys, or multiple keys.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ ascending() {
        this._order = [];
        for(var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++)keys[_key] = arguments[_key];
        return this.addAscending.apply(this, keys);
    }
    /**
   * Sorts the results in ascending order by the given key,
   * but can also add secondary sort descriptors without overwriting _order.
   *
   * @param {(string|string[])} keys The key to order by, which is a
   * string of comma separated values, or an Array of keys, or multiple keys.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ addAscending() {
        if (!this._order) this._order = [];
        for(var _len2 = arguments.length, keys = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)keys[_key2] = arguments[_key2];
        (0, $3677afb657bcb4bc$var$_forEach.default)(keys).call(keys, (key)=>{
            var _context6;
            if ((0, $3677afb657bcb4bc$var$_isArray.default)(key)) key = key.join();
            this._order = (0, $3677afb657bcb4bc$var$_concat.default)(_context6 = this._order).call(_context6, key.replace(/\s/g, "").split(","));
        });
        return this;
    }
    /**
   * Sorts the results in descending order by the given key.
   *
   * @param {(string|string[])} keys The key to order by, which is a
   * string of comma separated values, or an Array of keys, or multiple keys.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ descending() {
        this._order = [];
        for(var _len3 = arguments.length, keys = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)keys[_key3] = arguments[_key3];
        return this.addDescending.apply(this, keys);
    }
    /**
   * Sorts the results in descending order by the given key,
   * but can also add secondary sort descriptors without overwriting _order.
   *
   * @param {(string|string[])} keys The key to order by, which is a
   * string of comma separated values, or an Array of keys, or multiple keys.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ addDescending() {
        if (!this._order) this._order = [];
        for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
        (0, $3677afb657bcb4bc$var$_forEach.default)(keys).call(keys, (key)=>{
            var _context7, _context8;
            if ((0, $3677afb657bcb4bc$var$_isArray.default)(key)) key = key.join();
            this._order = (0, $3677afb657bcb4bc$var$_concat.default)(_context7 = this._order).call(_context7, (0, $3677afb657bcb4bc$var$_map.default)(_context8 = key.replace(/\s/g, "").split(",")).call(_context8, (k)=>{
                return "-" + k;
            }));
        });
        return this;
    }
    /* Query Options */ /**
   * Sets the number of results to skip before returning any results.
   * This is useful for pagination.
   * Default is to skip zero results.
   *
   * @param {number} n the number of results to skip.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ skip(n) {
        if (typeof n !== "number" || n < 0) throw new Error("You can only skip by a positive number");
        this._skip = n;
        return this;
    }
    /**
   * Sets the limit of the number of results to return. The default limit is 100.
   *
   * @param {number} n the number of results to limit to.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ limit(n) {
        if (typeof n !== "number") throw new Error("You can only set the limit to a numeric value");
        this._limit = n;
        return this;
    }
    /**
   * Sets the flag to include with response the total number of objects satisfying this query,
   * despite limits/skip. Might be useful for pagination.
   * Note that result of this query will be wrapped as an object with
   * `results`: holding {ParseObject} array and `count`: integer holding total number
   *
   * @param {boolean} includeCount false - disable, true - enable.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ withCount() {
        let includeCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        if (typeof includeCount !== "boolean") throw new Error("You can only set withCount to a boolean value");
        this._count = includeCount;
        return this;
    }
    /**
   * Includes nested Parse.Objects for the provided key.  You can use dot
   * notation to specify which fields in the included object are also fetched.
   *
   * You can include all nested Parse.Objects by passing in '*'.
   * Requires Parse Server 3.0.0+
   * <pre>query.include('*');</pre>
   *
   * @param {...string|Array<string>} keys The name(s) of the key(s) to include.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ include() {
        for(var _len5 = arguments.length, keys = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)keys[_key5] = arguments[_key5];
        (0, $3677afb657bcb4bc$var$_forEach.default)(keys).call(keys, (key)=>{
            if ((0, $3677afb657bcb4bc$var$_isArray.default)(key)) {
                var _context9;
                this._include = (0, $3677afb657bcb4bc$var$_concat.default)(_context9 = this._include).call(_context9, key);
            } else this._include.push(key);
        });
        return this;
    }
    /**
   * Includes all nested Parse.Objects one level deep.
   *
   * Requires Parse Server 3.0.0+
   *
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ includeAll() {
        return this.include("*");
    }
    /**
   * Restricts the fields of the returned Parse.Objects to include only the
   * provided keys.  If this is called multiple times, then all of the keys
   * specified in each of the calls will be included.
   *
   * @param {...string|Array<string>} keys The name(s) of the key(s) to include.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ select() {
        if (!this._select) this._select = [];
        for(var _len6 = arguments.length, keys = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)keys[_key6] = arguments[_key6];
        (0, $3677afb657bcb4bc$var$_forEach.default)(keys).call(keys, (key)=>{
            if ((0, $3677afb657bcb4bc$var$_isArray.default)(key)) {
                var _context10;
                this._select = (0, $3677afb657bcb4bc$var$_concat.default)(_context10 = this._select).call(_context10, key);
            } else this._select.push(key);
        });
        return this;
    }
    /**
   * Restricts the fields of the returned Parse.Objects to all keys except the
   * provided keys. Exclude takes precedence over select and include.
   *
   * Requires Parse Server 3.6.0+
   *
   * @param {...string|Array<string>} keys The name(s) of the key(s) to exclude.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ exclude() {
        for(var _len7 = arguments.length, keys = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)keys[_key7] = arguments[_key7];
        (0, $3677afb657bcb4bc$var$_forEach.default)(keys).call(keys, (key)=>{
            if ((0, $3677afb657bcb4bc$var$_isArray.default)(key)) {
                var _context11;
                this._exclude = (0, $3677afb657bcb4bc$var$_concat.default)(_context11 = this._exclude).call(_context11, key);
            } else this._exclude.push(key);
        });
        return this;
    }
    /**
   * Restricts live query to trigger only for watched fields.
   *
   * Requires Parse Server 6.0.0+
   *
   * @param {...string|Array<string>} keys The name(s) of the key(s) to watch.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ watch() {
        for(var _len8 = arguments.length, keys = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)keys[_key8] = arguments[_key8];
        (0, $3677afb657bcb4bc$var$_forEach.default)(keys).call(keys, (key)=>{
            if ((0, $3677afb657bcb4bc$var$_isArray.default)(key)) {
                var _context12;
                this._watch = (0, $3677afb657bcb4bc$var$_concat.default)(_context12 = this._watch).call(_context12, key);
            } else this._watch.push(key);
        });
        return this;
    }
    /**
   * Changes the read preference that the backend will use when performing the query to the database.
   *
   * @param {string} readPreference The read preference for the main query.
   * @param {string} includeReadPreference The read preference for the queries to include pointers.
   * @param {string} subqueryReadPreference The read preference for the sub queries.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ readPreference(readPreference, includeReadPreference, subqueryReadPreference) {
        this._readPreference = readPreference;
        this._includeReadPreference = includeReadPreference || null;
        this._subqueryReadPreference = subqueryReadPreference || null;
        return this;
    }
    /**
   * Subscribe this query to get liveQuery updates
   *
   * @param {string} sessionToken (optional) Defaults to the currentUser
   * @returns {Promise<LiveQuerySubscription>} Returns the liveQuerySubscription, it's an event emitter
   * which can be used to get liveQuery updates.
   */ async subscribe(sessionToken) {
        const currentUser = await $3677afb657bcb4bc$var$_CoreManager.default.getUserController().currentUserAsync();
        if (!sessionToken) sessionToken = currentUser ? currentUser.getSessionToken() || undefined : undefined;
        const liveQueryClient = await $3677afb657bcb4bc$var$_CoreManager.default.getLiveQueryController().getDefaultLiveQueryClient();
        if (liveQueryClient.shouldOpen()) liveQueryClient.open();
        const subscription = liveQueryClient.subscribe(this, sessionToken);
        return subscription.subscribePromise.then(()=>{
            return subscription;
        });
    }
    /**
   * Constructs a Parse.Query that is the OR of the passed in queries.  For
   * example:
   * <pre>var compoundQuery = Parse.Query.or(query1, query2, query3);</pre>
   *
   * will create a compoundQuery that is an or of the query1, query2, and
   * query3.
   *
   * @param {...Parse.Query} queries The list of queries to OR.
   * @static
   * @returns {Parse.Query} The query that is the OR of the passed in queries.
   */ static or() {
        for(var _len9 = arguments.length, queries = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++)queries[_key9] = arguments[_key9];
        const className = $3677afb657bcb4bc$var$_getClassNameFromQueries(queries);
        const query = new $3677afb657bcb4bc$var$ParseQuery(className);
        query._orQuery(queries);
        return query;
    }
    /**
   * Constructs a Parse.Query that is the AND of the passed in queries.  For
   * example:
   * <pre>var compoundQuery = Parse.Query.and(query1, query2, query3);</pre>
   *
   * will create a compoundQuery that is an and of the query1, query2, and
   * query3.
   *
   * @param {...Parse.Query} queries The list of queries to AND.
   * @static
   * @returns {Parse.Query} The query that is the AND of the passed in queries.
   */ static and() {
        for(var _len10 = arguments.length, queries = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++)queries[_key10] = arguments[_key10];
        const className = $3677afb657bcb4bc$var$_getClassNameFromQueries(queries);
        const query = new $3677afb657bcb4bc$var$ParseQuery(className);
        query._andQuery(queries);
        return query;
    }
    /**
   * Constructs a Parse.Query that is the NOR of the passed in queries.  For
   * example:
   * <pre>const compoundQuery = Parse.Query.nor(query1, query2, query3);</pre>
   *
   * will create a compoundQuery that is a nor of the query1, query2, and
   * query3.
   *
   * @param {...Parse.Query} queries The list of queries to NOR.
   * @static
   * @returns {Parse.Query} The query that is the NOR of the passed in queries.
   */ static nor() {
        for(var _len11 = arguments.length, queries = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++)queries[_key11] = arguments[_key11];
        const className = $3677afb657bcb4bc$var$_getClassNameFromQueries(queries);
        const query = new $3677afb657bcb4bc$var$ParseQuery(className);
        query._norQuery(queries);
        return query;
    }
    /**
   * Change the source of this query to the server.
   *
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ fromNetwork() {
        this._queriesLocalDatastore = false;
        this._localDatastorePinName = null;
        return this;
    }
    /**
   * Changes the source of this query to all pinned objects.
   *
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ fromLocalDatastore() {
        return this.fromPinWithName(null);
    }
    /**
   * Changes the source of this query to the default group of pinned objects.
   *
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ fromPin() {
        return this.fromPinWithName($klpRA.DEFAULT_PIN);
    }
    /**
   * Changes the source of this query to a specific group of pinned objects.
   *
   * @param {string} name The name of query source.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ fromPinWithName(name) {
        const localDatastore = $3677afb657bcb4bc$var$_CoreManager.default.getLocalDatastore();
        if (localDatastore.checkIfEnabled()) {
            this._queriesLocalDatastore = true;
            this._localDatastorePinName = name;
        }
        return this;
    }
    /**
   * Cancels the current network request (if any is running).
   *
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ cancel() {
        if (this._xhrRequest.task && typeof this._xhrRequest.task.abort === "function") {
            this._xhrRequest.task._aborted = true;
            this._xhrRequest.task.abort();
            this._xhrRequest.task = null;
            this._xhrRequest.onchange = ()=>{};
            return this;
        }
        this._xhrRequest.onchange = ()=>this.cancel();
        return this;
    }
    _setRequestTask(options) {
        options.requestTask = (task)=>{
            this._xhrRequest.task = task;
            this._xhrRequest.onchange();
        };
    }
    /**
   * Sets a comment to the query so that the query
   * can be identified when using a the profiler for MongoDB.
   *
   * @param {string} value a comment can make your profile data easier to interpret and trace.
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ comment(value) {
        if (value == null) {
            delete this._comment;
            return this;
        }
        if (typeof value !== "string") throw new Error("The value of a comment to be sent with this query must be a string.");
        this._comment = value;
        return this;
    }
}
const $3677afb657bcb4bc$var$DefaultController = {
    find (className, params, options) {
        const RESTController = $3677afb657bcb4bc$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "classes/" + className, params, options);
    },
    aggregate (className, params, options) {
        const RESTController = $3677afb657bcb4bc$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "aggregate/" + className, params, options);
    }
};
$3677afb657bcb4bc$var$_CoreManager.default.setParseQuery($3677afb657bcb4bc$var$ParseQuery);
$3677afb657bcb4bc$var$_CoreManager.default.setQueryController($3677afb657bcb4bc$var$DefaultController);
var $3677afb657bcb4bc$var$_default = module.exports.default = $3677afb657bcb4bc$var$ParseQuery;

});
parcelRegister("i3o6i", function(module, exports) {

module.exports = (parcelRequire("84aiV"));

});
parcelRegister("84aiV", function(module, exports) {
"use strict";

var $2qJJl = parcelRequire("2qJJl");
module.exports = $2qJJl;

});
parcelRegister("2qJJl", function(module, exports) {
"use strict";

var $8hsAO = parcelRequire("8hsAO");

var $hqow7 = parcelRequire("hqow7");
var $1c517b94a3f865cc$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.filter;
    return it === $1c517b94a3f865cc$var$ArrayPrototype || $8hsAO($1c517b94a3f865cc$var$ArrayPrototype, it) && own === $1c517b94a3f865cc$var$ArrayPrototype.filter ? $hqow7 : own;
};

});
parcelRegister("hqow7", function(module, exports) {
"use strict";
parcelRequire("jGn0H");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Array", "filter");

});
parcelRegister("jGn0H", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $igsV9 = parcelRequire("igsV9");
var $e543c9ebeb55a59c$require$$filter = $igsV9.filter;

var $PdD5d = parcelRequire("PdD5d");
var $e543c9ebeb55a59c$var$HAS_SPECIES_SUPPORT = $PdD5d("filter");
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$ggcsv({
    target: "Array",
    proto: true,
    forced: !$e543c9ebeb55a59c$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $e543c9ebeb55a59c$require$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

});





parcelRegister("e9nT0", function(module, exports) {

module.exports = (parcelRequire("hFJ9D"));

});
parcelRegister("hFJ9D", function(module, exports) {
"use strict";
parcelRequire("jXhxH");

var $aHxiP = parcelRequire("aHxiP");

var $heVlo = parcelRequire("heVlo");

var $8hsAO = parcelRequire("8hsAO");

var $4dz8S = parcelRequire("4dz8S");
var $cdd94abe6deac196$var$ArrayPrototype = Array.prototype;
var $cdd94abe6deac196$var$DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
module.exports = function(it) {
    var own = it.keys;
    return it === $cdd94abe6deac196$var$ArrayPrototype || $8hsAO($cdd94abe6deac196$var$ArrayPrototype, it) && own === $cdd94abe6deac196$var$ArrayPrototype.keys || $heVlo($cdd94abe6deac196$var$DOMIterables, $aHxiP(it)) ? $4dz8S : own;
};

});
parcelRegister("4dz8S", function(module, exports) {
"use strict";

var $1ZkcD = parcelRequire("1ZkcD");
module.exports = $1ZkcD;

});
parcelRegister("1ZkcD", function(module, exports) {
"use strict";
parcelRequire("5xrGR");
parcelRequire("iYyco");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Array", "keys");

});




parcelRegister("8zvHt", function(module, exports) {

module.exports = (parcelRequire("400TD"));

});
parcelRegister("400TD", function(module, exports) {
"use strict";

var $iQtta = parcelRequire("iQtta");
module.exports = $iQtta;

});
parcelRegister("iQtta", function(module, exports) {
"use strict";

var $8hsAO = parcelRequire("8hsAO");

var $4J1NL = parcelRequire("4J1NL");
var $db83f1561354fe44$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.sort;
    return it === $db83f1561354fe44$var$ArrayPrototype || $8hsAO($db83f1561354fe44$var$ArrayPrototype, it) && own === $db83f1561354fe44$var$ArrayPrototype.sort ? $4J1NL : own;
};

});
parcelRegister("4J1NL", function(module, exports) {
"use strict";
parcelRequire("5MdsH");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Array", "sort");

});
parcelRegister("5MdsH", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $f518o = parcelRequire("f518o");

var $8GsPx = parcelRequire("8GsPx");

var $iJNxK = parcelRequire("iJNxK");

var $6ocdr = parcelRequire("6ocdr");

var $adIjL = parcelRequire("adIjL");

var $l2Ut5 = parcelRequire("l2Ut5");

var $77TPA = parcelRequire("77TPA");

var $fkYhf = parcelRequire("fkYhf");

var $kQPJO = parcelRequire("kQPJO");

var $4vCOA = parcelRequire("4vCOA");

var $biVDg = parcelRequire("biVDg");

var $a9ory = parcelRequire("a9ory");

var $jxNoN = parcelRequire("jxNoN");
var $434be0b4f2b23d14$var$test = [];
var $434be0b4f2b23d14$var$nativeSort = $f518o($434be0b4f2b23d14$var$test.sort);
var $434be0b4f2b23d14$var$push = $f518o($434be0b4f2b23d14$var$test.push);
// IE8-
var $434be0b4f2b23d14$var$FAILS_ON_UNDEFINED = $77TPA(function() {
    $434be0b4f2b23d14$var$test.sort(undefined);
});
// V8 bug
var $434be0b4f2b23d14$var$FAILS_ON_NULL = $77TPA(function() {
    $434be0b4f2b23d14$var$test.sort(null);
});
// Old WebKit
var $434be0b4f2b23d14$var$STRICT_METHOD = $kQPJO("sort");
var $434be0b4f2b23d14$var$STABLE_SORT = !$77TPA(function() {
    // feature detection can be too slow, so check engines versions
    if ($a9ory) return $a9ory < 70;
    if ($4vCOA && $4vCOA > 3) return;
    if ($biVDg) return true;
    if ($jxNoN) return $jxNoN < 603;
    var result = "";
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)$434be0b4f2b23d14$var$test.push({
            k: chr + index,
            v: value
        });
    }
    $434be0b4f2b23d14$var$test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < $434be0b4f2b23d14$var$test.length; index++){
        chr = $434be0b4f2b23d14$var$test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== "DGBEFHACIJK";
});
var $434be0b4f2b23d14$var$FORCED = $434be0b4f2b23d14$var$FAILS_ON_UNDEFINED || !$434be0b4f2b23d14$var$FAILS_ON_NULL || !$434be0b4f2b23d14$var$STRICT_METHOD || !$434be0b4f2b23d14$var$STABLE_SORT;
var $434be0b4f2b23d14$var$getSortCompare = function(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return $l2Ut5(x) > $l2Ut5(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$ggcsv({
    target: "Array",
    proto: true,
    forced: $434be0b4f2b23d14$var$FORCED
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) $8GsPx(comparefn);
        var array = $iJNxK(this);
        if ($434be0b4f2b23d14$var$STABLE_SORT) return comparefn === undefined ? $434be0b4f2b23d14$var$nativeSort(array) : $434be0b4f2b23d14$var$nativeSort(array, comparefn);
        var items = [];
        var arrayLength = $6ocdr(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) $434be0b4f2b23d14$var$push(items, array[index]);
        $fkYhf(items, $434be0b4f2b23d14$var$getSortCompare(comparefn));
        itemsLength = $6ocdr(items);
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)$adIjL(array, index++);
        return array;
    }
});

});
parcelRegister("fkYhf", function(module, exports) {
"use strict";

var $hF40G = parcelRequire("hF40G");
var $b2a77b1793b3a8f1$var$floor = Math.floor;
var $b2a77b1793b3a8f1$var$sort = function(array, comparefn) {
    var length = array.length;
    if (length < 8) {
        // insertion sort
        var i = 1;
        var element, j;
        while(i < length){
            j = i;
            element = array[i];
            while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
            if (j !== i++) array[j] = element;
        }
    } else {
        // merge sort
        var middle = $b2a77b1793b3a8f1$var$floor(length / 2);
        var left = $b2a77b1793b3a8f1$var$sort($hF40G(array, 0, middle), comparefn);
        var right = $b2a77b1793b3a8f1$var$sort($hF40G(array, middle), comparefn);
        var llength = left.length;
        var rlength = right.length;
        var lindex = 0;
        var rindex = 0;
        while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    }
    return array;
};
module.exports = $b2a77b1793b3a8f1$var$sort;

});

parcelRegister("4vCOA", function(module, exports) {
"use strict";

var $jVEg8 = parcelRequire("jVEg8");
var $34882a84f7f9f087$var$firefox = $jVEg8.match(/firefox\/(\d+)/i);
module.exports = !!$34882a84f7f9f087$var$firefox && +$34882a84f7f9f087$var$firefox[1];

});

parcelRegister("biVDg", function(module, exports) {
"use strict";

var $jVEg8 = parcelRequire("jVEg8");
module.exports = /MSIE|Trident/.test($jVEg8);

});

parcelRegister("jxNoN", function(module, exports) {
"use strict";

var $jVEg8 = parcelRequire("jVEg8");
var $e3a76af8f475f579$var$webkit = $jVEg8.match(/AppleWebKit\/(\d+)\./);
module.exports = !!$e3a76af8f475f579$var$webkit && +$e3a76af8f475f579$var$webkit[1];

});






parcelRegister("hOvAP", function(module, exports) {

module.exports = (parcelRequire("guHiv"));

});
parcelRegister("guHiv", function(module, exports) {
"use strict";

var $g8ncX = parcelRequire("g8ncX");
module.exports = $g8ncX;

});
parcelRegister("g8ncX", function(module, exports) {
"use strict";
parcelRequire("52i1a");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Object.entries;

});
parcelRegister("52i1a", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $78Urq = parcelRequire("78Urq");
var $3aab1d9fdd92967c$require$$entries = $78Urq.entries;
// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$ggcsv({
    target: "Object",
    stat: true
}, {
    entries: function entries(O) {
        return $3aab1d9fdd92967c$require$$entries(O);
    }
});

});
parcelRegister("78Urq", function(module, exports) {
"use strict";

var $jeZ4p = parcelRequire("jeZ4p");

var $77TPA = parcelRequire("77TPA");

var $f518o = parcelRequire("f518o");

var $2pQL6 = parcelRequire("2pQL6");

var $3Ut0t = parcelRequire("3Ut0t");

var $bYkAs = parcelRequire("bYkAs");

var $d5uYy = parcelRequire("d5uYy");
var $53350fd4f9c1fc1e$require$$propertyIsEnumerable = $d5uYy.f;
var $53350fd4f9c1fc1e$var$propertyIsEnumerable = $f518o($53350fd4f9c1fc1e$require$$propertyIsEnumerable);
var $53350fd4f9c1fc1e$var$push = $f518o([].push);
// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var $53350fd4f9c1fc1e$var$IE_BUG = $jeZ4p && $77TPA(function() {
    // eslint-disable-next-line es/no-object-create -- safe
    var O = Object.create(null);
    O[2] = 2;
    return !$53350fd4f9c1fc1e$var$propertyIsEnumerable(O, 2);
});
// `Object.{ entries, values }` methods implementation
var $53350fd4f9c1fc1e$var$createMethod = function(TO_ENTRIES) {
    return function(it) {
        var O = $bYkAs(it);
        var keys = $3Ut0t(O);
        var IE_WORKAROUND = $53350fd4f9c1fc1e$var$IE_BUG && $2pQL6(O) === null;
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$jeZ4p || (IE_WORKAROUND ? key in O : $53350fd4f9c1fc1e$var$propertyIsEnumerable(O, key))) $53350fd4f9c1fc1e$var$push(result, TO_ENTRIES ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};
module.exports = {
    // `Object.entries` method
    // https://tc39.es/ecma262/#sec-object.entries
    entries: $53350fd4f9c1fc1e$var$createMethod(true),
    // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values
    values: $53350fd4f9c1fc1e$var$createMethod(false)
};

});





parcelRegister("fKbuz", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b76410fe68354a08$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $b76410fe68354a08$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $b76410fe68354a08$var$_filter = $iHLHC((parcelRequire("i3o6i")));

var $b76410fe68354a08$var$_slice = $iHLHC((parcelRequire("a1TrC")));

var $b76410fe68354a08$var$_isInteger = $iHLHC((parcelRequire("b4POi")));

var $b76410fe68354a08$var$_map = $iHLHC((parcelRequire("2VoQi")));

var $b76410fe68354a08$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $b76410fe68354a08$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $b76410fe68354a08$var$_equals = $iHLHC((parcelRequire("bkMQj")));

var $b76410fe68354a08$var$_decode = $iHLHC((parcelRequire("42E6z")));

var $b76410fe68354a08$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $b76410fe68354a08$var$_ParsePolygon = $iHLHC((parcelRequire("i8AKq")));

var $b76410fe68354a08$var$_ParseGeoPoint = $iHLHC((parcelRequire("jtZTC")));
/**
 * contains -- Determines if an object is contained in a list with special handling for Parse pointers.
 *
 * @param haystack
 * @param needle
 * @private
 * @returns {boolean}
 */ function $b76410fe68354a08$var$contains(haystack, needle) {
    if (needle && needle.__type && (needle.__type === "Pointer" || needle.__type === "Object")) {
        for(const i in haystack){
            const ptr = haystack[i];
            if (typeof ptr === "string" && ptr === needle.objectId) return true;
            if (ptr.className === needle.className && ptr.objectId === needle.objectId) return true;
        }
        return false;
    }
    if ((0, $b76410fe68354a08$var$_isArray.default)(needle)) for (const need of needle){
        if ($b76410fe68354a08$var$contains(haystack, need)) return true;
    }
    return (0, $b76410fe68354a08$var$_indexOf.default)(haystack).call(haystack, needle) > -1;
}
function $b76410fe68354a08$var$transformObject(object) {
    if (object._toFullJSON) return object._toFullJSON();
    return object;
}
/**
 * matchesQuery -- Determines if an object would be returned by a Parse Query
 * It's a lightweight, where-clause only implementation of a full query engine.
 * Since we find queries that match objects, rather than objects that match
 * queries, we can avoid building a full-blown query tool.
 *
 * @param className
 * @param object
 * @param objects
 * @param query
 * @private
 * @returns {boolean}
 */ function $b76410fe68354a08$var$matchesQuery(className, object, objects, query) {
    if (object.className !== className) return false;
    let obj = object;
    let q = query;
    if (object.toJSON) obj = object.toJSON();
    if (query.toJSON) q = query.toJSON().where;
    obj.className = className;
    for(const field in q){
        if (!$b76410fe68354a08$var$matchesKeyConstraints(className, obj, objects, field, q[field])) return false;
    }
    return true;
}
function $b76410fe68354a08$var$equalObjectsGeneric(obj, compareTo, eqlFn) {
    if ((0, $b76410fe68354a08$var$_isArray.default)(obj)) {
        for(let i = 0; i < obj.length; i++){
            if (eqlFn(obj[i], compareTo)) return true;
        }
        return false;
    }
    return eqlFn(obj, compareTo);
}
/**
 * @typedef RelativeTimeToDateResult
 * @property {string} status The conversion status, `error` if conversion failed or
 * `success` if conversion succeeded.
 * @property {string} info The error message if conversion failed, or the relative
 * time indication (`past`, `present`, `future`) if conversion succeeded.
 * @property {Date|undefined} result The converted date, or `undefined` if conversion
 * failed.
 */ /**
 * Converts human readable relative date string, for example, 'in 10 days' to a date
 * relative to now.
 *
 * @param {string} text The text to convert.
 * @param {Date} [now] The date from which add or subtract. Default is now.
 * @returns {RelativeTimeToDateResult}
 */ function $b76410fe68354a08$var$relativeTimeToDate(text) {
    let now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
    text = text.toLowerCase();
    let parts = text.split(" ");
    // Filter out whitespace
    parts = (0, $b76410fe68354a08$var$_filter.default)(parts).call(parts, (part)=>part !== "");
    const future = parts[0] === "in";
    const past = parts[parts.length - 1] === "ago";
    if (!future && !past && text !== "now") return {
        status: "error",
        info: "Time should either start with 'in' or end with 'ago'"
    };
    if (future && past) return {
        status: "error",
        info: "Time cannot have both 'in' and 'ago'"
    };
    // strip the 'ago' or 'in'
    if (future) parts = (0, $b76410fe68354a08$var$_slice.default)(parts).call(parts, 1);
    else // past
    parts = (0, $b76410fe68354a08$var$_slice.default)(parts).call(parts, 0, parts.length - 1);
    if (parts.length % 2 !== 0 && text !== "now") return {
        status: "error",
        info: "Invalid time string. Dangling unit or number."
    };
    const pairs = [];
    while(parts.length)pairs.push([
        parts.shift(),
        parts.shift()
    ]);
    let seconds = 0;
    for (const [num, interval] of pairs){
        const val = Number(num);
        if (!(0, $b76410fe68354a08$var$_isInteger.default)(val)) return {
            status: "error",
            info: `'${num}' is not an integer.`
        };
        switch(interval){
            case "yr":
            case "yrs":
            case "year":
            case "years":
                seconds += val * 31536000; // 365 * 24 * 60 * 60
                break;
            case "wk":
            case "wks":
            case "week":
            case "weeks":
                seconds += val * 604800; // 7 * 24 * 60 * 60
                break;
            case "d":
            case "day":
            case "days":
                seconds += val * 86400; // 24 * 60 * 60
                break;
            case "hr":
            case "hrs":
            case "hour":
            case "hours":
                seconds += val * 3600; // 60 * 60
                break;
            case "min":
            case "mins":
            case "minute":
            case "minutes":
                seconds += val * 60;
                break;
            case "sec":
            case "secs":
            case "second":
            case "seconds":
                seconds += val;
                break;
            default:
                return {
                    status: "error",
                    info: `Invalid interval: '${interval}'`
                };
        }
    }
    const milliseconds = seconds * 1000;
    if (future) return {
        status: "success",
        info: "future",
        result: new Date(now.valueOf() + milliseconds)
    };
    else if (past) return {
        status: "success",
        info: "past",
        result: new Date(now.valueOf() - milliseconds)
    };
    else return {
        status: "success",
        info: "present",
        result: new Date(now.valueOf())
    };
}
/**
 * Determines whether an object matches a single key's constraints
 *
 * @param className
 * @param object
 * @param objects
 * @param key
 * @param constraints
 * @private
 * @returns {boolean}
 */ function $b76410fe68354a08$var$matchesKeyConstraints(className, object, objects, key, constraints) {
    if (constraints === null) return false;
    if ((0, $b76410fe68354a08$var$_indexOf.default)(key).call(key, ".") >= 0) {
        // Key references a subobject
        const keyComponents = key.split(".");
        const subObjectKey = keyComponents[0];
        const keyRemainder = (0, $b76410fe68354a08$var$_slice.default)(keyComponents).call(keyComponents, 1).join(".");
        return $b76410fe68354a08$var$matchesKeyConstraints(className, object[subObjectKey] || {}, objects, keyRemainder, constraints);
    }
    let i;
    if (key === "$or") {
        for(i = 0; i < constraints.length; i++){
            if ($b76410fe68354a08$var$matchesQuery(className, object, objects, constraints[i])) return true;
        }
        return false;
    }
    if (key === "$and") {
        for(i = 0; i < constraints.length; i++){
            if (!$b76410fe68354a08$var$matchesQuery(className, object, objects, constraints[i])) return false;
        }
        return true;
    }
    if (key === "$nor") {
        for(i = 0; i < constraints.length; i++){
            if ($b76410fe68354a08$var$matchesQuery(className, object, objects, constraints[i])) return false;
        }
        return true;
    }
    if (key === "$relatedTo") // Bail! We can't handle relational queries locally
    return false;
    if (!/^[A-Za-z][0-9A-Za-z_]*$/.test(key)) throw new $b76410fe68354a08$var$_ParseError.default($b76410fe68354a08$var$_ParseError.default.INVALID_KEY_NAME, `Invalid Key: ${key}`);
    // Equality (or Array contains) cases
    if (typeof constraints !== "object") {
        if ((0, $b76410fe68354a08$var$_isArray.default)(object[key])) {
            var _context;
            return (0, $b76410fe68354a08$var$_indexOf.default)(_context = object[key]).call(_context, constraints) > -1;
        }
        return object[key] === constraints;
    }
    let compareTo;
    if (constraints.__type) {
        if (constraints.__type === "Pointer") return $b76410fe68354a08$var$equalObjectsGeneric(object[key], constraints, function(obj, ptr) {
            return typeof obj !== "undefined" && ptr.className === obj.className && ptr.objectId === obj.objectId;
        });
        return $b76410fe68354a08$var$equalObjectsGeneric((0, $b76410fe68354a08$var$_decode.default)(object[key]), (0, $b76410fe68354a08$var$_decode.default)(constraints), $b76410fe68354a08$var$_equals.default);
    }
    // More complex cases
    for(const condition in constraints){
        compareTo = constraints[condition];
        if (compareTo?.__type) compareTo = (0, $b76410fe68354a08$var$_decode.default)(compareTo);
        // is it a $relativeTime? convert to date
        if (compareTo?.["$relativeTime"]) {
            const parserResult = $b76410fe68354a08$var$relativeTimeToDate(compareTo["$relativeTime"]);
            if (parserResult.status !== "success") throw new $b76410fe68354a08$var$_ParseError.default($b76410fe68354a08$var$_ParseError.default.INVALID_JSON, `bad $relativeTime (${key}) value. ${parserResult.info}`);
            compareTo = parserResult.result;
        }
        // Compare Date Object or Date String
        if (toString.call(compareTo) === "[object Date]" || typeof compareTo === "string" && // @ts-ignore
        true && // @ts-ignore
        !isNaN(new Date(compareTo))) object[key] = new Date(object[key].iso ? object[key].iso : object[key]);
        switch(condition){
            case "$lt":
                if (object[key] >= compareTo) return false;
                break;
            case "$lte":
                if (object[key] > compareTo) return false;
                break;
            case "$gt":
                if (object[key] <= compareTo) return false;
                break;
            case "$gte":
                if (object[key] < compareTo) return false;
                break;
            case "$ne":
                if ((0, $b76410fe68354a08$var$_equals.default)(object[key], compareTo)) return false;
                break;
            case "$in":
                if (!$b76410fe68354a08$var$contains(compareTo, object[key])) return false;
                break;
            case "$nin":
                if ($b76410fe68354a08$var$contains(compareTo, object[key])) return false;
                break;
            case "$all":
                for(i = 0; i < compareTo.length; i++){
                    var _context2;
                    if ((0, $b76410fe68354a08$var$_indexOf.default)(_context2 = object[key]).call(_context2, compareTo[i]) < 0) return false;
                }
                break;
            case "$exists":
                {
                    const propertyExists = typeof object[key] !== "undefined";
                    const existenceIsRequired = constraints["$exists"];
                    if (typeof constraints["$exists"] !== "boolean") break;
                    if (!propertyExists && existenceIsRequired || propertyExists && !existenceIsRequired) return false;
                    break;
                }
            case "$regex":
                {
                    if (typeof compareTo === "object") return compareTo.test(object[key]);
                    // JS doesn't support perl-style escaping
                    let expString = "";
                    let escapeEnd = -2;
                    let escapeStart = (0, $b76410fe68354a08$var$_indexOf.default)(compareTo).call(compareTo, "\\Q");
                    while(escapeStart > -1){
                        // Add the unescaped portion
                        expString += compareTo.substring(escapeEnd + 2, escapeStart);
                        escapeEnd = (0, $b76410fe68354a08$var$_indexOf.default)(compareTo).call(compareTo, "\\E", escapeStart);
                        if (escapeEnd > -1) expString += compareTo.substring(escapeStart + 2, escapeEnd).replace(/\\\\\\\\E/g, "\\E").replace(/\W/g, "\\$&");
                        escapeStart = (0, $b76410fe68354a08$var$_indexOf.default)(compareTo).call(compareTo, "\\Q", escapeEnd);
                    }
                    expString += compareTo.substring(Math.max(escapeStart, escapeEnd + 2));
                    let modifiers = constraints.$options || "";
                    modifiers = modifiers.replace("x", "").replace("s", "");
                    // Parse Server / Mongo support x and s modifiers but JS RegExp doesn't
                    const exp = new RegExp(expString, modifiers);
                    if (!exp.test(object[key])) return false;
                    break;
                }
            case "$nearSphere":
                {
                    if (!compareTo || !object[key]) return false;
                    const distance = compareTo.radiansTo(object[key]);
                    const max = constraints.$maxDistance || Infinity;
                    return distance <= max;
                }
            case "$within":
                {
                    if (!compareTo || !object[key]) return false;
                    const southWest = compareTo.$box[0];
                    const northEast = compareTo.$box[1];
                    if (southWest.latitude > northEast.latitude || southWest.longitude > northEast.longitude) // Invalid box, crosses the date line
                    return false;
                    return object[key].latitude > southWest.latitude && object[key].latitude < northEast.latitude && object[key].longitude > southWest.longitude && object[key].longitude < northEast.longitude;
                }
            case "$options":
                break;
            case "$maxDistance":
                break;
            case "$select":
                {
                    const subQueryObjects = (0, $b76410fe68354a08$var$_filter.default)(objects).call(objects, (obj, index, arr)=>{
                        return $b76410fe68354a08$var$matchesQuery(compareTo.query.className, obj, arr, compareTo.query.where);
                    });
                    for(let i = 0; i < subQueryObjects.length; i += 1){
                        const subObject = $b76410fe68354a08$var$transformObject(subQueryObjects[i]);
                        return (0, $b76410fe68354a08$var$_equals.default)(object[key], subObject[compareTo.key]);
                    }
                    return false;
                }
            case "$dontSelect":
                {
                    const subQueryObjects = (0, $b76410fe68354a08$var$_filter.default)(objects).call(objects, (obj, index, arr)=>{
                        return $b76410fe68354a08$var$matchesQuery(compareTo.query.className, obj, arr, compareTo.query.where);
                    });
                    for(let i = 0; i < subQueryObjects.length; i += 1){
                        const subObject = $b76410fe68354a08$var$transformObject(subQueryObjects[i]);
                        return !(0, $b76410fe68354a08$var$_equals.default)(object[key], subObject[compareTo.key]);
                    }
                    return false;
                }
            case "$inQuery":
                {
                    const subQueryObjects = (0, $b76410fe68354a08$var$_filter.default)(objects).call(objects, (obj, index, arr)=>{
                        return $b76410fe68354a08$var$matchesQuery(compareTo.className, obj, arr, compareTo.where);
                    });
                    for(let i = 0; i < subQueryObjects.length; i += 1){
                        const subObject = $b76410fe68354a08$var$transformObject(subQueryObjects[i]);
                        if (object[key].className === subObject.className && object[key].objectId === subObject.objectId) return true;
                    }
                    return false;
                }
            case "$notInQuery":
                {
                    const subQueryObjects = (0, $b76410fe68354a08$var$_filter.default)(objects).call(objects, (obj, index, arr)=>{
                        return $b76410fe68354a08$var$matchesQuery(compareTo.className, obj, arr, compareTo.where);
                    });
                    for(let i = 0; i < subQueryObjects.length; i += 1){
                        const subObject = $b76410fe68354a08$var$transformObject(subQueryObjects[i]);
                        if (object[key].className === subObject.className && object[key].objectId === subObject.objectId) return false;
                    }
                    return true;
                }
            case "$containedBy":
                for (const value of object[key]){
                    if (!$b76410fe68354a08$var$contains(compareTo, value)) return false;
                }
                return true;
            case "$geoWithin":
                if (compareTo.$polygon) {
                    var _context3;
                    const points = (0, $b76410fe68354a08$var$_map.default)(_context3 = compareTo.$polygon).call(_context3, (geoPoint)=>[
                            geoPoint.latitude,
                            geoPoint.longitude
                        ]);
                    const polygon = new $b76410fe68354a08$var$_ParsePolygon.default(points);
                    return polygon.containsPoint(object[key]);
                }
                if (compareTo.$centerSphere) {
                    const [WGS84Point, maxDistance] = compareTo.$centerSphere;
                    const centerPoint = new $b76410fe68354a08$var$_ParseGeoPoint.default({
                        latitude: WGS84Point[1],
                        longitude: WGS84Point[0]
                    });
                    const point = new $b76410fe68354a08$var$_ParseGeoPoint.default(object[key]);
                    const distance = point.radiansTo(centerPoint);
                    return distance <= maxDistance;
                }
                return false;
            case "$geoIntersects":
                {
                    const polygon = new $b76410fe68354a08$var$_ParsePolygon.default(object[key].coordinates);
                    const point = new $b76410fe68354a08$var$_ParseGeoPoint.default(compareTo.$point);
                    return polygon.containsPoint(point);
                }
            default:
                return false;
        }
    }
    return true;
}
function $b76410fe68354a08$var$validateQuery(query) {
    var _context4;
    let q = query;
    if (query.toJSON) q = query.toJSON().where;
    const specialQuerykeys = [
        "$and",
        "$or",
        "$nor",
        "_rperm",
        "_wperm",
        "_perishable_token",
        "_email_verify_token",
        "_email_verify_token_expires_at",
        "_account_lockout_expires_at",
        "_failed_login_count"
    ];
    (0, $b76410fe68354a08$var$_forEach.default)(_context4 = (0, $b76410fe68354a08$var$_keys.default)(q)).call(_context4, (key)=>{
        if (q && q[key] && q[key].$regex) {
            if (typeof q[key].$options === "string") {
                if (!q[key].$options.match(/^[imxs]+$/)) throw new $b76410fe68354a08$var$_ParseError.default($b76410fe68354a08$var$_ParseError.default.INVALID_QUERY, `Bad $options value for query: ${q[key].$options}`);
            }
        }
        if ((0, $b76410fe68354a08$var$_indexOf.default)(specialQuerykeys).call(specialQuerykeys, key) < 0 && !key.match(/^[a-zA-Z][a-zA-Z0-9_\.]*$/)) throw new $b76410fe68354a08$var$_ParseError.default($b76410fe68354a08$var$_ParseError.default.INVALID_KEY_NAME, `Invalid key name: ${key}`);
    });
}
const $b76410fe68354a08$var$OfflineQuery = {
    matchesQuery: $b76410fe68354a08$var$matchesQuery,
    validateQuery: $b76410fe68354a08$var$validateQuery
};
module.exports = $b76410fe68354a08$var$OfflineQuery;
var $b76410fe68354a08$var$_default = module.exports.default = $b76410fe68354a08$var$OfflineQuery;

});
parcelRegister("b4POi", function(module, exports) {

module.exports = (parcelRequire("dJlUQ"));

});
parcelRegister("dJlUQ", function(module, exports) {
"use strict";

var $jyHF1 = parcelRequire("jyHF1");
module.exports = $jyHF1;

});
parcelRegister("jyHF1", function(module, exports) {
"use strict";
parcelRequire("40n6Q");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Number.isInteger;

});
parcelRegister("40n6Q", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $90Pfa = parcelRequire("90Pfa");
// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$ggcsv({
    target: "Number",
    stat: true
}, {
    isInteger: $90Pfa
});

});
parcelRegister("90Pfa", function(module, exports) {
"use strict";

var $1WYwK = parcelRequire("1WYwK");
var $68fbdd0a2d491e4f$var$floor = Math.floor;
// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
module.exports = Number.isInteger || function isInteger(it) {
    return !$1WYwK(it) && isFinite(it) && $68fbdd0a2d491e4f$var$floor(it) === it;
};

});





parcelRegister("bkMQj", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8407732367a624c0$var$equals;

var $8407732367a624c0$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $8407732367a624c0$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $8407732367a624c0$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $8407732367a624c0$var$_ParseACL = $iHLHC((parcelRequire("2xGBa")));

var $8407732367a624c0$var$_ParseFile = $iHLHC((parcelRequire("59JWU")));

var $8407732367a624c0$var$_ParseGeoPoint = $iHLHC((parcelRequire("jtZTC")));
function $8407732367a624c0$var$equals(a, b) {
    const toString = Object.prototype.toString;
    if (toString.call(a) === "[object Date]" || toString.call(b) === "[object Date]") {
        const dateA = new Date(a);
        const dateB = new Date(b);
        return +dateA === +dateB;
    }
    if (typeof a !== typeof b) return false;
    if (!a || typeof a !== "object") // a is a primitive
    return a === b;
    if ((0, $8407732367a624c0$var$_isArray.default)(a) || (0, $8407732367a624c0$var$_isArray.default)(b)) {
        if (!(0, $8407732367a624c0$var$_isArray.default)(a) || !(0, $8407732367a624c0$var$_isArray.default)(b)) return false;
        if (a.length !== b.length) return false;
        for(let i = a.length; i--;){
            if (!$8407732367a624c0$var$equals(a[i], b[i])) return false;
        }
        return true;
    }
    const ParseObject = $8407732367a624c0$var$_CoreManager.default.getParseObject();
    if (a instanceof $8407732367a624c0$var$_ParseACL.default || a instanceof $8407732367a624c0$var$_ParseFile.default || a instanceof $8407732367a624c0$var$_ParseGeoPoint.default || a instanceof ParseObject) return a.equals(b);
    if (b instanceof ParseObject) {
        if (a.__type === "Object" || a.__type === "Pointer") return a.objectId === b.id && a.className === b.className;
    }
    if ((0, $8407732367a624c0$var$_keys.default)(a).length !== (0, $8407732367a624c0$var$_keys.default)(b).length) return false;
    for(const k in a){
        if (!$8407732367a624c0$var$equals(a[k], b[k])) return false;
    }
    return true;
}

});



parcelRegister("7GXKV", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $599acee56bb5306d$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $599acee56bb5306d$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));
const $599acee56bb5306d$var$Storage = {
    async () {
        const controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        return !!controller.async;
    },
    getItem (path) {
        const controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) throw new Error("Synchronous storage is not supported by the current storage controller");
        return controller.getItem(path);
    },
    getItemAsync (path) {
        const controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) return controller.getItemAsync(path);
        return $599acee56bb5306d$var$_promise.default.resolve(controller.getItem(path));
    },
    setItem (path, value) {
        const controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) throw new Error("Synchronous storage is not supported by the current storage controller");
        return controller.setItem(path, value);
    },
    setItemAsync (path, value) {
        const controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) return controller.setItemAsync(path, value);
        return $599acee56bb5306d$var$_promise.default.resolve(controller.setItem(path, value));
    },
    removeItem (path) {
        const controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) throw new Error("Synchronous storage is not supported by the current storage controller");
        return controller.removeItem(path);
    },
    removeItemAsync (path) {
        const controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) return controller.removeItemAsync(path);
        return $599acee56bb5306d$var$_promise.default.resolve(controller.removeItem(path));
    },
    getAllKeys () {
        const controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) throw new Error("Synchronous storage is not supported by the current storage controller");
        return controller.getAllKeys();
    },
    getAllKeysAsync () {
        const controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) return controller.getAllKeysAsync();
        return $599acee56bb5306d$var$_promise.default.resolve(controller.getAllKeys());
    },
    generatePath (path) {
        if (!$599acee56bb5306d$var$_CoreManager.default.get("APPLICATION_ID")) throw new Error("You need to call Parse.initialize before using Parse.");
        if (typeof path !== "string") throw new Error("Tried to get a Storage path that was not a String.");
        if (path[0] === "/") path = path.substr(1);
        return "Parse/" + $599acee56bb5306d$var$_CoreManager.default.get("APPLICATION_ID") + "/" + path;
    },
    _clear () {
        const controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.hasOwnProperty("clear")) controller.clear();
    }
};
module.exports = $599acee56bb5306d$var$Storage;
var $599acee56bb5306d$var$_default = module.exports.default = $599acee56bb5306d$var$Storage;

});


parcelRegister("b4vvz", function(module, exports) {
"use strict";

var $e9nT0 = parcelRequire("e9nT0");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $iU2mB = parcelRequire("iU2mB");
/* global window */ let $80f8824c7b0efbe1$var$IndexedDBStorageController;
if (typeof window !== "undefined" && window.indexedDB) try {
    const ParseStore = (0, $iU2mB.createStore)("parseDB", "parseStore");
    $80f8824c7b0efbe1$var$IndexedDBStorageController = {
        async: 1,
        getItemAsync (path) {
            return (0, $iU2mB.get)(path, ParseStore);
        },
        setItemAsync (path, value) {
            return (0, $iU2mB.set)(path, value, ParseStore);
        },
        removeItemAsync (path) {
            return (0, $iU2mB.del)(path, ParseStore);
        },
        getAllKeysAsync () {
            return $e9nT0($iU2mB)(ParseStore);
        },
        clear () {
            return (0, $iU2mB.clear)(ParseStore);
        }
    };
} catch (_) {
    // IndexedDB not accessible
    $80f8824c7b0efbe1$var$IndexedDBStorageController = undefined;
}
else // IndexedDB not supported
$80f8824c7b0efbe1$var$IndexedDBStorageController = undefined;
module.exports = $80f8824c7b0efbe1$var$IndexedDBStorageController;
var $80f8824c7b0efbe1$var$_default = module.exports.default = $80f8824c7b0efbe1$var$IndexedDBStorageController;

});
parcelRegister("iU2mB", function(module, exports) {

$parcel$export(module.exports, "promisifyRequest", function () { return $dc2f4a51b83babfd$export$b327150396135fe7; });
$parcel$export(module.exports, "createStore", function () { return $dc2f4a51b83babfd$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "get", function () { return $dc2f4a51b83babfd$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "set", function () { return $dc2f4a51b83babfd$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "setMany", function () { return $dc2f4a51b83babfd$export$daa0a5170277c7a8; });
$parcel$export(module.exports, "getMany", function () { return $dc2f4a51b83babfd$export$5df405cccea42673; });
$parcel$export(module.exports, "update", function () { return $dc2f4a51b83babfd$export$722fbec263ad908a; });
$parcel$export(module.exports, "del", function () { return $dc2f4a51b83babfd$export$1d2f21e549771e67; });
$parcel$export(module.exports, "delMany", function () { return $dc2f4a51b83babfd$export$c8aa84257229cac8; });
$parcel$export(module.exports, "clear", function () { return $dc2f4a51b83babfd$export$42ffd38884aecdac; });
$parcel$export(module.exports, "keys", function () { return $dc2f4a51b83babfd$export$ed97f33186d4b816; });
$parcel$export(module.exports, "values", function () { return $dc2f4a51b83babfd$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "entries", function () { return $dc2f4a51b83babfd$export$3e9f948b41964866; });
function $dc2f4a51b83babfd$var$_slicedToArray(arr, i) {
    return $dc2f4a51b83babfd$var$_arrayWithHoles(arr) || $dc2f4a51b83babfd$var$_iterableToArrayLimit(arr, i) || $dc2f4a51b83babfd$var$_unsupportedIterableToArray(arr, i) || $dc2f4a51b83babfd$var$_nonIterableRest();
}
function $dc2f4a51b83babfd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dc2f4a51b83babfd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dc2f4a51b83babfd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dc2f4a51b83babfd$var$_arrayLikeToArray(o, minLen);
}
function $dc2f4a51b83babfd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dc2f4a51b83babfd$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $dc2f4a51b83babfd$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $dc2f4a51b83babfd$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        }; // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $dc2f4a51b83babfd$export$f51a9068ac82ea43(dbName, storeName) {
    var request = indexedDB.open(dbName);
    request.onupgradeneeded = function() {
        return request.result.createObjectStore(storeName);
    };
    var dbp = $dc2f4a51b83babfd$export$b327150396135fe7(request);
    return function(txMode, callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $dc2f4a51b83babfd$var$defaultGetStoreFunc;
function $dc2f4a51b83babfd$var$defaultGetStore() {
    if (!$dc2f4a51b83babfd$var$defaultGetStoreFunc) $dc2f4a51b83babfd$var$defaultGetStoreFunc = $dc2f4a51b83babfd$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $dc2f4a51b83babfd$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.put(value, key);
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return Promise.all(keys.map(function(key) {
            return $dc2f4a51b83babfd$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        return(// If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($dc2f4a51b83babfd$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.delete(key);
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.clear();
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
function $dc2f4a51b83babfd$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $dc2f4a51b83babfd$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $dc2f4a51b83babfd$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $dc2f4a51b83babfd$export$b327150396135fe7(store.getAll());
        var items = [];
        return $dc2f4a51b83babfd$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $dc2f4a51b83babfd$export$b327150396135fe7(store.getAllKeys()),
            $dc2f4a51b83babfd$export$b327150396135fe7(store.getAll())
        ]).then(function(_ref) {
            var _ref2 = $dc2f4a51b83babfd$var$_slicedToArray(_ref, 2), keys = _ref2[0], values = _ref2[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore("readonly", function(store) {
            return $dc2f4a51b83babfd$var$eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}

});


parcelRegister("i5Nxa", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2bf1e0b8e81e213$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $d2bf1e0b8e81e213$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $d2bf1e0b8e81e213$var$_Storage = $iHLHC((parcelRequire("7GXKV")));

var $d2bf1e0b8e81e213$var$_ParseInstallation = $iHLHC((parcelRequire("7nsYD")));

var $d2bf1e0b8e81e213$var$_uuid = $iHLHC((parcelRequire("4q6en")));
const $d2bf1e0b8e81e213$var$CURRENT_INSTALLATION_KEY = "currentInstallation";
const $d2bf1e0b8e81e213$var$CURRENT_INSTALLATION_ID_KEY = "currentInstallationId";
let $d2bf1e0b8e81e213$var$iidCache = null;
let $d2bf1e0b8e81e213$var$currentInstallationCache = null;
let $d2bf1e0b8e81e213$var$currentInstallationCacheMatchesDisk = false;
const $d2bf1e0b8e81e213$var$InstallationController = {
    async updateInstallationOnDisk (installation) {
        const path = $d2bf1e0b8e81e213$var$_Storage.default.generatePath($d2bf1e0b8e81e213$var$CURRENT_INSTALLATION_KEY);
        await $d2bf1e0b8e81e213$var$_Storage.default.setItemAsync(path, (0, $d2bf1e0b8e81e213$var$_stringify.default)(installation.toJSON()));
        this._setCurrentInstallationCache(installation);
    },
    async currentInstallationId () {
        if (typeof $d2bf1e0b8e81e213$var$iidCache === "string") return $d2bf1e0b8e81e213$var$iidCache;
        const path = $d2bf1e0b8e81e213$var$_Storage.default.generatePath($d2bf1e0b8e81e213$var$CURRENT_INSTALLATION_ID_KEY);
        let iid = await $d2bf1e0b8e81e213$var$_Storage.default.getItemAsync(path);
        if (!iid) {
            iid = (0, $d2bf1e0b8e81e213$var$_uuid.default)();
            return $d2bf1e0b8e81e213$var$_Storage.default.setItemAsync(path, iid).then(()=>{
                $d2bf1e0b8e81e213$var$iidCache = iid;
                return iid;
            });
        }
        $d2bf1e0b8e81e213$var$iidCache = iid;
        return iid;
    },
    async currentInstallation () {
        if ($d2bf1e0b8e81e213$var$currentInstallationCache) return $d2bf1e0b8e81e213$var$currentInstallationCache;
        if ($d2bf1e0b8e81e213$var$currentInstallationCacheMatchesDisk) return null;
        const path = $d2bf1e0b8e81e213$var$_Storage.default.generatePath($d2bf1e0b8e81e213$var$CURRENT_INSTALLATION_KEY);
        let installationData = await $d2bf1e0b8e81e213$var$_Storage.default.getItemAsync(path);
        $d2bf1e0b8e81e213$var$currentInstallationCacheMatchesDisk = true;
        if (installationData) {
            installationData = JSON.parse(installationData);
            installationData.className = "_Installation";
            const current = $d2bf1e0b8e81e213$var$_ParseInstallation.default.fromJSON(installationData);
            $d2bf1e0b8e81e213$var$currentInstallationCache = current;
            return current;
        }
        const installationId = await this.currentInstallationId();
        const installation = new $d2bf1e0b8e81e213$var$_ParseInstallation.default();
        installation.set("deviceType", $d2bf1e0b8e81e213$var$_ParseInstallation.default.DEVICE_TYPES.WEB);
        installation.set("installationId", installationId);
        installation.set("parseVersion", $d2bf1e0b8e81e213$var$_CoreManager.default.get("VERSION"));
        $d2bf1e0b8e81e213$var$currentInstallationCache = installation;
        await $d2bf1e0b8e81e213$var$_Storage.default.setItemAsync(path, (0, $d2bf1e0b8e81e213$var$_stringify.default)(installation.toJSON()));
        return installation;
    },
    _clearCache () {
        $d2bf1e0b8e81e213$var$iidCache = null;
        $d2bf1e0b8e81e213$var$currentInstallationCache = null;
        $d2bf1e0b8e81e213$var$currentInstallationCacheMatchesDisk = false;
    },
    _setInstallationIdCache (iid) {
        $d2bf1e0b8e81e213$var$iidCache = iid;
    },
    _setCurrentInstallationCache (installation) {
        let matchesDisk = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        $d2bf1e0b8e81e213$var$currentInstallationCache = installation;
        $d2bf1e0b8e81e213$var$currentInstallationCacheMatchesDisk = matchesDisk;
    }
};
module.exports = $d2bf1e0b8e81e213$var$InstallationController;
var $d2bf1e0b8e81e213$var$_default = module.exports.default = $d2bf1e0b8e81e213$var$InstallationController;

});
parcelRegister("7nsYD", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $55f12897a4ddbde5$var$_entries = $iHLHC((parcelRequire("hOvAP")));

var $55f12897a4ddbde5$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $55f12897a4ddbde5$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $55f12897a4ddbde5$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));
const $55f12897a4ddbde5$var$DEVICE_TYPES = {
    IOS: "ios",
    MACOS: "macos",
    TVOS: "tvos",
    FCM: "fcm",
    ANDROID: "android",
    WEB: "web"
};
/**
 * Parse.Installation is a local representation of installation data that can be saved and retrieved from the Parse cloud.
 * This class is a subclass of a Parse.Object, and retains the same functionality of a Parse.Object, but also extends it with installation-specific features.
 *
 * <p>A valid Parse.Installation can only be instantiated via <code>Parse.Installation.currentInstallation()</code>
 *
 * Parse.Installation objects which have a valid <code>deviceToken</code> and are saved to the Parse cloud can be used to target push notifications.
 * </p>
 *
 * @alias Parse.Installation
 */ class $55f12897a4ddbde5$var$ParseInstallation extends $55f12897a4ddbde5$var$_ParseObject.default {
    /**
   * @param {object} attributes The initial set of data to store in the object.
   */ constructor(attributes){
        super("_Installation");
        if (attributes && typeof attributes === "object") {
            if (!this.set(attributes)) throw new Error("Can't create an invalid Installation");
        }
    }
    /**
   * A unique identifier for this installation’s client application. In iOS, this is the Bundle Identifier.
   *
   * @property {string} appIdentifier
   * @static
   * @returns {string}
   */ get appIdentifier() {
        return this.get("appIdentifier");
    }
    /**
   * The version string of the client application to which this installation belongs.
   *
   * @property {string} appVersion
   * @static
   * @returns {string}
   */ get appVersion() {
        return this.get("appVersion");
    }
    /**
   * The display name of the client application to which this installation belongs.
   *
   * @property {string} appName
   * @static
   * @returns {string}
   */ get appName() {
        return this.get("appName");
    }
    /**
   * The current value of the icon badge for iOS apps.
   * Changes to this value on the server will be used
   * for future badge-increment push notifications.
   *
   * @property {number} badge
   * @static
   * @returns {number}
   */ get badge() {
        return this.get("badge");
    }
    /**
   * An array of the channels to which a device is currently subscribed.
   *
   * @property {string[]} channels
   * @static
   * @returns {string[]}
   */ get channels() {
        return this.get("channels");
    }
    /**
   * Token used to deliver push notifications to the device.
   *
   * @property {string} deviceToken
   * @static
   * @returns {string}
   */ get deviceToken() {
        return this.get("deviceToken");
    }
    /**
   * The type of device, “ios”, “android”, “web”, etc.
   *
   * @property {string} deviceType
   * @static
   * @returns {string}
   */ get deviceType() {
        return this.get("deviceType");
    }
    /**
   * Gets the GCM sender identifier for this installation
   *
   * @property {string} GCMSenderId
   * @static
   * @returns {string}
   */ get GCMSenderId() {
        return this.get("GCMSenderId");
    }
    /**
   * Universally Unique Identifier (UUID) for the device used by Parse. It must be unique across all of an app’s installations.
   *
   * @property {string} installationId
   * @static
   * @returns {string}
   */ get installationId() {
        return this.get("installationId");
    }
    /**
   * Gets the local identifier for this installation
   *
   * @property {string} localeIdentifier
   * @static
   * @returns {string}
   */ get localeIdentifier() {
        return this.get("localeIdentifier");
    }
    /**
   * Gets the parse server version for this installation
   *
   * @property {string} parseVersion
   * @static
   * @returns {string}
   */ get parseVersion() {
        return this.get("parseVersion");
    }
    /**
   * This field is reserved for directing Parse to the push delivery network to be used.
   *
   * @property {string} pushType
   * @static
   * @returns {string}
   */ get pushType() {
        return this.get("pushType");
    }
    /**
   * Gets the time zone for this installation
   *
   * @property {string} timeZone
   * @static
   * @returns {string}
   */ get timeZone() {
        return this.get("timeZone");
    }
    /**
   * Returns the device types for used for Push Notifications.
   *
   * <pre>
   * Parse.Installation.DEVICE_TYPES.IOS
   * Parse.Installation.DEVICE_TYPES.MACOS
   * Parse.Installation.DEVICE_TYPES.TVOS
   * Parse.Installation.DEVICE_TYPES.FCM
   * Parse.Installation.DEVICE_TYPES.ANDROID
   * Parse.Installation.DEVICE_TYPES.WEB
   * </pre
   *
   * @property {object} DEVICE_TYPES
   * @static
   * @returns {object}
   */ static get DEVICE_TYPES() {
        return $55f12897a4ddbde5$var$DEVICE_TYPES;
    }
    /**
   * Wrap the default fetch behavior with functionality to update local storage.
   * If the installation is deleted on the server, retry the fetch as a save operation.
   *
   * @param {...any} args
   * @returns {Promise}
   */ async fetch() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        try {
            await super.fetch.apply(this, args);
        } catch (e) {
            if (e.code !== $55f12897a4ddbde5$var$_ParseError.default.OBJECT_NOT_FOUND) throw e;
            // The installation was deleted from the server.
            // We always want fetch to succeed.
            delete this.id;
            this._getId(); // Generate localId
            this._markAllFieldsDirty();
            await super.save.apply(this, args);
        }
        await $55f12897a4ddbde5$var$_CoreManager.default.getInstallationController().updateInstallationOnDisk(this);
        return this;
    }
    /**
   * Wrap the default save behavior with functionality to update the local storage.
   * If the installation is deleted on the server, retry saving a new installation.
   *
   * @param {...any} args
   * @returns {Promise}
   */ async save() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        try {
            await super.save.apply(this, args);
        } catch (e) {
            if (e.code !== $55f12897a4ddbde5$var$_ParseError.default.OBJECT_NOT_FOUND) throw e;
            // The installation was deleted from the server.
            // We always want save to succeed.
            delete this.id;
            this._getId(); // Generate localId
            this._markAllFieldsDirty();
            await super.save.apply(this, args);
        }
        await $55f12897a4ddbde5$var$_CoreManager.default.getInstallationController().updateInstallationOnDisk(this);
        return this;
    }
    _markAllFieldsDirty() {
        for (const [key, value] of (0, $55f12897a4ddbde5$var$_entries.default)(this.attributes))this.set(key, value);
    }
    /**
   * Get the current Parse.Installation from disk. If doesn't exists, create an new installation.
   *
   * <pre>
   * const installation = await Parse.Installation.currentInstallation();
   * installation.set('deviceToken', '123');
   * await installation.save();
   * </pre>
   *
   * @returns {Promise} A promise that resolves to the local installation object.
   */ static currentInstallation() {
        return $55f12897a4ddbde5$var$_CoreManager.default.getInstallationController().currentInstallation();
    }
}
$55f12897a4ddbde5$var$_ParseObject.default.registerSubclass("_Installation", $55f12897a4ddbde5$var$ParseInstallation);
module.exports = $55f12897a4ddbde5$var$ParseInstallation;
var $55f12897a4ddbde5$var$_default = module.exports.default = $55f12897a4ddbde5$var$ParseInstallation;

});


parcelRegister("dcLeF", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99d109557c64e215$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $99d109557c64e215$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $99d109557c64e215$var$_includes = $iHLHC((parcelRequire("dNrmj")));

var $99d109557c64e215$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $99d109557c64e215$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $99d109557c64e215$var$_setTimeout2 = $iHLHC((parcelRequire("3Poce")));

var $99d109557c64e215$var$_uuid = $iHLHC((parcelRequire("4q6en")));

var $99d109557c64e215$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $99d109557c64e215$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $9FsFR = parcelRequire("9FsFR");

var $99d109557c64e215$var$_Xhr = $iHLHC((parcelRequire("fbHpb")));
/* global XMLHttpRequest, XDomainRequest */ let $99d109557c64e215$var$XHR = null;
if (typeof XMLHttpRequest !== "undefined") $99d109557c64e215$var$XHR = XMLHttpRequest;
let $99d109557c64e215$var$useXDomainRequest = false;
// @ts-ignore
if (typeof XDomainRequest !== "undefined" && !("withCredentials" in new XMLHttpRequest())) $99d109557c64e215$var$useXDomainRequest = true;
function $99d109557c64e215$var$ajaxIE9(method, url, data, headers, options) {
    return new $99d109557c64e215$var$_promise.default((resolve, reject)=>{
        // @ts-ignore
        const xdr = new XDomainRequest();
        xdr.onload = function() {
            let response;
            try {
                response = JSON.parse(xdr.responseText);
            } catch (e) {
                reject(e);
            }
            if (response) resolve({
                response: response
            });
        };
        xdr.onerror = xdr.ontimeout = function() {
            // Let's fake a real error message.
            const fakeResponse = {
                responseText: (0, $99d109557c64e215$var$_stringify.default)({
                    code: $99d109557c64e215$var$_ParseError.default.X_DOMAIN_REQUEST,
                    error: "IE's XDomainRequest does not supply error info."
                })
            };
            reject(fakeResponse);
        };
        xdr.onprogress = function() {
            if (options && typeof options.progress === "function") options.progress(xdr.responseText);
        };
        xdr.open(method, url);
        xdr.send(data);
        // @ts-ignore
        if (options && typeof options.requestTask === "function") // @ts-ignore
        options.requestTask(xdr);
    });
}
const $99d109557c64e215$var$RESTController = {
    ajax (method, url, data, headers, options) {
        var _context;
        if ($99d109557c64e215$var$useXDomainRequest) return $99d109557c64e215$var$ajaxIE9(method, url, data, headers, options);
        const promise = (0, $9FsFR.resolvingPromise)();
        const isIdempotent = $99d109557c64e215$var$_CoreManager.default.get("IDEMPOTENCY") && (0, $99d109557c64e215$var$_includes.default)(_context = [
            "POST",
            "PUT"
        ]).call(_context, method);
        const requestId = isIdempotent ? (0, $99d109557c64e215$var$_uuid.default)() : "";
        let attempts = 0;
        const dispatch = function() {
            if ($99d109557c64e215$var$XHR == null) throw new Error("Cannot make a request: No definition of XMLHttpRequest was found.");
            let handled = false;
            const xhr = new $99d109557c64e215$var$XHR();
            xhr.onreadystatechange = function() {
                if (xhr.readyState !== 4 || handled || xhr._aborted) return;
                handled = true;
                if (xhr.status >= 200 && xhr.status < 300) {
                    let response;
                    try {
                        response = JSON.parse(xhr.responseText);
                        const availableHeaders = typeof xhr.getAllResponseHeaders === "function" ? xhr.getAllResponseHeaders() : "";
                        headers = {};
                        if (typeof xhr.getResponseHeader === "function" && availableHeaders?.indexOf("access-control-expose-headers") >= 0) {
                            const responseHeaders = xhr.getResponseHeader("access-control-expose-headers").split(", ");
                            (0, $99d109557c64e215$var$_forEach.default)(responseHeaders).call(responseHeaders, (header)=>{
                                if ((0, $99d109557c64e215$var$_indexOf.default)(availableHeaders).call(availableHeaders, header.toLowerCase()) >= 0) headers[header] = xhr.getResponseHeader(header.toLowerCase());
                            });
                        }
                    } catch (e) {
                        promise.reject(e.toString());
                    }
                    if (response) promise.resolve({
                        response: response,
                        headers: headers,
                        status: xhr.status,
                        xhr: xhr
                    });
                } else if (xhr.status >= 500 || xhr.status === 0) {
                    // retry on 5XX or node-xmlhttprequest error
                    if (++attempts < $99d109557c64e215$var$_CoreManager.default.get("REQUEST_ATTEMPT_LIMIT")) {
                        // Exponentially-growing random delay
                        const delay = Math.round(Math.random() * 125 * Math.pow(2, attempts));
                        (0, $99d109557c64e215$var$_setTimeout2.default)(dispatch, delay);
                    } else if (xhr.status === 0) promise.reject("Unable to connect to the Parse API");
                    else // After the retry limit is reached, fail
                    promise.reject(xhr);
                } else promise.reject(xhr);
            };
            headers = headers || {};
            if (typeof headers["Content-Type"] !== "string") headers["Content-Type"] = "text/plain"; // Avoid pre-flight
            if ($99d109557c64e215$var$_CoreManager.default.get("IS_NODE")) headers["User-Agent"] = "Parse/" + $99d109557c64e215$var$_CoreManager.default.get("VERSION") + " (NodeJS " + $4TNnu.versions.node + ")";
            if (isIdempotent) headers["X-Parse-Request-Id"] = requestId;
            if ($99d109557c64e215$var$_CoreManager.default.get("SERVER_AUTH_TYPE") && $99d109557c64e215$var$_CoreManager.default.get("SERVER_AUTH_TOKEN")) headers["Authorization"] = $99d109557c64e215$var$_CoreManager.default.get("SERVER_AUTH_TYPE") + " " + $99d109557c64e215$var$_CoreManager.default.get("SERVER_AUTH_TOKEN");
            const customHeaders = $99d109557c64e215$var$_CoreManager.default.get("REQUEST_HEADERS");
            for(const key in customHeaders)headers[key] = customHeaders[key];
            if (options && typeof options.progress === "function") {
                const handleProgress = function(type, event) {
                    if (event.lengthComputable) options.progress(event.loaded / event.total, event.loaded, event.total, {
                        type: type
                    });
                    else options.progress(null, null, null, {
                        type: type
                    });
                };
                xhr.onprogress = (event)=>{
                    handleProgress("download", event);
                };
                if (xhr.upload) xhr.upload.onprogress = (event)=>{
                    handleProgress("upload", event);
                };
            }
            xhr.open(method, url, true);
            for(const h in headers)xhr.setRequestHeader(h, headers[h]);
            xhr.onabort = function() {
                promise.resolve({
                    response: {
                        results: []
                    },
                    status: 0,
                    xhr: xhr
                });
            };
            xhr.send(data);
            // @ts-ignore
            if (options && typeof options.requestTask === "function") // @ts-ignore
            options.requestTask(xhr);
        };
        dispatch();
        return promise;
    },
    request (method, path, data, options) {
        options = options || {};
        let url = $99d109557c64e215$var$_CoreManager.default.get("SERVER_URL");
        if (url[url.length - 1] !== "/") url += "/";
        url += path;
        const payload = {};
        if (data && typeof data === "object") for(const k in data)payload[k] = data[k];
        // Add context
        const context = options.context;
        if (context !== undefined) payload._context = context;
        if (method !== "POST") {
            payload._method = method;
            method = "POST";
        }
        payload._ApplicationId = $99d109557c64e215$var$_CoreManager.default.get("APPLICATION_ID");
        const jsKey = $99d109557c64e215$var$_CoreManager.default.get("JAVASCRIPT_KEY");
        if (jsKey) payload._JavaScriptKey = jsKey;
        payload._ClientVersion = $99d109557c64e215$var$_CoreManager.default.get("VERSION");
        let useMasterKey = options.useMasterKey;
        if (typeof useMasterKey === "undefined") useMasterKey = $99d109557c64e215$var$_CoreManager.default.get("USE_MASTER_KEY");
        if (useMasterKey) {
            if ($99d109557c64e215$var$_CoreManager.default.get("MASTER_KEY")) {
                delete payload._JavaScriptKey;
                payload._MasterKey = $99d109557c64e215$var$_CoreManager.default.get("MASTER_KEY");
            } else throw new Error("Cannot use the Master Key, it has not been provided.");
        }
        if ($99d109557c64e215$var$_CoreManager.default.get("FORCE_REVOCABLE_SESSION")) payload._RevocableSession = "1";
        const installationId = options.installationId;
        let installationIdPromise;
        if (installationId && typeof installationId === "string") installationIdPromise = $99d109557c64e215$var$_promise.default.resolve(installationId);
        else {
            const installationController = $99d109557c64e215$var$_CoreManager.default.getInstallationController();
            installationIdPromise = installationController.currentInstallationId();
        }
        return installationIdPromise.then((iid)=>{
            payload._InstallationId = iid;
            const userController = $99d109557c64e215$var$_CoreManager.default.getUserController();
            if (options && typeof options.sessionToken === "string") return $99d109557c64e215$var$_promise.default.resolve(options.sessionToken);
            else if (userController) return userController.currentUserAsync().then((user)=>{
                if (user) return $99d109557c64e215$var$_promise.default.resolve(user.getSessionToken());
                return $99d109557c64e215$var$_promise.default.resolve(null);
            });
            return $99d109557c64e215$var$_promise.default.resolve(null);
        }).then((token)=>{
            if (token) payload._SessionToken = token;
            const payloadString = (0, $99d109557c64e215$var$_stringify.default)(payload);
            return $99d109557c64e215$var$RESTController.ajax(method, url, payloadString, {}, options).then((_ref)=>{
                let { response: response, status: status, headers: headers, xhr: xhr } = _ref;
                if (options.returnStatus) return {
                    ...response,
                    _status: status,
                    _headers: headers,
                    _xhr: xhr
                };
                else return response;
            });
        }).catch($99d109557c64e215$var$RESTController.handleError);
    },
    handleError (response) {
        // Transform the error into an instance of ParseError by trying to parse
        // the error string as JSON
        let error;
        if (response && response.responseText) try {
            const errorJSON = JSON.parse(response.responseText);
            error = new $99d109557c64e215$var$_ParseError.default(errorJSON.code, errorJSON.error);
        } catch (e) {
            // If we fail to parse the error text, that's okay.
            error = new $99d109557c64e215$var$_ParseError.default($99d109557c64e215$var$_ParseError.default.INVALID_JSON, "Received an error with invalid JSON from Parse: " + response.responseText);
        }
        else {
            const message = response.message ? response.message : response;
            error = new $99d109557c64e215$var$_ParseError.default($99d109557c64e215$var$_ParseError.default.CONNECTION_FAILED, "XMLHttpRequest failed: " + (0, $99d109557c64e215$var$_stringify.default)(message));
        }
        return $99d109557c64e215$var$_promise.default.reject(error);
    },
    _setXHR (xhr) {
        $99d109557c64e215$var$XHR = xhr;
    },
    _getXHR () {
        return $99d109557c64e215$var$XHR;
    }
};
module.exports = $99d109557c64e215$var$RESTController;
var $99d109557c64e215$var$_default = module.exports.default = $99d109557c64e215$var$RESTController;

});
parcelRegister("3Poce", function(module, exports) {

module.exports = (parcelRequire("4SOhh"));

});
parcelRegister("4SOhh", function(module, exports) {
"use strict";
parcelRequire("dGoN0");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.setTimeout;

});



parcelRegister("54Znm", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.track = $3b2cef6ef61accae$var$track;

var $3b2cef6ef61accae$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));
/**
 * Parse.Analytics provides an interface to Parse's logging and analytics
 * backend.
 *
 * @class Parse.Analytics
 * @static
 * @hideconstructor
 */ /**
 * Tracks the occurrence of a custom event with additional dimensions.
 * Parse will store a data point at the time of invocation with the given
 * event name.
 *
 * Dimensions will allow segmentation of the occurrences of this custom
 * event. Keys and values should be {@code String}s, and will throw
 * otherwise.
 *
 * To track a user signup along with additional metadata, consider the
 * following:
 * <pre>
 * var dimensions = {
 *  gender: 'm',
 *  source: 'web',
 *  dayType: 'weekend'
 * };
 * Parse.Analytics.track('signup', dimensions);
 * </pre>
 *
 * There is a default limit of 8 dimensions per event tracked.
 *
 * @function track
 * @name Parse.Analytics.track
 * @param {string} name The name of the custom event to report to Parse as
 * having happened.
 * @param {object} dimensions The dictionary of information by which to
 * segment this event.
 * @returns {Promise} A promise that is resolved when the round-trip
 * to the server completes.
 */ function $3b2cef6ef61accae$var$track(name, dimensions) {
    name = name || "";
    name = name.replace(/^\s*/, "");
    name = name.replace(/\s*$/, "");
    if (name.length === 0) throw new TypeError("A name for the custom event must be provided");
    for(const key in dimensions){
        if (typeof key !== "string" || typeof dimensions[key] !== "string") throw new TypeError('track() dimensions expects keys and values of type "string".');
    }
    return $3b2cef6ef61accae$var$_CoreManager.default.getAnalyticsController().track(name, dimensions);
}
const $3b2cef6ef61accae$var$DefaultController = {
    track (name, dimensions) {
        const RESTController = $3b2cef6ef61accae$var$_CoreManager.default.getRESTController();
        return RESTController.request("POST", "events/" + name, {
            dimensions: dimensions
        });
    }
};
$3b2cef6ef61accae$var$_CoreManager.default.setAnalyticsController($3b2cef6ef61accae$var$DefaultController);

});

parcelRegister("ffqks", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b19cae1cd6b40d1a$var$_ParseUser = $iHLHC((parcelRequire("iQ4JH")));

var $b19cae1cd6b40d1a$var$_uuid = $iHLHC((parcelRequire("4q6en")));
let $b19cae1cd6b40d1a$var$registered = false;
/**
 * Provides utility functions for working with Anonymously logged-in users. <br />
 * Anonymous users have some unique characteristics:
 * <ul>
 *  <li>Anonymous users don't need a user name or password.</li>
 *  <ul>
 *    <li>Once logged out, an anonymous user cannot be recovered.</li>
 *  </ul>
 *  <li>signUp converts an anonymous user to a standard user with the given username and password.</li>
 *  <ul>
 *    <li>Data associated with the anonymous user is retained.</li>
 *  </ul>
 *  <li>logIn switches users without converting the anonymous user.</li>
 *  <ul>
 *    <li>Data associated with the anonymous user will be lost.</li>
 *  </ul>
 *  <li>Service logIn (e.g. Facebook, Twitter) will attempt to convert
 *  the anonymous user into a standard user by linking it to the service.</li>
 *  <ul>
 *    <li>If a user already exists that is linked to the service, it will instead switch to the existing user.</li>
 *  </ul>
 *  <li>Service linking (e.g. Facebook, Twitter) will convert the anonymous user
 *  into a standard user by linking it to the service.</li>
 * </ul>
 *
 * @class Parse.AnonymousUtils
 * @static
 */ const $b19cae1cd6b40d1a$var$AnonymousUtils = {
    /**
   * Gets whether the user has their account linked to anonymous user.
   *
   * @function isLinked
   * @name Parse.AnonymousUtils.isLinked
   * @param {Parse.User} user User to check for.
   *     The user must be logged in on this device.
   * @returns {boolean} <code>true</code> if the user has their account
   *     linked to an anonymous user.
   * @static
   */ isLinked (user) {
        const provider = this._getAuthProvider();
        return user._isLinked(provider.getAuthType());
    },
    /**
   * Logs in a user Anonymously.
   *
   * @function logIn
   * @name Parse.AnonymousUtils.logIn
   * @param {object} options MasterKey / SessionToken.
   * @returns {Promise} Logged in user
   * @static
   */ logIn (options) {
        const provider = this._getAuthProvider();
        return $b19cae1cd6b40d1a$var$_ParseUser.default.logInWith(provider.getAuthType(), provider.getAuthData(), options);
    },
    /**
   * Links Anonymous User to an existing PFUser.
   *
   * @function link
   * @name Parse.AnonymousUtils.link
   * @param {Parse.User} user User to link. This must be the current user.
   * @param {object} options MasterKey / SessionToken.
   * @returns {Promise} Linked with User
   * @static
   */ link (user, options) {
        const provider = this._getAuthProvider();
        return user.linkWith(provider.getAuthType(), provider.getAuthData(), options);
    },
    /**
   * Returns true if Authentication Provider has been registered for use.
   *
   * @function isRegistered
   * @name Parse.AnonymousUtils.isRegistered
   * @returns {boolean}
   * @static
   */ isRegistered () {
        return $b19cae1cd6b40d1a$var$registered;
    },
    _getAuthProvider () {
        const provider = {
            restoreAuthentication () {
                return true;
            },
            getAuthType () {
                return "anonymous";
            },
            getAuthData () {
                return {
                    authData: {
                        id: (0, $b19cae1cd6b40d1a$var$_uuid.default)()
                    }
                };
            }
        };
        if (!$b19cae1cd6b40d1a$var$registered) {
            $b19cae1cd6b40d1a$var$_ParseUser.default._registerAuthenticationProvider(provider);
            $b19cae1cd6b40d1a$var$registered = true;
        }
        return provider;
    }
};
var $b19cae1cd6b40d1a$var$_default = module.exports.default = $b19cae1cd6b40d1a$var$AnonymousUtils;

});
parcelRegister("iQ4JH", function(module, exports) {
"use strict";


var $iHLHC = parcelRequire("iHLHC");
(parcelRequire("4i3Tl"))(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db70c1cf4bc707fd$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $db70c1cf4bc707fd$var$_defineProperty = $iHLHC((parcelRequire("4i3Tl")));

var $db70c1cf4bc707fd$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $db70c1cf4bc707fd$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $db70c1cf4bc707fd$var$_isRevocableSession = $iHLHC((parcelRequire("6Jk06")));

var $db70c1cf4bc707fd$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $db70c1cf4bc707fd$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $db70c1cf4bc707fd$var$_Storage = $iHLHC((parcelRequire("7GXKV")));
const $db70c1cf4bc707fd$var$CURRENT_USER_KEY = "currentUser";
let $db70c1cf4bc707fd$var$canUseCurrentUser = !$db70c1cf4bc707fd$var$_CoreManager.default.get("IS_NODE");
let $db70c1cf4bc707fd$var$currentUserCacheMatchesDisk = false;
let $db70c1cf4bc707fd$var$currentUserCache = null;
const $db70c1cf4bc707fd$var$authProviders = {};
/**
 * <p>A Parse.User object is a local representation of a user persisted to the
 * Parse cloud. This class is a subclass of a Parse.Object, and retains the
 * same functionality of a Parse.Object, but also extends it with various
 * user specific methods, like authentication, signing up, and validation of
 * uniqueness.</p>
 *
 * @alias Parse.User
 * @augments Parse.Object
 */ class $db70c1cf4bc707fd$var$ParseUser extends $db70c1cf4bc707fd$var$_ParseObject.default {
    /**
   * @param {object} attributes The initial set of data to store in the user.
   */ constructor(attributes){
        super("_User");
        if (attributes && typeof attributes === "object") {
            if (!this.set(attributes || {})) throw new Error("Can't create an invalid Parse User");
        }
    }
    /**
   * Request a revocable session token to replace the older style of token.
   *
   * @param {object} options
   * @returns {Promise} A promise that is resolved when the replacement
   *   token has been fetched.
   */ _upgradeToRevocableSession(options) {
        options = options || {};
        const upgradeOptions = {};
        if (options.hasOwnProperty("useMasterKey")) upgradeOptions.useMasterKey = options.useMasterKey;
        const controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
        return controller.upgradeToRevocableSession(this, upgradeOptions);
    }
    /**
   * Parse allows you to link your users with {@link https://docs.parseplatform.org/parse-server/guide/#oauth-and-3rd-party-authentication 3rd party authentication}, enabling
   * your users to sign up or log into your application using their existing identities.
   * Since 2.9.0
   *
   * @see {@link https://docs.parseplatform.org/js/guide/#linking-users Linking Users}
   * @param {string | AuthProvider} provider Name of auth provider or {@link https://parseplatform.org/Parse-SDK-JS/api/master/AuthProvider.html AuthProvider}
   * @param {object} options
   * @param {object} [options.authData] AuthData to link with
   * <ul>
   *   <li>If provider is string, options is {@link http://docs.parseplatform.org/parse-server/guide/#supported-3rd-party-authentications authData}
   *   <li>If provider is AuthProvider, options is saveOpts
   * </ul>
   * @param {object} saveOpts useMasterKey / sessionToken
   * @returns {Promise} A promise that is fulfilled with the user is linked
   */ linkWith(provider, options) {
        let saveOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        saveOpts.sessionToken = saveOpts.sessionToken || this.getSessionToken() || "";
        let authType;
        if (typeof provider === "string") {
            authType = provider;
            if ($db70c1cf4bc707fd$var$authProviders[provider]) provider = $db70c1cf4bc707fd$var$authProviders[provider];
            else {
                const authProvider = {
                    restoreAuthentication () {
                        return true;
                    },
                    getAuthType () {
                        return authType;
                    }
                };
                $db70c1cf4bc707fd$var$authProviders[authProvider.getAuthType()] = authProvider;
                provider = authProvider;
            }
        } else authType = provider.getAuthType();
        if (options && options.hasOwnProperty("authData")) {
            const authData = this.get("authData") || {};
            if (typeof authData !== "object") throw new Error("Invalid type: authData field should be an object");
            authData[authType] = options.authData;
            const oldAnonymousData = authData.anonymous;
            this.stripAnonymity();
            const controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
            return controller.linkWith(this, authData, saveOpts).catch((e)=>{
                delete authData[authType];
                this.restoreAnonimity(oldAnonymousData);
                throw e;
            });
        } else return new $db70c1cf4bc707fd$var$_promise.default((resolve, reject)=>{
            provider.authenticate({
                success: (provider, result)=>{
                    const opts = {};
                    opts.authData = result;
                    this.linkWith(provider, opts, saveOpts).then(()=>{
                        resolve(this);
                    }, (error)=>{
                        reject(error);
                    });
                },
                error: (provider, error)=>{
                    reject(error);
                }
            });
        });
    }
    /**
   * @param provider
   * @param options
   * @param {object} [options.authData]
   * @param saveOpts
   * @deprecated since 2.9.0 see {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.User.html#linkWith linkWith}
   * @returns {Promise}
   */ _linkWith(provider, options) {
        let saveOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.linkWith(provider, options, saveOpts);
    }
    /**
   * Synchronizes auth data for a provider (e.g. puts the access token in the
   * right place to be used by the Facebook SDK).
   *
   * @param provider
   */ _synchronizeAuthData(provider) {
        if (!this.isCurrent() || !provider) return;
        let authType;
        if (typeof provider === "string") {
            authType = provider;
            provider = $db70c1cf4bc707fd$var$authProviders[authType];
        } else authType = provider.getAuthType();
        const authData = this.get("authData");
        if (!provider || !authData || typeof authData !== "object") return;
        const success = provider.restoreAuthentication(authData[authType]);
        if (!success) this._unlinkFrom(provider);
    }
    /**
   * Synchronizes authData for all providers.
   */ _synchronizeAllAuthData() {
        const authData = this.get("authData");
        if (typeof authData !== "object") return;
        for(const key in authData)this._synchronizeAuthData(key);
    }
    /**
   * Removes null values from authData (which exist temporarily for unlinking)
   */ _cleanupAuthData() {
        if (!this.isCurrent()) return;
        const authData = this.get("authData");
        if (typeof authData !== "object") return;
        for(const key in authData)if (!authData[key]) delete authData[key];
    }
    /**
   * Unlinks a user from a service.
   *
   * @param {string | AuthProvider} provider Name of auth provider or {@link https://parseplatform.org/Parse-SDK-JS/api/master/AuthProvider.html AuthProvider}
   * @param {object} options MasterKey / SessionToken
   * @returns {Promise} A promise that is fulfilled when the unlinking
   *     finishes.
   */ _unlinkFrom(provider, options) {
        return this.linkWith(provider, {
            authData: null
        }, options).then(()=>{
            this._synchronizeAuthData(provider);
            return $db70c1cf4bc707fd$var$_promise.default.resolve(this);
        });
    }
    /**
   * Checks whether a user is linked to a service.
   *
   * @param {object} provider service to link to
   * @returns {boolean} true if link was successful
   */ _isLinked(provider) {
        let authType;
        if (typeof provider === "string") authType = provider;
        else authType = provider.getAuthType();
        const authData = this.get("authData") || {};
        if (typeof authData !== "object") return false;
        return !!authData[authType];
    }
    /**
   * Deauthenticates all providers.
   */ _logOutWithAll() {
        const authData = this.get("authData");
        if (typeof authData !== "object") return;
        for(const key in authData)this._logOutWith(key);
    }
    /**
   * Deauthenticates a single provider (e.g. removing access tokens from the
   * Facebook SDK).
   *
   * @param {object} provider service to logout of
   */ _logOutWith(provider) {
        if (!this.isCurrent()) return;
        if (typeof provider === "string") provider = $db70c1cf4bc707fd$var$authProviders[provider];
        if (provider && provider.deauthenticate) provider.deauthenticate();
    }
    /**
   * Class instance method used to maintain specific keys when a fetch occurs.
   * Used to ensure that the session token is not lost.
   *
   * @returns {object} sessionToken
   */ _preserveFieldsOnFetch() {
        return {
            sessionToken: this.get("sessionToken")
        };
    }
    /**
   * Returns true if <code>current</code> would return this user.
   *
   * @returns {boolean} true if user is cached on disk
   */ isCurrent() {
        const current = $db70c1cf4bc707fd$var$ParseUser.current();
        return !!current && current.id === this.id;
    }
    /**
   * Returns true if <code>current</code> would return this user.
   *
   * @returns {Promise<boolean>} true if user is cached on disk
   */ async isCurrentAsync() {
        const current = await $db70c1cf4bc707fd$var$ParseUser.currentAsync();
        return !!current && current.id === this.id;
    }
    stripAnonymity() {
        const authData = this.get("authData");
        if (authData && typeof authData === "object" && authData.hasOwnProperty("anonymous")) // We need to set anonymous to null instead of deleting it in order to remove it from Parse.
        authData.anonymous = null;
    }
    restoreAnonimity(anonymousData) {
        if (anonymousData) {
            const authData = this.get("authData");
            authData.anonymous = anonymousData;
        }
    }
    /**
   * Returns get("username").
   *
   * @returns {string}
   */ getUsername() {
        const username = this.get("username");
        if (username == null || typeof username === "string") return username;
        return "";
    }
    /**
   * Calls set("username", username, options) and returns the result.
   *
   * @param {string} username
   */ setUsername(username) {
        this.stripAnonymity();
        this.set("username", username);
    }
    /**
   * Calls set("password", password, options) and returns the result.
   *
   * @param {string} password User's Password
   */ setPassword(password) {
        this.set("password", password);
    }
    /**
   * Returns get("email").
   *
   * @returns {string} User's Email
   */ getEmail() {
        const email = this.get("email");
        if (email == null || typeof email === "string") return email;
        return "";
    }
    /**
   * Calls set("email", email) and returns the result.
   *
   * @param {string} email
   * @returns {boolean}
   */ setEmail(email) {
        return this.set("email", email);
    }
    /**
   * Returns the session token for this user, if the user has been logged in,
   * or if it is the result of a query with the master key. Otherwise, returns
   * undefined.
   *
   * @returns {string} the session token, or undefined
   */ getSessionToken() {
        const token = this.get("sessionToken");
        if (token == null || typeof token === "string") return token;
        return "";
    }
    /**
   * Checks whether this user is the current user and has been authenticated.
   *
   * @returns {boolean} whether this user is the current user and is logged in.
   */ authenticated() {
        const current = $db70c1cf4bc707fd$var$ParseUser.current();
        return !!this.get("sessionToken") && !!current && current.id === this.id;
    }
    /**
   * Signs up a new user. You should call this instead of save for
   * new Parse.Users. This will create a new Parse.User on the server, and
   * also persist the session on disk so that you can access the user using
   * <code>current</code>.
   *
   * <p>A username and password must be set before calling signUp.</p>
   *
   * @param {object} attrs Extra fields to set on the new user, or null.
   * @param {object} options
   * @returns {Promise} A promise that is fulfilled when the signup
   *     finishes.
   */ signUp(attrs, options) {
        options = options || {};
        const signupOptions = {};
        if (options.hasOwnProperty("useMasterKey")) signupOptions.useMasterKey = options.useMasterKey;
        if (options.hasOwnProperty("installationId")) signupOptions.installationId = options.installationId;
        if (options.hasOwnProperty("context") && Object.prototype.toString.call(options.context) === "[object Object]") signupOptions.context = options.context;
        const controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
        return controller.signUp(this, attrs, signupOptions);
    }
    /**
   * Logs in a Parse.User. On success, this saves the session to disk,
   * so you can retrieve the currently logged in user using
   * <code>current</code>.
   *
   * <p>A username and password must be set before calling logIn.</p>
   *
   * @param {object} options
   * @returns {Promise} A promise that is fulfilled with the user when
   *     the login is complete.
   */ logIn() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        options = options || {};
        const loginOptions = {
            usePost: true
        };
        if (options.hasOwnProperty("useMasterKey")) loginOptions.useMasterKey = options.useMasterKey;
        if (options.hasOwnProperty("installationId")) loginOptions.installationId = options.installationId;
        if (options.hasOwnProperty("usePost")) loginOptions.usePost = options.usePost;
        if (options.hasOwnProperty("context") && Object.prototype.toString.call(options.context) === "[object Object]") loginOptions.context = options.context;
        const controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
        return controller.logIn(this, loginOptions);
    }
    /**
   * Wrap the default save behavior with functionality to save to local
   * storage if this is current user.
   *
   * @param {...any} args
   * @returns {Promise}
   */ async save() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        await super.save.apply(this, args);
        const current = await this.isCurrentAsync();
        if (current) return $db70c1cf4bc707fd$var$_CoreManager.default.getUserController().updateUserOnDisk(this);
        return this;
    }
    /**
   * Wrap the default destroy behavior with functionality that logs out
   * the current user when it is destroyed
   *
   * @param {...any} args
   * @returns {Parse.User}
   */ async destroy() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        await super.destroy.apply(this, args);
        const current = await this.isCurrentAsync();
        if (current) return $db70c1cf4bc707fd$var$_CoreManager.default.getUserController().removeUserFromDisk();
        return this;
    }
    /**
   * Wrap the default fetch behavior with functionality to save to local
   * storage if this is current user.
   *
   * @param {...any} args
   * @returns {Parse.User}
   */ async fetch() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        await super.fetch.apply(this, args);
        const current = await this.isCurrentAsync();
        if (current) return $db70c1cf4bc707fd$var$_CoreManager.default.getUserController().updateUserOnDisk(this);
        return this;
    }
    /**
   * Wrap the default fetchWithInclude behavior with functionality to save to local
   * storage if this is current user.
   *
   * @param {...any} args
   * @returns {Parse.User}
   */ async fetchWithInclude() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        await super.fetchWithInclude.apply(this, args);
        const current = await this.isCurrentAsync();
        if (current) return $db70c1cf4bc707fd$var$_CoreManager.default.getUserController().updateUserOnDisk(this);
        return this;
    }
    /**
   * Verify whether a given password is the password of the current user.
   *
   * @param {string} password The password to be verified.
   * @param {object} options The options.
   * @param {boolean} [options.ignoreEmailVerification] Set to `true` to bypass email verification and verify
   * the password regardless of whether the email has been verified. This requires the master key.
   * @returns {Promise} A promise that is fulfilled with a user when the password is correct.
   */ verifyPassword(password, options) {
        const username = this.getUsername() || "";
        return $db70c1cf4bc707fd$var$ParseUser.verifyPassword(username, password, options);
    }
    static readOnlyAttributes() {
        return [
            "sessionToken"
        ];
    }
    /**
   * Adds functionality to the existing Parse.User class.
   *
   * @param {object} protoProps A set of properties to add to the prototype
   * @param {object} classProps A set of static properties to add to the class
   * @static
   * @returns {Parse.User} The newly extended Parse.User class
   */ static extend(protoProps, classProps) {
        if (protoProps) {
            for(const prop in protoProps)if (prop !== "className") (0, $db70c1cf4bc707fd$var$_defineProperty.default)($db70c1cf4bc707fd$var$ParseUser.prototype, prop, {
                value: protoProps[prop],
                enumerable: false,
                writable: true,
                configurable: true
            });
        }
        if (classProps) {
            for(const prop in classProps)if (prop !== "className") (0, $db70c1cf4bc707fd$var$_defineProperty.default)($db70c1cf4bc707fd$var$ParseUser, prop, {
                value: classProps[prop],
                enumerable: false,
                writable: true,
                configurable: true
            });
        }
        return $db70c1cf4bc707fd$var$ParseUser;
    }
    /**
   * Retrieves the currently logged in ParseUser with a valid session,
   * either from memory or localStorage, if necessary.
   *
   * @static
   * @returns {Parse.Object} The currently logged in Parse.User.
   */ static current() {
        if (!$db70c1cf4bc707fd$var$canUseCurrentUser) return null;
        const controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
        return controller.currentUser();
    }
    /**
   * Retrieves the currently logged in ParseUser from asynchronous Storage.
   *
   * @static
   * @returns {Promise} A Promise that is resolved with the currently
   *   logged in Parse User
   */ static currentAsync() {
        if (!$db70c1cf4bc707fd$var$canUseCurrentUser) return $db70c1cf4bc707fd$var$_promise.default.resolve(null);
        const controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
        return controller.currentUserAsync();
    }
    /**
   * Signs up a new user with a username (or email) and password.
   * This will create a new Parse.User on the server, and also persist the
   * session in localStorage so that you can access the user using
   * {@link #current}.
   *
   * @param {string} username The username (or email) to sign up with.
   * @param {string} password The password to sign up with.
   * @param {object} attrs Extra fields to set on the new user.
   * @param {object} options
   * @static
   * @returns {Promise} A promise that is fulfilled with the user when
   *     the signup completes.
   */ static signUp(username, password, attrs, options) {
        attrs = attrs || {};
        attrs.username = username;
        attrs.password = password;
        const user = new this(attrs);
        return user.signUp({}, options);
    }
    /**
   * Logs in a user with a username (or email) and password. On success, this
   * saves the session to disk, so you can retrieve the currently logged in
   * user using <code>current</code>.
   *
   * @param {string} username The username (or email) to log in with.
   * @param {string} password The password to log in with.
   * @param {object} options
   * @static
   * @returns {Promise} A promise that is fulfilled with the user when
   *     the login completes.
   */ static logIn(username, password, options) {
        if (typeof username !== "string") return $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.OTHER_CAUSE, "Username must be a string."));
        else if (typeof password !== "string") return $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.OTHER_CAUSE, "Password must be a string."));
        const user = new this();
        user._finishFetch({
            username: username,
            password: password
        });
        return user.logIn(options);
    }
    /**
   * Logs in a user with a username (or email) and password, and authData. On success, this
   * saves the session to disk, so you can retrieve the currently logged in
   * user using <code>current</code>.
   *
   * @param {string} username The username (or email) to log in with.
   * @param {string} password The password to log in with.
   * @param {object} authData The authData to log in with.
   * @param {object} options
   * @static
   * @returns {Promise} A promise that is fulfilled with the user when
   *     the login completes.
   */ static logInWithAdditionalAuth(username, password, authData, options) {
        if (typeof username !== "string") return $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.OTHER_CAUSE, "Username must be a string."));
        if (typeof password !== "string") return $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.OTHER_CAUSE, "Password must be a string."));
        if (Object.prototype.toString.call(authData) !== "[object Object]") return $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.OTHER_CAUSE, "Auth must be an object."));
        const user = new this();
        user._finishFetch({
            username: username,
            password: password,
            authData: authData
        });
        return user.logIn(options);
    }
    /**
   * Logs in a user with an objectId. On success, this saves the session
   * to disk, so you can retrieve the currently logged in user using
   * <code>current</code>.
   *
   * @param {string} userId The objectId for the user.
   * @static
   * @returns {Promise} A promise that is fulfilled with the user when
   *     the login completes.
   */ static loginAs(userId) {
        if (!userId) throw new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.USERNAME_MISSING, "Cannot log in as user with an empty user id");
        const controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
        const user = new this();
        return controller.loginAs(user, userId);
    }
    /**
   * Logs in a user with a session token. On success, this saves the session
   * to disk, so you can retrieve the currently logged in user using
   * <code>current</code>.
   *
   * @param {string} sessionToken The sessionToken to log in with.
   * @param {object} options
   * @static
   * @returns {Promise} A promise that is fulfilled with the user when
   *     the login completes.
   */ static become(sessionToken, options) {
        if (!$db70c1cf4bc707fd$var$canUseCurrentUser) throw new Error("It is not memory-safe to become a user in a server environment");
        options = options || {};
        const becomeOptions = {
            sessionToken: sessionToken
        };
        if (options.hasOwnProperty("useMasterKey")) becomeOptions.useMasterKey = options.useMasterKey;
        const controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
        const user = new this();
        return controller.become(user, becomeOptions);
    }
    /**
   * Retrieves a user with a session token.
   *
   * @param {string} sessionToken The sessionToken to get user with.
   * @param {object} options
   * @static
   * @returns {Promise} A promise that is fulfilled with the user is fetched.
   */ static me(sessionToken) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
        const meOptions = {
            sessionToken: sessionToken
        };
        if (options.useMasterKey) meOptions.useMasterKey = options.useMasterKey;
        const user = new this();
        return controller.me(user, meOptions);
    }
    /**
   * Logs in a user with a session token. On success, this saves the session
   * to disk, so you can retrieve the currently logged in user using
   * <code>current</code>. If there is no session token the user will not logged in.
   *
   * @param {object} userJSON The JSON map of the User's data
   * @static
   * @returns {Promise} A promise that is fulfilled with the user when
   *     the login completes.
   */ static hydrate(userJSON) {
        const controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
        const user = new this();
        return controller.hydrate(user, userJSON);
    }
    /**
   * Static version of {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.User.html#linkWith linkWith}
   *
   * @param provider
   * @param options
   * @param {object} [options.authData]
   * @param saveOpts
   * @static
   * @returns {Promise}
   */ static logInWith(provider, options, saveOpts) {
        const user = new this();
        return user.linkWith(provider, options, saveOpts);
    }
    /**
   * Logs out the currently logged in user session. This will remove the
   * session from disk, log out of linked services, and future calls to
   * <code>current</code> will return <code>null</code>.
   *
   * @param {object} options
   * @static
   * @returns {Promise} A promise that is resolved when the session is
   *   destroyed on the server.
   */ static logOut() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
        return controller.logOut(options);
    }
    /**
   * Requests a password reset email to be sent to the specified email address
   * associated with the user account. This email allows the user to securely
   * reset their password on the Parse site.
   *
   * @param {string} email The email address associated with the user that
   *     forgot their password.
   * @param {object} options
   * @static
   * @returns {Promise}
   */ static requestPasswordReset(email, options) {
        options = options || {};
        const requestOptions = {};
        if (options.hasOwnProperty("useMasterKey")) requestOptions.useMasterKey = options.useMasterKey;
        const controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
        return controller.requestPasswordReset(email, requestOptions);
    }
    /**
   * Request an email verification.
   *
   * @param {string} email The email address associated with the user that
   *     needs to verify their email.
   * @param {object} options
   * @static
   * @returns {Promise}
   */ static requestEmailVerification(email, options) {
        options = options || {};
        const requestOptions = {};
        if (options.hasOwnProperty("useMasterKey")) requestOptions.useMasterKey = options.useMasterKey;
        const controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
        return controller.requestEmailVerification(email, requestOptions);
    }
    /**
   * Verify whether a given password is the password of the current user.
   * @static
   *
   * @param {string} username  The username of the user whose password should be verified.
   * @param {string} password The password to be verified.
   * @param {object} options The options.
   * @param {boolean} [options.ignoreEmailVerification] Set to `true` to bypass email verification and verify
   * the password regardless of whether the email has been verified. This requires the master key.
   * @returns {Promise} A promise that is fulfilled with a user when the password is correct.
   */ static verifyPassword(username, password, options) {
        if (typeof username !== "string") return $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.OTHER_CAUSE, "Username must be a string."));
        if (typeof password !== "string") return $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.OTHER_CAUSE, "Password must be a string."));
        const controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
        return controller.verifyPassword(username, password, options || {});
    }
    /**
   * Allow someone to define a custom User class without className
   * being rewritten to _User. The default behavior is to rewrite
   * User to _User for legacy reasons. This allows developers to
   * override that behavior.
   *
   * @param {boolean} isAllowed Whether or not to allow custom User class
   * @static
   */ static allowCustomUserClass(isAllowed) {
        $db70c1cf4bc707fd$var$_CoreManager.default.set("PERFORM_USER_REWRITE", !isAllowed);
    }
    /**
   * Allows a legacy application to start using revocable sessions. If the
   * current session token is not revocable, a request will be made for a new,
   * revocable session.
   * It is not necessary to call this method from cloud code unless you are
   * handling user signup or login from the server side. In a cloud code call,
   * this function will not attempt to upgrade the current token.
   *
   * @param {object} options
   * @static
   * @returns {Promise} A promise that is resolved when the process has
   *   completed. If a replacement session token is requested, the promise
   *   will be resolved after a new token has been fetched.
   */ static enableRevocableSession(options) {
        options = options || {};
        $db70c1cf4bc707fd$var$_CoreManager.default.set("FORCE_REVOCABLE_SESSION", true);
        if ($db70c1cf4bc707fd$var$canUseCurrentUser) {
            const current = $db70c1cf4bc707fd$var$ParseUser.current();
            if (current) return current._upgradeToRevocableSession(options);
        }
        return $db70c1cf4bc707fd$var$_promise.default.resolve();
    }
    /**
   * Enables the use of become or the current user in a server
   * environment. These features are disabled by default, since they depend on
   * global objects that are not memory-safe for most servers.
   *
   * @static
   */ static enableUnsafeCurrentUser() {
        $db70c1cf4bc707fd$var$canUseCurrentUser = true;
    }
    /**
   * Disables the use of become or the current user in any environment.
   * These features are disabled on servers by default, since they depend on
   * global objects that are not memory-safe for most servers.
   *
   * @static
   */ static disableUnsafeCurrentUser() {
        $db70c1cf4bc707fd$var$canUseCurrentUser = false;
    }
    /**
   * When registering users with {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.User.html#linkWith linkWith} a basic auth provider
   * is automatically created for you.
   *
   * For advanced authentication, you can register an Auth provider to
   * implement custom authentication, deauthentication.
   *
   * @param provider
   * @see {@link https://parseplatform.org/Parse-SDK-JS/api/master/AuthProvider.html AuthProvider}
   * @see {@link https://docs.parseplatform.org/js/guide/#custom-authentication-module Custom Authentication Module}
   * @static
   */ static _registerAuthenticationProvider(provider) {
        $db70c1cf4bc707fd$var$authProviders[provider.getAuthType()] = provider;
        // Synchronize the current user with the auth provider.
        $db70c1cf4bc707fd$var$ParseUser.currentAsync().then((current)=>{
            if (current) current._synchronizeAuthData(provider.getAuthType());
        });
    }
    /**
   * @param provider
   * @param options
   * @param {object} [options.authData]
   * @param saveOpts
   * @deprecated since 2.9.0 see {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.User.html#logInWith logInWith}
   * @static
   * @returns {Promise}
   */ static _logInWith(provider, options, saveOpts) {
        const user = new this();
        return user.linkWith(provider, options, saveOpts);
    }
    static _clearCache() {
        $db70c1cf4bc707fd$var$currentUserCache = null;
        $db70c1cf4bc707fd$var$currentUserCacheMatchesDisk = false;
    }
    static _setCurrentUserCache(user) {
        $db70c1cf4bc707fd$var$currentUserCache = user;
    }
}
$db70c1cf4bc707fd$var$_ParseObject.default.registerSubclass("_User", $db70c1cf4bc707fd$var$ParseUser);
const $db70c1cf4bc707fd$var$DefaultController = {
    updateUserOnDisk (user) {
        const path = $db70c1cf4bc707fd$var$_Storage.default.generatePath($db70c1cf4bc707fd$var$CURRENT_USER_KEY);
        const json = user.toJSON();
        delete json.password;
        json.className = "_User";
        let userData = (0, $db70c1cf4bc707fd$var$_stringify.default)(json);
        if ($db70c1cf4bc707fd$var$_CoreManager.default.get("ENCRYPTED_USER")) {
            const crypto = $db70c1cf4bc707fd$var$_CoreManager.default.getCryptoController();
            userData = crypto.encrypt(json, $db70c1cf4bc707fd$var$_CoreManager.default.get("ENCRYPTED_KEY"));
        }
        return $db70c1cf4bc707fd$var$_Storage.default.setItemAsync(path, userData).then(()=>{
            return user;
        });
    },
    removeUserFromDisk () {
        const path = $db70c1cf4bc707fd$var$_Storage.default.generatePath($db70c1cf4bc707fd$var$CURRENT_USER_KEY);
        $db70c1cf4bc707fd$var$currentUserCacheMatchesDisk = true;
        $db70c1cf4bc707fd$var$currentUserCache = null;
        return $db70c1cf4bc707fd$var$_Storage.default.removeItemAsync(path);
    },
    setCurrentUser (user) {
        $db70c1cf4bc707fd$var$currentUserCache = user;
        user._cleanupAuthData();
        user._synchronizeAllAuthData();
        return $db70c1cf4bc707fd$var$DefaultController.updateUserOnDisk(user);
    },
    currentUser () {
        if ($db70c1cf4bc707fd$var$currentUserCache) return $db70c1cf4bc707fd$var$currentUserCache;
        if ($db70c1cf4bc707fd$var$currentUserCacheMatchesDisk) return null;
        if ($db70c1cf4bc707fd$var$_Storage.default.async()) throw new Error("Cannot call currentUser() when using a platform with an async storage system. Call currentUserAsync() instead.");
        const path = $db70c1cf4bc707fd$var$_Storage.default.generatePath($db70c1cf4bc707fd$var$CURRENT_USER_KEY);
        let userData = $db70c1cf4bc707fd$var$_Storage.default.getItem(path);
        $db70c1cf4bc707fd$var$currentUserCacheMatchesDisk = true;
        if (!userData) {
            $db70c1cf4bc707fd$var$currentUserCache = null;
            return null;
        }
        if ($db70c1cf4bc707fd$var$_CoreManager.default.get("ENCRYPTED_USER")) {
            const crypto = $db70c1cf4bc707fd$var$_CoreManager.default.getCryptoController();
            userData = crypto.decrypt(userData, $db70c1cf4bc707fd$var$_CoreManager.default.get("ENCRYPTED_KEY"));
        }
        userData = JSON.parse(userData);
        if (!userData.className) userData.className = "_User";
        if (userData._id) {
            if (userData.objectId !== userData._id) userData.objectId = userData._id;
            delete userData._id;
        }
        if (userData._sessionToken) {
            userData.sessionToken = userData._sessionToken;
            delete userData._sessionToken;
        }
        const current = $db70c1cf4bc707fd$var$_ParseObject.default.fromJSON(userData);
        $db70c1cf4bc707fd$var$currentUserCache = current;
        current._synchronizeAllAuthData();
        return current;
    },
    currentUserAsync () {
        if ($db70c1cf4bc707fd$var$currentUserCache) return $db70c1cf4bc707fd$var$_promise.default.resolve($db70c1cf4bc707fd$var$currentUserCache);
        if ($db70c1cf4bc707fd$var$currentUserCacheMatchesDisk) return $db70c1cf4bc707fd$var$_promise.default.resolve(null);
        const path = $db70c1cf4bc707fd$var$_Storage.default.generatePath($db70c1cf4bc707fd$var$CURRENT_USER_KEY);
        return $db70c1cf4bc707fd$var$_Storage.default.getItemAsync(path).then((userData)=>{
            $db70c1cf4bc707fd$var$currentUserCacheMatchesDisk = true;
            if (!userData) {
                $db70c1cf4bc707fd$var$currentUserCache = null;
                return $db70c1cf4bc707fd$var$_promise.default.resolve(null);
            }
            if ($db70c1cf4bc707fd$var$_CoreManager.default.get("ENCRYPTED_USER")) {
                const crypto = $db70c1cf4bc707fd$var$_CoreManager.default.getCryptoController();
                userData = crypto.decrypt(userData.toString(), $db70c1cf4bc707fd$var$_CoreManager.default.get("ENCRYPTED_KEY"));
            }
            userData = JSON.parse(userData);
            if (!userData.className) userData.className = "_User";
            if (userData._id) {
                if (userData.objectId !== userData._id) userData.objectId = userData._id;
                delete userData._id;
            }
            if (userData._sessionToken) {
                userData.sessionToken = userData._sessionToken;
                delete userData._sessionToken;
            }
            const current = $db70c1cf4bc707fd$var$_ParseObject.default.fromJSON(userData);
            $db70c1cf4bc707fd$var$currentUserCache = current;
            current._synchronizeAllAuthData();
            return $db70c1cf4bc707fd$var$_promise.default.resolve(current);
        });
    },
    signUp (user, attrs, options) {
        const username = attrs && attrs.username || user.get("username");
        const password = attrs && attrs.password || user.get("password");
        if (!username || !username.length) return $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.OTHER_CAUSE, "Cannot sign up user with an empty username."));
        if (!password || !password.length) return $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.OTHER_CAUSE, "Cannot sign up user with an empty password."));
        return user.save(attrs, options).then(()=>{
            // Clear the password field
            user._finishFetch({
                password: undefined
            });
            if ($db70c1cf4bc707fd$var$canUseCurrentUser) return $db70c1cf4bc707fd$var$DefaultController.setCurrentUser(user);
            return user;
        });
    },
    logIn (user, options) {
        const RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
        const stateController = $db70c1cf4bc707fd$var$_CoreManager.default.getObjectStateController();
        const auth = {
            username: user.get("username"),
            password: user.get("password"),
            authData: user.get("authData")
        };
        return RESTController.request(options.usePost ? "POST" : "GET", "login", auth, options).then((response)=>{
            user._migrateId(response.objectId);
            user._setExisted(true);
            stateController.setPendingOp(user._getStateIdentifier(), "username", undefined);
            stateController.setPendingOp(user._getStateIdentifier(), "password", undefined);
            response.password = undefined;
            user._finishFetch(response);
            if (!$db70c1cf4bc707fd$var$canUseCurrentUser) // We can't set the current user, so just return the one we logged in
            return $db70c1cf4bc707fd$var$_promise.default.resolve(user);
            return $db70c1cf4bc707fd$var$DefaultController.setCurrentUser(user);
        });
    },
    loginAs (user, userId) {
        const RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
        return RESTController.request("POST", "loginAs", {
            userId: userId
        }, {
            useMasterKey: true
        }).then((response)=>{
            user._finishFetch(response);
            user._setExisted(true);
            if (!$db70c1cf4bc707fd$var$canUseCurrentUser) return $db70c1cf4bc707fd$var$_promise.default.resolve(user);
            return $db70c1cf4bc707fd$var$DefaultController.setCurrentUser(user);
        });
    },
    become (user, options) {
        const RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "users/me", {}, options).then((response)=>{
            user._finishFetch(response);
            user._setExisted(true);
            return $db70c1cf4bc707fd$var$DefaultController.setCurrentUser(user);
        });
    },
    hydrate (user, userJSON) {
        user._finishFetch(userJSON);
        user._setExisted(true);
        if (userJSON.sessionToken && $db70c1cf4bc707fd$var$canUseCurrentUser) return $db70c1cf4bc707fd$var$DefaultController.setCurrentUser(user);
        else return $db70c1cf4bc707fd$var$_promise.default.resolve(user);
    },
    me (user, options) {
        const RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "users/me", {}, options).then((response)=>{
            user._finishFetch(response);
            user._setExisted(true);
            return user;
        });
    },
    logOut (options) {
        const RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
        if (options.sessionToken) return RESTController.request("POST", "logout", {}, options);
        return $db70c1cf4bc707fd$var$DefaultController.currentUserAsync().then((currentUser)=>{
            const path = $db70c1cf4bc707fd$var$_Storage.default.generatePath($db70c1cf4bc707fd$var$CURRENT_USER_KEY);
            let promise = $db70c1cf4bc707fd$var$_Storage.default.removeItemAsync(path);
            if (currentUser !== null) {
                const currentSession = currentUser.getSessionToken();
                if (currentSession && (0, $db70c1cf4bc707fd$var$_isRevocableSession.default)(currentSession)) promise = promise.then(()=>{
                    return RESTController.request("POST", "logout", {}, {
                        sessionToken: currentSession
                    });
                });
                currentUser._logOutWithAll();
                currentUser._finishFetch({
                    sessionToken: undefined
                });
            }
            $db70c1cf4bc707fd$var$currentUserCacheMatchesDisk = true;
            $db70c1cf4bc707fd$var$currentUserCache = null;
            return promise;
        });
    },
    requestPasswordReset (email, options) {
        const RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
        return RESTController.request("POST", "requestPasswordReset", {
            email: email
        }, options);
    },
    async upgradeToRevocableSession (user, options) {
        const token = user.getSessionToken();
        if (!token) return $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.SESSION_MISSING, "Cannot upgrade a user with no session token"));
        options.sessionToken = token;
        const RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
        const result = await RESTController.request("POST", "upgradeToRevocableSession", {}, options);
        user._finishFetch({
            sessionToken: result?.sessionToken || ""
        });
        const current = await user.isCurrentAsync();
        if (current) return $db70c1cf4bc707fd$var$DefaultController.setCurrentUser(user);
        return $db70c1cf4bc707fd$var$_promise.default.resolve(user);
    },
    linkWith (user, authData, options) {
        return user.save({
            authData: authData
        }, options).then(()=>{
            if ($db70c1cf4bc707fd$var$canUseCurrentUser) return $db70c1cf4bc707fd$var$DefaultController.setCurrentUser(user);
            return user;
        });
    },
    verifyPassword (username, password, options) {
        const RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
        const data = {
            username: username,
            password: password,
            ...options.ignoreEmailVerification !== undefined && {
                ignoreEmailVerification: options.ignoreEmailVerification
            }
        };
        return RESTController.request("GET", "verifyPassword", data, options);
    },
    requestEmailVerification (email, options) {
        const RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
        return RESTController.request("POST", "verificationEmailRequest", {
            email: email
        }, options);
    }
};
$db70c1cf4bc707fd$var$_CoreManager.default.setParseUser($db70c1cf4bc707fd$var$ParseUser);
$db70c1cf4bc707fd$var$_CoreManager.default.setUserController($db70c1cf4bc707fd$var$DefaultController);
var $db70c1cf4bc707fd$var$_default = module.exports.default = $db70c1cf4bc707fd$var$ParseUser;

});
parcelRegister("6Jk06", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4e6675c71402065a$var$isRevocableSession;

var $4e6675c71402065a$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));
function $4e6675c71402065a$var$isRevocableSession(token) {
    return (0, $4e6675c71402065a$var$_indexOf.default)(token).call(token, "r:") > -1;
}

});



parcelRegister("2YVFi", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.getJobStatus = $22bdea717d82f556$var$getJobStatus;
module.exports.getJobsData = $22bdea717d82f556$var$getJobsData;
module.exports.run = $22bdea717d82f556$var$run;
module.exports.startJob = $22bdea717d82f556$var$startJob;

var $22bdea717d82f556$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $22bdea717d82f556$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $22bdea717d82f556$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $22bdea717d82f556$var$_decode = $iHLHC((parcelRequire("42E6z")));

var $22bdea717d82f556$var$_encode = $iHLHC((parcelRequire("1rsTn")));

var $22bdea717d82f556$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $22bdea717d82f556$var$_ParseQuery = $iHLHC((parcelRequire("4FVCr")));
/**
 * Contains functions for calling and declaring
 * <a href="/docs/cloud_code_guide#functions">cloud functions</a>.
 * <p><strong><em>
 *   Some functions are only available from Cloud Code.
 * </em></strong></p>
 *
 * @class Parse.Cloud
 * @static
 * @hideconstructor
 */ /**
 * Makes a call to a cloud function.
 *
 * @function run
 * @name Parse.Cloud.run
 * @param {string} name The function name.
 * @param {object} data The parameters to send to the cloud function.
 * @param {object} options
 * @returns {Promise} A promise that will be resolved with the result
 * of the function.
 */ function $22bdea717d82f556$var$run(name, data, options) {
    options = options || {};
    if (typeof name !== "string" || name.length === 0) throw new TypeError("Cloud function name must be a string.");
    const requestOptions = {};
    if (options.useMasterKey) requestOptions.useMasterKey = options.useMasterKey;
    if (options.sessionToken) requestOptions.sessionToken = options.sessionToken;
    if (options.installationId) requestOptions.installationId = options.installationId;
    if (options.context && typeof options.context === "object") requestOptions.context = options.context;
    return $22bdea717d82f556$var$_CoreManager.default.getCloudController().run(name, data, requestOptions);
}
/**
 * Gets data for the current set of cloud jobs.
 *
 * @function getJobsData
 * @name Parse.Cloud.getJobsData
 * @returns {Promise} A promise that will be resolved with the result
 * of the function.
 */ function $22bdea717d82f556$var$getJobsData() {
    return $22bdea717d82f556$var$_CoreManager.default.getCloudController().getJobsData({
        useMasterKey: true
    });
}
/**
 * Starts a given cloud job, which will process asynchronously.
 *
 * @function startJob
 * @name Parse.Cloud.startJob
 * @param {string} name The function name.
 * @param {object} data The parameters to send to the cloud function.
 * @returns {Promise} A promise that will be resolved with the jobStatusId
 * of the job.
 */ function $22bdea717d82f556$var$startJob(name, data) {
    if (typeof name !== "string" || name.length === 0) throw new TypeError("Cloud job name must be a string.");
    return $22bdea717d82f556$var$_CoreManager.default.getCloudController().startJob(name, data, {
        useMasterKey: true
    });
}
/**
 * Gets job status by Id
 *
 * @function getJobStatus
 * @name Parse.Cloud.getJobStatus
 * @param {string} jobStatusId The Id of Job Status.
 * @returns {Parse.Object} Status of Job.
 */ function $22bdea717d82f556$var$getJobStatus(jobStatusId) {
    const query = new $22bdea717d82f556$var$_ParseQuery.default("_JobStatus");
    return query.get(jobStatusId, {
        useMasterKey: true
    });
}
const $22bdea717d82f556$var$DefaultController = {
    run (name, data, options) {
        const RESTController = $22bdea717d82f556$var$_CoreManager.default.getRESTController();
        const payload = (0, $22bdea717d82f556$var$_encode.default)(data, true);
        const request = RESTController.request("POST", "functions/" + name, payload, options);
        return request.then((res)=>{
            if (typeof res === "object" && (0, $22bdea717d82f556$var$_keys.default)(res).length > 0 && !res.hasOwnProperty("result")) throw new $22bdea717d82f556$var$_ParseError.default($22bdea717d82f556$var$_ParseError.default.INVALID_JSON, "The server returned an invalid response.");
            const decoded = (0, $22bdea717d82f556$var$_decode.default)(res);
            if (decoded && decoded.hasOwnProperty("result")) return $22bdea717d82f556$var$_promise.default.resolve(decoded.result);
            return $22bdea717d82f556$var$_promise.default.resolve(undefined);
        });
    },
    getJobsData (options) {
        const RESTController = $22bdea717d82f556$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "cloud_code/jobs/data", null, options);
    },
    async startJob (name, data, options) {
        const RESTController = $22bdea717d82f556$var$_CoreManager.default.getRESTController();
        const payload = (0, $22bdea717d82f556$var$_encode.default)(data, true);
        options.returnStatus = true;
        const response = await RESTController.request("POST", "jobs/" + name, payload, options);
        return response._headers?.["X-Parse-Job-Status-Id"];
    }
};
$22bdea717d82f556$var$_CoreManager.default.setCloudController($22bdea717d82f556$var$DefaultController);

});

parcelRegister("hnFLk", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca74facc0e37113f$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $ca74facc0e37113f$var$_map = $iHLHC((parcelRequire("2ETAR")));

var $ca74facc0e37113f$var$_entries = $iHLHC((parcelRequire("4Rvnw")));

var $ca74facc0e37113f$var$_assign = $iHLHC((parcelRequire("55aVK")));

var $ca74facc0e37113f$var$_slice = $iHLHC((parcelRequire("a1TrC")));

var $ca74facc0e37113f$var$_includes = $iHLHC((parcelRequire("dNrmj")));

var $ca74facc0e37113f$var$_every = $iHLHC((parcelRequire("7Xgow")));

var $ca74facc0e37113f$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $ca74facc0e37113f$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $ca74facc0e37113f$var$_ParseRole = $iHLHC((parcelRequire("7MXHA")));

var $ca74facc0e37113f$var$_ParseUser = $iHLHC((parcelRequire("iQ4JH")));
const $ca74facc0e37113f$var$PUBLIC_KEY = "*";
const $ca74facc0e37113f$var$VALID_PERMISSIONS = new $ca74facc0e37113f$var$_map.default();
$ca74facc0e37113f$var$VALID_PERMISSIONS.set("get", {});
$ca74facc0e37113f$var$VALID_PERMISSIONS.set("find", {});
$ca74facc0e37113f$var$VALID_PERMISSIONS.set("count", {});
$ca74facc0e37113f$var$VALID_PERMISSIONS.set("create", {});
$ca74facc0e37113f$var$VALID_PERMISSIONS.set("update", {});
$ca74facc0e37113f$var$VALID_PERMISSIONS.set("delete", {});
$ca74facc0e37113f$var$VALID_PERMISSIONS.set("addField", {});
const $ca74facc0e37113f$var$VALID_PERMISSIONS_EXTENDED = new $ca74facc0e37113f$var$_map.default();
$ca74facc0e37113f$var$VALID_PERMISSIONS_EXTENDED.set("protectedFields", {});
/**
 * Creates a new CLP.
 * If no argument is given, the CLP has no permissions for anyone.
 * If the argument is a Parse.User or Parse.Role, the CLP will have read and write
 *   permission for only that user or role.
 * If the argument is any other JSON object, that object will be interpretted
 *   as a serialized CLP created with toJSON().
 *
 * <p>A CLP, or Class Level Permissions can be added to any
 * <code>Parse.Schema</code> to restrict access to only a subset of users
 * of your application.</p>
 *
 * <p>
 * For get/count/find/create/update/delete/addField using the following functions:
 *
 * Entity is type Parse.User or Parse.Role or string
 * Role is type Parse.Role or Name of Parse.Role
 *
 * getGetRequiresAuthentication()
 * setGetRequiresAuthentication(allowed: boolean)
 * getGetPointerFields()
 * setGetPointerFields(pointerFields: string[])
 * getGetAccess(entity: Entity)
 * setGetAccess(entity: Entity, allowed: boolean)
 * getPublicGetAccess()
 * setPublicGetAccess(allowed: boolean)
 * getRoleGetAccess(role: Role)
 * setRoleGetAccess(role: Role, allowed: boolean)
 * getFindRequiresAuthentication()
 * setFindRequiresAuthentication(allowed: boolean)
 * getFindPointerFields()
 * setFindPointerFields(pointerFields: string[])
 * getFindAccess(entity: Entity)
 * setFindAccess(entity: Entity, allowed: boolean)
 * getPublicFindAccess()
 * setPublicFindAccess(allowed: boolean)
 * getRoleFindAccess(role: Role)
 * setRoleFindAccess(role: Role, allowed: boolean)
 * getCountRequiresAuthentication()
 * setCountRequiresAuthentication(allowed: boolean)
 * getCountPointerFields()
 * setCountPointerFields(pointerFields: string[])
 * getCountAccess(entity: Entity)
 * setCountAccess(entity: Entity, allowed: boolean)
 * getPublicCountAccess()
 * setPublicCountAccess(allowed: boolean)
 * getRoleCountAccess(role: Role)
 * setRoleCountAccess(role: Role, allowed: boolean)
 * getCreateRequiresAuthentication()
 * setCreateRequiresAuthentication(allowed: boolean)
 * getCreatePointerFields()
 * setCreatePointerFields(pointerFields: string[])
 * getCreateAccess(entity: Entity)
 * setCreateAccess(entity: Entity, allowed: boolean)
 * getPublicCreateAccess()
 * setPublicCreateAccess(allowed: Boolean)
 * getRoleCreateAccess(role: Role)
 * setRoleCreateAccess(role: Role, allowed: boolean)
 * getUpdateRequiresAuthentication()
 * setUpdateRequiresAuthentication(allowed: boolean)
 * getUpdatePointerFields()
 * setUpdatePointerFields(pointerFields: string[])
 * getUpdateAccess(entity: Entity)
 * setUpdateAccess(entity: Entity, allowed: boolean)
 * getPublicUpdateAccess()
 * setPublicUpdateAccess(allowed: boolean)
 * getRoleUpdateAccess(role: Role)
 * setRoleUpdateAccess(role: Role, allowed: boolean)
 * getDeleteRequiresAuthentication()
 * setDeleteRequiresAuthentication(allowed: boolean)
 * getDeletePointerFields()
 * setDeletePointerFields(pointerFields: string[])
 * getDeleteAccess(entity: Entity)
 * setDeleteAccess(entity: Entity, allowed: boolean)
 * getPublicDeleteAccess()
 * setPublicDeleteAccess(allowed: boolean)
 * getRoleDeleteAccess(role: Role)
 * setRoleDeleteAccess(role: Role, allowed: boolean)
 * getAddFieldRequiresAuthentication()
 * setAddFieldRequiresAuthentication(allowed: boolean)
 * getAddFieldPointerFields()
 * setAddFieldPointerFields(pointerFields: string[])
 * getAddFieldAccess(entity: Entity)
 * setAddFieldAccess(entity: Entity, allowed: boolean)
 * getPublicAddFieldAccess()
 * setPublicAddFieldAccess(allowed: boolean)
 * getRoleAddFieldAccess(role: Role)
 * setRoleAddFieldAccess(role: Role, allowed: boolean)
 * </p>
 *
 * @alias Parse.CLP
 */ class $ca74facc0e37113f$var$ParseCLP {
    /**
   * @param {(Parse.User | Parse.Role | object)} userId The user to initialize the CLP for
   */ constructor(userId){
        (0, $ca74facc0e37113f$var$_defineProperty2.default)(this, "permissionsMap", void 0);
        this.permissionsMap = {};
        // Initialize permissions Map with default permissions
        for (const [operation, group] of (0, $ca74facc0e37113f$var$_entries.default)($ca74facc0e37113f$var$VALID_PERMISSIONS).call($ca74facc0e37113f$var$VALID_PERMISSIONS)){
            this.permissionsMap[operation] = (0, $ca74facc0e37113f$var$_assign.default)({}, group);
            const action = operation.charAt(0).toUpperCase() + (0, $ca74facc0e37113f$var$_slice.default)(operation).call(operation, 1);
            this[`get${action}RequiresAuthentication`] = function() {
                return this._getAccess(operation, "requiresAuthentication");
            };
            this[`set${action}RequiresAuthentication`] = function(allowed) {
                this._setAccess(operation, "requiresAuthentication", allowed);
            };
            this[`get${action}PointerFields`] = function() {
                return this._getAccess(operation, "pointerFields", false);
            };
            this[`set${action}PointerFields`] = function(pointerFields) {
                this._setArrayAccess(operation, "pointerFields", pointerFields);
            };
            this[`get${action}Access`] = function(entity) {
                return this._getAccess(operation, entity);
            };
            this[`set${action}Access`] = function(entity, allowed) {
                this._setAccess(operation, entity, allowed);
            };
            this[`getPublic${action}Access`] = function() {
                return this[`get${action}Access`]($ca74facc0e37113f$var$PUBLIC_KEY);
            };
            this[`setPublic${action}Access`] = function(allowed) {
                this[`set${action}Access`]($ca74facc0e37113f$var$PUBLIC_KEY, allowed);
            };
            this[`getRole${action}Access`] = function(role) {
                return this[`get${action}Access`](this._getRoleName(role));
            };
            this[`setRole${action}Access`] = function(role, allowed) {
                this[`set${action}Access`](this._getRoleName(role), allowed);
            };
        }
        // Initialize permissions Map with default extended permissions
        for (const [operation, group] of (0, $ca74facc0e37113f$var$_entries.default)($ca74facc0e37113f$var$VALID_PERMISSIONS_EXTENDED).call($ca74facc0e37113f$var$VALID_PERMISSIONS_EXTENDED))this.permissionsMap[operation] = (0, $ca74facc0e37113f$var$_assign.default)({}, group);
        if (userId && typeof userId === "object") {
            if (userId instanceof $ca74facc0e37113f$var$_ParseUser.default) {
                this.setReadAccess(userId, true);
                this.setWriteAccess(userId, true);
            } else if (userId instanceof $ca74facc0e37113f$var$_ParseRole.default) {
                this.setRoleReadAccess(userId, true);
                this.setRoleWriteAccess(userId, true);
            } else for(const permission in userId){
                var _context;
                const users = userId[permission];
                const isValidPermission = !!$ca74facc0e37113f$var$VALID_PERMISSIONS.get(permission);
                const isValidPermissionExtended = !!$ca74facc0e37113f$var$VALID_PERMISSIONS_EXTENDED.get(permission);
                const isValidGroupPermission = (0, $ca74facc0e37113f$var$_includes.default)(_context = [
                    "readUserFields",
                    "writeUserFields"
                ]).call(_context, permission);
                if (typeof permission !== "string" || !(isValidPermission || isValidPermissionExtended || isValidGroupPermission)) throw new TypeError("Tried to create an CLP with an invalid permission type.");
                if (isValidGroupPermission) {
                    if ((0, $ca74facc0e37113f$var$_every.default)(users).call(users, (pointer)=>typeof pointer === "string")) {
                        this.permissionsMap[permission] = users;
                        continue;
                    } else throw new TypeError("Tried to create an CLP with an invalid permission value.");
                }
                for(const user in users){
                    const allowed = users[user];
                    if (typeof allowed !== "boolean" && !isValidPermissionExtended && user !== "pointerFields") throw new TypeError("Tried to create an CLP with an invalid permission value.");
                    this.permissionsMap[permission][user] = allowed;
                }
            }
        } else if (typeof userId === "function") throw new TypeError("ParseCLP constructed with a function. Did you forget ()?");
    }
    /**
   * Returns a JSON-encoded version of the CLP.
   *
   * @returns {object}
   */ toJSON() {
        return {
            ...this.permissionsMap
        };
    }
    /**
   * Returns whether this CLP is equal to another object
   *
   * @param other The other object to compare to
   * @returns {boolean}
   */ equals(other) {
        if (!(other instanceof $ca74facc0e37113f$var$ParseCLP)) return false;
        const permissions = (0, $ca74facc0e37113f$var$_keys.default)(this.permissionsMap);
        const otherPermissions = (0, $ca74facc0e37113f$var$_keys.default)(other.permissionsMap);
        if (permissions.length !== otherPermissions.length) return false;
        for(const permission in this.permissionsMap){
            if (!other.permissionsMap[permission]) return false;
            const users = (0, $ca74facc0e37113f$var$_keys.default)(this.permissionsMap[permission]);
            const otherUsers = (0, $ca74facc0e37113f$var$_keys.default)(other.permissionsMap[permission]);
            if (users.length !== otherUsers.length) return false;
            for(const user in this.permissionsMap[permission]){
                if (!other.permissionsMap[permission][user]) return false;
                if (this.permissionsMap[permission][user] !== other.permissionsMap[permission][user]) return false;
            }
        }
        return true;
    }
    _getRoleName(role) {
        let name = role;
        if (role instanceof $ca74facc0e37113f$var$_ParseRole.default) // Normalize to the String name
        name = role.getName();
        if (typeof name !== "string") throw new TypeError("role must be a Parse.Role or a String");
        return `role:${name}`;
    }
    _parseEntity(entity) {
        let userId = entity;
        if (userId instanceof $ca74facc0e37113f$var$_ParseUser.default) {
            userId = userId.id;
            if (!userId) throw new Error("Cannot get access for a Parse.User without an id.");
        } else if (userId instanceof $ca74facc0e37113f$var$_ParseRole.default) userId = this._getRoleName(userId);
        if (typeof userId !== "string") throw new TypeError("userId must be a string.");
        return userId;
    }
    _setAccess(permission, userId, allowed) {
        userId = this._parseEntity(userId);
        if (typeof allowed !== "boolean") throw new TypeError("allowed must be either true or false.");
        const permissions = this.permissionsMap[permission][userId];
        if (!permissions) {
            if (!allowed) // The user already doesn't have this permission, so no action is needed
            return;
            else this.permissionsMap[permission][userId] = {};
        }
        if (allowed) this.permissionsMap[permission][userId] = true;
        else delete this.permissionsMap[permission][userId];
    }
    _getAccess(permission, userId) {
        let returnBoolean = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        userId = this._parseEntity(userId);
        const permissions = this.permissionsMap[permission][userId];
        if (returnBoolean) {
            if (!permissions) return false;
            return !!this.permissionsMap[permission][userId];
        }
        return permissions;
    }
    _setArrayAccess(permission, userId, fields) {
        userId = this._parseEntity(userId);
        const permissions = this.permissionsMap[permission][userId];
        if (!permissions) this.permissionsMap[permission][userId] = [];
        if (!fields || (0, $ca74facc0e37113f$var$_isArray.default)(fields) && fields.length === 0) delete this.permissionsMap[permission][userId];
        else if ((0, $ca74facc0e37113f$var$_isArray.default)(fields) && (0, $ca74facc0e37113f$var$_every.default)(fields).call(fields, (field)=>typeof field === "string")) this.permissionsMap[permission][userId] = fields;
        else throw new TypeError("fields must be an array of strings or undefined.");
    }
    _setGroupPointerPermission(operation, pointerFields) {
        const fields = this.permissionsMap[operation];
        if (!fields) this.permissionsMap[operation] = [];
        if (!pointerFields || (0, $ca74facc0e37113f$var$_isArray.default)(pointerFields) && pointerFields.length === 0) delete this.permissionsMap[operation];
        else if ((0, $ca74facc0e37113f$var$_isArray.default)(pointerFields) && (0, $ca74facc0e37113f$var$_every.default)(pointerFields).call(pointerFields, (field)=>typeof field === "string")) this.permissionsMap[operation] = pointerFields;
        else throw new TypeError(`${operation}.pointerFields must be an array of strings or undefined.`);
    }
    _getGroupPointerPermissions(operation) {
        return this.permissionsMap[operation] || [];
    }
    /**
   * Sets user pointer fields to allow permission for get/count/find operations.
   *
   * @param {string[]} pointerFields User pointer fields
   */ setReadUserFields(pointerFields) {
        this._setGroupPointerPermission("readUserFields", pointerFields);
    }
    /**
   * @returns {string[]} User pointer fields
   */ getReadUserFields() {
        return this._getGroupPointerPermissions("readUserFields") || [];
    }
    /**
   * Sets user pointer fields to allow permission for create/delete/update/addField operations
   *
   * @param {string[]} pointerFields User pointer fields
   */ setWriteUserFields(pointerFields) {
        this._setGroupPointerPermission("writeUserFields", pointerFields);
    }
    /**
   * @returns {string[]} User pointer fields
   */ getWriteUserFields() {
        return this._getGroupPointerPermissions("writeUserFields") || [];
    }
    /**
   * Sets whether the given user is allowed to retrieve fields from this class.
   *
   * @param userId An instance of Parse.User or its objectId.
   * @param {string[]} fields fields to be protected
   */ setProtectedFields(userId, fields) {
        this._setArrayAccess("protectedFields", userId, fields);
    }
    /**
   * Returns array of fields are accessable to this user.
   *
   * @param userId An instance of Parse.User or its objectId, or a Parse.Role.
   * @returns {string[]}
   */ getProtectedFields(userId) {
        return this._getAccess("protectedFields", userId, false);
    }
    /**
   * Sets whether the given user is allowed to read from this class.
   *
   * @param userId An instance of Parse.User or its objectId.
   * @param {boolean} allowed whether that user should have read access.
   */ setReadAccess(userId, allowed) {
        this._setAccess("find", userId, allowed);
        this._setAccess("get", userId, allowed);
        this._setAccess("count", userId, allowed);
    }
    /**
   * Get whether the given user id is *explicitly* allowed to read from this class.
   * Even if this returns false, the user may still be able to access it if
   * getPublicReadAccess returns true or a role that the user belongs to has
   * write access.
   *
   * @param userId An instance of Parse.User or its objectId, or a Parse.Role.
   * @returns {boolean}
   */ getReadAccess(userId) {
        return this._getAccess("find", userId) && this._getAccess("get", userId) && this._getAccess("count", userId);
    }
    /**
   * Sets whether the given user id is allowed to write to this class.
   *
   * @param userId An instance of Parse.User or its objectId, or a Parse.Role..
   * @param {boolean} allowed Whether that user should have write access.
   */ setWriteAccess(userId, allowed) {
        this._setAccess("create", userId, allowed);
        this._setAccess("update", userId, allowed);
        this._setAccess("delete", userId, allowed);
        this._setAccess("addField", userId, allowed);
    }
    /**
   * Gets whether the given user id is *explicitly* allowed to write to this class.
   * Even if this returns false, the user may still be able to write it if
   * getPublicWriteAccess returns true or a role that the user belongs to has
   * write access.
   *
   * @param userId An instance of Parse.User or its objectId, or a Parse.Role.
   * @returns {boolean}
   */ getWriteAccess(userId) {
        return this._getAccess("create", userId) && this._getAccess("update", userId) && this._getAccess("delete", userId) && this._getAccess("addField", userId);
    }
    /**
   * Sets whether the public is allowed to read from this class.
   *
   * @param {boolean} allowed
   */ setPublicReadAccess(allowed) {
        this.setReadAccess($ca74facc0e37113f$var$PUBLIC_KEY, allowed);
    }
    /**
   * Gets whether the public is allowed to read from this class.
   *
   * @returns {boolean}
   */ getPublicReadAccess() {
        return this.getReadAccess($ca74facc0e37113f$var$PUBLIC_KEY);
    }
    /**
   * Sets whether the public is allowed to write to this class.
   *
   * @param {boolean} allowed
   */ setPublicWriteAccess(allowed) {
        this.setWriteAccess($ca74facc0e37113f$var$PUBLIC_KEY, allowed);
    }
    /**
   * Gets whether the public is allowed to write to this class.
   *
   * @returns {boolean}
   */ getPublicWriteAccess() {
        return this.getWriteAccess($ca74facc0e37113f$var$PUBLIC_KEY);
    }
    /**
   * Sets whether the public is allowed to protect fields in this class.
   *
   * @param {string[]} fields
   */ setPublicProtectedFields(fields) {
        this.setProtectedFields($ca74facc0e37113f$var$PUBLIC_KEY, fields);
    }
    /**
   * Gets whether the public is allowed to read fields from this class.
   *
   * @returns {string[]}
   */ getPublicProtectedFields() {
        return this.getProtectedFields($ca74facc0e37113f$var$PUBLIC_KEY);
    }
    /**
   * Gets whether users belonging to the given role are allowed
   * to read from this class. Even if this returns false, the role may
   * still be able to write it if a parent role has read access.
   *
   * @param role The name of the role, or a Parse.Role object.
   * @returns {boolean} true if the role has read access. false otherwise.
   * @throws {TypeError} If role is neither a Parse.Role nor a String.
   */ getRoleReadAccess(role) {
        return this.getReadAccess(this._getRoleName(role));
    }
    /**
   * Gets whether users belonging to the given role are allowed
   * to write to this user. Even if this returns false, the role may
   * still be able to write it if a parent role has write access.
   *
   * @param role The name of the role, or a Parse.Role object.
   * @returns {boolean} true if the role has write access. false otherwise.
   * @throws {TypeError} If role is neither a Parse.Role nor a String.
   */ getRoleWriteAccess(role) {
        return this.getWriteAccess(this._getRoleName(role));
    }
    /**
   * Sets whether users belonging to the given role are allowed
   * to read from this class.
   *
   * @param role The name of the role, or a Parse.Role object.
   * @param {boolean} allowed Whether the given role can read this object.
   * @throws {TypeError} If role is neither a Parse.Role nor a String.
   */ setRoleReadAccess(role, allowed) {
        this.setReadAccess(this._getRoleName(role), allowed);
    }
    /**
   * Sets whether users belonging to the given role are allowed
   * to write to this class.
   *
   * @param role The name of the role, or a Parse.Role object.
   * @param {boolean} allowed Whether the given role can write this object.
   * @throws {TypeError} If role is neither a Parse.Role nor a String.
   */ setRoleWriteAccess(role, allowed) {
        this.setWriteAccess(this._getRoleName(role), allowed);
    }
    /**
   * Gets whether users belonging to the given role are allowed
   * to count to this user. Even if this returns false, the role may
   * still be able to count it if a parent role has count access.
   *
   * @param role The name of the role, or a Parse.Role object.
   * @returns {string[]}
   * @throws {TypeError} If role is neither a Parse.Role nor a String.
   */ getRoleProtectedFields(role) {
        return this.getProtectedFields(this._getRoleName(role));
    }
    /**
   * Sets whether users belonging to the given role are allowed
   * to set access field in this class.
   *
   * @param role The name of the role, or a Parse.Role object.
   * @param {string[]} fields Fields to be protected by Role.
   * @throws {TypeError} If role is neither a Parse.Role nor a String.
   */ setRoleProtectedFields(role, fields) {
        this.setProtectedFields(this._getRoleName(role), fields);
    }
}
var $ca74facc0e37113f$var$_default = module.exports.default = $ca74facc0e37113f$var$ParseCLP;

});
parcelRegister("2ETAR", function(module, exports) {

module.exports = (parcelRequire("gXAPd"));

});
parcelRegister("gXAPd", function(module, exports) {
"use strict";

var $4pVgE = parcelRequire("4pVgE");
parcelRequire("jXhxH");
module.exports = $4pVgE;

});
parcelRegister("4pVgE", function(module, exports) {
"use strict";
parcelRequire("5xrGR");
parcelRequire("5rfW8");
parcelRequire("c1I8r");
parcelRequire("iYyco");
parcelRequire("ja2zQ");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Map;

});
parcelRegister("5rfW8", function(module, exports) {
"use strict";
parcelRequire("hoPYl");

});
parcelRegister("hoPYl", function(module, exports) {
"use strict";

var $30YqS = parcelRequire("30YqS");

var $1q3vw = parcelRequire("1q3vw");
// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
$30YqS("Map", function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $1q3vw);

});
parcelRegister("1q3vw", function(module, exports) {
"use strict";

var $fhVPP = parcelRequire("fhVPP");

var $7kUwJ = parcelRequire("7kUwJ");

var $gklY2 = parcelRequire("gklY2");

var $b5UsH = parcelRequire("b5UsH");

var $a95no = parcelRequire("a95no");

var $6exeg = parcelRequire("6exeg");

var $jUk8Y = parcelRequire("jUk8Y");

var $5KUYO = parcelRequire("5KUYO");

var $5IrwJ = parcelRequire("5IrwJ");

var $13iqA = parcelRequire("13iqA");

var $jeZ4p = parcelRequire("jeZ4p");

var $iZE4H = parcelRequire("iZE4H");
var $108af0a6911c2cfe$require$fastKey = $iZE4H.fastKey;

var $fmQ29 = parcelRequire("fmQ29");
var $108af0a6911c2cfe$var$setInternalState = $fmQ29.set;
var $108af0a6911c2cfe$var$internalStateGetterFor = $fmQ29.getterFor;
module.exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $a95no(that, Prototype);
            $108af0a6911c2cfe$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: $fhVPP(null),
                first: null,
                last: null,
                size: 0
            });
            if (!$jeZ4p) that.size = 0;
            if (!$6exeg(iterable)) $jUk8Y(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $108af0a6911c2cfe$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = $108af0a6911c2cfe$require$fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: null,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if ($jeZ4p) state.size++;
                else that.size++;
                // add to index
                if (index !== "F") state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = $108af0a6911c2cfe$require$fastKey(key);
            var entry;
            if (index !== "F") return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key === key) return entry;
            }
        };
        $gklY2(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = null;
                    entry = entry.next;
                }
                state.first = state.last = null;
                state.index = $fhVPP(null);
                if ($jeZ4p) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            "delete": function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first === entry) state.first = next;
                    if (state.last === entry) state.last = prev;
                    if ($jeZ4p) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = $b5UsH(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        $gklY2(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if ($jeZ4p) $7kUwJ(Prototype, "size", {
            configurable: true,
            get: function() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + " Iterator";
        var getInternalCollectionState = $108af0a6911c2cfe$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = $108af0a6911c2cfe$var$internalStateGetterFor(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        $5KUYO(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            $108af0a6911c2cfe$var$setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: null
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = null;
                return $5IrwJ(undefined, true);
            }
            // return step by kind
            if (kind === "keys") return $5IrwJ(entry.key, false);
            if (kind === "values") return $5IrwJ(entry.value, false);
            return $5IrwJ([
                entry.key,
                entry.value
            ], false);
        }, IS_MAP ? "entries" : "values", !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        $13iqA(CONSTRUCTOR_NAME);
    }
};

});



parcelRegister("c1I8r", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $f518o = parcelRequire("f518o");

var $8GsPx = parcelRequire("8GsPx");

var $cBWnS = parcelRequire("cBWnS");

var $jUk8Y = parcelRequire("jUk8Y");

var $dfy73 = parcelRequire("dfy73");

var $7phdw = parcelRequire("7phdw");

var $77TPA = parcelRequire("77TPA");
var $8c17d059055b368a$var$Map = $dfy73.Map;
var $8c17d059055b368a$var$has = $dfy73.has;
var $8c17d059055b368a$var$get = $dfy73.get;
var $8c17d059055b368a$var$set = $dfy73.set;
var $8c17d059055b368a$var$push = $f518o([].push);
var $8c17d059055b368a$var$DOES_NOT_WORK_WITH_PRIMITIVES = $7phdw || $77TPA(function() {
    return $8c17d059055b368a$var$Map.groupBy("ab", function(it) {
        return it;
    }).get("a").length !== 1;
});
// `Map.groupBy` method
// https://github.com/tc39/proposal-array-grouping
$ggcsv({
    target: "Map",
    stat: true,
    forced: $7phdw || $8c17d059055b368a$var$DOES_NOT_WORK_WITH_PRIMITIVES
}, {
    groupBy: function groupBy(items, callbackfn) {
        $cBWnS(items);
        $8GsPx(callbackfn);
        var map = new $8c17d059055b368a$var$Map();
        var k = 0;
        $jUk8Y(items, function(value) {
            var key = callbackfn(value, k++);
            if (!$8c17d059055b368a$var$has(map, key)) $8c17d059055b368a$var$set(map, key, [
                value
            ]);
            else $8c17d059055b368a$var$push($8c17d059055b368a$var$get(map, key), value);
        });
        return map;
    }
});

});
parcelRegister("dfy73", function(module, exports) {
"use strict";

var $5Pobw = parcelRequire("5Pobw");

var $1Tqyy = parcelRequire("1Tqyy");
var $9a57232bf25135e7$var$Map = $5Pobw("Map");
module.exports = {
    Map: $9a57232bf25135e7$var$Map,
    set: $1Tqyy("set", 2),
    get: $1Tqyy("get", 1),
    has: $1Tqyy("has", 1),
    remove: $1Tqyy("delete", 1),
    proto: $9a57232bf25135e7$var$Map.prototype
};

});
parcelRegister("1Tqyy", function(module, exports) {
"use strict";
module.exports = function(methodName, numArgs) {
    return numArgs === 1 ? function(object, arg) {
        return object[methodName](arg);
    } : function(object, arg1, arg2) {
        return object[methodName](arg1, arg2);
    };
};

});






parcelRegister("4Rvnw", function(module, exports) {

module.exports = (parcelRequire("lADqs"));

});
parcelRegister("lADqs", function(module, exports) {
"use strict";
parcelRequire("jXhxH");

var $aHxiP = parcelRequire("aHxiP");

var $heVlo = parcelRequire("heVlo");

var $8hsAO = parcelRequire("8hsAO");

var $eaqOh = parcelRequire("eaqOh");
var $fb7b8ae7a4e6efd1$var$ArrayPrototype = Array.prototype;
var $fb7b8ae7a4e6efd1$var$DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
module.exports = function(it) {
    var own = it.entries;
    return it === $fb7b8ae7a4e6efd1$var$ArrayPrototype || $8hsAO($fb7b8ae7a4e6efd1$var$ArrayPrototype, it) && own === $fb7b8ae7a4e6efd1$var$ArrayPrototype.entries || $heVlo($fb7b8ae7a4e6efd1$var$DOMIterables, $aHxiP(it)) ? $eaqOh : own;
};

});
parcelRegister("eaqOh", function(module, exports) {
"use strict";

var $6Emw3 = parcelRequire("6Emw3");
module.exports = $6Emw3;

});
parcelRegister("6Emw3", function(module, exports) {
"use strict";
parcelRequire("5xrGR");
parcelRequire("iYyco");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Array", "entries");

});




parcelRegister("55aVK", function(module, exports) {

module.exports = (parcelRequire("4IMRI"));

});
parcelRegister("4IMRI", function(module, exports) {
"use strict";

var $cfbrK = parcelRequire("cfbrK");
module.exports = $cfbrK;

});
parcelRegister("cfbrK", function(module, exports) {
"use strict";
parcelRequire("jNyCo");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Object.assign;

});
parcelRegister("jNyCo", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $gykNr = parcelRequire("gykNr");
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$ggcsv({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $gykNr
}, {
    assign: $gykNr
});

});
parcelRegister("gykNr", function(module, exports) {
"use strict";

var $jeZ4p = parcelRequire("jeZ4p");

var $f518o = parcelRequire("f518o");

var $aELZY = parcelRequire("aELZY");

var $77TPA = parcelRequire("77TPA");

var $3Ut0t = parcelRequire("3Ut0t");

var $4BK7o = parcelRequire("4BK7o");

var $d5uYy = parcelRequire("d5uYy");

var $iJNxK = parcelRequire("iJNxK");

var $lEtn3 = parcelRequire("lEtn3");
// eslint-disable-next-line es/no-object-assign -- safe
var $c0cff40b2410be8f$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $c0cff40b2410be8f$var$defineProperty = Object.defineProperty;
var $c0cff40b2410be8f$var$concat = $f518o([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$c0cff40b2410be8f$var$$assign || $77TPA(function() {
    // should have correct order of operations (Edge bug)
    if ($jeZ4p && $c0cff40b2410be8f$var$$assign({
        b: 1
    }, $c0cff40b2410be8f$var$$assign($c0cff40b2410be8f$var$defineProperty({}, "a", {
        enumerable: true,
        get: function() {
            $c0cff40b2410be8f$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol("assign detection");
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $c0cff40b2410be8f$var$$assign({}, A)[symbol] !== 7 || $3Ut0t($c0cff40b2410be8f$var$$assign({}, B)).join("") !== alphabet;
}) ? function assign(target, source) {
    var T = $iJNxK(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $4BK7o.f;
    var propertyIsEnumerable = $d5uYy.f;
    while(argumentsLength > index){
        var S = $lEtn3(arguments[index++]);
        var keys = getOwnPropertySymbols ? $c0cff40b2410be8f$var$concat($3Ut0t(S), getOwnPropertySymbols(S)) : $3Ut0t(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$jeZ4p || $aELZY(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $c0cff40b2410be8f$var$$assign;

});





parcelRegister("7Xgow", function(module, exports) {

module.exports = (parcelRequire("65nOf"));

});
parcelRegister("65nOf", function(module, exports) {
"use strict";

var $lVyCV = parcelRequire("lVyCV");
module.exports = $lVyCV;

});
parcelRegister("lVyCV", function(module, exports) {
"use strict";

var $8hsAO = parcelRequire("8hsAO");

var $8migK = parcelRequire("8migK");
var $ff69c80067f74ec4$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.every;
    return it === $ff69c80067f74ec4$var$ArrayPrototype || $8hsAO($ff69c80067f74ec4$var$ArrayPrototype, it) && own === $ff69c80067f74ec4$var$ArrayPrototype.every ? $8migK : own;
};

});
parcelRegister("8migK", function(module, exports) {
"use strict";
parcelRequire("fY34z");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Array", "every");

});
parcelRegister("fY34z", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $igsV9 = parcelRequire("igsV9");
var $b9fed7c9ee572842$require$$every = $igsV9.every;

var $kQPJO = parcelRequire("kQPJO");
var $b9fed7c9ee572842$var$STRICT_METHOD = $kQPJO("every");
// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$ggcsv({
    target: "Array",
    proto: true,
    forced: !$b9fed7c9ee572842$var$STRICT_METHOD
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        return $b9fed7c9ee572842$require$$every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

});





parcelRegister("7MXHA", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5abb53a6926c4351$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $5abb53a6926c4351$var$_ParseACL = $iHLHC((parcelRequire("2xGBa")));

var $5abb53a6926c4351$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $5abb53a6926c4351$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));
/**
 * Represents a Role on the Parse server. Roles represent groupings of
 * Users for the purposes of granting permissions (e.g. specifying an ACL
 * for an Object). Roles are specified by their sets of child users and
 * child roles, all of which are granted any permissions that the parent
 * role has.
 *
 * <p>Roles must have a name (which cannot be changed after creation of the
 * role), and must specify an ACL.</p>
 *
 * @alias Parse.Role
 * @augments Parse.Object
 */ class $5abb53a6926c4351$var$ParseRole extends $5abb53a6926c4351$var$_ParseObject.default {
    /**
   * @param {string} name The name of the Role to create.
   * @param {Parse.ACL} acl The ACL for this role. Roles must have an ACL.
   * A Parse.Role is a local representation of a role persisted to the Parse
   * cloud.
   */ constructor(name, acl){
        super("_Role");
        if (typeof name === "string" && acl instanceof $5abb53a6926c4351$var$_ParseACL.default) {
            this.setName(name);
            this.setACL(acl);
        }
    }
    /**
   * Gets the name of the role.  You can alternatively call role.get("name")
   *
   * @returns {string} the name of the role.
   */ getName() {
        const name = this.get("name");
        if (name == null || typeof name === "string") return name;
        return "";
    }
    /**
   * Sets the name for a role. This value must be set before the role has
   * been saved to the server, and cannot be set once the role has been
   * saved.
   *
   * <p>
   *   A role's name can only contain alphanumeric characters, _, -, and
   *   spaces.
   * </p>
   *
   * <p>This is equivalent to calling role.set("name", name)</p>
   *
   * @param {string} name The name of the role.
   * @param {object} options Standard options object with success and error
   *     callbacks.
   * @returns {(ParseObject|boolean)} true if the set succeeded.
   */ setName(name, options) {
        this._validateName(name);
        return this.set("name", name, options);
    }
    /**
   * Gets the Parse.Relation for the Parse.Users that are direct
   * children of this role. These users are granted any privileges that this
   * role has been granted (e.g. read or write access through ACLs). You can
   * add or remove users from the role through this relation.
   *
   * <p>This is equivalent to calling role.relation("users")</p>
   *
   * @returns {Parse.Relation} the relation for the users belonging to this
   *     role.
   */ getUsers() {
        return this.relation("users");
    }
    /**
   * Gets the Parse.Relation for the Parse.Roles that are direct
   * children of this role. These roles' users are granted any privileges that
   * this role has been granted (e.g. read or write access through ACLs). You
   * can add or remove child roles from this role through this relation.
   *
   * <p>This is equivalent to calling role.relation("roles")</p>
   *
   * @returns {Parse.Relation} the relation for the roles belonging to this
   *     role.
   */ getRoles() {
        return this.relation("roles");
    }
    _validateName(newName) {
        if (typeof newName !== "string") throw new $5abb53a6926c4351$var$_ParseError.default($5abb53a6926c4351$var$_ParseError.default.OTHER_CAUSE, "A role's name must be a String.");
        if (!/^[0-9a-zA-Z\-_ ]+$/.test(newName)) throw new $5abb53a6926c4351$var$_ParseError.default($5abb53a6926c4351$var$_ParseError.default.OTHER_CAUSE, "A role's name can be only contain alphanumeric characters, _, -, and spaces.");
    }
    validate(attrs, options) {
        const isInvalid = super.validate(attrs, options);
        if (isInvalid) return isInvalid;
        if ("name" in attrs && attrs.name !== this.getName()) {
            const newName = attrs.name;
            if (this.id && this.id !== attrs.objectId) // Check to see if the objectId being set matches this.id
            // This happens during a fetch -- the id is set before calling fetch
            // Let the name be set in this case
            return new $5abb53a6926c4351$var$_ParseError.default($5abb53a6926c4351$var$_ParseError.default.OTHER_CAUSE, "A role's name can only be set before it has been saved.");
            try {
                this._validateName(newName);
            } catch (e) {
                return e;
            }
        }
        return false;
    }
}
$5abb53a6926c4351$var$_CoreManager.default.setParseRole($5abb53a6926c4351$var$ParseRole);
$5abb53a6926c4351$var$_ParseObject.default.registerSubclass("_Role", $5abb53a6926c4351$var$ParseRole);
var $5abb53a6926c4351$var$_default = module.exports.default = $5abb53a6926c4351$var$ParseRole;

});


parcelRegister("2GgHs", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * This is a simple wrapper to unify EventEmitter implementations across platforms.
 */ let $1f3c754b23a00446$var$EventEmitter;

try {
    $1f3c754b23a00446$var$EventEmitter = (parcelRequire("jMc9N")).EventEmitter;
} catch (_) {
// EventEmitter unavailable
}
module.exports = $1f3c754b23a00446$var$EventEmitter;
var $1f3c754b23a00446$var$_default = module.exports.default = $1f3c754b23a00446$var$EventEmitter;

});
parcelRegister("jMc9N", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $e65bee21a7cdc3da$var$R = typeof Reflect === "object" ? Reflect : null;
var $e65bee21a7cdc3da$var$ReflectApply = $e65bee21a7cdc3da$var$R && typeof $e65bee21a7cdc3da$var$R.apply === "function" ? $e65bee21a7cdc3da$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $e65bee21a7cdc3da$var$ReflectOwnKeys;
if ($e65bee21a7cdc3da$var$R && typeof $e65bee21a7cdc3da$var$R.ownKeys === "function") $e65bee21a7cdc3da$var$ReflectOwnKeys = $e65bee21a7cdc3da$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $e65bee21a7cdc3da$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $e65bee21a7cdc3da$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $e65bee21a7cdc3da$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $e65bee21a7cdc3da$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $e65bee21a7cdc3da$var$EventEmitter() {
    $e65bee21a7cdc3da$var$EventEmitter.init.call(this);
}
module.exports = $e65bee21a7cdc3da$var$EventEmitter;
module.exports.once = $e65bee21a7cdc3da$var$once;
// Backwards-compat with node 0.10.x
$e65bee21a7cdc3da$var$EventEmitter.EventEmitter = $e65bee21a7cdc3da$var$EventEmitter;
$e65bee21a7cdc3da$var$EventEmitter.prototype._events = undefined;
$e65bee21a7cdc3da$var$EventEmitter.prototype._eventsCount = 0;
$e65bee21a7cdc3da$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $e65bee21a7cdc3da$var$defaultMaxListeners = 10;
function $e65bee21a7cdc3da$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($e65bee21a7cdc3da$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $e65bee21a7cdc3da$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $e65bee21a7cdc3da$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $e65bee21a7cdc3da$var$defaultMaxListeners = arg;
    }
});
$e65bee21a7cdc3da$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$e65bee21a7cdc3da$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $e65bee21a7cdc3da$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $e65bee21a7cdc3da$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $e65bee21a7cdc3da$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $e65bee21a7cdc3da$var$_getMaxListeners(this);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $e65bee21a7cdc3da$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $e65bee21a7cdc3da$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$e65bee21a7cdc3da$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $e65bee21a7cdc3da$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $e65bee21a7cdc3da$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $e65bee21a7cdc3da$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $e65bee21a7cdc3da$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $e65bee21a7cdc3da$var$_addListener(this, type, listener, false);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.on = $e65bee21a7cdc3da$var$EventEmitter.prototype.addListener;
$e65bee21a7cdc3da$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $e65bee21a7cdc3da$var$_addListener(this, type, listener, true);
};
function $e65bee21a7cdc3da$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $e65bee21a7cdc3da$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $e65bee21a7cdc3da$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.once = function once(type, listener) {
    $e65bee21a7cdc3da$var$checkListener(listener);
    this.on(type, $e65bee21a7cdc3da$var$_onceWrap(this, type, listener));
    return this;
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $e65bee21a7cdc3da$var$checkListener(listener);
    this.prependListener(type, $e65bee21a7cdc3da$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$e65bee21a7cdc3da$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $e65bee21a7cdc3da$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $e65bee21a7cdc3da$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.off = $e65bee21a7cdc3da$var$EventEmitter.prototype.removeListener;
$e65bee21a7cdc3da$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $e65bee21a7cdc3da$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $e65bee21a7cdc3da$var$unwrapListeners(evlistener) : $e65bee21a7cdc3da$var$arrayClone(evlistener, evlistener.length);
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $e65bee21a7cdc3da$var$_listeners(this, type, true);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $e65bee21a7cdc3da$var$_listeners(this, type, false);
};
$e65bee21a7cdc3da$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $e65bee21a7cdc3da$var$listenerCount.call(emitter, type);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.listenerCount = $e65bee21a7cdc3da$var$listenerCount;
function $e65bee21a7cdc3da$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $e65bee21a7cdc3da$var$ReflectOwnKeys(this._events) : [];
};
function $e65bee21a7cdc3da$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $e65bee21a7cdc3da$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $e65bee21a7cdc3da$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $e65bee21a7cdc3da$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $e65bee21a7cdc3da$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $e65bee21a7cdc3da$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRegister("5K5Co", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42e59b49f917a38b$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $42e59b49f917a38b$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $42e59b49f917a38b$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $42e59b49f917a38b$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $42e59b49f917a38b$var$_decode = $iHLHC((parcelRequire("42E6z")));

var $42e59b49f917a38b$var$_encode = $iHLHC((parcelRequire("1rsTn")));

var $42e59b49f917a38b$var$_escape = $iHLHC((parcelRequire("1JxNp")));

var $42e59b49f917a38b$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $42e59b49f917a38b$var$_Storage = $iHLHC((parcelRequire("7GXKV")));
/**
 * Parse.Config is a local representation of configuration data that
 * can be set from the Parse dashboard.
 *
 * @alias Parse.Config
 */ class $42e59b49f917a38b$var$ParseConfig {
    constructor(){
        (0, $42e59b49f917a38b$var$_defineProperty2.default)(this, "attributes", void 0);
        (0, $42e59b49f917a38b$var$_defineProperty2.default)(this, "_escapedAttributes", void 0);
        this.attributes = {};
        this._escapedAttributes = {};
    }
    /**
   * Gets the value of an attribute.
   *
   * @param {string} attr The name of an attribute.
   * @returns {*}
   */ get(attr) {
        return this.attributes[attr];
    }
    /**
   * Gets the HTML-escaped value of an attribute.
   *
   * @param {string} attr The name of an attribute.
   * @returns {string}
   */ escape(attr) {
        const html = this._escapedAttributes[attr];
        if (html) return html;
        const val = this.attributes[attr];
        let escaped = "";
        if (val != null) escaped = (0, $42e59b49f917a38b$var$_escape.default)(val.toString());
        this._escapedAttributes[attr] = escaped;
        return escaped;
    }
    /**
   * Retrieves the most recently-fetched configuration object, either from
   * memory or from local storage if necessary.
   *
   * @static
   * @returns {Parse.Config} The most recently-fetched Parse.Config if it
   *     exists, else an empty Parse.Config.
   */ static current() {
        const controller = $42e59b49f917a38b$var$_CoreManager.default.getConfigController();
        return controller.current();
    }
    /**
   * Gets a new configuration object from the server.
   *
   * @static
   * @param {object} options
   * Valid options are:<ul>
   *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
   *     be used for this request.
   * </ul>
   * @returns {Promise} A promise that is resolved with a newly-created
   *     configuration object when the get completes.
   */ static get() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const controller = $42e59b49f917a38b$var$_CoreManager.default.getConfigController();
        return controller.get(options);
    }
    /**
   * Save value keys to the server.
   *
   * @static
   * @param {object} attrs The config parameters and values.
   * @param {object} masterKeyOnlyFlags The flags that define whether config parameters listed
   * in `attrs` should be retrievable only by using the master key.
   * For example: `param1: true` makes `param1` only retrievable by using the master key.
   * If a parameter is not provided or set to `false`, it can be retrieved without
   * using the master key.
   * @returns {Promise} A promise that is resolved with a newly-created
   *     configuration object or with the current with the update.
   */ static save(attrs, masterKeyOnlyFlags) {
        const controller = $42e59b49f917a38b$var$_CoreManager.default.getConfigController();
        //To avoid a mismatch with the local and the cloud config we get a new version
        return controller.save(attrs, masterKeyOnlyFlags).then(()=>{
            return controller.get({
                useMasterKey: true
            });
        }, (error)=>{
            return $42e59b49f917a38b$var$_promise.default.reject(error);
        });
    }
    /**
   * Used for testing
   *
   * @private
   */ static _clearCache() {
        $42e59b49f917a38b$var$currentConfig = null;
    }
}
let $42e59b49f917a38b$var$currentConfig = null;
const $42e59b49f917a38b$var$CURRENT_CONFIG_KEY = "currentConfig";
function $42e59b49f917a38b$var$decodePayload(data) {
    try {
        const json = JSON.parse(data);
        if (json && typeof json === "object") return (0, $42e59b49f917a38b$var$_decode.default)(json);
    } catch (e) {
        return null;
    }
}
const $42e59b49f917a38b$var$DefaultController = {
    current () {
        if ($42e59b49f917a38b$var$currentConfig) return $42e59b49f917a38b$var$currentConfig;
        const config = new $42e59b49f917a38b$var$ParseConfig();
        const storagePath = $42e59b49f917a38b$var$_Storage.default.generatePath($42e59b49f917a38b$var$CURRENT_CONFIG_KEY);
        if (!$42e59b49f917a38b$var$_Storage.default.async()) {
            const configData = $42e59b49f917a38b$var$_Storage.default.getItem(storagePath);
            if (configData) {
                const attributes = $42e59b49f917a38b$var$decodePayload(configData);
                if (attributes) {
                    config.attributes = attributes;
                    $42e59b49f917a38b$var$currentConfig = config;
                }
            }
            return config;
        }
        // Return a promise for async storage controllers
        return $42e59b49f917a38b$var$_Storage.default.getItemAsync(storagePath).then((configData)=>{
            if (configData) {
                const attributes = $42e59b49f917a38b$var$decodePayload(configData);
                if (attributes) {
                    config.attributes = attributes;
                    $42e59b49f917a38b$var$currentConfig = config;
                }
            }
            return config;
        });
    },
    get () {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const RESTController = $42e59b49f917a38b$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "config", {}, options).then((response)=>{
            if (!response || !response.params) {
                const error = new $42e59b49f917a38b$var$_ParseError.default($42e59b49f917a38b$var$_ParseError.default.INVALID_JSON, "Config JSON response invalid.");
                return $42e59b49f917a38b$var$_promise.default.reject(error);
            }
            const config = new $42e59b49f917a38b$var$ParseConfig();
            config.attributes = {};
            for(const attr in response.params)config.attributes[attr] = (0, $42e59b49f917a38b$var$_decode.default)(response.params[attr]);
            $42e59b49f917a38b$var$currentConfig = config;
            return $42e59b49f917a38b$var$_Storage.default.setItemAsync($42e59b49f917a38b$var$_Storage.default.generatePath($42e59b49f917a38b$var$CURRENT_CONFIG_KEY), (0, $42e59b49f917a38b$var$_stringify.default)(response.params)).then(()=>{
                return config;
            });
        });
    },
    save (attrs, masterKeyOnlyFlags) {
        const RESTController = $42e59b49f917a38b$var$_CoreManager.default.getRESTController();
        const encodedAttrs = {};
        for(const key in attrs)encodedAttrs[key] = (0, $42e59b49f917a38b$var$_encode.default)(attrs[key]);
        return RESTController.request("PUT", "config", {
            params: encodedAttrs,
            masterKeyOnly: masterKeyOnlyFlags
        }, {
            useMasterKey: true
        }).then((response)=>{
            if (response && response.result) return $42e59b49f917a38b$var$_promise.default.resolve();
            else {
                const error = new $42e59b49f917a38b$var$_ParseError.default($42e59b49f917a38b$var$_ParseError.default.INTERNAL_SERVER_ERROR, "Error occured updating Config.");
                return $42e59b49f917a38b$var$_promise.default.reject(error);
            }
        });
    }
};
$42e59b49f917a38b$var$_CoreManager.default.setConfigController($42e59b49f917a38b$var$DefaultController);
var $42e59b49f917a38b$var$_default = module.exports.default = $42e59b49f917a38b$var$ParseConfig;

});

parcelRegister("iRjYO", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbacacd35a49d2da$var$_ParseUser = $iHLHC((parcelRequire("iQ4JH")));
/* global FB */ let $dbacacd35a49d2da$var$initialized = false;
let $dbacacd35a49d2da$var$requestedPermissions;
let $dbacacd35a49d2da$var$initOptions;
const $dbacacd35a49d2da$var$provider = {
    authenticate (options) {
        if (typeof FB === "undefined") options.error(this, "Facebook SDK not found.");
        FB.login((response)=>{
            if (response.authResponse) {
                if (options.success) options.success(this, {
                    id: response.authResponse.userID,
                    access_token: response.authResponse.accessToken,
                    expiration_date: new Date(response.authResponse.expiresIn * 1000 + new Date().getTime()).toJSON()
                });
            } else if (options.error) options.error(this, response);
        }, {
            scope: $dbacacd35a49d2da$var$requestedPermissions
        });
    },
    restoreAuthentication (authData) {
        if (authData) {
            const newOptions = {};
            if ($dbacacd35a49d2da$var$initOptions) for(const key in $dbacacd35a49d2da$var$initOptions)newOptions[key] = $dbacacd35a49d2da$var$initOptions[key];
            // Suppress checks for login status from the browser.
            newOptions.status = false;
            // If the user doesn't match the one known by the FB SDK, log out.
            // Most of the time, the users will match -- it's only in cases where
            // the FB SDK knows of a different user than the one being restored
            // from a Parse User that logged in with username/password.
            const existingResponse = FB.getAuthResponse();
            if (existingResponse && existingResponse.userID !== authData.id) FB.logout();
            FB.init(newOptions);
        }
        return true;
    },
    getAuthType () {
        return "facebook";
    },
    deauthenticate () {
        this.restoreAuthentication(null);
    }
};
/**
 * Provides a set of utilities for using Parse with Facebook.
 *
 * @class Parse.FacebookUtils
 * @static
 * @hideconstructor
 */ const $dbacacd35a49d2da$var$FacebookUtils = {
    /**
   * Initializes Parse Facebook integration.  Call this function after you
   * have loaded the Facebook Javascript SDK with the same parameters
   * as you would pass to<code>
   * <a href=
   * "https://developers.facebook.com/docs/reference/javascript/FB.init/">
   * FB.init()</a></code>.  Parse.FacebookUtils will invoke FB.init() for you
   * with these arguments.
   *
   * @function init
   * @name Parse.FacebookUtils.init
   * @param {object} options Facebook options argument as described here:
   *   <a href=
   *   "https://developers.facebook.com/docs/reference/javascript/FB.init/">
   *   FB.init()</a>. The status flag will be coerced to 'false' because it
   *   interferes with Parse Facebook integration. Call FB.getLoginStatus()
   *   explicitly if this behavior is required by your application.
   */ init (options) {
        if (typeof FB === "undefined") throw new Error("The Facebook JavaScript SDK must be loaded before calling init.");
        $dbacacd35a49d2da$var$initOptions = {};
        if (options) for(const key in options)$dbacacd35a49d2da$var$initOptions[key] = options[key];
        if ($dbacacd35a49d2da$var$initOptions.status && typeof console !== "undefined") {
            const warn = console.warn || console.log || function() {}; // eslint-disable-line no-console
            warn.call(console, 'The "status" flag passed into FB.init, when set to true, can interfere with Parse Facebook integration, so it has been suppressed. Please call FB.getLoginStatus() explicitly if you require this behavior.');
        }
        $dbacacd35a49d2da$var$initOptions.status = false;
        FB.init($dbacacd35a49d2da$var$initOptions);
        $dbacacd35a49d2da$var$_ParseUser.default._registerAuthenticationProvider($dbacacd35a49d2da$var$provider);
        $dbacacd35a49d2da$var$initialized = true;
    },
    /**
   * Gets whether the user has their account linked to Facebook.
   *
   * @function isLinked
   * @name Parse.FacebookUtils.isLinked
   * @param {Parse.User} user User to check for a facebook link.
   *     The user must be logged in on this device.
   * @returns {boolean} <code>true</code> if the user has their account
   *     linked to Facebook.
   */ isLinked (user) {
        return user._isLinked("facebook");
    },
    /**
   * Logs in a user using Facebook. This method delegates to the Facebook
   * SDK to authenticate the user, and then automatically logs in (or
   * creates, in the case where it is a new user) a Parse.User.
   *
   * Standard API:
   *
   * <code>logIn(permission: string, authData: Object);</code>
   *
   * Advanced API: Used for handling your own oAuth tokens
   * {@link https://docs.parseplatform.org/rest/guide/#linking-users}
   *
   * <code>logIn(authData: Object, options?: Object);</code>
   *
   * @function logIn
   * @name Parse.FacebookUtils.logIn
   * @param {(string | object)} permissions The permissions required for Facebook
   *    log in.  This is a comma-separated string of permissions.
   *    Alternatively, supply a Facebook authData object as described in our
   *    REST API docs if you want to handle getting facebook auth tokens
   *    yourself.
   * @param {object} options MasterKey / SessionToken. Alternatively can be used for authData if permissions is a string
   * @returns {Promise}
   */ logIn (permissions, options) {
        if (!permissions || typeof permissions === "string") {
            if (!$dbacacd35a49d2da$var$initialized) throw new Error("You must initialize FacebookUtils before calling logIn.");
            $dbacacd35a49d2da$var$requestedPermissions = permissions;
            return $dbacacd35a49d2da$var$_ParseUser.default.logInWith("facebook", options);
        }
        return $dbacacd35a49d2da$var$_ParseUser.default.logInWith("facebook", {
            authData: permissions
        }, options);
    },
    /**
   * Links Facebook to an existing PFUser. This method delegates to the
   * Facebook SDK to authenticate the user, and then automatically links
   * the account to the Parse.User.
   *
   * Standard API:
   *
   * <code>link(user: Parse.User, permission: string, authData?: Object);</code>
   *
   * Advanced API: Used for handling your own oAuth tokens
   * {@link https://docs.parseplatform.org/rest/guide/#linking-users}
   *
   * <code>link(user: Parse.User, authData: Object, options?: FullOptions);</code>
   *
   * @function link
   * @name Parse.FacebookUtils.link
   * @param {Parse.User} user User to link to Facebook. This must be the
   *     current user.
   * @param {(string | object)} permissions The permissions required for Facebook
   *    log in.  This is a comma-separated string of permissions.
   *    Alternatively, supply a Facebook authData object as described in our
   *    REST API docs if you want to handle getting facebook auth tokens
   *    yourself.
   * @param {object} options MasterKey / SessionToken. Alternatively can be used for authData if permissions is a string
   * @returns {Promise}
   */ link (user, permissions, options) {
        if (!permissions || typeof permissions === "string") {
            if (!$dbacacd35a49d2da$var$initialized) throw new Error("You must initialize FacebookUtils before calling link.");
            $dbacacd35a49d2da$var$requestedPermissions = permissions;
            return user.linkWith("facebook", options);
        }
        return user.linkWith("facebook", {
            authData: permissions
        }, options);
    },
    /**
   * Unlinks the Parse.User from a Facebook account.
   *
   * @function unlink
   * @name Parse.FacebookUtils.unlink
   * @param {Parse.User} user User to unlink from Facebook. This must be the
   *     current user.
   * @param {object} options Standard options object with success and error
   *    callbacks.
   * @returns {Promise}
   */ unlink: function(user, options) {
        if (!$dbacacd35a49d2da$var$initialized) throw new Error("You must initialize FacebookUtils before calling unlink.");
        return user._unlinkFrom("facebook", options);
    },
    // Used for testing purposes
    _getAuthProvider () {
        return $dbacacd35a49d2da$var$provider;
    }
};
var $dbacacd35a49d2da$var$_default = module.exports.default = $dbacacd35a49d2da$var$FacebookUtils;

});

parcelRegister("9vZqN", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.create = $6ed6a9468161036f$var$create;
module.exports.createFunction = $6ed6a9468161036f$var$createFunction;
module.exports.createTrigger = $6ed6a9468161036f$var$createTrigger;
module.exports.getFunction = $6ed6a9468161036f$var$getFunction;
module.exports.getFunctions = $6ed6a9468161036f$var$getFunctions;
module.exports.getTrigger = $6ed6a9468161036f$var$getTrigger;
module.exports.getTriggers = $6ed6a9468161036f$var$getTriggers;
module.exports.remove = $6ed6a9468161036f$var$remove;
module.exports.removeFunction = $6ed6a9468161036f$var$removeFunction;
module.exports.removeTrigger = $6ed6a9468161036f$var$removeTrigger;
module.exports.update = $6ed6a9468161036f$var$update;
module.exports.updateFunction = $6ed6a9468161036f$var$updateFunction;
module.exports.updateTrigger = $6ed6a9468161036f$var$updateTrigger;

var $6ed6a9468161036f$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $6ed6a9468161036f$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $6ed6a9468161036f$var$_decode = $iHLHC((parcelRequire("42E6z")));

var $6ed6a9468161036f$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));
function $6ed6a9468161036f$var$getFunctions() {
    return $6ed6a9468161036f$var$_CoreManager.default.getHooksController().get("functions");
}
function $6ed6a9468161036f$var$getTriggers() {
    return $6ed6a9468161036f$var$_CoreManager.default.getHooksController().get("triggers");
}
function $6ed6a9468161036f$var$getFunction(name) {
    return $6ed6a9468161036f$var$_CoreManager.default.getHooksController().get("functions", name);
}
function $6ed6a9468161036f$var$getTrigger(className, triggerName) {
    return $6ed6a9468161036f$var$_CoreManager.default.getHooksController().get("triggers", className, triggerName);
}
function $6ed6a9468161036f$var$createFunction(functionName, url) {
    return $6ed6a9468161036f$var$create({
        functionName: functionName,
        url: url
    });
}
function $6ed6a9468161036f$var$createTrigger(className, triggerName, url) {
    return $6ed6a9468161036f$var$create({
        className: className,
        triggerName: triggerName,
        url: url
    });
}
function $6ed6a9468161036f$var$create(hook) {
    return $6ed6a9468161036f$var$_CoreManager.default.getHooksController().create(hook);
}
function $6ed6a9468161036f$var$updateFunction(functionName, url) {
    return $6ed6a9468161036f$var$update({
        functionName: functionName,
        url: url
    });
}
function $6ed6a9468161036f$var$updateTrigger(className, triggerName, url) {
    return $6ed6a9468161036f$var$update({
        className: className,
        triggerName: triggerName,
        url: url
    });
}
function $6ed6a9468161036f$var$update(hook) {
    return $6ed6a9468161036f$var$_CoreManager.default.getHooksController().update(hook);
}
function $6ed6a9468161036f$var$removeFunction(functionName) {
    return $6ed6a9468161036f$var$remove({
        functionName: functionName
    });
}
function $6ed6a9468161036f$var$removeTrigger(className, triggerName) {
    return $6ed6a9468161036f$var$remove({
        className: className,
        triggerName: triggerName
    });
}
function $6ed6a9468161036f$var$remove(hook) {
    return $6ed6a9468161036f$var$_CoreManager.default.getHooksController().remove(hook);
}
const $6ed6a9468161036f$var$DefaultController = {
    get (type, functionName, triggerName) {
        let url = "/hooks/" + type;
        if (functionName) {
            url += "/" + functionName;
            if (triggerName) url += "/" + triggerName;
        }
        return this.sendRequest("GET", url);
    },
    create (hook) {
        let url;
        if (hook.functionName && hook.url) url = "/hooks/functions";
        else if (hook.className && hook.triggerName && hook.url) url = "/hooks/triggers";
        else return $6ed6a9468161036f$var$_promise.default.reject({
            error: "invalid hook declaration",
            code: 143
        });
        return this.sendRequest("POST", url, hook);
    },
    remove (hook) {
        let url;
        if (hook.functionName) {
            url = "/hooks/functions/" + hook.functionName;
            delete hook.functionName;
        } else if (hook.className && hook.triggerName) {
            url = "/hooks/triggers/" + hook.className + "/" + hook.triggerName;
            delete hook.className;
            delete hook.triggerName;
        } else return $6ed6a9468161036f$var$_promise.default.reject({
            error: "invalid hook declaration",
            code: 143
        });
        return this.sendRequest("PUT", url, {
            __op: "Delete"
        });
    },
    update (hook) {
        let url;
        if (hook.functionName && hook.url) {
            url = "/hooks/functions/" + hook.functionName;
            delete hook.functionName;
        } else if (hook.className && hook.triggerName && hook.url) {
            url = "/hooks/triggers/" + hook.className + "/" + hook.triggerName;
            delete hook.className;
            delete hook.triggerName;
        } else return $6ed6a9468161036f$var$_promise.default.reject({
            error: "invalid hook declaration",
            code: 143
        });
        return this.sendRequest("PUT", url, hook);
    },
    sendRequest (method, url, body) {
        return $6ed6a9468161036f$var$_CoreManager.default.getRESTController().request(method, url, body, {
            useMasterKey: true
        }).then((res)=>{
            const decoded = (0, $6ed6a9468161036f$var$_decode.default)(res);
            if (decoded) return $6ed6a9468161036f$var$_promise.default.resolve(decoded);
            return $6ed6a9468161036f$var$_promise.default.reject(new $6ed6a9468161036f$var$_ParseError.default($6ed6a9468161036f$var$_ParseError.default.INVALID_JSON, "The server returned an invalid response."));
        });
    }
};
$6ed6a9468161036f$var$_CoreManager.default.setHooksController($6ed6a9468161036f$var$DefaultController);

});

parcelRegister("xW8Bi", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $06602e1f258d0b04$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $06602e1f258d0b04$var$_set = $iHLHC((parcelRequire("a4Pit")));

var $06602e1f258d0b04$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $06602e1f258d0b04$var$_filter = $iHLHC((parcelRequire("i3o6i")));

var $06602e1f258d0b04$var$_includes = $iHLHC((parcelRequire("dNrmj")));

var $06602e1f258d0b04$var$_startsWith = $iHLHC((parcelRequire("hNmgD")));

var $06602e1f258d0b04$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $06602e1f258d0b04$var$_map = $iHLHC((parcelRequire("2VoQi")));

var $06602e1f258d0b04$var$_concat = $iHLHC((parcelRequire("oorJA")));

var $06602e1f258d0b04$var$_from = $iHLHC((parcelRequire("35NIM")));

var $06602e1f258d0b04$var$_find = $iHLHC((parcelRequire("c61hX")));

var $06602e1f258d0b04$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $06602e1f258d0b04$var$_LocalDatastoreController = $iHLHC((parcelRequire("e3Muo")));

var $06602e1f258d0b04$var$_ParseQuery = $iHLHC((parcelRequire("4FVCr")));

var $klpRA = parcelRequire("klpRA");
/**
 * Provides a local datastore which can be used to store and retrieve <code>Parse.Object</code>. <br />
 * To enable this functionality, call <code>Parse.enableLocalDatastore()</code>.
 *
 * Pin object to add to local datastore
 *
 * <pre>await object.pin();</pre>
 * <pre>await object.pinWithName('pinName');</pre>
 *
 * Query pinned objects
 *
 * <pre>query.fromLocalDatastore();</pre>
 * <pre>query.fromPin();</pre>
 * <pre>query.fromPinWithName();</pre>
 *
 * <pre>const localObjects = await query.find();</pre>
 *
 * @class Parse.LocalDatastore
 * @static
 */ const $06602e1f258d0b04$var$LocalDatastore = {
    isEnabled: false,
    isSyncing: false,
    fromPinWithName (name) {
        const controller = $06602e1f258d0b04$var$_CoreManager.default.getLocalDatastoreController();
        return controller.fromPinWithName(name);
    },
    async pinWithName (name, value) {
        const controller = $06602e1f258d0b04$var$_CoreManager.default.getLocalDatastoreController();
        return controller.pinWithName(name, value);
    },
    async unPinWithName (name) {
        const controller = $06602e1f258d0b04$var$_CoreManager.default.getLocalDatastoreController();
        return controller.unPinWithName(name);
    },
    _getAllContents () {
        const controller = $06602e1f258d0b04$var$_CoreManager.default.getLocalDatastoreController();
        return controller.getAllContents();
    },
    // Use for testing
    async _getRawStorage () {
        const controller = $06602e1f258d0b04$var$_CoreManager.default.getLocalDatastoreController();
        return controller.getRawStorage();
    },
    async _clear () {
        const controller = $06602e1f258d0b04$var$_CoreManager.default.getLocalDatastoreController();
        return controller.clear();
    },
    // Pin the object and children recursively
    // Saves the object and children key to Pin Name
    async _handlePinAllWithName (name, objects) {
        const pinName = this.getPinName(name);
        const toPinPromises = [];
        const objectKeys = [];
        for (const parent of objects){
            const children = this._getChildren(parent);
            const parentKey = this.getKeyForObject(parent);
            const json = parent._toFullJSON(undefined, true);
            if (parent._localId) json._localId = parent._localId;
            children[parentKey] = json;
            for(const objectKey in children){
                objectKeys.push(objectKey);
                toPinPromises.push(this.pinWithName(objectKey, [
                    children[objectKey]
                ]));
            }
        }
        const fromPinPromise = this.fromPinWithName(pinName);
        const [pinned] = await $06602e1f258d0b04$var$_promise.default.all([
            fromPinPromise,
            toPinPromises
        ]);
        const toPin = [
            ...new $06602e1f258d0b04$var$_set.default([
                ...pinned || [],
                ...objectKeys
            ])
        ];
        return this.pinWithName(pinName, toPin);
    },
    // Removes object and children keys from pin name
    // Keeps the object and children pinned
    async _handleUnPinAllWithName (name, objects) {
        const localDatastore = await this._getAllContents();
        const pinName = this.getPinName(name);
        const promises = [];
        let objectKeys = [];
        for (const parent of objects){
            const children = this._getChildren(parent);
            const parentKey = this.getKeyForObject(parent);
            objectKeys.push(parentKey, ...(0, $06602e1f258d0b04$var$_keys.default)(children));
        }
        objectKeys = [
            ...new $06602e1f258d0b04$var$_set.default(objectKeys)
        ];
        let pinned = localDatastore[pinName] || [];
        pinned = (0, $06602e1f258d0b04$var$_filter.default)(pinned).call(pinned, (item)=>!(0, $06602e1f258d0b04$var$_includes.default)(objectKeys).call(objectKeys, item));
        if (pinned.length == 0) {
            promises.push(this.unPinWithName(pinName));
            delete localDatastore[pinName];
        } else {
            promises.push(this.pinWithName(pinName, pinned));
            localDatastore[pinName] = pinned;
        }
        for (const objectKey of objectKeys){
            let hasReference = false;
            for(const key in localDatastore)if (key === $klpRA.DEFAULT_PIN || (0, $06602e1f258d0b04$var$_startsWith.default)(key).call(key, $klpRA.PIN_PREFIX)) {
                const pinnedObjects = localDatastore[key] || [];
                if ((0, $06602e1f258d0b04$var$_includes.default)(pinnedObjects).call(pinnedObjects, objectKey)) {
                    hasReference = true;
                    break;
                }
            }
            if (!hasReference) promises.push(this.unPinWithName(objectKey));
        }
        return $06602e1f258d0b04$var$_promise.default.all(promises);
    },
    // Retrieve all pointer fields from object recursively
    _getChildren (object) {
        const encountered = {};
        const json = object._toFullJSON(undefined, true);
        for(const key in json)if (json[key] && json[key].__type && json[key].__type === "Object") this._traverse(json[key], encountered);
        return encountered;
    },
    _traverse (object, encountered) {
        if (!object.objectId) return;
        else {
            const objectKey = this.getKeyForObject(object);
            if (encountered[objectKey]) return;
            encountered[objectKey] = object;
        }
        for(const key in object){
            let json = object[key];
            if (!object[key]) json = object;
            if (json.__type && json.__type === "Object") this._traverse(json, encountered);
        }
    },
    // Transform keys in pin name to objects
    async _serializeObjectsFromPinName (name) {
        var _context;
        const localDatastore = await this._getAllContents();
        const allObjects = [];
        for(const key in localDatastore)if ((0, $06602e1f258d0b04$var$_startsWith.default)(key).call(key, $klpRA.OBJECT_PREFIX)) allObjects.push(localDatastore[key][0]);
        if (!name) return allObjects;
        const pinName = this.getPinName(name);
        const pinned = localDatastore[pinName];
        if (!(0, $06602e1f258d0b04$var$_isArray.default)(pinned)) return [];
        const promises = (0, $06602e1f258d0b04$var$_map.default)(pinned).call(pinned, (objectKey)=>this.fromPinWithName(objectKey));
        let objects = await $06602e1f258d0b04$var$_promise.default.all(promises);
        objects = (0, $06602e1f258d0b04$var$_concat.default)(_context = []).call(_context, ...objects);
        return (0, $06602e1f258d0b04$var$_filter.default)(objects).call(objects, (object)=>object != null);
    },
    // Replaces object pointers with pinned pointers
    // The object pointers may contain old data
    // Uses Breadth First Search Algorithm
    async _serializeObject (objectKey, localDatastore) {
        let LDS = localDatastore;
        if (!LDS) LDS = await this._getAllContents();
        if (!LDS[objectKey] || LDS[objectKey].length === 0) return null;
        const root = LDS[objectKey][0];
        const queue = [];
        const meta = {};
        let uniqueId = 0;
        meta[uniqueId] = root;
        queue.push(uniqueId);
        while(queue.length !== 0){
            const nodeId = queue.shift();
            const subTreeRoot = meta[nodeId];
            for(const field in subTreeRoot){
                const value = subTreeRoot[field];
                if (value.__type && value.__type === "Object") {
                    const key = this.getKeyForObject(value);
                    if (LDS[key] && LDS[key].length > 0) {
                        const pointer = LDS[key][0];
                        uniqueId++;
                        meta[uniqueId] = pointer;
                        subTreeRoot[field] = pointer;
                        queue.push(uniqueId);
                    }
                }
            }
        }
        return root;
    },
    // Called when an object is save / fetched
    // Update object pin value
    async _updateObjectIfPinned (object) {
        if (!this.isEnabled) return;
        const objectKey = this.getKeyForObject(object);
        const pinned = await this.fromPinWithName(objectKey);
        if (!pinned || pinned.length === 0) return;
        return this.pinWithName(objectKey, [
            object._toFullJSON()
        ]);
    },
    // Called when object is destroyed
    // Unpin object and remove all references from pin names
    // TODO: Destroy children?
    async _destroyObjectIfPinned (object) {
        if (!this.isEnabled) return;
        const localDatastore = await this._getAllContents();
        const objectKey = this.getKeyForObject(object);
        const pin = localDatastore[objectKey];
        if (!pin) return;
        const promises = [
            this.unPinWithName(objectKey)
        ];
        delete localDatastore[objectKey];
        for(const key in localDatastore)if (key === $klpRA.DEFAULT_PIN || (0, $06602e1f258d0b04$var$_startsWith.default)(key).call(key, $klpRA.PIN_PREFIX)) {
            let pinned = localDatastore[key] || [];
            if ((0, $06602e1f258d0b04$var$_includes.default)(pinned).call(pinned, objectKey)) {
                pinned = (0, $06602e1f258d0b04$var$_filter.default)(pinned).call(pinned, (item)=>item !== objectKey);
                if (pinned.length == 0) {
                    promises.push(this.unPinWithName(key));
                    delete localDatastore[key];
                } else {
                    promises.push(this.pinWithName(key, pinned));
                    localDatastore[key] = pinned;
                }
            }
        }
        return $06602e1f258d0b04$var$_promise.default.all(promises);
    },
    // Update pin and references of the unsaved object
    async _updateLocalIdForObject (localId, object) {
        if (!this.isEnabled) return;
        const localKey = `${$klpRA.OBJECT_PREFIX}${object.className}_${localId}`;
        const objectKey = this.getKeyForObject(object);
        const unsaved = await this.fromPinWithName(localKey);
        if (!unsaved || unsaved.length === 0) return;
        const promises = [
            this.unPinWithName(localKey),
            this.pinWithName(objectKey, unsaved)
        ];
        const localDatastore = await this._getAllContents();
        for(const key in localDatastore)if (key === $klpRA.DEFAULT_PIN || (0, $06602e1f258d0b04$var$_startsWith.default)(key).call(key, $klpRA.PIN_PREFIX)) {
            let pinned = localDatastore[key] || [];
            if ((0, $06602e1f258d0b04$var$_includes.default)(pinned).call(pinned, localKey)) {
                pinned = (0, $06602e1f258d0b04$var$_filter.default)(pinned).call(pinned, (item)=>item !== localKey);
                pinned.push(objectKey);
                promises.push(this.pinWithName(key, pinned));
                localDatastore[key] = pinned;
            }
        }
        return $06602e1f258d0b04$var$_promise.default.all(promises);
    },
    /**
   * Updates Local Datastore from Server
   *
   * <pre>
   * await Parse.LocalDatastore.updateFromServer();
   * </pre>
   *
   * @function updateFromServer
   * @name Parse.LocalDatastore.updateFromServer
   * @static
   */ async updateFromServer () {
        var _context2;
        if (!this.checkIfEnabled() || this.isSyncing) return;
        const localDatastore = await this._getAllContents();
        const keys = [];
        for(const key in localDatastore)if ((0, $06602e1f258d0b04$var$_startsWith.default)(key).call(key, $klpRA.OBJECT_PREFIX)) keys.push(key);
        if (keys.length === 0) return;
        this.isSyncing = true;
        const pointersHash = {};
        for (const key of keys){
            // Ignore the OBJECT_PREFIX
            let [, , className, objectId] = key.split("_");
            // User key is split into [ 'Parse', 'LDS', '', 'User', 'objectId' ]
            if (key.split("_").length === 5 && key.split("_")[3] === "User") {
                className = "_User";
                objectId = key.split("_")[4];
            }
            if ((0, $06602e1f258d0b04$var$_startsWith.default)(objectId).call(objectId, "local")) continue;
            if (!(className in pointersHash)) pointersHash[className] = new $06602e1f258d0b04$var$_set.default();
            pointersHash[className].add(objectId);
        }
        const queryPromises = (0, $06602e1f258d0b04$var$_map.default)(_context2 = (0, $06602e1f258d0b04$var$_keys.default)(pointersHash)).call(_context2, (className)=>{
            const objectIds = (0, $06602e1f258d0b04$var$_from.default)(pointersHash[className]);
            const query = new $06602e1f258d0b04$var$_ParseQuery.default(className);
            query.limit(objectIds.length);
            if (objectIds.length === 1) query.equalTo("objectId", objectIds[0]);
            else query.containedIn("objectId", objectIds);
            return (0, $06602e1f258d0b04$var$_find.default)(query).call(query);
        });
        try {
            const responses = await $06602e1f258d0b04$var$_promise.default.all(queryPromises);
            const objects = (0, $06602e1f258d0b04$var$_concat.default)([]).apply([], responses);
            const pinPromises = (0, $06602e1f258d0b04$var$_map.default)(objects).call(objects, (object)=>{
                const objectKey = this.getKeyForObject(object);
                return this.pinWithName(objectKey, object._toFullJSON());
            });
            await $06602e1f258d0b04$var$_promise.default.all(pinPromises);
            this.isSyncing = false;
        } catch (error) {
            console.error("Error syncing LocalDatastore: ", error);
            this.isSyncing = false;
        }
    },
    getKeyForObject (object) {
        const objectId = object.objectId || object._getId();
        return `${$klpRA.OBJECT_PREFIX}${object.className}_${objectId}`;
    },
    getPinName (pinName) {
        if (!pinName || pinName === $klpRA.DEFAULT_PIN) return $klpRA.DEFAULT_PIN;
        return $klpRA.PIN_PREFIX + pinName;
    },
    checkIfEnabled () {
        if (!this.isEnabled) console.error("Parse.enableLocalDatastore() must be called first");
        return this.isEnabled;
    }
};
module.exports = $06602e1f258d0b04$var$LocalDatastore;
var $06602e1f258d0b04$var$_default = module.exports.default = $06602e1f258d0b04$var$LocalDatastore;
$06602e1f258d0b04$var$_CoreManager.default.setLocalDatastoreController($06602e1f258d0b04$var$_LocalDatastoreController.default);
$06602e1f258d0b04$var$_CoreManager.default.setLocalDatastore($06602e1f258d0b04$var$LocalDatastore);

});
parcelRegister("a4Pit", function(module, exports) {

module.exports = (parcelRequire("3MfDS"));

});
parcelRegister("3MfDS", function(module, exports) {
"use strict";

var $lWhsD = parcelRequire("lWhsD");
parcelRequire("jXhxH");
module.exports = $lWhsD;

});
parcelRegister("lWhsD", function(module, exports) {
"use strict";
parcelRequire("5xrGR");
parcelRequire("iYyco");
parcelRequire("4YSU4");
parcelRequire("exHqm");
parcelRequire("erT3q");
parcelRequire("2YGUq");
parcelRequire("fwzu4");
parcelRequire("iwaKD");
parcelRequire("f6XTY");
parcelRequire("WDRWM");
parcelRequire("ja2zQ");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Set;

});
parcelRegister("4YSU4", function(module, exports) {
"use strict";
parcelRequire("fAKHb");

});
parcelRegister("fAKHb", function(module, exports) {
"use strict";

var $30YqS = parcelRequire("30YqS");

var $1q3vw = parcelRequire("1q3vw");
// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
$30YqS("Set", function(init) {
    return function Set() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $1q3vw);

});


parcelRegister("exHqm", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $iVUIp = parcelRequire("iVUIp");

var $feXbm = parcelRequire("feXbm");
// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
$ggcsv({
    target: "Set",
    proto: true,
    real: true,
    forced: !$feXbm("difference")
}, {
    difference: $iVUIp
});

});
parcelRegister("iVUIp", function(module, exports) {
"use strict";

var $9IMjb = parcelRequire("9IMjb");

var $1hv0z = parcelRequire("1hv0z");

var $8Zwqa = parcelRequire("8Zwqa");

var $KXAAL = parcelRequire("KXAAL");

var $hdmVd = parcelRequire("hdmVd");

var $jgHaf = parcelRequire("jgHaf");

var $9fqlz = parcelRequire("9fqlz");
var $dc898b5107c679e2$var$has = $1hv0z.has;
var $dc898b5107c679e2$var$remove = $1hv0z.remove;
// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
module.exports = function difference(other) {
    var O = $9IMjb(this);
    var otherRec = $hdmVd(other);
    var result = $8Zwqa(O);
    if ($KXAAL(O) <= otherRec.size) $jgHaf(O, function(e) {
        if (otherRec.includes(e)) $dc898b5107c679e2$var$remove(result, e);
    });
    else $9fqlz(otherRec.getIterator(), function(e) {
        if ($dc898b5107c679e2$var$has(O, e)) $dc898b5107c679e2$var$remove(result, e);
    });
    return result;
};

});
parcelRegister("9IMjb", function(module, exports) {
"use strict";

var $k9gzN = parcelRequire("k9gzN");
var $01d39363ddb5b111$var$$TypeError = TypeError;
// Perform ? RequireInternalSlot(M, [[SetData]])
module.exports = function(it) {
    if (typeof it == "object" && "size" in it && "has" in it && "add" in it && "delete" in it && "keys" in it) return it;
    throw new $01d39363ddb5b111$var$$TypeError($k9gzN(it) + " is not a set");
};

});

parcelRegister("1hv0z", function(module, exports) {
"use strict";

var $5Pobw = parcelRequire("5Pobw");

var $1Tqyy = parcelRequire("1Tqyy");
var $0eef6e8d1275f187$var$Set = $5Pobw("Set");
var $0eef6e8d1275f187$var$SetPrototype = $0eef6e8d1275f187$var$Set.prototype;
module.exports = {
    Set: $0eef6e8d1275f187$var$Set,
    add: $1Tqyy("add", 1),
    has: $1Tqyy("has", 1),
    remove: $1Tqyy("delete", 1),
    proto: $0eef6e8d1275f187$var$SetPrototype
};

});

parcelRegister("8Zwqa", function(module, exports) {
"use strict";

var $1hv0z = parcelRequire("1hv0z");

var $jgHaf = parcelRequire("jgHaf");
var $68bd2b66747a8973$var$Set = $1hv0z.Set;
var $68bd2b66747a8973$var$add = $1hv0z.add;
module.exports = function(set) {
    var result = new $68bd2b66747a8973$var$Set();
    $jgHaf(set, function(it) {
        $68bd2b66747a8973$var$add(result, it);
    });
    return result;
};

});
parcelRegister("jgHaf", function(module, exports) {
"use strict";

var $9fqlz = parcelRequire("9fqlz");
module.exports = function(set, fn, interruptible) {
    return interruptible ? $9fqlz(set.keys(), fn, true) : set.forEach(fn);
};

});
parcelRegister("9fqlz", function(module, exports) {
"use strict";

var $aELZY = parcelRequire("aELZY");
module.exports = function(record, fn, ITERATOR_INSTEAD_OF_RECORD) {
    var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
    var next = record.next;
    var step, result;
    while(!(step = $aELZY(next, iterator)).done){
        result = fn(step.value);
        if (result !== undefined) return result;
    }
};

});



parcelRegister("KXAAL", function(module, exports) {
"use strict";
module.exports = function(set) {
    return set.size;
};

});

parcelRegister("hdmVd", function(module, exports) {
"use strict";

var $8GsPx = parcelRequire("8GsPx");

var $l3LMJ = parcelRequire("l3LMJ");

var $aELZY = parcelRequire("aELZY");

var $3ZmxQ = parcelRequire("3ZmxQ");

var $bX0zD = parcelRequire("bX0zD");
var $c8856e5d22da50fc$var$INVALID_SIZE = "Invalid size";
var $c8856e5d22da50fc$var$$RangeError = RangeError;
var $c8856e5d22da50fc$var$$TypeError = TypeError;
var $c8856e5d22da50fc$var$max = Math.max;
var $c8856e5d22da50fc$var$SetRecord = function(set, intSize) {
    this.set = set;
    this.size = $c8856e5d22da50fc$var$max(intSize, 0);
    this.has = $8GsPx(set.has);
    this.keys = $8GsPx(set.keys);
};
$c8856e5d22da50fc$var$SetRecord.prototype = {
    getIterator: function() {
        return $bX0zD($l3LMJ($aELZY(this.keys, this.set)));
    },
    includes: function(it) {
        return $aELZY(this.has, this.set, it);
    }
};
// `GetSetRecord` abstract operation
// https://tc39.es/proposal-set-methods/#sec-getsetrecord
module.exports = function(obj) {
    $l3LMJ(obj);
    var numSize = +obj.size;
    // NOTE: If size is undefined, then numSize will be NaN
    // eslint-disable-next-line no-self-compare -- NaN check
    if (numSize !== numSize) throw new $c8856e5d22da50fc$var$$TypeError($c8856e5d22da50fc$var$INVALID_SIZE);
    var intSize = $3ZmxQ(numSize);
    if (intSize < 0) throw new $c8856e5d22da50fc$var$$RangeError($c8856e5d22da50fc$var$INVALID_SIZE);
    return new $c8856e5d22da50fc$var$SetRecord(obj, intSize);
};

});
parcelRegister("bX0zD", function(module, exports) {
"use strict";
// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
module.exports = function(obj) {
    return {
        iterator: obj,
        next: obj.next,
        done: false
    };
};

});



parcelRegister("feXbm", function(module, exports) {
"use strict";
module.exports = function() {
    return false;
};

});


parcelRegister("erT3q", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $77TPA = parcelRequire("77TPA");

var $8XVHm = parcelRequire("8XVHm");

var $feXbm = parcelRequire("feXbm");
var $a84e4aefa33a88ea$var$INCORRECT = !$feXbm("intersection") || $77TPA(function() {
    // eslint-disable-next-line es/no-array-from, es/no-set -- testing
    return String(Array.from(new Set([
        1,
        2,
        3
    ]).intersection(new Set([
        3,
        2
    ])))) !== "3,2";
});
// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
$ggcsv({
    target: "Set",
    proto: true,
    real: true,
    forced: $a84e4aefa33a88ea$var$INCORRECT
}, {
    intersection: $8XVHm
});

});
parcelRegister("8XVHm", function(module, exports) {
"use strict";

var $9IMjb = parcelRequire("9IMjb");

var $1hv0z = parcelRequire("1hv0z");

var $KXAAL = parcelRequire("KXAAL");

var $hdmVd = parcelRequire("hdmVd");

var $jgHaf = parcelRequire("jgHaf");

var $9fqlz = parcelRequire("9fqlz");
var $6870971a1f2c6e6c$var$Set = $1hv0z.Set;
var $6870971a1f2c6e6c$var$add = $1hv0z.add;
var $6870971a1f2c6e6c$var$has = $1hv0z.has;
// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
module.exports = function intersection(other) {
    var O = $9IMjb(this);
    var otherRec = $hdmVd(other);
    var result = new $6870971a1f2c6e6c$var$Set();
    if ($KXAAL(O) > otherRec.size) $9fqlz(otherRec.getIterator(), function(e) {
        if ($6870971a1f2c6e6c$var$has(O, e)) $6870971a1f2c6e6c$var$add(result, e);
    });
    else $jgHaf(O, function(e) {
        if (otherRec.includes(e)) $6870971a1f2c6e6c$var$add(result, e);
    });
    return result;
};

});


parcelRegister("2YGUq", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $52K8b = parcelRequire("52K8b");

var $feXbm = parcelRequire("feXbm");
// `Set.prototype.isDisjointFrom` method
// https://github.com/tc39/proposal-set-methods
$ggcsv({
    target: "Set",
    proto: true,
    real: true,
    forced: !$feXbm("isDisjointFrom")
}, {
    isDisjointFrom: $52K8b
});

});
parcelRegister("52K8b", function(module, exports) {
"use strict";

var $9IMjb = parcelRequire("9IMjb");

var $1hv0z = parcelRequire("1hv0z");
var $3ac0ec53ee229a64$require$has = $1hv0z.has;

var $KXAAL = parcelRequire("KXAAL");

var $hdmVd = parcelRequire("hdmVd");

var $jgHaf = parcelRequire("jgHaf");

var $9fqlz = parcelRequire("9fqlz");

var $2l0vW = parcelRequire("2l0vW");
// `Set.prototype.isDisjointFrom` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom
module.exports = function isDisjointFrom(other) {
    var O = $9IMjb(this);
    var otherRec = $hdmVd(other);
    if ($KXAAL(O) <= otherRec.size) return $jgHaf(O, function(e) {
        if (otherRec.includes(e)) return false;
    }, true) !== false;
    var iterator = otherRec.getIterator();
    return $9fqlz(iterator, function(e) {
        if ($3ac0ec53ee229a64$require$has(O, e)) return $2l0vW(iterator, "normal", false);
    }) !== false;
};

});


parcelRegister("fwzu4", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $5Tab2 = parcelRequire("5Tab2");

var $feXbm = parcelRequire("feXbm");
// `Set.prototype.isSubsetOf` method
// https://github.com/tc39/proposal-set-methods
$ggcsv({
    target: "Set",
    proto: true,
    real: true,
    forced: !$feXbm("isSubsetOf")
}, {
    isSubsetOf: $5Tab2
});

});
parcelRegister("5Tab2", function(module, exports) {
"use strict";

var $9IMjb = parcelRequire("9IMjb");

var $KXAAL = parcelRequire("KXAAL");

var $jgHaf = parcelRequire("jgHaf");

var $hdmVd = parcelRequire("hdmVd");
// `Set.prototype.isSubsetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf
module.exports = function isSubsetOf(other) {
    var O = $9IMjb(this);
    var otherRec = $hdmVd(other);
    if ($KXAAL(O) > otherRec.size) return false;
    return $jgHaf(O, function(e) {
        if (!otherRec.includes(e)) return false;
    }, true) !== false;
};

});


parcelRegister("iwaKD", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $jDZKl = parcelRequire("jDZKl");

var $feXbm = parcelRequire("feXbm");
// `Set.prototype.isSupersetOf` method
// https://github.com/tc39/proposal-set-methods
$ggcsv({
    target: "Set",
    proto: true,
    real: true,
    forced: !$feXbm("isSupersetOf")
}, {
    isSupersetOf: $jDZKl
});

});
parcelRegister("jDZKl", function(module, exports) {
"use strict";

var $9IMjb = parcelRequire("9IMjb");

var $1hv0z = parcelRequire("1hv0z");
var $e4d18e629241f513$require$has = $1hv0z.has;

var $KXAAL = parcelRequire("KXAAL");

var $hdmVd = parcelRequire("hdmVd");

var $9fqlz = parcelRequire("9fqlz");

var $2l0vW = parcelRequire("2l0vW");
// `Set.prototype.isSupersetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf
module.exports = function isSupersetOf(other) {
    var O = $9IMjb(this);
    var otherRec = $hdmVd(other);
    if ($KXAAL(O) < otherRec.size) return false;
    var iterator = otherRec.getIterator();
    return $9fqlz(iterator, function(e) {
        if (!$e4d18e629241f513$require$has(O, e)) return $2l0vW(iterator, "normal", false);
    }) !== false;
};

});


parcelRegister("f6XTY", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $fDTyB = parcelRequire("fDTyB");

var $feXbm = parcelRequire("feXbm");
// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
$ggcsv({
    target: "Set",
    proto: true,
    real: true,
    forced: !$feXbm("symmetricDifference")
}, {
    symmetricDifference: $fDTyB
});

});
parcelRegister("fDTyB", function(module, exports) {
"use strict";

var $9IMjb = parcelRequire("9IMjb");

var $1hv0z = parcelRequire("1hv0z");

var $8Zwqa = parcelRequire("8Zwqa");

var $hdmVd = parcelRequire("hdmVd");

var $9fqlz = parcelRequire("9fqlz");
var $b63597ffaccd78cb$var$add = $1hv0z.add;
var $b63597ffaccd78cb$var$has = $1hv0z.has;
var $b63597ffaccd78cb$var$remove = $1hv0z.remove;
// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
module.exports = function symmetricDifference(other) {
    var O = $9IMjb(this);
    var keysIter = $hdmVd(other).getIterator();
    var result = $8Zwqa(O);
    $9fqlz(keysIter, function(e) {
        if ($b63597ffaccd78cb$var$has(O, e)) $b63597ffaccd78cb$var$remove(result, e);
        else $b63597ffaccd78cb$var$add(result, e);
    });
    return result;
};

});


parcelRegister("WDRWM", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $kgAXK = parcelRequire("kgAXK");

var $feXbm = parcelRequire("feXbm");
// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
$ggcsv({
    target: "Set",
    proto: true,
    real: true,
    forced: !$feXbm("union")
}, {
    union: $kgAXK
});

});
parcelRegister("kgAXK", function(module, exports) {
"use strict";

var $9IMjb = parcelRequire("9IMjb");

var $1hv0z = parcelRequire("1hv0z");
var $03cebdd3b8cebef8$require$add = $1hv0z.add;

var $8Zwqa = parcelRequire("8Zwqa");

var $hdmVd = parcelRequire("hdmVd");

var $9fqlz = parcelRequire("9fqlz");
// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
module.exports = function union(other) {
    var O = $9IMjb(this);
    var keysIter = $hdmVd(other).getIterator();
    var result = $8Zwqa(O);
    $9fqlz(keysIter, function(it) {
        $03cebdd3b8cebef8$require$add(result, it);
    });
    return result;
};

});





parcelRegister("35NIM", function(module, exports) {

module.exports = (parcelRequire("9O8w2"));

});
parcelRegister("9O8w2", function(module, exports) {
"use strict";

var $bKchz = parcelRequire("bKchz");
module.exports = $bKchz;

});
parcelRegister("bKchz", function(module, exports) {
"use strict";
parcelRequire("ja2zQ");
parcelRequire("23sQl");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Array.from;

});
parcelRegister("23sQl", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $kNa4r = parcelRequire("kNa4r");

var $39DPZ = parcelRequire("39DPZ");
var $17f23c3e48682178$var$INCORRECT_ITERATION = !$39DPZ(function(iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
});
// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$ggcsv({
    target: "Array",
    stat: true,
    forced: $17f23c3e48682178$var$INCORRECT_ITERATION
}, {
    from: $kNa4r
});

});
parcelRegister("kNa4r", function(module, exports) {
"use strict";

var $b5UsH = parcelRequire("b5UsH");

var $aELZY = parcelRequire("aELZY");

var $iJNxK = parcelRequire("iJNxK");

var $kv5he = parcelRequire("kv5he");

var $b4lk6 = parcelRequire("b4lk6");

var $iQLrm = parcelRequire("iQLrm");

var $6ocdr = parcelRequire("6ocdr");

var $b1Dzg = parcelRequire("b1Dzg");

var $3Tvts = parcelRequire("3Tvts");

var $7qrIj = parcelRequire("7qrIj");
var $f2303212040ef78d$var$$Array = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = $iJNxK(arrayLike);
    var IS_CONSTRUCTOR = $iQLrm(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $b5UsH(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = $7qrIj(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $f2303212040ef78d$var$$Array && $b4lk6(iteratorMethod))) {
        result = IS_CONSTRUCTOR ? new this() : [];
        iterator = $3Tvts(O, iteratorMethod);
        next = iterator.next;
        for(; !(step = $aELZY(next, iterator)).done; index++){
            value = mapping ? $kv5he(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            $b1Dzg(result, index, value);
        }
    } else {
        length = $6ocdr(O);
        result = IS_CONSTRUCTOR ? new this(length) : $f2303212040ef78d$var$$Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $b1Dzg(result, index, value);
        }
    }
    result.length = index;
    return result;
};

});
parcelRegister("kv5he", function(module, exports) {
"use strict";

var $l3LMJ = parcelRequire("l3LMJ");

var $2l0vW = parcelRequire("2l0vW");
// call something on iterator step with safe closing on error
module.exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($l3LMJ(value)[0], value[1]) : fn(value);
    } catch (error) {
        $2l0vW(iterator, "throw", error);
    }
};

});






parcelRegister("e3Muo", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3c6f5769a56405c$var$_LocalDatastoreController = $iHLHC((parcelRequire("eP25y")));

var $a3c6f5769a56405c$var$_LocalDatastoreController2 = $iHLHC((parcelRequire("7eZzL")));
let $a3c6f5769a56405c$var$LocalDatastoreController = $a3c6f5769a56405c$var$_LocalDatastoreController2.default;
module.exports = $a3c6f5769a56405c$var$LocalDatastoreController;
var $a3c6f5769a56405c$var$_default = module.exports.default = $a3c6f5769a56405c$var$LocalDatastoreController;

});
parcelRegister("eP25y", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aca772dfbe4ec7f6$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $aca772dfbe4ec7f6$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $aca772dfbe4ec7f6$var$_map = $iHLHC((parcelRequire("2VoQi")));

var $klpRA = parcelRequire("klpRA");

var $aca772dfbe4ec7f6$var$_StorageController = $iHLHC((parcelRequire("3mSL9")));
const $aca772dfbe4ec7f6$var$LocalDatastoreController = {
    async fromPinWithName (name) {
        const values = await $aca772dfbe4ec7f6$var$_StorageController.default.getItemAsync(name);
        if (!values) return [];
        const objects = JSON.parse(values);
        return objects;
    },
    async pinWithName (name, value) {
        try {
            const values = (0, $aca772dfbe4ec7f6$var$_stringify.default)(value);
            await $aca772dfbe4ec7f6$var$_StorageController.default.setItemAsync(name, values);
        } catch (e) {
            // Quota exceeded, possibly due to Safari Private Browsing mode
            console.error(e.message);
        }
    },
    unPinWithName (name) {
        return $aca772dfbe4ec7f6$var$_StorageController.default.removeItemAsync(name);
    },
    async getAllContents () {
        const keys = await $aca772dfbe4ec7f6$var$_StorageController.default.getAllKeysAsync();
        const batch = [];
        for(let i = 0; i < keys.length; i += 1){
            const key = keys[i];
            if ((0, $klpRA.isLocalDatastoreKey)(key)) batch.push(key);
        }
        const LDS = {};
        let results = [];
        try {
            results = await $aca772dfbe4ec7f6$var$_StorageController.default.multiGet(batch);
        } catch (error) {
            console.error("Error getAllContents: ", error);
            return {};
        }
        (0, $aca772dfbe4ec7f6$var$_forEach.default)(results).call(results, (pair)=>{
            const [key, value] = pair;
            try {
                LDS[key] = JSON.parse(value);
            } catch (error) {
                LDS[key] = null;
            }
        });
        return LDS;
    },
    // Used for testing
    async getRawStorage () {
        var _context;
        const keys = await $aca772dfbe4ec7f6$var$_StorageController.default.getAllKeysAsync();
        const storage = {};
        const results = await $aca772dfbe4ec7f6$var$_StorageController.default.multiGet(keys);
        (0, $aca772dfbe4ec7f6$var$_map.default)(_context = results).call(_context, (pair)=>{
            const [key, value] = pair;
            storage[key] = value;
        });
        return storage;
    },
    async clear () {
        const keys = await $aca772dfbe4ec7f6$var$_StorageController.default.getAllKeysAsync();
        const batch = [];
        for(let i = 0; i < keys.length; i += 1){
            const key = keys[i];
            if ((0, $klpRA.isLocalDatastoreKey)(key)) batch.push(key);
        }
        await $aca772dfbe4ec7f6$var$_StorageController.default.multiRemove(batch).catch((error)=>console.error("Error clearing local datastore: ", error));
    }
};
module.exports = $aca772dfbe4ec7f6$var$LocalDatastoreController;
var $aca772dfbe4ec7f6$var$_default = module.exports.default = $aca772dfbe4ec7f6$var$LocalDatastoreController;

});
parcelRegister("3mSL9", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $273de74623852a9a$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $273de74623852a9a$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));
const $273de74623852a9a$var$StorageController = {
    async: 1,
    getItemAsync (path) {
        return new $273de74623852a9a$var$_promise.default((resolve, reject)=>{
            $273de74623852a9a$var$_CoreManager.default.getAsyncStorage().getItem(path, (err, value)=>{
                if (err) reject(err);
                else resolve(value || null);
            });
        });
    },
    setItemAsync (path, value) {
        return new $273de74623852a9a$var$_promise.default((resolve, reject)=>{
            $273de74623852a9a$var$_CoreManager.default.getAsyncStorage().setItem(path, value, (err)=>{
                if (err) reject(err);
                else resolve();
            });
        });
    },
    removeItemAsync (path) {
        return new $273de74623852a9a$var$_promise.default((resolve, reject)=>{
            $273de74623852a9a$var$_CoreManager.default.getAsyncStorage().removeItem(path, (err)=>{
                if (err) reject(err);
                else resolve();
            });
        });
    },
    getAllKeysAsync () {
        return new $273de74623852a9a$var$_promise.default((resolve, reject)=>{
            $273de74623852a9a$var$_CoreManager.default.getAsyncStorage().getAllKeys((err, keys)=>{
                if (err) reject(err);
                else resolve(keys || []);
            });
        });
    },
    multiGet (keys) {
        return new $273de74623852a9a$var$_promise.default((resolve, reject)=>{
            $273de74623852a9a$var$_CoreManager.default.getAsyncStorage().multiGet(keys, (err, result)=>{
                if (err) reject(err);
                else resolve(result || null);
            });
        });
    },
    multiRemove (keys) {
        return new $273de74623852a9a$var$_promise.default((resolve, reject)=>{
            $273de74623852a9a$var$_CoreManager.default.getAsyncStorage().multiRemove(keys, (err)=>{
                if (err) reject(err);
                else resolve(keys);
            });
        });
    },
    clear () {
        return $273de74623852a9a$var$_CoreManager.default.getAsyncStorage().clear();
    }
};
module.exports = $273de74623852a9a$var$StorageController;
var $273de74623852a9a$var$_default = module.exports.default = $273de74623852a9a$var$StorageController;

});


parcelRegister("7eZzL", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $54599ae3b10c2a95$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $54599ae3b10c2a95$var$_reduce = $iHLHC((parcelRequire("juKR7")));

var $54599ae3b10c2a95$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $54599ae3b10c2a95$var$_map = $iHLHC((parcelRequire("2VoQi")));

var $klpRA = parcelRequire("klpRA");

var $54599ae3b10c2a95$var$_Storage = $iHLHC((parcelRequire("7GXKV")));
const $54599ae3b10c2a95$var$LocalDatastoreController = {
    async fromPinWithName (name) {
        const values = await $54599ae3b10c2a95$var$_Storage.default.getItemAsync(name);
        if (!values) return [];
        const objects = JSON.parse(values);
        return objects;
    },
    pinWithName (name, value) {
        const values = (0, $54599ae3b10c2a95$var$_stringify.default)(value);
        return $54599ae3b10c2a95$var$_Storage.default.setItemAsync(name, values);
    },
    unPinWithName (name) {
        return $54599ae3b10c2a95$var$_Storage.default.removeItemAsync(name);
    },
    async getAllContents () {
        const keys = await $54599ae3b10c2a95$var$_Storage.default.getAllKeysAsync();
        return (0, $54599ae3b10c2a95$var$_reduce.default)(keys).call(keys, async (previousPromise, key)=>{
            const LDS = await previousPromise;
            if ((0, $klpRA.isLocalDatastoreKey)(key)) {
                const value = await $54599ae3b10c2a95$var$_Storage.default.getItemAsync(key);
                try {
                    LDS[key] = JSON.parse(value);
                } catch (error) {
                    console.error("Error getAllContents: ", error);
                }
            }
            return LDS;
        }, $54599ae3b10c2a95$var$_promise.default.resolve({}));
    },
    // Used for testing
    async getRawStorage () {
        const keys = await $54599ae3b10c2a95$var$_Storage.default.getAllKeysAsync();
        return (0, $54599ae3b10c2a95$var$_reduce.default)(keys).call(keys, async (previousPromise, key)=>{
            const LDS = await previousPromise;
            const value = await $54599ae3b10c2a95$var$_Storage.default.getItemAsync(key);
            LDS[key] = value;
            return LDS;
        }, $54599ae3b10c2a95$var$_promise.default.resolve({}));
    },
    async clear () {
        const keys = await $54599ae3b10c2a95$var$_Storage.default.getAllKeysAsync();
        const toRemove = [];
        for (const key of keys)if ((0, $klpRA.isLocalDatastoreKey)(key)) toRemove.push(key);
        const promises = (0, $54599ae3b10c2a95$var$_map.default)(toRemove).call(toRemove, this.unPinWithName);
        return $54599ae3b10c2a95$var$_promise.default.all(promises);
    }
};
module.exports = $54599ae3b10c2a95$var$LocalDatastoreController;
var $54599ae3b10c2a95$var$_default = module.exports.default = $54599ae3b10c2a95$var$LocalDatastoreController;

});
parcelRegister("juKR7", function(module, exports) {

module.exports = (parcelRequire("fS0Mn"));

});
parcelRegister("fS0Mn", function(module, exports) {
"use strict";

var $esgII = parcelRequire("esgII");
module.exports = $esgII;

});
parcelRegister("esgII", function(module, exports) {
"use strict";

var $8hsAO = parcelRequire("8hsAO");

var $lwUuh = parcelRequire("lwUuh");
var $a860a680aeb007a8$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.reduce;
    return it === $a860a680aeb007a8$var$ArrayPrototype || $8hsAO($a860a680aeb007a8$var$ArrayPrototype, it) && own === $a860a680aeb007a8$var$ArrayPrototype.reduce ? $lwUuh : own;
};

});
parcelRegister("lwUuh", function(module, exports) {
"use strict";
parcelRequire("fYgah");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Array", "reduce");

});
parcelRegister("fYgah", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $58e8C = parcelRequire("58e8C");
var $ba08ff9d98725f1d$require$$reduce = $58e8C.left;

var $kQPJO = parcelRequire("kQPJO");

var $a9ory = parcelRequire("a9ory");

var $1V6sC = parcelRequire("1V6sC");
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $ba08ff9d98725f1d$var$CHROME_BUG = !$1V6sC && $a9ory > 79 && $a9ory < 83;
var $ba08ff9d98725f1d$var$FORCED = $ba08ff9d98725f1d$var$CHROME_BUG || !$kQPJO("reduce");
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$ggcsv({
    target: "Array",
    proto: true,
    forced: $ba08ff9d98725f1d$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $ba08ff9d98725f1d$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});

});
parcelRegister("58e8C", function(module, exports) {
"use strict";

var $8GsPx = parcelRequire("8GsPx");

var $iJNxK = parcelRequire("iJNxK");

var $lEtn3 = parcelRequire("lEtn3");

var $6ocdr = parcelRequire("6ocdr");
var $3bc8aa9cdc885836$var$$TypeError = TypeError;
var $3bc8aa9cdc885836$var$REDUCE_EMPTY = "Reduce of empty array with no initial value";
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $3bc8aa9cdc885836$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        var O = $iJNxK(that);
        var self = $lEtn3(O);
        var length = $6ocdr(O);
        $8GsPx(callbackfn);
        if (length === 0 && argumentsLength < 2) throw new $3bc8aa9cdc885836$var$$TypeError($3bc8aa9cdc885836$var$REDUCE_EMPTY);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw new $3bc8aa9cdc885836$var$$TypeError($3bc8aa9cdc885836$var$REDUCE_EMPTY);
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
module.exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $3bc8aa9cdc885836$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $3bc8aa9cdc885836$var$createMethod(true)
};

});









parcelRegister("3Jcx2", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.getPushStatus = $2b6f4ba7aa35a323$var$getPushStatus;
module.exports.send = $2b6f4ba7aa35a323$var$send;

var $2b6f4ba7aa35a323$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $2b6f4ba7aa35a323$var$_ParseQuery = $iHLHC((parcelRequire("4FVCr")));
/**
 * Contains functions to deal with Push in Parse.
 *
 * @class Parse.Push
 * @static
 * @hideconstructor
 */ /**
 * Sends a push notification.
 * **Available in Cloud Code only.**
 *
 * See {@link https://docs.parseplatform.org/js/guide/#push-notifications Push Notification Guide}
 *
 * @function send
 * @name Parse.Push.send
 * @param {object} data -  The data of the push notification. Valid fields
 * are:
 *   <ol>
 *     <li>channels - An Array of channels to push to.</li>
 *     <li>push_time - A Date object for when to send the push.</li>
 *     <li>expiration_time -  A Date object for when to expire
 *         the push.</li>
 *     <li>expiration_interval - The seconds from now to expire the push.</li>
 *     <li>where - A Parse.Query over Parse.Installation that is used to match
 *         a set of installations to push to.</li>
 *     <li>data - The data to send as part of the push.</li>
 *   <ol>
 * @param {object} options Valid options
 * are:<ul>
 *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
 *     be used for this request.
 * </ul>
 * @returns {Promise} A promise that is fulfilled when the push request
 *     completes and returns `pushStatusId`.
 */ function $2b6f4ba7aa35a323$var$send(data) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (data.where && data.where instanceof $2b6f4ba7aa35a323$var$_ParseQuery.default) data.where = data.where.toJSON().where;
    if (data.push_time && typeof data.push_time === "object") data.push_time = data.push_time.toJSON();
    if (data.expiration_time && typeof data.expiration_time === "object") data.expiration_time = data.expiration_time.toJSON();
    if (data.expiration_time && data.expiration_interval) throw new Error("expiration_time and expiration_interval cannot both be set.");
    const pushOptions = {
        useMasterKey: true
    };
    if (options.hasOwnProperty("useMasterKey")) pushOptions.useMasterKey = options.useMasterKey;
    return $2b6f4ba7aa35a323$var$_CoreManager.default.getPushController().send(data, pushOptions);
}
/**
 * Gets push status by Id
 *
 * @function getPushStatus
 * @name Parse.Push.getPushStatus
 * @param {string} pushStatusId The Id of Push Status.
 * @param {object} options Valid options
 * are:<ul>
 *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
 *     be used for this request.
 * </ul>
 * @returns {Parse.Object} Status of Push.
 */ function $2b6f4ba7aa35a323$var$getPushStatus(pushStatusId) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const pushOptions = {
        useMasterKey: true
    };
    if (options.hasOwnProperty("useMasterKey")) pushOptions.useMasterKey = options.useMasterKey;
    const query = new $2b6f4ba7aa35a323$var$_ParseQuery.default("_PushStatus");
    return query.get(pushStatusId, pushOptions);
}
const $2b6f4ba7aa35a323$var$DefaultController = {
    async send (data, options) {
        options.returnStatus = true;
        const response = await $2b6f4ba7aa35a323$var$_CoreManager.default.getRESTController().request("POST", "push", data, options);
        return response._headers?.["X-Parse-Push-Status-Id"];
    }
};
$2b6f4ba7aa35a323$var$_CoreManager.default.setPushController($2b6f4ba7aa35a323$var$DefaultController);

});

parcelRegister("9xpH4", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f1b205d05a5e925$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $6f1b205d05a5e925$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $6f1b205d05a5e925$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $6f1b205d05a5e925$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $6f1b205d05a5e925$var$_ParseCLP = $iHLHC((parcelRequire("hnFLk")));
const $6f1b205d05a5e925$var$FIELD_TYPES = [
    "String",
    "Number",
    "Boolean",
    "Bytes",
    "Date",
    "File",
    "GeoPoint",
    "Polygon",
    "Array",
    "Object",
    "Pointer",
    "Relation"
];
/**
 * A Parse.Schema object is for handling schema data from Parse.
 * <p>All the schemas methods require MasterKey.
 *
 * When adding fields, you may set required and default values. (Requires Parse Server 3.7.0+)
 *
 * <pre>
 * const options = { required: true, defaultValue: 'hello world' };
 * const schema = new Parse.Schema('MyClass');
 * schema.addString('field', options);
 * schema.addIndex('index_name', { 'field': 1 });
 * schema.save();
 * </pre>
 * </p>
 *
 * @alias Parse.Schema
 */ class $6f1b205d05a5e925$var$ParseSchema {
    /**
   * @param {string} className Parse Class string.
   */ constructor(className){
        (0, $6f1b205d05a5e925$var$_defineProperty2.default)(this, "className", void 0);
        (0, $6f1b205d05a5e925$var$_defineProperty2.default)(this, "_fields", void 0);
        (0, $6f1b205d05a5e925$var$_defineProperty2.default)(this, "_indexes", void 0);
        (0, $6f1b205d05a5e925$var$_defineProperty2.default)(this, "_clp", void 0);
        if (typeof className === "string") {
            if (className === "User" && $6f1b205d05a5e925$var$_CoreManager.default.get("PERFORM_USER_REWRITE")) this.className = "_User";
            else this.className = className;
        }
        this._fields = {};
        this._indexes = {};
    }
    /**
   * Static method to get all schemas
   *
   * @returns {Promise} A promise that is resolved with the result when
   * the query completes.
   */ static all() {
        const controller = $6f1b205d05a5e925$var$_CoreManager.default.getSchemaController();
        return controller.get("").then((response)=>{
            if (response.results.length === 0) throw new Error("Schema not found.");
            return response.results;
        });
    }
    /**
   * Get the Schema from Parse
   *
   * @returns {Promise} A promise that is resolved with the result when
   * the query completes.
   */ get() {
        this.assertClassName();
        const controller = $6f1b205d05a5e925$var$_CoreManager.default.getSchemaController();
        return controller.get(this.className).then((response)=>{
            if (!response) throw new Error("Schema not found.");
            return response;
        });
    }
    /**
   * Create a new Schema on Parse
   *
   * @returns {Promise} A promise that is resolved with the result when
   * the query completes.
   */ save() {
        this.assertClassName();
        const controller = $6f1b205d05a5e925$var$_CoreManager.default.getSchemaController();
        const params = {
            className: this.className,
            fields: this._fields,
            indexes: this._indexes,
            classLevelPermissions: this._clp
        };
        return controller.create(this.className, params);
    }
    /**
   * Update a Schema on Parse
   *
   * @returns {Promise} A promise that is resolved with the result when
   * the query completes.
   */ update() {
        this.assertClassName();
        const controller = $6f1b205d05a5e925$var$_CoreManager.default.getSchemaController();
        const params = {
            className: this.className,
            fields: this._fields,
            indexes: this._indexes,
            classLevelPermissions: this._clp
        };
        this._fields = {};
        this._indexes = {};
        return controller.update(this.className, params);
    }
    /**
   * Removing a Schema from Parse
   * Can only be used on Schema without objects
   *
   * @returns {Promise} A promise that is resolved with the result when
   * the query completes.
   */ delete() {
        this.assertClassName();
        const controller = $6f1b205d05a5e925$var$_CoreManager.default.getSchemaController();
        return controller.delete(this.className);
    }
    /**
   * Removes all objects from a Schema (class) in Parse.
   * EXERCISE CAUTION, running this will delete all objects for this schema and cannot be reversed
   *
   * @returns {Promise} A promise that is resolved with the result when
   * the query completes.
   */ purge() {
        this.assertClassName();
        const controller = $6f1b205d05a5e925$var$_CoreManager.default.getSchemaController();
        return controller.purge(this.className);
    }
    /**
   * Assert if ClassName has been filled
   *
   * @private
   */ assertClassName() {
        if (!this.className) throw new Error("You must set a Class Name before making any request.");
    }
    /**
   * Sets Class Level Permissions when creating / updating a Schema.
   * EXERCISE CAUTION, running this may override CLP for this schema and cannot be reversed
   *
   * @param {object | Parse.CLP} clp Class Level Permissions
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   */ setCLP(clp) {
        if (clp instanceof $6f1b205d05a5e925$var$_ParseCLP.default) this._clp = clp.toJSON();
        else this._clp = clp;
        return this;
    }
    /**
   * Adding a Field to Create / Update a Schema
   *
   * @param {string} name Name of the field that will be created on Parse
   * @param {string} type Can be a (String|Number|Boolean|Date|Parse.File|Parse.GeoPoint|Array|Object|Pointer|Parse.Relation)
   * @param {object} options
   * Valid options are:<ul>
   *   <li>required: If field is not set, save operation fails (Requires Parse Server 3.7.0+)
   *   <li>defaultValue: If field is not set, a default value is selected (Requires Parse Server 3.7.0+)
   *   <li>targetClass: Required if type is Pointer or Parse.Relation
   * </ul>
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   */ addField(name, type) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        type = type || "String";
        if (!name) throw new Error("field name may not be null.");
        if ((0, $6f1b205d05a5e925$var$_indexOf.default)($6f1b205d05a5e925$var$FIELD_TYPES).call($6f1b205d05a5e925$var$FIELD_TYPES, type) === -1) throw new Error(`${type} is not a valid type.`);
        if (type === "Pointer") return this.addPointer(name, options.targetClass, options);
        if (type === "Relation") return this.addRelation(name, options.targetClass);
        const fieldOptions = {
            type: type
        };
        if (typeof options.required === "boolean") fieldOptions.required = options.required;
        if (options.defaultValue !== undefined) fieldOptions.defaultValue = options.defaultValue;
        if (type === "Date") {
            if (options && options.defaultValue) fieldOptions.defaultValue = {
                __type: "Date",
                iso: new Date(options.defaultValue)
            };
        }
        if (type === "Bytes") {
            if (options && options.defaultValue) fieldOptions.defaultValue = {
                __type: "Bytes",
                base64: options.defaultValue
            };
        }
        this._fields[name] = fieldOptions;
        return this;
    }
    /**
   * Adding an Index to Create / Update a Schema
   *
   * @param {string} name Name of the index
   * @param {object} index { field: value }
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   *
   * <pre>
   * schema.addIndex('index_name', { 'field': 1 });
   * </pre>
   */ addIndex(name, index) {
        if (!name) throw new Error("index name may not be null.");
        if (!index) throw new Error("index may not be null.");
        this._indexes[name] = index;
        return this;
    }
    /**
   * Adding String Field
   *
   * @param {string} name Name of the field that will be created on Parse
   * @param {object} options See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Schema.html#addField addField}
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   */ addString(name, options) {
        return this.addField(name, "String", options);
    }
    /**
   * Adding Number Field
   *
   * @param {string} name Name of the field that will be created on Parse
   * @param {object} options See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Schema.html#addField addField}
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   */ addNumber(name, options) {
        return this.addField(name, "Number", options);
    }
    /**
   * Adding Boolean Field
   *
   * @param {string} name Name of the field that will be created on Parse
   * @param {object} options See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Schema.html#addField addField}
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   */ addBoolean(name, options) {
        return this.addField(name, "Boolean", options);
    }
    /**
   * Adding Bytes Field
   *
   * @param {string} name Name of the field that will be created on Parse
   * @param {object} options See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Schema.html#addField addField}
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   */ addBytes(name, options) {
        return this.addField(name, "Bytes", options);
    }
    /**
   * Adding Date Field
   *
   * @param {string} name Name of the field that will be created on Parse
   * @param {object} options See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Schema.html#addField addField}
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   */ addDate(name, options) {
        return this.addField(name, "Date", options);
    }
    /**
   * Adding File Field
   *
   * @param {string} name Name of the field that will be created on Parse
   * @param {object} options See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Schema.html#addField addField}
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   */ addFile(name, options) {
        return this.addField(name, "File", options);
    }
    /**
   * Adding GeoPoint Field
   *
   * @param {string} name Name of the field that will be created on Parse
   * @param {object} options See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Schema.html#addField addField}
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   */ addGeoPoint(name, options) {
        return this.addField(name, "GeoPoint", options);
    }
    /**
   * Adding Polygon Field
   *
   * @param {string} name Name of the field that will be created on Parse
   * @param {object} options See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Schema.html#addField addField}
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   */ addPolygon(name, options) {
        return this.addField(name, "Polygon", options);
    }
    /**
   * Adding Array Field
   *
   * @param {string} name Name of the field that will be created on Parse
   * @param {object} options See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Schema.html#addField addField}
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   */ addArray(name, options) {
        return this.addField(name, "Array", options);
    }
    /**
   * Adding Object Field
   *
   * @param {string} name Name of the field that will be created on Parse
   * @param {object} options See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Schema.html#addField addField}
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   */ addObject(name, options) {
        return this.addField(name, "Object", options);
    }
    /**
   * Adding Pointer Field
   *
   * @param {string} name Name of the field that will be created on Parse
   * @param {string} targetClass Name of the target Pointer Class
   * @param {object} options See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Schema.html#addField addField}
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   */ addPointer(name, targetClass) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (!name) throw new Error("field name may not be null.");
        if (!targetClass) throw new Error("You need to set the targetClass of the Pointer.");
        const fieldOptions = {
            type: "Pointer",
            targetClass: targetClass
        };
        if (typeof options.required === "boolean") fieldOptions.required = options.required;
        if (options.defaultValue !== undefined) {
            fieldOptions.defaultValue = options.defaultValue;
            if (options.defaultValue instanceof $6f1b205d05a5e925$var$_ParseObject.default) fieldOptions.defaultValue = options.defaultValue.toPointer();
        }
        this._fields[name] = fieldOptions;
        return this;
    }
    /**
   * Adding Relation Field
   *
   * @param {string} name Name of the field that will be created on Parse
   * @param {string} targetClass Name of the target Pointer Class
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   */ addRelation(name, targetClass) {
        if (!name) throw new Error("field name may not be null.");
        if (!targetClass) throw new Error("You need to set the targetClass of the Relation.");
        this._fields[name] = {
            type: "Relation",
            targetClass: targetClass
        };
        return this;
    }
    /**
   * Deleting a Field to Update on a Schema
   *
   * @param {string} name Name of the field
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   */ deleteField(name) {
        this._fields[name] = {
            __op: "Delete"
        };
        return this;
    }
    /**
   * Deleting an Index to Update on a Schema
   *
   * @param {string} name Name of the field
   * @returns {Parse.Schema} Returns the schema, so you can chain this call.
   */ deleteIndex(name) {
        this._indexes[name] = {
            __op: "Delete"
        };
        return this;
    }
}
const $6f1b205d05a5e925$var$DefaultController = {
    send (className, method) {
        let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const RESTController = $6f1b205d05a5e925$var$_CoreManager.default.getRESTController();
        return RESTController.request(method, `schemas/${className}`, params, {
            useMasterKey: true
        });
    },
    get (className) {
        return this.send(className, "GET");
    },
    create (className, params) {
        return this.send(className, "POST", params);
    },
    update (className, params) {
        return this.send(className, "PUT", params);
    },
    delete (className) {
        return this.send(className, "DELETE");
    },
    purge (className) {
        const RESTController = $6f1b205d05a5e925$var$_CoreManager.default.getRESTController();
        return RESTController.request("DELETE", `purge/${className}`, {}, {
            useMasterKey: true
        });
    }
};
$6f1b205d05a5e925$var$_CoreManager.default.setSchemaController($6f1b205d05a5e925$var$DefaultController);
var $6f1b205d05a5e925$var$_default = module.exports.default = $6f1b205d05a5e925$var$ParseSchema;

});

parcelRegister("b7rpJ", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81859cfc4fe78f14$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $81859cfc4fe78f14$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $81859cfc4fe78f14$var$_isRevocableSession = $iHLHC((parcelRequire("6Jk06")));

var $81859cfc4fe78f14$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $81859cfc4fe78f14$var$_ParseUser = $iHLHC((parcelRequire("iQ4JH")));
/**
 * <p>A Parse.Session object is a local representation of a revocable session.
 * This class is a subclass of a Parse.Object, and retains the same
 * functionality of a Parse.Object.</p>
 *
 * @alias Parse.Session
 * @augments Parse.Object
 */ class $81859cfc4fe78f14$var$ParseSession extends $81859cfc4fe78f14$var$_ParseObject.default {
    /**
   * @param {object} attributes The initial set of data to store in the user.
   */ constructor(attributes){
        super("_Session");
        if (attributes && typeof attributes === "object") {
            if (!this.set(attributes || {})) throw new Error("Can't create an invalid Session");
        }
    }
    /**
   * Returns the session token string.
   *
   * @returns {string}
   */ getSessionToken() {
        const token = this.get("sessionToken");
        if (typeof token === "string") return token;
        return "";
    }
    static readOnlyAttributes() {
        return [
            "createdWith",
            "expiresAt",
            "installationId",
            "restricted",
            "sessionToken",
            "user"
        ];
    }
    /**
   * Retrieves the Session object for the currently logged in session.
   *
   * @param {object} options useMasterKey
   * @static
   * @returns {Promise} A promise that is resolved with the Parse.Session
   * object after it has been fetched. If there is no current user, the
   * promise will be rejected.
   */ static current(options) {
        options = options || {};
        const controller = $81859cfc4fe78f14$var$_CoreManager.default.getSessionController();
        const sessionOptions = {};
        if (options.hasOwnProperty("useMasterKey")) sessionOptions.useMasterKey = options.useMasterKey;
        return $81859cfc4fe78f14$var$_ParseUser.default.currentAsync().then((user)=>{
            if (!user) return $81859cfc4fe78f14$var$_promise.default.reject("There is no current user.");
            sessionOptions.sessionToken = user.getSessionToken();
            return controller.getSession(sessionOptions);
        });
    }
    /**
   * Determines whether the current session token is revocable.
   * This method is useful for migrating Express.js or Node.js web apps to
   * use revocable sessions. If you are migrating an app that uses the Parse
   * SDK in the browser only, please use Parse.User.enableRevocableSession()
   * instead, so that sessions can be automatically upgraded.
   *
   * @static
   * @returns {boolean}
   */ static isCurrentSessionRevocable() {
        const currentUser = $81859cfc4fe78f14$var$_ParseUser.default.current();
        if (currentUser) return (0, $81859cfc4fe78f14$var$_isRevocableSession.default)(currentUser.getSessionToken() || "");
        return false;
    }
}
$81859cfc4fe78f14$var$_ParseObject.default.registerSubclass("_Session", $81859cfc4fe78f14$var$ParseSession);
const $81859cfc4fe78f14$var$DefaultController = {
    getSession (options) {
        const RESTController = $81859cfc4fe78f14$var$_CoreManager.default.getRESTController();
        const session = new $81859cfc4fe78f14$var$ParseSession();
        return RESTController.request("GET", "sessions/me", {}, options).then((sessionData)=>{
            session._finishFetch(sessionData);
            session._setExisted(true);
            return session;
        });
    }
};
$81859cfc4fe78f14$var$_CoreManager.default.setSessionController($81859cfc4fe78f14$var$DefaultController);
var $81859cfc4fe78f14$var$_default = module.exports.default = $81859cfc4fe78f14$var$ParseSession;

});

parcelRegister("heN8G", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c8c9dc7513081513$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $c8c9dc7513081513$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $c8c9dc7513081513$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $c8c9dc7513081513$var$_LiveQueryClient = $iHLHC((parcelRequire("b2fSd")));

var $c8c9dc7513081513$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));
function $c8c9dc7513081513$var$getLiveQueryClient() {
    return $c8c9dc7513081513$var$_CoreManager.default.getLiveQueryController().getDefaultLiveQueryClient();
}
/**
 * We expose three events to help you monitor the status of the WebSocket connection:
 *
 * <p>Open - When we establish the WebSocket connection to the LiveQuery server, you'll get this event.
 *
 * <pre>
 * Parse.LiveQuery.on('open', () => {
 *
 * });</pre></p>
 *
 * <p>Close - When we lose the WebSocket connection to the LiveQuery server, you'll get this event.
 *
 * <pre>
 * Parse.LiveQuery.on('close', () => {
 *
 * });</pre></p>
 *
 * <p>Error - When some network error or LiveQuery server error happens, you'll get this event.
 *
 * <pre>
 * Parse.LiveQuery.on('error', (error) => {
 *
 * });</pre></p>
 *
 * @class Parse.LiveQuery
 * @static
 */ class $c8c9dc7513081513$var$LiveQuery {
    constructor(){
        var _this = this;
        (0, $c8c9dc7513081513$var$_defineProperty2.default)(this, "emitter", void 0);
        (0, $c8c9dc7513081513$var$_defineProperty2.default)(this, "on", void 0);
        (0, $c8c9dc7513081513$var$_defineProperty2.default)(this, "emit", void 0);
        const EventEmitter = $c8c9dc7513081513$var$_CoreManager.default.getEventEmitter();
        this.emitter = new EventEmitter();
        this.on = (eventName, listener)=>this.emitter.on(eventName, listener);
        this.emit = function(eventName) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return _this.emitter.emit(eventName, ...args);
        };
        // adding listener so process does not crash
        // best practice is for developer to register their own listener
        this.on("error", ()=>{});
    }
    /**
   * After open is called, the LiveQuery will try to send a connect request
   * to the LiveQuery server.
   */ async open() {
        const liveQueryClient = await $c8c9dc7513081513$var$getLiveQueryClient();
        liveQueryClient.open();
    }
    /**
   * When you're done using LiveQuery, you can call Parse.LiveQuery.close().
   * This function will close the WebSocket connection to the LiveQuery server,
   * cancel the auto reconnect, and unsubscribe all subscriptions based on it.
   * If you call query.subscribe() after this, we'll create a new WebSocket
   * connection to the LiveQuery server.
   */ async close() {
        const liveQueryClient = await $c8c9dc7513081513$var$getLiveQueryClient();
        liveQueryClient.close();
    }
}
var $c8c9dc7513081513$var$_default = module.exports.default = $c8c9dc7513081513$var$LiveQuery;
let $c8c9dc7513081513$var$defaultLiveQueryClient;
const $c8c9dc7513081513$var$DefaultLiveQueryController = {
    setDefaultLiveQueryClient (liveQueryClient) {
        $c8c9dc7513081513$var$defaultLiveQueryClient = liveQueryClient;
    },
    async getDefaultLiveQueryClient () {
        if ($c8c9dc7513081513$var$defaultLiveQueryClient) return $c8c9dc7513081513$var$defaultLiveQueryClient;
        const [currentUser, installationId] = await $c8c9dc7513081513$var$_promise.default.all([
            $c8c9dc7513081513$var$_CoreManager.default.getUserController().currentUserAsync(),
            $c8c9dc7513081513$var$_CoreManager.default.getInstallationController().currentInstallationId()
        ]);
        const sessionToken = currentUser ? currentUser.getSessionToken() : undefined;
        let liveQueryServerURL = $c8c9dc7513081513$var$_CoreManager.default.get("LIVEQUERY_SERVER_URL");
        if (liveQueryServerURL && (0, $c8c9dc7513081513$var$_indexOf.default)(liveQueryServerURL).call(liveQueryServerURL, "ws") !== 0) throw new Error("You need to set a proper Parse LiveQuery server url before using LiveQueryClient");
        // If we can not find Parse.liveQueryServerURL, we try to extract it from Parse.serverURL
        if (!liveQueryServerURL) {
            const serverURL = $c8c9dc7513081513$var$_CoreManager.default.get("SERVER_URL");
            const protocol = (0, $c8c9dc7513081513$var$_indexOf.default)(serverURL).call(serverURL, "https") === 0 ? "wss://" : "ws://";
            const host = serverURL.replace(/^https?:\/\//, "");
            liveQueryServerURL = protocol + host;
            $c8c9dc7513081513$var$_CoreManager.default.set("LIVEQUERY_SERVER_URL", liveQueryServerURL);
        }
        const applicationId = $c8c9dc7513081513$var$_CoreManager.default.get("APPLICATION_ID");
        const javascriptKey = $c8c9dc7513081513$var$_CoreManager.default.get("JAVASCRIPT_KEY");
        const masterKey = $c8c9dc7513081513$var$_CoreManager.default.get("MASTER_KEY");
        $c8c9dc7513081513$var$defaultLiveQueryClient = new $c8c9dc7513081513$var$_LiveQueryClient.default({
            applicationId: applicationId,
            serverURL: liveQueryServerURL,
            javascriptKey: javascriptKey,
            masterKey: masterKey,
            sessionToken: sessionToken,
            installationId: installationId
        });
        const LiveQuery = $c8c9dc7513081513$var$_CoreManager.default.getLiveQuery();
        $c8c9dc7513081513$var$defaultLiveQueryClient.on("error", (error)=>{
            LiveQuery.emit("error", error);
        });
        $c8c9dc7513081513$var$defaultLiveQueryClient.on("open", ()=>{
            LiveQuery.emit("open");
        });
        $c8c9dc7513081513$var$defaultLiveQueryClient.on("close", ()=>{
            LiveQuery.emit("close");
        });
        return $c8c9dc7513081513$var$defaultLiveQueryClient;
    },
    _clearCachedDefaultClient () {
        $c8c9dc7513081513$var$defaultLiveQueryClient = null;
    }
};
$c8c9dc7513081513$var$_CoreManager.default.setLiveQueryController($c8c9dc7513081513$var$DefaultLiveQueryController);

});
parcelRegister("b2fSd", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $808c31c11c66dd58$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $808c31c11c66dd58$var$_map = $iHLHC((parcelRequire("2ETAR")));

var $808c31c11c66dd58$var$_keys = $iHLHC((parcelRequire("e9nT0")));

var $808c31c11c66dd58$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $808c31c11c66dd58$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $808c31c11c66dd58$var$_values = $iHLHC((parcelRequire("34k5C")));

var $808c31c11c66dd58$var$_setTimeout2 = $iHLHC((parcelRequire("3Poce")));

var $808c31c11c66dd58$var$_bind = $iHLHC((parcelRequire("h3iZF")));

var $808c31c11c66dd58$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $808c31c11c66dd58$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $808c31c11c66dd58$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $808c31c11c66dd58$var$_LiveQuerySubscription = $iHLHC((parcelRequire("kuTrw")));

var $9FsFR = parcelRequire("9FsFR");

var $808c31c11c66dd58$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));
// The LiveQuery client inner state
const $808c31c11c66dd58$var$CLIENT_STATE = {
    INITIALIZED: "initialized",
    CONNECTING: "connecting",
    CONNECTED: "connected",
    CLOSED: "closed",
    RECONNECTING: "reconnecting",
    DISCONNECTED: "disconnected"
};
// The event type the LiveQuery client should sent to server
const $808c31c11c66dd58$var$OP_TYPES = {
    CONNECT: "connect",
    SUBSCRIBE: "subscribe",
    UNSUBSCRIBE: "unsubscribe",
    ERROR: "error"
};
// The event we get back from LiveQuery server
const $808c31c11c66dd58$var$OP_EVENTS = {
    CONNECTED: "connected",
    SUBSCRIBED: "subscribed",
    UNSUBSCRIBED: "unsubscribed",
    ERROR: "error",
    CREATE: "create",
    UPDATE: "update",
    ENTER: "enter",
    LEAVE: "leave",
    DELETE: "delete"
};
// The event the LiveQuery client should emit
const $808c31c11c66dd58$var$CLIENT_EMMITER_TYPES = {
    CLOSE: "close",
    ERROR: "error",
    OPEN: "open"
};
// The event the LiveQuery subscription should emit
const $808c31c11c66dd58$var$SUBSCRIPTION_EMMITER_TYPES = {
    OPEN: "open",
    CLOSE: "close",
    ERROR: "error",
    CREATE: "create",
    UPDATE: "update",
    ENTER: "enter",
    LEAVE: "leave",
    DELETE: "delete"
};
// Exponentially-growing random delay
const $808c31c11c66dd58$var$generateInterval = (k)=>{
    return Math.random() * Math.min(30, Math.pow(2, k) - 1) * 1000;
};
/**
 * Creates a new LiveQueryClient.
 * <a href="https://nodejs.org/api/events.html#events_class_eventemitter">cloud functions</a>.
 *
 * A wrapper of a standard WebSocket client. We add several useful methods to
 * help you connect/disconnect to LiveQueryServer, subscribe/unsubscribe a ParseQuery easily.
 *
 * javascriptKey and masterKey are used for verifying the LiveQueryClient when it tries
 * to connect to the LiveQuery server
 *
 * We expose three events to help you monitor the status of the LiveQueryClient.
 *
 * <pre>
 * const LiveQueryClient = Parse.LiveQueryClient;
 * const client = new LiveQueryClient({
 *   applicationId: '',
 *   serverURL: '',
 *   javascriptKey: '',
 *   masterKey: ''
 *  });
 * </pre>
 *
 * Open - When we establish the WebSocket connection to the LiveQuery server, you'll get this event.
 * <pre>
 * client.on('open', () => {
 *
 * });</pre>
 *
 * Close - When we lose the WebSocket connection to the LiveQuery server, you'll get this event.
 * <pre>
 * client.on('close', () => {
 *
 * });</pre>
 *
 * Error - When some network error or LiveQuery server error happens, you'll get this event.
 * <pre>
 * client.on('error', (error) => {
 *
 * });</pre>
 *
 * @alias Parse.LiveQueryClient
 */ class $808c31c11c66dd58$var$LiveQueryClient {
    /**
   * @param {object} options
   * @param {string} options.applicationId - applicationId of your Parse app
   * @param {string} options.serverURL - <b>the URL of your LiveQuery server</b>
   * @param {string} options.javascriptKey (optional)
   * @param {string} options.masterKey (optional) Your Parse Master Key. (Node.js only!)
   * @param {string} options.sessionToken (optional)
   * @param {string} options.installationId (optional)
   */ constructor(_ref){
        var _this = this;
        let { applicationId: applicationId, serverURL: serverURL, javascriptKey: javascriptKey, masterKey: masterKey, sessionToken: sessionToken, installationId: installationId } = _ref;
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "attempts", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "id", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "requestId", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "applicationId", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "serverURL", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "javascriptKey", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "masterKey", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "sessionToken", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "installationId", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "additionalProperties", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "connectPromise", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "subscriptions", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "socket", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "state", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "reconnectHandle", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "emitter", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "on", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)(this, "emit", void 0);
        if (!serverURL || (0, $808c31c11c66dd58$var$_indexOf.default)(serverURL).call(serverURL, "ws") !== 0) throw new Error("You need to set a proper Parse LiveQuery server url before using LiveQueryClient");
        this.reconnectHandle = null;
        this.attempts = 1;
        this.id = 0;
        this.requestId = 1;
        this.serverURL = serverURL;
        this.applicationId = applicationId;
        this.javascriptKey = javascriptKey || undefined;
        this.masterKey = masterKey || undefined;
        this.sessionToken = sessionToken || undefined;
        this.installationId = installationId || undefined;
        this.additionalProperties = true;
        this.connectPromise = (0, $9FsFR.resolvingPromise)();
        this.subscriptions = new $808c31c11c66dd58$var$_map.default();
        this.state = $808c31c11c66dd58$var$CLIENT_STATE.INITIALIZED;
        const EventEmitter = $808c31c11c66dd58$var$_CoreManager.default.getEventEmitter();
        this.emitter = new EventEmitter();
        this.on = (eventName, listener)=>this.emitter.on(eventName, listener);
        this.emit = function(eventName) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return _this.emitter.emit(eventName, ...args);
        };
        // adding listener so process does not crash
        // best practice is for developer to register their own listener
        this.on("error", ()=>{});
    }
    shouldOpen() {
        return this.state === $808c31c11c66dd58$var$CLIENT_STATE.INITIALIZED || this.state === $808c31c11c66dd58$var$CLIENT_STATE.DISCONNECTED;
    }
    /**
   * Subscribes to a ParseQuery
   *
   * If you provide the sessionToken, when the LiveQuery server gets ParseObject's
   * updates from parse server, it'll try to check whether the sessionToken fulfills
   * the ParseObject's ACL. The LiveQuery server will only send updates to clients whose
   * sessionToken is fit for the ParseObject's ACL. You can check the LiveQuery protocol
   * <a href="https://github.com/parse-community/parse-server/wiki/Parse-LiveQuery-Protocol-Specification">here</a> for more details. The subscription you get is the same subscription you get
   * from our Standard API.
   *
   * @param {ParseQuery} query - the ParseQuery you want to subscribe to
   * @param {string} sessionToken (optional)
   * @returns {LiveQuerySubscription | undefined}
   */ subscribe(query, sessionToken) {
        if (!query) return;
        const className = query.className;
        const queryJSON = query.toJSON();
        const where = queryJSON.where;
        const keys = (0, $808c31c11c66dd58$var$_keys.default)(queryJSON)?.split(",");
        const watch = queryJSON.watch?.split(",");
        const subscribeRequest = {
            op: $808c31c11c66dd58$var$OP_TYPES.SUBSCRIBE,
            requestId: this.requestId,
            query: {
                className: className,
                where: where,
                keys: keys,
                watch: watch
            },
            sessionToken: undefined
        };
        if (sessionToken) subscribeRequest.sessionToken = sessionToken;
        const subscription = new $808c31c11c66dd58$var$_LiveQuerySubscription.default(this.requestId, query, sessionToken);
        this.subscriptions.set(this.requestId, subscription);
        this.requestId += 1;
        this.connectPromise.then(()=>{
            this.socket.send((0, $808c31c11c66dd58$var$_stringify.default)(subscribeRequest));
        }).catch((error)=>{
            subscription.subscribePromise.reject(error);
        });
        return subscription;
    }
    /**
   * After calling unsubscribe you'll stop receiving events from the subscription object.
   *
   * @param {object} subscription - subscription you would like to unsubscribe from.
   * @returns {Promise | undefined}
   */ async unsubscribe(subscription) {
        if (!subscription) return;
        const unsubscribeRequest = {
            op: $808c31c11c66dd58$var$OP_TYPES.UNSUBSCRIBE,
            requestId: subscription.id
        };
        return this.connectPromise.then(()=>{
            return this.socket.send((0, $808c31c11c66dd58$var$_stringify.default)(unsubscribeRequest));
        }).then(()=>{
            return subscription.unsubscribePromise;
        });
    }
    /**
   * After open is called, the LiveQueryClient will try to send a connect request
   * to the LiveQuery server.
   *
   */ open() {
        const WebSocketImplementation = $808c31c11c66dd58$var$_CoreManager.default.getWebSocketController();
        if (!WebSocketImplementation) {
            this.emit($808c31c11c66dd58$var$CLIENT_EMMITER_TYPES.ERROR, "Can not find WebSocket implementation");
            return;
        }
        if (this.state !== $808c31c11c66dd58$var$CLIENT_STATE.RECONNECTING) this.state = $808c31c11c66dd58$var$CLIENT_STATE.CONNECTING;
        this.socket = new WebSocketImplementation(this.serverURL);
        this.socket.closingPromise = (0, $9FsFR.resolvingPromise)();
        // Bind WebSocket callbacks
        this.socket.onopen = ()=>{
            this._handleWebSocketOpen();
        };
        this.socket.onmessage = (event)=>{
            this._handleWebSocketMessage(event);
        };
        this.socket.onclose = (event)=>{
            this.socket.closingPromise?.resolve(event);
            this._handleWebSocketClose();
        };
        this.socket.onerror = (error)=>{
            this._handleWebSocketError(error);
        };
    }
    resubscribe() {
        var _context;
        (0, $808c31c11c66dd58$var$_forEach.default)(_context = this.subscriptions).call(_context, (subscription, requestId)=>{
            const query = subscription.query;
            const queryJSON = query.toJSON();
            const where = queryJSON.where;
            const keys = (0, $808c31c11c66dd58$var$_keys.default)(queryJSON)?.split(",");
            const watch = queryJSON.watch?.split(",");
            const className = query.className;
            const sessionToken = subscription.sessionToken;
            const subscribeRequest = {
                op: $808c31c11c66dd58$var$OP_TYPES.SUBSCRIBE,
                requestId: requestId,
                query: {
                    className: className,
                    where: where,
                    keys: keys,
                    watch: watch
                },
                sessionToken: undefined
            };
            if (sessionToken) subscribeRequest.sessionToken = sessionToken;
            this.connectPromise.then(()=>{
                this.socket.send((0, $808c31c11c66dd58$var$_stringify.default)(subscribeRequest));
            });
        });
    }
    /**
   * This method will close the WebSocket connection to this LiveQueryClient,
   * cancel the auto reconnect and unsubscribe all subscriptions based on it.
   *
   * @returns {Promise | undefined} CloseEvent {@link https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/close_event}
   */ async close() {
        if (this.state === $808c31c11c66dd58$var$CLIENT_STATE.INITIALIZED || this.state === $808c31c11c66dd58$var$CLIENT_STATE.DISCONNECTED) return;
        this.state = $808c31c11c66dd58$var$CLIENT_STATE.DISCONNECTED;
        this.socket?.close();
        // Notify each subscription about the close
        for (const subscription of (0, $808c31c11c66dd58$var$_values.default)(_context2 = this.subscriptions).call(_context2)){
            var _context2;
            subscription.subscribed = false;
            subscription.emit($808c31c11c66dd58$var$SUBSCRIPTION_EMMITER_TYPES.CLOSE);
        }
        this._handleReset();
        this.emit($808c31c11c66dd58$var$CLIENT_EMMITER_TYPES.CLOSE);
        return this.socket?.closingPromise;
    }
    // ensure we start with valid state if connect is called again after close
    _handleReset() {
        this.attempts = 1;
        this.id = 0;
        this.requestId = 1;
        this.connectPromise = (0, $9FsFR.resolvingPromise)();
        this.subscriptions = new $808c31c11c66dd58$var$_map.default();
    }
    _handleWebSocketOpen() {
        const connectRequest = {
            op: $808c31c11c66dd58$var$OP_TYPES.CONNECT,
            applicationId: this.applicationId,
            javascriptKey: this.javascriptKey,
            masterKey: this.masterKey,
            sessionToken: this.sessionToken,
            installationId: undefined
        };
        if (this.additionalProperties) connectRequest.installationId = this.installationId;
        this.socket.send((0, $808c31c11c66dd58$var$_stringify.default)(connectRequest));
    }
    _handleWebSocketMessage(event) {
        let data = event.data;
        if (typeof data === "string") data = JSON.parse(data);
        let subscription = null;
        if (data.requestId) subscription = this.subscriptions.get(data.requestId) || null;
        const response = {
            clientId: data.clientId,
            installationId: data.installationId
        };
        switch(data.op){
            case $808c31c11c66dd58$var$OP_EVENTS.CONNECTED:
                if (this.state === $808c31c11c66dd58$var$CLIENT_STATE.RECONNECTING) this.resubscribe();
                this.emit($808c31c11c66dd58$var$CLIENT_EMMITER_TYPES.OPEN);
                this.id = data.clientId;
                this.connectPromise.resolve();
                this.state = $808c31c11c66dd58$var$CLIENT_STATE.CONNECTED;
                break;
            case $808c31c11c66dd58$var$OP_EVENTS.SUBSCRIBED:
                if (subscription) {
                    this.attempts = 1;
                    subscription.subscribed = true;
                    subscription.subscribePromise.resolve();
                    (0, $808c31c11c66dd58$var$_setTimeout2.default)(()=>subscription.emit($808c31c11c66dd58$var$SUBSCRIPTION_EMMITER_TYPES.OPEN, response), 200);
                }
                break;
            case $808c31c11c66dd58$var$OP_EVENTS.ERROR:
                {
                    const parseError = new $808c31c11c66dd58$var$_ParseError.default(data.code, data.error);
                    if (!this.id) {
                        this.connectPromise.reject(parseError);
                        this.state = $808c31c11c66dd58$var$CLIENT_STATE.DISCONNECTED;
                    }
                    if (data.requestId) {
                        if (subscription) {
                            subscription.subscribePromise.reject(parseError);
                            (0, $808c31c11c66dd58$var$_setTimeout2.default)(()=>subscription.emit($808c31c11c66dd58$var$SUBSCRIPTION_EMMITER_TYPES.ERROR, data.error), 200);
                        }
                    } else this.emit($808c31c11c66dd58$var$CLIENT_EMMITER_TYPES.ERROR, data.error);
                    if (data.error === "Additional properties not allowed") this.additionalProperties = false;
                    if (data.reconnect) this._handleReconnect();
                    break;
                }
            case $808c31c11c66dd58$var$OP_EVENTS.UNSUBSCRIBED:
                if (subscription) {
                    this.subscriptions.delete(data.requestId);
                    subscription.subscribed = false;
                    subscription.unsubscribePromise.resolve();
                }
                break;
            default:
                {
                    // create, update, enter, leave, delete cases
                    if (!subscription) break;
                    let override = false;
                    if (data.original) {
                        override = true;
                        delete data.original.__type;
                        // Check for removed fields
                        for(const field in data.original)if (!(field in data.object)) data.object[field] = undefined;
                        data.original = $808c31c11c66dd58$var$_ParseObject.default.fromJSON(data.original, false);
                    }
                    delete data.object.__type;
                    const parseObject = $808c31c11c66dd58$var$_ParseObject.default.fromJSON(data.object, !(subscription.query && subscription.query._select) ? override : false);
                    if (data.original) subscription.emit(data.op, parseObject, data.original, response);
                    else subscription.emit(data.op, parseObject, response);
                    const localDatastore = $808c31c11c66dd58$var$_CoreManager.default.getLocalDatastore();
                    if (override && localDatastore.isEnabled) localDatastore._updateObjectIfPinned(parseObject).then(()=>{});
                }
        }
    }
    _handleWebSocketClose() {
        if (this.state === $808c31c11c66dd58$var$CLIENT_STATE.DISCONNECTED) return;
        this.state = $808c31c11c66dd58$var$CLIENT_STATE.CLOSED;
        this.emit($808c31c11c66dd58$var$CLIENT_EMMITER_TYPES.CLOSE);
        // Notify each subscription about the close
        for (const subscription of (0, $808c31c11c66dd58$var$_values.default)(_context3 = this.subscriptions).call(_context3)){
            var _context3;
            subscription.emit($808c31c11c66dd58$var$SUBSCRIPTION_EMMITER_TYPES.CLOSE);
        }
        this._handleReconnect();
    }
    _handleWebSocketError(error) {
        this.emit($808c31c11c66dd58$var$CLIENT_EMMITER_TYPES.ERROR, error);
        for (const subscription of (0, $808c31c11c66dd58$var$_values.default)(_context4 = this.subscriptions).call(_context4)){
            var _context4;
            subscription.emit($808c31c11c66dd58$var$SUBSCRIPTION_EMMITER_TYPES.ERROR, error);
        }
        this._handleReconnect();
    }
    _handleReconnect() {
        var _context5;
        // if closed or currently reconnecting we stop attempting to reconnect
        if (this.state === $808c31c11c66dd58$var$CLIENT_STATE.DISCONNECTED) return;
        this.state = $808c31c11c66dd58$var$CLIENT_STATE.RECONNECTING;
        const time = $808c31c11c66dd58$var$generateInterval(this.attempts);
        // handle case when both close/error occur at frequent rates we ensure we do not reconnect unnecessarily.
        // we're unable to distinguish different between close/error when we're unable to reconnect therefore
        // we try to reconnect in both cases
        // server side ws and browser WebSocket behave differently in when close/error get triggered
        if (this.reconnectHandle) clearTimeout(this.reconnectHandle);
        this.reconnectHandle = (0, $808c31c11c66dd58$var$_setTimeout2.default)((0, $808c31c11c66dd58$var$_bind.default)(_context5 = ()=>{
            this.attempts++;
            this.connectPromise = (0, $9FsFR.resolvingPromise)();
            this.open();
        }).call(_context5, this), time);
    }
}
var $808c31c11c66dd58$var$_default = module.exports.default = $808c31c11c66dd58$var$LiveQueryClient;

});
parcelRegister("34k5C", function(module, exports) {

module.exports = (parcelRequire("hNbrN"));

});
parcelRegister("hNbrN", function(module, exports) {
"use strict";
parcelRequire("jXhxH");

var $aHxiP = parcelRequire("aHxiP");

var $heVlo = parcelRequire("heVlo");

var $8hsAO = parcelRequire("8hsAO");

var $1dIem = parcelRequire("1dIem");
var $cf3fe47887d7907b$var$ArrayPrototype = Array.prototype;
var $cf3fe47887d7907b$var$DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
module.exports = function(it) {
    var own = it.values;
    return it === $cf3fe47887d7907b$var$ArrayPrototype || $8hsAO($cf3fe47887d7907b$var$ArrayPrototype, it) && own === $cf3fe47887d7907b$var$ArrayPrototype.values || $heVlo($cf3fe47887d7907b$var$DOMIterables, $aHxiP(it)) ? $1dIem : own;
};

});
parcelRegister("1dIem", function(module, exports) {
"use strict";

var $1UTMd = parcelRequire("1UTMd");
module.exports = $1UTMd;

});
parcelRegister("1UTMd", function(module, exports) {
"use strict";
parcelRequire("5xrGR");
parcelRequire("iYyco");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Array", "values");

});




parcelRegister("h3iZF", function(module, exports) {

module.exports = (parcelRequire("gn22P"));

});
parcelRegister("gn22P", function(module, exports) {
"use strict";

var $dv3bg = parcelRequire("dv3bg");
module.exports = $dv3bg;

});
parcelRegister("dv3bg", function(module, exports) {
"use strict";

var $8hsAO = parcelRequire("8hsAO");

var $jOysZ = parcelRequire("jOysZ");
var $9d40a340398128f8$var$FunctionPrototype = Function.prototype;
module.exports = function(it) {
    var own = it.bind;
    return it === $9d40a340398128f8$var$FunctionPrototype || $8hsAO($9d40a340398128f8$var$FunctionPrototype, it) && own === $9d40a340398128f8$var$FunctionPrototype.bind ? $jOysZ : own;
};

});
parcelRegister("jOysZ", function(module, exports) {
"use strict";
parcelRequire("83xNS");

var $1F553 = parcelRequire("1F553");
module.exports = $1F553("Function", "bind");

});
parcelRegister("83xNS", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $jWy7e = parcelRequire("jWy7e");
// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$ggcsv({
    target: "Function",
    proto: true,
    forced: Function.bind !== $jWy7e
}, {
    bind: $jWy7e
});

});
parcelRegister("jWy7e", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");

var $8GsPx = parcelRequire("8GsPx");

var $1WYwK = parcelRequire("1WYwK");

var $heVlo = parcelRequire("heVlo");

var $hF40G = parcelRequire("hF40G");

var $4abbf = parcelRequire("4abbf");
var $e84de5c07d9c9bde$var$$Function = Function;
var $e84de5c07d9c9bde$var$concat = $f518o([].concat);
var $e84de5c07d9c9bde$var$join = $f518o([].join);
var $e84de5c07d9c9bde$var$factories = {};
var $e84de5c07d9c9bde$var$construct = function(C, argsLength, args) {
    if (!$heVlo($e84de5c07d9c9bde$var$factories, argsLength)) {
        var list = [];
        var i = 0;
        for(; i < argsLength; i++)list[i] = "a[" + i + "]";
        $e84de5c07d9c9bde$var$factories[argsLength] = $e84de5c07d9c9bde$var$$Function("C,a", "return new C(" + $e84de5c07d9c9bde$var$join(list, ",") + ")");
    }
    return $e84de5c07d9c9bde$var$factories[argsLength](C, args);
};
// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
module.exports = $4abbf ? $e84de5c07d9c9bde$var$$Function.bind : function bind(that /* , ...args */ ) {
    var F = $8GsPx(this);
    var Prototype = F.prototype;
    var partArgs = $hF40G(arguments, 1);
    var boundFunction = function bound() {
        var args = $e84de5c07d9c9bde$var$concat(partArgs, $hF40G(arguments));
        return this instanceof boundFunction ? $e84de5c07d9c9bde$var$construct(F, args.length, args) : F.apply(that, args);
    };
    if ($1WYwK(Prototype)) boundFunction.prototype = Prototype;
    return boundFunction;
};

});






parcelRegister("kuTrw", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eec19dd1bc8a0491$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $eec19dd1bc8a0491$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $9FsFR = parcelRequire("9FsFR");
/**
 * Creates a new LiveQuery Subscription.
 * <a href="https://nodejs.org/api/events.html#events_class_eventemitter">cloud functions</a>.
 *
 * <p>Response Object - Contains data from the client that made the request
 * <ul>
 * <li>clientId</li>
 * <li>installationId - requires Parse Server 4.0.0+</li>
 * </ul>
 * </p>
 *
 * <p>Open Event - When you call query.subscribe(), we send a subscribe request to
 * the LiveQuery server, when we get the confirmation from the LiveQuery server,
 * this event will be emitted. When the client loses WebSocket connection to the
 * LiveQuery server, we will try to auto reconnect the LiveQuery server. If we
 * reconnect the LiveQuery server and successfully resubscribe the ParseQuery,
 * you'll also get this event.
 *
 * <pre>
 * subscription.on('open', (response) => {
 *
 * });</pre></p>
 *
 * <p>Create Event - When a new ParseObject is created and it fulfills the ParseQuery you subscribe,
 * you'll get this event. The object is the ParseObject which is created.
 *
 * <pre>
 * subscription.on('create', (object, response) => {
 *
 * });</pre></p>
 *
 * <p>Update Event - When an existing ParseObject (original) which fulfills the ParseQuery you subscribe
 * is updated (The ParseObject fulfills the ParseQuery before and after changes),
 * you'll get this event. The object is the ParseObject which is updated.
 * Its content is the latest value of the ParseObject.
 *
 * Parse-Server 3.1.3+ Required for original object parameter
 *
 * <pre>
 * subscription.on('update', (object, original, response) => {
 *
 * });</pre></p>
 *
 * <p>Enter Event - When an existing ParseObject's (original) old value doesn't fulfill the ParseQuery
 * but its new value fulfills the ParseQuery, you'll get this event. The object is the
 * ParseObject which enters the ParseQuery. Its content is the latest value of the ParseObject.
 *
 * Parse-Server 3.1.3+ Required for original object parameter
 *
 * <pre>
 * subscription.on('enter', (object, original, response) => {
 *
 * });</pre></p>
 *
 *
 * <p>Update Event - When an existing ParseObject's old value fulfills the ParseQuery but its new value
 * doesn't fulfill the ParseQuery, you'll get this event. The object is the ParseObject
 * which leaves the ParseQuery. Its content is the latest value of the ParseObject.
 *
 * <pre>
 * subscription.on('leave', (object, response) => {
 *
 * });</pre></p>
 *
 *
 * <p>Delete Event - When an existing ParseObject which fulfills the ParseQuery is deleted, you'll
 * get this event. The object is the ParseObject which is deleted.
 *
 * <pre>
 * subscription.on('delete', (object, response) => {
 *
 * });</pre></p>
 *
 *
 * <p>Close Event - When the client loses the WebSocket connection to the LiveQuery
 * server and we stop receiving events, you'll get this event.
 *
 * <pre>
 * subscription.on('close', () => {
 *
 * });</pre></p>
 */ class $eec19dd1bc8a0491$var$Subscription {
    /*
   * @param {string | number} id - subscription id
   * @param {string} query - query to subscribe to
   * @param {string} sessionToken - optional session token
   */ constructor(id, query, sessionToken){
        var _this = this;
        (0, $eec19dd1bc8a0491$var$_defineProperty2.default)(this, "id", void 0);
        (0, $eec19dd1bc8a0491$var$_defineProperty2.default)(this, "query", void 0);
        (0, $eec19dd1bc8a0491$var$_defineProperty2.default)(this, "sessionToken", void 0);
        (0, $eec19dd1bc8a0491$var$_defineProperty2.default)(this, "subscribePromise", void 0);
        (0, $eec19dd1bc8a0491$var$_defineProperty2.default)(this, "unsubscribePromise", void 0);
        (0, $eec19dd1bc8a0491$var$_defineProperty2.default)(this, "subscribed", void 0);
        (0, $eec19dd1bc8a0491$var$_defineProperty2.default)(this, "emitter", void 0);
        (0, $eec19dd1bc8a0491$var$_defineProperty2.default)(this, "on", void 0);
        (0, $eec19dd1bc8a0491$var$_defineProperty2.default)(this, "emit", void 0);
        this.id = id;
        this.query = query;
        this.sessionToken = sessionToken;
        this.subscribePromise = (0, $9FsFR.resolvingPromise)();
        this.unsubscribePromise = (0, $9FsFR.resolvingPromise)();
        this.subscribed = false;
        const EventEmitter = $eec19dd1bc8a0491$var$_CoreManager.default.getEventEmitter();
        this.emitter = new EventEmitter();
        this.on = (eventName, listener)=>this.emitter.on(eventName, listener);
        this.emit = function(eventName) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return _this.emitter.emit(eventName, ...args);
        };
        // adding listener so process does not crash
        // best practice is for developer to register their own listener
        this.on("error", ()=>{});
    }
    /**
   * Close the subscription
   *
   * @returns {Promise}
   */ unsubscribe() {
        return $eec19dd1bc8a0491$var$_CoreManager.default.getLiveQueryController().getDefaultLiveQueryClient().then((liveQueryClient)=>{
            this.emit("close");
            return liveQueryClient.unsubscribe(this);
        });
    }
}
var $eec19dd1bc8a0491$var$_default = module.exports.default = $eec19dd1bc8a0491$var$Subscription;

});



parcelRegister("7pMC1", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56609398e3902692$var$_StorageController = $iHLHC((parcelRequire("3mSL9")));

var $56609398e3902692$var$_StorageController2 = $iHLHC((parcelRequire("dwctU")));

var $56609398e3902692$var$_StorageController3 = $iHLHC((parcelRequire("36J2U")));

var $56609398e3902692$var$_StorageController4 = $iHLHC((parcelRequire("k38QV")));
let $56609398e3902692$var$StorageController = $56609398e3902692$var$_StorageController4.default;
$56609398e3902692$var$StorageController = $56609398e3902692$var$_StorageController2.default;
module.exports = $56609398e3902692$var$StorageController;
var $56609398e3902692$var$_default = module.exports.default = $56609398e3902692$var$StorageController;

});
parcelRegister("dwctU", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/* global localStorage */ const $9d77f210814a41e5$var$StorageController = {
    async: 0,
    getItem (path) {
        return localStorage.getItem(path);
    },
    setItem (path, value) {
        try {
            localStorage.setItem(path, value);
        } catch (e) {
            // Quota exceeded, possibly due to Safari Private Browsing mode
            console.log(e.message);
        }
    },
    removeItem (path) {
        localStorage.removeItem(path);
    },
    getAllKeys () {
        const keys = [];
        for(let i = 0; i < localStorage.length; i += 1)keys.push(localStorage.key(i));
        return keys;
    },
    clear () {
        localStorage.clear();
    }
};
module.exports = $9d77f210814a41e5$var$StorageController;
var $9d77f210814a41e5$var$_default = module.exports.default = $9d77f210814a41e5$var$StorageController;

});

parcelRegister("36J2U", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2434dfcb72bdfd9a$var$_keys = $iHLHC((parcelRequire("e9nT0")));
const $2434dfcb72bdfd9a$var$StorageController = {
    async: 0,
    getItem (path) {
        // @ts-ignore
        return wx.getStorageSync(path);
    },
    setItem (path, value) {
        try {
            // @ts-ignore
            wx.setStorageSync(path, value);
        } catch (e) {
        // Quota exceeded
        }
    },
    removeItem (path) {
        // @ts-ignore
        wx.removeStorageSync(path);
    },
    getAllKeys () {
        // @ts-ignore
        const res = wx.getStorageInfoSync();
        return (0, $2434dfcb72bdfd9a$var$_keys.default)(res);
    },
    clear () {
        // @ts-ignore
        wx.clearStorageSync();
    }
};
module.exports = $2434dfcb72bdfd9a$var$StorageController;
var $2434dfcb72bdfd9a$var$_default = module.exports.default = $2434dfcb72bdfd9a$var$StorageController;

});

parcelRegister("k38QV", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e98af4669fdfb796$var$_keys = $iHLHC((parcelRequire("2QmZN")));
// When there is no native storage interface, we default to an in-memory map
const $e98af4669fdfb796$var$memMap = {};
const $e98af4669fdfb796$var$StorageController = {
    async: 0,
    getItem (path) {
        if ($e98af4669fdfb796$var$memMap.hasOwnProperty(path)) return $e98af4669fdfb796$var$memMap[path];
        return null;
    },
    setItem (path, value) {
        $e98af4669fdfb796$var$memMap[path] = String(value);
    },
    removeItem (path) {
        delete $e98af4669fdfb796$var$memMap[path];
    },
    getAllKeys () {
        return (0, $e98af4669fdfb796$var$_keys.default)($e98af4669fdfb796$var$memMap);
    },
    clear () {
        for(const key in $e98af4669fdfb796$var$memMap)if ($e98af4669fdfb796$var$memMap.hasOwnProperty(key)) delete $e98af4669fdfb796$var$memMap[key];
    }
};
module.exports = $e98af4669fdfb796$var$StorageController;
var $e98af4669fdfb796$var$_default = module.exports.default = $e98af4669fdfb796$var$StorageController;

});


parcelRegister("5C46p", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4163af000bd48d75$var$_ws = $iHLHC((parcelRequire("ivIUF")));

var $4163af000bd48d75$var$_Socket = $iHLHC((parcelRequire("gCPWC")));
/* global WebSocket */ let $4163af000bd48d75$var$WebSocketController;
try {
    $4163af000bd48d75$var$WebSocketController = typeof WebSocket === "function" || typeof WebSocket === "object" ? WebSocket : null;
} catch (_) {
// WebSocket unavailable
}
module.exports = $4163af000bd48d75$var$WebSocketController;
var $4163af000bd48d75$var$_default = module.exports.default = $4163af000bd48d75$var$WebSocketController;

});
parcelRegister("ivIUF", function(module, exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});

parcelRegister("gCPWC", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");

var $iHLHC = parcelRequire("iHLHC");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1a87d05af5d6e2d$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));
class $c1a87d05af5d6e2d$var$SocketWeapp {
    constructor(serverURL){
        (0, $c1a87d05af5d6e2d$var$_defineProperty2.default)(this, "onopen", void 0);
        (0, $c1a87d05af5d6e2d$var$_defineProperty2.default)(this, "onmessage", void 0);
        (0, $c1a87d05af5d6e2d$var$_defineProperty2.default)(this, "onclose", void 0);
        (0, $c1a87d05af5d6e2d$var$_defineProperty2.default)(this, "onerror", void 0);
        this.onopen = ()=>{};
        this.onmessage = ()=>{};
        this.onclose = ()=>{};
        this.onerror = ()=>{};
        // @ts-ignore
        wx.onSocketOpen(()=>{
            this.onopen();
        });
        // @ts-ignore
        wx.onSocketMessage((msg)=>{
            // @ts-ignore
            this.onmessage(msg);
        });
        // @ts-ignore
        wx.onSocketClose((event)=>{
            // @ts-ignore
            this.onclose(event);
        });
        // @ts-ignore
        wx.onSocketError((error)=>{
            // @ts-ignore
            this.onerror(error);
        });
        // @ts-ignore
        wx.connectSocket({
            url: serverURL
        });
    }
    send(data) {
        // @ts-ignore
        wx.sendSocketMessage({
            data: data
        });
    }
    close() {
        // @ts-ignore
        wx.closeSocket();
    }
}
module.exports = $c1a87d05af5d6e2d$var$SocketWeapp;
var $c1a87d05af5d6e2d$var$_default = module.exports.default = $c1a87d05af5d6e2d$var$SocketWeapp;

});





//# sourceMappingURL=index.adf27624.js.map
